import { useState, useEffect, useRef } from "react";
import * as XLSX from 'xlsx';
import { initializeApp } from 'firebase/app';
import { getFirestore, collection, getDocs, setDoc, deleteDoc, doc as fsDoc, getDoc } from 'firebase/firestore';

import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyCl1bikQ4UrS_EMC0J4vG_rxjdCV7Bcb9k",
  authDomain: "permatech-207e1.firebaseapp.com",
  projectId: "permatech-207e1",
  storageBucket: "permatech-207e1.firebasestorage.app",
  messagingSenderId: "1055876057211",
  appId: "1:1055876057211:web:d5e0c69169416a378a7ade",
  measurementId: "G-T9NDCHLDNN"
};

const firebaseApp = initializeApp(firebaseConfig);
const COMPANY_LOGO = "data:image/jpeg;base64,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";
const db = getFirestore(firebaseApp);

const auth = getAuth(firebaseApp);

const importExcelFile = async (file, onData) => {
  try {
    
    const arrayBuffer = await file.arrayBuffer();
    const wb = XLSX.read(arrayBuffer, { type: "array" });
    const ws = wb.Sheets[wb.SheetNames[0]];
    const data = XLSX.utils.sheet_to_json(ws, { defval: "" });
    if (!data.length) { alert("No data found. Make sure first row has column headers."); return; }
    onData(data);
  } catch (err) {
    console.error("Import error:", err);
    alert("Failed to read file: " + err.message);
  }
};

const downloadTemplate = (headers, filename) => {
  const csvContent = headers.join(",") + "\n";
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.replace(".xlsx", ".csv");
  a.click();
  URL.revokeObjectURL(url);
};
// ─── THEME ───────────────────────────────────────────────────────────────────
const lightTheme = {
  bg: "#f0f4ff",
  surface: "#ffffff",
  card: "#ffffff",
  border: "#e8edf5",
  accent: "#2563eb",
  green: "#059669",
  red: "#dc2626",
  blue: "#2563eb",
  purple: "#7c3aed",
  orange: "#ea580c",
  text: "#0f1f3d",
  muted: "#64748b",
  faint: "#94a3b8",
};

const darkTheme = {
  bg: "#060b14",
  surface: "#0f1f3d",
  card: "#0d1829",
  border: "rgba(99,179,237,0.1)",
  accent: "#3b82f6",
  green: "#10b981",
  red: "#ef4444",
  blue: "#3b82f6",
  purple: "#8b5cf6",
  orange: "#f59e0b",
  text: "#e2efff",
  muted: "#5a7aa8",
  faint: "#3a5a80",
};

let theme = lightTheme;
let MACHINERY_LIST = {
  "Grinder": ["Grinder"],
  "PU Grouting Mc": ["PUGM1", "PUGM2", "PUGM3", "PUGM4", "PUGM5"],
  "Cement Grouting Mc": ["CGM1", "CGM2", "CGM3", "CGM4"],
  "Drill Mc": ["DM1", "DM2", "DM3", "DM4", "DM5", "DM6"],
  "Stirrer Mc": ["SM1", "SM2", "SM3", "SM4", "SM5", "SM6", "SM7", "SM8"],
  "Electric Board": ["EB1", "EB2", "EB3", "EB4", "EB5", "EB6", "EB7", "EB8", "EB9", "EB10", "EB11", "EB12", "EB13", "EB14", "EB15"],
  "Tullu Pump": ["TP1", "TP2", "TP3"],
  "Small Breaker": ["SB1", "SB2"],
  "Big Breaker": ["BB1", "BB2", "BB3"],
};

// ─── SHARED DATA ─────────────────────────────────────────────────────────────
const initialMasterBOQ = [
  { id: 1,  description: "UPVC Pressure Release Pipe",           unit: "RMT",   rate: 1200 },
  { id: 2,  description: "PRP Grouting Cementious",              unit: "Kg",    rate: 50   },
  { id: 3,  description: "Raft — Crystalline",                   unit: "Ltr",   rate: 310  },
  { id: 4,  description: "Raft — Sprinkle",                   unit: "Kg",   rate: 200  },

  { id: 5,  description: "Retaining Wall — Crystalline",         unit: "Ltr",   rate: 310  },
  { id: 6,  description: "Construction Joint (SYNKO-FLEX)",      unit: "RMT",   rate: 650  },
  { id: 7,  description: "Tie Rod Filing (TRG)",                 unit: "NOS",   rate: 325  },

  { id: 9,  description: "Water Tank — Surface Preparation",     unit: "Sq ft", rate: 0    },
  { id: 10,  description: "Water Tank — Application of TW",      unit: "Sq ft", rate: 90   },
  { id: 11, description: "Cemento Grouting",                     unit: "Kg",    rate: 40   },
];
const FINANCIAL_YEAR = "2025-2026";
const SHORT_FY = "25-26";




const initialProducts = [
  { id: 1, name: "IPANEX ADMIX", batchNo: "25 20300425", packingSize: "25 Ltr", unit: "Ltr", currentStock: 11000, maxStock: 20000, reorderLevel: 0, unitCost: 170, supplier: "", category: "", manufacturingDate: "2025-04-30", expiryDate: "2027-04-29", location: "warehouse" },
  { id: 2, name: "IPANEX ADMIX", batchNo: "725 5280725", packingSize: "25 Ltr", unit: "Ltr", currentStock: 3200, maxStock: 5000, reorderLevel: 0, unitCost: 170, supplier: "", category: "", manufacturingDate: "2025-07-28", expiryDate: "2027-07-27", location: "warehouse" },
  { id: 3, name: "IPA Slurry", batchNo: "030225 2030225", packingSize: "25 Kg", unit: "Kg", currentStock: 3000, maxStock: 5000, reorderLevel: 0, unitCost: 100, supplier: "", category: "", manufacturingDate: "2025-07-28", expiryDate: "2026-07-27", location: "warehouse" },
   {
    id: 4,
    name: "WEBAC PURseal Comp. A PU",
    batchNo: "333474",
    packingSize: "20.20 Kg",
    unit: "Kg",
    currentStock: 121.2,
    maxStock: 242.4,
    reorderLevel: 0,
    unitCost: 636,
    supplier: "",
    category: "WEBAC",
    manufacturingDate: "2023-06-01",
    expiryDate: "2026-06-01",
    location: "warehouse",
  },
  {
    id: 5,
    name: "WEBAC PURseal Comp. A PU",
    batchNo: "335499",
    packingSize: "",
    unit: "Kg",
    currentStock: 0,
    maxStock: 0,
    reorderLevel: 0,
    unitCost: 636,
    supplier: "",
    category: "WEBAC",
    manufacturingDate: "2024-06-01",
    expiryDate: "2027-06-01",
    location: "warehouse",
  },
  {
    id: 6,
    name: "WEBAC PURseal Comp. B",
    batchNo: "336281",
    packingSize: "24.80 Kg",
    unit: "Kg",
    currentStock: 0,
    maxStock: 297.6,
    reorderLevel: 0,
    unitCost: 0,
    supplier: "",
    category: "WEBAC",
    manufacturingDate: "2024-04-01",
    expiryDate: "2027-04-01",
    location: "warehouse",
  },
  {
    id: 7,
    name: "WEBAC 240 Comp. A Polyacrylic Gel",
    batchNo: "336353",
    packingSize: "21.50 Kg",
    unit: "Kg",
    currentStock: 494.5,
    maxStock: 494.5,
    reorderLevel: 0,
    unitCost: 770,
    supplier: "",
    category: "WEBAC",
    manufacturingDate: "2025-05-01",
    expiryDate: "2027-05-01",
    location: "warehouse",
  },
  {
    id: 8,
    name: "WEBAC 240 Comp. A2 Polyacrylic Gel",
    batchNo: "336398",
    packingSize: "1.05 Kg",
    unit: "Kg",
    currentStock: 24.15,
    maxStock: 24.15,
    reorderLevel: 0,
    unitCost: 0,
    supplier: "",
    category: "WEBAC",
    manufacturingDate: "2025-05-01",
    expiryDate: "2027-02-01",
    location: "warehouse",
  },
  {
    id: 9,
    name: "WEBAC PURseal M ACC3 Accelerator",
    batchNo: "335194",
    packingSize: "4 Kg",
    unit: "Kg",
    currentStock: 24,
    maxStock: 24,
    reorderLevel: 0,
    unitCost: 392.22,
    supplier: "",
    category: "WEBAC",
    manufacturingDate: "2024-05-01",
    expiryDate: "2027-05-01",
    location: "warehouse",
  },
  {
    id: 10,
    name: "WEBAC PURseal M SF Accelerator",
    batchNo: "336305",
    packingSize: "1 Kg",
    unit: "Kg",
    currentStock: 3,
    maxStock: 3,
    reorderLevel: 0,
    unitCost: 618.57,
    supplier: "",
    category: "WEBAC",
    manufacturingDate: "2025-04-01",
    expiryDate: "2028-04-01",
    location: "warehouse",
  },

  // ─── TABLE 2: Impermax / Rayston Products ──────────────────────────────────
  {
    id: 11,
    name: "Impermax Cold Polyurea Rayston grey ral 7011 kit 26.5kg Comp.A",
    batchNo: "250530-5131",
    packingSize: "25 Kg",
    unit: "Kg",
    currentStock: 1200,
    maxStock: 1200,
    reorderLevel: 0,
    unitCost: 385,
    supplier: "",
    category: "Impermax",
    manufacturingDate: "2025-05-29",
    expiryDate: "2026-05-29",
    location: "warehouse",
  },
  {
    id: 12,
    name: "Impermax Cold Polyurea Rayston grey ral 7011 kit 26.5kg Comp.A",
    batchNo: "250530-5132",
    packingSize: "25 Kg",
    unit: "Kg",
    currentStock: 1175,
    maxStock: 1175,
    reorderLevel: 0,
    unitCost: 385,
    supplier: "",
    category: "Impermax",
    manufacturingDate: "2025-05-29",
    expiryDate: "2026-05-29",
    location: "warehouse",
  },
  {
    id: 13,
    name: "Impermax Cold Polyurea Rayston grey ral 7011 kit 26.5kg Comp.A",
    batchNo: "250602-5130",
    packingSize: "25 Kg",
    unit: "Kg",
    currentStock: 1200,
    maxStock: 1200,
    reorderLevel: 0,
    unitCost: 385,
    supplier: "",
    category: "Impermax",
    manufacturingDate: "2025-05-29",
    expiryDate: "2026-05-29",
    location: "warehouse",
  },
  {
    id: 14,
    name: "Impermax Cold Polyurea Rayston grey ral 7011 kit 26.5kg Comp.A",
    batchNo: "250602-5131",
    packingSize: "25 Kg",
    unit: "Kg",
    currentStock: 550,
    maxStock: 550,
    reorderLevel: 0,
    unitCost: 385,
    supplier: "",
    category: "Impermax",
    manufacturingDate: "2025-05-29",
    expiryDate: "2026-05-29",
    location: "warehouse",
  },
  {
    id: 15,
    name: "Impermax Cold Polyurea Rayston grey ral 7011 kit 26.5kg Comp.A",
    batchNo: "250526-5130",
    packingSize: "25 Kg",
    unit: "Kg",
    currentStock: 625,
    maxStock: 625,
    reorderLevel: 0,
    unitCost: 385,
    supplier: "",
    category: "Impermax",
    manufacturingDate: "2025-05-26",
    expiryDate: "2026-05-23",
    location: "warehouse",
  },
  {
    id: 16,
    name: "IMPERMAX COLD POLYUREA RAYSTON kit 26.5kg Comp.B",
    batchNo: "250527-K7020",
    packingSize: "1.5 Kg",
    unit: "Kg",
    currentStock: 252,
    maxStock: 285,
    reorderLevel: 0,
    unitCost: 0,
    supplier: "",
    category: "Impermax",
    manufacturingDate: "2025-05-27",
    expiryDate: "2025-09-29",
    location: "warehouse",
  },
  {
    id: 17,
    name: "Rayston GC Primer dark grey kit 15kg Comp.A",
    batchNo: "250527-7192",
    packingSize: "11.7 Kg",
    unit: "Kg",
    currentStock: 561.6,
    maxStock: 596.7,
    reorderLevel: 0,
    unitCost: 740,
    supplier: "",
    category: "Rayston",
    manufacturingDate: "2025-05-29",
    expiryDate: "2026-05-29",
    location: "warehouse",
  },
  {
    id: 18,
    name: "Rayston GC Primer dark grey kit 15kg Comp.B",
    batchNo: "250527-7198",
    packingSize: "3.3 Kg",
    unit: "Kg",
    currentStock: 168.3,
    maxStock: 168.3,
    reorderLevel: 0,
    unitCost: 0,
    supplier: "",
    category: "Rayston",
    manufacturingDate: "2025-05-28",
    expiryDate: "2026-05-28",
    location: "warehouse",
  },
  {
    id: 19,
    name: "Colodur Rayston colorless 20kg",
    batchNo: "250527K-2100",
    packingSize: "20 Kg",
    unit: "Kg",
    currentStock: 520,
    maxStock: 520,
    reorderLevel: 0,
    unitCost: 765,
    supplier: "",
    category: "Rayston",
    manufacturingDate: "2025-05-21",
    expiryDate: "2026-05-27",
    location: "warehouse",
  },
  {
    id: 20,
    name: "Pigment Paste PU white 4kg",
    batchNo: "250527K-D6",
    packingSize: "4 Kg",
    unit: "Kg",
    currentStock: 104,
    maxStock: 104,
    reorderLevel: 0,
    unitCost: 0,
    supplier: "",
    category: "Rayston",
    manufacturingDate: "2025-05-27",
    expiryDate: "2026-05-27",
    location: "warehouse",
  },
];


const initialMovements = [
 
];

const initialPendingRequests = [
 
];
const initialGodownProducts = [
  // ── Main Stock ─────────────────────────────────────────────────────────────
  { id: 1,  category: "Main Stock",    name: "IPANEX",                       batchNo: "2513004255300", expiryDate: "2027-04-29", cans: 96,  packaging: 25,   unit: "Kg",  currentStock: 2400  },
  { id: 2,  category: "Main Stock",    name: "IMPERMAX Cold Polyurea Part A", batchNo: "2406135102240", expiryDate: "2025-07-04", cans: 65,  packaging: 25,   unit: "Kg",  currentStock: 1625  },
  { id: 3,  category: "Main Stock",    name: "IMPERMAX Cold Polyurea Part B", batchNo: "240702K-7020",  expiryDate: "2025-07-02", cans: 59,  packaging: 1.5,  unit: "Kg",  currentStock: 88.5  },
  { id: 4,  category: "Main Stock",    name: "Humidity Primer Comp A",        batchNo: "240702K-7200",  expiryDate: "2025-06-27", cans: 24,  packaging: 5.2,  unit: "Kg",  currentStock: 124.8 },
  { id: 5,  category: "Main Stock",    name: "Humidity Primer Comp B",        batchNo: "240614K-72 B",  expiryDate: "2025-07-02", cans: 21,  packaging: 12.8, unit: "Kg",  currentStock: 268.8 },
  { id: 6,  category: "Main Stock",    name: "Primer GC Comp B",              batchNo: "250527-719B",   expiryDate: "2026-05-28", cans: 50,  packaging: 3.3,  unit: "Kg",  currentStock: 165   },
  { id: 7,  category: "Main Stock",    name: "Pigment PU",                    batchNo: "25527K-D6",     expiryDate: "2026-05-27", cans: 18,  packaging: 4,    unit: "Kg",  currentStock: 72    },
  { id: 8,  category: "Main Stock",    name: "IMPERMAX 2K Comp A",            batchNo: "240702K-5910",  expiryDate: "2025-07-08", cans: 33,  packaging: 18.8, unit: "Kg",  currentStock: 620.4 },
  { id: 9,  category: "Main Stock",    name: "Purseal MS",                    batchNo: "335797",        expiryDate: "2026-11-01", cans: 2,   packaging: 24.8, unit: "Kg",  currentStock: 49.6  },
  { id: 10, category: "Main Stock",    name: "Piurseal A",                    batchNo: "334827",        expiryDate: "2027-02-01", cans: 6,   packaging: 20.2, unit: "Kg",  currentStock: 121.2 },
  { id: 11, category: "Main Stock",    name: "Purseal B",                     batchNo: "336281",        expiryDate: "2027-08-01", cans: 10,  packaging: 24.8, unit: "Kg",  currentStock: 248   },
  { id: 12, category: "Main Stock",    name: "WEBAC 155",                     batchNo: "336905",        expiryDate: "2026-11-01", cans: 91,  packaging: 10.6, unit: "Kg",  currentStock: 964.6 },
  // ── Old Material ───────────────────────────────────────────────────────────
  { id: 13, category: "Old Material",  name: "M Con Rasayan",                 batchNo: "",              expiryDate: "",           cans: 2,   packaging: 20,   unit: "Kg",  currentStock: 40    },
  { id: 14, category: "Old Material",  name: "Rayston Cold Polyurea Part A",  batchNo: "23098-5100",    expiryDate: "",           cans: 3,   packaging: 25,   unit: "Kg",  currentStock: 75    },
  // ── Sample Packs ───────────────────────────────────────────────────────────
  { id: 15, category: "Sample Pack",   name: "IMPERMAX 2K M Comp B",          batchNo: "24072K-66B",    expiryDate: "2025-07-02", cans: 1,   packaging: 1.25, unit: "Kg",  currentStock: 1.25  },
  { id: 16, category: "Sample Pack",   name: "Pigment Spray",                 batchNo: "240702K-PO7001",expiryDate: "2025-07-02", cans: 1,   packaging: 0.4,  unit: "Kg",  currentStock: 0.4   },
  { id: 17, category: "Sample Pack",   name: "IMPERMAX LY",                   batchNo: "",              expiryDate: "",           cans: 2,   packaging: 0,    unit: "Kg",  currentStock: 0     },
  { id: 18, category: "Sample Pack",   name: "IMPERMAX AQUA 2K Comp B",       batchNo: "",              expiryDate: "",           cans: 1,   packaging: 0,    unit: "Kg",  currentStock: 0     },
  // ── Balance Stock ──────────────────────────────────────────────────────────
  { id: 19, category: "Balance Stock", name: "Conplast NC",                   batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Ltr", currentStock: 100   },
  { id: 20, category: "Balance Stock", name: "Silico Crete TRG",              batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Kg",  currentStock: 125   },
  { id: 21, category: "Balance Stock", name: "Rendo Plug",                    batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Kg",  currentStock: 165   },
  { id: 22, category: "Balance Stock", name: "Perma Polymer",                 batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Ltr", currentStock: 90    },
  { id: 23, category: "Balance Stock", name: "HA Flex Deneef Resign",         batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Kg",  currentStock: 0     },
  { id: 24, category: "Balance Stock", name: "HA Flex Deneef Hardner",        batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Ltr", currentStock: 0     },
  { id: 25, category: "Balance Stock", name: "Eniroof EMB",                   batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Kg",  currentStock: 0     },
  { id: 26, category: "Balance Stock", name: "Fibermesh Flex",                batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Nos", currentStock: 20    },
  { id: 27, category: "Balance Stock", name: "Synko Flex",                    batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Rmt", currentStock: 300   },
  { id: 28, category: "Balance Stock", name: "Oil",                           batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Ltr", currentStock: 86    },
  { id: 29, category: "Balance Stock", name: "Thinner",                       batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Ltr", currentStock: 6     },
  { id: 30, category: "Balance Stock", name: "Steel Packer",                  batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Nos", currentStock: 2000  },
  { id: 31, category: "Balance Stock", name: "Venus V-800+V-7800 Face Mask",  batchNo: "",              expiryDate: "",           cans: 0,   packaging: 0,    unit: "Nos", currentStock: 1     },
];
const initialGodownMovements = [];

// ─── SHARED UTILITIES ─────────────────────────────────────────────────────────
const fmt = (n) => new Intl.NumberFormat("en-IN", { style: "currency", currency: "INR", maximumFractionDigits: 0 }).format(n);
const pct = (done, total) => total > 0 ? Math.round((done / total) * 100) : 0;
const round2 = (n) => Math.round((Number(n) || 0) * 100) / 100;
const statusColors = { Active: theme.green, "On Hold": theme.orange, Completed: theme.blue, Upcoming: theme.purple };

function stockStatus(p) {
  if (p.currentStock <= p.reorderLevel * 0.5) return { label: "Critical", color: theme.red };
  if (p.currentStock <= p.reorderLevel) return { label: "Low", color: theme.orange };
  if ((p.currentStock / p.maxStock) * 100 >= 70) return { label: "Good", color: theme.green };
  return { label: "OK", color: theme.blue };
}

// ─── SHARED COMPONENTS ────────────────────────────────────────────────────────
function ProgressBar({ value, color, height = 6 }) {
  return (
    <div style={{ background: theme.border, borderRadius: 99, height, overflow: "hidden", width: "100%" }}>
      <div style={{ width: `${Math.min(value, 100)}%`, height: "100%", background: color, borderRadius: 99, transition: "width 0.5s ease" }} />
    </div>
  );
}

function StatCard({ label, value, sub, color, icon }) {
  return (
    <div style={{ background: theme.card, border: `1.5px solid ${theme.border}`, borderRadius: 14, padding: "14px 16px", position: "relative", overflow: "hidden", boxShadow: "0 1px 3px rgba(0,0,0,0.06)" }}>
      <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, borderRadius: "14px 14px 0 0", background: color }} />
      <div style={{ fontSize: 20, marginBottom: 8 }}>{icon}</div>
      <div style={{ fontSize: 22, fontWeight: 800, color, lineHeight: 1, marginBottom: 4 }}>{value}</div>
<div style={{ fontSize: 12, color: theme.faint, fontWeight: 500, textTransform: "uppercase", letterSpacing: "0.5px" }}>{label}</div>
{sub && <div style={{ fontSize: 11, color: theme.faint, marginTop: 2 }}>{sub}</div>}
    </div>
  );
}

function Badge({ status }) {
  if (!status) return null;
  const color = statusColors[status] || theme.muted;
  return <span style={{ background: color + "22", color, border: `1px solid ${color}44`, borderRadius: 6, padding: "2px 10px", fontSize: 11, fontWeight: 700, letterSpacing: 0.5 }}>{status.toUpperCase()}</span>;
}

function Modal({ title, onClose, children, width = 560 }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "#000000cc", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: theme.surface, border: `1px solid ${theme.border}`, borderRadius: 16, width: "100%", maxWidth: width, maxHeight: "88vh", overflow: "auto" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "18px 22px", borderBottom: `1px solid ${theme.border}`, position: "sticky", top: 0, background: theme.surface, zIndex: 1 }}>
          <div style={{ color: theme.text, fontWeight: 700, fontSize: 15 }}>{title}</div>
          <button onClick={onClose} style={{ background: "none", border: "none", color: theme.muted, cursor: "pointer", fontSize: 20 }}>✕</button>
        </div>
        <div style={{ padding: "18px 22px" }}>{children}</div>
      </div>
    </div>
  );
}

function Input({ label, value, onChange, type = "text", placeholder }) {
  return (
    <div style={{ marginBottom: 14 }}>
      {label && <label style={{ color: theme.muted, fontSize: 11, fontWeight: 600, letterSpacing: 0.8, textTransform: "uppercase", display: "block", marginBottom: 5 }}>{label}</label>}
      <input type={type} value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
        style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.text, padding: "9px 12px", fontSize: 13, outline: "none", boxSizing: "border-box" }} />
    </div>
  );
}

function Sel({ label, value, onChange, options }) {
  return (
    <div style={{ marginBottom: 14 }}>
      {label && <label style={{ color: theme.muted, fontSize: 11, fontWeight: 600, letterSpacing: 0.8, textTransform: "uppercase", display: "block", marginBottom: 5 }}>{label}</label>}
      <select value={value} onChange={e => onChange(e.target.value)}
        style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.text, padding: "9px 12px", fontSize: 13, outline: "none" }}>
        {options.map(o => <option key={o.value ?? o} value={o.value ?? o}>{o.label ?? o}</option>)}
      </select>
    </div>
  );
}

function Btn({ onClick, children, variant = "primary", small = false, disabled = false }) {
  const base = { border: "none", borderRadius: 9, fontWeight: 600, cursor: disabled ? "not-allowed" : "pointer", opacity: disabled ? 0.5 : 1, fontFamily: "'Sora', sans-serif", transition: "all 0.15s", display: "inline-flex", alignItems: "center", gap: 5 };
  const size = small ? { padding: "6px 13px", fontSize: 12 } : { padding: "9px 18px", fontSize: 13 };
  const variants = {
    primary: { background: "#162040", color: "#fff", border: "none" },
    ghost: { background: "transparent", color: theme.text, border: `1.5px solid ${theme.border}` },
    danger: { background: "rgba(220,38,38,0.1)", color: "#dc2626", border: "1px solid rgba(220,38,38,0.25)" },
    success: { background: "rgba(5,150,105,0.1)", color: "#059669", border: "1px solid rgba(5,150,105,0.25)" },
    blue: { background: "#2563eb", color: "#fff", border: "none" },
  };
  return (
    <button onClick={onClick} disabled={disabled} style={{ ...base, ...size, ...variants[variant] || variants.primary }}>
      {children}
    </button>
  );
}

function Tabs({ tabs, active, onChange }) {
  return (
    <div style={{ display: "flex", gap: 2, marginBottom: 22, borderBottom: `1px solid ${theme.border}` }}>
      {tabs.map(t => (
        <button key={t.id} onClick={() => onChange(t.id)}
          style={{ background: "none", border: "none", borderBottom: active === t.id ? `2px solid ${theme.accent}` : "2px solid transparent", color: active === t.id ? theme.accent : theme.muted, padding: "9px 16px", cursor: "pointer", fontSize: 13, fontWeight: active === t.id ? 700 : 400, fontFamily: "inherit", marginBottom: -1, whiteSpace: "nowrap" }}>
          {t.label}
        </button>
      ))}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// MODULE 1 — PROJECT MANAGEMENT & BOQ
// ═══════════════════════════════════════════════════════════════════════════════
function ProjectsModule({ projects, setProjects, challans, setChallans, materialRequests, setMaterialRequests, invoices, setInvoices, masterBOQ, setMasterBOQ }) {
  const [selectedId, setSelectedId] = useState(null);
  const [showCreate, setShowCreate] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const selected = projects.find(p => p.id === selectedId);
  const updateProject = (updated) => {
  setProjects(ps => ps.map(p => p.id === updated.id ? updated : p));
  saveProject(updated);
};

  return (
    <div>
  {selected
  ? <ProjectDetail
      project={selected}
      onBack={() => setSelectedId(null)}
      onUpdate={updateProject}
      challans={challans}
      setChallans={setChallans}
      materialRequests={materialRequests}
      setMaterialRequests={setMaterialRequests}
      
    />
        : <ProjectDashboard projects={projects} challans={challans} onSelect={setSelectedId} onCreate={() => setShowCreate(true)} onSettings={() => setShowSettings(true)} onDelete={async (id) => {
  const updated = projects.filter(p => p.id !== id);
  setProjects(updated);
  localStorage.setItem("projects", JSON.stringify(updated));
  try { await deleteDoc(fsDoc(db, "projects", String(id))); }
  catch (e) { console.error(e); }
}}
onUpdate={async (updated) => {
  const newProjects = projects.map(p => p.id === updated.id ? updated : p);
  setProjects(newProjects);
  localStorage.setItem("projects", JSON.stringify(newProjects));
  try { await setDoc(fsDoc(db, "projects", String(updated.id)), updated); }
  catch (e) { console.error(e); }
}}
/>
      }
      {showCreate && <CreateProjectModal masterBOQ={masterBOQ} onClose={() => setShowCreate(false)} onSave={p => { setProjects(ps => [...ps, p]); saveProject(p); setShowCreate(false); setSelectedId(p.id); }} />}
      {showSettings && <MasterBOQSettings masterBOQ={masterBOQ} setMasterBOQ={setMasterBOQ} onClose={() => setShowSettings(false)} />}
    </div>
  );
}

function MachineryMaster({ onUpdate }) {
  const [machineryData, setMachineryData] = useState(() => {
    const ls = localStorage.getItem("machinery_master");
    if (ls) return JSON.parse(ls);
    return Object.entries(MACHINERY_LIST).map(([name, ids]) => ({ name, ids }));
  });
  const [loading, setLoading] = useState(true);
  const [newMachineName, setNewMachineName] = useState("");
  const [newMachineId, setNewMachineId] = useState("");
  const [selectedMachine, setSelectedMachine] = useState("");
  const [showAddMachine, setShowAddMachine] = useState(false);
  const [showAddId, setShowAddId] = useState(false);

  useEffect(() => {
    const sync = (data) => {
      const newList = {};
      data.forEach(m => { newList[m.name] = m.ids; });
      MACHINERY_LIST = newList;
      if (onUpdate) onUpdate();
    };
    getDocs(collection(db, "machinery_master")).then(snap => {
      if (snap.docs.length > 0) {
        const data = snap.docs.map(d => d.data());
        setMachineryData(data);
        sync(data);
      } else {
        const ls = localStorage.getItem("machinery_master");
        if (ls) {
          const parsed = JSON.parse(ls);
          setMachineryData(parsed);
          sync(parsed);
        }
      }
    }).catch(() => {
      const ls = localStorage.getItem("machinery_master");
      if (ls) {
        const parsed = JSON.parse(ls);
        setMachineryData(parsed);
        sync(parsed);
      }
    }).finally(() => setLoading(false));
  }, [onUpdate]);

  const syncToGlobal = (data) => {
    const newList = {};
    data.forEach(m => { newList[m.name] = m.ids; });
    MACHINERY_LIST = newList;
    if (onUpdate) onUpdate();
  };

  const save = async (updated) => {
    setMachineryData(updated);
    syncToGlobal(updated);
    localStorage.setItem("machinery_master", JSON.stringify(updated));
    try {
      for (const m of updated) {
        await setDoc(fsDoc(db, "machinery_master", m.name), m);
      }
    } catch (e) { console.error(e); }
  };

  const addMachine = () => {
    if (!newMachineName.trim()) return alert("Enter machine name.");
    if (machineryData.find(m => m.name.toLowerCase() === newMachineName.trim().toLowerCase())) {
      return alert("Machine already exists.");
    }
    save([...machineryData, { name: newMachineName.trim(), ids: [] }]);
    setNewMachineName("");
    setShowAddMachine(false);
  };

  const addMachineId = () => {
    if (!selectedMachine) return alert("Select a machine first.");
    if (!newMachineId.trim()) return alert("Enter machine ID.");
    const updated = machineryData.map(m =>
      m.name === selectedMachine
        ? { ...m, ids: [...m.ids, newMachineId.trim()] }
        : m
    );
    save(updated);
    setNewMachineId("");
    setShowAddId(false);
  };

  const deleteMachineId = (machineName, id) => {
    if (!window.confirm(`Delete ${id} from ${machineName}?`)) return;
    const updated = machineryData.map(m =>
      m.name === machineName ? { ...m, ids: m.ids.filter(i => i !== id) } : m
    );
    save(updated);
  };

  const deleteMachine = async (machineName) => {
    if (!window.confirm(`Delete entire machine "${machineName}" and all its IDs?`)) return;
    const updated = machineryData.filter(m => m.name !== machineName);
    save(updated);
    try { await deleteDoc(fsDoc(db, "machinery_master", machineName)); } catch (e) { console.error(e); }
  };

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "8px 10px", fontSize: 12, outline: "none", width: "100%", boxSizing: "border-box" };

  if (loading) return <div style={{ color: theme.muted, padding: 20 }}>Loading machinery master...</div>;

  return (
    <div style={{ marginBottom: 24 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div>
          <div style={{ color: theme.accent, fontWeight: 800, fontSize: 15 }}>⚙️ Machinery Master</div>
          <div style={{ color: theme.muted, fontSize: 12, marginTop: 2 }}>{machineryData.length} machine types · changes auto-reflect in challan dropdown</div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn small onClick={() => { setShowAddId(true); setShowAddMachine(false); }}>+ Add Machine ID</Btn>
          <Btn small onClick={() => { setShowAddMachine(true); setShowAddId(false); }}>+ New Machine Type</Btn>
        </div>
      </div>

      {/* Add Machine Type Form */}
      {showAddMachine && (
        <div style={{ background: theme.card, border: `1px solid ${theme.accent}44`, borderRadius: 10, padding: 14, marginBottom: 14 }}>
          <div style={{ color: theme.accent, fontWeight: 700, fontSize: 13, marginBottom: 10 }}>➕ New Machine Type</div>
          <div style={{ display: "flex", gap: 10 }}>
            <input value={newMachineName} onChange={e => setNewMachineName(e.target.value)}
              style={{ ...inp, flex: 1 }} placeholder="e.g. Water Pump" autoFocus
              onKeyDown={e => e.key === "Enter" && addMachine()} />
            <Btn onClick={addMachine}>✅ Add</Btn>
            <Btn variant="ghost" onClick={() => { setShowAddMachine(false); setNewMachineName(""); }}>Cancel</Btn>
          </div>
        </div>
      )}

      {/* Add Machine ID Form */}
      {showAddId && (
        <div style={{ background: theme.card, border: `1px solid ${theme.blue}44`, borderRadius: 10, padding: 14, marginBottom: 14 }}>
          <div style={{ color: theme.blue, fontWeight: 700, fontSize: 13, marginBottom: 10 }}>➕ Add Machine ID</div>
          <div style={{ display: "flex", gap: 10 }}>
            <select value={selectedMachine} onChange={e => setSelectedMachine(e.target.value)}
              style={{ ...inp, flex: 1, cursor: "pointer" }}>
              <option value="">— Select Machine Type —</option>
              {machineryData.map(m => <option key={m.name} value={m.name}>{m.name}</option>)}
            </select>
            <input value={newMachineId} onChange={e => setNewMachineId(e.target.value)}
              style={{ ...inp, flex: 1 }} placeholder="e.g. WP1"
              onKeyDown={e => e.key === "Enter" && addMachineId()} />
            <Btn onClick={addMachineId}>✅ Add</Btn>
            <Btn variant="ghost" onClick={() => { setShowAddId(false); setNewMachineId(""); setSelectedMachine(""); }}>Cancel</Btn>
          </div>
        </div>
      )}

      {/* Machine List */}
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {machineryData.map(m => (
          <div key={m.name} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "12px 16px" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
              <div style={{ color: theme.text, fontWeight: 700, fontSize: 14 }}>🚜 {m.name}</div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span style={{ color: theme.muted, fontSize: 11 }}>{m.ids.length} units</span>
                <button onClick={() => deleteMachine(m.name)}
                  style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 6, padding: "3px 10px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>🗑 Delete</button>
              </div>
            </div>
            <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
              {m.ids.length === 0 && <span style={{ color: theme.muted, fontSize: 12, fontStyle: "italic" }}>No IDs yet — click "+ Add Machine ID"</span>}
              {m.ids.map(id => (
                <span key={id} style={{ background: theme.accent + "22", border: `1px solid ${theme.accent}44`, color: theme.accent, borderRadius: 6, padding: "3px 10px", fontSize: 12, fontWeight: 700, display: "flex", alignItems: "center", gap: 6 }}>
                  {id}
                  <button onClick={() => deleteMachineId(m.name, id)}
                    style={{ background: "none", border: "none", color: theme.red, cursor: "pointer", fontSize: 13, padding: 0, lineHeight: 1 }}>×</button>
                </span>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
function MachineryEditModal({ rec, onClose, onSave }) {
  const [toDate, setToDate] = useState(rec.toDate || "");
  const [condition, setCondition] = useState(rec.condition || "");
  const [remark, setRemark] = useState(rec.remark || "");
  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 5, color: theme.text, padding: "6px 8px", fontSize: 12, outline: "none", width: "100%", boxSizing: "border-box" };
  return (
    <div style={{ position: "fixed", inset: 0, background: "#000c", zIndex: 400, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: theme.card, borderRadius: 16, width: "100%", maxWidth: 460, boxShadow: "0 20px 60px rgba(0,0,0,0.4)" }}>
        <div style={{ padding: "14px 20px", background: "#162040", borderRadius: "16px 16px 0 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ color: "#93c5fd", fontWeight: 800 }}>✏️ Edit Record — {rec.machineId}</div>
          <button onClick={onClose} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", borderRadius: 8, width: 30, height: 30, cursor: "pointer", fontSize: 16 }}>×</button>
        </div>
        <div style={{ padding: 20 }}>
          <div style={{ background: theme.bg, borderRadius: 8, padding: "10px 14px", marginBottom: 14 }}>
            <div style={{ color: theme.accent, fontWeight: 700 }}>{rec.machineName} — {rec.machineId}</div>
            <div style={{ color: theme.muted, fontSize: 12, marginTop: 2 }}>{rec.siteName} · From: {rec.fromDate}</div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ color: theme.muted, fontSize: 11, fontWeight: 600, display: "block", marginBottom: 4 }}>To Date</label>
            <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} style={{ ...inp, padding: "8px 10px" }} />
          </div>
          <div style={{ marginBottom: 12 }}>
            <label style={{ color: theme.muted, fontSize: 11, fontWeight: 600, display: "block", marginBottom: 4 }}>Condition</label>
            <select value={condition} onChange={e => setCondition(e.target.value)} style={{ ...inp, padding: "8px 10px", cursor: "pointer" }}>
              <option value="">— Select —</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={{ color: theme.muted, fontSize: 11, fontWeight: 600, display: "block", marginBottom: 4 }}>Remark</label>
            <input value={remark} onChange={e => setRemark(e.target.value)} style={{ ...inp, padding: "8px 10px" }} placeholder="Any remarks..." />
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
            <Btn onClick={() => onSave({ toDate, condition, remark })}>💾 Save</Btn>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProjectMachineryTracker({ projects, challans = [] }) {
  const [filterMachine, setFilterMachine] = useState("");
  const [filterProject, setFilterProject] = useState("");
  const [editingKey, setEditingKey] = useState(null);
  const [suppData, setSuppData] = useState(() => {
    const ls = localStorage.getItem("machinery_tracker_supp");
    return ls ? JSON.parse(ls) : {};
  });

  const saveSupp = async (key, data) => {
    const updated = { ...suppData, [key]: data };
    setSuppData(updated);
    localStorage.setItem("machinery_tracker_supp", JSON.stringify(updated));
    try { await setDoc(fsDoc(db, "machinery_tracker_supp", key), data); }
    catch (e) { console.error(e); }
  };

  const records = challans.flatMap(challan => {
    const project = projects.find(p => p.id === challan.projectId || p.projectCode === challan.projectCode);
    return (challan.machineryItems || []).map((m, idx) => {
      const key = `${challan.id}_${idx}`;
      const supp = suppData[key] || {};
      return {
        key,
        machineName: m.machineName || "—",
        machineId: m.machineId || "—",
        totalQty: m.quantity || "—",
        companyName: m.companyName || "—",
        siteName: challan.clientName || "—",
        location: challan.siteAddress || "—",
        fromDate: challan.date || "—",
        challanNo: challan.challanNo || "—",
        projectName: project?.name || challan.projectCode || "Unknown",
        toDate: supp.toDate || "",
        condition: supp.condition || "",
        remark: supp.remark || "",
      };
    });
  });

  const filtered = records.filter(r =>
    (!filterMachine || r.machineName?.toLowerCase().includes(filterMachine.toLowerCase()) ||
      r.machineId?.toLowerCase().includes(filterMachine.toLowerCase())) &&
    (!filterProject || r.siteName?.toLowerCase().includes(filterProject.toLowerCase()) ||
      r.projectName?.toLowerCase().includes(filterProject.toLowerCase()))
  );

  const th = { padding: "9px 10px", background: "#162040", color: "#93c5fd", fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "left", border: "1px solid rgba(99,179,237,0.2)", whiteSpace: "nowrap" };
  const td = { padding: "9px 10px", border: `1px solid ${theme.border}`, fontSize: 12, verticalAlign: "middle" };

  
  
  return (
    <div>
      {editingKey && (
  <MachineryEditModal
    rec={records.find(r => r.key === editingKey)}
    onClose={() => setEditingKey(null)}
    onSave={async (data) => {
      await saveSupp(editingKey, data);
      setEditingKey(null);
    }}
  />
)}

      <div style={{ background: theme.blue + "11", border: `1px solid ${theme.blue}33`, borderRadius: 10, padding: "10px 16px", marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
        <span>💡</span>
        <span style={{ color: theme.blue, fontSize: 12, fontWeight: 600 }}>Auto-fetched from Challans. Click ✏️ to update To Date, Condition and Remark.</span>
      </div>

      {/* Filters */}
      <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
        <input value={filterMachine} onChange={e => setFilterMachine(e.target.value)}
          placeholder="🔍 Search by machine name or ID..."
          style={{ flex: 1, background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.text, padding: "8px 12px", fontSize: 13, outline: "none" }} />
        <input value={filterProject} onChange={e => setFilterProject(e.target.value)}
          placeholder="🏗️ Filter by site or project..."
          style={{ flex: 1, background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.text, padding: "8px 12px", fontSize: 13, outline: "none" }} />
      </div>

      {/* Summary Cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))", gap: 12, marginBottom: 20 }}>
        {Object.keys(MACHINERY_LIST).map(name => {
          const count = records.filter(r => r.machineName === name).length;
          if (count === 0) return null;
          return (
            <div key={name} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "14px 16px" }}>
              <div style={{ fontSize: 20, marginBottom: 6 }}>🚜</div>
              <div style={{ color: theme.accent, fontWeight: 800, fontSize: 20 }}>{count}</div>
              <div style={{ color: theme.text, fontWeight: 600, fontSize: 12 }}>{name}</div>
              <div style={{ color: theme.muted, fontSize: 11, marginTop: 2 }}>deployments</div>
            </div>
          );
        })}
        {records.length === 0 && (
          <div style={{ gridColumn: "1 / -1", background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 40, textAlign: "center" }}>
            <div style={{ fontSize: 40, marginBottom: 10 }}>🚜</div>
            <div style={{ color: theme.muted }}>No machinery records yet. Add machinery when creating challans.</div>
          </div>
        )}
      </div>

      {/* Records Table */}
      {filtered.length > 0 && (
        <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
          <div style={{ padding: "12px 16px", background: "#162040" }}>
            <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>🚜 Machinery Deployment Records — {filtered.length} entries</div>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1200 }}>
              <thead>
                <tr>
                  {["SR No.", "Site Name", "Location", "Machinery Name", "Total Qty", "Company Name", "From Date", "To Date", "Machine ID", "Condition", "Remark", "Actions"].map(h => (
                    <th key={h} style={th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((r, i) => (
                  <tr key={r.key} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                    <td style={{ ...td, color: theme.muted, width: 50, textAlign: "center" }}>{i + 1}</td>
                    <td style={{ ...td, fontWeight: 600, minWidth: 130 }}>{r.siteName}</td>
                    <td style={{ ...td, minWidth: 160, color: theme.muted, fontSize: 11 }}>{r.location}</td>
                    <td style={{ ...td, fontWeight: 700, color: theme.text, minWidth: 130 }}>{r.machineName}</td>
                    <td style={{ ...td, color: theme.green, fontWeight: 700, textAlign: "center", minWidth: 80 }}>{r.totalQty}</td>
                    <td style={{ ...td, minWidth: 120 }}>{r.companyName}</td>
                    <td style={{ ...td, minWidth: 100 }}>{r.fromDate}</td>
                    <td style={{ ...td, minWidth: 100, color: r.toDate ? theme.text : theme.muted, fontStyle: r.toDate ? "normal" : "italic" }}>{r.toDate || "—"}</td>
                    <td style={{ ...td, color: theme.accent, fontWeight: 800, minWidth: 80 }}>{r.machineId}</td>
                    <td style={{ ...td, textAlign: "center", minWidth: 90 }}>
                      {r.condition ? (
                        <span style={{ background: r.condition === "Yes" ? theme.green + "22" : theme.red + "22", color: r.condition === "Yes" ? theme.green : theme.red, border: `1px solid ${r.condition === "Yes" ? theme.green : theme.red}44`, borderRadius: 5, padding: "2px 10px", fontSize: 11, fontWeight: 700 }}>
                          {r.condition}
                        </span>
                      ) : <span style={{ color: theme.muted, fontSize: 11 }}>—</span>}
                    </td>
                    <td style={{ ...td, minWidth: 130, color: theme.muted, fontStyle: r.remark ? "normal" : "italic", fontSize: 11 }}>{r.remark || "—"}</td>
                    <td style={{ ...td, minWidth: 80, textAlign: "center" }}>
                      <button onClick={() => setEditingKey(r.key)}
                        style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 5, padding: "4px 10px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>✏️ Edit</button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}
function EditProjectModal({ project, onClose, onSave }) {
  const [name, setName] = useState(project.name || "");
  const [clientName, setClientName] = useState(project.clientName || "");
  const [projectCode, setProjectCode] = useState(project.projectCode || "");
  const [location, setLocation] = useState(project.location || "");
  const [engineer, setEngineer] = useState(project.engineer || "");
  const [contractValue, setContractValue] = useState(project.contractValue || "");
  const [siteAddress, setSiteAddress] = useState(project.siteAddress || "");

  const inp = { width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "8px 10px", fontSize: 13, outline: "none", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 11, fontWeight: 600, display: "block", marginBottom: 4 };

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000c", zIndex: 400, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: theme.card, borderRadius: 16, width: "100%", maxWidth: 560, boxShadow: "0 20px 60px rgba(0,0,0,0.4)" }}>
        <div style={{ padding: "16px 20px", background: "#162040", borderRadius: "16px 16px 0 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 16 }}>✏️ Edit Project</div>
          <button onClick={onClose} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", borderRadius: 8, width: 32, height: 32, cursor: "pointer", fontSize: 16 }}>×</button>
        </div>
        <div style={{ padding: 20 }}>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
            <div><label style={lbl}>Project Name</label><input value={name} onChange={e => setName(e.target.value)} style={inp} /></div>
            <div><label style={lbl}>Client Name</label><input value={clientName} onChange={e => setClientName(e.target.value)} style={inp} /></div>
            <div><label style={lbl}>Project Code</label><input value={projectCode} onChange={e => setProjectCode(e.target.value.toUpperCase())} style={{ ...inp, color: theme.accent, fontWeight: 700 }} /></div>
            <div><label style={lbl}>Location</label><input value={location} onChange={e => setLocation(e.target.value)} style={inp} /></div>
            <div><label style={lbl}>Engineer</label><input value={engineer} onChange={e => setEngineer(e.target.value)} style={inp} /></div>
            <div><label style={lbl}>Contract Value ₹</label><input type="number" value={contractValue} onChange={e => setContractValue(e.target.value)} style={{ ...inp, color: theme.green, fontWeight: 700 }} /></div>
          </div>
          <div style={{ marginBottom: 16 }}>
            <label style={lbl}>Site Address</label>
            <input value={siteAddress} onChange={e => setSiteAddress(e.target.value)} style={inp} />
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
            <Btn onClick={() => onSave({ ...project, name, clientName, projectCode, location, engineer, contractValue: Number(contractValue), siteAddress })}>💾 Save Changes</Btn>
          </div>
        </div>
      </div>
    </div>
  );
}

function ProjectDashboard({ projects, challans = [], onSelect, onCreate, onSettings, onDelete, onUpdate }) {
  const [dashTab, setDashTab] = useState("projects");
  const [editProject, setEditProject] = useState(null);
  const active = projects.filter(p => p.status === "Active").length;
  const totalValue = projects.reduce((s, p) => s + p.contractValue, 0);
  const boqDone = projects.reduce((s, p) =>
    s + (p.raEntries || []).reduce((es, entry) =>
      es + (entry.items || []).reduce((is, item) => is + (Number(item.amount) || 0), 0), 0), 0);
  const boqTotal = projects.flatMap(p => p.boq || []).reduce((s, b) => s + (b.plannedQty || 0) * (b.rate || 0), 0);

  return (
    <div>
      {editProject && (
  <EditProjectModal
    project={editProject}
    onClose={() => setEditProject(null)}
    onSave={updated => {
      onUpdate(updated);
      setEditProject(null);
    }}
  />
)}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Admin Dashboard</div>
          <h2 style={{ color: theme.text, fontSize: 26, fontWeight: 800, margin: 0 }}>All Sites Overview</h2>
          <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>Mumbai Region · February 2026</div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn onClick={onSettings} variant="ghost">⚙️ Master BOQ</Btn>
          <Btn onClick={onCreate}>+ New Project</Btn>
        </div>
      </div>

      <div style={{ display: "flex", gap: 12, marginBottom: 22, flexWrap: "wrap" }}>
        <StatCard label="Active Sites" value={active} sub={`${projects.length} total`} color={theme.green} icon="🏗️" />
        <StatCard label="Contract Value" value={fmt(totalValue)} color={theme.accent} icon="💰" />
        <StatCard label="BOQ Progress" value={`${pct(boqDone, boqTotal)}%`} sub="overall completion" color={theme.blue} icon="📊" />
        <StatCard label="Engineers" value="8" sub="on active sites" color={theme.purple} icon="👷" />
      </div>

      {/* Tabs */}
      <Tabs active={dashTab} onChange={setDashTab} tabs={[
  { id: "projects", label: `🏗️ Active Sites (${projects.length})` },
  { id: "machinery", label: "🚜 Machinery Tracker" },
  { id: "machinerymaster", label: "⚙️ Machinery Master" },
  { id: "sitemaster", label: "🏗️ Site Master" },
]} />

      {/* ---- PROJECTS TAB ---- */}
      {dashTab === "projects" && (
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 14 }}>
          {projects.map(p => {
            const val = (p.boq || []).reduce((s, b) => s + (b.plannedQty || 0) * (b.rate || 0), 0);
            const done = (p.raEntries || []).reduce((s, entry) =>
              s + (entry.items || []).reduce((es, item) => es + (Number(item.amount) || 0), 0), 0);
            const progress = pct(done, val);
            return (
              <div key={p.id}
                style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 14, padding: 18, position: "relative", overflow: "hidden", transition: "border-color 0.2s" }}
                onMouseEnter={e => e.currentTarget.style.borderColor = theme.accent}
                onMouseLeave={e => e.currentTarget.style.borderColor = theme.border}>

                <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: statusColors[p.status] + "88" }} />

                {/* Clickable area */}
                <div onClick={() => onSelect(p.id)} style={{ cursor: "pointer" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 10 }}>
                    <div style={{ flex: 1, marginRight: 10 }}>
                      <div style={{ color: theme.text, fontWeight: 700, fontSize: 14, marginBottom: 2 }}>{p.name}</div>
                      <div style={{ color: theme.muted, fontSize: 11 }}>📍 {p.location}</div>
                    </div>
                    <Badge status={p.status} />
                  </div>
                  <div style={{ display: "flex", gap: 14, marginBottom: 12, flexWrap: "wrap" }}>
                    <div><div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Engineer</div><div style={{ color: theme.text, fontSize: 12, fontWeight: 600 }}>{p.engineer}</div></div>
                    <div><div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Contract</div><div style={{ color: theme.accent, fontSize: 12, fontWeight: 700 }}>{fmt(p.contractValue)}</div></div>
                    <div><div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Logs</div><div style={{ color: theme.text, fontSize: 12, fontWeight: 600 }}>{(p.logs || []).length}</div></div>
                  </div>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
                    <span style={{ color: theme.muted, fontSize: 11 }}>BOQ Progress</span>
                    <span style={{ color: progress >= 75 ? theme.green : progress >= 40 ? theme.accent : theme.red, fontWeight: 700, fontSize: 11 }}>{progress}%</span>
                  </div>
                  <ProgressBar value={progress} color={progress >= 75 ? theme.green : progress >= 40 ? theme.accent : theme.red} />
                </div>

                {/* Bottom row */}
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: 10, flexWrap: "wrap", gap: 6 }}>
                  <div style={{ display: "flex", gap: 5, flexWrap: "wrap", flex: 1, cursor: "pointer" }} onClick={() => onSelect(p.id)}>
                    {(p.services || []).map(s => (
                      <span key={s} style={{ background: theme.bg, border: `1px solid ${theme.border}`, color: theme.muted, borderRadius: 5, padding: "2px 7px", fontSize: 10 }}>{s}</span>
                    ))}
                  </div>
                  <button onClick={e => { e.stopPropagation(); setEditProject(p); }}
  style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700, cursor: "pointer", flexShrink: 0 }}>
  ✏️ Edit
</button>
<button onClick={e => {
  e.stopPropagation();
  if (!window.confirm(`Delete project "${p.name}"? This cannot be undone.`)) return;
  onDelete(p.id);
}}
  style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700, cursor: "pointer", flexShrink: 0 }}>
  🗑 Delete
</button>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {/* ---- MACHINERY TRACKER TAB ---- */}

    {dashTab === "machinery" && (
      
  <ProjectMachineryTracker projects={projects} challans={challans} />
)}
{dashTab === "machinerymaster" && (
  <MachineryMaster onUpdate={() => {}} />
)}
{dashTab === "sitemaster" && <SiteMaster projects={projects} />}
    </div>
  );
}

function ProjectBudgetSheet({ project, onUpdate }) {
  const sheets = project.budgetSheets || [];
  const [mode, setMode] = useState("list");
  const [activeSheet, setActiveSheet] = useState(null);

  const handleSave = (sheetData) => {
    const isEdit = sheets.find(s => s.id === sheetData.id);
    const updated = isEdit ? sheets.map(s => s.id === sheetData.id ? sheetData : s) : [sheetData, ...sheets];
    onUpdate({ ...project, budgetSheets: updated });
    setMode("list");
    setActiveSheet(null);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this budget sheet? This cannot be undone.")) return;
    onUpdate({ ...project, budgetSheets: sheets.filter(s => s.id !== id) });
  };

  if (mode === "create" || mode === "edit") {
    return <BudgetSheetForm project={project} existing={activeSheet} onSave={handleSave} onBack={() => { setMode("list"); setActiveSheet(null); }} />;
  }

  if (mode === "view" && activeSheet) {
    return <BudgetSheetPreview sheet={activeSheet} onClose={() => { setMode("list"); setActiveSheet(null); }} onEdit={() => setMode("edit")} />;
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Project Budget</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📋 Project Budget Sheets</h2>
          <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>{sheets.length} sheet{sheets.length !== 1 ? "s" : ""} saved</div>
        </div>
        <Btn onClick={() => { setActiveSheet(null); setMode("create"); }}>+ New Sheet</Btn>
      </div>

      {sheets.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 60, textAlign: "center" }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📋</div>
          <div style={{ color: theme.text, fontWeight: 800, fontSize: 18, marginBottom: 8 }}>No Budget Sheets Yet</div>
          <div style={{ color: theme.muted, fontSize: 13, marginBottom: 16 }}>Create your first project budget sheet</div>
          <Btn onClick={() => setMode("create")}>+ Create Sheet</Btn>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {sheets.map((s, i) => (
            <div key={s.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
              <div>
                <div style={{ color: theme.text, fontWeight: 800, fontSize: 15 }}>📋 {s.projectName || `Sheet ${i + 1}`}</div>
                <div style={{ color: theme.muted, fontSize: 12, marginTop: 3 }}>
                  Client: {s.client || "—"} · Scope: {s.scope || "—"} ·
                  Total: <span style={{ color: theme.accent, fontWeight: 700 }}>₹{(s.grandTotal || 0).toLocaleString("en-IN")}</span>
                </div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <Btn small variant="ghost" onClick={() => { setActiveSheet(s); setMode("view"); }}>👁 View</Btn>
                <Btn small variant="ghost" onClick={() => { setActiveSheet(s); setMode("edit"); }}>✏️ Edit</Btn>
                <Btn small variant="danger" onClick={() => handleDelete(s.id)}>🗑</Btn>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function BudgetSheetForm({ project, existing, onSave, onBack }) {
  const [client, setClient] = useState(existing?.client || "");
  const [projectName, setProjectName] = useState(existing?.projectName || project.name || "");
  const [scope, setScope] = useState(existing?.scope || "");
  const [totalArea, setTotalArea] = useState(existing?.totalArea || "");

  const [sec1, setSec1] = useState(existing?.sec1 || [{ id: Date.now(), description: "", coverage: "", unitPrice: "" }]);
  const [sec1SqM, setSec1SqM] = useState(existing?.sec1SqM || "");

  const [sec2, setSec2] = useState(existing?.sec2 || [{ id: Date.now() + 1, category: "", batch: "", workingDays: "", unitPrice: "" }]);
  const [sec2SqM, setSec2SqM] = useState(existing?.sec2SqM || "");

  const [sec3, setSec3] = useState(existing?.sec3 || [{ id: Date.now() + 2, name: "", amount: "" }]);
  const [sec3SqM, setSec3SqM] = useState(existing?.sec3SqM || "");

  const [totalSqM, setTotalSqM] = useState(existing?.totalSqM || "");
const [sqMtrRate, setSqMtrRate] = useState(existing?.sqMtrRate || "");
const [variations, setVariations] = useState(existing?.variations || "");
const [variationsAmount, setVariationsAmount] = useState(existing?.variationsAmount || "");

  // Section 1 calculations
  const s1Rows = sec1.map(r => {
    const qty = Math.round((Number(r.coverage) || 0) * 4000 * 100) / 100;
    const amount = Math.round(qty * (Number(r.unitPrice) || 0) * 100) / 100;
    return { ...r, qty, amount };
  });
  const s1Total = Math.round(s1Rows.reduce((s, r) => s + r.amount, 0) * 100) / 100;

  // Section 2 calculations
  const s2Rows = sec2.map(r => {
    const amount = Math.round((Number(r.unitPrice) || 0) * (Number(r.workingDays) || 0) * (Number(r.batch) || 0) * 100) / 100;
    return { ...r, amount };
  });
  const s2Total = Math.round(s2Rows.reduce((s, r) => s + r.amount, 0) * 100) / 100;

  // Section 3 calculations
  const s3Total = Math.round(sec3.reduce((s, r) => s + (Number(r.amount) || 0), 0) * 100) / 100;

  const grandTotal = Math.round((s1Total + s2Total + s3Total) * 100) / 100;
const contractValue = Math.round((Number(totalArea) || 0) * (Number(sqMtrRate) || 0) * 100) / 100;
const anticipatedProfit = Math.round((contractValue - grandTotal) * 100) / 100;
const profitMargin = contractValue > 0 ? Math.round((anticipatedProfit / contractValue) * 100 * 100) / 100 : 0;

  const handleSave = () => {
  onSave({
    id: existing?.id || Date.now(),
    client, projectName, scope, totalArea,
    sec1, sec1SqM, sec2, sec2SqM, sec3, sec3SqM,
    totalSqM, grandTotal, sqMtrRate, variations,
    variationsAmount, contractValue, anticipatedProfit, profitMargin,
    createdAt: existing?.createdAt || new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  });
};

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, color: theme.text, padding: "6px 8px", fontSize: 12, outline: "none", width: "100%", boxSizing: "border-box" };
  const thS = (color = theme.accent) => ({ padding: "9px 10px", background: color + "22", color, fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: `1px solid ${theme.border}`, whiteSpace: "nowrap" });
  const td = { padding: "7px 8px", border: `1px solid ${theme.border}`, fontSize: 12, textAlign: "center", verticalAlign: "middle" };
  const calc = (color) => ({ ...td, color, fontWeight: 700, background: color + "11" });
  const lbl = { color: theme.muted, fontSize: 11, fontWeight: 600, display: "block", marginBottom: 3 };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <button onClick={onBack} style={{ background: "none", border: "none", color: theme.muted, cursor: "pointer", fontSize: 13, marginBottom: 8, padding: 0 }}>← Back to Sheets</button>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📋 {existing ? "Edit Sheet" : "New Budget Sheet"}</h2>
        </div>
        <Btn onClick={handleSave}>💾 Save Sheet</Btn>
      </div>

      {/* Header Info */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 20, marginBottom: 20 }}>
        <div style={{ textAlign: "center", marginBottom: 16 }}>
          <div style={{ color: theme.accent, fontWeight: 900, fontSize: 18, letterSpacing: 1, textTransform: "uppercase" }}>PROJECT BUDGET SHEETS</div>
          <div style={{ color: theme.text, fontWeight: 700, fontSize: 14, marginTop: 4 }}>PERMATECH CONCRETE SOLUTIONS</div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div><label style={lbl}>Client</label><input value={client} onChange={e => setClient(e.target.value)} style={inp} placeholder="Client name..." /></div>
          <div><label style={lbl}>Project</label><input value={projectName} onChange={e => setProjectName(e.target.value)} style={inp} placeholder="Project name..." /></div>
          <div><label style={lbl}>Scope</label><input value={scope} onChange={e => setScope(e.target.value)} style={inp} placeholder="Scope of work..." /></div>
          <div><label style={lbl}>Total Area</label><input value={totalArea} onChange={e => setTotalArea(e.target.value)} style={inp} placeholder="e.g. 5000 Sq.M" /></div>
        </div>
      </div>

      {/* Section 1 — Material Costing */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden", marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 18px", borderBottom: `2px solid ${theme.blue}`, background: theme.blue + "11" }}>
          <div style={{ color: theme.blue, fontWeight: 800, fontSize: 14 }}>🧱 Section 1: Material Costing</div>
          <Btn small onClick={() => setSec1(s => [...s, { id: Date.now(), description: "", coverage: "", unitPrice: "" }])}>+ Add Row</Btn>
<label style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, borderRadius: 7, padding: "4px 12px", fontSize: 11, fontWeight: 700, color: theme.blue, cursor: "pointer" }}>
  📤 Import
  <input type="file" accept=".xlsx,.xls,.csv" style={{ display: "none" }} onChange={e => {
    if (!e.target.files[0]) return;
    importExcelFile(e.target.files[0], (data) => {
      if (!data.length) { alert("No data found."); return; }
      const newRows = data.map(row => ({
        id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
        description: row["Material Description"] || row["Description"] || row["description"] || "",
        coverage: String(row["Coverage"] || row["coverage"] || ""),
        unitPrice: String(row["Unit Price"] || row["Rate"] || row["rate"] || "")
      }));
      setSec1(s => [...s, ...newRows]);
      alert(`✅ Imported ${newRows.length} material rows!`);
    });
    e.target.value = "";
  }} />
</label>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 700 }}>
            <thead>
              <tr>
                {["SR", "Material Description", "Coverage", "Quantity (Auto)", "Unit Price (₹)", "Amount (₹)", ""].map(h => (
                  <th key={h} style={thS(theme.blue)}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {s1Rows.map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? "transparent" : theme.bg + "44" }}>
                  <td style={{ ...td, color: theme.faint, width: 40 }}>{i + 1}</td>
                  <td style={{ ...td, minWidth: 200 }}><input value={r.description} onChange={e => setSec1(s => s.map(x => x.id === r.id ? { ...x, description: e.target.value } : x))} style={inp} placeholder="Material name..." /></td>
                  <td style={{ ...td, width: 100 }}><input type="number" value={r.coverage} onChange={e => setSec1(s => s.map(x => x.id === r.id ? { ...x, coverage: e.target.value } : x))} style={{ ...inp, color: theme.blue }} placeholder="0" /></td>
                  <td style={calc(theme.purple)}>{r.qty.toLocaleString("en-IN")}</td>
                  <td style={{ ...td, width: 120 }}><input type="number" value={r.unitPrice} onChange={e => setSec1(s => s.map(x => x.id === r.id ? { ...x, unitPrice: e.target.value } : x))} style={{ ...inp, color: theme.accent }} placeholder="0" /></td>
                  <td style={calc(theme.green)}>₹{r.amount.toLocaleString("en-IN")}</td>
                  <td style={{ ...td, width: 40 }}>
                    <button onClick={() => setSec1(s => s.filter(x => x.id !== r.id))} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: theme.blue + "11", borderTop: `2px solid ${theme.blue}` }}>
                <td colSpan={4} style={{ ...td, textAlign: "right", fontWeight: 800, color: theme.blue }}>Grand Total Cost</td>
                <td style={{ ...td }}><input type="number" value={sec1SqM} onChange={e => setSec1SqM(e.target.value)} style={{ ...inp, color: theme.green }} placeholder="Sq.M" /></td>
                <td style={{ ...td, color: theme.blue, fontWeight: 900, fontSize: 14 }}>₹{s1Total.toLocaleString("en-IN")}</td>
                <td style={td} />
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* Section 2 — Labour Costing */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden", marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 18px", borderBottom: `2px solid ${theme.orange}`, background: theme.orange + "11" }}>
          <div style={{ color: theme.orange, fontWeight: 800, fontSize: 14 }}>👷 Section 2: Labour Costing</div>
          <Btn small onClick={() => setSec2(s => [...s, { id: Date.now(), category: "", batch: "", workingDays: "", unitPrice: "" }])}>+ Add Row</Btn>
<label style={{ background: theme.orange + "22", border: `1px solid ${theme.orange}44`, borderRadius: 7, padding: "4px 12px", fontSize: 11, fontWeight: 700, color: theme.orange, cursor: "pointer" }}>
  📤 Import
  <input type="file" accept=".xlsx,.xls,.csv" style={{ display: "none" }} onChange={e => {
    if (!e.target.files[0]) return;
    importExcelFile(e.target.files[0], (data) => {
      if (!data.length) { alert("No data found."); return; }
      const newRows = data.map(row => ({
        id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
        category: row["Category"] || row["category"] || "",
        batch: String(row["Batch"] || row["batch"] || ""),
        workingDays: String(row["Working Days"] || row["working days"] || ""),
        unitPrice: String(row["Unit Price"] || row["Rate"] || row["rate"] || "")
      }));
      setSec2(s => [...s, ...newRows]);
      alert(`✅ Imported ${newRows.length} labour rows!`);
    });
    e.target.value = "";
  }} />
</label>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 700 }}>
            <thead>
              <tr>
                {["SR", "Category", "Batch", "Working Days", "Unit Price (₹)", "Amount (₹)", ""].map(h => (
                  <th key={h} style={thS(theme.orange)}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {s2Rows.map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? "transparent" : theme.bg + "44" }}>
                  <td style={{ ...td, color: theme.faint, width: 40 }}>{i + 1}</td>
                  <td style={{ ...td, minWidth: 180 }}><input value={r.category} onChange={e => setSec2(s => s.map(x => x.id === r.id ? { ...x, category: e.target.value } : x))} style={inp} placeholder="Category..." /></td>
                  <td style={{ ...td, width: 100 }}><input type="number" value={r.batch} onChange={e => setSec2(s => s.map(x => x.id === r.id ? { ...x, batch: e.target.value } : x))} style={{ ...inp, color: theme.orange }} placeholder="0" /></td>
                  <td style={{ ...td, width: 120 }}><input type="number" value={r.workingDays} onChange={e => setSec2(s => s.map(x => x.id === r.id ? { ...x, workingDays: e.target.value } : x))} style={{ ...inp, color: theme.blue }} placeholder="0" /></td>
                  <td style={{ ...td, width: 120 }}><input type="number" value={r.unitPrice} onChange={e => setSec2(s => s.map(x => x.id === r.id ? { ...x, unitPrice: e.target.value } : x))} style={{ ...inp, color: theme.accent }} placeholder="0" /></td>
                  <td style={calc(theme.orange)}>₹{r.amount.toLocaleString("en-IN")}</td>
                  <td style={{ ...td, width: 40 }}>
                    <button onClick={() => setSec2(s => s.filter(x => x.id !== r.id))} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: theme.orange + "11", borderTop: `2px solid ${theme.orange}` }}>
                <td colSpan={4} style={{ ...td, textAlign: "right", fontWeight: 800, color: theme.orange }}>Grand Total Cost</td>
                <td style={td}><input type="number" value={sec2SqM} onChange={e => setSec2SqM(e.target.value)} style={{ ...inp, color: theme.green }} placeholder="Sq.M" /></td>
                <td style={{ ...td, color: theme.orange, fontWeight: 900, fontSize: 14 }}>₹{s2Total.toLocaleString("en-IN")}</td>
                <td style={td} />
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* Section 3 — Other Costs */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden", marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 18px", borderBottom: `2px solid ${theme.purple}`, background: theme.purple + "11" }}>
          <div style={{ color: theme.purple, fontWeight: 800, fontSize: 14 }}>📦 Section 3: Other Costs</div>
          <Btn small onClick={() => setSec3(s => [...s, { id: Date.now(), name: "", amount: "" }])}>+ Add Row</Btn>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 400 }}>
            <thead>
              <tr>
                {["SR", "Name", "Amount (₹)", ""].map(h => (
                  <th key={h} style={thS(theme.purple)}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sec3.map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? "transparent" : theme.bg + "44" }}>
                  <td style={{ ...td, color: theme.faint, width: 40 }}>{i + 1}</td>
                  <td style={{ ...td }}><input value={r.name} onChange={e => setSec3(s => s.map(x => x.id === r.id ? { ...x, name: e.target.value } : x))} style={inp} placeholder="Cost name..." /></td>
                  <td style={{ ...td, width: 180 }}><input type="number" value={r.amount} onChange={e => setSec3(s => s.map(x => x.id === r.id ? { ...x, amount: e.target.value } : x))} style={{ ...inp, color: theme.accent }} placeholder="0" /></td>
                  <td style={{ ...td, width: 40 }}>
                    <button onClick={() => setSec3(s => s.filter(x => x.id !== r.id))} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: theme.purple + "11", borderTop: `2px solid ${theme.purple}` }}>
                <td colSpan={1} style={{ ...td, textAlign: "right", fontWeight: 800, color: theme.purple }}>Grand Total Cost</td>
                <td style={td}><input type="number" value={sec3SqM} onChange={e => setSec3SqM(e.target.value)} style={{ ...inp, color: theme.green }} placeholder="Sq.M" /></td>
                <td style={{ ...td, color: theme.purple, fontWeight: 900, fontSize: 14 }}>₹{s3Total.toLocaleString("en-IN")}</td>
                <td style={td} />
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* Total Project Cost */}
      <div style={{ background: theme.accent + "11", border: `2px solid ${theme.accent}44`, borderRadius: 12, padding: "18px 24px" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12 }}>
          <div>
            <div style={{ color: theme.muted, fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1 }}>Total Project Cost</div>
            <div style={{ color: theme.text, fontSize: 12, marginTop: 2 }}>
              Material (₹{s1Total.toLocaleString("en-IN")}) + Labour (₹{s2Total.toLocaleString("en-IN")}) + Other (₹{s3Total.toLocaleString("en-IN")})
            </div>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <div>
              <label style={{ ...lbl, textAlign: "right" }}>Total Sq.M</label>
              <input type="number" value={totalSqM} onChange={e => setTotalSqM(e.target.value)} style={{ ...inp, width: 120, color: theme.green, textAlign: "center" }} placeholder="Sq.M" />
            </div>
            <div style={{ color: theme.accent, fontWeight: 900, fontSize: 28 }}>₹{grandTotal.toLocaleString("en-IN")}</div>
          </div>
        </div>
      </div>
    
    

{/* Contract Value, Variations, Profit */}
<div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
  <table style={{ width: "100%", borderCollapse: "collapse" }}>
    <tbody>
      {/* Contract Value */}
      <tr style={{ borderBottom: `1px solid ${theme.border}` }}>
        <td style={{ padding: "12px 16px", color: theme.text, fontWeight: 700, fontSize: 13, width: "40%" }}>Contract Value</td>
        <td style={{ padding: "12px 16px", color: theme.muted, fontSize: 12, width: "30%" }}>
          Total Area ({totalArea || "—"}) × Sq.Mtr Rate:
          <input type="number" value={sqMtrRate} onChange={e => setSqMtrRate(e.target.value)}
            style={{ ...inp, width: 100, display: "inline-block", marginLeft: 8, color: theme.accent }} placeholder="Rate" />
        </td>
        <td style={{ padding: "12px 16px", color: theme.green, fontWeight: 800, fontSize: 15, textAlign: "right" }}>
          ₹{contractValue.toLocaleString("en-IN")}
        </td>
      </tr>

      {/* Variations */}
      <tr style={{ borderBottom: `1px solid ${theme.border}` }}>
        <td style={{ padding: "12px 16px", color: theme.text, fontWeight: 700, fontSize: 13 }}>Variations (if any)</td>
        <td style={{ padding: "12px 16px" }}>
          <input value={variations} onChange={e => setVariations(e.target.value)}
            style={inp} placeholder="Enter variations description..." />
        </td>
        <td style={{ padding: "12px 16px", textAlign: "right" }}>
          <input type="number" value={variationsAmount} onChange={e => setVariationsAmount(e.target.value)}
            style={{ ...inp, width: 140, color: theme.blue, textAlign: "right" }} placeholder="₹ Amount" />
        </td>
      </tr>

      {/* Anticipated Profit */}
      <tr style={{ borderBottom: `1px solid ${theme.border}`, background: theme.green + "08" }}>
        <td style={{ padding: "12px 16px", color: theme.green, fontWeight: 700, fontSize: 13 }}>Anticipated Profit</td>
        <td style={{ padding: "12px 16px", color: theme.muted, fontSize: 12 }}>
          Contract Value (₹{contractValue.toLocaleString("en-IN")}) − Total Project Cost (₹{grandTotal.toLocaleString("en-IN")})
        </td>
        <td style={{ padding: "12px 16px", color: anticipatedProfit >= 0 ? theme.green : theme.red, fontWeight: 800, fontSize: 15, textAlign: "right" }}>
          ₹{anticipatedProfit.toLocaleString("en-IN")}
        </td>
      </tr>

      {/* Profit Margin % */}
      <tr style={{ background: theme.accent + "11" }}>
        <td style={{ padding: "12px 16px", color: theme.accent, fontWeight: 800, fontSize: 13 }}>Total Profit Margin %</td>
        <td style={{ padding: "12px 16px", color: theme.muted, fontSize: 12 }}>
          (Anticipated Profit ÷ Contract Value) × 100
        </td>
        <td style={{ padding: "12px 16px", color: profitMargin >= 0 ? theme.accent : theme.red, fontWeight: 900, fontSize: 18, textAlign: "right" }}>
          {profitMargin}%
        </td>
      </tr>
    </tbody>
  </table>
</div>
</div>
  );
}

function BudgetSheetPreview({ sheet, onClose, onEdit }) {
  const s1Rows = (sheet.sec1 || []).map(r => {
    const qty = Math.round((Number(r.coverage) || 0) * 4000 * 100) / 100;
    const amount = Math.round(qty * (Number(r.unitPrice) || 0) * 100) / 100;
    return { ...r, qty, amount };
  });
  const s1Total = Math.round(s1Rows.reduce((s, r) => s + r.amount, 0) * 100) / 100;

  const s2Rows = (sheet.sec2 || []).map(r => ({
    ...r, amount: Math.round((Number(r.unitPrice) || 0) * (Number(r.workingDays) || 0) * (Number(r.batch) || 0) * 100) / 100
  }));
  const s2Total = Math.round(s2Rows.reduce((s, r) => s + r.amount, 0) * 100) / 100;
  const s3Total = Math.round((sheet.sec3 || []).reduce((s, r) => s + (Number(r.amount) || 0), 0) * 100) / 100;
  const grandTotal = Math.round((s1Total + s2Total + s3Total) * 100) / 100;

  const th = (bg, color) => ({ padding: "8px 10px", background: bg, color, fontSize: 11, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: "1px solid #ccc" });
  const td = { padding: "7px 10px", border: "1px solid #ccc", fontSize: 12, textAlign: "center" };

  return (
    <div>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          #sheet-print-area, #sheet-print-area * { visibility: visible !important; }
          #sheet-print-area { position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; background: white !important; padding: 20px !important; }
          .no-print { display: none !important; }
        }
      `}</style>

      <div className="no-print" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <button onClick={onClose} style={{ background: "none", border: "none", color: theme.muted, cursor: "pointer", fontSize: 13, padding: 0 }}>← Back to Sheets</button>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn variant="ghost" onClick={onEdit}>✏️ Edit</Btn>
          <Btn variant="blue" onClick={() => window.print()}>🖨 Print / PDF</Btn>
        </div>
      </div>

      <div id="sheet-print-area" style={{ background: "#fff", color: "#000", padding: 24, borderRadius: 12, border: `1px solid ${theme.border}` }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 20, borderBottom: "2px solid #1a365d", paddingBottom: 16 }}>
          <div style={{ fontSize: 18, fontWeight: 900, color: "#1a365d", letterSpacing: 1, textTransform: "uppercase" }}>PROJECT BUDGET SHEETS</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#2563eb", marginTop: 4 }}>PERMATECH CONCRETE SOLUTIONS</div>
        </div>

        {/* Project Info */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 8, marginBottom: 20, background: "#f8fafc", borderRadius: 8, padding: 16, border: "1px solid #e2e8f0" }}>
          {[["Client", sheet.client], ["Project", sheet.projectName], ["Scope", sheet.scope], ["Total Area", sheet.totalArea]].map(([k, v]) => (
            <div key={k} style={{ display: "flex", gap: 8 }}>
              <span style={{ color: "#64748b", fontWeight: 700, fontSize: 12, minWidth: 80 }}>{k}:</span>
              <span style={{ color: "#0f172a", fontSize: 12, fontWeight: 600 }}>{v || "—"}</span>
            </div>
          ))}
        </div>

        {/* Section 1 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#1d4ed8", marginBottom: 8, textTransform: "uppercase" }}>Section 1: Material Costing</div>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr>{["SR", "Material Description", "Coverage", "Quantity", "Unit Price (₹)", "Amount (₹)"].map(h => <th key={h} style={th("#dbeafe", "#1d4ed8")}>{h}</th>)}</tr></thead>
            <tbody>
              {s1Rows.map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? "#fff" : "#f8fafc" }}>
                  <td style={td}>{i + 1}</td>
                  <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.description}</td>
                  <td style={td}>{r.coverage}</td>
                  <td style={{ ...td, color: "#7c3aed", fontWeight: 700 }}>{r.qty.toLocaleString("en-IN")}</td>
                  <td style={td}>₹{Number(r.unitPrice).toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: "#059669", fontWeight: 700 }}>₹{r.amount.toLocaleString("en-IN")}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: "#dbeafe" }}>
                <td colSpan={4} style={{ ...td, textAlign: "right", fontWeight: 800, color: "#1d4ed8" }}>Grand Total Cost</td>
                <td style={{ ...td, color: "#374151" }}>{sheet.sec1SqM ? `${sheet.sec1SqM} Sq.M` : "—"}</td>
                <td style={{ ...td, color: "#1d4ed8", fontWeight: 900, fontSize: 14 }}>₹{s1Total.toLocaleString("en-IN")}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        {/* Section 2 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#c2410c", marginBottom: 8, textTransform: "uppercase" }}>Section 2: Labour Costing</div>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr>{["SR", "Category", "Batch", "Working Days", "Unit Price (₹)", "Amount (₹)"].map(h => <th key={h} style={th("#ffedd5", "#c2410c")}>{h}</th>)}</tr></thead>
            <tbody>
              {s2Rows.map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? "#fff" : "#f8fafc" }}>
                  <td style={td}>{i + 1}</td>
                  <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.category}</td>
                  <td style={td}>{r.batch}</td>
                  <td style={td}>{r.workingDays}</td>
                  <td style={td}>₹{Number(r.unitPrice).toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: "#c2410c", fontWeight: 700 }}>₹{r.amount.toLocaleString("en-IN")}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: "#ffedd5" }}>
                <td colSpan={4} style={{ ...td, textAlign: "right", fontWeight: 800, color: "#c2410c" }}>Grand Total Cost</td>
                <td style={{ ...td, color: "#374151" }}>{sheet.sec2SqM ? `${sheet.sec2SqM} Sq.M` : "—"}</td>
                <td style={{ ...td, color: "#c2410c", fontWeight: 900, fontSize: 14 }}>₹{s2Total.toLocaleString("en-IN")}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        {/* Section 3 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#7c3aed", marginBottom: 8, textTransform: "uppercase" }}>Section 3: Other Costs</div>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead><tr>{["SR", "Name", "Amount (₹)"].map(h => <th key={h} style={th("#ede9fe", "#7c3aed")}>{h}</th>)}</tr></thead>
            <tbody>
              {(sheet.sec3 || []).map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? "#fff" : "#f8fafc" }}>
                  <td style={td}>{i + 1}</td>
                  <td style={{ ...td, textAlign: "left", fontWeight: 600 }}>{r.name}</td>
                  <td style={{ ...td, color: "#7c3aed", fontWeight: 700 }}>₹{Number(r.amount).toLocaleString("en-IN")}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: "#ede9fe" }}>
                <td style={{ ...td, textAlign: "right", fontWeight: 800, color: "#7c3aed" }}>Grand Total Cost</td>
                <td style={{ ...td, color: "#374151" }}>{sheet.sec3SqM ? `${sheet.sec3SqM} Sq.M` : "—"}</td>
                <td style={{ ...td, color: "#7c3aed", fontWeight: 900, fontSize: 14 }}>₹{s3Total.toLocaleString("en-IN")}</td>
              </tr>
            </tfoot>
          </table>
        </div>

       {/* Grand Total */}
<div style={{ background: "#1a365d", color: "#fff", borderRadius: 10, padding: "16px 24px", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
  <div>
    <div style={{ fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1, opacity: 0.8 }}>Total Project Cost</div>
    <div style={{ fontSize: 12, marginTop: 2, opacity: 0.7 }}>
      Material (₹{s1Total.toLocaleString("en-IN")}) + Labour (₹{s2Total.toLocaleString("en-IN")}) + Other (₹{s3Total.toLocaleString("en-IN")})
      {sheet.totalSqM ? ` · ${sheet.totalSqM} Sq.M` : ""}
    </div>
  </div>
  <div style={{ fontSize: 28, fontWeight: 900 }}>₹{grandTotal.toLocaleString("en-IN")}</div>
</div>

{/* Financial Summary */}
<table style={{ width: "100%", borderCollapse: "collapse", borderRadius: 10, overflow: "hidden" }}>
  <tbody>
    <tr style={{ background: "#f0fdf4" }}>
      <td style={{ ...td, textAlign: "left", fontWeight: 700, color: "#0f172a" }}>Contract Value</td>
      <td style={{ ...td, color: "#64748b", fontSize: 11 }}>
        {sheet.totalArea} × ₹{sheet.sqMtrRate}/Sq.M
      </td>
      <td style={{ ...td, color: "#059669", fontWeight: 800, fontSize: 14 }}>₹{(sheet.contractValue || 0).toLocaleString("en-IN")}</td>
    </tr>
    <tr style={{ background: "#fff" }}>
      <td style={{ ...td, textAlign: "left", fontWeight: 700, color: "#0f172a" }}>Variations (if any)</td>
      <td style={{ ...td, color: "#64748b" }}>{sheet.variations || "—"}</td>
      <td style={{ ...td, color: "#2563eb", fontWeight: 700 }}>{sheet.variationsAmount ? `₹${Number(sheet.variationsAmount).toLocaleString("en-IN")}` : "—"}</td>
    </tr>
    <tr style={{ background: "#f0fdf4" }}>
      <td style={{ ...td, textAlign: "left", fontWeight: 700, color: "#059669" }}>Anticipated Profit</td>
      <td style={{ ...td, color: "#64748b", fontSize: 11 }}>
        Contract Value − Total Project Cost
      </td>
      <td style={{ ...td, color: (sheet.anticipatedProfit || 0) >= 0 ? "#059669" : "#dc2626", fontWeight: 800, fontSize: 14 }}>
        ₹{(sheet.anticipatedProfit || 0).toLocaleString("en-IN")}
      </td>
    </tr>
    <tr style={{ background: "#eff6ff" }}>
      <td style={{ ...td, textAlign: "left", fontWeight: 800, color: "#1d4ed8", fontSize: 13 }}>Total Profit Margin %</td>
      <td style={{ ...td, color: "#64748b", fontSize: 11 }}>
        (Anticipated Profit ÷ Contract Value) × 100
      </td>
      <td style={{ ...td, color: (sheet.profitMargin || 0) >= 0 ? "#1d4ed8" : "#dc2626", fontWeight: 900, fontSize: 18 }}>
        {sheet.profitMargin || 0}%
      </td>
    </tr>
  </tbody>
</table>
      </div>
    </div>
  );
}

function ProjectBudget({ project, onUpdate }) {
  const budgets = project.budgets || [];
  const [mode, setMode] = useState("list");
  const [activeBudget, setActiveBudget] = useState(null);
  const [activeTemplate, setActiveTemplate] = useState("budget");

  const handleSave = (budgetData) => {
    const isEdit = budgets.find(b => b.id === budgetData.id);
    const updated = isEdit
      ? budgets.map(b => b.id === budgetData.id ? budgetData : b)
      : [budgetData, ...budgets];
    onUpdate({ ...project, budgets: updated });
    setMode("list");
    setActiveBudget(null);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this budget? This cannot be undone.")) return;
    onUpdate({ ...project, budgets: budgets.filter(b => b.id !== id) });
  };

  if (mode === "create" || mode === "edit") {
    return <ProjectBudgetForm
      project={project}
      existing={activeBudget}
      onSave={handleSave}
      onBack={() => { setMode("list"); setActiveBudget(null); }}
    />;
  }

  if (mode === "view" && activeBudget) {
    return <ProjectBudgetPreview
      budget={activeBudget}
      project={project}
      onClose={() => { setMode("list"); setActiveBudget(null); }}
      onEdit={() => setMode("edit")}
    />;
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Finance & P&L</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📈 Project Budget</h2>
        </div>
      </div>

      {/* Template Selector */}
      <div style={{ display: "flex", gap: 10, marginBottom: 20 }}>
        <button onClick={() => setActiveTemplate("budget")}
          style={{ padding: "10px 20px", borderRadius: 8, border: `1px solid ${activeTemplate === "budget" ? theme.accent : theme.border}`, background: activeTemplate === "budget" ? theme.accent + "22" : theme.card, color: activeTemplate === "budget" ? theme.accent : theme.text, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
          📊 Project Budget
        </button>
        <button onClick={() => setActiveTemplate("sheet")}
          style={{ padding: "10px 20px", borderRadius: 8, border: `1px solid ${activeTemplate === "sheet" ? theme.blue : theme.border}`, background: activeTemplate === "sheet" ? theme.blue + "22" : theme.card, color: activeTemplate === "sheet" ? theme.blue : theme.text, fontWeight: 700, fontSize: 13, cursor: "pointer" }}>
          📋 Project Budget Sheets
        </button>
      </div>

      {activeTemplate === "sheet" && <ProjectBudgetSheet project={project} onUpdate={onUpdate} />}

      {activeTemplate === "budget" && <>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
          <div style={{ color: theme.muted, fontSize: 13 }}>{budgets.length} budget{budgets.length !== 1 ? "s" : ""} saved</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
            {/* Download Template */}
            <Btn variant="ghost" onClick={() => downloadTemplate(
              ["Project Name", "Client", "Description", "Unit", "Qty", "Rate", "Amount"],
              "Project_Budget_Template.xlsx"
            )}>📥 Template</Btn>

            {/* Import Excel */}
            <label style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 9, padding: "8px 16px", fontSize: 13, fontWeight: 600, color: theme.text, cursor: "pointer", display: "inline-flex", alignItems: "center", gap: 6 }}>
              📤 Import Excel
              <input type="file" accept=".xlsx,.xls,.csv" style={{ display: "none" }}
                onChange={e => {
                  if (!e.target.files[0]) return;
                  importExcelFile(e.target.files[0], (data) => {
                    if (!data.length) { alert("No data found in file."); return; }
                    // Group rows by Project Name — each unique project becomes a budget
                    const grouped = {};
                    data.forEach(row => {
                      const pName = row["Project Name"] || row["project name"] || row["Project"] || "Imported Budget";
                      if (!grouped[pName]) grouped[pName] = [];
                      grouped[pName].push({
                        id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
                        description: row["Description"] || row["description"] || row["Item"] || "",
                        unit: row["Unit"] || row["unit"] || "",
                        qty: String(row["Qty"] || row["qty"] || row["Quantity"] || ""),
                        rate: String(row["Rate"] || row["rate"] || ""),
                        amount: String(row["Amount"] || row["amount"] || "")
                      });
                    });
                    const newBudgets = Object.entries(grouped).map(([pName, items]) => ({
                      id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
                      projectName: pName,
                      client: items[0]?.client || "",
                      items,
                      grandTotal: items.reduce((s, it) => s + (Number(it.qty) || 0) * (Number(it.rate) || 0), 0),
                      createdAt: new Date().toISOString(),
                      updatedAt: new Date().toISOString(),
                    }));
                    const updated = [...budgets, ...newBudgets];
                    onUpdate({ ...project, budgets: updated });
                    alert(`✅ Imported ${newBudgets.length} budget(s) with ${data.length} items!`);
                  });
                  e.target.value = "";
                }} />
            </label>

            <Btn onClick={() => { setActiveBudget(null); setMode("create"); }}>+ New Budget</Btn>
          </div>
        </div>

        {budgets.length === 0 ? (
          <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 60, textAlign: "center" }}>
            <div style={{ fontSize: 48, marginBottom: 16 }}>📈</div>
            <div style={{ color: theme.text, fontWeight: 800, fontSize: 18, marginBottom: 8 }}>No Budgets Yet</div>
            <div style={{ color: theme.muted, fontSize: 13, marginBottom: 16 }}>Create your first project budget or import from Excel</div>
            <div style={{ display: "flex", gap: 10, justifyContent: "center" }}>
              <Btn variant="ghost" onClick={() => downloadTemplate(["Project Name","Client","Description","Unit","Qty","Rate","Amount"], "Project_Budget_Template.xlsx")}>📥 Download Template</Btn>
              <Btn onClick={() => setMode("create")}>+ Create Budget</Btn>
            </div>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {budgets.map((b, i) => (
              <div key={b.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
                <div>
                  <div style={{ color: theme.text, fontWeight: 800, fontSize: 15 }}>📈 {b.projectName || `Budget ${i + 1}`}</div>
                  <div style={{ color: theme.muted, fontSize: 12, marginTop: 3 }}>
                    Created: {b.createdAt?.slice(0, 10) || "—"} ·
                    Grand Total: <span style={{ color: theme.accent, fontWeight: 700 }}>₹{(b.grandTotal || 0).toLocaleString("en-IN")}</span>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <Btn small variant="ghost" onClick={() => { setActiveBudget(b); setMode("view"); }}>👁 View</Btn>
                  <Btn small variant="ghost" onClick={() => { setActiveBudget(b); setMode("edit"); }}>✏️ Edit</Btn>
                  <Btn small variant="danger" onClick={() => handleDelete(b.id)}>🗑</Btn>
                </div>
              </div>
            ))}
          </div>
        )}
      </>}
    </div>
  );
}
function ProjectBudgetForm({ project, existing, onSave, onBack }) {
  const [projectName, setProjectName] = useState(existing?.projectName || project.name || "");
  const [profitPct, setProfitPct] = useState(existing?.profitPct || 10);
  const [profitArea, setProfitArea] = useState(existing?.profitArea || "");
  const [totalArea, setTotalArea] = useState(existing?.totalArea || "");
  const [section1, setSection1] = useState(existing?.section1 || [
    { id: Date.now(), item: "", rate: "", calculation: "", area: "" },
  ]);
  const [section2, setSection2] = useState(existing?.section2 || [
    { id: Date.now() + 1, item: "", rate: "", quantity: "" },
  ]);

  const addRow1 = () => setSection1(s => [...s, { id: Date.now(), item: "", rate: "", calculation: "", area: "" }]);
  const deleteRow1 = (id) => setSection1(s => s.filter(r => r.id !== id));
  const updateRow1 = (id, key, val) => setSection1(s => s.map(r => r.id === id ? { ...r, [key]: val } : r));

  const addRow2 = () => setSection2(s => [...s, { id: Date.now(), item: "", rate: "", quantity: "" }]);
  const deleteRow2 = (id) => setSection2(s => s.filter(r => r.id !== id));
  const updateRow2 = (id, key, val) => setSection2(s => s.map(r => r.id === id ? { ...r, [key]: val } : r));

  const s1Rows = section1.map(r => {
    const costPerM3 = Math.round((Number(r.rate) || 0) * (Number(r.calculation) || 0) * 100) / 100;
    const amount = Math.round(costPerM3 * (Number(r.area) || 0) * 100) / 100;
    return { ...r, costPerM3, amount };
  });
  const s1SumCostPerM3 = Math.round(s1Rows.reduce((s, r) => s + r.costPerM3, 0) * 100) / 100;
  const profitCostPerM3 = Math.round(s1SumCostPerM3 * (Number(profitPct) || 0) / 100 * 100) / 100;
  const profitRowAmount = Math.round(profitCostPerM3 * (Number(profitArea) || 0) * 100) / 100;
  const totalCostPerM3value = Math.round((s1SumCostPerM3 + profitCostPerM3) * 100) / 100;
  const s1Total = Math.round(totalCostPerM3value * (Number(totalArea) || 0) * 100) / 100;

  const s2Rows = section2.map(r => {
    const amount = Math.round((Number(r.rate) || 0) * (Number(r.quantity) || 0) * 100) / 100;
    return { ...r, amount };
  });
  const s2Total = Math.round(s2Rows.reduce((s, r) => s + r.amount, 0) * 100) / 100;
  const grandTotal = Math.round((s1Total + s2Total) * 100) / 100;
  const boqTotal = Math.round((project.boq || []).reduce((s, b) => s + ((Number(b.plannedQty) || 0) * (Number(b.rate) || 0)), 0) * 100) / 100;
const anticipatedProfit = Math.round((boqTotal - grandTotal) * 100) / 100;
const profitMargin = boqTotal > 0 ? Math.round((anticipatedProfit / boqTotal) * 10000) / 100 : 0;

  const handleSave = () => {
    onSave({
      id: existing?.id || Date.now(),
      projectName, profitPct, profitArea, totalArea,
      section1, section2, grandTotal,
      createdAt: existing?.createdAt || new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  };

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, color: theme.text, padding: "6px 8px", fontSize: 12, outline: "none", width: "100%", boxSizing: "border-box" };
  const thStyle = { padding: "10px 12px", background: theme.accent + "22", color: theme.accent, fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "center", borderBottom: `2px solid ${theme.accent}`, whiteSpace: "nowrap", border: `1px solid ${theme.border}` };
  const tdStyle = { padding: "8px 10px", border: `1px solid ${theme.border}`, fontSize: 12, textAlign: "center", verticalAlign: "middle" };
  const calcStyle = (color) => ({ ...tdStyle, color, fontWeight: 700, background: color + "11" });

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <button onClick={onBack} style={{ background: "none", border: "none", color: theme.muted, cursor: "pointer", fontSize: 13, marginBottom: 8, padding: 0 }}>← Back to Budgets</button>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📈 {existing ? "Edit Budget" : "New Budget"}</h2>
        </div>
        <Btn onClick={handleSave}>💾 Save Budget</Btn>
      </div>

      {/* Title Block */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 20, marginBottom: 20, textAlign: "center" }}>
        <div style={{ color: theme.accent, fontWeight: 900, fontSize: 18, letterSpacing: 1, textTransform: "uppercase", marginBottom: 12 }}>
          PERMATECH CONCRETE SOLUTIONS — PROJECT BUDGET
        </div>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 12 }}>
          <span style={{ color: theme.muted, fontSize: 13, fontWeight: 600 }}>Project Name:</span>
          <input value={projectName} onChange={e => setProjectName(e.target.value)}
            style={{ ...inp, width: 300, textAlign: "center", fontWeight: 700, fontSize: 14 }}
            placeholder="Enter project name..." />
        </div>
      </div>

      {/* Section 1 */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden", marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 18px", borderBottom: `2px solid ${theme.accent}`, background: theme.accent + "11" }}>
          <div style={{ color: theme.accent, fontWeight: 800, fontSize: 14 }}>📊 Section 1 — Per m³ Calculation</div>
          <Btn small onClick={addRow1}>+ Add Row</Btn>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 800 }}>
            <thead>
              <tr>
                {["SR", "Item", "Rate (₹)", "Calculation", "Cost per m³ (₹)", "Area (m³)", "Amount (₹)", ""].map(h => (
                  <th key={h} style={thStyle}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {s1Rows.map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? "transparent" : theme.bg + "44" }}>
                  <td style={{ ...tdStyle, color: theme.faint, width: 40 }}>{i + 1}</td>
                  <td style={{ ...tdStyle, minWidth: 180 }}><input value={r.item} onChange={e => updateRow1(r.id, "item", e.target.value)} style={inp} placeholder="Item name..." /></td>
                  <td style={{ ...tdStyle, width: 100 }}><input type="number" value={r.rate} onChange={e => updateRow1(r.id, "rate", e.target.value)} style={{ ...inp, color: theme.accent }} placeholder="0" /></td>
                  <td style={{ ...tdStyle, width: 110 }}><input type="number" value={r.calculation} onChange={e => updateRow1(r.id, "calculation", e.target.value)} style={{ ...inp, color: theme.blue }} placeholder="0" /></td>
                  <td style={calcStyle(theme.purple)}>₹{r.costPerM3.toLocaleString("en-IN")}</td>
                  <td style={{ ...tdStyle, width: 100 }}><input type="number" value={r.area} onChange={e => updateRow1(r.id, "area", e.target.value)} style={{ ...inp, color: theme.green }} placeholder="0" /></td>
                  <td style={calcStyle(theme.green)}>₹{r.amount.toLocaleString("en-IN")}</td>
                  <td style={{ ...tdStyle, width: 40 }}>
                    <button onClick={() => deleteRow1(r.id)} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              {/* Profit Row */}
              <tr style={{ background: theme.orange + "11", borderTop: `2px solid ${theme.border}` }}>
                <td style={{ ...tdStyle, color: theme.faint }}>★</td>
                <td style={{ ...tdStyle, color: theme.orange, fontWeight: 700, textAlign: "left", paddingLeft: 8 }}>
                  Profit & Overheads (<input type="number" value={profitPct} onChange={e => setProfitPct(e.target.value)} style={{ background: "transparent", border: "none", borderBottom: `1px solid ${theme.orange}`, color: theme.orange, fontWeight: 800, width: 36, fontSize: 12, outline: "none", textAlign: "center" }} />%)
                </td>
                <td style={{ ...tdStyle, color: theme.orange, fontWeight: 600, fontSize: 11 }}>{profitPct}% of subtotal</td>
                <td style={{ ...calcStyle(theme.orange), fontSize: 10 }}>({s1Rows.map(r => r.costPerM3).filter(v => v > 0).join(" + ")}) × {profitPct}%</td>
                <td style={calcStyle(theme.orange)}>₹{profitCostPerM3.toLocaleString("en-IN")}</td>
                <td style={tdStyle}><input type="number" value={profitArea} onChange={e => setProfitArea(e.target.value)} style={{ ...inp, color: theme.green }} placeholder="0" /></td>
                <td style={calcStyle(theme.orange)}>₹{profitRowAmount.toLocaleString("en-IN")}</td>
                <td style={tdStyle} />
              </tr>
              {/* Total Cost per m³ */}
              <tr style={{ background: theme.blue + "11", borderTop: `2px solid ${theme.blue}` }}>
                <td style={{ ...tdStyle, color: theme.faint }}>∑</td>
                <td style={{ ...tdStyle, color: theme.blue, fontWeight: 800, textAlign: "left", paddingLeft: 8 }}>Total Cost per m³</td>
                <td style={tdStyle} />
                <td style={{ ...calcStyle(theme.blue), fontSize: 11 }}>Sum of all costs</td>
                <td style={calcStyle(theme.blue)}>₹{totalCostPerM3value.toLocaleString("en-IN")}</td>
                <td style={tdStyle}><input type="number" value={totalArea} onChange={e => setTotalArea(e.target.value)} style={{ ...inp, color: theme.green }} placeholder="0" /></td>
                <td style={{ ...calcStyle(theme.blue), fontWeight: 900, fontSize: 14 }}>₹{s1Total.toLocaleString("en-IN")}</td>
                <td style={tdStyle} />
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* Section 2 */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden", marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 18px", borderBottom: `2px solid ${theme.green}`, background: theme.green + "11" }}>
          <div style={{ color: theme.green, fontWeight: 800, fontSize: 14 }}>📋 Section 2 — Direct Items</div>
          <Btn small onClick={addRow2}>+ Add Row</Btn>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 600 }}>
            <thead>
              <tr>
                {["SR", "Item", "Rate (₹)", "Quantity", "Amount (₹)", ""].map(h => (
                  <th key={h} style={{ ...thStyle, background: theme.green + "22", color: theme.green, borderBottom: `2px solid ${theme.green}` }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {s2Rows.map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? "transparent" : theme.bg + "44" }}>
                  <td style={{ ...tdStyle, color: theme.faint, width: 40 }}>{i + 1}</td>
                  <td style={{ ...tdStyle, minWidth: 200 }}><input value={r.item} onChange={e => updateRow2(r.id, "item", e.target.value)} style={inp} placeholder="Item name..." /></td>
                  <td style={{ ...tdStyle, width: 120 }}><input type="number" value={r.rate} onChange={e => updateRow2(r.id, "rate", e.target.value)} style={{ ...inp, color: theme.accent }} placeholder="0" /></td>
                  <td style={{ ...tdStyle, width: 120 }}><input type="number" value={r.quantity} onChange={e => updateRow2(r.id, "quantity", e.target.value)} style={{ ...inp, color: theme.blue }} placeholder="0" /></td>
                  <td style={calcStyle(theme.green)}>₹{r.amount.toLocaleString("en-IN")}</td>
                  <td style={{ ...tdStyle, width: 40 }}>
                    <button onClick={() => deleteRow2(r.id)} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: theme.green + "11", borderTop: `2px solid ${theme.green}` }}>
                <td colSpan={4} style={{ ...tdStyle, textAlign: "right", fontWeight: 800, color: theme.green }}>Section 2 Total</td>
                <td style={{ ...tdStyle, color: theme.green, fontWeight: 900, fontSize: 14 }}>₹{s2Total.toLocaleString("en-IN")}</td>
                <td style={tdStyle} />
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* Grand Total */}
     {/* Grand Total */}
<div style={{ background: theme.accent + "11", border: `2px solid ${theme.accent}44`, borderRadius: 12, padding: "18px 24px", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
  <div>
    <div style={{ color: theme.muted, fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1 }}>Grand Total (Total Project Cost)</div>
    <div style={{ color: theme.text, fontSize: 12, marginTop: 2 }}>Section 1 (₹{s1Total.toLocaleString("en-IN")}) + Section 2 (₹{s2Total.toLocaleString("en-IN")})</div>
  </div>
  <div style={{ color: theme.accent, fontWeight: 900, fontSize: 28 }}>₹{grandTotal.toLocaleString("en-IN")}</div>
</div>

{/* Financial Summary */}
<div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
  <div style={{ padding: "12px 18px", background: "#162040", borderBottom: `2px solid #93c5fd` }}>
    <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>💰 Financial Summary</div>
  </div>
  <table style={{ width: "100%", borderCollapse: "collapse" }}>
    <tbody>
      {/* BOQ Total */}
      <tr style={{ borderBottom: `1px solid ${theme.border}` }}>
        <td style={{ padding: "14px 18px", color: theme.text, fontWeight: 700, fontSize: 13, width: "35%" }}>
          Contract Value (BOQ Total)
          <div style={{ color: theme.green, fontSize: 10, fontWeight: 600, marginTop: 2 }}>✅ Auto-fetched from BOQ Tracker</div>
        </td>
        <td style={{ padding: "14px 18px", color: theme.muted, fontSize: 12 }}>
          {(project.boq || []).length} BOQ items
        </td>
        <td style={{ padding: "14px 18px", color: theme.green, fontWeight: 900, fontSize: 18, textAlign: "right" }}>
          ₹{boqTotal.toLocaleString("en-IN")}
        </td>
      </tr>

      {/* Anticipated Profit */}
      <tr style={{ borderBottom: `1px solid ${theme.border}`, background: anticipatedProfit >= 0 ? theme.green + "08" : theme.red + "08" }}>
        <td style={{ padding: "14px 18px", color: anticipatedProfit >= 0 ? theme.green : theme.red, fontWeight: 700, fontSize: 13 }}>
          Anticipated Profit
        </td>
        <td style={{ padding: "14px 18px", color: theme.muted, fontSize: 12 }}>
          BOQ Total (₹{boqTotal.toLocaleString("en-IN")}) − Grand Total (₹{grandTotal.toLocaleString("en-IN")})
        </td>
        <td style={{ padding: "14px 18px", color: anticipatedProfit >= 0 ? theme.green : theme.red, fontWeight: 900, fontSize: 18, textAlign: "right" }}>
          ₹{anticipatedProfit.toLocaleString("en-IN")}
        </td>
      </tr>

      {/* Profit Margin % */}
      <tr style={{ background: theme.accent + "11" }}>
        <td style={{ padding: "14px 18px", color: theme.accent, fontWeight: 800, fontSize: 13 }}>
          Anticipated Profit %
        </td>
        <td style={{ padding: "14px 18px", color: theme.muted, fontSize: 12 }}>
          (Anticipated Profit ÷ BOQ Total) × 100
        </td>
        <td style={{ padding: "14px 18px", color: profitMargin >= 0 ? theme.accent : theme.red, fontWeight: 900, fontSize: 24, textAlign: "right" }}>
          {profitMargin}%
        </td>
      </tr>
    </tbody>
  </table>
</div>
    </div>
  );
}

function ProjectBudgetPreview({ budget,project, onClose, onEdit }) {
  const s1Rows = (budget.section1 || []).map(r => {
    const costPerM3 = Math.round((Number(r.rate) || 0) * (Number(r.calculation) || 0) * 100) / 100;
    const amount = Math.round(costPerM3 * (Number(r.area) || 0) * 100) / 100;
    return { ...r, costPerM3, amount };
  });
  const s1SumCostPerM3 = Math.round(s1Rows.reduce((s, r) => s + r.costPerM3, 0) * 100) / 100;
  const profitCostPerM3 = Math.round(s1SumCostPerM3 * (Number(budget.profitPct) || 0) / 100 * 100) / 100;
  const profitRowAmount = Math.round(profitCostPerM3 * (Number(budget.profitArea) || 0) * 100) / 100;
  const totalCostPerM3value = Math.round((s1SumCostPerM3 + profitCostPerM3) * 100) / 100;
  const s1Total = Math.round(totalCostPerM3value * (Number(budget.totalArea) || 0) * 100) / 100;
  const s2Rows = (budget.section2 || []).map(r => ({
    ...r, amount: Math.round((Number(r.rate) || 0) * (Number(r.quantity) || 0) * 100) / 100
  }));
  const s2Total = Math.round(s2Rows.reduce((s, r) => s + r.amount, 0) * 100) / 100;
  const grandTotal = Math.round((s1Total + s2Total) * 100) / 100;
 const boqTotal = Math.round((project?.boq || []).reduce((s, b) => s + ((Number(b.plannedQty) || 0) * (Number(b.rate) || 0)), 0) * 100) / 100;
const anticipatedProfit = Math.round((boqTotal - grandTotal) * 100) / 100;
const profitMargin = boqTotal > 0 ? Math.round((anticipatedProfit / boqTotal) * 10000) / 100 : 0;

  const thPrint = { padding: "8px 10px", background: "#e8f4fd", color: "#1a365d", fontSize: 11, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: "1px solid #ccc" };
  const tdPrint = { padding: "7px 10px", border: "1px solid #ccc", fontSize: 12, textAlign: "center" };

  return (
    <div>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          #budget-print-area, #budget-print-area * { visibility: visible !important; }
          #budget-print-area { position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; background: white !important; padding: 20px !important; }
          .no-print { display: none !important; }
        }
      `}</style>

      {/* Action Bar */}
      <div className="no-print" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <button onClick={onClose} style={{ background: "none", border: "none", color: theme.muted, cursor: "pointer", fontSize: 13, padding: 0 }}>← Back to Budgets</button>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn variant="ghost" onClick={onEdit}>✏️ Edit</Btn>
          <Btn variant="blue" onClick={() => window.print()}>🖨 Print / PDF</Btn>
        </div>
      </div>

      {/* Printable Area */}
      <div id="budget-print-area" style={{ background: "#fff", color: "#000", padding: 24, borderRadius: 12, border: `1px solid ${theme.border}` }}>
        {/* Header */}
        <div style={{ textAlign: "center", marginBottom: 20, borderBottom: "2px solid #1a365d", paddingBottom: 16 }}>
          <div style={{ fontSize: 18, fontWeight: 900, color: "#1a365d", letterSpacing: 1, textTransform: "uppercase" }}>PERMATECH CONCRETE SOLUTIONS</div>
          <div style={{ fontSize: 14, fontWeight: 700, color: "#2563eb", marginTop: 4 }}>PROJECT BUDGET</div>
          <div style={{ fontSize: 13, fontWeight: 600, color: "#374151", marginTop: 8 }}>Project: {budget.projectName}</div>
          <div style={{ fontSize: 11, color: "#6b7280", marginTop: 4 }}>Created: {budget.createdAt?.slice(0, 10)} · Updated: {budget.updatedAt?.slice(0, 10)}</div>
        </div>

        {/* Section 1 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#1a365d", marginBottom: 8, textTransform: "uppercase" }}>Section 1 — Per m³ Calculation</div>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {["SR", "Item", "Rate (₹)", "Calculation", "Cost per m³ (₹)", "Area (m³)", "Amount (₹)"].map(h => (
                  <th key={h} style={thPrint}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {s1Rows.map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? "#fff" : "#f9fafb" }}>
                  <td style={tdPrint}>{i + 1}</td>
                  <td style={{ ...tdPrint, textAlign: "left", fontWeight: 600 }}>{r.item}</td>
                  <td style={tdPrint}>₹{Number(r.rate).toLocaleString("en-IN")}</td>
                  <td style={tdPrint}>{r.calculation}</td>
                  <td style={{ ...tdPrint, color: "#7c3aed", fontWeight: 700 }}>₹{r.costPerM3.toLocaleString("en-IN")}</td>
                  <td style={tdPrint}>{r.area}</td>
                  <td style={{ ...tdPrint, color: "#059669", fontWeight: 700 }}>₹{r.amount.toLocaleString("en-IN")}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: "#fff7ed" }}>
                <td style={tdPrint}>★</td>
                <td style={{ ...tdPrint, textAlign: "left", fontWeight: 700, color: "#ea580c" }}>Profit & Overheads ({budget.profitPct}%)</td>
                <td style={{ ...tdPrint, color: "#ea580c" }}>{budget.profitPct}% of subtotal</td>
                <td style={{ ...tdPrint, fontSize: 10 }}>({s1Rows.map(r => r.costPerM3).filter(v => v > 0).join(" + ")}) × {budget.profitPct}%</td>
                <td style={{ ...tdPrint, color: "#ea580c", fontWeight: 700 }}>₹{profitCostPerM3.toLocaleString("en-IN")}</td>
                <td style={tdPrint}>{budget.profitArea}</td>
                <td style={{ ...tdPrint, color: "#ea580c", fontWeight: 700 }}>₹{profitRowAmount.toLocaleString("en-IN")}</td>
              </tr>
              <tr style={{ background: "#eff6ff" }}>
                <td style={tdPrint}>∑</td>
                <td style={{ ...tdPrint, textAlign: "left", fontWeight: 800, color: "#1d4ed8" }}>Total Cost per m³</td>
                <td style={tdPrint} />
                <td style={{ ...tdPrint, fontSize: 11 }}>Sum of all costs</td>
                <td style={{ ...tdPrint, color: "#1d4ed8", fontWeight: 800 }}>₹{totalCostPerM3value.toLocaleString("en-IN")}</td>
                <td style={tdPrint}>{budget.totalArea}</td>
                <td style={{ ...tdPrint, color: "#1d4ed8", fontWeight: 900, fontSize: 14 }}>₹{s1Total.toLocaleString("en-IN")}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        {/* Section 2 */}
        <div style={{ marginBottom: 20 }}>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#065f46", marginBottom: 8, textTransform: "uppercase" }}>Section 2 — Direct Items</div>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                {["SR", "Item", "Rate (₹)", "Quantity", "Amount (₹)"].map(h => (
                  <th key={h} style={{ ...thPrint, background: "#d1fae5", color: "#065f46" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {s2Rows.map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? "#fff" : "#f9fafb" }}>
                  <td style={tdPrint}>{i + 1}</td>
                  <td style={{ ...tdPrint, textAlign: "left", fontWeight: 600 }}>{r.item}</td>
                  <td style={tdPrint}>₹{Number(r.rate).toLocaleString("en-IN")}</td>
                  <td style={tdPrint}>{r.quantity}</td>
                  <td style={{ ...tdPrint, color: "#059669", fontWeight: 700 }}>₹{r.amount.toLocaleString("en-IN")}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: "#d1fae5" }}>
                <td colSpan={4} style={{ ...tdPrint, textAlign: "right", fontWeight: 800, color: "#065f46" }}>Section 2 Total</td>
                <td style={{ ...tdPrint, color: "#065f46", fontWeight: 900, fontSize: 14 }}>₹{s2Total.toLocaleString("en-IN")}</td>
              </tr>
            </tfoot>
          </table>
        </div>

        {/* Grand Total */}
{/* Grand Total */}
<div style={{ background: "#1a365d", color: "#fff", borderRadius: 10, padding: "16px 24px", display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
  <div>
    <div style={{ fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 1, opacity: 0.8 }}>Grand Total (Total Project Cost)</div>
    <div style={{ fontSize: 12, marginTop: 2, opacity: 0.7 }}>Section 1 (₹{s1Total.toLocaleString("en-IN")}) + Section 2 (₹{s2Total.toLocaleString("en-IN")})</div>
  </div>
  <div style={{ fontSize: 28, fontWeight: 900 }}>₹{grandTotal.toLocaleString("en-IN")}</div>
</div>

{/* Financial Summary */}
<div style={{ border: "1px solid #ccc", borderRadius: 10, overflow: "hidden" }}>
  <div style={{ padding: "10px 16px", background: "#162040", borderBottom: "2px solid #93c5fd" }}>
    <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 13 }}>💰 Financial Summary</div>
  </div>
  <table style={{ width: "100%", borderCollapse: "collapse" }}>
    <tbody>
      <tr style={{ borderBottom: "1px solid #e5e7eb" }}>
        <td style={{ ...tdPrint, textAlign: "left", fontWeight: 700 }}>Contract Value (BOQ Total)</td>
        <td style={{ ...tdPrint, color: "#6b7280", fontSize: 11 }}>{(project?.boq || []).length} BOQ items · auto-fetched</td>
        <td style={{ ...tdPrint, color: "#059669", fontWeight: 900, fontSize: 15, textAlign: "right" }}>₹{boqTotal.toLocaleString("en-IN")}</td>
      </tr>
      <tr style={{ borderBottom: "1px solid #e5e7eb", background: anticipatedProfit >= 0 ? "#f0fdf4" : "#fef2f2" }}>
        <td style={{ ...tdPrint, textAlign: "left", fontWeight: 700, color: anticipatedProfit >= 0 ? "#059669" : "#dc2626" }}>Anticipated Profit</td>
        <td style={{ ...tdPrint, color: "#6b7280", fontSize: 11 }}>BOQ Total − Grand Total</td>
        <td style={{ ...tdPrint, color: anticipatedProfit >= 0 ? "#059669" : "#dc2626", fontWeight: 900, fontSize: 15, textAlign: "right" }}>₹{anticipatedProfit.toLocaleString("en-IN")}</td>
      </tr>
      <tr style={{ background: "#eff6ff" }}>
        <td style={{ ...tdPrint, textAlign: "left", fontWeight: 800, color: "#1d4ed8" }}>Anticipated Profit %</td>
        <td style={{ ...tdPrint, color: "#6b7280", fontSize: 11 }}>(Profit ÷ BOQ Total) × 100</td>
        <td style={{ ...tdPrint, color: profitMargin >= 0 ? "#1d4ed8" : "#dc2626", fontWeight: 900, fontSize: 20, textAlign: "right" }}>{profitMargin}%</td>
      </tr>
    </tbody>
  </table>
</div>
      </div>
    </div>
  );
}
function ChallanReceivedTab({ project, onUpdate }) {
  const [records, setRecords] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const key = `challan_received_${project.id}`;
    getDocs(collection(db, "challan_received")).then(snap => {
      const data = snap.docs.map(d => d.data()).filter(d => d.projectId === project.id);
      if (data.length > 0) setRecords(data);
      else {
        const ls = localStorage.getItem(key);
        if (ls) setRecords(JSON.parse(ls));
      }
    }).catch(() => {
      const ls = localStorage.getItem(key);
      if (ls) setRecords(JSON.parse(ls));
    });
  }, [project.id]);

  const saveRecords = async (updated) => {
    setRecords(updated);
    localStorage.setItem(`challan_received_${project.id}`, JSON.stringify(updated));
    setSaving(true);
    try {
      for (const r of updated) {
        await setDoc(fsDoc(db, "challan_received", String(r.id)), r);
      }
    } catch (e) { console.error(e); }
    finally { setSaving(false); }
  };

  const addRow = () => {
    saveRecords([...records, {
      id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
      projectId: project.id,
      challanNo: "", date: "", photo: null, fileName: "",
    }]);
  };

  const updateRecord = (id, key, val) => {
    setRecords(rs => rs.map(r => r.id === id ? { ...r, [key]: val } : r));
  };

  const deleteRecord = (id) => {
    if (!window.confirm("Delete this record?")) return;
    saveRecords(records.filter(r => r.id !== id));
  };

  const handlePhotoUpload = (id, file) => {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const updated = records.map(r => r.id === id ? { ...r, photo: e.target.result, fileName: file.name } : r);
      setRecords(updated);
      localStorage.setItem(`challan_received_${project.id}`, JSON.stringify(updated));
    };
    reader.readAsDataURL(file);
  };

  const inputStyle = { width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "8px 10px", fontSize: 13, outline: "none", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 4 };

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div style={{ color: theme.muted, fontSize: 13 }}>{records.length} challan{records.length !== 1 ? "s" : ""} received</div>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn variant="ghost" onClick={addRow}>+ Add Entry</Btn>
          <Btn onClick={() => saveRecords(records)} disabled={saving}>{saving ? "⏳ Saving..." : "💾 Save"}</Btn>
        </div>
      </div>

      {records.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>📥</div>
          <div style={{ color: theme.text, fontWeight: 800, fontSize: 16, marginBottom: 6 }}>No Challans Received Yet</div>
          <div style={{ color: theme.muted, fontSize: 13, marginBottom: 16 }}>Upload photos of challans received from site</div>
          <Btn onClick={addRow}>+ Add First Entry</Btn>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          {records.map((r, i) => (
            <div key={r.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "16px 18px", display: "flex", gap: 16, alignItems: "flex-start", flexWrap: "wrap" }}>
              {/* SR */}
              <div style={{ color: theme.accent, fontWeight: 800, fontSize: 16, width: 28, flexShrink: 0, paddingTop: 8 }}>{i + 1}</div>

              {/* Challan No */}
              <div style={{ flex: 1, minWidth: 180 }}>
                <label style={lbl}>Challan Number</label>
                <input value={r.challanNo} onChange={e => updateRecord(r.id, "challanNo", e.target.value)}
                  style={inputStyle} placeholder="e.g. PCS/RR/02/2025-26" />
              </div>

              {/* Date */}
              <div style={{ width: 160 }}>
                <label style={lbl}>Date of Challan</label>
                <input type="date" value={r.date} onChange={e => updateRecord(r.id, "date", e.target.value)} style={inputStyle} />
              </div>

              {/* Photo Upload */}
              <div style={{ flex: 1, minWidth: 200 }}>
                <label style={lbl}>Challan Photo</label>
                {!r.photo ? (
                  <label style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: 8, background: theme.bg, border: `2px dashed ${theme.border}`, borderRadius: 8, padding: "14px 16px", cursor: "pointer", color: theme.muted, fontSize: 13, fontWeight: 600 }}>
                    📷 Upload Challan Photo
                    <input type="file" accept="image/*,application/pdf" style={{ display: "none" }}
                      onChange={e => handlePhotoUpload(r.id, e.target.files[0])} />
                  </label>
                ) : (
                  <div style={{ background: theme.bg, border: `1px solid ${theme.green}44`, borderRadius: 8, padding: "10px 14px", display: "flex", alignItems: "center", gap: 10 }}>
                    {r.photo.startsWith("data:image") ? (
                      <img src={r.photo} alt="Challan" style={{ width: 48, height: 48, objectFit: "cover", borderRadius: 6, border: `1px solid ${theme.border}` }} />
                    ) : (
                      <div style={{ width: 48, height: 48, background: theme.accent + "22", borderRadius: 6, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 22 }}>📄</div>
                    )}
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ color: theme.text, fontSize: 12, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{r.fileName}</div>
                      <div style={{ color: theme.green, fontSize: 11, marginTop: 2 }}>✅ Uploaded</div>
                    </div>
                    <label style={{ background: theme.muted + "22", border: `1px solid ${theme.border}`, borderRadius: 6, padding: "4px 8px", fontSize: 11, cursor: "pointer", color: theme.muted, fontWeight: 600, flexShrink: 0 }}>
                      🔄 Replace
                      <input type="file" accept="image/*,application/pdf" style={{ display: "none" }}
                        onChange={e => handlePhotoUpload(r.id, e.target.files[0])} />
                    </label>
                  </div>
                )}
              </div>

              {/* Action Buttons */}
              <div style={{ display: "flex", gap: 8, flexShrink: 0, paddingTop: 22, flexWrap: "wrap" }}>
                {r.photo && <>
                  {/* View */}
                  <button onClick={() => {
                    const win = window.open();
                    win.document.write(`<html><body style="margin:0;background:#000;display:flex;align-items:center;justify-content:center;min-height:100vh">
                      ${r.photo.startsWith("data:image") ? `<img src="${r.photo}" style="max-width:100%;max-height:100vh;object-fit:contain"/>` : `<embed src="${r.photo}" type="application/pdf" width="100%" height="100vh"/>`}
                    </body></html>`);
                  }} style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 7, padding: "6px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                    👁 View
                  </button>

                  {/* Download */}
                  <button onClick={() => {
                    const a = document.createElement("a");
                    a.href = r.photo;
                    a.download = r.fileName || `challan_${r.challanNo || i + 1}`;
                    a.click();
                  }} style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 7, padding: "6px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                    📥 Download
                  </button>

                  {/* Print */}
                  {r.photo.startsWith("data:image") && (
                    <button onClick={() => {
                      const win = window.open("", "_blank");
                      win.document.write(`<html><head><style>body{margin:0}img{max-width:100%;display:block}@media print{body{margin:0}}</style></head>
                        <body><img src="${r.photo}" onload="window.print();window.close()"/></body></html>`);
                    }} style={{ background: theme.purple + "22", border: `1px solid ${theme.purple}44`, color: theme.purple, borderRadius: 7, padding: "6px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                      🖨 Print
                    </button>
                  )}
                </>}

                {/* Delete */}
                <button onClick={() => deleteRecord(r.id)}
                  style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 7, padding: "6px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                  🗑 Delete
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function CostingTab({ project, onUpdate }) {
  const [costingSubTab, setCostingSubTab] = useState("projectcosting");

  return (
    <div>
      <Tabs active={costingSubTab} onChange={setCostingSubTab} tabs={[
        { id: "projectcosting", label: "💰 Project Costing" },
        { id: "rateanalysis", label: "📊 Rate Analysis" },
      ]} />
      {costingSubTab === "projectcosting" && <MonthlyCostingTab project={project} />}
      {costingSubTab === "rateanalysis" && <RateAnalysisModule />}
    </div>
  );
}
function ProjectDetail({ project, onBack, onUpdate, challans, setChallans, materialRequests, setMaterialRequests, invoices, setInvoices }) {
  const [tab, setTab] = useState("boq");
  const [modal, setModal] = useState(null); 
  const [materialSubTab, setMaterialSubTab] = useState("requests");
  const boqTotal = project.boq.reduce((s, b) => s + b.plannedQty * b.rate, 0);
const boqDone = (project.raEntries || []).reduce((s, entry) =>
  s + (entry.items || []).reduce((es, item) => es + (Number(item.amount) || 0), 0), 0);
  const pending = (project.materialRequests || []).filter(r => r.status === "pending").length;

  return (
    <div>
      <button onClick={onBack} style={{ background: "none", border: "none", color: theme.muted, cursor: "pointer", fontSize: 13, marginBottom: 14, padding: 0 }}>← Back to Dashboard</button>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20, flexWrap: "wrap", gap: 10 }}>
        <div>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
            <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>{project.name}</h2>
            <Badge status={project.status} />
          </div>
          <div style={{ color: theme.muted, fontSize: 12 }}>📍 {project.location} · 👷 {project.engineer} · 🏢 {project.client}</div>
        </div>
        <div style={{ textAlign: "right" }}>
          <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Contract Value</div>
          <div style={{ color: theme.accent, fontSize: 20, fontWeight: 800 }}>{fmt(project.contractValue)}</div>
        </div>
      </div>
      <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
        <StatCard label="Progress" value={`${pct(boqDone, boqTotal)}%`} color={theme.green} />
        <StatCard label="BOQ Done" value={fmt(boqDone)} sub={`of ${fmt(boqTotal)}`} color={theme.blue} />
        <StatCard label="Logs" value={project.logs.length} color={theme.purple} />
        <StatCard label="Requests" value={(project.materialRequests || []).length} sub={`${pending} pending`} color={pending > 0 ? theme.red : theme.green} />
      </div>
      <Tabs active={tab} onChange={setTab} tabs={[
        { id: "boq", label: "📋 BOQ Tracker" },
        { id: "logs", label: `📝 Daily Progress Report (${project.logs.length})` },
       { id: "materials", label: `📦 Materials ${pending > 0 ? `(${pending})` : ""}` },
       { id: "documents", label: `📁 Documents` },

{ id: "billing", label: `🧾 Billing & Invoicing` },
{ id: "costing", label: `💰 Costing` },
{ id: "budget", label: `📈 Project Budget` },
       
      ]} />
      {tab === "boq" && <BOQTab project={project} onUpdate={onUpdate} onAdd={() => setModal("boq")} />}
     {tab === "logs" && <LogsTab project={project} onAdd={() => setModal("log")} onUpdate={onUpdate} challans={challans} />}
   {tab === "materials" && (
  <div>
    <Tabs active={materialSubTab} onChange={setMaterialSubTab} tabs={[
  { id: "requests", label: `📦 Material Requests${pending > 0 ? ` (${pending})` : ""}` },
  { id: "balance", label: "⚖️ Material Balance" },
{ id: "challan", label: `📄 Challan (${challans.filter(c => c.projectId === project.id || c.projectCode === project.projectCode || (!c.projectId && !c.projectCode)).length})` },
  { id: "challanreceived", label: "📥 Challan Received" },
]} />
{materialSubTab === "requests" && <MaterialsTab
  project={project}
  onRequest={() => setModal("request")}
  onUpdate={onUpdate}
  materialRequests={project.materialRequests || []}
  setMaterialRequests={(updated) => onUpdate({
    ...project,
    materialRequests: typeof updated === "function" ? updated(project.materialRequests || []) : updated
  })}
/>}
    {materialSubTab === "balance" && <MaterialBalanceTab project={project} onUpdate={onUpdate} challans={challans} />}
   {materialSubTab === "challan" && <ChallanModule
  challans={challans}
  setChallans={setChallans}
  projects={[project]}
  materialRequests={project.materialRequests || []}
  setMaterialRequests={(updated) => onUpdate({
    ...project,
    materialRequests: typeof updated === "function" ? updated(project.materialRequests || []) : updated
  })}
  currentProject={project}
/>}
{materialSubTab === "challanreceived" && <ChallanReceivedTab project={project} onUpdate={onUpdate} />}
  </div>
)}
      {tab === "documents" && <DocumentsTab project={project} onUpdate={onUpdate} />}

{tab === "billing" && <BillingModule
  invoices={project.invoices || []}
  setInvoices={(updated) => onUpdate({ ...project, invoices: typeof updated === "function" ? updated(project.invoices || []) : updated })}
  taxInvoicesProp={project.taxInvoices || []}
  setTaxInvoicesProp={(updated) => onUpdate({ ...project, taxInvoices: typeof updated === "function" ? updated(project.taxInvoices || []) : updated })}
  projects={[project]}
  currentProject={project}
/>}

{tab === "costing" && <CostingTab project={project} onUpdate={onUpdate} />}
{tab === "budget" && <ProjectBudget project={project} onUpdate={onUpdate} />}
     
     
      {modal === "log" && <DailyLogModal project={project} onClose={() => setModal(null)} onSave={log => {
  let updatedProject = { ...project, logs: [log, ...(project.logs || [])] };

  // Update BOQ raEntries from daily log boqUpdates
  if (log.boqUpdates && log.boqUpdates.length > 0) {
    const raEntries = [...(updatedProject.raEntries || [])];
    const existingIndex = raEntries.findIndex(e => e.date === log.date);

    // Get previous entry to calculate prevRaQty
    const sortedEntries = [...raEntries].sort((a, b) => a.date.localeCompare(b.date));
    const prevEntry = sortedEntries.filter(e => e.date < log.date).pop();

    // Build items for this date
    const items = (updatedProject.boq || []).map(boqItem => {
      const prevItem = prevEntry?.items?.find(i => i.id === boqItem.id);
      const prevCumulative = prevItem ? (prevItem.prevRaQty + prevItem.thisRaQty) : 0;
      const boqUpdate = log.boqUpdates.find(u => u.boqId === boqItem.id);
      const thisRaQty = boqUpdate ? boqUpdate.area : 0;
      const cumulative = Math.round((prevCumulative + thisRaQty) * 100) / 100;
      const balance = Math.round(((boqItem.plannedQty || 0) - cumulative) * 100) / 100;
      return {
        id: boqItem.id,
        description: boqItem.description,
        prevRaQty: prevCumulative,
        thisRaQty,
        cumulative,
        balance,
        amount: Math.round(thisRaQty * boqItem.rate * 100) / 100,
      };
    });

    const newEntry = { date: log.date, items };
    if (existingIndex >= 0) {
      raEntries[existingIndex] = newEntry;
    } else {
      raEntries.push(newEntry);
      raEntries.sort((a, b) => a.date.localeCompare(b.date));
    }
    updatedProject = { ...updatedProject, raEntries };
  }

  onUpdate(updatedProject);
  setModal(null);
}} />}

      {modal === "boq" && <AddBOQModal onClose={() => setModal(null)} onSave={item => { onUpdate({ ...project, boq: [...project.boq, { ...item, id: Date.now(), completedQty: 0 }] }); setModal(null); }} />}
      {modal === "request" && <MaterialRequestModal project={project} onClose={() => setModal(null)} onSave={req => {
  onUpdate({ ...project, materialRequests: [req, ...(project.materialRequests || [])] });
  setModal(null);
}} />}
    </div>
  );
}

function BOQTab({ project, onUpdate, onAdd }) {
  const today = new Date().toISOString().slice(0, 10);
  const raEntries = project.raEntries || [];

  // Find latest entry or create new
  const [selectedDate, setSelectedDate] = useState(() => {
    if (raEntries.length > 0) return raEntries[raEntries.length - 1].date;
    return today;
  });
  const [isEditing, setIsEditing] = useState(false);

  // Get the entry for selected date
  
  // Get previous entry to auto-fill prevRaQty
  
 

  // Working data for current editing session
  const getInitialItems = (forDate = selectedDate) => {
  const entry = raEntries.find(e => e.date === forDate);
  if (entry) {
    return project.boq.map(item => {
      const saved = entry.items.find(i => i.id === item.id) || {};
      return {
        id: item.id,
        prevRaQty: saved.prevRaQty || 0,
        thisRaQty: saved.thisRaQty || 0,
      };
    });
  } else {
    const sortedEntries = [...raEntries].sort((a, b) => a.date.localeCompare(b.date));
    const prevEntry = sortedEntries.filter(e => e.date < forDate).pop();
    return project.boq.map(item => {
      const lastItem = prevEntry?.items.find(i => i.id === item.id);
      const prevCumulative = lastItem ? (lastItem.cumulative || (lastItem.prevRaQty + lastItem.thisRaQty)) : 0;
      return { id: item.id, prevRaQty: prevCumulative, thisRaQty: 0 };
    });
  }
};

  const [workingItems, setWorkingItems] = useState(getInitialItems);
  const [saved, setSaved] = useState(false);

  // When date changes, reload working items
 const handleDateChange = (newDate) => {
  setSelectedDate(newDate);
  setIsEditing(false);
  setSaved(false);
  setWorkingItems(getInitialItems(newDate));
};
  const getRa = (id) => workingItems.find(r => r.id === id) || { prevRaQty: 0, thisRaQty: 0 };
  const updateRa = (id, key, value) => {
    setSaved(false);
    setWorkingItems(ws => ws.map(w => w.id === id ? { ...w, [key]: Number(value) } : w));
  };

  // Totals
  const totalBOQValue = project.boq.reduce((s, b) => s + (b.plannedQty || 0) * b.rate, 0);
  const totalThisRA = project.boq.reduce((s, b) => { const ra = getRa(b.id); return s + ra.thisRaQty * b.rate; }, 0);
  const totalCumulative = project.boq.reduce((s, b) => { const ra = getRa(b.id); return Math.round((s + (ra.prevRaQty + ra.thisRaQty) * b.rate) * 100) / 100; }, 0);
  const totalBalance = project.boq.reduce((s, b) => { const ra = getRa(b.id); return Math.round((s + ((b.plannedQty || 0) - (ra.prevRaQty + ra.thisRaQty)) * b.rate) * 100) / 100; }, 0); 

  const handleSave = () => {
    const itemsToSave = project.boq.map(item => {
      const ra = getRa(item.id);
      return {
        id: item.id,
        description: item.description,
        prevRaQty: ra.prevRaQty,
        thisRaQty: ra.thisRaQty,
        cumulative: Math.round((ra.prevRaQty + ra.thisRaQty) * 100) / 100,
        balance: Math.round(((item.plannedQty || 0) - (ra.prevRaQty + ra.thisRaQty)) * 100) / 100,
        amount: ra.thisRaQty * item.rate,
      };
    });

    const newEntry = { date: selectedDate, items: itemsToSave };
    const existingIndex = raEntries.findIndex(e => e.date === selectedDate);
    let updatedEntries;
    if (existingIndex >= 0) {
      updatedEntries = raEntries.map((e, i) => i === existingIndex ? newEntry : e);
    } else {
      updatedEntries = [...raEntries, newEntry].sort((a, b) => a.date.localeCompare(b.date));
    }

    onUpdate({ ...project, raEntries: updatedEntries });
    setSaved(true);
    setIsEditing(false);
  };

  // Navigate dates
  const sortedDates = raEntries.map(e => e.date).sort();
  const currentIdx = sortedDates.indexOf(selectedDate);
  const canGoPrev = currentIdx > 0;
  const canGoNext = currentIdx < sortedDates.length - 1;

  const inputStyle = { background: theme.bg, border: `1px solid ${theme.green}55`, borderRadius: 6, color: theme.green, padding: "5px 7px", fontSize: 12, outline: "none", width: "100%", textAlign: "center", boxSizing: "border-box", fontWeight: 600 };
  const cellStyle = (color = theme.text) => ({ color, fontSize: 12, padding: "10px 8px", textAlign: "center", borderBottom: `1px solid ${theme.border}`, fontWeight: 500 });
  const headerStyle = { color: theme.muted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", letterSpacing: 0.7, padding: "10px 8px", textAlign: "center", background: theme.bg, borderBottom: `2px solid ${theme.border}` };

  const isNewDate = !raEntries.find(e => e.date === selectedDate);

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
        <div>
          <span style={{ color: theme.text, fontWeight: 700, fontSize: 14 }}>Running Account (RA) Bill</span>
          <div style={{ color: theme.muted, fontSize: 11, marginTop: 2 }}>{raEntries.length} entries saved · {project.boq.length} BOQ items</div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          <Btn onClick={onAdd} small variant="ghost">+ Add BOQ Item</Btn>
          {(isEditing || isNewDate) && <Btn onClick={handleSave} small variant="success">💾 Save Entry</Btn>}
          {!isEditing && !isNewDate && <Btn onClick={() => setIsEditing(true)} small variant="ghost">✏️ Edit</Btn>}
        </div>
      </div>

      {/* Summary Cards */}
      <div style={{ display: "flex", gap: 12, marginBottom: 16 }}>
  <StatCard label="BOQ Value" value={fmt(totalBOQValue)} color={theme.blue} icon="📋" />
  <StatCard label="Balance" value={fmt(totalBalance)} color={theme.red} icon="⏳" />
</div>

      {/* Date Navigation */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "12px 16px", marginBottom: 16, display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap" }}>
        <button onClick={() => canGoPrev && handleDateChange(sortedDates[currentIdx - 1])} disabled={!canGoPrev}
          style={{ background: canGoPrev ? theme.blue + "22" : theme.border, border: `1px solid ${canGoPrev ? theme.blue + "44" : theme.border}`, color: canGoPrev ? theme.blue : theme.faint, borderRadius: 7, padding: "6px 12px", cursor: canGoPrev ? "pointer" : "not-allowed", fontSize: 13 }}>← Prev</button>

        <div style={{ flex: 1, display: "flex", alignItems: "center", gap: 10 }}>
          <input type="date" value={selectedDate} onChange={e => handleDateChange(e.target.value)}
            style={{ background: theme.bg, border: `1px solid ${theme.accent}44`, borderRadius: 7, color: theme.accent, padding: "6px 12px", fontSize: 13, fontWeight: 700, outline: "none" }} />
          {isNewDate
            ? <span style={{ background: theme.accent + "22", color: theme.accent, borderRadius: 5, padding: "2px 10px", fontSize: 11, fontWeight: 700 }}>NEW ENTRY</span>
            : <span style={{ background: theme.green + "22", color: theme.green, borderRadius: 5, padding: "2px 10px", fontSize: 11, fontWeight: 700 }}>SAVED</span>
          }
          {isEditing && <span style={{ background: theme.orange + "22", color: theme.orange, borderRadius: 5, padding: "2px 10px", fontSize: 11, fontWeight: 700 }}>EDITING</span>}
        </div>

        <button onClick={() => canGoNext && handleDateChange(sortedDates[currentIdx + 1])} disabled={!canGoNext}
          style={{ background: canGoNext ? theme.blue + "22" : theme.border, border: `1px solid ${canGoNext ? theme.blue + "44" : theme.border}`, color: canGoNext ? theme.blue : theme.faint, borderRadius: 7, padding: "6px 12px", cursor: canGoNext ? "pointer" : "not-allowed", fontSize: 13 }}>Next →</button>

        {/* Jump to today */}
        <button onClick={() => handleDateChange(today)}
          style={{ background: theme.purple + "22", border: `1px solid ${theme.purple}44`, color: theme.purple, borderRadius: 7, padding: "6px 12px", fontSize: 12, cursor: "pointer", fontWeight: 600 }}>Today</button>
      </div>

      {/* RA Table */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "auto" }}>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 900 }}>
          <thead>
            <tr>
              {["SR", "Description", "BOQ Qty", "Unit", "Rate ₹", "Prev RA Qty", "This RA Qty", "Cumulative Qty", "Balance Qty", "Amount ₹"].map(h => (
                <th key={h} style={headerStyle}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {project.boq.map((item, index) => {
              const ra = getRa(item.id);
              const cumulative = ra.prevRaQty + ra.thisRaQty;
              const balance = Math.round(((item.plannedQty || 0) - cumulative) * 100) / 100;
              const amount = ra.thisRaQty * item.rate;
              const isOverrun = balance < 0;
              const canEdit = isEditing || isNewDate;

              return (
                <tr key={item.id} style={{ background: index % 2 === 0 ? "transparent" : theme.bg + "44" }}>
                  <td style={cellStyle(theme.faint)}>{index + 1}</td>
                  <td style={{ ...cellStyle(theme.text), textAlign: "left", padding: "10px 12px", fontWeight: 600, minWidth: 200 }}>
                    {item.description}
                  </td>
           <td style={{ ...cellStyle(theme.blue), padding: "6px 8px" }}>
  <input
    type="number"
    value={item.plannedQty || ""}
    onChange={e => onUpdate({
      ...project,
      boq: project.boq.map(b => b.id === item.id
        ? { ...b, plannedQty: Number(e.target.value) }
        : b
      )
    })}
    style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, color: theme.blue, padding: "4px 8px", fontSize: 12, outline: "none", width: 80, textAlign: "center", fontWeight: 600 }}
    placeholder="0"
  />
</td>
                  <td style={cellStyle(theme.muted)}>{item.unit || "—"}</td>
                  <td style={cellStyle(theme.text)}>₹{item.rate}</td>

                  {/* Prev RA Qty */}
                  <td style={{ ...cellStyle(), padding: "6px 8px" }}>
                    {canEdit ? (
                      <input type="number" value={ra.prevRaQty}
                        onChange={e => updateRa(item.id, "prevRaQty", e.target.value)}
                        style={{ ...inputStyle, color: theme.muted, border: `1px solid ${theme.border}` }} min="0" />
                    ) : (
                      <span style={{ color: theme.muted }}>{ra.prevRaQty}</span>
                    )}
                  </td>

                  {/* This RA Qty */}
                  <td style={{ ...cellStyle(), padding: "6px 8px" }}>
                    {canEdit ? (
                      <input type="number" value={ra.thisRaQty}
                        onChange={e => updateRa(item.id, "thisRaQty", e.target.value)}
                        style={inputStyle} min="0" placeholder="Enter" />
                    ) : (
                      <span style={{ color: theme.green, fontWeight: 700 }}>{ra.thisRaQty}</span>
                    )}
                  </td>

                  {/* Cumulative */}
                  <td style={cellStyle(theme.accent)}>
                    <span style={{ background: theme.accent + "22", borderRadius: 5, padding: "3px 8px" }}>{cumulative}</span>
                  </td>

                  {/* Balance */}
                  <td style={cellStyle(isOverrun ? theme.red : theme.green)}>
                    <span style={{ background: (isOverrun ? theme.red : theme.green) + "22", borderRadius: 5, padding: "3px 8px" }}>
                      {balance}{isOverrun && " ⚠️"}
                    </span>
                  </td>

                {/* Amount */}
<td style={{ ...cellStyle(theme.text), fontWeight: 700 }}>{fmt(amount)}</td>

{/* Delete */}
<td style={{ ...cellStyle(), padding: "6px 8px" }}>
  <button onClick={() => {
    if (window.confirm(`Remove "${item.description}" from BOQ?`))
      onUpdate({ ...project, boq: project.boq.filter(b => b.id !== item.id) });
  }}
    style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
</td>
</tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr style={{ borderTop: `2px solid ${theme.border}`, background: theme.bg }}>
              <td colSpan={5} style={{ ...cellStyle(theme.text), textAlign: "right", fontWeight: 800, fontSize: 13 }}>TOTAL</td>
              <td style={cellStyle()} />
              <td style={cellStyle()} />
              <td style={{ ...cellStyle(theme.accent), fontWeight: 800 }}>{fmt(totalCumulative)}</td>
              <td style={{ ...cellStyle(theme.green), fontWeight: 800 }}>{fmt(totalBalance)}</td>
              <td style={{ ...cellStyle(theme.accent), fontWeight: 800 }}>{fmt(totalThisRA)}</td>
            </tr>
          </tfoot>
        </table>
      </div>

      {saved && (
        <div style={{ background: theme.green + "11", border: `1px solid ${theme.green}33`, borderRadius: 8, padding: "10px 14px", marginTop: 12, color: theme.green, fontSize: 12, fontWeight: 600 }}>
          ✓ Entry saved for {selectedDate}! Navigate to the next date to continue.
        </div>
      )}
    </div>
  );
}

function LogsTab({ project, onAdd, onUpdate, challans }) {
  const [viewLog, setViewLog] = useState(null);
  const [editLog, setEditLog] = useState(null);
  const [activeTab, setActiveTab] = useState("logs");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [summaryTab, setSummaryTab] = useState("supervisor");
  const [materialFilter, setMaterialFilter] = useState("");

  // Filter logs by date range
  const filteredLogs = (project.logs || []).filter(log => {
    if (!fromDate && !toDate) return true;
    if (fromDate && log.date < fromDate) return false;
    if (toDate && log.date > toDate) return false;
    return true;
  }).sort((a, b) => a.date.localeCompare(b.date));

  // ---- Supervisor Summary ----
 const supervisorSummary = filteredLogs
  .filter(log => log.supervisor?.name)
  .map(log => ({
    date: log.date,
    workLocation: log.workLocation || log.siteName || "—",
    name: log.supervisor.name,
    rate: log.supervisor.rate || 0,
    inTime: log.supervisor.inTime || "—",
    outTime: log.supervisor.outTime || "—",
    cost: log.costs?.supervisor || 0,
    travel: log.supervisor.travel || 0,
  }));
  // ---- Labour Summary ----
  const labourSummary = filteredLogs.flatMap(log =>
    (log.labours || []).filter(l => l.name).map(l => {
      const perHour = Math.round(((Number(l.rate) || 0) / 8) * 100) / 100;
      const totalHours = calcTotalHours(l.inTime, l.outTime);
      const cost = Math.round(perHour * totalHours * 100) / 100;
      return {
        date: log.date,
        workLocation: log.workLocation || log.siteName || "—",
        name: l.name,
        rate: l.rate || 0,
        inTime: l.inTime || "—",
        outTime: l.outTime || "—",
        perHour,
        totalHours,
        cost,
        travel: l.travellingCost || 0,
        food: l.foodCost || 0,
      };
    })
  );

  // ---- Material Summary ----
  const materialSummary = filteredLogs.flatMap(log =>
    (log.materials || []).filter(m => m.name).map(m => ({
      date: log.date,
      workLocation: log.workLocation || log.siteName || "—",
      company: m.company || "—",
      name: m.name,
      unit: m.unit || "—",
      qty: m.qty || 0,
      rate: m.rate || 0,
      coverage: m.coverage || "—",
      amount: Math.round((Number(m.qty) || 0) * (Number(m.rate) || 0) * 100) / 100,
    }))
  );

  // ---- Excel Export ----
  const exportToExcel = async () => {
    
    const wb = XLSX.utils.book_new();

    const dateRange = fromDate && toDate ? `${fromDate} to ${toDate}` : "All Dates";
    const header = [[`PERMATECH CONCRETE SOLUTIONS`], [`Project: ${project.name}`], [`Date Range: ${dateRange}`], [`Generated: ${new Date().toLocaleDateString("en-IN")}`], []];

    // Supervisor Sheet
    const supHeaders = ["Date", "Work Location", "Supervisor Name", "Rate (₹)", "In Time", "Out Time", "Cost (₹)", "Travel (₹)"];
const supData = supervisorSummary.map(r => [r.date, r.workLocation, r.name, r.rate, r.inTime, r.outTime, r.cost, r.travel]);
const supTotals = ["", "", "TOTAL", "", "", "", supervisorSummary.reduce((s, r) => s + Number(r.cost), 0), supervisorSummary.reduce((s, r) => s + Number(r.travel), 0)];
    const supSheet = XLSX.utils.aoa_to_sheet([...header, supHeaders, ...supData, [], supTotals]);
    supSheet["!cols"] = [{ wch: 12 }, { wch: 20 }, { wch: 20 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 12 }];
    XLSX.utils.book_append_sheet(wb, supSheet, "Supervisor Summary");

    // Labour Sheet
    const labHeaders = ["Date", "Work Location", "Labour Name", "Rate (₹)", "In Time", "Out Time", "Per Hour (₹)", "Total Hrs", "Cost (₹)", "Travel (₹)", "Food (₹)"];
    const labData = labourSummary.map(r => [r.date, r.workLocation, r.name, r.rate, r.inTime, r.outTime, r.perHour, r.totalHours, r.cost, r.travel, r.food]);
    const labTotals = ["", "", "TOTAL", "", "", "", "",
      labourSummary.reduce((s, r) => s + Number(r.totalHours), 0),
      labourSummary.reduce((s, r) => s + Number(r.cost), 0),
      labourSummary.reduce((s, r) => s + Number(r.travel), 0),
      labourSummary.reduce((s, r) => s + Number(r.food), 0),
    ];
    const labSheet = XLSX.utils.aoa_to_sheet([...header, labHeaders, ...labData, [], labTotals]);
    labSheet["!cols"] = [{ wch: 12 }, { wch: 20 }, { wch: 18 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 12 }, { wch: 10 }, { wch: 12 }, { wch: 10 }, { wch: 10 }];
    XLSX.utils.book_append_sheet(wb, labSheet, "Labour Summary");

    // Material Sheet
    const matHeaders = ["Date", "Work Location", "Company", "Product Name", "Unit", "Qty Used", "Rate (₹)", "Coverage", "Amount (₹)"];
    const matData = materialSummary.map(r => [r.date, r.workLocation, r.company, r.name, r.unit, r.qty, r.rate, r.coverage, r.amount]);
    const matTotals = ["", "", "", "TOTAL", "", materialSummary.reduce((s, r) => s + Number(r.qty), 0), "", "", materialSummary.reduce((s, r) => s + Number(r.amount), 0)];
    const matSheet = XLSX.utils.aoa_to_sheet([...header, matHeaders, ...matData, [], matTotals]);
    matSheet["!cols"] = [{ wch: 12 }, { wch: 20 }, { wch: 18 }, { wch: 22 }, { wch: 8 }, { wch: 10 }, { wch: 10 }, { wch: 14 }, { wch: 12 }];
    XLSX.utils.book_append_sheet(wb, matSheet, "Material Summary");

    XLSX.writeFile(wb, `DPR_Summary_${project.name}_${dateRange.replace(/ /g, "_")}.xlsx`);
  };

  // ---- PDF Print ----
  const printSummary = () => {
    const el = document.getElementById("dpr-summary-print");
    if (!el) return;
    const win = window.open("", "_blank");
    win.document.write(`
      <html><head><style>
        body { font-family: Arial, sans-serif; padding: 20px; font-size: 11px; }
        h2 { color: #1a365d; font-size: 16px; margin-bottom: 4px; }
        h3 { color: #1a365d; font-size: 13px; margin: 16px 0 6px; border-bottom: 2px solid #1a365d; padding-bottom: 4px; }
        .meta { color: #666; font-size: 11px; margin-bottom: 16px; }
        table { width: 100%; border-collapse: collapse; margin-bottom: 20px; }
        th { background: #1a365d; color: #fff; padding: 7px 8px; font-size: 10px; text-align: center; border: 1px solid #2d4a7a; }
        td { padding: 6px 8px; border: 1px solid #e2e8f0; font-size: 10px; }
        tr:nth-child(even) { background: #f8fafc; }
        .total-row { background: #1a365d !important; color: #fff; font-weight: bold; }
        .total-row td { color: #fff; border-color: #2d4a7a; }
        @media print { @page { margin: 10mm; } }
      </style></head><body>${el.innerHTML}</body></html>
    `);
    win.document.close();
    setTimeout(() => { win.print(); win.close(); }, 500);
  };

  const n = v => Number(v) || 0;
  const fmt = v => n(v).toLocaleString("en-IN");
  const th = { padding: "9px 10px", background: "#162040", color: "#93c5fd", fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: `1px solid rgba(99,179,237,0.2)`, whiteSpace: "nowrap" };
  const td = { padding: "8px 10px", border: `1px solid ${theme.border}`, fontSize: 11, textAlign: "center", verticalAlign: "middle" };
  const inp = { background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 12, outline: "none" };

  return (
    <div>
      <Tabs active={activeTab} onChange={setActiveTab} tabs={[
        { id: "logs", label: `📝 Daily Logs (${(project.logs || []).length})` },
        { id: "summary", label: "📊 Summary Report" },
      ]} />

      {/* ---- LOGS TAB ---- */}
      {activeTab === "logs" && (
        <div>
          <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
            <span style={{ color: theme.text, fontWeight: 600, fontSize: 13 }}>{(project.logs || []).length} Progress Report Entries</span>
            <Btn onClick={onAdd} small>+ Add Report</Btn>
          </div>
          {(project.logs || []).length === 0
            ? <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 36, textAlign: "center", color: theme.muted }}>No reports yet. Add today's progress.</div>
            : (project.logs || []).map(log => (
              <div key={log.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 10 }}>
                <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 8, flexWrap: "wrap", gap: 6 }}>
                  <div>
                    <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, marginBottom: 3 }}>📅 {log.date}</div>
                    <div style={{ color: theme.text, fontWeight: 700 }}>{log.workLocation || log.siteName}</div>
                  </div>
                  <div style={{ display: "flex", gap: 6 }}>
                    <Btn small variant="ghost" onClick={() => setViewLog(log)}>👁 View</Btn>
                    <Btn small variant="ghost" onClick={() => setEditLog(log)}>✏️ Edit</Btn>
                    <Btn small variant="blue" onClick={() => { setViewLog(log); setTimeout(() => window.print(), 300); }}>🖨 Print</Btn>
                    <Btn small variant="danger" onClick={() => {
                      if (!window.confirm("Delete this daily log?")) return;
                      const updated = { ...project, logs: (project.logs || []).filter(l => l.id !== log.id) };
                      onUpdate(updated);
                    }}>🗑</Btn>
                  </div>
                </div>
                <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 8 }}>
                  {[
                    ["Material", log.materials?.filter(m => m.name).map(m => m.name).join(", ") || "—"],
                    ["Labor", `${log.labours?.filter(l => l.name).length || 0} workers`],
                    ["Machinery", log.machinery || "—"],
                    ["Notes", log.workItems?.map(w => typeof w === "string" ? w : w.description).filter(Boolean).join(", ") || "—"]
                  ].map(([k, v]) => (
                    <div key={k} style={{ background: theme.bg, borderRadius: 7, padding: "7px 10px" }}>
                      <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase", marginBottom: 2 }}>{k}</div>
                      <div style={{ color: theme.text, fontSize: 11 }}>{v}</div>
                    </div>
                  ))}
                </div>
              </div>
            ))
          }
        </div>
      )}

      {/* ---- SUMMARY TAB ---- */}
      {activeTab === "summary" && (
        <div>
          {/* Date Range + Actions */}
          <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 16 }}>
            <div style={{ display: "flex", gap: 16, alignItems: "flex-end", flexWrap: "wrap" }}>
              <div>
                <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>FROM DATE</div>
                <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} style={inp} />
              </div>
              <div>
                <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>TO DATE</div>
                <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} style={inp} />
              </div>
              <Btn variant="ghost" onClick={() => { setFromDate(""); setToDate(""); }}>Clear</Btn>
              <div style={{ marginLeft: "auto", display: "flex", gap: 10 }}>
                <Btn variant="ghost" onClick={printSummary}>🖨 Download PDF</Btn>
                <Btn onClick={exportToExcel}>📥 Export Excel</Btn>
              </div>
            </div>
            {filteredLogs.length > 0 && (
              <div style={{ marginTop: 10, color: theme.muted, fontSize: 12 }}>
                Showing <span style={{ color: theme.accent, fontWeight: 700 }}>{filteredLogs.length}</span> logs
                {fromDate && toDate && ` from ${fromDate} to ${toDate}`}
              </div>
            )}
          </div>

          {filteredLogs.length === 0 ? (
            <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 40, textAlign: "center" }}>
              <div style={{ fontSize: 36, marginBottom: 10 }}>📊</div>
              <div style={{ color: theme.muted }}>No logs found for selected date range.</div>
            </div>
          ) : (
            <>
              {/* Summary Sub Tabs */}
              <Tabs active={summaryTab} onChange={setSummaryTab} tabs={[
                { id: "supervisor", label: `👤 Supervisor (${supervisorSummary.length})` },
                { id: "labour", label: `👷 Labour (${labourSummary.length})` },
                { id: "material", label: `📦 Material (${materialSummary.length})` },
              ]} />

              {/* Printable area */}
              <div id="dpr-summary-print">
                <h2 style={{ color: theme.text, margin: "0 0 4px" }}>PERMATECH CONCRETE SOLUTIONS</h2>
                <div style={{ color: theme.muted, fontSize: 12, marginBottom: 16 }}>
                  Project: {project.name} &nbsp;|&nbsp;
                  Date Range: {fromDate || "Start"} to {toDate || "Today"} &nbsp;|&nbsp;
                  Generated: {new Date().toLocaleDateString("en-IN")}
                </div>

                {/* ---- SUPERVISOR SUMMARY ---- */}
                {summaryTab === "supervisor" && (
                  <div>
                    <div style={{ color: theme.accent, fontWeight: 700, fontSize: 13, marginBottom: 10 }}>👤 Supervisor Summary</div>
                    <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }}>
                      <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 700 }}>
                        <thead>
                          <tr>{["Date", "Work Location", "Supervisor Name", "Rate ₹", "In Time", "Out Time", "Cost ₹", "Travel ₹"].map(h => <th key={h} style={th}>{h}</th>)}</tr>
                        </thead>
                        <tbody>
                          {supervisorSummary.map((r, i) => (
                            <tr key={i} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                              <td style={{ ...td, color: theme.accent, fontWeight: 700 }}>{r.date}</td>
                              <td style={{ ...td, textAlign: "left", paddingLeft: 12 }}>{r.workLocation}</td>
                              <td style={{ ...td, fontWeight: 600, textAlign: "left", paddingLeft: 12 }}>{r.name}</td>
                              <td style={{ ...td, color: theme.blue }}>₹{fmt(r.rate)}</td>
                              <td style={td}>{r.inTime}</td>
                              <td style={td}>{r.outTime}</td>
                              <td style={{ ...td, color: theme.green, fontWeight: 700 }}>₹{fmt(r.cost)}</td>
                              <td style={{ ...td, color: theme.orange, fontWeight: 700 }}>₹{fmt(r.travel)}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr style={{ background: "#162040" }}>
                            <td colSpan={6} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>TOTAL</td>
<td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(supervisorSummary.reduce((s, r) => s + n(r.cost), 0))}</td>
<td style={{ ...td, color: "#FCD34D", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(supervisorSummary.reduce((s, r) => s + n(r.travel), 0))}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                )}

                {/* ---- LABOUR SUMMARY ---- */}
                {summaryTab === "labour" && (
                  <div>
                    <div style={{ color: theme.accent, fontWeight: 700, fontSize: 13, marginBottom: 10 }}>👷 Labour Summary</div>
                    <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }}>
                      <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1000 }}>
                        <thead>
                          <tr>{["Date", "Work Location", "Labour Name", "Rate ₹", "In Time", "Out Time", "Per Hour ₹", "Total Hrs", "Cost ₹", "Travel ₹", "Food ₹"].map(h => <th key={h} style={th}>{h}</th>)}</tr>
                        </thead>
                        <tbody>
                          {labourSummary.map((r, i) => (
                            <tr key={i} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                              <td style={{ ...td, color: theme.accent, fontWeight: 700 }}>{r.date}</td>
                              <td style={{ ...td, textAlign: "left", paddingLeft: 12 }}>{r.workLocation}</td>
                              <td style={{ ...td, fontWeight: 600, textAlign: "left", paddingLeft: 12 }}>{r.name}</td>
                              <td style={{ ...td, color: theme.blue }}>₹{fmt(r.rate)}</td>
                              <td style={td}>{r.inTime}</td>
                              <td style={td}>{r.outTime}</td>
                              <td style={{ ...td, color: theme.purple }}>₹{fmt(r.perHour)}</td>
                              <td style={{ ...td, color: theme.blue, fontWeight: 700 }}>{r.totalHours}h</td>
                              <td style={{ ...td, color: theme.green, fontWeight: 700 }}>₹{fmt(r.cost)}</td>
                              <td style={{ ...td, color: theme.orange }}>₹{fmt(r.travel)}</td>
                              <td style={{ ...td, color: theme.green }}>₹{fmt(r.food)}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr style={{ background: "#162040" }}>
                            <td colSpan={7} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>TOTAL</td>
                            <td style={{ ...td, color: "#93c5fd", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>{labourSummary.reduce((s, r) => s + n(r.totalHours), 0)}h</td>
                            <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(labourSummary.reduce((s, r) => s + n(r.cost), 0))}</td>
                            <td style={{ ...td, color: "#FCD34D", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(labourSummary.reduce((s, r) => s + n(r.travel), 0))}</td>
                            <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(labourSummary.reduce((s, r) => s + n(r.food), 0))}</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                )}

               {/* ---- MATERIAL SUMMARY ---- */}
{summaryTab === "material" && (
  <div>
    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
      <div style={{ color: theme.accent, fontWeight: 700, fontSize: 13 }}>📦 Material Used Summary</div>
      <input
        value={materialFilter}
        onChange={e => setMaterialFilter(e.target.value)}
        placeholder="🔍 Filter by product name..."
        style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.text, padding: "7px 12px", fontSize: 12, outline: "none", width: 260 }}
      />
    </div>
    {materialFilter && (() => {
      const filtered = materialSummary.filter(r => r.name.toLowerCase().includes(materialFilter.toLowerCase()));
      const totalQty = filtered.reduce((s, r) => s + Number(r.qty), 0);
      const totalAmt = filtered.reduce((s, r) => s + Number(r.amount), 0);
      return filtered.length > 0 ? (
        <div style={{ background: theme.accent + "11", border: `1px solid ${theme.accent}33`, borderRadius: 8, padding: "10px 16px", marginBottom: 10, display: "flex", gap: 24, alignItems: "center", flexWrap: "wrap" }}>
          <span style={{ color: theme.muted, fontSize: 12 }}>Filter: <span style={{ color: theme.accent, fontWeight: 700 }}>"{materialFilter}"</span></span>
          <span style={{ color: theme.muted, fontSize: 12 }}>Entries: <span style={{ color: theme.blue, fontWeight: 700 }}>{filtered.length}</span></span>
          <span style={{ color: theme.muted, fontSize: 12 }}>Total Qty: <span style={{ color: theme.green, fontWeight: 700 }}>{totalQty}</span></span>
          <span style={{ color: theme.muted, fontSize: 12 }}>Total Amount: <span style={{ color: theme.green, fontWeight: 800 }}>₹{fmt(totalAmt)}</span></span>
        </div>
      ) : (
        <div style={{ background: theme.red + "11", border: `1px solid ${theme.red}33`, borderRadius: 8, padding: "10px 16px", marginBottom: 10, color: theme.red, fontSize: 12, fontWeight: 600 }}>
          No results found for "{materialFilter}"
        </div>
      );
    })()}
    <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }}>
                      <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 900 }}>
                        <thead>
                          <tr>{["Date", "Work Location", "Company", "Product Name", "Unit", "Qty Used", "Rate ₹", "Coverage", "Amount ₹"].map(h => <th key={h} style={th}>{h}</th>)}</tr>
                        </thead>
                        <tbody>
                         {(materialFilter ? materialSummary.filter(r => r.name.toLowerCase().includes(materialFilter.toLowerCase())) : materialSummary).map((r, i) => (
                            <tr key={i} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                              <td style={{ ...td, color: theme.accent, fontWeight: 700 }}>{r.date}</td>
                              <td style={{ ...td, textAlign: "left", paddingLeft: 12 }}>{r.workLocation}</td>
                              <td style={{ ...td, textAlign: "left", paddingLeft: 12 }}>{r.company}</td>
                              <td style={{ ...td, fontWeight: 600, textAlign: "left", paddingLeft: 12 }}>{r.name}</td>
                              <td style={td}>{r.unit}</td>
                              <td style={{ ...td, color: theme.blue, fontWeight: 700 }}>{r.qty}</td>
                              <td style={{ ...td, color: theme.blue }}>₹{fmt(r.rate)}</td>
                              <td style={td}>{r.coverage}</td>
                              <td style={{ ...td, color: theme.green, fontWeight: 700 }}>₹{fmt(r.amount)}</td>
                            </tr>
                          ))}
                        </tbody>
                        <tfoot>
                          <tr style={{ background: "#162040" }}>
                            <td colSpan={5} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>TOTAL</td>
                           {(() => {
  const ms = materialFilter ? materialSummary.filter(r => r.name.toLowerCase().includes(materialFilter.toLowerCase())) : materialSummary;
  return <>
    <td style={{ ...td, color: "#93c5fd", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>{ms.reduce((s, r) => s + n(r.qty), 0)}</td>
    <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
    <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
    <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(ms.reduce((s, r) => s + n(r.amount), 0))}</td>
  </>;
})()}
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      )}

      {viewLog && <DailyLogPreviewModal log={viewLog} project={project} onClose={() => setViewLog(null)} />}
      {editLog && <DailyLogModal project={project} existing={editLog} onClose={() => setEditLog(null)}
        onSave={updated => {
          let updatedProject = { ...project, logs: project.logs.map(l => l.id === editLog.id ? { ...updated, id: editLog.id } : l) };
          if (updated.boqUpdates && updated.boqUpdates.length > 0) {
            const raEntries = [...(updatedProject.raEntries || [])];
            const existingIndex = raEntries.findIndex(e => e.date === updated.date);
            const sortedEntries = [...raEntries].sort((a, b) => a.date.localeCompare(b.date));
            const prevEntry = sortedEntries.filter(e => e.date < updated.date).pop();
            const items = (updatedProject.boq || []).map(boqItem => {
              const prevItem = prevEntry?.items?.find(i => i.id === boqItem.id);
              const prevCumulative = prevItem ? (prevItem.prevRaQty + prevItem.thisRaQty) : 0;
              const boqUpdate = updated.boqUpdates.find(u => u.boqId === boqItem.id);
              const thisRaQty = boqUpdate ? boqUpdate.area : 0;
              const cumulative = Math.round((prevCumulative + thisRaQty) * 100) / 100;
              const balance = Math.round(((boqItem.plannedQty || 0) - cumulative) * 100) / 100;
              return { id: boqItem.id, description: boqItem.description, prevRaQty: prevCumulative, thisRaQty, cumulative, balance, amount: Math.round(thisRaQty * boqItem.rate * 100) / 100 };
            });
            const newEntry = { date: updated.date, items };
            if (existingIndex >= 0) raEntries[existingIndex] = newEntry;
            else { raEntries.push(newEntry); raEntries.sort((a, b) => a.date.localeCompare(b.date)); }
            updatedProject = { ...updatedProject, raEntries };
          }
          onUpdate(updatedProject);
          setEditLog(null);
        }}
      />}
    </div>
  );
}
function MaterialsTab({ project, onRequest, onUpdate, materialRequests = [], setMaterialRequests }) {
  
  const requests = materialRequests.filter(r => r.projectId === project.id);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
        <span style={{ color: theme.text, fontWeight: 600, fontSize: 13 }}>{requests.length} Requests</span>
        <Btn onClick={onRequest} small>+ New Request</Btn>
      </div>

      {requests.length === 0
        ? <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 36, textAlign: "center", color: theme.muted }}>No requests yet.</div>
        : requests.map(r => (
          <div key={r.id} style={{ background: theme.card, border: `1px solid ${r.status === "pending" ? theme.orange + "44" : r.status === "fulfilled" ? theme.green + "44" : r.status === "cancelled" ? theme.red + "44" : theme.border}`, borderRadius: 12, padding: "13px 16px", marginBottom: 10, display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: 10, flexWrap: "wrap" }}>
            <div>
              <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6 }}>
                <span style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>📦 Request — {r.date}</span>
                <span style={{
                  background: r.status === "pending" ? theme.orange + "22" : r.status === "fulfilled" ? theme.green + "22" : theme.red + "22",
                  color: r.status === "pending" ? theme.orange : r.status === "fulfilled" ? theme.green : theme.red,
                  borderRadius: 5, padding: "1px 8px", fontSize: 10, fontWeight: 700
                }}>
                  {r.status?.toUpperCase()}
                </span>
              </div>
              <div style={{ color: theme.muted, fontSize: 12, marginBottom: 6 }}>👤 {r.requestedBy}</div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                {r.items?.map((item, i) => (
                  <span key={i} style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, padding: "3px 8px", fontSize: 11, color: theme.text }}>
                    {item.name} — {item.qty} {item.unit}
                  </span>
                ))}
              </div>
              {r.notes && <div style={{ color: theme.faint, fontSize: 11, marginTop: 4, fontStyle: "italic" }}>"{r.notes}"</div>}
            </div>
            {r.status === "pending" && (
           <Btn small variant="danger" onClick={() => {
  if (window.confirm("Cancel this request?")) {
    const cancelledReq = materialRequests.find(x => x.id === r.id);
    if (cancelledReq) saveMaterialRequest({ ...cancelledReq, status: "cancelled" });
    setMaterialRequests(rs => rs.map(x => x.id === r.id ? { ...x, status: "cancelled" } : x));
  }
}}>✕ Cancel</Btn>
            )}
          </div>
        ))
      }
    </div>
  );
}


let LABOUR_LIST = [
  { name: "Bakimulla", rate: 650 },
  { name: "Harish", rate: 550 },
  { name: "Manish new", rate: 550 },
  { name: "Anuj", rate: 525 },
  { name: "Kandhai", rate: 575 },
  { name: "Sujit 1", rate: 575 },
  { name: "Shailendra", rate: 675 },
  { name: "Sushil", rate: 650 },
  { name: "Ashish new", rate: 575 },
  { name: "Kuldeep", rate: 625 },
  { name: "Jabbar", rate: 650 },
  { name: "Pradeep", rate: 550 },
  { name: "Kamlashankar", rate: 675 },
  { name: "Ramu", rate: 550 },
  { name: "Ajay 2", rate: 600 },
  { name: "Amit", rate: 525 },
  { name: "Ankit", rate: 575 },
  { name: "Dinesh", rate: 575 },
  { name: "Ranjeet", rate: 650 },
  { name: "Navab", rate: 650 },
  { name: "Siddik", rate: 550 },
  { name: "Abdul Azij", rate: 550 },
  { name: "Mukesh", rate: 650 },
];


const MATERIAL_LIST = {
  "IPA Bauchemische Produkte GmbH": [
    { name: "IPA Admix",                    unit: "Ltr", packing: "25", rate: 200 },
    { name: "IPA Slurry",                   unit: "Kg",  packing: "25", rate: 90  },
    { name: "IPA TRINKWASSERCHLAMME TW",    unit: "Kg",  packing: "25", rate: 146 },
    { name: "IPAFIX SchnellMörtel",         unit: "Kg",  packing: "25", rate: 135 },
    { name: "IPA Unimortar",                unit: "Kg",  packing: "25", rate: 95  },
  ],
  "WEBAC GmbH": [
    { name: "WEBAC 155", unit: "Kg", packing: "10.6", rate: 985  },
    { name: "WEBAC 15",  unit: "Kg", packing: "1",    rate: 1840 },
    { name: "Purseal",   unit: "",   packing: "",      rate: 0    },
  ],
  "Krypton Chemi GmbH": [
    { name: "Impermax Cold Polyurea", unit: "Kg", packing: "26.5", rate: 485 },
    { name: "Impermax",               unit: "Kg", packing: "25",   rate: 425 },
    { name: "Humidity Primer",        unit: "Kg", packing: "18",   rate: 870 },
  ],
  "Vandex": [
    { name: "Vandex AM 10",      unit: "Kg", packing: "25", rate: 120 },
    { name: "Vandex Super",      unit: "Kg", packing: "25", rate: 110 },
    { name: "Vandex BB75 Grey",  unit: "Kg", packing: "25", rate: 75  },
    { name: "Vandex BB75 White", unit: "Kg", packing: "25", rate: 110 },
  ],
  "Others": [
    { name: "Eniroof EMB PU",          unit: "Kg",  packing: "20", rate: 185  },
    { name: "Brushbond Polymer Coating",unit: "Set", packing: "25", rate: 2610 },
    { name: "Redroc Plug",             unit: "Kg",  packing: "15", rate: 57   },
    { name: "Parma Polymer 76",        unit: "Kg",  packing: "25", rate: 130  },
    { name: "Parma Polymer 401",       unit: "Kg",  packing: "25", rate: 140  },
    { name: "Silco Crete TRG",         unit: "Kg",  packing: "25", rate: 14   },
    { name: "Silico Ready Plast",      unit: "Kg",  packing: "40", rate: 6    },
    { name: "Supmol",                  unit: "Kg",  packing: "1",  rate: 145  },
    { name: "Accletor",                unit: "Kg",  packing: "20", rate: 150  },
    { name: "Alcofine Cement",         unit: "Kg",  packing: "25", rate: 68   },
  ],
  "Tools and Others": [
    { name: "Steel Packer",           unit: "",    packing: "", rate: 26  },
    { name: "Conneteor",              unit: "",    packing: "", rate: 40  },
    { name: "Oil",                    unit: "",    packing: "", rate: 140 },
    { name: "Thinner",                unit: "",    packing: "", rate: 140 },
    { name: "Hand Gloves",            unit: "",    packing: "", rate: 35  },
    { name: "Nose Mask",              unit: "",    packing: "", rate: 7   },
    { name: "Hammer",                 unit: "",    packing: "", rate: 120 },
    { name: "Chinzel",                unit: "",    packing: "", rate: 80  },
    { name: "Taccha",                 unit: "",    packing: "", rate: 70  },
    { name: "Thapi",                  unit: "",    packing: "", rate: 60  },
    { name: "Ghamela",                unit: "",    packing: "", rate: 100 },
    { name: "Coating Brush",          unit: "",    packing: "", rate: 75  },
    { name: "Cement Grouting Nozzel", unit: "No.", packing: "", rate: 500 },
    { name: "Cement Grouting Rubber", unit: "No.", packing: "", rate: 22  },
    { name: "Roller",                 unit: "",    packing: "", rate: 140 },
  ],
};



const calcTotalHours = (inTime, outTime) => {
  if (!inTime || !outTime) return 0;
  const [inH, inM] = inTime.split(":").map(Number);
  const [outH, outM] = outTime.split(":").map(Number);
  if (isNaN(inH) || isNaN(outH)) return 0;
  let diff = (outH + outM / 60) - (inH + inM / 60);
  if (diff < 0) diff += 24;
  return Math.round(diff * 100) / 100;
};


function DailyLogModal({ project, onClose, onSave,  existing }) {
const today = new Date().toISOString().slice(0, 10);
const [photos, setPhotos] = useState(existing?.photos || []);
const [date, setDate] = useState(existing?.date || today);
const [siteName, setSiteName] = useState(existing?.siteName || project.name);
const [workLocation, setWorkLocation] = useState(existing?.workLocation || "");
const [supervisorName, setSupervisorName] = useState(existing?.supervisor?.name || "");
const [supervisorRate, setSupervisorRate] = useState(existing?.supervisor?.rate || "");
const [supervisorInTime, setSupervisorInTime] = useState(existing?.supervisor?.inTime || "");
const [supervisorOutTime, setSupervisorOutTime] = useState(existing?.supervisor?.outTime || "");
const [supervisorTravel, setSupervisorTravel] = useState(existing?.supervisor?.travel || "");
const [labours, setLabours] = useState(existing?.labours?.length ? existing.labours : [{ name: "", rate: "", inTime: "", outTime: "", travellingCost: "" }]);
const [workItems, setWorkItems] = useState(existing?.workItems?.length ? existing.workItems : [{ boqId: "", description: "", area: "", isManual: false }]);

  // Section 7 — Materials Used (up to 3)
const [materials, setMaterials] = useState(existing?.materials?.length ? existing.materials : [
  { name: "", qty: "", unit: "", rate: "" },
]);

  // Section 8 — Material Balance (up to 3)


  // Section 9 — Other costs
  
const autoMaterialCost = materials.reduce((s, m) => s + ((Number(m.qty) || 0) * (Number(m.rate) || 0)), 0);
  const [travelCharges, setTravelCharges] = useState(existing?.costs?.porter || "");
const [mathadiCharges, setMathadiCharges] = useState(existing?.costs?.mathadi || "");

  // Auto calculations
 const supervisorCost = Number(supervisorRate) || 0;
const labourCost = labours.reduce((s, l) => {
  const perHour = (Number(l.rate) || 0) / 8;
  const totalHours = calcTotalHours(l.inTime, l.outTime);
  return s + (perHour * totalHours);
}, 0);

const labourPorterCost = labours.reduce((s, l) => s + (Number(l.travellingCost) || 0), 0);
const labourMathadiCost = labours.reduce((s, l) => s + (Number(l.mathadiCost) || 0), 0);
const labourFoodCost = labours.reduce((s, l) => s + (Number(l.foodCost) || 0), 0);
const totalCost = supervisorCost + labourCost + autoMaterialCost + (Number(travelCharges) || 0) + labourPorterCost + (Number(mathadiCharges) || 0) + labourFoodCost;

// Auto-calculate material balance

  const sectionStyle = {
    background: theme.bg,
    border: `1px solid ${theme.border}`,
    borderRadius: 10,
    padding: "14px 16px",
    marginBottom: 14,
  };
  const sectionTitle = {
    color: theme.red,
    fontWeight: 700,
    fontSize: 13,
    marginBottom: 12,
    letterSpacing: 0.5,
  };
  const rowStyle = { display: "flex", gap: 10, marginBottom: 8 };
  const labelStyle = { color: theme.muted, fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 4 };
  const inputStyle = { width: "100%", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "8px 10px", fontSize: 13, outline: "none", boxSizing: "border-box" };

  const handleSave = () => {
  const filledWork = workItems.filter(w => w.description?.trim());
  if (!date || filledWork.length === 0) return alert("Please fill Date and at least one Work item.");

  // Build BOQ updates from work items
  const boqUpdates = filledWork
    .filter(w => w.boqId && w.area)
    .map(w => ({ boqId: w.boqId, area: Number(w.area) || 0 }));

onSave({
  id: existing?.id || Date.now(),
  date,
  siteName,
  workLocation,
  supervisor: { name: supervisorName, rate: Number(supervisorRate), inTime: supervisorInTime, outTime: supervisorOutTime, travel: Number(supervisorTravel) || 0 },
  labours: labours.filter(l => l.name.trim()),
  workItems: filledWork,
  materials: materials.filter(m => m.name.trim()),
  costs: {
    supervisor: supervisorCost,
    labour: Math.round(labourCost * 100) / 100,
    material: autoMaterialCost,
    labourTravel: labourPorterCost,
    porter: Number(travelCharges) || 0,
    mathadi: Number(mathadiCharges) || 0,
    food: labourFoodCost,
    total: Math.round(totalCost * 100) / 100,
  },
  photos,
  boqUpdates,
});
  };
  return (
   <Modal title={existing ? "✏️ Edit Daily Progress Report" : "📝 Daily Progress Report"} onClose={onClose} width={1100}>
       

      {/* Sections 2–4 */}
      <div style={sectionStyle}>
        <div style={sectionTitle}>Basic Information</div>
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>1. Date</label>
            <input type="date" value={date} onChange={e => setDate(e.target.value)} style={inputStyle} />
          </div>
          <div style={{ flex: 2 }}>
            <label style={labelStyle}>2. Site Name</label>
            <input value={siteName} onChange={e => setSiteName(e.target.value)} style={inputStyle} />
          </div>
        </div>
        <div>
          <label style={labelStyle}>3. Work Location</label>
          <input value={workLocation} onChange={e => setWorkLocation(e.target.value)} placeholder="e.g. Basement, Terrace, Raft" style={inputStyle} />
        </div>
      </div>

      {/* Section 5 — Supervisor */}
      <div style={sectionStyle}>
        <div style={sectionTitle}>4. Supervisor Details</div>
        <div style={rowStyle}>
          <div style={{ flex: 2 }}>
            <label style={labelStyle}>Supervisor Name</label>
            <input value={supervisorName} onChange={e => setSupervisorName(e.target.value)} placeholder="e.g. Jamaul" style={inputStyle} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Rate (₹)</label>
            <input type="number" value={supervisorRate} onChange={e => setSupervisorRate(e.target.value)} placeholder="e.g. 1166" style={inputStyle} />
          </div>
          <div style={{ flex: 1 }}>
  <label style={labelStyle}>In Time</label>
  <input type="time" value={supervisorInTime} onChange={e => setSupervisorInTime(e.target.value)} style={inputStyle} />
</div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>Out Time</label>
            <input type="time" value={supervisorOutTime} onChange={e => setSupervisorOutTime(e.target.value)} style={inputStyle} />
          </div>
          <div style={{ flex: 1 }}>
  <label style={labelStyle}>Travel (₹)</label>
  <input type="number" value={supervisorTravel} onChange={e => setSupervisorTravel(e.target.value)}
    placeholder="0" style={{ ...inputStyle, color: theme.orange, fontWeight: 600 }} />
</div>
        </div>
      </div>

      {/* Section 6 — Labour */}

<div style={sectionStyle}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
    <div style={sectionTitle}>5. Labour Details</div>
    <button
      onClick={() => setLabours(ls => [...ls, { name: "", rate: "", inTime: "", outTime: "", travellingCost: "", mathadiCost: "", foodCost: "" }])}
      style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 7, width: 28, height: 28, fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>+</button>
  </div>

  <div style={{ overflowX: "auto" }}>
    {/* Column Headers */}
    <div style={{ display: "grid", gridTemplateColumns: "180px 80px 100px 100px 80px 80px 80px 80px 80px 28px", gap: 6, marginBottom: 6, minWidth: 980 }}>
      <div style={{ ...labelStyle, marginBottom: 0 }}>Labour Name</div>
      <div style={{ ...labelStyle, marginBottom: 0 }}>Rate ₹</div>
      <div style={{ ...labelStyle, marginBottom: 0 }}>In Time</div>
      <div style={{ ...labelStyle, marginBottom: 0 }}>Out Time</div>
      <div style={{ ...labelStyle, marginBottom: 0 }}>Per Hour ₹</div>
      <div style={{ ...labelStyle, marginBottom: 0 }}>Total Hrs</div>
      <div style={{ ...labelStyle, marginBottom: 0 }}>Cost ₹</div>
      <div style={{ ...labelStyle, marginBottom: 0 }}>Travel ₹</div>

         <div style={{ ...labelStyle, marginBottom: 0 }}>Food ₹</div>
      <div />
    </div>

    {/* Labour Rows */}
    {labours.map((l, i) => {
      const perHour = Math.round(((Number(l.rate) || 0) / 8) * 100) / 100;
      const totalHours = calcTotalHours(l.inTime, l.outTime);
      const cost = Math.round(perHour * totalHours * 100) / 100;
      return (
        <div key={i} style={{ display: "grid", gridTemplateColumns: "180px 80px 100px 100px 80px 80px 80px 80px 80px 28px", gap: 6, marginBottom: 8, alignItems: "center", minWidth: 980 }}>
          {/* Name Dropdown */}
          <input
  list={`labour-list-${i}`}
  value={l.name}
  onChange={e => {
    const selected = LABOUR_LIST.find(lb => lb.name === e.target.value);
    setLabours(ls => ls.map((x, j) => j === i
      ? { ...x, name: e.target.value, rate: selected ? selected.rate : x.rate }
      : x
    ));
  }}
  onFocus={e => e.target.select()}
  placeholder="Type or select labour..."
  style={{ ...inputStyle, color: l.name ? theme.text : theme.faint }}
/>
<datalist id={`labour-list-${i}`}>
  {LABOUR_LIST.map(lb => (
    <option key={lb.name} value={lb.name} />
  ))}
</datalist>

          {/* Rate */}
          <input
            type="number"
            value={l.rate}
            onChange={e => setLabours(ls => ls.map((x, j) => j === i ? { ...x, rate: e.target.value } : x))}
            placeholder="0"
            style={{ ...inputStyle, color: theme.accent, fontWeight: 600 }}
          />

          {/* In Time */}
          <input
            type="time"
            value={l.inTime}
            onChange={e => setLabours(ls => ls.map((x, j) => j === i ? { ...x, inTime: e.target.value } : x))}
            style={{ ...inputStyle, fontSize: 11 }}
          />

          {/* Out Time */}
          <input
            type="time"
            value={l.outTime}
            onChange={e => setLabours(ls => ls.map((x, j) => j === i ? { ...x, outTime: e.target.value } : x))}
            style={{ ...inputStyle, fontSize: 11 }}
          />

          {/* Per Hour */}
          <div style={{ background: theme.purple + "11", border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.purple, fontWeight: 600, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, padding: "8px 4px" }}>
            ₹{perHour}
          </div>

          {/* Total Hours */}
          <div style={{ background: theme.blue + "11", border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.blue, fontWeight: 600, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, padding: "8px 4px" }}>
            {totalHours}h
          </div>

          {/* Cost */}
          <div style={{ background: theme.accent + "11", border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.accent, fontWeight: 700, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 12, padding: "8px 4px" }}>
            ₹{cost}
          </div>

         {/* Porter Cost */}
          <input
            type="number"
            value={l.travellingCost || ""}
            onChange={e => setLabours(ls => ls.map((x, j) => j === i ? { ...x, travellingCost: e.target.value } : x))}
            placeholder="0"
            style={{ ...inputStyle, color: theme.orange, fontWeight: 600 }}
          />

        

              {/* Food Cost */}
          <input
            type="number"
            value={l.foodCost || ""}
            onChange={e => setLabours(ls => ls.map((x, j) => j === i ? { ...x, foodCost: e.target.value } : x))}
            placeholder="0"
            style={{ ...inputStyle, color: theme.green, fontWeight: 600 }}
          />

          {/* Remove button */}
          <button
            onClick={() => setLabours(ls => ls.filter((_, j) => j !== i))}
            style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 6, width: 28, height: 28, fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
        </div>
      );
    })}
  </div>

  {/* Total */}
  {labourCost > 0 && (
    <div style={{ background: theme.card, borderRadius: 8, padding: "10px 12px", marginTop: 6 }}>
      {labours.filter(l => l.name).map((l, i) => {
        const ph = Math.round(((Number(l.rate) || 0) / 8) * 100) / 100;
        const th = calcTotalHours(l.inTime, l.outTime);
        const c = Math.round(ph * th * 100) / 100;
        return (
          <div key={i} style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
            <span style={{ color: theme.muted, fontSize: 12 }}>{l.name} ({th}h × ₹{ph}/hr)</span>
            <span style={{ color: theme.accent, fontWeight: 700, fontSize: 12 }}>₹{c}</span>
          </div>
        );
      })}
      <div style={{ borderTop: `1px solid ${theme.border}`, paddingTop: 6, marginTop: 4, display: "flex", justifyContent: "space-between" }}>
        <span style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>Labour Cost</span>
        <span style={{ color: theme.accent, fontWeight: 800, fontSize: 14 }}>₹{Math.round(labourCost * 100) / 100}</span>
      </div>
     {labourPorterCost > 0 && (
  <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
    <span style={{ color: theme.muted, fontSize: 12 }}>Total Labour Travel</span>
    <span style={{ color: theme.orange, fontWeight: 700, fontSize: 12 }}>₹{labourPorterCost}</span>
  </div>
)}
    {labourMathadiCost > 0 && (
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
        <span style={{ color: theme.muted, fontSize: 12 }}>Total Mathadi Cost</span>
        <span style={{ color: theme.purple, fontWeight: 700, fontSize: 12 }}>₹{labourMathadiCost}</span>
      </div>
    )}
        {labourFoodCost > 0 && (
      <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
        <span style={{ color: theme.muted, fontSize: 12 }}>Total Food Cost</span>
        <span style={{ color: theme.green, fontWeight: 700, fontSize: 12 }}>₹{labourFoodCost}</span>
      </div>
    )}
    </div>
  )}
</div>
      {/* Section 7 — Work Done Today with BOQ Integration */}
<div style={sectionStyle}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
    <div style={sectionTitle}>6. Work Done Today</div>
    <button onClick={() => setWorkItems(ws => [...ws, { boqId: "", description: "", area: "", isManual: false }])}
      style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 7, width: 28, height: 28, fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>+</button>
  </div>

  {/* Header */}
  <div style={{ display: "grid", gridTemplateColumns: "1fr 140px 24px", gap: 8, marginBottom: 6 }}>
    <div style={{ ...labelStyle, marginBottom: 0 }}>BOQ Item / Work Description</div>
    <div style={{ ...labelStyle, marginBottom: 0 }}>Area Covered (thisRaQty)</div>
    <div />
  </div>

  {workItems.map((item, i) => (
    <div key={i} style={{ marginBottom: 10, background: theme.bg, borderRadius: 8, padding: "10px 12px", border: `1px solid ${theme.border}` }}>
      <div style={{ display: "grid", gridTemplateColumns: "1fr 140px 24px", gap: 8, alignItems: "center" }}>
        {/* BOQ Dropdown or Manual Input */}
        <div>
          {!item.isManual ? (
            <div style={{ display: "flex", gap: 6 }}>
              <input
                list={`boq-list-${i}`}
                value={item.description || ""}
                onChange={e => {
                  const found = (project.boq || []).find(b => b.description === e.target.value);
                  setWorkItems(ws => ws.map((x, j) => j === i ? {
                    ...x,
                    description: e.target.value,
                    boqId: found ? found.id : "",
                  } : x));
                }}
                onFocus={e => { e.target.select(); }}
                placeholder="Select or type BOQ item..."
                style={{ ...inputStyle, flex: 1 }}
              />
              <datalist id={`boq-list-${i}`}>
                {(project.boq || []).map(b => <option key={b.id} value={b.description} />)}
              </datalist>
              <button onClick={() => setWorkItems(ws => ws.map((x, j) => j === i ? { ...x, isManual: true, boqId: "", description: "" } : x))}
                style={{ background: theme.muted + "22", border: `1px solid ${theme.border}`, color: theme.muted, borderRadius: 6, padding: "4px 8px", fontSize: 10, cursor: "pointer", whiteSpace: "nowrap" }}>
                ✏️ Manual
              </button>
            </div>
          ) : (
            <div style={{ display: "flex", gap: 6 }}>
              <input
                value={item.description || ""}
                onChange={e => setWorkItems(ws => ws.map((x, j) => j === i ? { ...x, description: e.target.value } : x))}
                placeholder="Type work description manually..."
                style={{ ...inputStyle, flex: 1 }}
              />
              <button onClick={() => setWorkItems(ws => ws.map((x, j) => j === i ? { ...x, isManual: false, boqId: "", description: "" } : x))}
                style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 6, padding: "4px 8px", fontSize: 10, cursor: "pointer", whiteSpace: "nowrap" }}>
                📋 BOQ
              </button>
            </div>
          )}
          {/* Show matched BOQ info */}
          {item.boqId && (() => {
            const boqItem = (project.boq || []).find(b => b.id === item.boqId);
            return boqItem ? (
              <div style={{ color: theme.green, fontSize: 10, marginTop: 3, fontWeight: 600 }}>
                ✓ Matched BOQ: {boqItem.description} · Rate: ₹{boqItem.rate} · Unit: {boqItem.unit}
              </div>
            ) : null;
          })()}
        </div>

        {/* Area Input */}
        <input
          type="number"
          value={item.area || ""}
          onChange={e => setWorkItems(ws => ws.map((x, j) => j === i ? { ...x, area: e.target.value } : x))}
          placeholder="0"
          style={{ ...inputStyle, color: theme.green, fontWeight: 600 }}
        />

        {/* Delete */}
        <button onClick={() => setWorkItems(ws => ws.filter((_, j) => j !== i))}
          style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
      </div>
    </div>
  ))}
</div>
      
     {/* Section 8 — Materials Used */}
<div style={sectionStyle}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
  <div style={sectionTitle}>7. Material Used</div>
  <button onClick={() => setMaterials(ms => [...ms, { name: "", qty: "", unit: "", rate: "", company: "", coverage: "" }])}
    style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 7, width: 28, height: 28, fontSize: 18, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>+</button>
</div>
  {materials.map((m, i) => (
    <div key={i} style={{ background: theme.card, borderRadius: 8, padding: "10px 12px", marginBottom: 10 }}>

{/* Row 1 — Company + Product */}
<div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
  <div style={{ flex: 1 }}>
    {i === 0 && <label style={labelStyle}>Company</label>}
    <input
  list={`log-company-${i}`}
  value={m.company || ""}
  onChange={e => setMaterials(ms => ms.map((x, j) => j === i
    ? { ...x, company: e.target.value, name: "", unit: "", packing: "", rate: "" }
    : x
  ))}
  onClick={e => { e.target.value = ""; setTimeout(() => e.target.dispatchEvent(new Event("input")), 0); }}
  onFocus={e => { e.target.select(); }}
  style={inputStyle}
  placeholder="Type or select company..."
/>
<datalist id={`log-company-${i}`}>
  {Object.keys(MATERIAL_LIST).map(c => <option key={c} value={c} />)}
</datalist>


  </div>
  <div style={{ flex: 1 }}>
    {i === 0 && <label style={labelStyle}>Product Name</label>}
   <input
  list={`log-product-${i}`}
  value={m.name || ""}
  onChange={e => {
    const product = (MATERIAL_LIST[m.company] || []).find(p => p.name === e.target.value);
    setMaterials(ms => ms.map((x, j) => j === i
      ? { ...x, name: e.target.value, unit: product?.unit || x.unit, packing: product?.packing || x.packing, rate: product?.rate || x.rate }
      : x
    ));
  }}
  onFocus={e => {
    const current = e.target.value;
    e.target.value = "";
    setMaterials(ms => ms.map((x, j) => j === i ? { ...x, name: "" } : x));
    setTimeout(() => {
      if (!e.target.value) {
        setMaterials(ms => ms.map((x, j) => j === i ? { ...x, name: current } : x));
      }
    }, 2000000);
  }}
  style={inputStyle}
  placeholder="Type or select product..."
/>
<datalist id={`log-product-${i}`}>
  {(MATERIAL_LIST[m.company] || []).map(p => <option key={p.name} value={p.name} />)}
</datalist>
  </div>
</div>
      {/* Row 2 — Unit, Packing, Rate, Qty */}
      <div style={{ display: "flex", gap: 8 }}>
        <div style={{ flex: 1 }}>
          {i === 0 && <label style={labelStyle}>Unit</label>}
        <input
  value={m.unit || ""}
  onChange={e => setMaterials(ms => ms.map((x, j) => j === i ? { ...x, unit: e.target.value } : x))}
  style={inputStyle}
  placeholder="Kg/Ltr"
/>
        </div>
        <div style={{ flex: 1 }}>
       {i === 0 && <label style={labelStyle}>Coverage</label>}
<input
  value={m.coverage || ""}
  onChange={e => setMaterials(ms => ms.map((x, j) => j === i ? { ...x, coverage: e.target.value } : x))}
  style={inputStyle}
  placeholder="e.g. 120 Sq ft"
/>
        </div>
        <div style={{ flex: 1 }}>
          {i === 0 && <label style={labelStyle}>Rate ₹</label>}
          <input
            type="number"
            value={m.rate || ""}
            onChange={e => setMaterials(ms => ms.map((x, j) => j === i ? { ...x, rate: e.target.value } : x))}
            style={{ ...inputStyle, color: theme.accent, fontWeight: 600 }}
          />
        </div>
        <div style={{ flex: 1 }}>
          {i === 0 && <label style={labelStyle}>Qty Used</label>}
          <input
            type="number"
            value={m.qty || ""}
            onChange={e => setMaterials(ms => ms.map((x, j) => j === i ? { ...x, qty: e.target.value } : x))}
            placeholder="0"
            style={{ ...inputStyle, color: theme.green, fontWeight: 600 }}
          />
        </div>
      </div>

      {/* Amount preview */}
      {m.name && m.qty && m.rate && (
        <div style={{ marginTop: 8, color: theme.muted, fontSize: 11, textAlign: "right" }}>
          {m.qty} × ₹{m.rate} =
          <span style={{ color: theme.accent, fontWeight: 700, marginLeft: 4 }}>
            ₹{(Number(m.qty) * Number(m.rate)).toLocaleString("en-IN")}
          </span>
        </div>
      )}
    <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 6 }}>
        <button onClick={() => setMaterials(ms => ms.filter((_, j) => j !== i))}
          style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, padding: "3px 10px", fontSize: 11, cursor: "pointer" }}>× Remove</button>
      </div>
    </div>
  ))}
</div>
      
      {/* Section 10 — Cost Summary */}
      <div style={sectionStyle}>
        <div style={sectionTitle}>8. Cost Summary</div>
        <div style={rowStyle}>
          <div style={{ flex: 1 }}>
  <label style={labelStyle}>Material Cost (₹) — Auto Calculated</label>
  <div style={{ background: theme.accent + "11", border: `1px solid ${theme.accent}44`, borderRadius: 7, padding: "10px 12px", color: theme.accent, fontWeight: 800, fontSize: 14 }}>
    ₹{autoMaterialCost.toLocaleString("en-IN")}
  </div>
</div>
         <div style={{ flex: 1 }}>
  <label style={labelStyle}>Porter Charges (₹)</label>
  <input type="number" value={travelCharges} onChange={e => setTravelCharges(e.target.value)} placeholder="0" style={inputStyle} />
</div>
<div style={{ flex: 1 }}>
  <label style={labelStyle}>Mathadi Charges (₹)</label>
  <input type="number" value={mathadiCharges} onChange={e => setMathadiCharges(e.target.value)} placeholder="0" style={inputStyle} />
</div>
        </div>
        <div style={{ background: theme.card, borderRadius: 8, padding: "12px 14px", marginTop: 8 }}>
          {[
            ["Supervisor Cost", supervisorCost],
            ["Labour Cost", labourCost],
            ["Material Cost", autoMaterialCost],
           ["Labour Travel", labourPorterCost],
["Porter Charges", Number(travelCharges) || 0],
["Mathadi Charges", Number(mathadiCharges) || 0],
["Labour Food", labourFoodCost],
          ].map(([label, val]) => (
            <div key={label} style={{ display: "flex", justifyContent: "space-between", marginBottom: 6 }}>
              <span style={{ color: theme.muted, fontSize: 12 }}>{label}</span>
              <span style={{ color: theme.text, fontSize: 12, fontWeight: 600 }}>₹{val.toLocaleString("en-IN")}</span>
            </div>
          ))}
          <div style={{ borderTop: `1px solid ${theme.border}`, paddingTop: 8, marginTop: 4, display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>10. Total Cost Today</span>
            <span style={{ color: theme.accent, fontWeight: 800, fontSize: 15 }}>₹{totalCost.toLocaleString("en-IN")}</span>
          </div>
        </div>
      </div>

    {/* Photo Upload Section */}
<div style={sectionStyle}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
    <div style={sectionTitle}>📸 Site Photos</div>
    <label style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 7, padding: "5px 14px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
      + Upload Photos
      <input type="file" accept="image/*" multiple style={{ display: "none" }}
        onChange={e => {
          const files = Array.from(e.target.files);
          files.forEach(file => {
            const reader = new FileReader();
            reader.onload = ev => {
              setPhotos(prev => [...prev, {
                id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
                name: file.name,
                data: ev.target.result,
                uploadedAt: new Date().toISOString(),
              }]);
            };
            reader.readAsDataURL(file);
          });
          e.target.value = "";
        }}
      />
    </label>
  </div>

  {photos.length === 0 ? (
    <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 8, padding: 20, textAlign: "center" }}>
      <div style={{ fontSize: 28, marginBottom: 6 }}>📷</div>
      <div style={{ color: theme.muted, fontSize: 12 }}>No photos uploaded yet. Click "+ Upload Photos" to add site photos.</div>
    </div>
  ) : (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))", gap: 10 }}>
      {photos.map(photo => (
        <div key={photo.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 10, overflow: "hidden", position: "relative" }}>
          <img src={photo.data} alt={photo.name}
            style={{ width: "100%", height: 120, objectFit: "cover", display: "block" }} />
          <div style={{ padding: "6px 8px" }}>
            <div style={{ color: theme.text, fontSize: 10, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{photo.name}</div>
            <div style={{ color: theme.muted, fontSize: 9, marginTop: 2 }}>{photo.uploadedAt?.slice(0, 10)}</div>
          </div>
          <div style={{ display: "flex", gap: 4, padding: "0 8px 8px" }}>
            <button onClick={() => {
              const a = document.createElement("a");
              a.href = photo.data;
              a.download = photo.name;
              a.click();
            }} style={{ flex: 1, background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 5, padding: "3px 0", fontSize: 10, cursor: "pointer", fontWeight: 700 }}>
              📥 Save
            </button>
            <button onClick={() => {
              const win = window.open();
              win.document.write(`<img src="${photo.data}" style="max-width:100%" />`);
            }} style={{ flex: 1, background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 5, padding: "3px 0", fontSize: 10, cursor: "pointer", fontWeight: 700 }}>
              👁 View
            </button>
            <button onClick={() => {
              if (window.confirm("Delete this photo?"))
                setPhotos(prev => prev.filter(p => p.id !== photo.id));
            }} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, padding: "3px 6px", fontSize: 10, cursor: "pointer", fontWeight: 700 }}>
              🗑
            </button>
          </div>
        </div>
      ))}
    </div>
  )}
</div>

      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={handleSave}>Save Daily Log</Btn>
      </div>
    </Modal>
  );
}


function MonthlyCostingTab({ project }) {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));
  

  const logs = project.logs || [];

  const filteredLogs = logs.filter(log => {
    if (fromDate && log.date < fromDate) return false;
    if (toDate && log.date > toDate) return false;
    return true;
  }).sort((a, b) => a.date.localeCompare(b.date));

  const totals = filteredLogs.reduce((acc, log) => {
  acc.supervisor += log.costs?.supervisor || 0;
  acc.labour += log.costs?.labour || 0;
  acc.material += log.costs?.material || 0;
  acc.labourTravel += log.costs?.labourTravel || 0;
  acc.porter += log.costs?.porter || 0;
  acc.mathadi += log.costs?.mathadi || 0;
  acc.food += log.costs?.food || 0;
  acc.total += log.costs?.total || 0;
  return acc;
}, { supervisor: 0, labour: 0, material: 0, labourTravel: 0, porter: 0, mathadi: 0, food: 0, total: 0 });

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 12, outline: "none", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 };
  const thStyle = { padding: "12px 14px", background: theme.accent + "22", color: theme.accent, fontSize: 12, fontWeight: 800, textTransform: "uppercase", textAlign: "left", borderBottom: `2px solid ${theme.accent}`, whiteSpace: "nowrap" };
  const tdStyle = { padding: "10px 12px", borderBottom: `1px solid ${theme.border}`, fontSize: 12, color: theme.text };

  const COST_CATEGORIES = [
  { key: "supervisor", label: "Supervisor", color: theme.blue },
  { key: "labour", label: "Labour", color: theme.purple },
  { key: "material", label: "Material", color: theme.orange },
  { key: "labourTravel", label: "Labour Travel", color: theme.orange },
  { key: "porter", label: "Porter", color: theme.green },
  { key: "mathadi", label: "Mathadi", color: theme.red },
  { key: "food", label: "Food", color: theme.accent },
];

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Project Management</div>
          <h3 style={{ color: theme.text, margin: 0, fontSize: 18, fontWeight: 800 }}>💰 Project Costing Summary</h3>
          <div style={{ color: theme.muted, fontSize: 12, marginTop: 3 }}>{filteredLogs.length} logs in selected period</div>
        </div>
        {filteredLogs.length > 0 && (
          <Btn onClick={() => window.print()} variant="blue">🖨 Print Report</Btn>
        )}
      </div>

      {/* Date Range */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 20, display: "flex", gap: 16, alignItems: "flex-end", flexWrap: "wrap" }}>
        <div style={{ flex: 1, minWidth: 140 }}>
          <label style={lbl}>From Date</label>
          <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} style={{ ...inp, width: "100%" }} />
        </div>
        <div style={{ flex: 1, minWidth: 140 }}>
          <label style={lbl}>Up To Date</label>
          <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} style={{ ...inp, width: "100%" }} />
        </div>
        <Btn variant="ghost" small onClick={() => { setFromDate(""); setToDate(new Date().toISOString().slice(0, 10)); }}>Reset</Btn>
      </div>

      {filteredLogs.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>📊</div>
          <div style={{ color: theme.muted, fontSize: 14 }}>No logs found for selected date range.</div>
        </div>
      ) : (
        <>
          {/* Summary Stat Cards */}
          <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
            {COST_CATEGORIES.map(cat => (
              <StatCard key={cat.key} label={cat.label} value={`₹${totals[cat.key].toLocaleString("en-IN")}`} color={cat.color} icon={cat.icon} />
            ))}
            <StatCard label="Total Cost" value={`₹${totals.total.toLocaleString("en-IN")}`} color={theme.accent} icon="💰" />
          </div>

          {/* Detailed Table */}
          <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  {["Sr.", "Date", "Site Name", "Work Location", "Supervisor", "Labour", "Material", "Porter", "Mathadi", "Food", "Total"].map(h => (
                    <th key={h} style={thStyle}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredLogs.map((log, i) => (
                  <tr key={log.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                    <td style={{ ...tdStyle, color: theme.muted, textAlign: "center" }}>{i + 1}</td>
                    <td style={{ ...tdStyle, color: theme.accent, fontWeight: 700, whiteSpace: "nowrap" }}>{log.date}</td>
                    <td style={{ ...tdStyle }}>{log.siteName || "—"}</td>
                    <td style={{ ...tdStyle, color: theme.muted }}>{log.workLocation || "—"}</td>
                    <td style={{ ...tdStyle, color: theme.blue, fontWeight: 600, textAlign: "right" }}>₹{(log.costs?.supervisor || 0).toLocaleString("en-IN")}</td>
<td style={{ ...tdStyle, color: theme.purple, fontWeight: 600, textAlign: "right" }}>₹{(log.costs?.labour || 0).toLocaleString("en-IN")}</td>
<td style={{ ...tdStyle, color: theme.orange, fontWeight: 600, textAlign: "right" }}>₹{(log.costs?.material || 0).toLocaleString("en-IN")}</td>
<td style={{ ...tdStyle, color: theme.green, fontWeight: 600, textAlign: "right" }}>₹{(log.costs?.porter || 0).toLocaleString("en-IN")}</td>
<td style={{ ...tdStyle, color: theme.red, fontWeight: 600, textAlign: "right" }}>₹{(log.costs?.mathadi || 0).toLocaleString("en-IN")}</td>
<td style={{ ...tdStyle, color: theme.accent, fontWeight: 600, textAlign: "right" }}>₹{(log.costs?.food || 0).toLocaleString("en-IN")}</td>
<td style={{ ...tdStyle, color: theme.accent, fontWeight: 800, textAlign: "right" }}>₹{(log.costs?.total || 0).toLocaleString("en-IN")}</td>
                  </tr>
                ))}
              </tbody>
              {/* Total Row */}
              <tfoot>
                <tr style={{ background: theme.accent + "22", borderTop: `2px solid ${theme.accent}` }}>
                  <td colSpan={4} style={{ ...tdStyle, fontWeight: 800, fontSize: 13, color: theme.text }}>TOTAL ({filteredLogs.length} days)</td>
                 <td style={{ ...tdStyle, color: theme.blue, fontWeight: 800, textAlign: "right" }}>₹{totals.supervisor.toLocaleString("en-IN")}</td>
<td style={{ ...tdStyle, color: theme.purple, fontWeight: 800, textAlign: "right" }}>₹{totals.labour.toLocaleString("en-IN")}</td>
<td style={{ ...tdStyle, color: theme.orange, fontWeight: 800, textAlign: "right" }}>₹{totals.material.toLocaleString("en-IN")}</td>
<td style={{ ...tdStyle, color: theme.green, fontWeight: 800, textAlign: "right" }}>₹{totals.porter.toLocaleString("en-IN")}</td>
<td style={{ ...tdStyle, color: theme.red, fontWeight: 800, textAlign: "right" }}>₹{totals.mathadi.toLocaleString("en-IN")}</td>
<td style={{ ...tdStyle, color: theme.accent, fontWeight: 800, textAlign: "right" }}>₹{totals.food.toLocaleString("en-IN")}</td>
<td style={{ ...tdStyle, color: theme.accent, fontWeight: 900, fontSize: 14, textAlign: "right" }}>
  ₹{(totals.supervisor + totals.labour + totals.material + totals.porter + totals.mathadi + totals.food).toLocaleString("en-IN")}
</td>
                </tr>
              </tfoot>
            </table>
          </div>

          {/* Cost Breakdown */}
          <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 20, marginTop: 16 }}>
            <div style={{ color: theme.text, fontWeight: 700, fontSize: 14, marginBottom: 14 }}>📊 Cost Breakdown</div>
            {COST_CATEGORIES.map(cat => {
              const pct = totals.total > 0 ? Math.round((totals[cat.key] / totals.total) * 100) : 0;
              return (
                <div key={cat.key} style={{ marginBottom: 12 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                    <span style={{ color: theme.text, fontSize: 12 }}>{cat.icon} {cat.label}</span>
                    <span style={{ color: cat.color, fontWeight: 700, fontSize: 12 }}>₹{totals[cat.key].toLocaleString("en-IN")} ({pct}%)</span>
                  </div>
                  <ProgressBar value={pct} color={cat.color} height={7} />
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}


// Project Modals
function MaterialRequestModal({ project, onClose, onSave }) {
  const [items, setItems] = useState([{ name: "", qty: "", unit: "" }]);
  const [requestedBy, setRequestedBy] = useState("");
  const [notes, setNotes] = useState("");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));

  const allProducts = Object.values(MATERIAL_LIST).flat().map(p => p.name);

  const inputStyle = { width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 12, outline: "none", boxSizing: "border-box" };
  const labelStyle = { color: theme.muted, fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 3 };

  return (
    <Modal title="📦 Material Request" onClose={onClose} width={640}>
      <div style={{ display: "flex", gap: 10, marginBottom: 12 }}>
        <div style={{ flex: 1 }}>
          <label style={labelStyle}>Requested By</label>
          <input value={requestedBy} onChange={e => setRequestedBy(e.target.value)} style={inputStyle} placeholder="e.g. Rashid" />
        </div>
        <div style={{ flex: 1 }}>
          <label style={labelStyle}>Date</label>
          <input type="date" value={date} onChange={e => setDate(e.target.value)} style={inputStyle} />
        </div>
      </div>

      {/* Items */}
      <div style={{ marginBottom: 12 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <label style={{ ...labelStyle, marginBottom: 0 }}>Items Requested</label>
          <button onClick={() => setItems(is => [...is, { name: "", qty: "", unit: "" }])}
            style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 6, width: 26, height: 26, fontSize: 16, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>+</button>
        </div>

        {/* Header */}
        <div style={{ display: "grid", gridTemplateColumns: "24px 3fr 1fr 1fr 24px", gap: 8, marginBottom: 5 }}>
          {["Sr.", "Material Name", "Qty", "Unit", ""].map(h => (
            <div key={h} style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase", fontWeight: 600 }}>{h}</div>
          ))}
        </div>

        {items.map((item, i) => (
          <div key={i} style={{ display: "grid", gridTemplateColumns: "24px 3fr 1fr 1fr 24px", gap: 8, marginBottom: 8, alignItems: "center" }}>
            <div style={{ color: theme.faint, fontSize: 11, textAlign: "center", fontWeight: 700 }}>{i + 1}</div>

            {/* Material Name — type or select */}
            <div>
              <input
                list={`mat-list-${i}`}
                value={item.name || ""}
                onChange={e => {
                  const product = Object.values(MATERIAL_LIST).flat().find(p => p.name === e.target.value);
                  setItems(is => is.map((x, j) => j === i ? { ...x, name: e.target.value, unit: product?.unit || x.unit } : x));
                }}
                style={inputStyle}
                placeholder="Type or select material..."
              />
              <datalist id={`mat-list-${i}`}>
                {allProducts.map(p => <option key={p} value={p} />)}
              </datalist>
            </div>

            {/* Qty */}
            <input
              type="text"
              value={item.qty || ""}
              onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, qty: e.target.value } : x))}
              style={{ ...inputStyle, color: theme.green, fontWeight: 600 }}
              placeholder="e.g. 500"
            />

            {/* Unit */}
            <input
              value={item.unit || ""}
              onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, unit: e.target.value } : x))}
              style={inputStyle}
              placeholder="Kg"
            />

            {/* Remove */}
            <button onClick={() => setItems(is => is.filter((_, j) => j !== i))}
              style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
          </div>
        ))}
      </div>

      <div style={{ marginBottom: 12 }}>
        <label style={labelStyle}>Notes</label>
        <input value={notes} onChange={e => setNotes(e.target.value)} style={inputStyle} placeholder="Any special instructions..." />
      </div>

      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => {
          const filled = items.filter(i => i.name.trim());
          if (!requestedBy || filled.length === 0) return alert("Please fill requested by and at least one item.");
          onSave({
            id: Date.now(),
            projectId: project.id,
            projectName: project.name,
            projectCode: project.id.toString().slice(-2) || "RR",
            requestedBy,
            date,
            notes,
            items: filled,
            status: "pending",
          });
        }}>Submit Request</Btn>
      </div>
    </Modal>
  );
}




function AddBOQModal({ onClose, onSave }) {
  const [f, setF] = useState({ description: "", unit: "sqft", plannedQty: "", rate: "" });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  return (
    <Modal title="+ Add BOQ Item" onClose={onClose}>
      <Input label="Description" value={f.description} onChange={s("description")} placeholder="e.g. Terrace Waterproofing" />
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Sel label="Unit" value={f.unit} onChange={s("unit")} options={["sqft", "RMT", "sqm", "kg", "bags", "Nos", "Ltr", "Rft"]} /></div>
        <div style={{ flex: 1 }}><Input label="Planned Qty" value={f.plannedQty} onChange={s("plannedQty")} type="number" /></div>
      </div>
      <Input label="Rate (₹ per unit)" value={f.rate} onChange={s("rate")} type="number" />
      {f.plannedQty && f.rate && (
        <div style={{ background: theme.accent + "11", border: `1px solid ${theme.accent}33`, borderRadius: 8, padding: "9px 12px", marginBottom: 12 }}>
          <span style={{ color: theme.muted, fontSize: 12 }}>Total: </span>
          <span style={{ color: theme.accent, fontWeight: 700 }}>{fmt(f.plannedQty * f.rate)}</span>
        </div>
      )}
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => { if (!f.description || !f.plannedQty || !f.rate) return; onSave({ ...f, plannedQty: Number(f.plannedQty), rate: Number(f.rate) }); }}>Add Item</Btn>
      </div>
    </Modal>
  );
}

function CreateProjectModal({ onClose, onSave, masterBOQ=[] }) {
  const [f, setF] = useState({
    name: "", client: "", location: "", engineer: "",
    contractValue: "", startDate: new Date().toISOString().slice(0, 10),
    endDate: "", status: "Active", services: ""
  });
  const s = k => v => setF(p => ({ ...p, [k]: v }));

  return (
    <Modal title="🏗️ Create New Project" onClose={onClose} width={620}>
      <Input label="Project Name" value={f.name} onChange={s("name")} placeholder="e.g. Lodha Palava — Block C" />
      <Input label="Client Name" value={f.client} onChange={s("client")} />
      <Input label="Site Location" value={f.location} onChange={s("location")} />
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Input label="Engineer" value={f.engineer} onChange={s("engineer")} /></div>
        <div style={{ flex: 1 }}><Sel label="Status" value={f.status} onChange={s("status")} options={["Active", "Upcoming", "On Hold"]} /></div>
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Input label="Start Date" value={f.startDate} onChange={s("startDate")} type="date" /></div>
        <div style={{ flex: 1 }}><Input label="End Date" value={f.endDate} onChange={s("endDate")} type="date" /></div>
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Input label="Contract Value (₹)" value={f.contractValue} onChange={s("contractValue")} type="number" /></div>
      </div>
      <Input label="Services (comma separated)" value={f.services} onChange={s("services")} placeholder="e.g. Basement Waterproofing, Grouting" />

     

      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
  <Btn onClick={onClose} variant="ghost">Cancel</Btn>
  <Btn onClick={() => {
    if (!f.name || !f.client) return;
    const boqFromMaster = (masterBOQ || []).map(item => ({
      ...item,
      id: Date.now() + Math.random(),
      completedQty: 0,
    }));
    onSave({
      id: Date.now(),
      ...f,
      contractValue: Number(f.contractValue),
      services: f.services.split(",").map(s => s.trim()).filter(Boolean),
      boq: boqFromMaster,
      logs: [],
      materialRequests: [],
      raEntries: [],
    });
  }}>Create Project</Btn>
</div>
    </Modal>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// MODULE 2 — INVENTORY & WAREHOUSE
// ═══════════════════════════════════════════════════════════════════════════════

// ─── INVENTORY MODAL COMPONENTS (proper React components, no hook violations) ─

function AddProductForm({ onClose, onSave, prefillName = "", prefillCategory = "", prefillUnit = "" }) {
  const [f, setF] = useState({
    name: prefillName,
    batchNo: "",
    hsnCode: "",
    packingSize: "",
    unit: prefillUnit,
    quantity: "",
    manufacturingDate: "",
    expiryDate: "",
    location: "warehouse",
  });
  const s = k => v => setF(p => ({ ...p, [k]: v }));

  return (
    <Modal title={prefillName ? `+ Add New Batch — ${prefillName}` : "+ Add Product"} onClose={onClose}>
      {prefillName ? (
  <div style={{ marginBottom: 10 }}>
    <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>PRODUCT NAME</div>
    <div style={{ background: theme.accent + "11", border: `1px solid ${theme.accent}33`, borderRadius: 7, padding: "8px 12px", color: theme.accent, fontWeight: 700, fontSize: 13 }}>{prefillName}</div>
  </div>
) : (
  <Input label="Product Name" value={f.name} onChange={s("name")} placeholder="e.g. IPANEX ADMIX" />
)}
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Input label="Batch No." value={f.batchNo} onChange={s("batchNo")} placeholder="e.g. 25 20300425" /></div>
<div style={{ flex: 1 }}><Input label="HSN Code" value={f.hsnCode} onChange={s("hsnCode")} placeholder="e.g. 38244090" /></div>
<div style={{ flex: 1 }}><Input label="Packing Size" value={f.packingSize} onChange={s("packingSize")} placeholder="e.g. 25 Ltr" /></div>
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Input label="Unit" value={f.unit} onChange={s("unit")} placeholder="e.g. Ltr, Kg" /></div>
        <div style={{ flex: 1 }}><Input label="Quantity" value={f.quantity} onChange={s("quantity")} type="number" placeholder="e.g. 20000" /></div>
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Input label="Manufacturing Date" value={f.manufacturingDate} onChange={s("manufacturingDate")} type="date" /></div>
        <div style={{ flex: 1 }}><Input label="Expiry Date" value={f.expiryDate} onChange={s("expiryDate")} type="date" /></div>
      </div>
      <Input label="Location" value={f.location} onChange={s("location")} placeholder="e.g. warehouse" />
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => {
          if (!f.name || !f.quantity) return;
          onSave({
            id: Date.now(),
            name: prefillName || f.name,
            batchNo: f.batchNo,
             hsnCode: f.hsnCode,
            packingSize: f.packingSize,
            unit: f.unit,
            currentStock: Number(f.quantity),
            maxStock: Number(f.quantity),
            reorderLevel: 0,
            unitCost: 0,
            supplier: "",
            category: "",
            manufacturingDate: f.manufacturingDate,
            expiryDate: f.expiryDate,
            location: f.location,
          });
        }}>Add Product</Btn>
      </div>
    </Modal>
  );
}

function DispatchForm({ product, sites, onClose, onSave }) {
  const [f, setF] = useState({
    qty: "",
    destination: "site",
    site: "",
    requestedBy: "",
    notes: "",
    date: new Date().toISOString().slice(0, 10)
  });
  const s = k => v => setF(p => ({ ...p, [k]: v }));

  const handleSave = () => {
    if (!f.qty) return;
    if (f.destination === "site" && !f.site) return alert("Please select a site.");
if (f.destination === "site" && f.site === "__custom__" && !f.customSite?.trim()) return alert("Please enter site name manually.");
    if (Number(f.qty) > product.currentStock) return alert("Insufficient stock!");

    const resolvedSite = f.site === "__custom__" ? (f.customSite || "") : f.site;
const to = f.destination === "godown" ? "Office Godown" : resolvedSite;
const site = f.destination === "godown" ? null : resolvedSite.split(" —")[0];

    onSave({
      type: "out",
      productId: product.id,
      productName: product.name,
      qty: Number(f.qty),
      from: "Matunga Warehouse",
      to,
      site,
      destination: f.destination,
      requestedBy: f.requestedBy || "Admin",
      notes: f.notes,
      date: f.date,
    });
  };

  return (
    <Modal title={`↑ Dispatch — ${product.name}`} onClose={onClose}>

      {/* Current Stock Info */}
      <div style={{ background: theme.red + "11", border: `1px solid ${theme.red}33`, borderRadius: 8, padding: "9px 12px", marginBottom: 16 }}>
        <span style={{ color: theme.muted, fontSize: 12 }}>Available Stock: </span>
        <span style={{ color: theme.red, fontWeight: 700 }}>{product.currentStock} {product.unit}s</span>
      </div>

      {/* Send To — toggle buttons */}
      <div style={{ marginBottom: 14 }}>
        <label style={{ color: theme.muted, fontSize: 11, fontWeight: 600, letterSpacing: 0.8, textTransform: "uppercase", display: "block", marginBottom: 8 }}>
          Send To
        </label>
        <div style={{ display: "flex", gap: 10 }}>
          {[
            { value: "site",   label: "🏗️ Direct to Site",   color: theme.blue },
            { value: "godown", label: "🏠 Office Godown",     color: theme.purple },
          ].map(opt => (
            <button
              key={opt.value}
              onClick={() => setF(p => ({ ...p, destination: opt.value, site: "" }))}
              style={{
                flex: 1,
                padding: "10px 14px",
                borderRadius: 8,
                border: `2px solid ${f.destination === opt.value ? opt.color : theme.border}`,
                background: f.destination === opt.value ? opt.color + "22" : "transparent",
                color: f.destination === opt.value ? opt.color : theme.muted,
                fontWeight: f.destination === opt.value ? 700 : 400,
                fontSize: 13,
                cursor: "pointer",
                fontFamily: "inherit",
                transition: "all 0.2s",
              }}>
              {opt.label}
            </button>
          ))}
        </div>
      </div>

      {/* Site dropdown — only if Direct to Site selected */}
     {f.destination === "site" && (
  <div style={{ marginBottom: 14 }}>
    <label style={{ color: theme.muted, fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 4 }}>Select Site</label>
    <select value={f.site} onChange={e => setF(p => ({ ...p, site: e.target.value, customSite: "" }))}
      style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 14, outline: "none", marginBottom: 8 }}>
      <option value="">— Select from list —</option>
      {sites.map(s => <option key={s} value={s}>{s}</option>)}
      <option value="__custom__">✏️ Enter manually...</option>
    </select>
    {f.site === "__custom__" && (
      <input value={f.customSite || ""} onChange={e => setF(p => ({ ...p, customSite: e.target.value }))}
        placeholder="Type site name manually..."
        style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.accent}44`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 14, outline: "none", boxSizing: "border-box" }} />
    )}
  </div>
)}

      {/* Godown confirmation info */}
      {f.destination === "godown" && (
        <div style={{ background: theme.purple + "11", border: `1px solid ${theme.purple}33`, borderRadius: 8, padding: "9px 12px", marginBottom: 14 }}>
          <span style={{ color: theme.purple, fontSize: 12, fontWeight: 600 }}>
            📦 Material will be moved to Office Godown stock
          </span>
        </div>
      )}

      <Input label="Date" value={f.date} onChange={s("date")} type="date" />
      <Input label="Quantity to Dispatch" value={f.qty} onChange={s("qty")} type="number" placeholder={`Max: ${product.currentStock}`} />
      <Input label="Requested By" value={f.requestedBy} onChange={s("requestedBy")} placeholder="e.g. Rashid" />
      <Input label="Notes (optional)" value={f.notes} onChange={s("notes")} placeholder="Purpose of dispatch" />

      {/* Preview */}
      {f.qty && Number(f.qty) > 0 && (
        <div style={{ background: theme.accent + "11", border: `1px solid ${theme.accent}33`, borderRadius: 8, padding: "9px 12px", marginBottom: 14 }}>
          <span style={{ color: theme.muted, fontSize: 12 }}>Remaining after dispatch: </span>
          <span style={{ color: theme.accent, fontWeight: 700 }}>
            {product.currentStock - Number(f.qty)} {product.unit}s
          </span>
          {(product.currentStock - Number(f.qty)) <= product.reorderLevel && (
            <span style={{ color: theme.red, fontSize: 11, marginLeft: 8 }}>⚠️ Will trigger reorder alert</span>
          )}
        </div>
      )}

      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={handleSave} variant="danger">Confirm Dispatch</Btn>
      </div>
    </Modal>
  );
}

function ReceiveForm({ product, onClose, onSave }) {
  const [f, setF] = useState({ qty: "", vendor: product.supplier, notes: "", date: new Date().toISOString().slice(0, 10) });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  return (
    <Modal title={`↓ Receive — ${product.name}`} onClose={onClose}>
      <div style={{ background: theme.green + "11", border: `1px solid ${theme.green}33`, borderRadius: 8, padding: "9px 12px", marginBottom: 14 }}>
        <span style={{ color: theme.muted, fontSize: 12 }}>Current: </span>
        <span style={{ color: theme.green, fontWeight: 700 }}>{product.currentStock} {product.unit}s</span>
      </div>
      <Input label="Date" value={f.date} onChange={s("date")} type="date" />
      <Input label="Vendor" value={f.vendor} onChange={s("vendor")} />
      <Input label="Quantity Received" value={f.qty} onChange={s("qty")} type="number" />
      <Input label="Notes" value={f.notes} onChange={s("notes")} />
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => { if (!f.qty) return; onSave({ type: "in", productId: product.id, productName: product.name, qty: Number(f.qty), from: `Vendor — ${f.vendor}`, to: "Matunga Warehouse", site: null, requestedBy: "Admin", notes: f.notes, date: f.date }); }} variant="success">Confirm Receipt</Btn>
      </div>
    </Modal>
  );
}

function TransferForm({ products, sites, onClose, onSave }) {
  const [f, setF] = useState({ productId: "", qty: "", from: "", to: "", requestedBy: "", notes: "", date: new Date().toISOString().slice(0, 10) });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  const selected = products.find(p => p.id === Number(f.productId));
  return (
    <Modal title="↔ Inter-Site Transfer" onClose={onClose}>
      <Input label="Date" value={f.date} onChange={s("date")} type="date" />
      <Sel label="Material" value={f.productId} onChange={s("productId")} options={[{ value: "", label: "Select material..." }, ...products.map(p => ({ value: p.id, label: `${p.name} (${p.currentStock} left)` }))]} />
      <div style={{ marginBottom: 14 }}>
  <label style={{ color: theme.muted, fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 4 }}>From Site</label>
  <select value={f.from} onChange={e => setF(p => ({ ...p, from: e.target.value, customFrom: "" }))}
    style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 14, outline: "none", marginBottom: 6 }}>
    <option value="">— Select from list —</option>
    {sites.map(s => <option key={s} value={s}>{s}</option>)}
    <option value="__custom__">✏️ Enter manually...</option>
  </select>
  {f.from === "__custom__" && (
    <input value={f.customFrom || ""} onChange={e => setF(p => ({ ...p, customFrom: e.target.value }))}
      placeholder="Type site name manually..."
      style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.accent}44`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 14, outline: "none", boxSizing: "border-box" }} />
  )}
</div>

<div style={{ marginBottom: 14 }}>
  <label style={{ color: theme.muted, fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 4 }}>To Site</label>
  <select value={f.to} onChange={e => setF(p => ({ ...p, to: e.target.value, customTo: "" }))}
    style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 14, outline: "none", marginBottom: 6 }}>
    <option value="">— Select from list —</option>
    {sites.filter(x => x !== f.from).map(s => <option key={s} value={s}>{s}</option>)}
    <option value="__custom__">✏️ Enter manually...</option>
  </select>
  {f.to === "__custom__" && (
    <input value={f.customTo || ""} onChange={e => setF(p => ({ ...p, customTo: e.target.value }))}
      placeholder="Type site name manually..."
      style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.accent}44`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 14, outline: "none", boxSizing: "border-box" }} />
  )}
</div>
      <Input label="Quantity" value={f.qty} onChange={s("qty")} type="number" />
      <Input label="Requested By" value={f.requestedBy} onChange={s("requestedBy")} />
      <Input label="Notes" value={f.notes} onChange={s("notes")} />
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => {
  if (!f.productId || !f.qty || !f.from || !f.to) return;
  const resolvedFrom = f.from === "__custom__" ? (f.customFrom || "") : f.from;
  const resolvedTo = f.to === "__custom__" ? (f.customTo || "") : f.to;
  if (!resolvedFrom.trim() || !resolvedTo.trim()) return alert("Please fill both site names.");
  onSave({ type: "transfer", productId: Number(f.productId), productName: selected?.name, qty: Number(f.qty), from: resolvedFrom, to: resolvedTo, site: resolvedTo.split(" —")[0], requestedBy: f.requestedBy || "Admin", notes: f.notes, date: f.date });
}} variant="blue">Confirm Transfer</Btn>
      </div>
    </Modal>
  );
}



const PRODUCT_MERGE_MAP = {
  "WEBAC PURseal Comp. A PU": "WEBAC PURseal",
  "WEBAC PURseal Comp. B": "WEBAC PURseal",
  "WEBAC 240 Comp. A Polyacrylic Gel": "WEBAC 240 Polyacrylic Gel",
  "WEBAC 240 Comp. A2 Polyacrylic Gel": "WEBAC 240 Polyacrylic Gel",
  "Impermax Cold Polyurea Rayston grey ral 7011 kit 26.5kg Comp.A": "Impermax Cold Polyurea Rayston kit 26.5kg",
  "Impermax Cold Polyurea Rayston grey ral 7011 kit 26.5kg Comp. A": "Impermax Cold Polyurea Rayston kit 26.5kg",
  "IMPERMAX COLD POLYUREA RAYSTON kit 26.5kg Comp.B": "Impermax Cold Polyurea Rayston kit 26.5kg",
  "IMPERMAX COLD POLYUREA RAYSTON kit 26.5kg Comp. B": "Impermax Cold Polyurea Rayston kit 26.5kg",
  "Impermax Cold Polyurea Rayston grey ral 7011 kit 26.5kg Comp.": "Impermax Cold Polyurea Rayston kit 26.5kg",
  "IMPERMAX COLD POLYUREA RAYSTON kit 26.5kg Comp.": "Impermax Cold Polyurea Rayston kit 26.5kg",
  "Rayston GC Primer dark grey kit 15kg Comp.A": "Rayston GC Primer dark grey kit 15kg",
  "Rayston GC Primer dark grey kit 15kg Comp. A": "Rayston GC Primer dark grey kit 15kg",
  "Rayston GC Primer dark grey kit 15kg Comp.B": "Rayston GC Primer dark grey kit 15kg",
  "Rayston GC Primer dark grey kit 15kg Comp. B": "Rayston GC Primer dark grey kit 15kg",
};
const normalizeName = (name) => {
  const trimmed = name.trim();
  for (const [key, value] of Object.entries(PRODUCT_MERGE_MAP)) {
    if (key.toLowerCase().trim() === trimmed.toLowerCase()) return value;
  }
  return trimmed;
};

function GroupedStockView({ products, movements, setModal }) {
  const [expanded, setExpanded] = useState({});

  const grouped = products.reduce((acc, p) => {
  const key = normalizeName(p.name);
  if (!acc[key]) acc[key] = {
    name: p.name,
    normalizedKey: key,
    category: p.category,
    unit: p.unit,
    unitCost: p.unitCost,
    batches: []
  };
    acc[key].batches.push(p);
    return acc;
  }, {});

  const toggleExpand = (name) => setExpanded(prev => ({ ...prev, [name]: !prev[name] }));

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      {Object.values(grouped).map(group => {
        const totalStock = Math.round(group.batches.reduce((s, b) => s + (Number(b.currentStock) || 0), 0) * 100) / 100;
        const maxStock = group.batches.reduce((s, b) => s + b.maxStock, 0);
        const totalValue = Math.round(group.batches.reduce((s, b) => s + (Number(b.currentStock) || 0) * (Number(b.unitCost) || 0), 0) * 100) / 100;
        const isLow = group.batches.some(b => b.currentStock <= b.reorderLevel);
        const isCritical = group.batches.some(b => b.currentStock === 0);
        const statusColor = isCritical ? theme.red : isLow ? theme.orange : theme.green;
        const statusLabel = isCritical ? "CRITICAL" : isLow ? "LOW" : "OK";
        const pctVal = maxStock > 0 ? Math.round((totalStock / maxStock) * 100) : 0;
        const isOpen = expanded[group.name];

        return (
          <div key={group.name} style={{ background: theme.card, border: `1px solid ${isOpen ? theme.accent : theme.border}`, borderRadius: 14, overflow: "hidden", transition: "border 0.2s" }}>

            {/* Main Product Row */}
            <div onClick={() => toggleExpand(group.name)} style={{ padding: 16, cursor: "pointer", display: "flex", alignItems: "center", gap: 14, position: "relative" }}>
              <div style={{ position: "absolute", top: 0, left: 0, bottom: 0, width: 4, background: statusColor }} />
              <div style={{ paddingLeft: 8, flex: 1 }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                  <div>
                    <div style={{ color: theme.text, fontWeight: 800, fontSize: 15 }}>{group.name}</div>
                    <div style={{ color: theme.muted, fontSize: 11, marginTop: 2 }}>
                      <span style={{ background: theme.border, borderRadius: 4, padding: "1px 5px", marginRight: 5 }}>{group.category}</span>
                      {group.batches.length} batch{group.batches.length > 1 ? "es" : ""}
                    </div>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                    <span style={{ background: statusColor + "22", color: statusColor, border: `1px solid ${statusColor}44`, borderRadius: 5, padding: "2px 7px", fontSize: 10, fontWeight: 700 }}>{statusLabel}</span>
                    <span style={{ color: theme.muted, fontSize: 18, transform: isOpen ? "rotate(180deg)" : "rotate(0deg)", transition: "transform 0.2s" }}>▾</span>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 24, marginBottom: 10, flexWrap: "wrap" }}>
                  <div>
                    <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Total Stock</div>
                    <div style={{ color: statusColor, fontWeight: 800, fontSize: 18 }}>{totalStock} <span style={{ fontSize: 11, fontWeight: 400 }}>{group.unit}s</span></div>
                  </div>
                  <div>
                    <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Unit Cost</div>
                    <div style={{ color: theme.accent, fontWeight: 700, fontSize: 14 }}>{fmt(group.unitCost)}</div>
                  </div>
                  <div>
                    <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Total Value</div>
                    <div style={{ color: theme.text, fontWeight: 700, fontSize: 14 }}>{fmt(totalValue)}</div>
                  </div>
                </div>
                <ProgressBar value={pctVal} color={statusColor} height={6} />
                <div style={{ color: theme.faint, fontSize: 10, marginTop: 3 }}>{totalStock} of {maxStock} {group.unit}s total capacity</div>
              </div>
            </div>

            {/* Expanded Batch Details */}
            {isOpen && (
              <div style={{ borderTop: `1px solid ${theme.border}`, background: theme.bg }}>
                <div style={{ padding: "10px 16px 6px 24px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
  <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1 }}>Batch Details</div>
  <Btn small onClick={e => { e.stopPropagation(); setModal({ type: "addBatch", data: group }); }}>+ Add New Batch</Btn>
</div>
                {group.batches.map((b, i) => {
                  const s = stockStatus(b);
                  const bPct = b.maxStock > 0 ? Math.round((b.currentStock / b.maxStock) * 100) : 0;
                  const compLabel = b.name.match(/Comp\.?\s*[AB][0-9]?/i)?.[0];
                  return (
                    <div key={b.id} style={{ padding: "12px 16px 12px 24px", borderTop: i > 0 ? `1px solid ${theme.border}` : "none", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
                      <div style={{ flex: 1, minWidth: 200 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 6, flexWrap: "wrap" }}>
                          <div style={{ width: 8, height: 8, borderRadius: "50%", background: s.color, flexShrink: 0 }} />
                          {compLabel && (
                            <span style={{ background: theme.accent + "22", color: theme.accent, borderRadius: 4, padding: "1px 8px", fontSize: 11, fontWeight: 800 }}>
                              {compLabel}
                            </span>
                          )}
                          <span style={{ color: theme.text, fontWeight: 600, fontSize: 13 }}>📍 {b.location}</span>
                          <span style={{ color: theme.purple, fontSize: 10, fontWeight: 600 }}>Batch: {b.batchNo}</span>
                          {b.hsnCode && <span style={{ color: theme.purple, fontSize: 10, marginLeft: 8, fontWeight: 600 }}>HSN: {b.hsnCode}</span>}
                          <span style={{ background: s.color + "22", color: s.color, borderRadius: 4, padding: "1px 6px", fontSize: 10, fontWeight: 700 }}>{s.label}</span>
                        </div>
                        <div style={{ display: "flex", gap: 16, marginBottom: 6, flexWrap: "wrap" }}>
                          <span style={{ color: theme.muted, fontSize: 11 }}>Stock: <span style={{ color: s.color, fontWeight: 700 }}>{Math.round((Number(b.currentStock) || 0) * 100) / 100} / {b.maxStock} {b.unit}s</span></span>
                          <span style={{ color: theme.muted, fontSize: 11 }}>Reorder: <span style={{ color: theme.text, fontWeight: 600 }}>{b.reorderLevel}</span></span>
                          <span style={{ color: theme.muted, fontSize: 11 }}>Value: <span style={{ color: theme.accent, fontWeight: 600 }}>{fmt(b.currentStock * b.unitCost)}</span></span>
                          <span style={{ color: theme.muted, fontSize: 11 }}>Expiry: <span style={{ color: theme.text, fontWeight: 600 }}>{b.expiryDate}</span></span>
                        </div>
                        <ProgressBar value={bPct} color={s.color} height={5} />
                      </div>
                      <div style={{ display: "flex", gap: 6 }}>
                        <Btn small variant="ghost" onClick={() => setModal({ type: "editProduct", data: b })}>✏️ Edit</Btn>
                        <Btn onClick={(e) => { e.stopPropagation(); setModal({ type: "dispatch", data: b }); }} small variant="danger">↑ Dispatch</Btn>
                        <Btn onClick={(e) => { e.stopPropagation(); setModal({ type: "receive", data: b }); }} small variant="success">↓ Receive</Btn>
                        <Btn onClick={(e) => { e.stopPropagation(); setModal({ type: "history", data: b }); }} small variant="ghost">History</Btn>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

const PO_STATUSES = ["Ordered", "In Transit", "Reached Dubai", "Reached India", "In Customs", "Out for Delivery", "Delivered"];

const PO_STATUS_COLORS = {
  "Ordered": "#3B82F6",
  "In Transit": "#8B5CF6",
  "Reached Dubai": "#F59E0B",
  "Reached India": "#10B981",
  "In Customs": "#EF4444",
  "Out for Delivery": "#06B6D4",
  "Delivered": "#22C55E",
};

function CreatePOModal({ existing, onClose, onSave }) {
  const [f, setF] = useState({
    poNo: existing?.poNo || `PO-${Date.now().toString().slice(-6)}`,
    poDate: existing?.poDate || new Date().toISOString().slice(0, 10),
    deliveryDate: existing?.deliveryDate || "",
    supplier: existing?.supplier || "",
    status: existing?.status || "Ordered",
    notes: existing?.notes || "",
   locationTracking: existing?.locationTracking && Array.isArray(existing.locationTracking)
  ? existing.locationTracking
  : [],
  });

  const [items, setItems] = useState(existing?.items || [{
    id: Date.now(),
    name: "", category: "", unit: "", quantity: "",
    unitCost: "", packingSize: "", batchNo: "",
    manufacturingDate: "", expiryDate: "", location: "warehouse"
  }]);

  const updateField = (k, v) => setF(p => ({ ...p, [k]: v }));
  
  const updateItem = (id, field, value) => setItems(is => is.map(i => i.id === id ? { ...i, [field]: value } : i));
  const addItem = () => setItems(is => [...is, {
    id: Date.now(), name: "", category: "", unit: "", quantity: "",
    unitCost: "", packingSize: "", batchNo: "",
    manufacturingDate: "", expiryDate: "", location: "warehouse"
  }]);
  const deleteItem = (id) => setItems(is => is.filter(i => i.id !== id));

  const totalValue = items.reduce((s, i) => s + ((Number(i.quantity) || 0) * (Number(i.unitCost) || 0)), 0);

  const handleSave = () => {
    if (!f.supplier.trim()) { alert("Please enter supplier name."); return; }
    if (items.some(i => !i.name.trim())) { alert("Please fill product name for all rows."); return; }
    onSave({ ...f, items, id: existing?.id || Date.now(), totalValue });
    onClose();
  };

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 };

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000a", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 16, width: "100%", maxWidth: 900, maxHeight: "93vh", display: "flex", flexDirection: "column" }}>

        {/* Header */}
        <div style={{ padding: "18px 24px", borderBottom: `1px solid ${theme.border}` }}>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Inventory</div>
          <h3 style={{ color: theme.text, margin: 0, fontSize: 20, fontWeight: 800 }}>{existing ? "✏️ Edit Purchase Order" : "📦 New Purchase Order"}</h3>
        </div>

        <div style={{ overflowY: "auto", flex: 1, padding: "20px 24px", display: "flex", flexDirection: "column", gap: 16 }}>

          {/* PO Details */}
          <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 10, padding: 14 }}>
            <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, marginBottom: 12, textTransform: "uppercase" }}>📋 PO Details</div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 10 }}>
              <div><label style={lbl}>PO Number</label><input value={f.poNo} onChange={e => updateField("poNo", e.target.value)} style={inp} /></div>
              <div><label style={lbl}>PO Date</label><input type="date" value={f.poDate} onChange={e => updateField("poDate", e.target.value)} style={inp} /></div>
              <div><label style={lbl}>Expected Delivery</label><input type="date" value={f.deliveryDate} onChange={e => updateField("deliveryDate", e.target.value)} style={inp} /></div>
              <div><label style={lbl}>Supplier Name</label><input value={f.supplier} onChange={e => updateField("supplier", e.target.value)} style={inp} placeholder="Supplier..." /></div>
            </div>
            <div style={{ marginTop: 10, display: "grid", gridTemplateColumns: "1fr 3fr", gap: 10 }}>
              <div>
                <label style={lbl}>Status</label>
                <select value={f.status} onChange={e => updateField("status", e.target.value)} style={{ ...inp, cursor: "pointer" }}>
                  {PO_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                </select>
              </div>
              <div><label style={lbl}>Notes</label><input value={f.notes} onChange={e => updateField("notes", e.target.value)} style={inp} placeholder="Any notes..." /></div>
            </div>
          </div>

        {/* Location Tracking */}
<div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 10, padding: 14 }}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
    <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>📍 Location Tracking</div>
    <Btn small onClick={() => setF(p => ({ ...p, locationTracking: [...(Array.isArray(p.locationTracking) ? p.locationTracking : []), { id: Date.now(), location: "", date: "" }] }))}>+ Add Row</Btn>
  </div>

  {/* Header */}
  <div style={{ display: "grid", gridTemplateColumns: "1fr 160px 32px", gap: 8, marginBottom: 6 }}>
    <div style={{ color: theme.faint, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>Location / Status</div>
    <div style={{ color: theme.faint, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>Date</div>
    <div />
  </div>

  {(Array.isArray(f.locationTracking) ? f.locationTracking : []).map((row, i) => (
    <div key={row.id} style={{ display: "grid", gridTemplateColumns: "1fr 160px 32px", gap: 8, marginBottom: 8, alignItems: "center" }}>
      <input
        value={row.location}
        onChange={e => setF(p => ({ ...p, locationTracking: p.locationTracking.map(r => r.id === row.id ? { ...r, location: e.target.value } : r) }))}
        style={inp}
        placeholder="e.g. Reached Dubai, In Customs..."
      />
      <input
        type="date"
        value={row.date}
        onChange={e => setF(p => ({ ...p, locationTracking: p.locationTracking.map(r => r.id === row.id ? { ...r, date: e.target.value } : r) }))}
        style={inp}
      />
      <button
        onClick={() => setF(p => ({ ...p, locationTracking: p.locationTracking.filter(r => r.id !== row.id) }))}
        style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 26, height: 26, fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
      >×</button>
    </div>
  ))}

   {(!Array.isArray(f.locationTracking) || f.locationTracking.length === 0) && (
    <div style={{ textAlign: "center", padding: "20px 0", color: theme.muted, fontSize: 12 }}>
      No tracking rows yet. Click "+ Add Row" to start tracking.
    </div>
  )}
</div>
          {/* Products Table */}
          <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 10, padding: 14 }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>📦 Products ({items.length})</div>
              <Btn small onClick={addItem}>+ Add Row</Btn>
            </div>

            {/* Table Header */}
            <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 70px 80px 80px 100px 100px 1fr 32px", gap: 6, marginBottom: 6 }}>
              {["Product Name", "Category", "Batch No.", "Unit", "Qty", "Unit Cost", "Mfg Date", "Expiry Date", "Location", ""].map(h => (
                <div key={h} style={{ color: theme.faint, fontSize: 9, fontWeight: 700, textTransform: "uppercase" }}>{h}</div>
              ))}
            </div>

            {items.map((item, idx) => (
              <div key={item.id} style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 70px 80px 80px 100px 100px 1fr 32px", gap: 6, marginBottom: 8, alignItems: "center" }}>
                <input value={item.name} onChange={e => updateItem(item.id, "name", e.target.value)} style={inp} placeholder="Product name..." />
                <input value={item.category} onChange={e => updateItem(item.id, "category", e.target.value)} style={inp} placeholder="Category" />
                <input value={item.batchNo} onChange={e => updateItem(item.id, "batchNo", e.target.value)} style={inp} placeholder="Batch No." />
                <input value={item.unit} onChange={e => updateItem(item.id, "unit", e.target.value)} style={inp} placeholder="Kg" />
                <input type="number" value={item.quantity} onChange={e => updateItem(item.id, "quantity", e.target.value)} style={inp} placeholder="0" />
                <input type="number" value={item.unitCost} onChange={e => updateItem(item.id, "unitCost", e.target.value)} style={{ ...inp, color: theme.accent }} placeholder="₹0" />
                <input type="date" value={item.manufacturingDate} onChange={e => updateItem(item.id, "manufacturingDate", e.target.value)} style={inp} />
                <input type="date" value={item.expiryDate} onChange={e => updateItem(item.id, "expiryDate", e.target.value)} style={inp} />
                <input value={item.location} onChange={e => updateItem(item.id, "location", e.target.value)} style={inp} placeholder="warehouse" />
                <button onClick={() => deleteItem(item.id)} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 26, height: 26, fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
              </div>
            ))}

            {/* Total */}
            <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 10, paddingTop: 10, borderTop: `1px solid ${theme.border}` }}>
              <div style={{ textAlign: "right" }}>
                <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Total PO Value</div>
                <div style={{ color: theme.green, fontWeight: 800, fontSize: 18 }}>₹{totalValue.toLocaleString("en-IN")}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div style={{ padding: "14px 24px", borderTop: `1px solid ${theme.border}`, display: "flex", justifyContent: "flex-end", gap: 10 }}>
          <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
          <Btn onClick={handleSave}>💾 {existing ? "Save Changes" : "Create PO"}</Btn>
        </div>
      </div>
    </div>
  );
}

function POPreviewModal({ po, onClose, onEdit }) {
  const thS = { padding: "8px 10px", background: "#1a365d", color: "#fff", fontSize: 10, fontWeight: 800, textTransform: "uppercase", border: "1px solid #2d4a7a", textAlign: "center" };
  const tdS = { padding: "7px 10px", fontSize: 11, border: "1px solid #e2e8f0" };
  const statusColor = PO_STATUS_COLORS[po.status] || "#3B82F6";

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000a", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 900, maxHeight: "93vh", display: "flex", flexDirection: "column" }}>

        {/* Action Bar */}
        <div className="no-print" style={{ padding: "12px 20px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f8fafc", borderRadius: "16px 16px 0 0" }}>
          <button onClick={onClose} style={{ background: "none", border: "1px solid #cbd5e0", borderRadius: 8, padding: "6px 16px", cursor: "pointer", fontSize: 13 }}>✕ Close</button>
          <div style={{ display: "flex", gap: 10 }}>
            {onEdit && <button onClick={onEdit} style={{ background: "#3B82F6", color: "#fff", border: "none", borderRadius: 8, padding: "6px 16px", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>✏️ Edit</button>}
            <button onClick={() => window.print()} style={{ background: "#1a365d", color: "#fff", border: "none", borderRadius: 8, padding: "6px 16px", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>🖨 Print</button>
          </div>
        </div>

        <div style={{ overflowY: "auto", flex: 1, padding: 28, background: "#fff" }}>

          {/* Company Header */}
          <div style={{ textAlign: "center", marginBottom: 20, borderBottom: "2px solid #1a365d", paddingBottom: 14 }}>
            <div style={{ fontSize: 22, fontWeight: 900, color: "#1a365d", letterSpacing: 1 }}>PERMATECH CONSTRUCTION SERVICES</div>
            <div style={{ fontSize: 10, color: "#4a5568", marginTop: 3 }}>Waterproofing & Civil Contractors | Mumbai</div>
          </div>

          {/* PO Title */}
          <div style={{ textAlign: "center", marginBottom: 18 }}>
            <div style={{ fontSize: 16, fontWeight: 900, color: "#1a365d", textTransform: "uppercase", letterSpacing: 2 }}>Purchase Order</div>
            <div style={{ fontSize: 13, color: "#4a5568", marginTop: 4 }}>PO No: <strong>{po.poNo}</strong></div>
          </div>

          {/* PO Info Grid */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 20 }}>
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: 12, border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: 10, color: "#718096", textTransform: "uppercase", fontWeight: 700, marginBottom: 8 }}>PO Information</div>
              {[["PO Date", po.poDate], ["Expected Delivery", po.deliveryDate || "—"], ["Supplier", po.supplier], ["Notes", po.notes || "—"]].map(([k, v]) => (
                <div key={k} style={{ display: "flex", justifyContent: "space-between", marginBottom: 5 }}>
                  <span style={{ color: "#718096", fontSize: 11 }}>{k}</span>
                  <span style={{ color: "#1a202c", fontWeight: 600, fontSize: 11 }}>{v}</span>
                </div>
              ))}
            </div>
            <div style={{ background: "#f8fafc", borderRadius: 8, padding: 12, border: "1px solid #e2e8f0" }}>
              <div style={{ fontSize: 10, color: "#718096", textTransform: "uppercase", fontWeight: 700, marginBottom: 8 }}>Current Status</div>
              <div style={{ display: "inline-block", background: statusColor + "22", color: statusColor, border: `1px solid ${statusColor}44`, borderRadius: 6, padding: "4px 12px", fontSize: 13, fontWeight: 800, marginBottom: 10 }}>{po.status}</div>
              <div style={{ fontSize: 10, color: "#718096", textTransform: "uppercase", fontWeight: 700, marginBottom: 6 }}>Total Value</div>
              <div style={{ color: "#059669", fontWeight: 900, fontSize: 20 }}>₹{po.totalValue?.toLocaleString("en-IN")}</div>
            </div>
          </div>

          {/* Location Tracking Timeline */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 12, fontWeight: 800, color: "#1a365d", textTransform: "uppercase", marginBottom: 10 }}>📍 Location Tracking</div>
            
             {(Array.isArray(po.locationTracking) ? po.locationTracking : []).map((row, i) => {
             const status = row.location;
             const date = row.date;
 
  return (
    <div key={i} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "8px 12px", background: i % 2 === 0 ? "#f8fafc" : "#fff", borderRadius: 6, marginBottom: 4, border: "1px solid #e2e8f0" }}>
      <span style={{ color: "#1a365d", fontWeight: 600, fontSize: 12 }}>📍 {status || "—"}</span>
      <span style={{ color: date ? "#059669" : "#a0aec0", fontWeight: 600, fontSize: 12 }}>{date || "Not yet"}</span>
    </div>
  );
})}
            </div>
         

          {/* Products Table */}
          <div style={{ fontSize: 12, fontWeight: 800, color: "#1a365d", textTransform: "uppercase", marginBottom: 10 }}>📦 Products</div>
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 20 }}>
            <thead>
              <tr>
                {["Sr.", "Product Name", "Category", "Batch No.", "Unit", "Qty", "Unit Cost", "Amount", "Mfg Date", "Expiry Date", "Location"].map(h => (
                  <th key={h} style={thS}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {po.items.map((item, i) => (
                <tr key={item.id} style={{ background: i % 2 === 0 ? "#f8fafc" : "#fff" }}>
                  <td style={{ ...tdS, textAlign: "center", fontWeight: 700, color: "#1a365d" }}>{i + 1}</td>
                  <td style={{ ...tdS, fontWeight: 600 }}>{item.name}</td>
                  <td style={{ ...tdS, textAlign: "center" }}>{item.category || "—"}</td>
                  <td style={{ ...tdS, textAlign: "center" }}>{item.batchNo || "—"}</td>
                  <td style={{ ...tdS, textAlign: "center" }}>{item.unit}</td>
                  <td style={{ ...tdS, textAlign: "center", color: "#3B82F6", fontWeight: 700 }}>{item.quantity}</td>
                  <td style={{ ...tdS, textAlign: "right", color: "#D97706" }}>₹{Number(item.unitCost).toLocaleString("en-IN")}</td>
                  <td style={{ ...tdS, textAlign: "right", color: "#059669", fontWeight: 700 }}>₹{((Number(item.quantity) || 0) * (Number(item.unitCost) || 0)).toLocaleString("en-IN")}</td>
                  <td style={{ ...tdS, textAlign: "center" }}>{item.manufacturingDate || "—"}</td>
                  <td style={{ ...tdS, textAlign: "center" }}>{item.expiryDate || "—"}</td>
                  <td style={{ ...tdS, textAlign: "center" }}>{item.location || "—"}</td>
                </tr>
              ))}
              <tr style={{ background: "#1a365d" }}>
                <td colSpan={7} style={{ ...tdS, background: "#1a365d", color: "#fff", textAlign: "right", fontWeight: 800, border: "1px solid #2d4a7a" }}>TOTAL</td>
                <td style={{ ...tdS, background: "#1a365d", color: "#6EE7B7", fontWeight: 900, fontSize: 14, border: "1px solid #2d4a7a" }}>₹{po.totalValue?.toLocaleString("en-IN")}</td>
                <td colSpan={3} style={{ background: "#1a365d", border: "1px solid #2d4a7a" }}></td>
              </tr>
            </tbody>
          </table>

          {/* Signature */}
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 30 }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ borderTop: "1px solid #1a365d", paddingTop: 8, width: 160, fontSize: 11, color: "#4a5568" }}>Supplier Signature</div>
              <div style={{ fontSize: 10, color: "#718096", marginTop: 2 }}>{po.supplier}</div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div style={{ borderTop: "1px solid #1a365d", paddingTop: 8, width: 160, fontSize: 11, color: "#4a5568" }}>Authorized Signatory</div>
              <div style={{ fontSize: 10, color: "#718096", marginTop: 2 }}>Permatech Construction Services</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function PurchaseOrderTab({ purchaseOrders, setPurchaseOrders, products, setProducts }) {
  const [modal, setModal] = useState(null);
  const [viewPO, setViewPO] = useState(null);
  const [editPO, setEditPO] = useState(null);

  const savePO = async (po) => {
    const updated = purchaseOrders.find(p => p.id === po.id)
      ? purchaseOrders.map(p => p.id === po.id ? po : p)
      : [po, ...purchaseOrders];
    setPurchaseOrders(updated);
    localStorage.setItem("purchaseOrders", JSON.stringify(updated));
    try { await setDoc(fsDoc(db, "purchase_orders", String(po.id)), po); } catch (e) { console.error(e); }

    // Auto-update stock when Delivered
    if (po.status === "Delivered") {
      const oldPO = purchaseOrders.find(p => p.id === po.id);
      if (oldPO?.status !== "Delivered") {
        setProducts(ps => {
          let updated = [...ps];
          po.items.forEach(item => {
           const existing = updated.find(p => p.name.toLowerCase() === item.name.toLowerCase() && p.batchNo === item.batchNo && p.hsnCode === item.hsnCode);
            if (existing) {
              updated = updated.map(p => p.id === existing.id ? { ...p, currentStock: p.currentStock + Number(item.quantity) } : p);
            } else {
              updated = [...updated, {
                id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
                name: item.name, category: item.category, unit: item.unit,
                currentStock: Number(item.quantity), maxStock: Number(item.quantity),
                reorderLevel: 0, unitCost: Number(item.unitCost),
                batchNo: item.batchNo, packingSize: item.packingSize || "",
                manufacturingDate: item.manufacturingDate, expiryDate: item.expiryDate,
                location: item.location || "warehouse", supplier: po.supplier
              }];
            }
          });
          return updated;
        });
      }
    }
  };

  const deletePO = async (id) => {
    if (!window.confirm("Delete this Purchase Order?")) return;
    const updated = purchaseOrders.filter(p => p.id !== id);
    setPurchaseOrders(updated);
    localStorage.setItem("purchaseOrders", JSON.stringify(updated));
    try { await deleteDoc(fsDoc(db, "purchase_orders", String(id))); } catch (e) { console.error(e); }
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 18 }}>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          <StatCard label="Total POs" value={purchaseOrders.length} color={theme.blue} icon="📋" />
          <StatCard label="In Transit" value={purchaseOrders.filter(p => ["In Transit", "Reached Dubai", "Reached India", "In Customs"].includes(p.status)).length} color={theme.orange} icon="🚢" />
          <StatCard label="Delivered" value={purchaseOrders.filter(p => p.status === "Delivered").length} color={theme.green} icon="✅" />
          <StatCard label="Total Value" value={fmt(purchaseOrders.reduce((s, p) => s + (p.totalValue || 0), 0))} color={theme.accent} icon="💰" />
        </div>
        <Btn onClick={() => setModal("create")}>+ New PO</Btn>
      </div>

      {purchaseOrders.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>📦</div>
          <div style={{ color: theme.muted, fontSize: 14 }}>No purchase orders yet. Create your first one.</div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {purchaseOrders.map(po => {
            const statusColor = PO_STATUS_COLORS[po.status] || theme.blue;
            return (
              <div key={po.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6, flexWrap: "wrap" }}>
                    <span style={{ color: theme.accent, fontWeight: 800, fontSize: 15 }}>{po.poNo}</span>
                    <span style={{ background: statusColor + "22", color: statusColor, border: `1px solid ${statusColor}44`, borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700 }}>{po.status}</span>
                    <span style={{ color: theme.green, fontWeight: 700, fontSize: 13 }}>₹{po.totalValue?.toLocaleString("en-IN")}</span>
                  </div>
                  <div style={{ color: theme.muted, fontSize: 12 }}>🏭 {po.supplier} · 📅 {po.poDate} · 📦 {po.items?.length} product{po.items?.length !== 1 ? "s" : ""}</div>
                  {po.deliveryDate && <div style={{ color: theme.faint, fontSize: 11, marginTop: 2 }}>Expected Delivery: {po.deliveryDate}</div>}

                  {/* Mini tracking bar */}
                  <div style={{ display: "flex", gap: 4, marginTop: 8, flexWrap: "wrap" }}>
                    {(Array.isArray(po.locationTracking) ? po.locationTracking : []).map((row, i) => {
  const color = PO_STATUS_COLORS[row.location] || theme.accent;
  return (
    <div key={i} style={{ display: "flex", alignItems: "center", gap: 3 }}>
      <div style={{ width: 8, height: 8, borderRadius: "50%", background: row.date ? color : theme.border }} title={row.location} />
      {i < (Array.isArray(po.locationTracking) ? po.locationTracking : []).length - 1 && (
        <div style={{ width: 12, height: 2, background: row.date ? color : theme.border }} />
      )}
    </div>
  );
})}
<span style={{ color: theme.muted, fontSize: 10, marginLeft: 4 }}>{po.status}</span>
                    <span style={{ color: theme.muted, fontSize: 10, marginLeft: 4 }}>{po.status}</span>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <Btn small variant="ghost" onClick={() => setViewPO(po)}>👁 View</Btn>
                  <Btn small variant="ghost" onClick={() => setEditPO(po)}>✏️ Edit</Btn>
                  <Btn small variant="blue" onClick={() => { setViewPO(po); setTimeout(() => window.print(), 300); }}>🖨 Print</Btn>
                  <Btn small variant="danger" onClick={() => deletePO(po.id)}>🗑</Btn>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {modal === "create" && <CreatePOModal onClose={() => setModal(null)} onSave={po => { savePO(po); setModal(null); setViewPO(po); }} />}
      {editPO && <CreatePOModal existing={editPO} onClose={() => setEditPO(null)} onSave={po => { savePO(po); setEditPO(null); setViewPO(po); }} />}
      {viewPO && <POPreviewModal po={viewPO} onClose={() => setViewPO(null)} onEdit={() => { setEditPO(viewPO); setViewPO(null); }} />}
    </div>
  );
}

function EditProductModal({ product, onClose, onSave }) {
  const [f, setF] = useState({ ...product });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  return (
    <Modal title="✏️ Edit Product" onClose={onClose}>
      <Input label="Product Name" value={f.name} onChange={s("name")} />
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Input label="Batch No." value={f.batchNo || ""} onChange={s("batchNo")} placeholder="e.g. 25 20300425" /></div>
        <div style={{ flex: 1 }}><Input label="HSN Code" value={f.hsnCode || ""} onChange={s("hsnCode")} placeholder="e.g. 38244090" /></div>
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Input label="Packing Size" value={f.packingSize || ""} onChange={s("packingSize")} placeholder="e.g. 25 Ltr" /></div>
        <div style={{ flex: 1 }}><Input label="Unit" value={f.unit || ""} onChange={s("unit")} placeholder="e.g. Ltr, Kg" /></div>
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Input label="Manufacturing Date" value={f.manufacturingDate || ""} onChange={s("manufacturingDate")} type="date" /></div>
        <div style={{ flex: 1 }}><Input label="Expiry Date" value={f.expiryDate || ""} onChange={s("expiryDate")} type="date" /></div>
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => onSave(f)}>💾 Save Changes</Btn>
      </div>
    </Modal>
  );
}

function InventoryModule({ products, setProducts, movements, setMovements, pendingRequests, setPendingRequests, projects = [] }) {
  const [tab, setTab] = useState("stock");
  const [modal, setModal] = useState(null);
  const [purchaseOrders, setPurchaseOrders] = useState(() => {
    try { return JSON.parse(localStorage.getItem("purchaseOrders") || "[]"); } catch { return []; }
  });

  useEffect(() => {
    getDocs(collection(db, "purchase_orders")).then(snap => {
      const data = snap.docs.map(d => d.data());
      if (data.length > 0) setPurchaseOrders(data);
    }).catch(console.error);
  }, []);

  const sites = projects.map(p => p.name).filter(Boolean);

  const addMovement = (movement) => {
    setMovements(ms => [{ id: Date.now(), ...movement }, ...ms]);
    if (movement.type === "out" || movement.type === "transfer")
      setProducts(ps => ps.map(p => p.id === movement.productId ? { ...p, currentStock: p.currentStock - movement.qty } : p));
    if (movement.type === "in")
      setProducts(ps => ps.map(p => p.id === movement.productId ? { ...p, currentStock: p.currentStock + movement.qty } : p));
    setModal(null);
  };

  const approveRequest = (req) => {
    const product = products.find(p => p.name === req.productName);
    if (product) addMovement({ type: "out", productId: product.id, productName: product.name, qty: req.qty, from: "Matunga Warehouse", to: req.site, site: req.site.split(" —")[0], requestedBy: req.requestedBy, notes: "Approved via request", date: new Date().toISOString().slice(0, 10) });
    setPendingRequests(rs => rs.filter(r => r.id !== req.id));
  };

  const lowStock = products.filter(p => p.currentStock <= p.reorderLevel);
  const totalValue = products.reduce((s, p) => s + p.currentStock * p.unitCost, 0);

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Warehouse Management</div>
          <h2 style={{ color: theme.text, fontSize: 26, fontWeight: 800, margin: 0 }}>Inventory Control</h2>
          <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>Matunga, Mumbai · {products.length} products</div>
        </div>
        <Btn onClick={() => setModal("transfer")} variant="blue">↔ Inter-Site Transfer</Btn>
      </div>

      <div style={{ display: "flex", gap: 12, marginBottom: 22, flexWrap: "wrap" }}>
        <StatCard label="Total SKUs" value={products.length} color={theme.blue} icon="📦" />
        <StatCard label="Low / Critical" value={lowStock.length} sub="need reorder" color={lowStock.length > 0 ? theme.red : theme.green} icon="⚠️" />
        <StatCard label="Warehouse Value" value={fmt(totalValue)} color={theme.accent} icon="💰" />
        <StatCard label="Pending Requests" value={pendingRequests.length} color={pendingRequests.length > 0 ? theme.orange : theme.green} icon="📋" />
      </div>

      {lowStock.length > 0 && (
        <div style={{ background: theme.red + "11", border: `1px solid ${theme.red}33`, borderRadius: 10, padding: "12px 16px", marginBottom: 18 }}>
          <div style={{ color: theme.red, fontWeight: 700, fontSize: 12, marginBottom: 7 }}>⚠️ Reorder Alert — {lowStock.length} item{lowStock.length > 1 ? "s" : ""}</div>
          <div style={{ display: "flex", gap: 7, flexWrap: "wrap" }}>
            {lowStock.map(p => { const s = stockStatus(p); return <span key={p.id} style={{ background: s.color + "22", color: s.color, border: `1px solid ${s.color}44`, borderRadius: 5, padding: "2px 9px", fontSize: 11, fontWeight: 600 }}>{p.name} — {round2(p.currentStock)} left</span>; })}
          </div>
        </div>
      )}

    <Tabs active={tab} onChange={setTab} tabs={[
  { id: "stock", label: "📦 Stock Overview" },
  { id: "movements", label: `🔄 Movements (${movements.length})` },
  { id: "requests", label: `📋 Pending Requests${pendingRequests.length > 0 ? ` (${pendingRequests.length})` : ""}` },
  { id: "po", label: `📋 Purchase Orders (${purchaseOrders.length})` },
]} />

    {tab === "stock" && (
  <div>
    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 14 }}>
      <Btn onClick={() => setModal("addProduct")} small>+ Add Product</Btn>
    </div>
    <GroupedStockView products={products} movements={movements} setModal={setModal} />
  </div>
)}

      {tab === "movements" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {movements.map(m => {
            const tc = { in: { label: "Received", color: theme.green, icon: "↓" }, out: { label: "Dispatched", color: theme.red, icon: "↑" }, transfer: { label: "Transfer", color: theme.blue, icon: "↔" } }[m.type];
            return (
              <div key={m.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "13px 16px", display: "flex", gap: 14, alignItems: "flex-start" }}>
                <div style={{ width: 34, height: 34, borderRadius: 9, background: tc.color + "22", border: `1px solid ${tc.color}44`, display: "flex", alignItems: "center", justifyContent: "center", color: tc.color, fontWeight: 800, fontSize: 15, flexShrink: 0 }}>{tc.icon}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 5 }}>
                    <div>
                      <span style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>{m.productName}</span>
                      <span style={{ background: tc.color + "22", color: tc.color, borderRadius: 4, padding: "1px 7px", fontSize: 10, fontWeight: 700, marginLeft: 7 }}>{tc.label.toUpperCase()}</span>
                    </div>
                    <span style={{ color: theme.accent, fontWeight: 700 }}>× {m.qty}</span>
                  </div>
                  <div style={{ display: "flex", gap: 12, marginTop: 4, flexWrap: "wrap" }}>
                    <span style={{ color: theme.muted, fontSize: 11 }}>📅 {m.date}</span>
                    <span style={{ color: theme.muted, fontSize: 11 }}>→ {m.to}</span>
                    <span style={{ color: theme.muted, fontSize: 11 }}>👤 {m.requestedBy}</span>
                  </div>
                  {m.notes && <div style={{ color: theme.faint, fontSize: 10, fontStyle: "italic", marginTop: 3 }}>"{m.notes}"</div>}
                </div>
                <Btn small variant="danger" onClick={() => {
  if (!window.confirm("Delete this movement record?")) return;
  const updated = movements.filter(x => x.id !== m.id);
  setMovements(updated);
  localStorage.setItem("movements", JSON.stringify(updated));
}}>🗑</Btn>
              </div>
            );
          })}
        </div>
      )}

      {tab === "requests" && (
        <div>
          {pendingRequests.length === 0
            ? <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 40, textAlign: "center" }}><div style={{ fontSize: 28, marginBottom: 8 }}>✅</div><div style={{ color: theme.muted }}>All requests processed!</div></div>
            : pendingRequests.map(r => {
              const uc = { High: theme.red, Medium: theme.orange, Low: theme.blue }[r.urgency] || theme.muted;
              return (
                <div key={r.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 10 }}>
                  <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10, flexWrap: "wrap", gap: 8 }}>
                    <div>
                      <div style={{ display: "flex", alignItems: "center", gap: 7, marginBottom: 3 }}>
                        <span style={{ color: theme.text, fontWeight: 700 }}>{r.productName}</span>
                        <span style={{ background: uc + "22", color: uc, border: `1px solid ${uc}44`, borderRadius: 5, padding: "1px 7px", fontSize: 10, fontWeight: 700 }}>{r.urgency.toUpperCase()}</span>
                      </div>
                      <div style={{ color: theme.muted, fontSize: 11 }}>📍 {r.site} · 👤 {r.requestedBy} · 📅 {r.date}</div>
                    </div>
                    <div style={{ textAlign: "right" }}>
                      <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Qty</div>
                      <div style={{ color: theme.accent, fontWeight: 800, fontSize: 20 }}>{r.qty}</div>
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <Btn onClick={() => approveRequest(r)} small variant="success">✓ Approve & Dispatch</Btn>
                    <Btn onClick={() => setPendingRequests(rs => rs.filter(x => x.id !== r.id))} small variant="danger">✕ Reject</Btn>
                  </div>
                </div>
              );
            })
          }
        </div>
      )}
      {tab === "po" && <PurchaseOrderTab purchaseOrders={purchaseOrders} setPurchaseOrders={setPurchaseOrders} products={products} setProducts={setProducts} />}

      {/* Inventory Modals */}
      {modal === "addProduct" && <AddProductForm onClose={() => setModal(null)} onSave={p => { setProducts(ps => [...ps, p]); setModal(null); }} />}
        {modal?.type === "addBatch" && (
  <AddProductForm
    onClose={() => setModal(null)}
    prefillName={modal.data.name}
    prefillCategory={modal.data.category}
    prefillUnit={modal.data.unit}
    onSave={p => { setProducts(ps => [...ps, p]); setModal(null); }}
  />
)}
        {modal?.type === "editProduct" && (
  <EditProductModal
    product={modal.data}
    onClose={() => setModal(null)}
   onSave={async p => {
  const updated = products.map(x => x.id === p.id ? p : x);
  setProducts(updated);
  localStorage.setItem("products", JSON.stringify(updated));
  try { await setDoc(fsDoc(db, "products", String(p.id)), p); }
  catch (e) { console.error(e); }
  setModal(null);
}}
  />
)}
      {modal?.type === "dispatch" && <DispatchForm product={modal.data} sites={sites} onClose={() => setModal(null)} onSave={addMovement} />}
      {modal?.type === "receive" && <ReceiveForm product={modal.data} onClose={() => setModal(null)} onSave={addMovement} />}
      {modal === "transfer" && <TransferForm products={products} sites={sites} onClose={() => setModal(null)} onSave={addMovement} />}
      {modal?.type === "history" && (
        <Modal title={`History — ${modal.data.name}`} onClose={() => setModal(null)}>
          {movements.filter(m => m.productId === modal.data.id).length === 0
            ? <div style={{ textAlign: "center", color: theme.muted, padding: 30 }}>No movements yet.</div>
            : movements.filter(m => m.productId === modal.data.id).map(m => {
              const tc = { in: { color: theme.green, icon: "↓" }, out: { color: theme.red, icon: "↑" }, transfer: { color: theme.blue, icon: "↔" } }[m.type];
              return (
                <div key={m.id} style={{ display: "flex", gap: 10, background: theme.bg, borderRadius: 8, padding: 10, marginBottom: 8 }}>
                  <div style={{ width: 28, height: 28, borderRadius: 7, background: tc.color + "22", display: "flex", alignItems: "center", justifyContent: "center", color: tc.color, fontWeight: 700, flexShrink: 0 }}>{tc.icon}</div>
                  <div>
                    <div style={{ display: "flex", gap: 10 }}>
                      <span style={{ color: tc.color, fontWeight: 600, fontSize: 12 }}>{m.type.toUpperCase()}</span>
                      <span style={{ color: theme.accent, fontWeight: 700, fontSize: 12 }}>× {m.qty}</span>
                    </div>
                    <div style={{ color: theme.faint, fontSize: 11 }}>{m.date} · {m.to} · {m.requestedBy}</div>
                  </div>
                </div>
              );
            })
          }
        </Modal>
      )}
    </div>
  );
}

// ═══════════════════════════════════════════════════════════════════════════════
// ROOT APP WITH SIDEBAR NAVIGATION
// ═══════════════════════════════════════════════════════════════════════════════
function GodownModule({ products, setProducts, movements, setMovements }) {
  const [tab, setTab] = useState("stock");
  const [modal, setModal] = useState(null);
  const [categoryFilter, setCategoryFilter] = useState("All");
  const [search, setSearch] = useState("");

  const categories = ["All", "Main Stock", "Old Material", "Sample Pack", "Balance Stock"];
  const expired = products.filter(p => p.expiryDate && new Date(p.expiryDate) < new Date());

  const totalItems = products.length;

const godownValue = products.reduce((sum, p) => {
  // Try to find rate from MATERIAL_LIST by matching product name
  let rate = p.unitCost || 0;
  if (!rate) {
    for (const company of Object.values(MATERIAL_LIST)) {
      const match = company.find(item =>
        p.name.toLowerCase().includes(item.name.toLowerCase()) ||
        item.name.toLowerCase().includes(p.name.toLowerCase())
      );
      if (match) { rate = match.rate || 0; break; }
    }
  }
  return sum + (p.currentStock * rate);
}, 0);

  const filtered = products
    .filter(p => categoryFilter === "All" || p.category === categoryFilter)
    .filter(p => p.name.toLowerCase().includes(search.toLowerCase()));

  const addMovement = (mov) => {
    setMovements(ms => [{ id: Date.now(), ...mov }, ...ms]);
    if (mov.type === "out") setProducts(ps => ps.map(p => p.id === mov.productId ? { ...p, currentStock: p.currentStock - mov.qty } : p));
    if (mov.type === "in")  setProducts(ps => ps.map(p => p.id === mov.productId ? { ...p, currentStock: p.currentStock + mov.qty } : p));
    setModal(null);
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Office / Godown</div>
          <h2 style={{ color: theme.text, fontSize: 26, fontWeight: 800, margin: 0 }}>Godown Inventory</h2>
          <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>Bandra Office · {totalItems} products</div>
        </div>
        <Btn onClick={() => setModal("add")} small>+ Add Product</Btn>
      </div>

      {/* Stats */}
      <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
     <StatCard label="Total Items" value={totalItems} color={theme.blue} icon="📦" />
<StatCard label="Expired" value={expired.length} sub="need disposal" color={expired.length > 0 ? theme.red : theme.green} icon="⚠️" />
<StatCard label="Zero Stock" value={products.filter(p => p.currentStock === 0).length} color={theme.orange} icon="📭" />
<StatCard label="Godown Value" value={fmt(godownValue)} color={theme.accent} icon="💰" />
<StatCard label="Movements" value={movements.length} color={theme.purple} icon="🔄" />
      </div>

      {/* Expired Alert */}
      {expired.length > 0 && (
        <div style={{ background: theme.red + "11", border: `1px solid ${theme.red}33`, borderRadius: 10, padding: "12px 16px", marginBottom: 18 }}>
          <div style={{ color: theme.red, fontWeight: 700, fontSize: 12, marginBottom: 7 }}>⚠️ Expired Products — {expired.length} item{expired.length > 1 ? "s" : ""}</div>
          <div style={{ display: "flex", gap: 7, flexWrap: "wrap" }}>
            {expired.map(p => (
              <span key={p.id} style={{ background: theme.red + "22", color: theme.red, border: `1px solid ${theme.red}44`, borderRadius: 5, padding: "2px 9px", fontSize: 11, fontWeight: 600 }}>
                {p.name} — expired {p.expiryDate}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Tabs */}
      <Tabs active={tab} onChange={setTab} tabs={[
        { id: "stock",     label: "📦 Stock Overview" },
        { id: "movements", label: `🔄 Movements (${movements.length})` },
      ]} />

      {tab === "stock" && (
        <div>
          {/* Filters */}
          <div style={{ display: "flex", gap: 10, marginBottom: 16, flexWrap: "wrap" }}>
            <input value={search} onChange={e => setSearch(e.target.value)} placeholder="🔍 Search products..."
              style={{ flex: 1, minWidth: 180, background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.text, padding: "9px 14px", fontSize: 13, outline: "none" }} />
            <select value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)}
              style={{ background: theme.card, border: `1px solid ${theme.border}`, color: theme.muted, borderRadius: 8, padding: "9px 12px", fontSize: 13, outline: "none" }}>
              {categories.map(c => <option key={c}>{c}</option>)}
            </select>
          </div>

          {/* Product Cards */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 14 }}>
            {filtered.map(p => {
              const isExpired = p.expiryDate && new Date(p.expiryDate) < new Date();
              const isZero = p.currentStock === 0;
              const statusColor = isExpired ? theme.red : isZero ? theme.faint : theme.green;
              const statusLabel = isExpired ? "Expired" : isZero ? "Empty" : "In Stock";
              return (
                <div key={p.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 14, padding: 16, position: "relative", overflow: "hidden" }}>
                  <div style={{ position: "absolute", top: 0, left: 0, bottom: 0, width: 4, background: statusColor }} />
                  <div style={{ paddingLeft: 8 }}>
                    {/* Header */}
                    <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 10 }}>
                      <div style={{ flex: 1, marginRight: 8 }}>
                        <div style={{ color: theme.text, fontWeight: 700, fontSize: 14 }}>{p.name}</div>
                        <div style={{ color: theme.muted, fontSize: 11, marginTop: 2 }}>
                          <span style={{ background: theme.border, borderRadius: 4, padding: "1px 5px", marginRight: 5 }}>{p.category}</span>
                          {p.batchNo && <span style={{ color: theme.purple, fontWeight: 600 }}>Batch: {p.batchNo}</span>}
                          {p.hsnCode && <span style={{ marginLeft: 8, color: theme.purple, fontWeight: 600 }}>HSN: {p.hsnCode}</span>}
                        </div>
                      </div>
                      <span style={{ background: statusColor + "22", color: statusColor, border: `1px solid ${statusColor}44`, borderRadius: 5, padding: "2px 7px", fontSize: 10, fontWeight: 700, whiteSpace: "nowrap" }}>{statusLabel}</span>
                    </div>

                    {/* Details */}
                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 8, marginBottom: 12 }}>
                      <div style={{ background: theme.bg, borderRadius: 7, padding: "7px 10px" }}>
                        <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Stock</div>
                        <div style={{ color: theme.accent, fontWeight: 700, fontSize: 14 }}>{round2(p.currentStock)}</div>
                        <div style={{ color: theme.faint, fontSize: 10 }}>{p.unit}</div>
                      </div>
                      <div style={{ background: theme.bg, borderRadius: 7, padding: "7px 10px" }}>
                        <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Cans</div>
                        <div style={{ color: theme.text, fontWeight: 600, fontSize: 14 }}>{p.cans || "—"}</div>
                        <div style={{ color: theme.faint, fontSize: 10 }}>× {p.packaging || "—"} {p.unit}</div>
                      </div>
                      <div style={{ background: theme.bg, borderRadius: 7, padding: "7px 10px" }}>
                        <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Expiry</div>
                        <div style={{ color: isExpired ? theme.red : theme.text, fontWeight: 600, fontSize: 11 }}>{p.expiryDate || "—"}</div>
                      </div>
                    </div>

                    {/* Actions */}
                    <div style={{ display: "flex", gap: 7 }}>
                     <Btn onClick={() => setModal({ type: "editGodownProduct", data: p })} small variant="ghost">✏️ Edit</Btn>
<Btn onClick={() => setModal({ type: "issue", data: p })} small variant="danger">↑ Issue to Site</Btn>
<Btn onClick={() => setModal({ type: "receive", data: p })} small variant="success">↓ Add Stock</Btn>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {tab === "movements" && (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {movements.length === 0
            ? <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 40, textAlign: "center", color: theme.muted }}>No movements yet.</div>
            : movements.map(m => {
              const tc = { in: { color: theme.green, icon: "↓", label: "Received" }, out: { color: theme.red, icon: "↑", label: "Issued to Site" } }[m.type] || { color: theme.muted, icon: "—", label: m.type };
              return (
                <div key={m.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "13px 16px", display: "flex", gap: 14 }}>
                  <div style={{ width: 34, height: 34, borderRadius: 9, background: tc.color + "22", border: `1px solid ${tc.color}44`, display: "flex", alignItems: "center", justifyContent: "center", color: tc.color, fontWeight: 800, fontSize: 15, flexShrink: 0 }}>{tc.icon}</div>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", flexWrap: "wrap", gap: 5 }}>
                      <div>
                        <span style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>{m.productName}</span>
                        <span style={{ background: tc.color + "22", color: tc.color, borderRadius: 4, padding: "1px 7px", fontSize: 10, fontWeight: 700, marginLeft: 7 }}>{tc.label.toUpperCase()}</span>
                      </div>
                      <span style={{ color: theme.accent, fontWeight: 700 }}>× {m.qty} {m.unit}</span>
                    </div>
                    <div style={{ display: "flex", gap: 12, marginTop: 4, flexWrap: "wrap" }}>
                      <span style={{ color: theme.muted, fontSize: 11 }}>📅 {m.date}</span>
                      {m.to && <span style={{ color: theme.muted, fontSize: 11 }}>→ {m.to}</span>}
                      <span style={{ color: theme.muted, fontSize: 11 }}>👤 {m.requestedBy}</span>
                    </div>
                    {m.notes && <div style={{ color: theme.faint, fontSize: 10, fontStyle: "italic", marginTop: 3 }}>"{m.notes}"</div>}
                  </div>
                </div>
              );
            })
          }
        </div>
      )}

      {/* Modals */}
      {modal?.type === "issue"   && <GodownIssueForm   product={modal.data} onClose={() => setModal(null)} onSave={addMovement} />}
{modal?.type === "receive" && <GodownReceiveForm  product={modal.data} onClose={() => setModal(null)} onSave={addMovement} />}
{modal === "add"           && <GodownAddForm      onClose={() => setModal(null)} onSave={p => { setProducts(ps => [...ps, p]); setModal(null); }} />}
{modal?.type === "editGodownProduct" && (
  <EditProductModal
    product={modal.data}
    onClose={() => setModal(null)}
   onSave={async p => {
  const updated = products.map(x => x.id === p.id ? p : x);
  setProducts(updated);
  localStorage.setItem("godownProducts", JSON.stringify(updated));
  try { await setDoc(fsDoc(db, "godown_products", String(p.id)), p); }
  catch (e) { console.error(e); }
  setModal(null);
}}
  />
)}
    </div>
  );
}


function GodownIssueForm({ product, onClose, onSave }) {
  const [f, setF] = useState({ qty: "", site: "Roswalt Raya — Chembur", requestedBy: "", notes: "", date: new Date().toISOString().slice(0, 10) });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  return (
    <Modal title={`↑ Issue to Site — ${product.name}`} onClose={onClose}>
      <div style={{ background: theme.red + "11", border: `1px solid ${theme.red}33`, borderRadius: 8, padding: "9px 12px", marginBottom: 14 }}>
        <span style={{ color: theme.muted, fontSize: 12 }}>Available: </span>
        <span style={{ color: theme.red, fontWeight: 700 }}>{round2(product.currentStock)} {product.unit}</span>
      </div>
      <Input label="Date" value={f.date} onChange={s("date")} type="date" />
      <Sel label="Site" value={f.site} onChange={s("site")} options={["Roswalt Raya — Chembur"]} />
      <Input label="Quantity" value={f.qty} onChange={s("qty")} type="number" placeholder={`Max: ${round2(product.currentStock)}`} />
      <Input label="Requested By" value={f.requestedBy} onChange={s("requestedBy")} placeholder="e.g. Rashid" />
      <Input label="Notes" value={f.notes} onChange={s("notes")} />
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => {
          if (!f.qty) return;
          if (Number(f.qty) > product.currentStock) return alert("Insufficient stock!");
          onSave({ type: "out", productId: product.id, productName: product.name, qty: Number(f.qty), unit: product.unit, to: f.site, requestedBy: f.requestedBy || "Admin", notes: f.notes, date: f.date });
        }} variant="danger">Confirm Issue</Btn>
      </div>
    </Modal>
  );
}

function GodownReceiveForm({ product, onClose, onSave }) {
  const [f, setF] = useState({ qty: "", from: "Warehouse", notes: "", date: new Date().toISOString().slice(0, 10) });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  return (
    <Modal title={`↓ Add Stock — ${product.name}`} onClose={onClose}>
      <div style={{ background: theme.green + "11", border: `1px solid ${theme.green}33`, borderRadius: 8, padding: "9px 12px", marginBottom: 14 }}>
        <span style={{ color: theme.muted, fontSize: 12 }}>Current Stock: </span>
        <span style={{ color: theme.green, fontWeight: 700 }}>{product.currentStock} {product.unit}</span>
      </div>
      <Input label="Date" value={f.date} onChange={s("date")} type="date" />
      <Sel label="Received From" value={f.from} onChange={s("from")} options={["Warehouse", "Direct Purchase", "Other"]} />
      <Input label="Quantity" value={f.qty} onChange={s("qty")} type="number" />
      <Input label="Notes" value={f.notes} onChange={s("notes")} />
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => {
          if (!f.qty) return;
          onSave({ type: "in", productId: product.id, productName: product.name, qty: Number(f.qty), unit: product.unit, from: f.from, to: "Office Godown", requestedBy: "Admin", notes: f.notes, date: f.date });
        }} variant="success">Add Stock</Btn>
      </div>
    </Modal>
  );
}

function GodownAddForm({ onClose, onSave }) {
 const [f, setF] = useState({ name: "", category: "Main Stock", batchNo: "", hsnCode: "", expiryDate: "", cans: "", packaging: "", unit: "Kg", currentStock: "" });
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  return (
    <Modal title="+ Add Godown Product" onClose={onClose}>
      <Input label="Product Name" value={f.name} onChange={s("name")} />
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Sel label="Category" value={f.category} onChange={s("category")} options={["Main Stock", "Old Material", "Sample Pack", "Balance Stock"]} /></div>
        <div style={{ flex: 1 }}><Sel label="Unit" value={f.unit} onChange={s("unit")} options={["Kg", "Ltr", "Nos", "Rmt", "Set"]} /></div>
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Input label="Batch No." value={f.batchNo} onChange={s("batchNo")} /></div>
       <div style={{ flex: 1 }}><Input label="HSN Code" value={f.hsnCode} onChange={s("hsnCode")} placeholder="e.g. 38244090" /></div>
<div style={{ flex: 1 }}><Input label="Expiry Date" value={f.expiryDate} onChange={s("expiryDate")} type="date" /></div>
      </div>
      <div style={{ display: "flex", gap: 10 }}>
        <div style={{ flex: 1 }}><Input label="No. of Cans" value={f.cans} onChange={s("cans")} type="number" /></div>
        <div style={{ flex: 1 }}><Input label="Packaging (per can)" value={f.packaging} onChange={s("packaging")} type="number" /></div>
        <div style={{ flex: 1 }}><Input label="Total Qty" value={f.currentStock} onChange={s("currentStock")} type="number" /></div>
      </div>
      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => {
          if (!f.name) return;
          onSave({ id: Date.now(), ...f, cans: Number(f.cans), packaging: Number(f.packaging), currentStock: Number(f.currentStock) });
        }}>Add Product</Btn>
      </div>
    </Modal>
  );
}

function MasterBOQSettings({ masterBOQ, setMasterBOQ, onClose }) {
  const [editId, setEditId] = useState(null);
  const [editVal, setEditVal] = useState({});
  const [newItem, setNewItem] = useState({ description: "", unit: "", rate: "" });
  const [showAdd, setShowAdd] = useState(false);

  const startEdit = (item) => { setEditId(item.id); setEditVal({ description: item.description, unit: item.unit, rate: item.rate }); };
  const saveEdit = () => { setMasterBOQ(bs => bs.map(b => b.id === editId ? { ...b, ...editVal, rate: Number(editVal.rate) } : b)); setEditId(null); };
  const deleteItem = (id) => { if (window.confirm("Remove this item from Master BOQ?")) setMasterBOQ(bs => bs.filter(b => b.id !== id)); };
  const addItem = () => {
    if (!newItem.description) return;
    setMasterBOQ(bs => [...bs, { id: Date.now(), ...newItem, rate: Number(newItem.rate) }]);
    setNewItem({ description: "", unit: "", rate: "" });
    setShowAdd(false);
  };

  const inputStyle = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, color: theme.text, padding: "5px 8px", fontSize: 12, outline: "none", width: "100%" };

  return (
    <Modal title="⚙️ Master BOQ Settings" onClose={onClose} width={680}>
      <div style={{ color: theme.muted, fontSize: 12, marginBottom: 16 }}>
        These items will be automatically imported into every new project.
      </div>

      {/* Item List */}
      <div style={{ display: "flex", flexDirection: "column", gap: 8, marginBottom: 14 }}>
        {masterBOQ.map((item, i) => (
          <div key={item.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "10px 14px" }}>
            {editId === item.id ? (
              <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input value={editVal.description} onChange={e => setEditVal(v => ({ ...v, description: e.target.value }))} style={{ ...inputStyle, flex: 3 }} placeholder="Description" />
                <input value={editVal.unit} onChange={e => setEditVal(v => ({ ...v, unit: e.target.value }))} style={{ ...inputStyle, flex: 1 }} placeholder="Unit" />
                <input type="number" value={editVal.rate} onChange={e => setEditVal(v => ({ ...v, rate: e.target.value }))} style={{ ...inputStyle, flex: 1 }} placeholder="Rate ₹" />
                <Btn small variant="success" onClick={saveEdit}>Save</Btn>
                <Btn small variant="ghost" onClick={() => setEditId(null)}>✕</Btn>
              </div>
            ) : (
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
                  <span style={{ color: theme.faint, fontSize: 11, width: 20 }}>{i + 1}.</span>
                  <div>
                    <div style={{ color: theme.text, fontSize: 13, fontWeight: 600 }}>{item.description}</div>
                    <div style={{ color: theme.faint, fontSize: 11 }}>{item.unit || "—"} · ₹{item.rate}</div>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 6 }}>
                  <Btn small variant="ghost" onClick={() => startEdit(item)}>✏️ Edit</Btn>
                  <Btn small variant="danger" onClick={() => deleteItem(item.id)}>🗑</Btn>
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Add New Item */}
      {showAdd ? (
        <div style={{ background: theme.bg, border: `1px solid ${theme.accent}44`, borderRadius: 10, padding: "12px 14px", marginBottom: 14 }}>
          <div style={{ color: theme.accent, fontWeight: 700, fontSize: 12, marginBottom: 10 }}>+ New BOQ Item</div>
          <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
            <input value={newItem.description} onChange={e => setNewItem(v => ({ ...v, description: e.target.value }))} style={{ ...inputStyle, flex: 3 }} placeholder="Item description" />
            <input value={newItem.unit} onChange={e => setNewItem(v => ({ ...v, unit: e.target.value }))} style={{ ...inputStyle, flex: 1 }} placeholder="Unit" />
            <input type="number" value={newItem.rate} onChange={e => setNewItem(v => ({ ...v, rate: e.target.value }))} style={{ ...inputStyle, flex: 1 }} placeholder="Rate ₹" />
          </div>
          <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
            <Btn small variant="ghost" onClick={() => setShowAdd(false)}>Cancel</Btn>
            <Btn small onClick={addItem}>Add Item</Btn>
          </div>
        </div>
      ) : (
        <Btn onClick={() => setShowAdd(true)} variant="ghost" small>+ Add New Item to Master BOQ</Btn>
      )}

      <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
        <Btn onClick={onClose}>Done</Btn>
      </div>
    </Modal>
  );
}


function ChallanModule({ challans = [], setChallans, projects = [], materialRequests = [], setMaterialRequests, currentProject }) {
  const [modal, setModal] = useState(null);
  const [viewChallan, setViewChallan] = useState(null);
  const [editChallan, setEditChallan] = useState(null);
  const [tab, setTab] = useState("challans");
  const [createFromRequest, setCreateFromRequest] = useState(null);
  const [fromDate, setFromDate] = useState("");
const [toDate, setToDate] = useState("");

  // Filter challans for this project only
  const projectChallans = currentProject
    ? challans.filter(c =>
        c.projectId === currentProject.id ||
        c.projectCode === currentProject.projectCode ||
        (!c.projectId && !c.projectCode)
      )
    : challans;

  const pendingRequests = materialRequests.filter(r => r.status === "pending");

  // Tag challan with project info
  const tagChallan = (c) => ({
    ...c,
    projectId: currentProject?.id || c.projectId || "",
    projectCode: c.projectCode || currentProject?.projectCode || "",
  });

  const getNextChallanNo = (projectCode) => {
    const existing = projectChallans.filter(c => c.projectCode === projectCode);
    const next = String(existing.length + 1).padStart(2, "0");
    return `PCS/${projectCode}/${next}/${FINANCIAL_YEAR}`;
  };

  const getNextQuotationNo = (projectCode) => {
    const existing = projectChallans.filter(c => c.projectCode === projectCode);
    const next = 109 + existing.length;
    return `PCS/${projectCode}/Q-${next}/${SHORT_FY}`;
  };

  const saveChallanItem = async (c) => {
    const updated = challans.find(x => x.id === c.id)
      ? challans.map(x => x.id === c.id ? c : x)
      : [c, ...challans];
    setChallans(updated);
    localStorage.setItem("challans", JSON.stringify(updated));
    try { await setDoc(fsDoc(db, "challans", String(c.id)), c); }
    catch (e) { console.error(e); }
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Delivery Management</div>
          <h2 style={{ color: theme.text, fontSize: 26, fontWeight: 800, margin: 0 }}>Challans</h2>
          <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>
            {projectChallans.length} challans
            {currentProject && <span style={{ color: theme.accent, fontWeight: 600 }}> · {currentProject.name}</span>}
          </div>
        </div>
        {tab === "challans" && <Btn onClick={() => setModal("create")}>+ New Challan</Btn>}
      </div>

      {/* Stats */}
      <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
        <StatCard label="Total Challans" value={projectChallans.length} color={theme.blue} icon="📄" />
        <StatCard label="This Month" value={projectChallans.filter(c => c.date?.startsWith(new Date().toISOString().slice(0, 7))).length} color={theme.green} icon="📅" />
        <StatCard label="Received" value={projectChallans.filter(c => c.received).length} color={theme.purple} icon="✅" />
        <StatCard label="Pending Requests" value={pendingRequests.length} color={pendingRequests.length > 0 ? theme.red : theme.muted} icon="⏳" />
      </div>

      {/* Tabs */}
      <Tabs active={tab} onChange={setTab} tabs={[
        { id: "challans", label: `📄 Challans (${projectChallans.length})` },
        { id: "requests", label: `⏳ Pending Requests (${pendingRequests.length})` },
        {id: "summary", label: "📊 Challan Summary" },
      ]} />

      {/* Challans Tab */}
      {tab === "challans" && (
        <>
          {projectChallans.length === 0 ? (
            <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
              <div style={{ fontSize: 36, marginBottom: 10 }}>📄</div>
              <div style={{ color: theme.muted, fontSize: 14 }}>No challans yet for this project. Create your first one.</div>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {projectChallans.map(c => (
                <div key={c.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
                      <span style={{ color: theme.accent, fontWeight: 800, fontSize: 14 }}>{c.challanNo}</span>
                      {c.received && <span style={{ background: theme.green + "22", color: theme.green, border: `1px solid ${theme.green}44`, borderRadius: 5, padding: "1px 8px", fontSize: 10, fontWeight: 700 }}>✅ RECEIVED</span>}
                      <span style={{ background: theme.green + "22", color: theme.green, borderRadius: 5, padding: "1px 8px", fontSize: 10, fontWeight: 700 }}>CHALLAN</span>
                    </div>
                    <div style={{ color: theme.muted, fontSize: 12 }}>📅 {c.date} · 🏗️ {c.clientName} · {c.items?.length || 0} items</div>
                    <div style={{ color: theme.faint, fontSize: 11, marginTop: 2 }}>Quotation: {c.quotationNo} · {c.subject}</div>
                  </div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Btn small variant="ghost" onClick={() => setViewChallan(c)}>👁 View</Btn>
                    <Btn small variant="ghost" onClick={() => setEditChallan(c)}>✏️ Edit</Btn>
                    <Btn small variant="ghost" onClick={() => { setViewChallan(c); setTimeout(() => window.print(), 300); }}>🖨 Print</Btn>
                    <button onClick={async () => {
                      const updated = tagChallan({ ...c, received: !c.received });
                      const newChallans = challans.map(x => x.id === c.id ? updated : x);
                      setChallans(newChallans);
                      localStorage.setItem("challans", JSON.stringify(newChallans));
                      try { await setDoc(fsDoc(db, "challans", String(c.id)), updated); } catch (e) { console.error(e); }
                    }} style={{ background: c.received ? theme.green + "22" : theme.card, border: `1px solid ${c.received ? theme.green : theme.border}`, color: c.received ? theme.green : theme.muted, borderRadius: 7, padding: "4px 10px", fontSize: 12, fontWeight: 700, cursor: "pointer", transition: "all 0.2s" }}>
                      {c.received ? "✅ Received" : "☐ Mark Received"}
                    </button>
                    <Btn small variant="danger" onClick={() => {
                      if (window.confirm(`Delete challan ${c.challanNo}? This cannot be undone.`)) {
                        const updated = challans.filter(x => x.id !== c.id);
                        setChallans(updated);
                        localStorage.setItem("challans", JSON.stringify(updated));
                        deleteDoc(fsDoc(db, "challans", String(c.id))).catch(console.error);
                      }
                    }}>🗑</Btn>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* Pending Requests Tab */}
      {tab === "requests" && (
        <>
          {pendingRequests.length === 0 ? (
            <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
              <div style={{ fontSize: 36, marginBottom: 10 }}>📭</div>
              <div style={{ color: theme.muted, fontSize: 14 }}>No pending material requests.</div>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {pendingRequests.map(req => (
                <div key={req.id} style={{ background: theme.card, border: `1px solid ${theme.orange}44`, borderRadius: 12, padding: "14px 18px" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 10 }}>
                    <div>
                      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
                        <span style={{ color: theme.text, fontWeight: 800, fontSize: 14 }}>📦 {req.projectName}</span>
                        <span style={{ background: theme.orange + "22", color: theme.orange, borderRadius: 5, padding: "1px 8px", fontSize: 10, fontWeight: 700 }}>PENDING</span>
                      </div>
                      <div style={{ color: theme.muted, fontSize: 12 }}>📅 {req.date} · 👤 {req.requestedBy} · {req.items?.length} items</div>
                      {req.notes && <div style={{ color: theme.faint, fontSize: 11, marginTop: 3, fontStyle: "italic" }}>"{req.notes}"</div>}
                      <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginTop: 8 }}>
                        {req.items?.map((item, i) => (
                          <span key={i} style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, padding: "3px 8px", fontSize: 11, color: theme.text }}>
                            {item.name} — {item.qty} {item.unit}
                          </span>
                        ))}
                      </div>
                    </div>
                    <div style={{ display: "flex", gap: 8, flexDirection: "column", alignItems: "flex-end" }}>
                      <Btn small onClick={() => { setCreateFromRequest(req); setTab("challans"); }}>📄 Create Challan</Btn>
                      <Btn small variant="danger" onClick={() => {
                        if (window.confirm("Reject this request?")) {
                          const rejectedReq = materialRequests.find(r => r.id === req.id);
                          if (rejectedReq) saveMaterialRequest({ ...rejectedReq, status: "rejected" });
                          setMaterialRequests(rs => rs.map(r => r.id === req.id ? { ...r, status: "rejected" } : r));
                        }
                      }}>✕ Reject</Btn>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </>
      )}

      {/* Summary Tab */}
{tab === "summary" && (() => {
  const filtered = projectChallans.filter(c => {
    if (fromDate && c.date < fromDate) return false;
    if (toDate && c.date > toDate) return false;
    return true;
  }).sort((a, b) => a.date.localeCompare(b.date));

  const allItems = filtered.flatMap(c =>
    (c.items || []).map(item => ({
      challanNo: c.challanNo,
      quotationNo: c.quotationNo || "—",
      date: c.date,
      clientName: c.clientName,
      siteAddress: c.siteAddress || "—",
      workOrderNo: c.workOrderNo || "—",
      trRr: c.trRr || "—",
      subject: c.subject || "—",
      remarks: c.remarks || "—",
      company: item.company || "—",
      particulars: item.particulars || "—",
      unit: item.unit || "—",
      packing: item.packing || "—",
      qty: item.qty || "—",
    }))
  );

  const exportExcel = async () => {
    
    const wb = XLSX.utils.book_new();
    const dateRange = fromDate && toDate ? `${fromDate} to ${toDate}` : "All Dates";
    const header = [
      ["PERMATECH CONCRETE SOLUTIONS"],
      [`Project: ${currentProject?.name || "All Projects"}`],
      [`Date Range: ${dateRange}`],
      [`Generated: ${new Date().toLocaleDateString("en-IN")}`],
      [],
    ];
    const cols = ["Challan No", "Quotation No", "Date", "Client Name", "Site Address", "Work Order No", "T.R./R.R.", "Subject", "Remarks", "Company", "Particulars", "Unit", "Packing", "Qty"];
    const rows = allItems.map(r => [r.challanNo, r.quotationNo, r.date, r.clientName, r.siteAddress, r.workOrderNo, r.trRr, r.subject, r.remarks, r.company, r.particulars, r.unit, r.packing, r.qty]);
    const ws = XLSX.utils.aoa_to_sheet([...header, cols, ...rows]);
    ws["!cols"] = [{ wch: 18 }, { wch: 18 }, { wch: 12 }, { wch: 22 }, { wch: 28 }, { wch: 14 }, { wch: 10 }, { wch: 16 }, { wch: 14 }, { wch: 18 }, { wch: 22 }, { wch: 8 }, { wch: 16 }, { wch: 8 }];
    XLSX.utils.book_append_sheet(wb, ws, "Challan Summary");
    XLSX.writeFile(wb, `Challan_Summary_${currentProject?.name || "All"}_${dateRange.replace(/ /g, "_")}.xlsx`);
  };

  const printSummary = () => {
    const el = document.getElementById("challan-summary-print");
    if (!el) return;
    const win = window.open("", "_blank");
    win.document.write(`<html><head><style>
      body{font-family:Arial,sans-serif;padding:20px;font-size:10px}
      h2{color:#1a365d;font-size:15px;margin-bottom:2px}
      .meta{color:#666;font-size:10px;margin-bottom:14px}
      table{width:100%;border-collapse:collapse;margin-top:10px}
      th{background:#1a365d;color:#fff;padding:7px 6px;font-size:9px;text-align:center;border:1px solid #2d4a7a;white-space:nowrap}
      td{padding:6px;border:1px solid #e2e8f0;font-size:9px}
      tr:nth-child(even){background:#f8fafc}
      .total-row td{background:#1a365d;color:#fff;font-weight:bold;border-color:#2d4a7a}
      @media print{@page{margin:8mm;size:A4 landscape}}
    </style></head><body>${el.innerHTML}</body></html>`);
    win.document.close();
    setTimeout(() => { win.print(); win.close(); }, 500);
  };

  const th = { padding: "9px 8px", background: "#162040", color: "#93c5fd", fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: `1px solid rgba(99,179,237,0.2)`, whiteSpace: "nowrap" };
  const td = { padding: "8px 8px", border: `1px solid ${theme.border}`, fontSize: 11, textAlign: "center", verticalAlign: "middle" };
  const inp = { background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 12, outline: "none" };

  return (
    <div>
      {/* Date Filter + Actions */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 16 }}>
        <div style={{ display: "flex", gap: 16, alignItems: "flex-end", flexWrap: "wrap" }}>
          <div>
            <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>FROM DATE</div>
            <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} style={inp} />
          </div>
          <div>
            <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>TO DATE</div>
            <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} style={inp} />
          </div>
          <Btn variant="ghost" onClick={() => { setFromDate(""); setToDate(""); }}>Clear</Btn>
          <div style={{ marginLeft: "auto", display: "flex", gap: 10 }}>
            <Btn variant="ghost" onClick={printSummary}>🖨 Download PDF</Btn>
            <Btn onClick={exportExcel}>📥 Export Excel</Btn>
          </div>
        </div>
        {filtered.length > 0 && (
          <div style={{ marginTop: 10, color: theme.muted, fontSize: 12 }}>
            Showing <span style={{ color: theme.accent, fontWeight: 700 }}>{filtered.length}</span> challans ·
            <span style={{ color: theme.blue, fontWeight: 700 }}> {allItems.length}</span> items
            {fromDate && toDate && ` · ${fromDate} to ${toDate}`}
          </div>
        )}
      </div>

      {filtered.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 40, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>📊</div>
          <div style={{ color: theme.muted }}>No challans found for selected date range.</div>
        </div>
      ) : (
        <div id="challan-summary-print">
          <h2 style={{ color: theme.text, margin: "0 0 4px" }}>PERMATECH CONCRETE SOLUTIONS</h2>
          <div style={{ color: theme.muted, fontSize: 12, marginBottom: 16 }}>
            Project: {currentProject?.name || "All"} &nbsp;|&nbsp;
            {fromDate || "Start"} to {toDate || "Today"} &nbsp;|&nbsp;
            {filtered.length} challans · {allItems.length} items &nbsp;|&nbsp;
            Generated: {new Date().toLocaleDateString("en-IN")}
          </div>
          <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1400 }}>
              <thead>
                <tr>
                  {["SR", "Challan No", "Quotation No", "Date", "Client Name", "Site Address", "Work Order No", "T.R./R.R.", "Subject", "Remarks", "Company", "Particulars", "Unit", "Packing", "Qty"].map(h => (
                    <th key={h} style={th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {allItems.map((r, i) => (
                  <tr key={i} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                    <td style={{ ...td, color: theme.muted, width: 40 }}>{i + 1}</td>
                    <td style={{ ...td, color: theme.accent, fontWeight: 700, minWidth: 160 }}>{r.challanNo}</td>
                    <td style={{ ...td, color: theme.blue, minWidth: 160 }}>{r.quotationNo}</td>
                    <td style={{ ...td, minWidth: 100 }}>{r.date}</td>
                    <td style={{ ...td, textAlign: "left", paddingLeft: 10, fontWeight: 600, minWidth: 140 }}>{r.clientName}</td>
                    <td style={{ ...td, textAlign: "left", paddingLeft: 10, minWidth: 180, fontSize: 10 }}>{r.siteAddress}</td>
                    <td style={td}>{r.workOrderNo}</td>
                    <td style={td}>{r.trRr}</td>
                    <td style={{ ...td, minWidth: 120 }}>{r.subject}</td>
                    <td style={{ ...td, minWidth: 100 }}>{r.remarks}</td>
                    <td style={{ ...td, minWidth: 140 }}>{r.company}</td>
                    <td style={{ ...td, fontWeight: 600, textAlign: "left", paddingLeft: 10, minWidth: 160 }}>{r.particulars}</td>
                    <td style={td}>{r.unit}</td>
                    <td style={{ ...td, minWidth: 120 }}>{r.packing}</td>
                    <td style={{ ...td, color: theme.green, fontWeight: 700 }}>{r.qty}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                  <td colSpan={14} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>
                    TOTAL ITEMS
                  </td>
                  <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>
                    {allItems.length}
                  </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      )}
    </div>
  );
})()}

      {/* Modals */}
      {modal === "create" && (
        <CreateChallanModal
          projects={projects}
          getNextChallanNo={getNextChallanNo}
          getNextQuotationNo={getNextQuotationNo}
          onClose={() => setModal(null)}
          currentProject={currentProject || projects?.[0]}
          onSave={c => {
            const tagged = tagChallan(c);
            setChallans(cs => [tagged, ...cs]);
            saveChallanItem(tagged);
            setModal(null);
            setViewChallan(tagged);
          }}
        />
      )}
      {editChallan && (
        <CreateChallanModal
          projects={projects}
          getNextChallanNo={getNextChallanNo}
          getNextQuotationNo={getNextQuotationNo}
          existing={editChallan}
          onClose={() => setEditChallan(null)}
          currentProject={currentProject || projects?.[0]}
          onSave={c => {
            const updated = tagChallan({ ...c, id: editChallan.id });
            setChallans(cs => cs.map(x => x.id === editChallan.id ? updated : x));
            saveChallanItem(updated);
            setEditChallan(null);
            setViewChallan(updated);
          }}
        />
      )}
      {createFromRequest && (
        <CreateChallanModal
          projects={projects}
          getNextChallanNo={getNextChallanNo}
          getNextQuotationNo={getNextQuotationNo}
          prefillFromRequest={createFromRequest}
          currentProject={currentProject || projects?.[0]}
          onClose={() => setCreateFromRequest(null)}
          onSave={c => {
            const tagged = tagChallan(c);
            setChallans(cs => [tagged, ...cs]);
            saveChallanItem(tagged);
            const fulfilledReq = materialRequests.find(r => r.id === createFromRequest.id);
            if (fulfilledReq) saveMaterialRequest({ ...fulfilledReq, status: "fulfilled" });
            setMaterialRequests(rs => rs.map(r => r.id === createFromRequest.id ? { ...r, status: "fulfilled" } : r));
            setCreateFromRequest(null);
            setViewChallan(tagged);
            setTab("challans");
          }}
        />
      )}
      {viewChallan && <ChallanPreviewModal challan={viewChallan} onClose={() => setViewChallan(null)} />}
    </div>
  );
}

function CreateChallanModal({ projects, getNextChallanNo, getNextQuotationNo, onClose, onSave, existing, prefillFromRequest, currentProject }) {
  const [projectCode, setProjectCode] = useState(existing?.projectCode || prefillFromRequest?.projectCode || "RR");
  const [machineryItems, setMachineryItems] = useState(existing?.machineryItems || []);
const [showMachinery, setShowMachinery] = useState((existing?.machineryItems?.length || 0) > 0);
 const [f, setF] = useState({
  clientName: existing?.clientName || currentProject?.clientName || "",
  siteAddress: existing?.siteAddress || currentProject?.siteAddress || "",
    workOrderNo: existing?.workOrderNo || "",
    trRr: existing?.trRr || "By Porter",
    subject: existing?.subject || "For Waterproofing",
    remarks: existing?.remarks || prefillFromRequest?.requestedBy || "",
    date: existing?.date || new Date().toISOString().slice(0, 10),
  });
  const [items, setItems] = useState(() => {
    if (existing?.items) return existing.items;
    if (prefillFromRequest?.items) {
      return prefillFromRequest.items.map(item => ({
        particulars: item.name,
        unit: item.unit,
        packing: "",
        qty: item.qty,
        company: "",
        description: "",
      }));
    }
    return [{ particulars: "", unit: "", packing: "", qty: "", company: "", description: "" }];
  });
  const s = k => v => setF(p => ({ ...p, [k]: v }));

const challanNo = existing?.challanNo || getNextChallanNo(projectCode);
const quotationNo = existing?.quotationNo || getNextQuotationNo(projectCode);
const [editableChallanNo, setEditableChallanNo] = useState(challanNo);
const [editableQuotationNo, setEditableQuotationNo] = useState(quotationNo);

  const inputStyle = { width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 12, outline: "none", boxSizing: "border-box" };
  const labelStyle = { color: theme.muted, fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 3 };

  return (
   <Modal title={existing ? "✏️ Edit Challan" : prefillFromRequest ? `📄 Create Challan from Request — ${prefillFromRequest.projectName}` : "📄 Create New Challan"} onClose={onClose} width={700}>

      {/* Auto-generated numbers */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 }}>
       <div style={{ background: theme.accent + "11", border: `1px solid ${theme.accent}33`, borderRadius: 8, padding: "10px 12px" }}>
  <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase", marginBottom: 4 }}>Challan No. (Editable)</div>
  <input value={editableChallanNo} onChange={e => setEditableChallanNo(e.target.value)}
    style={{ background: "transparent", border: "none", borderBottom: `1px solid ${theme.accent}44`, color: theme.accent, fontWeight: 800, fontSize: 13, outline: "none", width: "100%" }} />
</div>
<div style={{ background: theme.blue + "11", border: `1px solid ${theme.blue}33`, borderRadius: 8, padding: "10px 12px" }}>
  <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase", marginBottom: 4 }}>Quotation No. (Editable)</div>
  <input value={editableQuotationNo} onChange={e => setEditableQuotationNo(e.target.value)}
    style={{ background: "transparent", border: "none", borderBottom: `1px solid ${theme.blue}44`, color: theme.blue, fontWeight: 800, fontSize: 13, outline: "none", width: "100%" }} />
</div>
        <div>
          <label style={labelStyle}>Project Code</label>
          <input value={projectCode} onChange={e => setProjectCode(e.target.value.toUpperCase())} style={inputStyle} placeholder="e.g. RR" />
        </div>
      </div>

      {/* Client & Site */}
      <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
        <div style={{ flex: 1 }}>
          <label style={labelStyle}>Client Name</label>
          <input value={f.clientName} onChange={e => s("clientName")(e.target.value)} style={inputStyle} />
        </div>
        <div style={{ flex: 1 }}>
          <label style={labelStyle}>Date</label>
          <input type="date" value={f.date} onChange={e => s("date")(e.target.value)} style={inputStyle} />
        </div>
      </div>

      <div style={{ marginBottom: 10 }}>
        <label style={labelStyle}>Site Address</label>
        <input value={f.siteAddress} onChange={e => s("siteAddress")(e.target.value)} style={inputStyle} />
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 10, marginBottom: 10 }}>
        <div>
          <label style={labelStyle}>Work Order No.</label>
          <input value={f.workOrderNo} onChange={e => s("workOrderNo")(e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>T.R./R.R.</label>
          <input value={f.trRr} onChange={e => s("trRr")(e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Subject</label>
          <input value={f.subject} onChange={e => s("subject")(e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Remarks</label>
          <input value={f.remarks} onChange={e => s("remarks")(e.target.value)} style={inputStyle} placeholder="e.g. Rashid" />
        </div>
      </div>

      {/* Items Table */}
      <div style={{ marginBottom: 14 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <label style={{ ...labelStyle, marginBottom: 0 }}>Items</label>
          <button onClick={() => setItems(is => [...is, { particulars: "", unit: "", packing: "", qty: "" }])}
            style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 6, width: 26, height: 26, fontSize: 16, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>+</button>
        </div>

        {/* Header */}
      {/* Header */}
<div style={{ display: "grid", gridTemplateColumns: "24px 1fr 1fr 24px", gap: 8, marginBottom: 5 }}>
  {["Sr.", "Company", "Product", ""].map(h => (
    <div key={h} style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase", fontWeight: 600 }}>{h}</div>
  ))}
</div>

    {items.map((item, i) => (
  <div key={i} style={{ background: theme.bg, borderRadius: 8, padding: "10px 12px", marginBottom: 10, border: `1px solid ${theme.border}` }}>

    {/* Row 1 — Sr + Company + Product + Remove */}
    <div style={{ display: "grid", gridTemplateColumns: "24px 1fr 1fr 24px", gap: 8, marginBottom: 8, alignItems: "center" }}>
      <div style={{ color: theme.faint, fontSize: 11, textAlign: "center", fontWeight: 700 }}>{i + 1}</div>

      {/* Company — type freely or pick from suggestions */}
      <div>
        <input
          list={`company-list-${i}`}
          value={item.company || ""}
          onChange={e => setItems(is => is.map((x, j) => j === i
            ? { ...x, company: e.target.value, particulars: "", unit: "", packing: "" }
            : x
          ))}
          style={inputStyle}
          placeholder="Type or select company..."
        />
        <datalist id={`company-list-${i}`}>
          {Object.keys(MATERIAL_LIST).map(c => (
            <option key={c} value={c} />
          ))}
        </datalist>
      </div>

      {/* Product — type freely or pick from suggestions */}
      <div>
        <input
          list={`product-list-${i}`}
          value={item.particulars || ""}
          onChange={e => {
            const product = (MATERIAL_LIST[item.company] || []).find(p => p.name === e.target.value);
            setItems(is => is.map((x, j) => j === i
              ? { ...x, particulars: e.target.value, unit: product?.unit || x.unit, packing: product?.packing || x.packing }
              : x
            ));
          }}
          style={inputStyle}
          placeholder="Type or select product..."
        />
        <datalist id={`product-list-${i}`}>
          {(MATERIAL_LIST[item.company] || []).map(p => (
            <option key={p.name} value={p.name} />
          ))}
        </datalist>
      </div>

      {/* Remove */}
      <button onClick={() => setItems(is => is.filter((_, j) => j !== i))}
        style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
    </div>

    {/* Row 2 — Unit, Packing, Qty */}
    <div style={{ display: "grid", gridTemplateColumns: "24px 1fr 1fr 1fr", gap: 8, alignItems: "center" }}>
      <div />
      <div>
        <div style={{ ...labelStyle, fontSize: 9 }}>Unit</div>
        <input
          value={item.unit || ""}
          onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, unit: e.target.value } : x))}
          style={{ ...inputStyle, fontSize: 11 }}
          placeholder="Kg / Nos / Ltr"
        />
      </div>
      <div>
        <div style={{ ...labelStyle, fontSize: 9 }}>Packing</div>
        <input
          value={item.packing || ""}
          onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, packing: e.target.value } : x))}
          style={{ ...inputStyle, fontSize: 11 }}
          placeholder="e.g. 25 Kgs × 1 Bag"
        />
      </div>
      <div>
        <div style={{ ...labelStyle, fontSize: 9 }}>Qty</div>
        <input
          type="text"
          value={item.qty || ""}
          onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, qty: e.target.value } : x))}
          style={{ ...inputStyle, color: theme.green, fontWeight: 700, fontSize: 11 }}
          placeholder="e.g. 500 Kg"
        />
      </div>
    </div>
  </div>
))}
      </div>
   {/* Machinery Section */}
<div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "14px 16px", marginBottom: 14 }}>
  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: showMachinery ? 12 : 0 }}>
    <div style={{ color: theme.accent, fontWeight: 700, fontSize: 13 }}>🚜 Machinery (Optional)</div>
    <button onClick={() => setShowMachinery(s => !s)}
      style={{ background: theme.accent + "22", border: `1px solid ${theme.accent}44`, color: theme.accent, borderRadius: 7, padding: "4px 12px", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
      {showMachinery ? "− Hide" : "+ Add Machinery"}
    </button>
  </div>
  {showMachinery && (
    <div>
      {/* Header */}
      <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr 0.7fr 0.8fr 28px", gap: 8, marginBottom: 6 }}>
        {["Machine Name", "Machine ID", "Qty", "Company Name", ""].map(h => (
          <div key={h} style={{ color: theme.muted, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</div>
        ))}
      </div>
      {machineryItems.map((item, i) => (
        <div key={i} style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr 0.7fr 0.8fr 28px", gap: 8, marginBottom: 8, alignItems: "center" }}>
          {/* Machine Name */}
          <select
            value={item.machineName || ""}
            onChange={e => setMachineryItems(ms => ms.map((x, j) => j === i ? { ...x, machineName: e.target.value, machineId: "" } : x))}
            style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 12, outline: "none" }}>
            <option value="">— Select Machine —</option>
            {Object.keys(MACHINERY_LIST).map(name => (
              <option key={name} value={name}>{name}</option>
            ))}
          </select>
          {/* Machine ID */}
          <select
            value={item.machineId || ""}
            onChange={e => setMachineryItems(ms => ms.map((x, j) => j === i ? { ...x, machineId: e.target.value } : x))}
            style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: item.machineId ? theme.accent : theme.muted, padding: "7px 10px", fontSize: 12, outline: "none", fontWeight: item.machineId ? 700 : 400 }}
            disabled={!item.machineName}>
            <option value="">— Select ID —</option>
            {(MACHINERY_LIST[item.machineName] || []).map(id => (
              <option key={id} value={id}>{id}</option>
            ))}
          </select>
          {/* Quantity */}
          <input
            type="number"
            value={item.quantity || ""}
            onChange={e => setMachineryItems(ms => ms.map((x, j) => j === i ? { ...x, quantity: e.target.value } : x))}
            placeholder="Qty"
            style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.green, padding: "7px 10px", fontSize: 12, outline: "none", fontWeight: 700, boxSizing: "border-box" }}
          />
          {/* Company Name */}
          <input
            value={item.companyName || ""}
            onChange={e => setMachineryItems(ms => ms.map((x, j) => j === i ? { ...x, companyName: e.target.value } : x))}
            placeholder="Company..."
            style={{ width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 12, outline: "none", boxSizing: "border-box" }}
          />
          {/* Remove */}
          <button onClick={() => setMachineryItems(ms => ms.filter((_, j) => j !== i))}
            style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 28, height: 28, fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
        </div>
      ))}
      <button onClick={() => setMachineryItems(ms => [...ms, { machineName: "", machineId: "", quantity: "", companyName: "" }])}
        style={{ background: theme.green + "22", border: `1px dashed ${theme.green}`, color: theme.green, borderRadius: 7, padding: "6px 14px", fontSize: 12, cursor: "pointer", width: "100%", fontWeight: 600 }}>
        + Add Machine
      </button>
    </div>
  )}
</div>
<div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => {
          const filled = items.filter(i => i.particulars.trim());
          if (!f.clientName || filled.length === 0) return alert("Please fill client name and at least one item.");
          onSave({ id: Date.now(), challanNo: editableChallanNo, quotationNo: editableQuotationNo, projectCode, projectId: currentProject?.id || "", ...f, items: filled, machineryItems: machineryItems.filter(m => m.machineName && m.machineId) });
        }}>{existing ? "Save Changes" : "Create & Preview"}</Btn>
      </div>
    </Modal>
  );
}

function ChallanPreviewModal({ challan, onClose }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "#000000cc", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
     <style>{`
  @media print {
    body * { visibility: hidden !important; }
    #challan-print, #challan-print * { visibility: visible !important; }
    #challan-print {
      position: absolute !important;
      top: 0 !important; left: 0 !important;
      width: 100% !important;
      padding: 16px 20px !important;
      font-size: 11px !important;
    }
    .no-print { display: none !important; }
    @page { margin: 0; size: A4; }
  }
`}</style>
      <div style={{ background: "#fff", borderRadius: 12, width: "100%", maxWidth: 750, maxHeight: "92vh", overflow: "auto" }}>

        {/* Action Bar */}
        <div className="no-print" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 18px", borderBottom: "1px solid #e2e8f0", background: "#f8fafc" }}>
          <span style={{ fontWeight: 700, color: "#1a202c", fontSize: 14 }}>📄 {challan.challanNo}</span>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => window.print()} style={{ background: "#1a365d", color: "#fff", border: "none", borderRadius: 7, padding: "7px 16px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>🖨 Print / Download PDF</button>
            <button onClick={onClose} style={{ background: "#f1f5f9", border: "1px solid #e2e8f0", color: "#64748b", borderRadius: 7, padding: "7px 14px", fontSize: 12, cursor: "pointer" }}>✕ Close</button>
          </div>
        </div>

        {/* Print Area */}
        <div id="challan-print" style={{ padding: "16px 22px", fontFamily: "Arial, sans-serif", fontSize: 11, color: "#000", background: "#fff" }}>

          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid #000", paddingBottom: 12, marginBottom: 12 }}>
            <div>
              <div style={{ fontWeight: 900, fontSize: 16, letterSpacing: 1, color: "#1a365d" }}>PERMATECH CONCRETE SOLUTIONS</div>
              <div style={{ fontSize: 11, marginTop: 3, color: "#333" }}>18, Divya Darshan, Mount Mary Steps, Bandra (W) Mumbai - 400050</div>
              <div style={{ fontSize: 11, color: "#333" }}>Mobile: 7738131631 &nbsp;|&nbsp; Email: info@permatech.in</div>
              <div style={{ fontSize: 10, color: "#555", marginTop: 2 }}>PAN: AAJFP3195N &nbsp;|&nbsp; GSTIN: 27AAJFP3195N1ZJ</div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div style={{ fontWeight: 900, fontSize: 18, letterSpacing: 3, border: "2px solid #1a365d", color: "#1a365d", padding: "6px 20px" }}>CHALLAN</div>
            </div>
          </div>

          {/* Info Grid */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", border: "1px solid #000", marginBottom: 12 }}>
            <div style={{ borderRight: "1px solid #000", padding: "10px 12px" }}>
              <div style={{ fontSize: 10, color: "#666", marginBottom: 3 }}>To,</div>
              <div style={{ fontWeight: 800, fontSize: 13 }}>{challan.clientName}</div>
              <div style={{ fontSize: 10, color: "#666", marginTop: 6, marginBottom: 2 }}>Site Address:</div>
              <div style={{ fontSize: 11 }}>{challan.siteAddress}</div>
            </div>
            <div style={{ fontSize: 11 }}>
              {[
                ["Challan No.", challan.challanNo, challan.date ? `Date: ${challan.date.split("-").reverse().join(".")}` : ""],
                ["Quotation No.", challan.quotationNo || "—", ""],
                ["Work Order No.", challan.workOrderNo || "—", ""],
                ["T.R./R.R.", challan.trRr || "—", ""],
                ["Subject", challan.subject || "—", ""],
                ["Remarks", challan.remarks || "—", ""],
              ].map(([label, value, extra]) => (
                <div key={label} style={{ display: "grid", gridTemplateColumns: "110px 1fr auto", borderBottom: "1px solid #ddd", padding: "5px 8px", gap: 4 }}>
                  <span style={{ fontWeight: 600, color: "#333" }}>{label}:</span>
                  <span>{value}</span>
                  <span style={{ color: "#555", fontSize: 10 }}>{extra}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Please receive line */}
          <div style={{ textAlign: "center", fontSize: 11, fontStyle: "italic", marginBottom: 10, borderTop: "1px solid #ccc", borderBottom: "1px solid #ccc", padding: "5px 0" }}>
            Please receive the undermentioned goods as per bearer & return duplicate copy of Challan Duly Signed
          </div>

          {/* Items Table */}
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 16 }}>
            <thead>
              <tr style={{ background: "#f1f5f9" }}>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontWeight: 700, fontSize: 11, width: 40 }}>Sr. No.</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "left", fontWeight: 700, fontSize: 11 }}>Particulars</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontWeight: 700, fontSize: 11, width: 70 }}>Unit</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontWeight: 700, fontSize: 11, width: 150 }}>Packing</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontWeight: 700, fontSize: 11, width: 80 }}>Qty</th>
              </tr>
            </thead>
            <tbody>
              {challan.items?.map((item, i) => (
                <tr key={i}>
                  <td style={{ border: "1px solid #000", padding: "10px 8px", textAlign: "center", fontSize: 11 }}>{i + 1}</td>
                  <td style={{ border: "1px solid #000", padding: "10px 8px", fontSize: 11 }}>
                    <div>{item.particulars}</div>
                    {item.description && <div style={{ color: "#666", fontSize: 10, marginTop: 2, fontStyle: "italic" }}>({item.description})</div>}
                  </td>
                  <td style={{ border: "1px solid #000", padding: "10px 8px", textAlign: "center", fontSize: 11 }}>{item.unit}</td>
                  <td style={{ border: "1px solid #000", padding: "10px 8px", textAlign: "center", fontSize: 11 }}>{item.packing}</td>
                  <td style={{ border: "1px solid #000", padding: "10px 8px", textAlign: "center", fontSize: 11 }}>{item.qty}</td>
                </tr>
              ))}
             {Array.from({ length: Math.max(0, 5 - (challan.items?.length || 0)) }).map((_, i) => (
  <tr key={`empty-${i}`}>
    {[...Array(5)].map((_, j) => <td key={j} style={{ border: "1px solid #000", padding: "10px 8px" }}></td>)}
  </tr>
))}
            </tbody>
          </table>
          {/* Machinery Section */}
{challan.machineryItems?.length > 0 && (
  <div style={{ marginBottom: 16 }}>
    <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 6, color: "#1a365d", borderBottom: "1px solid #ccc", paddingBottom: 4 }}>🚜 Machinery Dispatched</div>
    <table style={{ width: "100%", borderCollapse: "collapse" }}>
      <thead>
        <tr style={{ background: "#f1f5f9" }}>
          <th style={{ border: "1px solid #000", padding: "6px 8px", textAlign: "center", fontSize: 11, width: 40 }}>Sr.</th>
          <th style={{ border: "1px solid #000", padding: "6px 8px", textAlign: "left", fontSize: 11 }}>Machine Name</th>
          <th style={{ border: "1px solid #000", padding: "6px 8px", textAlign: "center", fontSize: 11 }}>Machine ID</th>
        </tr>
      </thead>
      <tbody>
        {challan.machineryItems.map((m, i) => (
          <tr key={i}>
            <td style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontSize: 11 }}>{i + 1}</td>
            <td style={{ border: "1px solid #000", padding: "7px 8px", fontSize: 11, fontWeight: 600 }}>{m.machineName}</td>
            <td style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontSize: 11, color: "#1a365d", fontWeight: 700 }}>{m.machineId}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}

          {/* Footer */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginTop: 10 }}>
            <div style={{ fontSize: 10, color: "#444", lineHeight: 1.6 }}>
              Subject to Mumbai Jurisdiction. Complaints will only be considered within 3 days after receipt of goods which are forwarded at customer's risk. Goods once sold will not be taken back under any circumstances.
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 40 }}>For PERMATECH CONCRETE SOLUTIONS</div>
              <div style={{ borderTop: "1px solid #000", paddingTop: 5, fontSize: 11, display: "inline-block", minWidth: 180 }}>Authorised Signatory</div>
            </div>
          </div>

          <div style={{ marginTop: 20, borderTop: "1px solid #ccc", paddingTop: 12 }}>
            <div style={{ borderTop: "1px solid #000", paddingTop: 5, marginTop: 40, width: 180, fontSize: 11 }}>Receiver's Signature &amp; Stamp</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function BOQInvoiceModal({ project, getNextInvoiceNo, onClose, onSave }) {
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState(new Date().toISOString().slice(0, 10));
  const [step, setStep] = useState(1);

 const getQtyUpToDate = (boqId, date) => {
  if (!date || !project?.raEntries) return "";
  const validEntries = project.raEntries
    .filter(e => e.date <= date)
    .sort((a, b) => b.date.localeCompare(a.date));
  if (validEntries.length === 0) return "";
  const latestEntry = validEntries[0];
  const item = latestEntry.items?.find(i => i.id === boqId);
  return item?.cumulative || 0;
};

const [rows, setRows] = useState(
  (project?.boq || []).map(b => ({
    id: b.id,
    description: b.description || "",
    unit: b.unit || "",
    qty: "",
    rate: b.rate || "",
    selected: false,
  }))
);
  const updateRow = (id, field, value) => {
    setRows(rs => rs.map(r => r.id === id ? { ...r, [field]: value } : r));
  };

  const toggleRow = (id) => {
    setRows(rs => rs.map(r => r.id === id ? { ...r, selected: !r.selected } : r));
  };

  const selectAll = () => setRows(rs => rs.map(r => ({ ...r, selected: true })));
  const clearAll = () => setRows(rs => rs.map(r => ({ ...r, selected: false })));

  const addRow = () => setRows(rs => [...rs, {
    id: Date.now(), description: "", unit: "", qty: "", rate: "", selected: true
  }]);

  const deleteRow = (id) => setRows(rs => rs.filter(r => r.id !== id));

  const selectedRows = rows.filter(r => r.selected);
  const totalAmount = selectedRows.reduce((s, r) => s + ((Number(r.qty) || 0) * (Number(r.rate) || 0)), 0);

  const handleGenerate = () => {
    if (selectedRows.length === 0) { alert("Please select at least one item."); return; }
    const emptyQty = selectedRows.find(r => !r.qty || Number(r.qty) === 0);
    if (emptyQty) { alert(`Please enter quantity for: ${emptyQty.description || "unnamed item"}`); return; }
    setStep(2);
  };

  const prefilledInvoice = {
    clientName: project?.client || "",
    clientAddress: "",
    clientGSTIN: "",
    siteAddress: project?.location || "",
    invoiceDate: toDate,
    woRef: "",
    woDate: "",
    runningBillNo: "1",
    sacCode: "995453",
    subName: project?.name || "",
    cgst: 9,
    sgst: 9,
    items: selectedRows.map(r => ({
      particulars: r.description,
      description: `${fromDate ? `From ${fromDate} to ` : "Up to "}${toDate}`,
      unit: r.unit,
      qty: r.qty,
      rate: r.rate,
    }))
  };

  if (step === 2) {
    return (
      <CreateInvoiceModal
        getNextInvoiceNo={getNextInvoiceNo}
        onClose={onClose}
        onSave={onSave}
        existing={prefilledInvoice}
      />
    );
  }

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, color: theme.text, padding: "5px 8px", fontSize: 12, outline: "none", width: "100%", boxSizing: "border-box" };
  const labelStyle = { color: theme.muted, fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 3 };



  return (
    <div style={{ position: "fixed", inset: 0, background: "#000a", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 16, width: "100%", maxWidth: 860, maxHeight: "92vh", display: "flex", flexDirection: "column" }}>

        {/* Header */}
        <div style={{ padding: "18px 24px", borderBottom: `1px solid ${theme.border}` }}>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Billing & Invoicing</div>
          <h3 style={{ color: theme.text, margin: "0 0 2px", fontSize: 18, fontWeight: 800 }}>📋 Invoice from BOQ Tracker</h3>
          <div style={{ color: theme.muted, fontSize: 12 }}>
            Project: <span style={{ color: theme.accent, fontWeight: 700 }}>{project?.name}</span> · Client: <span style={{ color: theme.text, fontWeight: 600 }}>{project?.client}</span>
          </div>
        </div>

        {/* Date Range */}
        <div style={{ padding: "14px 24px", borderBottom: `1px solid ${theme.border}`, display: "flex", gap: 16, alignItems: "flex-end", flexWrap: "wrap" }}>
          <div style={{ flex: 1, minWidth: 140 }}>
            <label style={labelStyle}>From Date (optional)</label>
           <input type="date" value={fromDate} onChange={e => {
  const newFromDate = e.target.value;
  setFromDate(newFromDate);
  // Recalculate: qty = cumulative up to toDate - cumulative up to fromDate
  setRows(rs => rs.map(r => {
    const qtyUpToDate = getQtyUpToDate(r.id, toDate) || 0;
    const qtyBeforeFrom = newFromDate ? (getQtyUpToDate(r.id, newFromDate) || 0) : 0;
    return { ...r, qty: Math.max(0, qtyUpToDate - qtyBeforeFrom) };
  }));
}} style={{ ...inp, width: "100%" }} />
          </div>
          <div style={{ flex: 1, minWidth: 140 }}>
            <label style={labelStyle}>Up To Date</label>
            <input type="date" value={toDate} onChange={e => {
  const newDate = e.target.value;
  setToDate(newDate);
  // Auto-update quantities for all rows based on new date
  setRows(rs => rs.map(r => ({
    ...r,
    qty: getQtyUpToDate(r.id, newDate)
  })));
}} style={{ ...inp, width: "100%" }} />
          </div>
          <div style={{ display: "flex", gap: 8 }}>
            <Btn small variant="ghost" onClick={selectAll}>✓ Select All</Btn>
            <Btn small variant="ghost" onClick={clearAll}>✕ Clear</Btn>
            <Btn small onClick={addRow}>+ Add Row</Btn>
          </div>
        </div>

        {/* Table */}
        <div style={{ overflowY: "auto", flex: 1, padding: "14px 24px" }}>

          {/* Column Headers */}
          <div style={{ display: "grid", gridTemplateColumns: "32px 2.5fr 70px 90px 100px 110px 32px", gap: 8, marginBottom: 8, padding: "0 4px" }}>
            {["", "Description", "Unit", "Qty (Period)", "Rate ₹", "Amount ₹", ""].map(h => (
              <div key={h} style={{ color: theme.faint, fontSize: 10, fontWeight: 700, textTransform: "uppercase" }}>{h}</div>
            ))}
          </div>

          {rows.length === 0 ? (
            <div style={{ textAlign: "center", padding: 40, color: theme.muted }}>
              <div style={{ fontSize: 32, marginBottom: 10 }}>📋</div>
              <div>No BOQ items found. Click "+ Add Row" to add manually.</div>
            </div>
          ) : (
            rows.map(row => {
              const amount = (Number(row.qty) || 0) * (Number(row.rate) || 0);
              return (
                <div
                  key={row.id}
                  style={{ display: "grid", gridTemplateColumns: "32px 2.5fr 70px 90px 100px 110px 32px", gap: 8, alignItems: "center", padding: "8px 4px", borderRadius: 8, marginBottom: 6, background: row.selected ? theme.accent + "11" : theme.card, border: `1px solid ${row.selected ? theme.accent + "44" : theme.border}`, transition: "all 0.15s" }}
                >
                  {/* Checkbox */}
                  <div
                    onClick={() => toggleRow(row.id)}
                    style={{ width: 18, height: 18, borderRadius: 4, border: `2px solid ${row.selected ? theme.accent : theme.border}`, background: row.selected ? theme.accent : "transparent", display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", flexShrink: 0 }}
                  >
                    {row.selected && <span style={{ color: "#fff", fontSize: 11, fontWeight: 800 }}>✓</span>}
                  </div>

                  {/* Description */}
                  <input
                    value={row.description}
                    onChange={e => updateRow(row.id, "description", e.target.value)}
                    style={{ ...inp, fontWeight: 600 }}
                    placeholder="Item description..."
                  />

                  {/* Unit */}
                  <input
                    value={row.unit}
                    onChange={e => updateRow(row.id, "unit", e.target.value)}
                    style={inp}
                    placeholder="Unit"
                  />

                  {/* Qty */}
                  <input
                    type="number"
                    value={row.qty}
                    onChange={e => updateRow(row.id, "qty", e.target.value)}
                    style={{ ...inp, color: theme.blue, fontWeight: 700, border: `1px solid ${!row.qty && row.selected ? theme.red + "88" : theme.border}` }}
                    placeholder="Enter qty"
                  />

                  {/* Rate */}
                  <input
                    type="number"
                    value={row.rate}
                    onChange={e => updateRow(row.id, "rate", e.target.value)}
                    style={{ ...inp, color: theme.accent, fontWeight: 600 }}
                    placeholder="Rate"
                  />

                  {/* Amount */}
                  <div style={{ color: theme.green, fontWeight: 700, fontSize: 13, textAlign: "right", paddingRight: 4 }}>
                    {amount > 0 ? `₹${amount.toLocaleString("en-IN")}` : "—"}
                  </div>

                  {/* Delete */}
                  <button
                    onClick={() => deleteRow(row.id)}
                    style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}
                  >×</button>
                </div>
              );
            })
          )}
        </div>

        {/* Footer */}
        <div style={{ padding: "14px 24px", borderTop: `1px solid ${theme.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ display: "flex", gap: 24 }}>
            <div>
              <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Selected Items</div>
              <div style={{ color: theme.text, fontWeight: 800, fontSize: 18 }}>{selectedRows.length}</div>
            </div>
            <div>
              <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase" }}>Total Amount</div>
              <div style={{ color: theme.green, fontWeight: 800, fontSize: 18 }}>₹{totalAmount.toLocaleString("en-IN")}</div>
            </div>
          </div>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
            <Btn onClick={handleGenerate}>Generate Proforma Invoice →</Btn>
          </div>
        </div>
      </div>
    </div>
  );
}
function AbstractSummary({ invoices, projects }) {
  const [selectedProjectId, setSelectedProjectId] = useState(projects[0]?.id || "");
  const [summaryData, setSummaryData] = useState({
    clientName: "", clientAddress: "", siteAddress: "",
    invoiceNo: "", invoiceDate: "", runningBillNo: ""
  });
  

  const selectedProject = projects.find(p => String(p.id) === String(selectedProjectId));

  // Get project invoices sorted by RA number
  

  // Get qty and amount for a BOQ item from a specific RA invoice
  const getRAData = (boqItem, raNo) => {
    const raInvoices = invoices.filter(inv => String(inv.runningBillNo) === String(raNo));
    if (!raInvoices.length) return { qty: 0, amount: 0 };
    let totalQty = 0, totalAmount = 0;
    raInvoices.forEach(inv => {
      (inv.items || []).forEach(item => {
        const invName = (item.particulars || "").trim().toLowerCase().replace(/[-_/\\().,:;]+/g, " ").replace(/\s+/g, " ");
        const boqName = (boqItem.description || "").trim().toLowerCase().replace(/[-_/\\().,:;]+/g, " ").replace(/\s+/g, " ");
        if (invName === boqName || invName.includes(boqName) || boqName.includes(invName)) {
          const qty = Number(item.qty) || 0;
          const rate = Number(item.rate) || boqItem.rate || 0;
          totalQty += qty;
          totalAmount += qty * rate;
        }
      });
    });
    return { qty: Math.round(totalQty * 100) / 100, amount: Math.round(totalAmount * 100) / 100 };
  };

  const boqItems = selectedProject?.boq || [];
  const thStyle = { padding: "8px 10px", background: "#162040", color: "#93c5fd", fontSize: 11, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: `1px solid rgba(99,179,237,0.2)`, whiteSpace: "nowrap" };
  const tdStyle = { padding: "8px 10px", border: `1px solid ${theme.border}`, fontSize: 13, textAlign: "center", verticalAlign: "middle" };
  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "8px 10px", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 };
  const exportSummaryToExcel = async () => {
  
  const wb = XLSX.utils.book_new();

  const headers1 = [
    "PERMATECH CONCRETE SOLUTIONS",
    "", "", "", "", "", "", "", "", "", "", "", ""
  ];
  const headers2 = [
    "Abstract Sheet", "", "", "", "", "", "", "", "", "", "", "", ""
  ];
  const clientRow = [
    `Client: ${summaryData.clientName || "—"}`, "", "",
    `Invoice No: ${summaryData.invoiceNo || "—"}`, "", "",
    `Invoice Date: ${summaryData.invoiceDate || "—"}`, "", "",
    `Running Bill No: ${summaryData.runningBillNo || "—"}`, "", "", ""
  ];
  const blankRow = ["", "", "", "", "", "", "", "", "", "", "", "", ""];
  const colHeaders1 = [
    "SR", "Item Description", "BOQ Unit", "BOQ Qty", "BOQ Rate",
    "RA01 QTY", "RA01 Amount",
    "RA02 QTY", "RA02 Amount",
    "RA03 QTY", "RA03 Amount",
    "Total QTY", "Total Amount"
  ];

  const dataRows = boqItems.map((item, idx) => {
    const ra1 = getRAData(item, "1");
    const ra2 = getRAData(item, "2");
    const ra3 = getRAData(item, "3");
    const totalQty = Math.round((ra1.qty + ra2.qty + ra3.qty) * 100) / 100;
    const totalAmount = Math.round((ra1.amount + ra2.amount + ra3.amount) * 100) / 100;
    return [
      idx + 1,
      item.description || "",
      item.unit || "",
      item.plannedQty || 0,
      item.rate || 0,
      ra1.qty || 0, ra1.amount || 0,
      ra2.qty || 0, ra2.amount || 0,
      ra3.qty || 0, ra3.amount || 0,
      totalQty, totalAmount,
    ];
  });

  // Grand total row
  const grand = boqItems.reduce((s, item) => {
    const r1 = getRAData(item, "1");
    const r2 = getRAData(item, "2");
    const r3 = getRAData(item, "3");
    return {
      ra1q: s.ra1q + r1.qty, ra1a: s.ra1a + r1.amount,
      ra2q: s.ra2q + r2.qty, ra2a: s.ra2a + r2.amount,
      ra3q: s.ra3q + r3.qty, ra3a: s.ra3a + r3.amount,
    };
  }, { ra1q: 0, ra1a: 0, ra2q: 0, ra2a: 0, ra3q: 0, ra3a: 0 });

  const totalRow = [
    "", "GRAND TOTAL", "", "", "",
    Math.round(grand.ra1q * 100) / 100, Math.round(grand.ra1a),
    Math.round(grand.ra2q * 100) / 100, Math.round(grand.ra2a),
    Math.round(grand.ra3q * 100) / 100, Math.round(grand.ra3a),
    Math.round((grand.ra1q + grand.ra2q + grand.ra3q) * 100) / 100,
    Math.round(grand.ra1a + grand.ra2a + grand.ra3a),
  ];

  const allData = [headers1, headers2, clientRow, blankRow, colHeaders1, ...dataRows, blankRow, totalRow];
  const ws = XLSX.utils.aoa_to_sheet(allData);

  // Column widths
  ws["!cols"] = [
    { wch: 5 }, { wch: 28 }, { wch: 10 }, { wch: 10 }, { wch: 12 },
    { wch: 10 }, { wch: 14 }, { wch: 10 }, { wch: 14 },
    { wch: 10 }, { wch: 14 }, { wch: 12 }, { wch: 16 }
  ];

  // Style title row
  const titleCell = XLSX.utils.encode_cell({ r: 0, c: 0 });
  if (ws[titleCell]) ws[titleCell].s = { font: { bold: true, sz: 14, color: { rgb: "162040" } } };

  // Style column headers row (row index 4)
  colHeaders1.forEach((_, colIdx) => {
    const cellRef = XLSX.utils.encode_cell({ r: 4, c: colIdx });
    if (!ws[cellRef]) return;
    ws[cellRef].s = {
      fill: { fgColor: { rgb: "162040" } },
      font: { bold: true, sz: 11, color: { rgb: "93C5FD" } },
      alignment: { horizontal: "center", wrapText: true },
      border: { top: { style: "thin" }, bottom: { style: "thin" }, left: { style: "thin" }, right: { style: "thin" } }
    };
  });

  // Style data rows
  dataRows.forEach((_, rowIdx) => {
    colHeaders1.forEach((__, colIdx) => {
      const cellRef = XLSX.utils.encode_cell({ r: 5 + rowIdx, c: colIdx });
      if (!ws[cellRef]) return;
      ws[cellRef].s = {
        fill: { fgColor: { rgb: rowIdx % 2 === 0 ? "FFFFFF" : "F0F4FF" } },
        alignment: { horizontal: "center" },
        border: { top: { style: "thin", color: { rgb: "CCCCCC" } }, bottom: { style: "thin", color: { rgb: "CCCCCC" } }, left: { style: "thin", color: { rgb: "CCCCCC" } }, right: { style: "thin", color: { rgb: "CCCCCC" } } }
      };
    });
  });

  // Style total row
  const totalRowIdx = allData.length - 1;
  colHeaders1.forEach((_, colIdx) => {
    const cellRef = XLSX.utils.encode_cell({ r: totalRowIdx, c: colIdx });
    if (!ws[cellRef]) return;
    ws[cellRef].s = { fill: { fgColor: { rgb: "162040" } }, font: { bold: true, sz: 12, color: { rgb: "FCD34D" } }, alignment: { horizontal: "center" } };
  });

  ws["!rows"] = [{ hpt: 22 }, { hpt: 18 }, { hpt: 16 }, { hpt: 6 }, { hpt: 28 }];

  XLSX.utils.book_append_sheet(wb, ws, "Abstract Summary");
  XLSX.writeFile(wb, `Abstract_Summary_${selectedProject?.name?.replace(/\s+/g, "_") || "export"}_${new Date().toISOString().slice(0, 10)}.xlsx`);
};

  return (
    <div>
      <style>{`@media print { body * { visibility: hidden !important; } #abs-print, #abs-print * { visibility: visible !important; } #abs-print { position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; background: white !important; padding: 20px !important; font-family: Arial, sans-serif; } .no-print { display: none !important; } }`}</style>

      {/* Header */}
      <div className="no-print" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Billing & Invoicing</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📋 Abstract Summary Sheet</h2>
        </div>
        <Btn variant="ghost" onClick={exportSummaryToExcel}>📥 Export Excel</Btn>
<Btn variant="blue" onClick={() => window.print()}>🖨 Print / PDF</Btn>
      </div>

      {/* Project Selector */}
      <div className="no-print" style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 20 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
          <div>
            <label style={lbl}>Select Project</label>
            <select value={selectedProjectId} onChange={e => setSelectedProjectId(e.target.value)} style={{ ...inp, color: theme.accent, fontWeight: 700 }}>
              {projects.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>Invoice No.</label>
            <input value={summaryData.invoiceNo} onChange={e => setSummaryData(d => ({ ...d, invoiceNo: e.target.value }))} style={inp} placeholder="e.g. PCS/RR/174/2025-26" />
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
          <div>
            <label style={lbl}>Invoice Date</label>
            <input type="date" value={summaryData.invoiceDate} onChange={e => setSummaryData(d => ({ ...d, invoiceDate: e.target.value }))} style={inp} />
          </div>
          <div>
            <label style={lbl}>Running Bill No.</label>
            <input value={summaryData.runningBillNo} onChange={e => setSummaryData(d => ({ ...d, runningBillNo: e.target.value }))} style={inp} placeholder="e.g. 01" />
          </div>
          <div>
            <label style={lbl}>Client Name</label>
            <input value={summaryData.clientName} onChange={e => setSummaryData(d => ({ ...d, clientName: e.target.value }))} style={inp} placeholder="Client name..." />
          </div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          <div>
            <label style={lbl}>Billing Address</label>
            <input value={summaryData.clientAddress} onChange={e => setSummaryData(d => ({ ...d, clientAddress: e.target.value }))} style={inp} placeholder="Billing address..." />
          </div>
          <div>
            <label style={lbl}>Site Address</label>
            <input value={summaryData.siteAddress} onChange={e => setSummaryData(d => ({ ...d, siteAddress: e.target.value }))} style={inp} placeholder="Site address..." />
          </div>
        </div>
      </div>

      {/* Printable Area */}
      <div id="abs-print" style={{ background: "#fff", color: "#000", borderRadius: 12, border: `1px solid ${theme.border}`, padding: 24 }}>

        {/* Company Header */}
        <div style={{ textAlign: "center", marginBottom: 16, borderBottom: "2px solid #162040", paddingBottom: 14 }}>
          <div style={{ fontSize: 17, fontWeight: 900, color: "#162040", textTransform: "uppercase", letterSpacing: 1 }}>PERMATECH CONCRETE SOLUTIONS</div>
          <div style={{ fontSize: 11, color: "#64748b", marginTop: 4 }}>18, Divya Darshan, Mount Mary Steps, Bandra (W), Mumbai - 400 050.</div>
          <div style={{ fontSize: 11, color: "#64748b" }}>Office Mobile No.: +91 7738131613, Email: info@permatech.in</div>
          <div style={{ fontSize: 11, color: "#64748b" }}>Pan No. AAJFP3195N, GSTIN : 27AAJFP3195N1ZJ, UAM No. MH19E0109732</div>
          <div style={{ fontSize: 13, fontWeight: 800, color: "#162040", marginTop: 10, letterSpacing: 2, textTransform: "uppercase" }}>— ABSTRACT SHEET —</div>
        </div>

        {/* Client Info */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16, fontSize: 12 }}>
          <div>
            <div style={{ color: "#64748b", marginBottom: 4 }}>To,</div>
            <div style={{ fontWeight: 700, color: "#0f1f3d", fontSize: 13 }}>{summaryData.clientName || "—"}</div>
            {summaryData.clientAddress && <div style={{ color: "#374151", marginTop: 3 }}>Billing Address: {summaryData.clientAddress}</div>}
            {summaryData.siteAddress && <div style={{ color: "#374151", marginTop: 3 }}>Site Address: {summaryData.siteAddress || selectedProject?.name}</div>}
          </div>
          <div style={{ fontSize: 12 }}>
            {[
              ["Invoice No.", summaryData.invoiceNo || "—"],
              ["Invoice Date", summaryData.invoiceDate ? new Date(summaryData.invoiceDate).toLocaleDateString("en-IN") : "—"],
              ["Running Bill No.", summaryData.runningBillNo || "—"],
            ].map(([k, v]) => (
              <div key={k} style={{ display: "flex", gap: 8, marginBottom: 5 }}>
                <span style={{ color: "#64748b", fontWeight: 600, minWidth: 120 }}>{k}:</span>
                <span style={{ color: "#0f1f3d", fontWeight: 700 }}>{v}</span>
              </div>
            ))}
          </div>
        </div>

        <div style={{ borderTop: "1px solid #e2e8f0", marginBottom: 12 }} />

        {/* Table */}
        {boqItems.length === 0 ? (
          <div style={{ textAlign: "center", padding: 40, color: "#94a3b8" }}>
            <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
            <div>No BOQ items found for this project. Add items in BOQ Tracker first.</div>
          </div>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1100 }}>
              <thead>
                <tr>
                  <th style={{ ...thStyle, background: "#162040" }} rowSpan={2}>SR</th>
                  <th style={{ ...thStyle, background: "#162040" }} rowSpan={2}>Item Description</th>
                  <th style={{ ...thStyle, background: "#162040" }} rowSpan={2}>BOQ Unit</th>
                  <th style={{ ...thStyle, background: "#162040" }} rowSpan={2}>BOQ Qty</th>
                  <th style={{ ...thStyle, background: "#162040" }} rowSpan={2}>BOQ Rate</th>
                  <th style={{ ...thStyle, background: "#1e3a5f" }} colSpan={2}>This Bill (RA 01)</th>
                  <th style={{ ...thStyle, background: "#1a3356" }} colSpan={2}>This Bill (RA 02)</th>
                  <th style={{ ...thStyle, background: "#0f2444" }} colSpan={2}>This Bill (RA 03)</th>
                  <th style={{ ...thStyle, background: "#162040" }} colSpan={2}>Total Upto Date</th>
                </tr>
                <tr>
                  {["QTY", "Amount", "QTY", "Amount", "QTY", "Amount", "QTY", "Amount"].map((h, i) => (
                    <th key={i} style={{ ...thStyle, fontSize: 10, background: i < 2 ? "#1e3a5f" : i < 4 ? "#1a3356" : i < 6 ? "#0f2444" : "#162040" }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {boqItems.map((item, idx) => {
                  const ra1 = getRAData(item, "1");
                  const ra2 = getRAData(item, "2");
                  const ra3 = getRAData(item, "3");
                  const totalQty = Math.round((ra1.qty + ra2.qty + ra3.qty) * 100) / 100;
                  const totalAmount = Math.round((ra1.amount + ra2.amount + ra3.amount) * 100) / 100;
                  

                  return (
                    <tr key={item.id} style={{ background: idx % 2 === 0 ? "#fff" : "#f8fafc" }}>
                      <td style={{ ...tdStyle, color: "#94a3b8" }}>{idx + 1}</td>
                      <td style={{ ...tdStyle, textAlign: "left", fontWeight: 600, color: "#0f172a", minWidth: 180 }}>{item.description}</td>
                      <td style={{ ...tdStyle, color: "#64748b" }}>{item.unit || "—"}</td>
                      <td style={{ ...tdStyle, color: "#2563eb", fontWeight: 700 }}>{item.plannedQty || 0}</td>
                      <td style={{ ...tdStyle, color: "#2563eb" }}>₹{(item.rate || 0).toLocaleString("en-IN")}</td>
                      {/* RA01 */}
                      <td style={{ ...tdStyle, background: ra1.qty > 0 ? "#eff6ff" : "#fff" }}>
                        <span style={{ color: "#1d4ed8", fontWeight: ra1.qty > 0 ? 700 : 400 }}>{ra1.qty > 0 ? ra1.qty : "—"}</span>
                      </td>
                      <td style={{ ...tdStyle, background: ra1.qty > 0 ? "#eff6ff" : "#fff" }}>
                        <span style={{ color: "#1d4ed8", fontWeight: ra1.qty > 0 ? 700 : 400 }}>{ra1.amount > 0 ? `₹${ra1.amount.toLocaleString("en-IN")}` : "—"}</span>
                      </td>
                      {/* RA02 */}
                      <td style={{ ...tdStyle, background: ra2.qty > 0 ? "#f0fdf4" : "#fff" }}>
                        <span style={{ color: "#059669", fontWeight: ra2.qty > 0 ? 700 : 400 }}>{ra2.qty > 0 ? ra2.qty : "—"}</span>
                      </td>
                      <td style={{ ...tdStyle, background: ra2.qty > 0 ? "#f0fdf4" : "#fff" }}>
                        <span style={{ color: "#059669", fontWeight: ra2.qty > 0 ? 700 : 400 }}>{ra2.amount > 0 ? `₹${ra2.amount.toLocaleString("en-IN")}` : "—"}</span>
                      </td>
                      {/* RA03 */}
                      <td style={{ ...tdStyle, background: ra3.qty > 0 ? "#faf5ff" : "#fff" }}>
                        <span style={{ color: "#7c3aed", fontWeight: ra3.qty > 0 ? 700 : 400 }}>{ra3.qty > 0 ? ra3.qty : "—"}</span>
                      </td>
                      <td style={{ ...tdStyle, background: ra3.qty > 0 ? "#faf5ff" : "#fff" }}>
                        <span style={{ color: "#7c3aed", fontWeight: ra3.qty > 0 ? 700 : 400 }}>{ra3.amount > 0 ? `₹${ra3.amount.toLocaleString("en-IN")}` : "—"}</span>
                      </td>
                      {/* Total */}
                      <td style={{ ...tdStyle, background: totalQty > 0 ? "#fef9c3" : "#fff" }}>
                        <span style={{ color: "#92400e", fontWeight: totalQty > 0 ? 800 : 400 }}>{totalQty > 0 ? totalQty : "—"}</span>
                      </td>
                      <td style={{ ...tdStyle, background: totalAmount > 0 ? "#fef9c3" : "#fff" }}>
                        <span style={{ color: "#92400e", fontWeight: totalAmount > 0 ? 800 : 400 }}>{totalAmount > 0 ? `₹${totalAmount.toLocaleString("en-IN")}` : "—"}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr style={{ background: "#162040", borderTop: "2px solid #3b82f6" }}>
                  <td colSpan={5} style={{ ...tdStyle, textAlign: "right", fontWeight: 800, fontSize: 13, color: "#93c5fd", background: "#162040", border: `1px solid rgba(99,179,237,0.2)` }}>TOTAL</td>
                  {[1, 2, 3].map(ra => {
                    const total = boqItems.reduce((s, item) => {
                      const d = getRAData(item, String(ra));
                      return { qty: s.qty + d.qty, amount: s.amount + d.amount };
                    }, { qty: 0, amount: 0 });
                    const bg = ra === 1 ? "#1e3a5f" : ra === 2 ? "#1a3356" : "#0f2444";
                    return [
                      <td key={`ra${ra}q`} style={{ ...tdStyle, background: bg, border: `1px solid rgba(99,179,237,0.2)` }}>
                        <span style={{ color: "#93c5fd", fontWeight: 800 }}>{Math.round(total.qty * 100) / 100 || "—"}</span>
                      </td>,
                      <td key={`ra${ra}a`} style={{ ...tdStyle, background: bg, border: `1px solid rgba(99,179,237,0.2)` }}>
                        <span style={{ color: "#93c5fd", fontWeight: 800 }}>₹{Math.round(total.amount).toLocaleString("en-IN") || "—"}</span>
                      </td>
                    ];
                  })}
                  {(() => {
                    const grand = boqItems.reduce((s, item) => {
                      const r1 = getRAData(item, "1");
                      const r2 = getRAData(item, "2");
                      const r3 = getRAData(item, "3");
                      return { qty: s.qty + r1.qty + r2.qty + r3.qty, amount: s.amount + r1.amount + r2.amount + r3.amount };
                    }, { qty: 0, amount: 0 });
                    return [
                      <td key="tq" style={{ ...tdStyle, background: "#162040", border: `1px solid rgba(99,179,237,0.2)` }}>
                        <span style={{ color: "#fcd34d", fontWeight: 900 }}>{Math.round(grand.qty * 100) / 100}</span>
                      </td>,
                      <td key="ta" style={{ ...tdStyle, background: "#162040", border: `1px solid rgba(99,179,237,0.2)` }}>
                        <span style={{ color: "#fcd34d", fontWeight: 900 }}>₹{Math.round(grand.amount).toLocaleString("en-IN")}</span>
                      </td>
                    ];
                  })()}
                </tr>
              </tfoot>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}

function CreateTaxInvoiceModal({ getNextTaxInvoiceNo, proformaInvoices, onClose, onSave, existing }) {
  const [projectCode, setProjectCode] = useState(existing?.projectCode || "RR");
  const [editableInvoiceNo, setEditableInvoiceNo] = useState(existing?.invoiceNo || getNextTaxInvoiceNo("RR"));
  const [proformaRef, setProformaRef] = useState(existing?.proformaRef || "");
  const [proformaDate, setProformaDate] = useState(existing?.proformaDate || "");
  const [f, setF] = useState({
    clientName: existing?.clientName || "",
    clientAddress: existing?.clientAddress || "",
    clientGSTIN: existing?.clientGSTIN || "",
    siteAddress: existing?.siteAddress || "",
    invoiceDate: existing?.invoiceDate || new Date().toISOString().slice(0, 10),
    woRef: existing?.woRef || "",
    woDate: existing?.woDate || "",
    runningBillNo: existing?.runningBillNo || "1",
    sacCode: existing?.sacCode || "995453",
    subName: existing?.subName || "",
    cgst: existing?.cgst || 9,
    sgst: existing?.sgst || 9,
  });
  const [items, setItems] = useState(existing?.items || [{ particulars: "", description: "", unit: "", qty: "", rate: "" }]);
  const s = k => v => setF(p => ({ ...p, [k]: v }));

  // When proforma is selected, auto-fill all fields
  const handleProformaSelect = (invoiceNo) => {
    setProformaRef(invoiceNo);
    const found = proformaInvoices.find(inv => inv.invoiceNo === invoiceNo);
    if (found) {
      setProjectCode(found.projectCode || "RR");
      setEditableInvoiceNo(getNextTaxInvoiceNo(found.projectCode || "RR"));
      setProformaDate(found.invoiceDate || "");
      setF({
        clientName: found.clientName || "",
        clientAddress: found.clientAddress || "",
        clientGSTIN: found.clientGSTIN || "",
        siteAddress: found.siteAddress || "",
        invoiceDate: new Date().toISOString().slice(0, 10),
        woRef: found.woRef || "",
        woDate: found.woDate || "",
        runningBillNo: found.runningBillNo || "1",
        sacCode: found.sacCode || "995453",
        subName: found.subName || "",
        cgst: found.cgst || 9,
        sgst: found.sgst || 9,
      });
      setItems(found.items || [{ particulars: "", description: "", unit: "", qty: "", rate: "" }]);
    }
  };

  const invoiceAmount = items.reduce((sum, item) => sum + ((Number(item.qty) || 0) * (Number(item.rate) || 0)), 0);
  const cgstAmount = invoiceAmount * (Number(f.cgst) || 0) / 100;
  const sgstAmount = invoiceAmount * (Number(f.sgst) || 0) / 100;
  const billAmount = invoiceAmount + cgstAmount + sgstAmount;
  const roundOff = Math.round(billAmount) - billAmount;
  const totalAmount = Math.round(billAmount);

  const inputStyle = { width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 12, outline: "none", boxSizing: "border-box" };
  const labelStyle = { color: theme.muted, fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 3 };

  return (
    <Modal title={existing ? "✏️ Edit Tax Invoice" : "🧾 Create Tax Invoice"} onClose={onClose} width={740}>
      {/* Invoice No + Project Code */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 }}>
        <div style={{ background: theme.green + "11", border: `1px solid ${theme.green}33`, borderRadius: 8, padding: "10px 12px" }}>
          <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase", marginBottom: 4 }}>Tax Invoice No.</div>
          <input value={editableInvoiceNo} onChange={e => setEditableInvoiceNo(e.target.value)}
            style={{ background: "transparent", border: "none", borderBottom: `1px solid ${theme.green}44`, color: theme.green, fontWeight: 800, fontSize: 13, outline: "none", width: "100%" }} />
        </div>
        <div>
          <label style={labelStyle}>Project Code</label>
          <input value={projectCode} onChange={e => { setProjectCode(e.target.value.toUpperCase()); setEditableInvoiceNo(getNextTaxInvoiceNo(e.target.value.toUpperCase())); }}
            style={{ ...inputStyle, padding: "3px 8px" }} placeholder="e.g. RR" />
        </div>
        <div>
          <label style={labelStyle}>Invoice Date</label>
          <input type="date" value={f.invoiceDate} onChange={e => s("invoiceDate")(e.target.value)} style={inputStyle} />
        </div>
      </div>

      {/* Proforma Reference */}
      <div style={{ background: theme.blue + "11", border: `1px solid ${theme.blue}33`, borderRadius: 10, padding: "12px 14px", marginBottom: 14 }}>
        <div style={{ color: theme.blue, fontSize: 11, fontWeight: 700, marginBottom: 8 }}>🔗 Reference Proforma Invoice</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
          <div>
            <label style={labelStyle}>Select Proforma Invoice</label>
            <select value={proformaRef} onChange={e => handleProformaSelect(e.target.value)}
              style={{ ...inputStyle, cursor: "pointer", color: theme.accent, fontWeight: 600 }}>
              <option value="">— Select or type manually —</option>
              {proformaInvoices.map(inv => <option key={inv.id} value={inv.invoiceNo}>{inv.invoiceNo} — {inv.clientName}</option>)}
            </select>
          </div>
          <div>
            <label style={labelStyle}>Or Type Proforma No. Manually</label>
            <input value={proformaRef} onChange={e => setProformaRef(e.target.value)}
              style={inputStyle} placeholder="e.g. PCS/RR/174/2025-26" />
          </div>
        </div>
        <div style={{ marginTop: 8 }}>
          <label style={labelStyle}>Proforma Invoice Date</label>
          <input type="date" value={proformaDate} onChange={e => setProformaDate(e.target.value)} style={{ ...inputStyle, width: 200 }} />
        </div>
        {proformaRef && proformaDate && (
          <div style={{ marginTop: 8, background: theme.blue + "08", borderRadius: 6, padding: "6px 10px", color: theme.blue, fontSize: 11, fontWeight: 600 }}>
            📋 This invoice raised against the Proforma Invoice : {proformaRef}, Dt. {new Date(proformaDate).toLocaleDateString("en-IN")}
          </div>
        )}
      </div>

      {/* Client Details */}
      <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "12px 14px", marginBottom: 12 }}>
        <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, marginBottom: 10 }}>👤 Client Details</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
          <div><label style={labelStyle}>Client Name</label><input value={f.clientName} onChange={e => s("clientName")(e.target.value)} style={inputStyle} /></div>
          <div><label style={labelStyle}>Client GSTIN</label><input value={f.clientGSTIN} onChange={e => s("clientGSTIN")(e.target.value)} style={inputStyle} /></div>
        </div>
        <div style={{ marginBottom: 10 }}><label style={labelStyle}>Client Address</label><input value={f.clientAddress} onChange={e => s("clientAddress")(e.target.value)} style={inputStyle} /></div>
        <div><label style={labelStyle}>Site Address</label><input value={f.siteAddress} onChange={e => s("siteAddress")(e.target.value)} style={inputStyle} /></div>
      </div>

      {/* Invoice Meta */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", gap: 10, marginBottom: 12 }}>
        <div><label style={labelStyle}>WO Ref</label><input value={f.woRef} onChange={e => s("woRef")(e.target.value)} style={inputStyle} /></div>
        <div><label style={labelStyle}>WO Date</label><input value={f.woDate} onChange={e => s("woDate")(e.target.value)} style={inputStyle} /></div>
        <div><label style={labelStyle}>Running Bill No.</label><input value={f.runningBillNo} onChange={e => s("runningBillNo")(e.target.value)} style={inputStyle} /></div>
        <div><label style={labelStyle}>SAC Code</label><input value={f.sacCode} onChange={e => s("sacCode")(e.target.value)} style={inputStyle} /></div>
        <div><label style={labelStyle}>Sub Name</label><input value={f.subName} onChange={e => s("subName")(e.target.value)} style={inputStyle} /></div>
      </div>

      {/* Items */}
      <div style={{ marginBottom: 14 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <label style={{ ...labelStyle, marginBottom: 0 }}>Items</label>
          <button onClick={() => setItems(is => [...is, { particulars: "", description: "", unit: "", qty: "", rate: "" }])}
            style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 6, width: 26, height: 26, fontSize: 16, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>+</button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "24px 2fr 1fr 80px 80px 90px 24px", gap: 6, marginBottom: 5 }}>
          {["Sr.", "Particulars", "Description", "Unit", "Qty", "Rate ₹", ""].map(h => (
            <div key={h} style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase", fontWeight: 600 }}>{h}</div>
          ))}
        </div>
        {items.map((item, i) => (
          <div key={i} style={{ display: "grid", gridTemplateColumns: "24px 2fr 1fr 80px 80px 90px 24px", gap: 6, marginBottom: 8, alignItems: "center" }}>
            <div style={{ color: theme.faint, fontSize: 11, textAlign: "center" }}>{i + 1}</div>
            <div>
              <input list={`tax-product-${i}`} value={item.particulars || ""} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, particulars: e.target.value } : x))} style={inputStyle} placeholder="Product name" />
              <datalist id={`tax-product-${i}`}>{Object.values(MATERIAL_LIST).flat().map(p => <option key={p.name} value={p.name} />)}</datalist>
            </div>
            <input value={item.description || ""} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, description: e.target.value } : x))} style={{ ...inputStyle, fontSize: 11, color: theme.muted }} placeholder="Note" />
            <input value={item.unit || ""} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, unit: e.target.value } : x))} style={inputStyle} placeholder="Kg" />
            <input type="number" value={item.qty || ""} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, qty: e.target.value } : x))} style={inputStyle} placeholder="0" />
            <input type="number" value={item.rate || ""} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, rate: e.target.value } : x))} style={{ ...inputStyle, color: theme.accent, fontWeight: 600 }} placeholder="0" />
            <button onClick={() => setItems(is => is.filter((_, j) => j !== i))} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
          </div>
        ))}
      </div>

      {/* GST + Summary */}
      <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "12px 14px", marginBottom: 14 }}>
        <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
          <div style={{ flex: 1 }}><label style={labelStyle}>CGST %</label><input type="number" value={f.cgst} onChange={e => s("cgst")(e.target.value)} style={inputStyle} /></div>
          <div style={{ flex: 1 }}><label style={labelStyle}>SGST %</label><input type="number" value={f.sgst} onChange={e => s("sgst")(e.target.value)} style={inputStyle} /></div>
        </div>
        {[["Invoice Amount", invoiceAmount], [`CGST @ ${f.cgst}%`, cgstAmount], [`SGST @ ${f.sgst}%`, sgstAmount], ["Bill Amount", billAmount], ["Round Off", roundOff], ["Total Amount", totalAmount]].map(([label, val]) => (
          <div key={label} style={{ display: "flex", justifyContent: "space-between" }}>
            <span style={{ color: theme.muted, fontSize: 12 }}>{label}</span>
            <span style={{ color: label === "Total Amount" ? theme.green : theme.text, fontWeight: label === "Total Amount" ? 800 : 500, fontSize: label === "Total Amount" ? 14 : 12 }}>
              ₹{Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>
        ))}
      </div>

      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => {
          if (!f.clientName || !items.filter(i => i.particulars?.trim()).length) return alert("Please fill client name and at least one item.");
          onSave({ id: existing?.id || Date.now(), invoiceNo: editableInvoiceNo, projectCode, ...f, items: items.filter(i => i.particulars?.trim()), invoiceAmount, cgstAmount, sgstAmount, billAmount, roundOff, totalAmount, proformaRef, proformaDate, invoiceType: "tax" });
        }}>Create Tax Invoice</Btn>
      </div>
    </Modal>
  );
}

function TaxInvoicePreviewModal({ invoice, onClose }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "#000000cc", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          #tax-invoice-print, #tax-invoice-print * { visibility: visible !important; }
          #tax-invoice-print { position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; background: white !important; padding: 16px 22px !important; font-size: 11px !important; }
          .no-print { display: none !important; }
          @page { margin: 0; size: A4; }
        }
      `}</style>
      <div style={{ background: "#fff", borderRadius: 12, width: "100%", maxWidth: 800, maxHeight: "92vh", overflow: "auto" }}>
        <div className="no-print" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 18px", borderBottom: "1px solid #e2e8f0", background: "#f8fafc" }}>
          <span style={{ fontWeight: 700, color: "#1a202c", fontSize: 14 }}>🧾 {invoice.invoiceNo}</span>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => window.print()} style={{ background: "#1a365d", color: "#fff", border: "none", borderRadius: 7, padding: "7px 16px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>🖨 Print / PDF</button>
            <button onClick={onClose} style={{ background: "#f1f5f9", border: "1px solid #e2e8f0", color: "#64748b", borderRadius: 7, padding: "7px 14px", fontSize: 12, cursor: "pointer" }}>✕ Close</button>
          </div>
        </div>

        <div id="tax-invoice-print" style={{ padding: "24px 30px", fontFamily: "Arial, sans-serif", fontSize: 12, color: "#000", background: "#fff" }}>
          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid #1a365d", paddingBottom: 12, marginBottom: 12 }}>
            <div>
              <div style={{ fontWeight: 900, fontSize: 17, color: "#1a365d", letterSpacing: 1 }}>PERMATECH CONCRETE SOLUTIONS</div>
              <div style={{ fontSize: 11, color: "#555", marginTop: 3 }}>18, Divya Darshan, Mount Mary Steps, Bandra (W), Mumbai – 400 050</div>
              <div style={{ fontSize: 11, color: "#555" }}>Mobile: +91 7738131613 &nbsp;|&nbsp; Email: info@permatech.in</div>
              <div style={{ fontSize: 10, color: "#777", marginTop: 2 }}>PAN: AAJFP3195N &nbsp;|&nbsp; GSTIN: 27AAJFP3195N1ZJ &nbsp;|&nbsp; UDYAM-MH-18-0450938</div>
            </div>
            <div style={{ fontWeight: 900, fontSize: 15, letterSpacing: 2, border: "2px solid #1a365d", color: "#1a365d", padding: "8px 20px", textAlign: "center" }}>TAX INVOICE</div>
          </div>

          {/* Client + Invoice Info */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", border: "1px solid #000", marginBottom: 12 }}>
            <div style={{ borderRight: "1px solid #000", padding: "10px 12px" }}>
              <div style={{ fontSize: 10, color: "#666", marginBottom: 3 }}>To,</div>
              <div style={{ fontWeight: 800, fontSize: 13 }}>{invoice.clientName}</div>
              <div style={{ fontSize: 11, color: "#444", marginTop: 4, lineHeight: 1.5 }}>{invoice.clientAddress}</div>
              <div style={{ fontSize: 10, color: "#666", marginTop: 4 }}>GSTIN: {invoice.clientGSTIN}</div>
              <div style={{ fontSize: 10, color: "#666", marginTop: 6, borderTop: "1px dashed #ccc", paddingTop: 6 }}>
                <span style={{ fontWeight: 600 }}>Site Address:</span> {invoice.siteAddress}
              </div>
            </div>
            <div style={{ fontSize: 11 }}>
              {[
                ["Invoice No.", invoice.invoiceNo],
                ["Invoice Date", invoice.invoiceDate?.split("-").reverse().join(".")],
                ["WO Ref / Date", `${invoice.woRef || "—"} / ${invoice.woDate || "—"}`],
                ["Running Bill No.", invoice.runningBillNo],
                ["SAC Code", invoice.sacCode],
                ["Sub Name", invoice.subName],
              ].map(([label, value]) => (
                <div key={label} style={{ display: "grid", gridTemplateColumns: "120px 1fr", borderBottom: "1px solid #ddd", padding: "5px 10px", gap: 6 }}>
                  <span style={{ fontWeight: 600, color: "#444" }}>{label}:</span>
                  <span style={{ color: "#222" }}>{value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Items Table */}
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 0 }}>
            <thead>
              <tr style={{ background: "#f1f5f9" }}>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontWeight: 700, fontSize: 11, width: 40 }}>SR.</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "left", fontWeight: 700, fontSize: 11 }}>PARTICULARS</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontWeight: 700, fontSize: 11, width: 50 }}>UNIT</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontWeight: 700, fontSize: 11, width: 65 }}>QTY</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontWeight: 700, fontSize: 11, width: 90 }}>RATE</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "right", fontWeight: 700, fontSize: 11, width: 100 }}>AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              {invoice.items?.map((item, i) => (
                <tr key={i}>
                  <td style={{ border: "1px solid #000", padding: "9px 8px", textAlign: "center", fontSize: 11 }}>{i + 1}</td>
                  <td style={{ border: "1px solid #000", padding: "9px 8px", fontSize: 11 }}>
                    <div style={{ fontWeight: 500 }}>{item.particulars}</div>
                    {item.description && <div style={{ color: "#666", fontSize: 10, marginTop: 2, fontStyle: "italic" }}>({item.description})</div>}
                  </td>
                  <td style={{ border: "1px solid #000", padding: "9px 8px", textAlign: "center", fontSize: 11 }}>{item.unit}</td>
                  <td style={{ border: "1px solid #000", padding: "9px 8px", textAlign: "center", fontSize: 11 }}>{Number(item.qty).toFixed(2)}</td>
                  <td style={{ border: "1px solid #000", padding: "9px 8px", textAlign: "center", fontSize: 11 }}>{Number(item.rate).toLocaleString("en-IN")}</td>
                  <td style={{ border: "1px solid #000", padding: "9px 8px", textAlign: "right", fontSize: 11 }}>{(Number(item.qty) * Number(item.rate)).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
                </tr>
              ))}
              {Array.from({ length: Math.max(0, 3 - (invoice.items?.length || 0)) }).map((_, i) => (
                <tr key={`e-${i}`}>{[...Array(6)].map((_, j) => <td key={j} style={{ border: "1px solid #000", padding: "14px 8px" }}></td>)}</tr>
              ))}
            </tbody>
          </table>

          {/* Totals */}
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 0 }}>
            <tbody>
              {[
                ["Invoice Amount", invoice.invoiceAmount, false],
                [`Add: CGST @ ${invoice.cgst}%`, invoice.cgstAmount, false],
                [`Add: SGST @ ${invoice.sgst}%`, invoice.sgstAmount, false],
                ["Bill Amount", invoice.billAmount, false],
                ["Round Off", Math.abs(invoice.roundOff) < 0.01 ? 0 : invoice.roundOff, false],
                ["Total Amount", invoice.totalAmount, true],
              ].map(([label, val, bold]) => (
                <tr key={label}>
                  <td colSpan={5} style={{ border: "1px solid #000", padding: "5px 10px", textAlign: "right", fontWeight: bold ? 800 : 500, fontSize: bold ? 13 : 11, background: bold ? "#f1f5f9" : "#fff" }}>{label}</td>
                  <td style={{ border: "1px solid #000", padding: "5px 10px", textAlign: "right", fontWeight: bold ? 800 : 500, fontSize: bold ? 13 : 11, minWidth: 100, background: bold ? "#f1f5f9" : "#fff" }}>
                    {Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Amount in Words */}
          <div style={{ border: "1px solid #000", borderTop: "none", padding: "7px 10px", display: "flex", gap: 8, marginBottom: 10 }}>
            <span style={{ fontWeight: 700, fontSize: 11, whiteSpace: "nowrap" }}>AMOUNT IN WORDS:</span>
            <span style={{ fontSize: 11 }}>Rupees {numberToWords(invoice.totalAmount)} Only.</span>
          </div>

          {/* Proforma Reference Line */}
          {invoice.proformaRef && (
            <div style={{ border: "1px solid #1a365d", borderRadius: 6, padding: "8px 12px", marginBottom: 10, background: "#eff6ff", fontSize: 11, color: "#1a365d", fontStyle: "italic", fontWeight: 600 }}>
              📋 This invoice raised against the Proforma Invoice : {invoice.proformaRef}, Dt. {invoice.proformaDate ? new Date(invoice.proformaDate).toLocaleDateString("en-IN") : "—"}
            </div>
          )}

          {/* Bank Details */}
          <div style={{ border: "1px solid #000", padding: "8px 10px", marginBottom: 14, fontSize: 11 }}>
            <span style={{ fontWeight: 700, color: "#1a365d" }}>Bank Name: </span>Cosmos Bank, Branch: Bandra (W) &nbsp;|&nbsp;
            <span style={{ fontWeight: 700, color: "#1a365d" }}>A/c No.: </span>04360010198 &nbsp;|&nbsp;
            <span style={{ fontWeight: 700, color: "#1a365d" }}>IFSC: </span>COSB0000043
          </div>

          {/* Signatures */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginTop: 10 }}>
            <div>
              <div style={{ borderTop: "1px solid #000", paddingTop: 6, marginTop: 40, fontSize: 11 }}>Receiver's Stamp &amp; Signature</div>
              <div style={{ fontSize: 10, color: "#666", marginTop: 2 }}>For Client</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 40 }}>For M/s. Permatech Concrete Solutions</div>
              <div style={{ borderTop: "1px solid #000", paddingTop: 6, fontSize: 11, display: "inline-block", minWidth: 180 }}>Authorised Signatory</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function BillingModule({ invoices, setInvoices, projects, currentProject, taxInvoicesProp, setTaxInvoicesProp }) {
  // Filter invoices for this project only
 const projectInvoices = invoices;

  const [modal, setModal] = useState(null);
  const [viewInvoice, setViewInvoice] = useState(null);
  const [editInvoice, setEditInvoice] = useState(null);
  const [billingTab, setBillingTab] = useState("invoices");
  const taxInvoices = taxInvoicesProp || [];
const setTaxInvoices = setTaxInvoicesProp || (() => {});
  const [viewTaxInvoice, setViewTaxInvoice] = useState(null);
  const [editTaxInvoice, setEditTaxInvoice] = useState(null);

  const [ledgers, setLedgers] = useState(() => {
    const ls = localStorage.getItem('ledgers');
    return ls ? JSON.parse(ls) : [];
  });

  useEffect(() => {
    getDocs(collection(db, 'ledgers')).then(snap => {
      const data = snap.docs.map(d => d.data());
      if (data.length > 0) setLedgers(data);
    }).catch(console.error);
  }, []);


  // Filter tax invoices by project too
  const projectTaxInvoices = taxInvoices;
  const saveLedger = async (ledger) => {
    const updated = ledgers.find(l => l.id === ledger.id)
      ? ledgers.map(l => l.id === ledger.id ? ledger : l)
      : [ledger, ...ledgers];
    setLedgers(updated);
    localStorage.setItem('ledgers', JSON.stringify(updated));
    try { await setDoc(fsDoc(db, 'ledgers', String(ledger.id)), ledger); }
    catch (err) { console.error(err); }
  };

  const deleteLedger = async (id) => {
    if (!window.confirm("Delete this ledger account?")) return;
    const updated = ledgers.filter(l => l.id !== id);
    setLedgers(updated);
    localStorage.setItem('ledgers', JSON.stringify(updated));
    try { await deleteDoc(fsDoc(db, 'ledgers', String(id))); }
    catch (err) { console.error(err); }
  };

  const saveInvoice = async (inv) => {
    const updated = invoices.find(x => x.id === inv.id)
      ? invoices.map(x => x.id === inv.id ? inv : x)
      : [inv, ...invoices];
    setInvoices(updated);
    localStorage.setItem("invoices", JSON.stringify(updated));
    try { await setDoc(fsDoc(db, "invoices", String(inv.id)), inv); }
    catch (e) { console.error(e); }
  };

 const saveTaxInvoice = (inv) => {
  const isEdit = taxInvoices.find(x => x.id === inv.id);
  const updated = isEdit
    ? taxInvoices.map(x => x.id === inv.id ? inv : x)
    : [inv, ...taxInvoices];
  setTaxInvoices(updated);
};

 const deleteTaxInvoice = (id) => {
  if (!window.confirm("Delete this tax invoice?")) return;
  const updated = taxInvoices.filter(x => x.id !== id);
  setTaxInvoices(updated);
};

  // Use projectInvoices for counting to avoid duplicate numbers per project
  const getNextInvoiceNo = (projectCode) => {
    const existing = projectInvoices.filter(inv => inv.projectCode === projectCode);
    const next = 174 + existing.length;
    return `PCS/${projectCode}/${next}/${FINANCIAL_YEAR}`;
  };

  const getNextTaxInvoiceNo = (projectCode) => {
    const filtered = projectTaxInvoices.filter(i => i.projectCode === projectCode);
    const next = filtered.length + 1;
    return `TAX/PCS/${projectCode}/${String(next).padStart(3, "0")}/${FINANCIAL_YEAR}`;
  };

  // Tag invoice with project info
  const tagInvoice = (inv) => ({
    ...inv,
    projectId: currentProject?.id || inv.projectId || "",
    projectCode: inv.projectCode || currentProject?.projectCode || "",
  });

  const totalBilled = projectInvoices.reduce((s, inv) => s + (inv.totalAmount || 0), 0);
  const thisMonth = projectInvoices.filter(inv => inv.invoiceDate?.startsWith(new Date().toISOString().slice(0, 7)));
  const totalTaxBilled = projectTaxInvoices.reduce((s, i) => s + (i.totalAmount || 0), 0);

  const exportTaxInvoiceToExcel = async (inv) => {
    
    const wb = XLSX.utils.book_new();
    const headerData = [
      ["PERMATECH CONCRETE SOLUTIONS"],
      ["18, Divya Darshan, Mount Mary Steps, Bandra (W), Mumbai - 400 050."],
      ["TAX INVOICE"],
      [""],
      ["Invoice No.", inv.invoiceNo, "Invoice Date", inv.invoiceDate],
      ["Client Name", inv.clientName, "Running Bill No.", inv.runningBillNo],
      ["Client Address", inv.clientAddress],
      ["Site Address", inv.siteAddress],
      ["GSTIN", inv.clientGSTIN],
      [""],
      inv.proformaRef ? [`This invoice raised against the Proforma Invoice : ${inv.proformaRef}, Dt. ${inv.proformaDate ? new Date(inv.proformaDate).toLocaleDateString("en-IN") : "—"}`] : [],
      [""],
      ["SR.", "Particulars", "Description", "Unit", "Qty", "Rate (₹)", "Amount (₹)"],
      ...(inv.items || []).map((item, i) => [i + 1, item.particulars || "", item.description || "", item.unit || "", Number(item.qty) || 0, Number(item.rate) || 0, Math.round((Number(item.qty) || 0) * (Number(item.rate) || 0) * 100) / 100]),
      [""],
      ["", "", "", "", "", "Invoice Amount", inv.invoiceAmount || 0],
      ["", "", "", "", "", `CGST @ ${inv.cgst}%`, inv.cgstAmount || 0],
      ["", "", "", "", "", `SGST @ ${inv.sgst}%`, inv.sgstAmount || 0],
      ["", "", "", "", "", "Round Off", inv.roundOff || 0],
      ["", "", "", "", "", "TOTAL AMOUNT", inv.totalAmount || 0],
      [""],
      ["Bank: Cosmos Bank, Branch: Bandra (W) | A/c: 04360010198 | IFSC: COSB0000043"],
    ].filter(row => row.length > 0);

    const ws = XLSX.utils.aoa_to_sheet(headerData);
    ws["!cols"] = [{ wch: 6 }, { wch: 30 }, { wch: 20 }, { wch: 10 }, { wch: 10 }, { wch: 15 }, { wch: 15 }];
    XLSX.utils.book_append_sheet(wb, ws, "Tax Invoice");
    XLSX.writeFile(wb, `TaxInvoice_${inv.invoiceNo?.replace(/\//g, "_") || "export"}_${inv.invoiceDate}.xlsx`);
  };

  const exportInvoiceToExcel = async (inv) => {
    
    const wb = XLSX.utils.book_new();
    const headerData = [
      ["PERMATECH CONCRETE SOLUTIONS"],
      ["18, Divya Darshan, Mount Mary Steps, Bandra (W), Mumbai - 400 050."],
      [""],
      ["Invoice No.", inv.invoiceNo, "Invoice Date", inv.invoiceDate],
      ["Client Name", inv.clientName, "Running Bill No.", inv.runningBillNo],
      ["Client Address", inv.clientAddress],
      ["Site Address", inv.siteAddress],
      [""],
      ["SR.", "Particulars", "Description", "Unit", "Qty", "Rate (₹)", "Amount (₹)"],
      ...(inv.items || []).map((item, i) => [i + 1, item.particulars || "", item.description || "", item.unit || "", Number(item.qty) || 0, Number(item.rate) || 0, Math.round((Number(item.qty) || 0) * (Number(item.rate) || 0) * 100) / 100]),
      [""],
      ["", "", "", "", "", "Invoice Amount", inv.invoiceAmount || 0],
      ["", "", "", "", "", `CGST @ ${inv.cgst}%`, inv.cgstAmount || 0],
      ["", "", "", "", "", `SGST @ ${inv.sgst}%`, inv.sgstAmount || 0],
      ["", "", "", "", "", "Round Off", inv.roundOff || 0],
      ["", "", "", "", "", "TOTAL AMOUNT", inv.totalAmount || 0],
    ];
    const ws = XLSX.utils.aoa_to_sheet(headerData);
    ws["!cols"] = [{ wch: 6 }, { wch: 30 }, { wch: 20 }, { wch: 10 }, { wch: 10 }, { wch: 15 }, { wch: 15 }];
    XLSX.utils.book_append_sheet(wb, ws, "Invoice");
    XLSX.writeFile(wb, `Invoice_${inv.invoiceNo?.replace(/\//g, "_") || "export"}_${inv.invoiceDate}.xlsx`);
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Finance</div>
          <h2 style={{ color: theme.text, fontSize: 26, fontWeight: 800, margin: 0 }}>Billing & Invoicing</h2>
          <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>
            {projectInvoices.length} proforma · {projectTaxInvoices.length} tax invoices
            {currentProject && <span style={{ color: theme.accent, fontWeight: 600 }}> · {currentProject.name}</span>}
          </div>
        </div>
        {billingTab === "invoices" && (
          <div style={{ display: "flex", gap: 10 }}>
            <Btn variant="ghost" onClick={() => setModal("boqInvoice")}>📋 Invoice from BOQ</Btn>
            <Btn onClick={() => setModal("create")}>+ New Proforma</Btn>
          </div>
        )}
        {billingTab === "taxinvoices" && (
          <Btn onClick={() => setModal("createTax")}>+ New Tax Invoice</Btn>
        )}
      </div>

      <Tabs active={billingTab} onChange={setBillingTab} tabs={[
        { id: "invoices", label: `🧾 Proforma Invoice (${projectInvoices.length})` },
        { id: "taxinvoices", label: `🧾 Tax Invoice (${projectTaxInvoices.length})` },
        { id: "ledger", label: `📒 Project Ledger (${ledgers.length})` },
        { id: "summary", label: `📋 Abstract Summary` },
      ]} />

      {/* ---- PROFORMA TAB ---- */}
      {billingTab === "invoices" && (
        <div>
          <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
            <StatCard label="Total Invoices" value={projectInvoices.length} color={theme.blue} icon="🧾" />
            <StatCard label="This Month" value={thisMonth.length} color={theme.green} icon="📅" />
            <StatCard label="Total Billed" value={fmt(totalBilled)} color={theme.accent} icon="💰" />
          </div>

          {projectInvoices.length === 0 ? (
            <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
              <div style={{ fontSize: 36, marginBottom: 10 }}>🧾</div>
              <div style={{ color: theme.muted, fontSize: 14 }}>No invoices yet for this project.</div>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {projectInvoices.map(inv => (
                <div key={inv.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
                      <span style={{ color: theme.accent, fontWeight: 800, fontSize: 14 }}>{inv.invoiceNo}</span>
                      <span style={{ background: theme.blue + "22", color: theme.blue, borderRadius: 5, padding: "1px 8px", fontSize: 10, fontWeight: 700 }}>PROFORMA</span>
                      {inv.runningBillNo && <span style={{ background: theme.purple + "22", color: theme.purple, borderRadius: 5, padding: "1px 8px", fontSize: 10, fontWeight: 700 }}>RA #{inv.runningBillNo}</span>}
                    </div>
                    <div style={{ color: theme.muted, fontSize: 12 }}>📅 {inv.invoiceDate} · 🏗️ {inv.clientName}</div>
                    <div style={{ color: theme.faint, fontSize: 11, marginTop: 2 }}>Total: <span style={{ color: theme.green, fontWeight: 700 }}>₹{inv.totalAmount?.toLocaleString("en-IN")}</span> · {inv.subName}</div>
                  </div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Btn small variant="ghost" onClick={() => setViewInvoice(inv)}>👁 View</Btn>
                    <Btn small variant="ghost" onClick={() => setEditInvoice(inv)}>✏️ Edit</Btn>
                    <Btn small variant="blue" onClick={() => { setViewInvoice(inv); setTimeout(() => window.print(), 300); }}>🖨 Print</Btn>
                    <Btn small variant="ghost" onClick={() => exportInvoiceToExcel(inv)}>📥 Excel</Btn>
                    <Btn small variant="danger" onClick={async () => {
                      if (!window.confirm(`Delete invoice ${inv.invoiceNo}?`)) return;
                      const updated = invoices.filter(i => i.id !== inv.id);
                      setInvoices(updated);
                      localStorage.setItem("invoices", JSON.stringify(updated));
                      try { await deleteDoc(fsDoc(db, "invoices", String(inv.id))); } catch (e) { console.error(e); }
                    }}>🗑</Btn>
                  </div>
                </div>
              ))}
            </div>
          )}

          {modal === "boqInvoice" && (
            <BOQInvoiceModal
              project={projects?.[0]}
              getNextInvoiceNo={getNextInvoiceNo}
              onClose={() => setModal(null)}

              onSave={inv => {
                const tagged = tagInvoice(inv);
                
                saveInvoice(tagged);
                setModal(null);
              }}
            />
          )}
          {modal === "create" && (
            <CreateInvoiceModal
              getNextInvoiceNo={getNextInvoiceNo}
              onClose={() => setModal(null)}
              onSave={inv => {
                const tagged = tagInvoice(inv);
                
                saveInvoice(tagged);
                setModal(null);
                setViewInvoice(tagged);
              }}
            />
          )}
          {editInvoice && (
            <CreateInvoiceModal
              getNextInvoiceNo={getNextInvoiceNo}
              existing={editInvoice}
              onClose={() => setEditInvoice(null)}
              onSave={inv => {
                const updated = tagInvoice({ ...inv, id: editInvoice.id });
                
                saveInvoice(updated);
                setEditInvoice(null);
                setViewInvoice(updated);
              }}
            />
          )}
          {viewInvoice && <InvoicePreviewModal invoice={viewInvoice} onClose={() => setViewInvoice(null)} />}
        </div>
      )}

      {/* ---- TAX INVOICE TAB ---- */}
      {billingTab === "taxinvoices" && (
        <div>
          <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
            <StatCard label="Tax Invoices" value={projectTaxInvoices.length} color={theme.blue} icon="🧾" />
            <StatCard label="Total Billed" value={fmt(totalTaxBilled)} color={theme.accent} icon="💰" />
          </div>

          {projectTaxInvoices.length === 0 ? (
            <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
              <div style={{ fontSize: 36, marginBottom: 10 }}>🧾</div>
              <div style={{ color: theme.muted, fontSize: 14 }}>No tax invoices yet. Click "+ New Tax Invoice" to create one.</div>
            </div>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              {projectTaxInvoices.map(inv => (
                <div key={inv.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
                  <div>
                    <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
                      <span style={{ color: theme.accent, fontWeight: 800, fontSize: 14 }}>{inv.invoiceNo}</span>
                      <span style={{ background: theme.green + "22", color: theme.green, borderRadius: 5, padding: "1px 8px", fontSize: 10, fontWeight: 700 }}>TAX INVOICE</span>
                      {inv.runningBillNo && <span style={{ background: theme.purple + "22", color: theme.purple, borderRadius: 5, padding: "1px 8px", fontSize: 10, fontWeight: 700 }}>RA #{inv.runningBillNo}</span>}
                    </div>
                    <div style={{ color: theme.muted, fontSize: 12 }}>📅 {inv.invoiceDate} · 🏗️ {inv.clientName}</div>
                    <div style={{ color: theme.faint, fontSize: 11, marginTop: 2 }}>
                      Ref: <span style={{ color: theme.blue, fontWeight: 600 }}>{inv.proformaRef || "—"}</span> ·
                      Total: <span style={{ color: theme.green, fontWeight: 700 }}>₹{inv.totalAmount?.toLocaleString("en-IN")}</span>
                    </div>
                  </div>
                  <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Btn small variant="ghost" onClick={() => setViewTaxInvoice(inv)}>👁 View</Btn>
                    <Btn small variant="ghost" onClick={() => setEditTaxInvoice(inv)}>✏️ Edit</Btn>
                    <Btn small variant="blue" onClick={() => { setViewTaxInvoice(inv); setTimeout(() => window.print(), 300); }}>🖨 Print</Btn>
                    <Btn small variant="ghost" onClick={() => exportTaxInvoiceToExcel(inv)}>📥 Excel</Btn>
                    <Btn small variant="danger" onClick={() => deleteTaxInvoice(inv.id)}>🗑</Btn>
                  </div>
                </div>
              ))}
            </div>
          )}

          {modal === "createTax" && (
            <CreateTaxInvoiceModal
              getNextTaxInvoiceNo={getNextTaxInvoiceNo}
              proformaInvoices={projectInvoices}
              onClose={() => setModal(null)}
              onSave={inv => {
                const tagged = tagInvoice(inv);
                saveTaxInvoice(tagged);
                setModal(null);
                setViewTaxInvoice(tagged);
              }}
            />
          )}
          {editTaxInvoice && (
            <CreateTaxInvoiceModal
              getNextTaxInvoiceNo={getNextTaxInvoiceNo}
              proformaInvoices={projectInvoices}
              existing={editTaxInvoice}
              onClose={() => setEditTaxInvoice(null)}
              onSave={inv => {
                const updated = tagInvoice({ ...inv, id: editTaxInvoice.id });
                saveTaxInvoice(updated);
                setEditTaxInvoice(null);
                setViewTaxInvoice(updated);
              }}
            />
          )}
          {viewTaxInvoice && (
            <TaxInvoicePreviewModal
              invoice={viewTaxInvoice}
              onClose={() => setViewTaxInvoice(null)}
            />
          )}
        </div>
      )}

      {billingTab === "summary" && <AbstractSummary invoices={projectInvoices} projects={projects} />}
      {billingTab === "ledger" && <LedgerTab ledgers={ledgers} onSave={saveLedger} onDelete={deleteLedger} />}
    </div>
  );
}

function CreateInvoiceModal({ getNextInvoiceNo, onClose, onSave, existing }) {
  const [projectCode, setProjectCode] = useState(existing?.projectCode || "RR");
const [f, setF] = useState({
  clientName: existing?.clientName || "",
  clientAddress: existing?.clientAddress || "",
  clientGSTIN: existing?.clientGSTIN || "",
  siteAddress: existing?.siteAddress || "",
  invoiceDate: existing?.invoiceDate || new Date().toISOString().slice(0, 10),
  woRef: existing?.woRef || "",
  woDate: existing?.woDate || "",
  runningBillNo: existing?.runningBillNo || "1",
  sacCode: existing?.sacCode || "995453",
  subName: existing?.subName || "",
  cgst: existing?.cgst || 9,
  sgst: existing?.sgst || 9,
});
  const [items, setItems] = useState(existing?.items || [{ particulars: "", description: "", unit: "", qty: "", rate: "" }]);
  const s = k => v => setF(p => ({ ...p, [k]: v }));

  const [editableInvoiceNo, setEditableInvoiceNo] = useState(existing?.invoiceNo || getNextInvoiceNo(projectCode));

  // Calculations
  const invoiceAmount = items.reduce((sum, item) => sum + ((Number(item.qty) || 0) * (Number(item.rate) || 0)), 0);
  const cgstAmount = invoiceAmount * (Number(f.cgst) || 0) / 100;
  const sgstAmount = invoiceAmount * (Number(f.sgst) || 0) / 100;
  const billAmount = invoiceAmount + cgstAmount + sgstAmount;
  const roundOff = Math.round(billAmount) - billAmount;
  const totalAmount = Math.round(billAmount);

  const inputStyle = { width: "100%", background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 12, outline: "none", boxSizing: "border-box" };
  const labelStyle = { color: theme.muted, fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 3 };

  return (
    <Modal title={existing ? "✏️ Edit Invoice" : "🧾 Create Proforma Invoice"} onClose={onClose} width={740}>

      {/* Invoice No + Project Code */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 }}>
       <div style={{ background: theme.accent + "11", border: `1px solid ${theme.accent}33`, borderRadius: 8, padding: "10px 12px" }}>
  <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase", marginBottom: 4 }}>Invoice No. (Editable)</div>
  <input value={editableInvoiceNo} onChange={e => setEditableInvoiceNo(e.target.value)}
    style={{ background: "transparent", border: "none", borderBottom: `1px solid ${theme.accent}44`, color: theme.accent, fontWeight: 800, fontSize: 13, outline: "none", width: "100%" }} />
</div>
        <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 8, padding: "10px 12px" }}>
          <div style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase", marginBottom: 4 }}>Project Code</div>
          <input value={projectCode} onChange={e => setProjectCode(e.target.value.toUpperCase())} style={{ ...inputStyle, padding: "3px 8px" }} placeholder="e.g. RR" />
        </div>
        <div>
          <label style={labelStyle}>Invoice Date</label>
          <input type="date" value={f.invoiceDate} onChange={e => s("invoiceDate")(e.target.value)} style={inputStyle} />
        </div>
      </div>

      {/* Client Details */}
      <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "12px 14px", marginBottom: 12 }}>
        <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, marginBottom: 10 }}>👤 Client Details</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
          <div>
            <label style={labelStyle}>Client Name</label>
            <input value={f.clientName} onChange={e => s("clientName")(e.target.value)} style={inputStyle} />
          </div>
          <div>
            <label style={labelStyle}>Client GSTIN</label>
            <input value={f.clientGSTIN} onChange={e => s("clientGSTIN")(e.target.value)} style={inputStyle} />
          </div>
        </div>
        <div style={{ marginBottom: 10 }}>
          <label style={labelStyle}>Client Address</label>
          <input value={f.clientAddress} onChange={e => s("clientAddress")(e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Site Address</label>
          <input value={f.siteAddress} onChange={e => s("siteAddress")(e.target.value)} style={inputStyle} />
        </div>
      </div>

      {/* Invoice Meta */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr 1fr", gap: 10, marginBottom: 12 }}>
        <div>
          <label style={labelStyle}>WO Ref</label>
          <input value={f.woRef} onChange={e => s("woRef")(e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>WO Date</label>
          <input value={f.woDate} onChange={e => s("woDate")(e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>Running Bill No.</label>
          <input value={f.runningBillNo} onChange={e => s("runningBillNo")(e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>SAC Code</label>
          <input value={f.sacCode} onChange={e => s("sacCode")(e.target.value)} style={inputStyle} />
        </div>
        <div>
          <label style={labelStyle}>SUB Name</label>
          <input value={f.subName} onChange={e => s("subName")(e.target.value)} style={inputStyle} />
        </div>
      </div>

      {/* Items */}
      <div style={{ marginBottom: 14 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <label style={{ ...labelStyle, marginBottom: 0 }}>Items</label>
          <button onClick={() => setItems(is => [...is, { particulars: "", description: "", unit: "", qty: "", rate: "" }])}
            style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 6, width: 26, height: 26, fontSize: 16, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", fontWeight: 700 }}>+</button>
        </div>

        {/* Header */}
        <div style={{ display: "grid", gridTemplateColumns: "24px 2fr 1fr 80px 80px 90px 24px", gap: 6, marginBottom: 5 }}>
          {["Sr.", "Particulars", "Description", "Unit", "Qty", "Rate ₹", ""].map(h => (
            <div key={h} style={{ color: theme.faint, fontSize: 10, textTransform: "uppercase", fontWeight: 600 }}>{h}</div>
          ))}
        </div>

        {items.map((item, i) => (
          <div key={i} style={{ display: "grid", gridTemplateColumns: "24px 2fr 1fr 80px 80px 90px 24px", gap: 6, marginBottom: 8, alignItems: "center" }}>
            <div style={{ color: theme.faint, fontSize: 11, textAlign: "center" }}>{i + 1}</div>
            <div>
              <input
                list={`inv-product-${i}`}
                value={item.particulars || ""}
                onChange={e => {
                  const product = Object.values(MATERIAL_LIST).flat().find(p => p.name === e.target.value);
                  setItems(is => is.map((x, j) => j === i ? { ...x, particulars: e.target.value, unit: product?.unit || x.unit, rate: product?.rate || x.rate } : x));
                }}
                style={inputStyle}
                placeholder="Product name"
              />
              <datalist id={`inv-product-${i}`}>
                {Object.values(MATERIAL_LIST).flat().map(p => <option key={p.name} value={p.name} />)}
              </datalist>
            </div>
            <input value={item.description || ""} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, description: e.target.value } : x))}
              style={{ ...inputStyle, fontSize: 11, color: theme.muted, fontStyle: "italic" }} placeholder="Note / description" />
            <input value={item.unit || ""} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, unit: e.target.value } : x))}
              style={inputStyle} placeholder="Kg" />
            <input type="number" value={item.qty || ""} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, qty: e.target.value } : x))}
              style={inputStyle} placeholder="0" />
            <input type="number" value={item.rate || ""} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, rate: e.target.value } : x))}
              style={{ ...inputStyle, color: theme.accent, fontWeight: 600 }} placeholder="0" />
            <button onClick={() => setItems(is => is.filter((_, j) => j !== i))}
              style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
          </div>
        ))}
      </div>

      {/* GST + Summary */}
      <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "12px 14px", marginBottom: 14 }}>
        <div style={{ display: "flex", gap: 10, marginBottom: 10 }}>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>CGST %</label>
            <input type="number" value={f.cgst} onChange={e => s("cgst")(e.target.value)} style={inputStyle} />
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>SGST %</label>
            <input type="number" value={f.sgst} onChange={e => s("sgst")(e.target.value)} style={inputStyle} />
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
          {[
            ["Invoice Amount", invoiceAmount, theme.text],
            [`CGST @ ${f.cgst}%`, cgstAmount, theme.muted],
            [`SGST @ ${f.sgst}%`, sgstAmount, theme.muted],
            ["Bill Amount", billAmount, theme.text],
            ["Round Off", roundOff, theme.faint],
            ["Total Amount", totalAmount, theme.green],
          ].map(([label, val, color]) => (
            <div key={label} style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: theme.muted, fontSize: 12 }}>{label}</span>
              <span style={{ color, fontWeight: label === "Total Amount" ? 800 : 500, fontSize: label === "Total Amount" ? 14 : 12 }}>
                ₹{Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => {
          const filled = items.filter(i => i.particulars?.trim());
          if (!f.clientName || filled.length === 0) return alert("Please fill client name and at least one item.");
         onSave({ id: existing?.id || Date.now(), invoiceNo: editableInvoiceNo, projectCode, projectId: existing?.projectId || "", ...f, items: filled, invoiceAmount, cgstAmount, sgstAmount, billAmount, roundOff, totalAmount });
        }}>{existing ? "Save Changes" : "Create & Preview"}</Btn>
      </div>
    </Modal>
  );
}

function numberToWords(num) {
  const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
  const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
  if (num === 0) return "Zero";
  const convert = (n) => {
    if (n < 20) return ones[n];
    if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
    if (n < 1000) return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + convert(n % 100) : "");
    if (n < 100000) return convert(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + convert(n % 1000) : "");
    if (n < 10000000) return convert(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + convert(n % 100000) : "");
    return convert(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + convert(n % 10000000) : "");
  };
  return convert(Math.floor(num)) + " Only";
}

function InvoicePreviewModal({ invoice, onClose }) {
  return (
    <div style={{ position: "fixed", inset: 0, background: "#000000cc", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
     <style>{`
  @media print {
    body * { visibility: hidden !important; }
    #invoice-print, #invoice-print * { visibility: visible !important; }
    #invoice-print {
      position: absolute !important;
      top: 0 !important; left: 0 !important;
      width: 100% !important;
      padding: 16px 20px !important;
      font-size: 11px !important;
    }
    .no-print { display: none !important; }
    @page { margin: 0; size: A4; }
  }
`}</style>
      <div style={{ background: "#fff", borderRadius: 12, width: "100%", maxWidth: 800, maxHeight: "92vh", overflow: "auto" }}>

        {/* Action Bar */}
        <div className="no-print" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 18px", borderBottom: "1px solid #e2e8f0", background: "#f8fafc" }}>
          <span style={{ fontWeight: 700, color: "#1a202c", fontSize: 14 }}>🧾 {invoice.invoiceNo}</span>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => window.print()} style={{ background: "#1a365d", color: "#fff", border: "none", borderRadius: 7, padding: "7px 16px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>🖨 Print / Download PDF</button>
            <button onClick={onClose} style={{ background: "#f1f5f9", border: "1px solid #e2e8f0", color: "#64748b", borderRadius: 7, padding: "7px 14px", fontSize: 12, cursor: "pointer" }}>✕ Close</button>
          </div>
        </div>

        {/* Print Area */}
        <div id="invoice-print" style={{ padding: "16px 22px", fontFamily: "Arial, sans-serif", fontSize: 11, color: "#000", background: "#fff" }}>

          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid #1a365d", paddingBottom: 12, marginBottom: 12 }}>
            <div>
              <div style={{ fontWeight: 900, fontSize: 17, color: "#1a365d", letterSpacing: 1 }}>PERMATECH CONCRETE SOLUTIONS</div>
              <div style={{ fontSize: 11, color: "#555", marginTop: 3 }}>18, Divya Darshan, Mount Mary Steps, Bandra (W), Mumbai – 400 050</div>
              <div style={{ fontSize: 11, color: "#555" }}>Mobile: +91 7738131631 &nbsp;|&nbsp; Email: info@permatech.in</div>
              <div style={{ fontSize: 10, color: "#777", marginTop: 2 }}>PAN: AAJFP3195N &nbsp;|&nbsp; GSTIN: 27AAJFP3195N1ZJ &nbsp;|&nbsp; UDYAM-MH-18-0450938</div>
            </div>
            <div>
              <div style={{ fontWeight: 900, fontSize: 15, letterSpacing: 2, border: "2px solid #1a365d", color: "#1a365d", padding: "8px 20px", textAlign: "center" }}>PROFORMA INVOICE</div>
            </div>
          </div>

          {/* Client + Invoice Info */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", border: "1px solid #000", marginBottom: 12 }}>
            <div style={{ borderRight: "1px solid #000", padding: "10px 12px" }}>
              <div style={{ fontSize: 10, color: "#666", marginBottom: 3 }}>To,</div>
              <div style={{ fontWeight: 800, fontSize: 13 }}>{invoice.clientName}</div>
              <div style={{ fontSize: 11, color: "#444", marginTop: 4, lineHeight: 1.5 }}>{invoice.clientAddress}</div>
              <div style={{ fontSize: 10, color: "#666", marginTop: 4 }}>GSTIN: {invoice.clientGSTIN}</div>
              <div style={{ fontSize: 10, color: "#666", marginTop: 6, borderTop: "1px dashed #ccc", paddingTop: 6 }}>
                <span style={{ fontWeight: 600 }}>Site Address:</span> {invoice.siteAddress}
              </div>
            </div>
            <div style={{ fontSize: 11 }}>
              {[
                ["Invoice No.", invoice.invoiceNo],
                ["Invoice Date", invoice.invoiceDate?.split("-").reverse().join(".")],
                ["WO Ref / Date", `${invoice.woRef || "—"} / ${invoice.woDate || "—"}`],
                ["Running Bill No.", invoice.runningBillNo],
                ["SAC Code", invoice.sacCode],
                ["Sub Name", invoice.subName],
              ].map(([label, value]) => (
                <div key={label} style={{ display: "grid", gridTemplateColumns: "120px 1fr", borderBottom: "1px solid #ddd", padding: "5px 10px", gap: 6 }}>
                  <span style={{ fontWeight: 600, color: "#444" }}>{label}:</span>
                  <span style={{ color: "#222" }}>{value}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Items Table */}
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 0 }}>
            <thead>
              <tr style={{ background: "#f1f5f9" }}>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontWeight: 700, fontSize: 11, width: 40 }}>SR.</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "left", fontWeight: 700, fontSize: 11 }}>PARTICULARS</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontWeight: 700, fontSize: 11, width: 50 }}>UNIT</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontWeight: 700, fontSize: 11, width: 65 }}>QTY</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "center", fontWeight: 700, fontSize: 11, width: 90 }}>RATE</th>
                <th style={{ border: "1px solid #000", padding: "7px 8px", textAlign: "right", fontWeight: 700, fontSize: 11, width: 100 }}>AMOUNT</th>
              </tr>
            </thead>
            <tbody>
              {invoice.items?.map((item, i) => (
                <tr key={i}>
                  <td style={{ border: "1px solid #000", padding: "9px 8px", textAlign: "center", fontSize: 11 }}>{i + 1}</td>
                  <td style={{ border: "1px solid #000", padding: "9px 8px", fontSize: 11 }}>
                    <div style={{ fontWeight: 500 }}>{item.particulars}</div>
                    {item.description && <div style={{ color: "#666", fontSize: 10, marginTop: 2, fontStyle: "italic" }}>({item.description})</div>}
                  </td>
                  <td style={{ border: "1px solid #000", padding: "9px 8px", textAlign: "center", fontSize: 11 }}>{item.unit}</td>
                  <td style={{ border: "1px solid #000", padding: "9px 8px", textAlign: "center", fontSize: 11 }}>{Number(item.qty).toFixed(2)}</td>
                  <td style={{ border: "1px solid #000", padding: "9px 8px", textAlign: "center", fontSize: 11 }}>{Number(item.rate).toLocaleString("en-IN")}</td>
                  <td style={{ border: "1px solid #000", padding: "9px 8px", textAlign: "right", fontSize: 11 }}>{(Number(item.qty) * Number(item.rate)).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
                </tr>
              ))}
              {Array.from({ length: Math.max(0, 3 - (invoice.items?.length || 0)) }).map((_, i) => (
  <tr key={`e-${i}`}>
    {[...Array(6)].map((_, j) => <td key={j} style={{ border: "1px solid #000", padding: "10px 8px" }}></td>)}
  </tr>
))}
            </tbody>
          </table>

          {/* Totals */}
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 0 }}>
            <tbody>
              {[
                ["Invoice Amount", invoice.invoiceAmount, false],
                [`Add: CGST @ ${invoice.cgst}%`, invoice.cgstAmount, false],
                [`Add: SGST @ ${invoice.sgst}%`, invoice.sgstAmount, false],
                ["Bill Amount", invoice.billAmount, false],
                ["Round Off", Math.abs(invoice.roundOff) < 0.01 ? 0 : invoice.roundOff, false],
                ["Total Amount", invoice.totalAmount, true],
              ].map(([label, val, bold]) => (
                <tr key={label}>
                  <td colSpan={5} style={{ border: "1px solid #000", padding: "5px 10px", textAlign: "right", fontWeight: bold ? 800 : 500, fontSize: bold ? 13 : 11, background: bold ? "#f1f5f9" : "#fff" }}>{label}</td>
                  <td style={{ border: "1px solid #000", padding: "5px 10px", textAlign: "right", fontWeight: bold ? 800 : 500, fontSize: bold ? 13 : 11, minWidth: 100, background: bold ? "#f1f5f9" : "#fff" }}>
                    {Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Amount in Words */}
          <div style={{ border: "1px solid #000", borderTop: "none", padding: "7px 10px", display: "flex", gap: 8, marginBottom: 12 }}>
            <span style={{ fontWeight: 700, fontSize: 11, whiteSpace: "nowrap" }}>AMOUNT IN WORDS:</span>
            <span style={{ fontSize: 11 }}>Rupees {numberToWords(invoice.totalAmount)} Only.</span>
          </div>

          {/* Bank Details */}
          <div style={{ border: "1px solid #000", padding: "8px 10px", marginBottom: 16, fontSize: 11 }}>
            <span style={{ fontWeight: 700, color: "#1a365d" }}>Bank Name: </span>Cosmos Bank, Branch: Bandra (W) &nbsp;|&nbsp;
            <span style={{ fontWeight: 700, color: "#1a365d" }}>A/c No.: </span>04360010198 &nbsp;|&nbsp;
            <span style={{ fontWeight: 700, color: "#1a365d" }}>IFSC: </span>COSB0000043
          </div>

          {/* Signatures — only once */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginTop: 10 }}>
            <div>
              <div style={{ borderTop: "1px solid #000", paddingTop: 6, marginTop: 30, fontSize: 11 }}>Receiver's Stamp &amp; Signature</div>
              <div style={{ fontSize: 10, color: "#666", marginTop: 2 }}>For Client</div>
            </div>
            <div style={{ textAlign: "right" }}>
              <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 30 }}>For M/s. Permatech Concrete Solutions</div>
              <div style={{ borderTop: "1px solid #000", paddingTop: 6, fontSize: 11, display: "inline-block", minWidth: 180 }}>Authorised Signatory</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
function MaterialBalanceTab({ project, onUpdate, challans = [] }) {
  const today = new Date().toISOString().slice(0, 10);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState(today);

  // Auto-use all project challans — no manual linking needed
  const projectChallans = challans.filter(c =>
    c.projectId === project.id ||
    c.projectCode === project.projectCode ||
    (!c.projectId && !c.projectCode)
  );

  // Build material list from all project challans automatically
  const materialMap = {};
  projectChallans.forEach(challan => {
    (challan.items || []).forEach(item => {
      const key = item.particulars;
      if (!key) return;
      if (!materialMap[key]) {
        materialMap[key] = { name: key, unit: item.unit || "", totalReceived: 0, challanRefs: [] };
      }
      const qty = parseFloat(item.qty) || 0;
      materialMap[key].totalReceived += qty;
      materialMap[key].challanRefs.push(`${challan.challanNo} (${item.qty} ${item.unit})`);
    });
  });
  const materials = Object.values(materialMap);

  // Auto-fetch material usage from Daily Progress Reports within date range
  const getAutoUsed = (materialName) => {
    const logs = project.logs || [];
    const stripName = (str) => str.trim().toLowerCase()
      .replace(/[-_/\\().,:;]+/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    const normalizedTarget = stripName(materialName);
    return logs
      .filter(log => {
        if (fromDate && log.date < fromDate) return false;
        if (toDate && log.date > toDate) return false;
        return true;
      })
      .reduce((sum, log) => {
        const matchedMats = (log.materials || []).filter(m => {
          if (!m.name || !m.qty) return false;
          const normalizedSource = stripName(m.name);
          return normalizedSource === normalizedTarget ||
            normalizedSource.includes(normalizedTarget) ||
            normalizedTarget.includes(normalizedSource);
        });
        const total = matchedMats.reduce((s, m) => s + (parseFloat(m.qty) || 0), 0);
        return sum + total;
      }, 0);
  };

  const cellStyle = (color = theme.text) => ({ color, fontSize: 12, padding: "10px 10px", textAlign: "center", borderBottom: `1px solid ${theme.border}` });
  const headerStyle = { color: theme.muted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", padding: "10px 10px", textAlign: "center", background: theme.bg, borderBottom: `2px solid ${theme.border}` };
  const labelStyle = { color: theme.muted, fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 3 };
  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 12, outline: "none" };

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 16, flexWrap: "wrap", gap: 10 }}>
        <div>
          <span style={{ color: theme.text, fontWeight: 700, fontSize: 14 }}>⚖️ Material Balance at Site</span>
          <div style={{ color: theme.muted, fontSize: 11, marginTop: 2 }}>
            {materials.length} materials from {projectChallans.length} challan{projectChallans.length !== 1 ? "s" : ""} · auto-synced
          </div>
        </div>
      </div>

      {/* Info Banner */}
      <div style={{ background: theme.green + "11", border: `1px solid ${theme.green}33`, borderRadius: 10, padding: "10px 16px", marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 16 }}>💡</span>
        <span style={{ color: theme.green, fontSize: 12, fontWeight: 600 }}>
          Material balance is auto-calculated from all challans created for this project. No manual linking needed.
        </span>
      </div>

      {/* Challan References */}
      {projectChallans.length > 0 && (
        <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "12px 16px", marginBottom: 16 }}>
          <div style={{ color: theme.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", marginBottom: 8 }}>Challans included</div>
          <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
            {projectChallans.map(c => (
              <span key={c.challanNo} style={{ background: theme.green + "22", border: `1px solid ${theme.green}33`, color: theme.green, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700 }}>
                ✓ {c.challanNo}
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Date Range Filter */}
      {materials.length > 0 && (
        <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "12px 16px", marginBottom: 16, display: "flex", alignItems: "flex-end", gap: 16, flexWrap: "wrap" }}>
          <div>
            <label style={labelStyle}>From Date</label>
            <input type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} style={inp} />
          </div>
          <div>
            <label style={labelStyle}>Up To Date</label>
            <input type="date" value={toDate} onChange={e => setToDate(e.target.value)} style={inp} />
          </div>
          <div style={{ display: "flex", flex: 1, alignItems: "center", gap: 10, flexWrap: "wrap" }}>
            <div style={{ background: theme.accent + "11", border: `1px solid ${theme.accent}33`, borderRadius: 7, padding: "6px 12px" }}>
              <span style={{ color: theme.muted, fontSize: 11 }}>Logs included: </span>
              <span style={{ color: theme.accent, fontWeight: 700, fontSize: 12 }}>
                {(project.logs || []).filter(l => (!fromDate || l.date >= fromDate) && (!toDate || l.date <= toDate)).length} daily reports
              </span>
            </div>
            <Btn small variant="ghost" onClick={() => { setFromDate(""); setToDate(today); }}>Reset</Btn>
          </div>
        </div>
      )}

      {/* No challans yet */}
      {projectChallans.length === 0 && (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 40, textAlign: "center" }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>📋</div>
          <div style={{ color: theme.muted, fontSize: 13 }}>No challans found for this project. Create challans in the Challan tab to see material balance.</div>
        </div>
      )}

      {/* Material Table */}
      {materials.length > 0 && (
        <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "auto", marginBottom: 16 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 700 }}>
            <thead>
              <tr>
                {["SR", "Material", "Unit", "Total Received", "Total Used", "Balance"].map(h => (
                  <th key={h} style={headerStyle}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {materials.map((mat, index) => {
                const used = Math.round(getAutoUsed(mat.name) * 100) / 100;
                const balance = Math.round((mat.totalReceived - used) * 100) / 100;
                const isLow = balance > 0 && balance < mat.totalReceived * 0.2;
                const isEmpty = balance <= 0;
                return (
                  <tr key={mat.name} style={{ background: index % 2 === 0 ? "transparent" : theme.bg + "44" }}>
                    <td style={cellStyle(theme.faint)}>{index + 1}</td>
                    <td style={{ ...cellStyle(theme.text), textAlign: "left", padding: "10px 12px", fontWeight: 600, minWidth: 180 }}>
                      {mat.name}
                      <div style={{ color: theme.faint, fontSize: 10, fontWeight: 400, marginTop: 2 }}>{mat.challanRefs.join(" · ")}</div>
                    </td>
                    <td style={cellStyle(theme.muted)}>{mat.unit}</td>
                    <td style={cellStyle(theme.blue)}>
                      <span style={{ background: theme.blue + "22", borderRadius: 5, padding: "2px 8px" }}>{mat.totalReceived}</span>
                    </td>
                    <td style={cellStyle(theme.orange)}>
                      <span style={{ background: theme.orange + "22", borderRadius: 5, padding: "2px 8px" }}>
                        {used > 0 ? used : "—"}
                      </span>
                    </td>
                    <td style={cellStyle(isEmpty ? theme.red : isLow ? theme.orange : theme.green)}>
                      <span style={{ background: (isEmpty ? theme.red : isLow ? theme.orange : theme.green) + "22", borderRadius: 5, padding: "3px 8px", fontWeight: 700 }}>
                        {balance} {mat.unit} {isEmpty && "⚠️"}{isLow && !isEmpty && "🔶"}
                      </span>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
              <tr style={{ borderTop: `2px solid ${theme.border}`, background: theme.bg }}>
                <td colSpan={3} style={{ ...cellStyle(theme.text), textAlign: "right", fontWeight: 800, fontSize: 13 }}>SUMMARY</td>
                <td style={{ ...cellStyle(theme.blue), fontWeight: 800 }}>
                  {materials.reduce((s, m) => s + m.totalReceived, 0).toFixed(2)}
                </td>
                <td style={{ ...cellStyle(theme.orange), fontWeight: 800 }}>
                  {materials.reduce((s, m) => s + getAutoUsed(m.name), 0).toFixed(2)}
                </td>
                <td style={{ ...cellStyle(theme.green), fontWeight: 800 }}>
                  {materials.reduce((s, m) => {
                    const used = getAutoUsed(m.name);
                    return s + (m.totalReceived - used);
                  }, 0).toFixed(2)}
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      )}

      {/* Daily Logs Used in Range */}
      {materials.length > 0 && (
        <div>
          <div style={{ color: theme.muted, fontSize: 12, fontWeight: 700, textTransform: "uppercase", letterSpacing: 1, marginBottom: 10 }}>
            📋 Daily Reports Used in Calculation
          </div>
          {(project.logs || [])
            .filter(l => (!fromDate || l.date >= fromDate) && (!toDate || l.date <= toDate))
            .filter(l => (l.materials || []).some(m => m.name?.trim() && m.qty))
            .sort((a, b) => b.date.localeCompare(a.date))
            .map(log => (
              <div key={log.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "10px 14px", marginBottom: 8, display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 8 }}>
                <span style={{ color: theme.accent, fontWeight: 700, fontSize: 13 }}>📅 {log.date}</span>
                <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                  {(log.materials || []).filter(m => m.name && m.qty).map((m, i) => (
                    <span key={i} style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, padding: "2px 8px", fontSize: 11, color: theme.text }}>
                      {m.name}: {m.qty} {m.unit}
                    </span>
                  ))}
                </div>
              </div>
            ))}
          {(project.logs || []).filter(l =>
            (!fromDate || l.date >= fromDate) &&
            (!toDate || l.date <= toDate) &&
            (l.materials || []).some(m => m.name && m.qty)
          ).length === 0 && (
            <div style={{ color: theme.faint, fontSize: 12, textAlign: "center", padding: 20 }}>
              No material usage found in selected date range.
            </div>
          )}
        </div>
      )}
    </div>
  );
}

function DailyLogPreviewModal({ log, project, onClose }) {
  const printStyles = `
    @media print {
      body * { visibility: hidden !important; }
      #log-print, #log-print * { visibility: visible !important; }
      #log-print { position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; }
      .no-print { display: none !important; }
    }
  `;

  const tableStyle = { width: "100%", borderCollapse: "collapse", marginBottom: 12 };
  const thStyle = { border: "1px solid #000", padding: "6px 8px", background: "#f1f5f9", fontWeight: 700, fontSize: 11, textAlign: "left" };
  const tdStyle = { border: "1px solid #000", padding: "6px 8px", fontSize: 11 };

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000000cc", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <style>{printStyles}</style>
      <div style={{ background: "#fff", borderRadius: 12, width: "100%", maxWidth: 800, maxHeight: "92vh", overflow: "auto" }}>

        {/* Action Bar */}
        <div className="no-print" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 18px", borderBottom: "1px solid #e2e8f0", background: "#f8fafc" }}>
          <span style={{ fontWeight: 700, color: "#1a202c", fontSize: 14 }}>📝 Daily Progress Report — {log.date}</span>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => window.print()} style={{ background: "#3B82F6", color: "#fff", border: "none", borderRadius: 7, padding: "7px 16px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>🖨 Print / Download PDF</button>
            <button onClick={onClose} style={{ background: "#f1f5f9", border: "1px solid #e2e8f0", color: "#64748b", borderRadius: 7, padding: "7px 14px", fontSize: 12, cursor: "pointer" }}>✕ Close</button>
          </div>
        </div>

        {/* Print Area */}
        <div id="log-print" style={{ padding: "24px 30px", fontFamily: "Arial, sans-serif", color: "#000", background: "#fff" }}>

          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "2px solid #000", paddingBottom: 10, marginBottom: 14 }}>
            <div>
              <div style={{ fontWeight: 900, fontSize: 17, color: "#1a365d", letterSpacing: 1 }}>PERMATECH CONCRETE SOLUTIONS</div>
              <div style={{ fontSize: 11, color: "#555" }}>18, Divya Darshan, Mount Mary Steps, Bandra (W), Mumbai – 400 050</div>
              <div style={{ fontSize: 11, color: "#555" }}>Mobile: +91 7738131631 | Email: info@permatech.in</div>
            </div>
            <div style={{ textAlign: "center", border: "2px solid #1a365d", padding: "6px 16px" }}>
              <div style={{ fontWeight: 900, fontSize: 14, color: "#1a365d", letterSpacing: 2 }}>DAILY PROGRESS REPORT</div>
            </div>
          </div>

          {/* Basic Info */}
          <table style={tableStyle}>
            <tbody>
              <tr>
                <td style={{ ...tdStyle, fontWeight: 700, background: "#f8fafc", width: 150 }}>Date</td>
                <td style={tdStyle}>{log.date}</td>
                <td style={{ ...tdStyle, fontWeight: 700, background: "#f8fafc", width: 150 }}>Site Name</td>
                <td style={tdStyle}>{log.siteName || project.name}</td>
              </tr>
              <tr>
                <td style={{ ...tdStyle, fontWeight: 700, background: "#f8fafc" }}>Work Location</td>
                <td style={tdStyle}>{log.workLocation || "—"}</td>
                <td style={{ ...tdStyle, fontWeight: 700, background: "#f8fafc" }}>Linked Challans</td>
                <td style={tdStyle}>{log.linkedChallans?.join(", ") || "—"}</td>
              </tr>
            </tbody>
          </table>

          {/* Supervisor */}
          <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 6, color: "#1a365d" }}>SUPERVISOR DETAILS</div>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Name</th>
                <th style={thStyle}>In Time</th>
                <th style={thStyle}>Out Time</th>
                <th style={thStyle}>Rate (₹)</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={tdStyle}>{log.supervisor?.name || "—"}</td>
                <td style={tdStyle}>{log.supervisor?.inTime || "—"}</td>
                <td style={tdStyle}>{log.supervisor?.outTime || "—"}</td>
                <td style={tdStyle}>₹{log.supervisor?.rate || 0}</td>
              </tr>
            </tbody>
          </table>

          {/* Labour */}
          {log.labours?.length > 0 && (
            <>
              <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 6, color: "#1a365d" }}>LABOUR DETAILS</div>
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={thStyle}>SR</th>
                    <th style={thStyle}>Name</th>
                    <th style={thStyle}>In Time</th>
                    <th style={thStyle}>Out Time</th>
                    <th style={thStyle}>Rate (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {log.labours.map((l, i) => (
                    <tr key={i}>
                      <td style={tdStyle}>{i + 1}</td>
                      <td style={tdStyle}>{l.name}</td>
                      <td style={tdStyle}>{l.inTime || "—"}</td>
                      <td style={tdStyle}>{l.outTime || "—"}</td>
                      <td style={tdStyle}>₹{l.rate}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          {/* Work Done */}
          {log.workItems?.length > 0 && (
            <>
              <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 6, color: "#1a365d" }}>WORK DONE TODAY</div>
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={thStyle}>SR</th>
                    <th style={thStyle}>Work Description</th>
                    <th style={thStyle}>Area Covered</th>
                  </tr>
                </thead>
                <tbody>
                  {log.workItems.map((w, i) => (
                    <tr key={i}>
                      <td style={tdStyle}>{i + 1}</td>
                      <td style={tdStyle}>{typeof w === "string" ? w : w.description}</td>
                      <td style={tdStyle}>{typeof w === "string" ? "—" : w.area || "—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          {/* Materials */}
          {log.materials?.filter(m => m.name).length > 0 && (
            <>
              <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 6, color: "#1a365d" }}>MATERIAL USED</div>
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={thStyle}>SR</th>
                    <th style={thStyle}>Material</th>
                    <th style={thStyle}>Unit</th>
                    <th style={thStyle}>Coverage</th>
                    <th style={thStyle}>Rate (₹)</th>
                    <th style={thStyle}>Qty Used</th>
                    <th style={thStyle}>Amount (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  {log.materials.filter(m => m.name).map((m, i) => (
                    <tr key={i}>
                      <td style={tdStyle}>{i + 1}</td>
                      <td style={tdStyle}>{m.name}</td>
                      <td style={tdStyle}>{m.unit}</td>
                      <td style={tdStyle}>{m.coverage || "—"}</td>
                      <td style={tdStyle}>₹{m.rate}</td>
                      <td style={tdStyle}>{m.qty}</td>
                      <td style={tdStyle}>₹{(Number(m.qty) * Number(m.rate)).toLocaleString("en-IN")}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </>
          )}

          {/* Cost Summary */}
          <div style={{ fontWeight: 700, fontSize: 12, marginBottom: 6, color: "#1a365d" }}>COST SUMMARY</div>
          <table style={tableStyle}>
            <tbody>
              {[
                ["Supervisor Cost", `₹${log.costs?.supervisor || 0}`],
                ["Labour Cost", `₹${log.costs?.labour || 0}`],
                ["Material Cost", `₹${log.costs?.material || 0}`],
                

                ["Total Cost", `₹${log.costs?.total || 0}`],
              ].map(([label, val], i) => (
                <tr key={label} style={{ background: i === 4 ? "#f1f5f9" : "transparent" }}>
                  <td style={{ ...tdStyle, fontWeight: i === 4 ? 800 : 500, width: 200 }}>{label}</td>
                  <td style={{ ...tdStyle, fontWeight: i === 4 ? 800 : 500, fontSize: i === 4 ? 13 : 11 }}>{val}</td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* Signatures */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 30, marginTop: 30 }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ borderTop: "1px solid #000", paddingTop: 6, marginTop: 30, fontSize: 11 }}>Site Supervisor Signature</div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div style={{ borderTop: "1px solid #000", paddingTop: 6, marginTop: 50, fontSize: 11 }}>Authorised Signatory</div>
              <div style={{ fontSize: 10, color: "#666" }}>For M/s. Permatech Concrete Solutions</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const RATE_TEMPLATES = {

  "IPANEX Crystalline Admix": {
    product: "IPANEX Crystalline Admix",
    unit: "Ltr",
    constant: 4.00,
    rate: 170.00,
    wastage: 5,
    labour: 175.00,
    staffWelfare: 5,
    supervisorWelfare: 5,
    officeExp: 10,
    tools: 3,
    machinery: 3,
    transport: 2,
    mathadi: 1,
    labourCompliance: 5,
    retention: 5,
    rework: 5,
    misc: 3,
    emptyCanDeduction: 10.40,
    contractorProfit: 15,
  },
  "eniroof": {
  product: "eniroof", unit: "kg", constant: 1.50, rate: 185.00,
  hasSecondMaterial: false,
  wastage: 5, labour: 150,
  staffWelfare: 5, supervisorWelfare: 5, officeExp: 10,
  tools: 3, machinery: 3, transport: 2, mathadi: 1,
  labourCompliance: 5, retention: 0, rework: 0, misc: 3,
  emptyCanDeduction: 0, contractorProfit: 45, showSqft: true,
},
  "IPA SLURRY": {
    product: "IPA SLURRY",
    unit: "KG",
     showSqft: true,
    constant: 2.00,
    rate: 95.00,
    wastage: 5,
    labour: 175,
    staffWelfare: 5,
    supervisorWelfare: 5,
    officeExp: 10,
    tools: 3,
    machinery: 3,
    transport: 2,
    mathadi: 1,
    labourCompliance: 5,
    retention: 5,
    rework: 5,
    misc: 3,
    emptyCanDeduction: 0,
    contractorProfit: 15,
  },
  "IPA TRINKWASSERCHLAMME TW": {
    product: "IPA TRINKWASSERCHLAMME TW",
    unit: "KG",
    showSqft: true,
    constant: 2.50,
    rate: 127.00,
    wastage: 5,
    labour: 175,
    staffWelfare: 5,
    supervisorWelfare: 5,
    officeExp: 10,
    tools: 3,
    machinery: 3,
    transport: 2,
    mathadi: 1,
    labourCompliance: 5,
    retention: 5,
    rework: 5,
    misc: 3,
    emptyCanDeduction: 0,
    contractorProfit: 15,
  },
  "WEBAC 155": {
    product: "WEBAC 155",
    unit: "KG",
    constant: 1.00,
    rate: 850.00,
    wastage: 5,
    labour: 175,
    staffWelfare: 5,
    supervisorWelfare: 5,
    officeExp: 10,
    tools: 5,
    machinery: 5,
    transport: 2,
    mathadi: 1,
    labourCompliance: 5,
    retention: 5,
    rework: 5,
    misc: 3,
    emptyCanDeduction: 0,
    contractorProfit: 15,
  },
  "IMPERMAX COLD POLYUREA": {
    product: "IMPERMAX COLD POLYUREA", unit: "KG", constant: 2.00, rate: 380.00,
    product2: "GC Primer Part A + B", unit2: "KG", constant2: 0.30, rate2: 750.00,
    hasSecondMaterial: true,
    wastage: 5, labour: 150,
    staffWelfare: 3, supervisorWelfare: 5, officeExp: 5,
    tools: 3, machinery: 3, transport: 2, mathadi: 1,
    labourCompliance: 5, retention: 3, rework: 5, misc: 5,
    emptyCanDeduction: 0, contractorProfit: 20, showSqft: true,
  },
  "IMPERMAX POLYURETHANE": {
    product: "IMPERMAX POLYURETHANE", unit: "KG", constant: 2.00, rate: 390.00,
    product2: "Humidity Primer Part A + B", unit2: "KG", constant2: 0.30, rate2: 785.00,
    hasSecondMaterial: true,
    wastage: 5, labour: 175,
    staffWelfare: 6, supervisorWelfare: 8, officeExp: 10,
    tools: 3, machinery: 3, transport: 2, mathadi: 1,
    labourCompliance: 10, retention: 3, rework: 5, misc: 3,
    emptyCanDeduction: 0, contractorProfit: 15, showSqft: true,
  },
  "SUPERCAST SW": {
    product: "SUPERCAST SW", unit: "RMT", constant: 1.00, rate: 351.00,
    hasSecondMaterial: false,
    wastage: 5, labour: 175,
    staffWelfare: 5, supervisorWelfare: 5, officeExp: 10,
    tools: 3, machinery: 3, transport: 2, mathadi: 1,
    labourCompliance: 5, retention: 5, rework: 5, misc: 3,
    emptyCanDeduction: 0, contractorProfit: 15, showSqft: true,
  },
};

function RateAnalysisModule() {
  const [savedAnalyses, setSavedAnalyses] = useState([]);
  const [modal, setModal] = useState(false);
  const [viewAnalysis, setViewAnalysis] = useState(null);
  const [editAnalysis, setEditAnalysis] = useState(null);

 useEffect(() => {
  getDocs(collection(db, 'rate_analyses')).then(snap => {
    const data = snap.docs.map(d => d.data());
    if (data.length > 0) setSavedAnalyses(data);
    else {
      const ls = localStorage.getItem("rateAnalyses");
      if (ls) setSavedAnalyses(JSON.parse(ls));
    }
  }).catch(() => {
    const ls = localStorage.getItem("rateAnalyses");
    if (ls) setSavedAnalyses(JSON.parse(ls));
  });
}, []);

 const saveAnalysis = async (analysis) => {
  const newAnalysis = { ...analysis, id: Date.now() };
  await setDoc(fsDoc(db, 'rate_analyses', String(newAnalysis.id)), newAnalysis);
  setSavedAnalyses(prev => [newAnalysis, ...prev]);
  setModal(false);
  setViewAnalysis(newAnalysis);
};

const updateAnalysis = async (analysis) => {
  const updated = { ...analysis, id: editAnalysis.id };
  await setDoc(fsDoc(db, 'rate_analyses', String(updated.id)), updated);
  setSavedAnalyses(prev => prev.map(a => a.id === editAnalysis.id ? updated : a));
  setEditAnalysis(null);
  setViewAnalysis(updated);
};

const deleteAnalysis = async (id) => {
  
  await deleteDoc(fsDoc(db, 'rate_analyses', String(id)));
  setSavedAnalyses(prev => prev.filter(x => x.id !== id));
};
                          
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Cost Management</div>
          <h2 style={{ color: theme.text, fontSize: 26, fontWeight: 800, margin: 0 }}>Rate Analysis</h2>
          <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>{savedAnalyses.length} analyses saved</div>
        </div>
        <Btn onClick={() => setModal(true)}>+ New Analysis</Btn>
      </div>

      {savedAnalyses.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>📊</div>
          <div style={{ color: theme.muted, fontSize: 14 }}>No rate analyses yet. Create your first one.</div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {savedAnalyses.map(a => (
            <div key={a.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
              <div>
                <div style={{ color: theme.text, fontWeight: 800, fontSize: 14, marginBottom: 4 }}>📊 {a.product}</div>
                <div style={{ color: theme.muted, fontSize: 12 }}>Unit: {a.unit} · Constant: {a.constant} · Rate: ₹{a.rate}</div>
                <div style={{ color: theme.green, fontWeight: 700, fontSize: 13, marginTop: 4 }}>Final Rate: ₹{a.finalRate?.toFixed(2)} per {a.unit}</div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <Btn small variant="ghost" onClick={() => setViewAnalysis(a)}>👁 View</Btn>
                <Btn small variant="ghost" onClick={() => setEditAnalysis(a)}>✏️ Edit</Btn>
                <Btn small variant="blue" onClick={() => { setViewAnalysis(a); setTimeout(() => window.print(), 300); }}>🖨 Print</Btn>
                <Btn small variant="danger" onClick={() => {
                  if (window.confirm("Delete this analysis?")) deleteAnalysis(a.id);
                }}>🗑</Btn>
              </div>
            </div>
          ))}
        </div>
      )}

      {modal && <RateAnalysisModal onClose={() => setModal(false)} onSave={saveAnalysis} />}
      {editAnalysis && <RateAnalysisModal existing={editAnalysis} onClose={() => setEditAnalysis(null)} onSave={updateAnalysis} />}
      {viewAnalysis && <RateAnalysisPreview analysis={viewAnalysis} onClose={() => setViewAnalysis(null)} />}
    </div>
  );
}

function RateAnalysisModal({ onClose, onSave, existing }) {
  const allProducts = Object.values(MATERIAL_LIST).flat().map(p => p.name);
  
  const getTemplate = (name) => RATE_TEMPLATES[name] || {
    product: name, unit: "", constant: 1, rate: 0, wastage: 5,
    labour: 175, staffWelfare: 5, supervisorWelfare: 5, officeExp: 10,
    tools: 3, machinery: 3, transport: 2, mathadi: 1,
    labourCompliance: 5, retention: 5, rework: 5, misc: 3,
    emptyCanDeduction: 0, contractorProfit: 15,
  };

  const [f, setF] = useState(existing || getTemplate(""));
  const s = k => v => setF(p => ({ ...p, [k]: v }));
  const n = k => v => setF(p => ({ ...p, [k]: Number(v) }));

  // Calculations
  const materialAmount = (Number(f.constant) || 0) * (Number(f.rate) || 0);
const material2Amount = f.hasSecondMaterial ? (Number(f.constant2) || 0) * (Number(f.rate2) || 0) : 0;
const combinedMaterial = materialAmount + material2Amount;
const wastageAmount = combinedMaterial * (Number(f.wastage) || 0) / 100;
const total1 = combinedMaterial + wastageAmount;

  const staffWelfareAmt = total1 * (Number(f.staffWelfare) || 0) / 100;
const supervisorWelfareAmt = total1 * (Number(f.supervisorWelfare) || 0) / 100;
const officeExpAmt = total1 * (Number(f.officeExp) || 0) / 100;
  const total2 = (Number(f.labour) || 0) + staffWelfareAmt + supervisorWelfareAmt + officeExpAmt;

  const total3 = total1 + total2;

  const toolsAmt = total3 * (Number(f.tools) || 0) / 100;
  const machineryAmt = total3 * (Number(f.machinery) || 0) / 100;
  const transportAmt = total3 * (Number(f.transport) || 0) / 100;
  const mathadiAmt =  total1 * (Number(f.mathadi) || 0) / 100;
  const labourComplianceAmt = total3 * (Number(f.labourCompliance) || 0) / 100;
  const retentionAmt = total3 * (Number(f.retention) || 0) / 100;
  const reworkAmt = total3 * (Number(f.rework) || 0) / 100;
  const miscAmt = total3 * (Number(f.misc) || 0) / 100;
  const emptyCanDeduction = Number(f.emptyCanDeduction) || 0;

  const totalAdditional = toolsAmt + machineryAmt + transportAmt + mathadiAmt + labourComplianceAmt + retentionAmt + reworkAmt + miscAmt - emptyCanDeduction;
  const grandTotal = total3 + totalAdditional;
  const profitAmt = grandTotal * (Number(f.contractorProfit) || 0) / 100;
  const finalRate = grandTotal + profitAmt;

  const inputStyle = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, color: theme.text, padding: "6px 8px", fontSize: 12, outline: "none", width: "100%", boxSizing: "border-box" };
  const labelStyle = { color: theme.muted, fontSize: 10, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 3 };
  const sectionTitle = { color: theme.accent, fontSize: 12, fontWeight: 700, marginBottom: 10, marginTop: 4 };
  const rowStyle = { display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr", gap: 8, marginBottom: 8, alignItems: "center" };
  const headerStyle = { color: theme.faint, fontSize: 10, fontWeight: 700, textTransform: "uppercase" };
  const amtStyle = { color: theme.accent, fontWeight: 600, fontSize: 12, textAlign: "right" };

  return (
    <Modal title={existing ? "✏️ Edit Rate Analysis" : "📊 New Rate Analysis"} onClose={onClose} width={680}>

      {/* Product Selection */}
      <div style={{ marginBottom: 16 }}>
        <label style={labelStyle}>Product Name</label>
        <input
          list="ra-products"
          value={f.product || ""}
          onChange={e => {
            const template = getTemplate(e.target.value);
            setF({ ...template, product: e.target.value });
          }}
          style={inputStyle}
          placeholder="Type or select product..."
        />
        <datalist id="ra-products">
          {Object.keys(RATE_TEMPLATES).map(p => <option key={p} value={p} />)}
          {allProducts.map(p => <option key={p} value={p} />)}
        </datalist>
      </div>

      {/* Section 1 — Material */}
      <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "12px 14px", marginBottom: 12 }}>
        <div style={sectionTitle}>MATERIAL COST</div>
        <div style={rowStyle}>
          {["Description", "Unit", "Constant", "Rate ₹"].map(h => <div key={h} style={headerStyle}>{h}</div>)}
        </div>
       {/* Row headers */}
<div style={rowStyle}>
  {["", "Sr.", "", ""].map((_, i) => <div key={i} />)}
</div>

{/* Material 1 */}
<div style={{ display: "grid", gridTemplateColumns: "24px 2fr 1fr 1fr 1fr", gap: 8, marginBottom: 8, alignItems: "center" }}>
  <span style={{ color: "#c00", fontWeight: 700, fontSize: 12, textAlign: "center" }}>i</span>
  <input value={f.product || ""} onChange={e => s("product")(e.target.value)} style={inputStyle} />
  <input value={f.unit || ""} onChange={e => s("unit")(e.target.value)} style={inputStyle} placeholder="Ltr" />
  <input type="number" value={f.constant || ""} onChange={e => n("constant")(e.target.value)} style={inputStyle} />
  <input type="number" value={f.rate || ""} onChange={e => n("rate")(e.target.value)} style={inputStyle} />
</div>

{/* Material 2 — only if hasSecondMaterial */}
{f.hasSecondMaterial && (
  <div style={{ display: "grid", gridTemplateColumns: "24px 2fr 1fr 1fr 1fr", gap: 8, marginBottom: 8, alignItems: "center" }}>
    <span style={{ color: "#c00", fontWeight: 700, fontSize: 12, textAlign: "center" }}>ii</span>
    <input value={f.product2 || ""} onChange={e => s("product2")(e.target.value)} style={inputStyle} />
    <input value={f.unit2 || ""} onChange={e => s("unit2")(e.target.value)} style={inputStyle} placeholder="KG" />
    <input type="number" value={f.constant2 || ""} onChange={e => n("constant2")(e.target.value)} style={inputStyle} />
    <input type="number" value={f.rate2 || ""} onChange={e => n("rate2")(e.target.value)} style={inputStyle} />
  </div>
)}

<div style={{ display: "flex", justifyContent: "space-between", padding: "4px 0" }}>
  <span style={{ color: theme.muted, fontSize: 12 }}>Material Amount</span>
  <span style={amtStyle}>₹{combinedMaterial.toFixed(2)}</span>
</div>

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "4px 0" }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ color: theme.muted, fontSize: 12 }}>Wastage</span>
            <input type="number" value={f.wastage || ""} onChange={e => n("wastage")(e.target.value)}
              style={{ ...inputStyle, width: 50, textAlign: "center" }} />
            <span style={{ color: theme.muted, fontSize: 12 }}>%</span>
          </div>
          <span style={amtStyle}>₹{wastageAmount.toFixed(2)}</span>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", borderTop: `1px solid ${theme.border}`, paddingTop: 6, marginTop: 4 }}>
          <span style={{ color: theme.text, fontWeight: 700, fontSize: 12 }}>SUB TOTAL MATERIAL COST (TOTAL 1)</span>
          <span style={{ color: theme.blue, fontWeight: 800, fontSize: 13 }}>₹{total1.toFixed(2)}</span>
        </div>
      </div>

      {/* Section 2 — Labour */}
      <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "12px 14px", marginBottom: 12 }}>
        <div style={sectionTitle}>LABOUR & OTHER COST</div>

        {[
          ["Labour Treatment & Conveyance", "labour", false, null],
          ["Staff Welfare", "staffWelfare", true, staffWelfareAmt],
          ["Supervisor Welfare", "supervisorWelfare", true, supervisorWelfareAmt],
          ["Office Exp., Rent, Electricity", "officeExp", true, officeExpAmt],
        ].map(([label, key, isPercent, amt]) => (
          <div key={key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ color: theme.muted, fontSize: 12, minWidth: 200 }}>{label}</span>
              <input type="number" value={f[key] || ""} onChange={e => n(key)(e.target.value)}
                style={{ ...inputStyle, width: 70, textAlign: "center" }} />
              {isPercent && <span style={{ color: theme.muted, fontSize: 12 }}>%</span>}
            </div>
            <span style={amtStyle}>₹{isPercent ? amt.toFixed(2) : Number(f[key] || 0).toFixed(2)}</span>
          </div>
        ))}

        <div style={{ display: "flex", justifyContent: "space-between", borderTop: `1px solid ${theme.border}`, paddingTop: 6, marginTop: 4 }}>
          <span style={{ color: theme.text, fontWeight: 700, fontSize: 12 }}>SUB TOTAL LABOUR & OTH. COST (TOTAL 2)</span>
          <span style={{ color: theme.blue, fontWeight: 800, fontSize: 13 }}>₹{total2.toFixed(2)}</span>
        </div>
      </div>

      {/* Total 3 */}
      <div style={{ background: theme.accent + "11", border: `1px solid ${theme.accent}33`, borderRadius: 8, padding: "10px 14px", marginBottom: 12, display: "flex", justifyContent: "space-between" }}>
        <span style={{ color: theme.text, fontWeight: 700 }}>Total Material + Labour (TOTAL 3 = TOTAL 1 + TOTAL 2)</span>
        <span style={{ color: theme.accent, fontWeight: 800, fontSize: 14 }}>₹{total3.toFixed(2)}</span>
      </div>

      {/* Section 3 — Additional */}
      <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 10, padding: "12px 14px", marginBottom: 12 }}>
        <div style={sectionTitle}>ADDITIONAL CHARGES (% of Total 3)</div>

        {[
          ["a. Tools & Tackles", "tools", toolsAmt],
          ["b. Machinery Equipment", "machinery", machineryAmt],
          ["c. Material Porter Transport", "transport", transportAmt],
          ["d. Mathadi", "mathadi", mathadiAmt],
          ["e. Labour Compliance (on Labour)", "labourCompliance", labourComplianceAmt],
          ["f. Retention", "retention", retentionAmt],
          ["g. Rework", "rework", reworkAmt],
          ["h. Misc.", "misc", miscAmt],
        ].map(([label, key, amt]) => (
          <div key={key} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
              <span style={{ color: theme.muted, fontSize: 12, minWidth: 220 }}>{label}</span>
              <input type="number" value={f[key] || ""} onChange={e => n(key)(e.target.value)}
                style={{ ...inputStyle, width: 50, textAlign: "center" }} />
              <span style={{ color: theme.muted, fontSize: 12 }}>%</span>
            </div>
            <span style={amtStyle}>₹{amt.toFixed(2)}</span>
          </div>
        ))}

        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ color: theme.muted, fontSize: 12, minWidth: 220 }}>i. Empty Can Selling Price (deduction)</span>
            <input type="number" value={f.emptyCanDeduction || ""} onChange={e => n("emptyCanDeduction")(e.target.value)}
              style={{ ...inputStyle, width: 70, textAlign: "center" }} />
          </div>
          <span style={{ color: theme.red, fontWeight: 600, fontSize: 12 }}>- ₹{emptyCanDeduction.toFixed(2)}</span>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between", borderTop: `1px solid ${theme.border}`, paddingTop: 6, marginTop: 4 }}>
          <span style={{ color: theme.text, fontWeight: 700, fontSize: 12 }}>TOTAL (TOTAL 3 + a to i)</span>
          <span style={{ color: theme.blue, fontWeight: 800, fontSize: 13 }}>₹{grandTotal.toFixed(2)}</span>
        </div>
      </div>

      {/* Profit + Final */}
      <div style={{ background: theme.green + "11", border: `1px solid ${theme.green}33`, borderRadius: 10, padding: "12px 14px", marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 10 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
            <span style={{ color: theme.text, fontWeight: 600 }}>Add Contractor Profit</span>
            <input type="number" value={f.contractorProfit || ""} onChange={e => n("contractorProfit")(e.target.value)}
              style={{ ...inputStyle, width: 50, textAlign: "center" }} />
            <span style={{ color: theme.muted, fontSize: 12 }}>%</span>
          </div>
          <span style={amtStyle}>₹{profitAmt.toFixed(2)}</span>
        </div>
       <div style={{ display: "flex", justifyContent: "space-between", borderTop: `1px solid ${theme.green}44`, paddingTop: 8, marginBottom: f.showSqft ? 8 : 0 }}>
  <span style={{ color: theme.green, fontWeight: 800, fontSize: 14 }}>Total Cost of 1 {f.unit || "Unit"}</span>
  <span style={{ color: theme.green, fontWeight: 900, fontSize: 18 }}>₹{finalRate.toFixed(2)}</span>
</div>
{f.showSqft && (
  <>
    <div style={{ display: "flex", justifyContent: "space-between", borderTop: `1px solid ${theme.green}44`, paddingTop: 8, marginBottom: 6 }}>
      <span style={{ color: theme.blue, fontWeight: 800, fontSize: 14 }}>Total Cost of 1 SQMTR</span>
      <span style={{ color: theme.blue, fontWeight: 900, fontSize: 18 }}>₹{finalRate.toFixed(2)}</span>
    </div>
    <div style={{ display: "flex", justifyContent: "space-between" }}>
      <span style={{ color: theme.purple, fontWeight: 800, fontSize: 14 }}>Total Cost of 1 SQFT</span>
      <span style={{ color: theme.purple, fontWeight: 900, fontSize: 18 }}>₹{(finalRate / 10.764).toFixed(2)}</span>
    </div>
  </>
)}
      </div>

      <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
        <Btn onClick={onClose} variant="ghost">Cancel</Btn>
        <Btn onClick={() => {
          if (!f.product) return alert("Please enter a product name.");
          onSave({ ...f, materialAmount, material2Amount, combinedMaterial, wastageAmount, total1,staffWelfareAmt, supervisorWelfareAmt, officeExpAmt, total2, total3, toolsAmt, machineryAmt, transportAmt, mathadiAmt, labourComplianceAmt, 
            retentionAmt, reworkAmt, miscAmt, emptyCanDeduction, grandTotal, profitAmt, finalRate, showSqft: f.showSqft || false });
        }}>{existing ? "Save Changes" : "Save Analysis"}</Btn>
      </div>
    </Modal>
  );
}

function RateAnalysisPreview({ analysis: a, onClose }) {
  const printStyles = `
    @media print {
      body * { visibility: hidden !important; }
      #ra-print, #ra-print * { visibility: visible !important; }
      #ra-print { position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; }
      .no-print { display: none !important; }
    }
  `;
  const thStyle = { border: "1px solid #000", padding: "6px 8px", background: "#1a365d", color: "#fff", fontWeight: 700, fontSize: 11, textAlign: "center" };
  const tdStyle = { border: "1px solid #000", padding: "6px 8px", fontSize: 11 };
  const tdR = { ...tdStyle, textAlign: "right", fontWeight: 600 };

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000000cc", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <style>{printStyles}</style>
      <div style={{ background: "#fff", borderRadius: 12, width: "100%", maxWidth: 800, maxHeight: "92vh", overflow: "auto" }}>
        <div className="no-print" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 18px", borderBottom: "1px solid #e2e8f0", background: "#f8fafc" }}>
          <span style={{ fontWeight: 700, color: "#1a202c" }}>📊 Rate Analysis — {a.product}</span>
          <div style={{ display: "flex", gap: 8 }}>
            <button onClick={() => window.print()} style={{ background: "#3B82F6", color: "#fff", border: "none", borderRadius: 7, padding: "7px 16px", fontSize: 12, fontWeight: 600, cursor: "pointer" }}>🖨 Print / PDF</button>
            <button onClick={onClose} style={{ background: "#f1f5f9", border: "1px solid #e2e8f0", color: "#64748b", borderRadius: 7, padding: "7px 14px", fontSize: 12, cursor: "pointer" }}>✕ Close</button>
          </div>
        </div>

        <div id="ra-print" style={{ padding: "24px 30px", fontFamily: "Arial, sans-serif", color: "#000", background: "#fff" }}>
          {/* Header */}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "2px solid #000", paddingBottom: 10, marginBottom: 16 }}>
            <div>
              <div style={{ fontWeight: 900, fontSize: 17, color: "#1a365d" }}>PERMATECH CONCRETE SOLUTIONS</div>
              <div style={{ fontSize: 11, color: "#555" }}>18, Divya Darshan, Mount Mary Steps, Bandra (W), Mumbai – 400 050</div>
            </div>
            <div style={{ border: "2px solid #1a365d", padding: "6px 16px", textAlign: "center" }}>
              <div style={{ fontWeight: 900, fontSize: 13, color: "#1a365d", letterSpacing: 2 }}>RATE ANALYSIS</div>
              <div style={{ fontSize: 11, color: "#555", marginTop: 2 }}>{a.product}</div>
            </div>
          </div>

          {/* Table */}
          <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 0 }}>
            <thead>
              <tr>
                <th style={thStyle}>Sl. No</th>
                <th style={{ ...thStyle, textAlign: "left" }}>Description</th>
                <th style={thStyle}>Unit</th>
                <th style={thStyle}>Constant</th>
                <th style={thStyle}>Rate</th>
                <th style={thStyle}>Amount</th>
                <th style={thStyle}>Remarks</th>
              </tr>
            </thead>
            <tbody>
              {/* Material */}
              <tr><td colSpan={7} style={{ ...tdStyle, fontWeight: 700, background: "#f1f5f9" }}>MATERIAL COST — Waterproofing</td></tr>
           <tr>
  <td style={{ ...tdStyle, textAlign: "center", color: "#c00" }}>i</td>
  <td style={{ ...tdStyle, color: "#c00", fontWeight: 700 }}>{a.product}</td>
  <td style={{ ...tdStyle, textAlign: "center" }}>{a.unit}</td>
  <td style={{ ...tdStyle, textAlign: "center" }}>{Number(a.constant).toFixed(2)}</td>
  <td style={{ ...tdStyle, textAlign: "center" }}>{Number(a.rate).toFixed(2)}</td>
  <td style={tdR}>{a.materialAmount?.toFixed(2)}</td>
  <td style={tdStyle}></td>
</tr>
{a.hasSecondMaterial && (
  <tr>
    <td style={{ ...tdStyle, textAlign: "center", color: "#c00" }}>ii</td>
    <td style={{ ...tdStyle, color: "#c00", fontWeight: 700 }}>{a.product2}</td>
    <td style={{ ...tdStyle, textAlign: "center" }}>{a.unit2}</td>
    <td style={{ ...tdStyle, textAlign: "center" }}>{Number(a.constant2).toFixed(2)}</td>
    <td style={{ ...tdStyle, textAlign: "center" }}>{Number(a.rate2).toFixed(2)}</td>
    <td style={tdR}>{a.material2Amount?.toFixed(2)}</td>
    <td style={tdStyle}></td>
  </tr>
)}
              <tr>
                <td style={tdStyle}></td>
                <td style={tdStyle}>Wastage @ {a.wastage}%</td>
                <td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td>
                <td style={tdR}>{a.wastageAmount?.toFixed(2)}</td>
                <td style={tdStyle}></td>
              </tr>
              <tr style={{ background: "#e8f5e9" }}>
                <td colSpan={5} style={{ ...tdStyle, fontWeight: 700 }}>SUB TOTAL MATERIAL COST</td>
                <td style={{ ...tdR, fontWeight: 800 }}>{a.total1?.toFixed(2)}</td>
                <td style={{ ...tdStyle, fontWeight: 700 }}>TOTAL 1</td>
              </tr>

              {/* Labour */}
              <tr><td style={{ ...tdStyle, textAlign: "left" }} colSpan={7}></td></tr>
              {[
                ["Labour Treatment & Conveyance", a.labour],
                [`Staff Welfare ${a.staffWelfare}%`, a.staffWelfareAmt],
                [`Supervisor Welfare ${a.supervisorWelfare}%`, a.supervisorWelfareAmt],
                [`Office Exp., Rent, Electricity ${a.officeExp}%`, a.officeExpAmt],
              ].map(([label, val]) => (
                <tr key={label}>
                  <td style={tdStyle}></td>
                  <td style={tdStyle}>{label}</td>
                  <td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td>
                  <td style={tdR}>{Number(val).toFixed(2)}</td>
                  <td style={tdStyle}></td>
                </tr>
              ))}
              <tr style={{ background: "#e8f5e9" }}>
                <td colSpan={5} style={{ ...tdStyle, fontWeight: 700 }}>SUB TOTAL LABOUR & OTH. COST</td>
                <td style={{ ...tdR, fontWeight: 800 }}>{a.total2?.toFixed(2)}</td>
                <td style={{ ...tdStyle, fontWeight: 700 }}>TOTAL 2</td>
              </tr>

              {/* Total 3 */}
              <tr style={{ background: "#fff9c4" }}>
                <td colSpan={5} style={{ ...tdStyle, fontWeight: 800 }}>Total Material + Labour (TOTAL 1 + TOTAL 2)</td>
                <td style={{ ...tdR, fontWeight: 800 }}>{a.total3?.toFixed(2)}</td>
                <td style={{ ...tdStyle, fontWeight: 700 }}>TOTAL 3</td>
              </tr>

              {/* Additional */}
              {[
                ["a", `Tools & tackles @ ${a.tools}%`, a.toolsAmt],
                ["b", `Machinery Equipment @ ${a.machinery}%`, a.machineryAmt],
                ["c", `Material Porter Transport @ ${a.transport}%`, a.transportAmt],
                ["d", `Mathadi @ ${a.mathadi}%`, a.mathadiAmt],
                ["e", `Labour Compliance @ ${a.labourCompliance}% on labour Cost`, a.labourComplianceAmt],
                ["f", `Retention ${a.retention}%`, a.retentionAmt],
                ["g", `Rework ${a.rework}%`, a.reworkAmt],
                ["h", `Misc. ${a.misc}%`, a.miscAmt],
                ["i", `Empty Can selling price`, -a.emptyCanDeduction],
              ].map(([sr, label, val]) => (
                <tr key={sr}>
                  <td style={{ ...tdStyle, textAlign: "center" }}>{sr}</td>
                  <td style={tdStyle}>{label}</td>
                  <td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td>
                  <td style={{ ...tdR, color: val < 0 ? "#c00" : "#000" }}>{val < 0 ? `(${Math.abs(val).toFixed(2)})` : Number(val).toFixed(2)}</td>
                  <td style={tdStyle}></td>
                </tr>
              ))}

              {/* Grand Total */}
              <tr style={{ background: "#e8f5e9" }}>
                <td colSpan={5} style={{ ...tdStyle, fontWeight: 800 }}>TOTAL</td>
                <td style={{ ...tdR, fontWeight: 800 }}>{a.grandTotal?.toFixed(2)}</td>
                <td style={{ ...tdStyle, fontWeight: 700 }}>TOTAL 3 + (a to i)</td>
              </tr>

              {/* Profit */}
              <tr>
                <td style={tdStyle}></td>
                <td style={tdStyle}>Add contractor profit {a.contractorProfit}%</td>
                <td style={tdStyle}></td><td style={tdStyle}></td><td style={tdStyle}></td>
                <td style={tdR}>{a.profitAmt?.toFixed(2)}</td>
                <td style={tdStyle}></td>
              </tr>

              {/* Final */}
             <tr style={{ background: "#1a365d" }}>
  <td colSpan={5} style={{ ...tdStyle, fontWeight: 900, color: "#fff", fontSize: 13 }}>Total Cost of 1 {a.unit}</td>
  <td style={{ ...tdR, fontWeight: 900, color: "#fff", fontSize: 14 }}>{a.finalRate?.toFixed(2)}</td>
  <td style={{ ...tdStyle, fontWeight: 700, color: "#fff" }}>Rupees</td>
</tr>
{a.showSqft && (
  <>
    <tr style={{ background: "#1a365d" }}>
      <td colSpan={5} style={{ ...tdStyle, fontWeight: 900, color: "#fff", fontSize: 13 }}>Total Cost of 1 SQMTR</td>
      <td style={{ ...tdR, fontWeight: 900, color: "#fff", fontSize: 14 }}>{a.finalRate?.toFixed(2)}</td>
      <td style={{ ...tdStyle, fontWeight: 700, color: "#fff" }}>Rupees</td>
    </tr>
    <tr style={{ background: "#1a365d" }}>
      <td colSpan={5} style={{ ...tdStyle, fontWeight: 900, color: "#fff", fontSize: 13 }}>Total Cost of 1 SQFT</td>
      <td style={{ ...tdR, fontWeight: 900, color: "#fff", fontSize: 14 }}>{(a.finalRate / 10.764).toFixed(2)}</td>
      <td style={{ ...tdStyle, fontWeight: 700, color: "#fff" }}>Rupees</td>
    </tr>
  </>
)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function DocumentsTab({ project, onUpdate }) {
  const [viewDoc, setViewDoc] = useState(null);
  const [showAddRow, setShowAddRow] = useState(false);
  const [saving, setSaving] = useState(false);
  const [newRow, setNewRow] = useState({ type: "Work Order", description: "", uploadDate: new Date().toISOString().slice(0, 10), remarks: "", file: null });

  // Merge Firestore docs with localStorage docs (localStorage has base64 data)
 const [docs, setDocs] = useState(() => {
  try {
    const ls = localStorage.getItem(`project_docs_${project.id}`);
    return ls ? JSON.parse(ls) : (project.documents || []);
  } catch { return project.documents || []; }
});

useEffect(() => {
  // Load from Firestore project_documents collection
  getDocs(collection(db, "project_documents")).then(snap => {
    const firestoreDocs = snap.docs
      .filter(d => d.data().projectId === String(project.id))
      .map(d => d.data());
    if (firestoreDocs.length > 0) {
      // Merge with localStorage (localStorage has base64 data)
      try {
        const ls = localStorage.getItem(`project_docs_${project.id}`);
        const localDocs = ls ? JSON.parse(ls) : [];
        const merged = firestoreDocs.map(fd => {
          const local = localDocs.find(ld => String(ld.id) === String(fd.id));
          return local ? { ...fd, ...local } : fd;
        });
        setDocs(merged);
      } catch { setDocs(firestoreDocs); }
    }
  }).catch(e => console.error("Load docs error:", e));
}, [project.id]);

  const handleFileUpload = async (file, meta) => {
  const id = Date.now() + Math.random();
  // Skip Firebase Storage on localhost due to CORS — use base64 directly
  return await new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => resolve({
      ...meta, id,
      name: file.name,
      fileType: file.type,
      size: file.size,
      data: e.target.result,
      storedIn: "local"
    });
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
};

 const saveProjectDocs = async (newDocs) => {
  // 1 — Always save full data to localStorage first
  try {
    localStorage.setItem(`project_docs_${project.id}`, JSON.stringify(newDocs));
  } catch (e) { console.warn("localStorage full:", e); }

  
  // 2 — Update local state and parent state
setDocs(newDocs);
onUpdate({ ...project, documents: newDocs });

  // 3 — Save each doc as separate Firestore document in project_documents collection
  try {
    for (const doc of newDocs) {
      const { data, ...firestoreSafe } = doc; // strip base64
      await setDoc(
        fsDoc(db, "project_documents", `${project.id}_${doc.id}`),
        { ...firestoreSafe, projectId: String(project.id) }
      );
    }
    // Delete removed docs from Firestore
    const existingIds = newDocs.map(d => `${project.id}_${d.id}`);
    const allDocs = await getDocs(collection(db, "project_documents"));
    for (const d of allDocs.docs) {
      if (d.data().projectId === String(project.id) && !existingIds.includes(d.id)) {
        await deleteDoc(fsDoc(db, "project_documents", d.id));
      }
    }
  } catch (e) {
    console.error("Firestore doc save error:", e);
  }
};

  const handleAddRow = async () => {
  if (!newRow.description.trim()) { alert("Please enter a description/title."); return; }
  if (!newRow.file) { alert("Please upload a file."); return; }
  setSaving(true);
  try {
    const meta = { type: newRow.type, description: newRow.description, uploadDate: newRow.uploadDate, remarks: newRow.remarks };
    const docObj = await handleFileUpload(newRow.file, meta);
    const newDocs = [...docs, docObj];

    // Step 1 — localStorage
    try {
      localStorage.setItem(`project_docs_${project.id}`, JSON.stringify(newDocs));
      console.log("✅ localStorage saved");
    } catch (e) { console.error("❌ localStorage failed:", e); }

   // Step 2 — Save metadata only to Firestore (no base64 data)
try {
  const { data, ...safe } = docObj;
  await setDoc(fsDoc(db, "project_documents", `${project.id}_${String(docObj.id)}`), {
    ...safe,
    id: String(docObj.id),
    projectId: String(project.id),
    savedAt: new Date().toISOString()
  });
  console.log("✅ Firestore metadata saved");
} catch (e) { console.error("❌ Firestore failed:", e); }

    // Step 3 — update state
    setDocs(newDocs);
    onUpdate({ ...project, documents: newDocs });
    setNewRow({ type: "Work Order", description: "", uploadDate: new Date().toISOString().slice(0, 10), remarks: "", file: null });
    setShowAddRow(false);
    alert("✅ Document saved!");
  } catch (e) {
    console.error("❌ Upload failed:", e);
    alert("Failed: " + e.message);
  } finally { setSaving(false); }
};

  const deleteDocument = async (id) => {
    if (!window.confirm("Delete this document?")) return;
    const newDocs = docs.filter(d => d.id !== id);
    await saveProjectDocs(newDocs);
  };

  const downloadDoc = (doc) => {
    const a = window.document.createElement("a");
    a.href = doc.url || doc.data;
    a.download = doc.name;
    a.target = "_blank";
    a.click();
  };

  const getIcon = (type) => {
    if (type?.startsWith("image/")) return "🖼️";
    if (type === "application/pdf") return "📄";
    if (type?.includes("word")) return "📝";
    if (type?.includes("sheet") || type?.includes("excel")) return "📊";
    return "📎";
  };

  const formatSize = (bytes) => {
    if (!bytes) return "—";
    if (bytes < 1024) return bytes + " B";
    if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
    return (bytes / (1024 * 1024)).toFixed(1) + " MB";
  };

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" };
  const thStyle = { padding: "10px 12px", background: theme.accent + "22", color: theme.accent, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: 0.5, textAlign: "left", borderBottom: `2px solid ${theme.accent}`, whiteSpace: "nowrap" };
  const tdStyle = { padding: "11px 14px", borderBottom: `1px solid ${theme.border}`, fontSize: 14, color: theme.text, verticalAlign: "middle" };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div>
          <span style={{ color: theme.text, fontWeight: 700, fontSize: 14 }}>📁 Project Documents</span>
          <div style={{ color: theme.muted, fontSize: 11, marginTop: 2 }}>{docs.length} document{docs.length !== 1 ? "s" : ""} stored</div>
        </div>
        <Btn onClick={() => setShowAddRow(true)}>+ Add Document</Btn>
      </div>

      {showAddRow && (
        <div style={{ background: theme.card, border: `1px solid ${theme.accent}44`, borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, textTransform: "uppercase", marginBottom: 12 }}>📎 New Document</div>
          <div style={{ display: "grid", gridTemplateColumns: "140px 1fr 140px 1fr", gap: 10, marginBottom: 10 }}>
            <div>
              <div style={{ color: theme.muted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>Type <span style={{ color: theme.red }}>*</span></div>
              <select value={newRow.type} onChange={e => setNewRow(r => ({ ...r, type: e.target.value }))} style={{ ...inp, cursor: "pointer" }}>
                <option value="Work Order">Work Order</option>
                <option value="Drawing">Drawing</option>
                <option value="Contract">Contract</option>
                <option value="Invoice">Invoice</option>
                <option value="Photo">Photo</option>
                <option value="Other">Other</option>
              </select>
            </div>
            <div>
              <div style={{ color: theme.muted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>Description / Title <span style={{ color: theme.red }}>*</span></div>
              <input value={newRow.description} onChange={e => setNewRow(r => ({ ...r, description: e.target.value }))} style={inp} placeholder="Enter description..." />
            </div>
            <div>
              <div style={{ color: theme.muted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>Upload Date</div>
              <input type="date" value={newRow.uploadDate} onChange={e => setNewRow(r => ({ ...r, uploadDate: e.target.value }))} style={inp} />
            </div>
            <div>
              <div style={{ color: theme.muted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>Remarks</div>
              <input value={newRow.remarks} onChange={e => setNewRow(r => ({ ...r, remarks: e.target.value }))} style={inp} placeholder="Optional remarks..." />
            </div>
          </div>
          <div style={{ marginBottom: 12 }}>
            <div style={{ color: theme.muted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", marginBottom: 3 }}>File <span style={{ color: theme.red }}>*</span></div>
            <label style={{ display: "flex", alignItems: "center", gap: 10, background: theme.bg, border: `1px dashed ${newRow.file ? theme.green : theme.border}`, borderRadius: 8, padding: "10px 14px", cursor: "pointer" }}>
              <span style={{ fontSize: 20 }}>{newRow.file ? getIcon(newRow.file.type) : "📂"}</span>
              <span style={{ color: newRow.file ? theme.green : theme.muted, fontSize: 12, fontWeight: newRow.file ? 700 : 400 }}>
                {newRow.file ? `✓ ${newRow.file.name} (${formatSize(newRow.file.size)})` : "Click to select file..."}
              </span>
              <input type="file" style={{ display: "none" }} onChange={e => setNewRow(r => ({ ...r, file: e.target.files[0] }))} />
            </label>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Btn variant="ghost" onClick={() => { setShowAddRow(false); setNewRow({ type: "Work Order", description: "", uploadDate: new Date().toISOString().slice(0, 10), remarks: "", file: null }); }}>Cancel</Btn>
            <Btn onClick={handleAddRow} disabled={saving}>{saving ? "⏳ Saving..." : "💾 Save Document"}</Btn>
          </div>
        </div>
      )}

      {docs.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 40, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 8 }}>📭</div>
          <div style={{ color: theme.muted, fontSize: 13 }}>No documents uploaded yet. Click "+ Add Document" to start.</div>
        </div>
      ) : (
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", background: theme.card, borderRadius: 12, overflow: "hidden" }}>
            <thead>
              <tr>
                {["Sr.", "Type", "Description / Title", "File", "Size", "Upload Date", "Remarks", "Actions"].map(h => (
                  <th key={h} style={thStyle}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {docs.map((doc, i) => (
                <tr key={doc.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                  <td style={{ ...tdStyle, textAlign: "center", color: theme.muted, width: 40 }}>{i + 1}</td>
                  <td style={{ ...tdStyle, width: 120 }}>
                    <span style={{ background: doc.type === "Work Order" ? theme.blue + "22" : theme.purple + "22", color: doc.type === "Work Order" ? theme.blue : theme.purple, border: `1px solid ${doc.type === "Work Order" ? theme.blue + "44" : theme.purple + "44"}`, borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700 }}>
                      {doc.type || "Document"}
                    </span>
                  </td>
                  <td style={tdStyle}>
                    <div style={{ fontWeight: 600 }}>{doc.description || doc.name}</div>
                    <div style={{ color: theme.faint, fontSize: 10, marginTop: 2 }}>{doc.name}</div>
                  </td>
                  <td style={{ ...tdStyle, width: 50, textAlign: "center", fontSize: 22 }}>{getIcon(doc.fileType)}</td>
                  <td style={{ ...tdStyle, width: 80, color: theme.muted, fontSize: 12 }}>{formatSize(doc.size)}</td>
                  <td style={{ ...tdStyle, width: 110, color: theme.muted }}>{doc.uploadDate || "—"}</td>
                  <td style={{ ...tdStyle, color: theme.muted }}>{doc.remarks || "—"}</td>
                  <td style={{ ...tdStyle, width: 160 }}>
                    <div style={{ display: "flex", gap: 6 }}>
                      {(doc.fileType?.startsWith("image/") || doc.fileType === "application/pdf") && (doc.url || doc.data) && (
                        <Btn small variant="ghost" onClick={() => setViewDoc(doc)}>👁</Btn>
                      )}
                      {(doc.url || doc.data) && (
                        <Btn small variant="ghost" onClick={() => downloadDoc(doc)}>⬇️</Btn>
                      )}
                      <Btn small variant="danger" onClick={() => deleteDocument(doc.id)}>🗑</Btn>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {viewDoc && (
        <div style={{ position: "fixed", inset: 0, background: "#000000dd", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }} onClick={() => setViewDoc(null)}>
          <div style={{ background: theme.card, borderRadius: 12, width: "100%", maxWidth: 900, maxHeight: "92vh", overflow: "auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 18px", borderBottom: `1px solid ${theme.border}` }}>
              <div>
                <span style={{ color: theme.text, fontWeight: 700 }}>{viewDoc.description || viewDoc.name}</span>
                <div style={{ color: theme.muted, fontSize: 11, marginTop: 2 }}>{viewDoc.name} · {viewDoc.uploadDate} · {viewDoc.storedIn === "firebase" ? "☁️ Cloud" : "💾 Local"}</div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <Btn small onClick={() => downloadDoc(viewDoc)}>⬇️ Download</Btn>
                <Btn small variant="ghost" onClick={() => setViewDoc(null)}>✕ Close</Btn>
              </div>
            </div>
            <div style={{ padding: 20, textAlign: "center" }}>
              {viewDoc.fileType?.startsWith("image/") && (
                <img src={viewDoc.url || viewDoc.data} alt={viewDoc.name} style={{ maxWidth: "100%", borderRadius: 8 }} />
              )}
              {viewDoc.fileType === "application/pdf" && (
                <embed src={viewDoc.url || viewDoc.data} type="application/pdf" width="100%" height="600px" style={{ borderRadius: 8 }} />
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
const NAV = [
  { id: "finance", label: " Finance Dashboard", icon: "💹", sub: "Trackers & Reports" },
  { id: "projects", label: "Project Management", icon: "🏗️", sub: "BOQ & Daily Progress Report" },
  { id: "inventory", label: "Stock Inventory", icon: "📦", sub: "Warehouse & Godown" },
  { id: "hrms", label: "HRMS", icon: "👷", sub: "Attendance & Staff"},
  
  { id: "crm", label: "CRM & Sales", icon: "📊", sub: "Quotation Register" },
];
const saveProject = async (project) => {
  try {
    await setDoc(fsDoc(db, 'projects', String(project.id)), project);
  } catch (err) { console.error("Save project error:", err); }
};



const saveMaterialRequest = async (req) => {
  try {
    await setDoc(fsDoc(db, 'material_requests', String(req.id)), req);
  } catch (err) { console.error("Save request error:", err); }
};



// eslint-disable-next-line no-unused-vars
const saveMasterBOQItem = async (item) => {
  try {
    await setDoc(fsDoc(db, 'master_boq', String(item.id)), item);
  } catch (err) { console.error("Save BOQ error:", err); }
};

// eslint-disable-next-line no-unused-vars
const deleteMasterBOQItem = async (id) => {
  try {
    
    await deleteDoc(fsDoc(db, 'master_boq', String(id)));
  } catch (err) { console.error("Delete BOQ error:", err); }
};

// eslint-disable-next-line no-unused-vars
const deleteChallan = async (id) => {
  try {
    
    await deleteDoc(fsDoc(db, 'challans', String(id)));
  } catch (err) { console.error("Delete challan error:", err); }
};

// eslint-disable-next-line no-unused-vars
const deleteMaterialRequest = async (id) => {
  try {
    
    await deleteDoc(fsDoc(db, 'material_requests', String(id)));
  } catch (err) { console.error("Delete request error:", err); }
};



function LedgerTab({ ledgers, onSave, onDelete }) {
  const [modal, setModal] = useState(null); // null | "create" | {type:"view"|"edit", data}

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.muted, fontSize: 12, marginTop: 3 }}>{ledgers.length} ledger accounts</div>
        </div>
        <Btn onClick={() => setModal("create")}>+ New Ledger Account</Btn>
      </div>

      {ledgers.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>📒</div>
          <div style={{ color: theme.muted, fontSize: 14 }}>No ledger accounts yet. Create your first one.</div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {ledgers.map(l => {
            const totalNetReceivable = (l.rows || []).reduce((s, r) => s + (Number(r.netReceivable) || 0), 0);
            const balance = totalNetReceivable - (Number(l.paymentReceived) || 0);
            return (
              <div key={l.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "14px 18px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
                <div>
                  <div style={{ color: theme.accent, fontWeight: 800, fontSize: 14, marginBottom: 3 }}>📒 {l.billTo}</div>
                  <div style={{ color: theme.muted, fontSize: 12 }}>{l.rows?.length || 0} RA entries · Net Receivable: <span style={{ color: theme.accent, fontWeight: 700 }}>{fmt(totalNetReceivable)}</span></div>
                  <div style={{ color: balance > 0 ? theme.red : theme.green, fontSize: 12, fontWeight: 700, marginTop: 2 }}>Balance: {fmt(balance)}</div>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <Btn small variant="ghost" onClick={() => setModal({ type: "view", data: l })}>👁 View</Btn>
                  <Btn small variant="ghost" onClick={() => setModal({ type: "edit", data: l })}>✏️ Edit</Btn>
                  <Btn small variant="blue" onClick={() => { setModal({ type: "view", data: l }); setTimeout(() => window.print(), 400); }}>🖨 Print</Btn>
                  <Btn small variant="danger" onClick={() => { if (window.confirm(`Delete ledger for "${l.billTo}"?`)) onDelete(l.id); }}>🗑 Delete</Btn>
                </div>
              </div>
            );
          })}
        </div>
      )}

      {modal === "create" && (
        <LedgerFormModal
          onClose={() => setModal(null)}
          onSave={ledger => { onSave(ledger); setModal(null); }}
        />
      )}
      {modal?.type === "edit" && (
        <LedgerFormModal
          existing={modal.data}
          onClose={() => setModal(null)}
          onSave={ledger => { onSave(ledger); setModal(null); }}
        />
      )}
      {modal?.type === "view" && (
        <LedgerPreviewModal
          ledger={modal.data}
          onClose={() => setModal(null)}
          onEdit={() => setModal({ type: "edit", data: modal.data })}
        />
      )}
    </div>
  );
}
function LedgerFormModal({ existing, onSave, onClose }) {
  const billToGlobal = existing?.billTo || "";
  const [globalBillTo, setGlobalBillTo] = useState(billToGlobal);
  const [rows, setRows] = useState(existing?.rows || [
    { id: 1, srNo: "1", billTo: "", siteName: "", raNo: "", invoiceDate: "", invoiceNo: "", workDone: "", invoiceAmount: "", gst: "", totalWithGST: "", retention: "", tds: "", netReceivable: "", paymentReceived: "", balance: "", remarks: "" }
  ]);

  const calc = (row) => {
    const inv = parseFloat(row.invoiceAmount) || 0;
    const gst = parseFloat((inv * 0.18).toFixed(2));
    const totalWithGST = parseFloat((inv + gst).toFixed(2));
    const retention = parseFloat((inv * 0.05).toFixed(2));
    const tds = parseFloat((inv * 0.02).toFixed(2));
    const netReceivable = parseFloat((totalWithGST - retention - tds).toFixed(2));
    const paymentReceived = parseFloat(row.paymentReceived) || 0;
    const balance = parseFloat((netReceivable - paymentReceived).toFixed(2));
    return { gst, totalWithGST, retention, tds, netReceivable, balance };
  };

  const updateRow = (id, field, value) => {
    setRows(rs => rs.map(r => {
      if (r.id !== id) return r;
      const updated = { ...r, [field]: value };
      const computed = calc(updated);
      return { ...updated, ...computed };
    }));
  };

  const addRow = () => {
    setRows(rs => [...rs, {
      id: Date.now(), srNo: String(rs.length + 1), billTo: globalBillTo,
      siteName: "", raNo: "", invoiceDate: "", invoiceNo: "",
      workDone: "", invoiceAmount: "", gst: "", totalWithGST: "",
      retention: "", tds: "", netReceivable: "", paymentReceived: "", balance: "", remarks: ""
    }]);
  };

  const deleteRow = (id) => setRows(rs => rs.filter(r => r.id !== id));

  const handleGlobalBillToChange = (val) => {
    setGlobalBillTo(val);
    setRows(rs => rs.map(r => ({ ...r, billTo: val })));
  };

  const totals = rows.reduce((acc, row) => {
    acc.workDone += parseFloat(row.workDone) || 0;
    acc.invoiceAmount += parseFloat(row.invoiceAmount) || 0;
    acc.gst += parseFloat(row.gst) || 0;
    acc.totalWithGST += parseFloat(row.totalWithGST) || 0;
    acc.retention += parseFloat(row.retention) || 0;
    acc.tds += parseFloat(row.tds) || 0;
    acc.netReceivable += parseFloat(row.netReceivable) || 0;
    acc.paymentReceived += parseFloat(row.paymentReceived) || 0;
    acc.balance += parseFloat(row.balance) || 0;
    return acc;
  }, { workDone: 0, invoiceAmount: 0, gst: 0, totalWithGST: 0, retention: 0, tds: 0, netReceivable: 0, paymentReceived: 0, balance: 0 });

  const handleSave = () => {
    if (!globalBillTo.trim()) { alert("Please enter Bill To name."); return; }
    const ledger = {
      id: existing?.id || Date.now(),
      billTo: globalBillTo,
      rows: rows.map(r => ({ ...r, billTo: globalBillTo })),
      totals,
      updatedAt: new Date().toISOString()
    };
    onSave(ledger);
    onClose();
  };

  const inp = { background: "transparent", border: "none", outline: "none", color: theme.text, fontSize: 11, width: "100%", padding: "2px 4px" };
  const cell = (color) => ({ padding: "6px 8px", borderBottom: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}`, background: color + "11" });
  const thStyle = { padding: "10px 8px", background: theme.accent + "22", color: theme.accent, fontSize: 10, fontWeight: 800, textTransform: "uppercase", letterSpacing: 0.5, textAlign: "center", borderRight: `1px solid ${theme.border}`, borderBottom: `2px solid ${theme.accent}`, whiteSpace: "nowrap" };

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000a", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 16, width: "100%", maxWidth: 1400, maxHeight: "95vh", display: "flex", flexDirection: "column" }}>
        
        {/* Header */}
        <div style={{ padding: "20px 24px", borderBottom: `1px solid ${theme.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase" }}>Project Ledger</div>
            <h3 style={{ color: theme.text, margin: "4px 0 0", fontSize: 20, fontWeight: 800 }}>{existing ? "Edit Ledger Account" : "New Ledger Account"}</h3>
          </div>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
              <label style={{ color: theme.muted, fontSize: 11, fontWeight: 600 }}>BILL TO (applies to all rows)</label>
              <input
                value={globalBillTo}
                onChange={e => handleGlobalBillToChange(e.target.value)}
                placeholder="Client name..."
                style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 8, padding: "8px 14px", color: theme.text, fontSize: 13, fontWeight: 700, width: 220 }}
              />
            </div>
          </div>
        </div>

        {/* Table */}
        <div style={{ overflowX: "auto", overflowY: "auto", flex: 1, padding: "0 16px" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1600, marginTop: 16 }}>
            <thead>
              <tr>
                {["Sr No.", "Bill To", "Site Name", "RA No.", "Invoice Date", "Invoice No.", "Total Work Done", "Invoice Amount", "GST Amount", "Total Amt Incl. GST", "Retention 5%", "TDS 2%", "Net Receivable", "Payment Received", "Balance Payment", "Remarks", ""].map(h => (
                  <th key={h} style={thStyle}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map(row => (
                <tr key={row.id}>
                  <td style={{ ...cell(theme.accent), textAlign: "center", width: 50 }}>
                    <input value={row.srNo} onChange={e => updateRow(row.id, "srNo", e.target.value)} style={{ ...inp, textAlign: "center", fontWeight: 700, color: theme.accent, width: 40 }} />
                  </td>
                  <td style={cell(theme.text)}>
                    <input value={row.billTo || globalBillTo} onChange={e => updateRow(row.id, "billTo", e.target.value)} style={{ ...inp, textAlign: "left", minWidth: 100 }} placeholder="Bill to..." />
                  </td>
                  <td style={cell(theme.text)}>
                    <input value={row.siteName} onChange={e => updateRow(row.id, "siteName", e.target.value)} style={{ ...inp, textAlign: "left", minWidth: 100 }} placeholder="Site name..." />
                  </td>
                  <td style={{ ...cell(theme.blue), textAlign: "center" }}>
                    <input value={row.raNo} onChange={e => updateRow(row.id, "raNo", e.target.value)} style={{ ...inp, textAlign: "center", color: theme.blue, width: 60 }} placeholder="RA No." />
                  </td>
                  <td style={{ ...cell(theme.muted), textAlign: "center" }}>
                    <input type="date" value={row.invoiceDate} onChange={e => updateRow(row.id, "invoiceDate", e.target.value)} style={{ ...inp, textAlign: "center", color: theme.muted, width: 120 }} />
                  </td>
                  <td style={cell(theme.text)}>
                    <input value={row.invoiceNo} onChange={e => updateRow(row.id, "invoiceNo", e.target.value)} style={{ ...inp, textAlign: "center", width: 70 }} placeholder="Inv No." />
                  </td>
                  <td style={{ ...cell(theme.blue), textAlign: "right" }}>
                    <input value={row.workDone} onChange={e => updateRow(row.id, "workDone", e.target.value)} style={{ ...inp, textAlign: "right", color: theme.blue, width: 90 }} placeholder="0" />
                  </td>
                  <td style={{ ...cell(theme.text), textAlign: "right" }}>
                    <input value={row.invoiceAmount} onChange={e => updateRow(row.id, "invoiceAmount", e.target.value)} style={{ ...inp, textAlign: "right", width: 90 }} placeholder="0" />
                  </td>
                  <td style={{ ...cell(theme.purple), textAlign: "right" }}>
                    <input value={row.gst} readOnly style={{ ...inp, textAlign: "right", color: theme.purple, background: "transparent", width: 80 }} />
                  </td>
                  <td style={{ ...cell(theme.blue), textAlign: "right" }}>
                    <input value={row.totalWithGST} readOnly style={{ ...inp, textAlign: "right", color: theme.blue, background: "transparent", fontWeight: 700, width: 90 }} />
                  </td>
                  <td style={{ ...cell(theme.orange), textAlign: "right" }}>
                    <input value={row.retention} readOnly style={{ ...inp, textAlign: "right", color: theme.orange, background: "transparent", width: 80 }} />
                  </td>
                  <td style={{ ...cell(theme.red), textAlign: "right" }}>
                    <input value={row.tds} readOnly style={{ ...inp, textAlign: "right", color: theme.red, background: "transparent", width: 70 }} />
                  </td>
                  <td style={{ ...cell(theme.green), textAlign: "right", fontWeight: 700 }}>
                    <input value={row.netReceivable} readOnly style={{ ...inp, textAlign: "right", color: theme.green, fontWeight: 700, background: "transparent", width: 90 }} />
                  </td>
                  <td style={{ ...cell(theme.green), textAlign: "right" }}>
                    <input value={row.paymentReceived} onChange={e => updateRow(row.id, "paymentReceived", e.target.value)} style={{ ...inp, textAlign: "right", color: theme.green, width: 90 }} placeholder="0" />
                  </td>
                  <td style={{ ...cell(parseFloat(row.balance) > 0 ? theme.red : theme.green), textAlign: "right", fontWeight: 700 }}>
                    <input value={row.balance} readOnly style={{ ...inp, textAlign: "right", color: parseFloat(row.balance) > 0 ? theme.red : theme.green, fontWeight: 700, background: "transparent", width: 90 }} />
                  </td>
                  <td style={cell(theme.text)}>
                    <input value={row.remarks} onChange={e => updateRow(row.id, "remarks", e.target.value)} style={{ ...inp, textAlign: "left", minWidth: 80 }} placeholder="Remarks..." />
                  </td>
                  <td style={{ ...cell(theme.text), textAlign: "center", width: 36 }}>
                    <button onClick={() => deleteRow(row.id)} style={{ background: theme.red, color: "#fff", border: "none", borderRadius: 5, padding: "4px 8px", cursor: "pointer", fontSize: 12 }}>✕</button>
                  </td>
                </tr>
              ))}

              {/* TOTAL ROW */}
              <tr style={{ background: theme.card }}>
                <td colSpan={6} style={{ padding: "10px 12px", borderBottom: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}`, textAlign: "right", fontWeight: 800, fontSize: 12, color: theme.text }}>TOTAL</td>
                <td style={{ padding: "10px 8px", borderBottom: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}`, textAlign: "right", fontWeight: 800, color: theme.blue }}>₹{totals.workDone.toLocaleString("en-IN")}</td>
                <td style={{ padding: "10px 8px", borderBottom: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}`, textAlign: "right", fontWeight: 800, color: theme.text }}>₹{totals.invoiceAmount.toLocaleString("en-IN")}</td>
                <td style={{ padding: "10px 8px", borderBottom: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}`, textAlign: "right", fontWeight: 800, color: theme.purple }}>₹{totals.gst.toLocaleString("en-IN")}</td>
                <td style={{ padding: "10px 8px", borderBottom: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}`, textAlign: "right", fontWeight: 800, color: theme.blue }}>₹{totals.totalWithGST.toLocaleString("en-IN")}</td>
                <td style={{ padding: "10px 8px", borderBottom: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}`, textAlign: "right", fontWeight: 800, color: theme.orange }}>₹{totals.retention.toLocaleString("en-IN")}</td>
                <td style={{ padding: "10px 8px", borderBottom: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}`, textAlign: "right", fontWeight: 800, color: theme.red }}>₹{totals.tds.toLocaleString("en-IN")}</td>
                <td style={{ padding: "10px 8px", borderBottom: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}`, textAlign: "right", fontWeight: 800, color: theme.green }}>₹{totals.netReceivable.toLocaleString("en-IN")}</td>
                <td style={{ padding: "10px 8px", borderBottom: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}`, textAlign: "right", fontWeight: 800, color: theme.green }}>₹{totals.paymentReceived.toLocaleString("en-IN")}</td>
                <td style={{ padding: "10px 8px", borderBottom: `1px solid ${theme.border}`, borderRight: `1px solid ${theme.border}`, textAlign: "right", fontWeight: 800, color: totals.balance > 0 ? theme.red : theme.green }}>₹{totals.balance.toLocaleString("en-IN")}</td>
                <td colSpan={2} style={{ padding: "10px 8px", borderBottom: `1px solid ${theme.border}` }}></td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Footer */}
        <div style={{ padding: "16px 24px", borderTop: `1px solid ${theme.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Btn variant="ghost" onClick={addRow}>+ Add RA Row</Btn>
          <div style={{ display: "flex", gap: 10 }}>
            <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
            <Btn onClick={handleSave}>💾 Save Ledger</Btn>
          </div>
        </div>
      </div>
    </div>
  );
}

function LedgerPreviewModal({ ledger, onClose, onEdit }) {
  const totals = ledger.totals || ledger.rows.reduce((acc, row) => {
    acc.workDone += parseFloat(row.workDone) || 0;
    acc.invoiceAmount += parseFloat(row.invoiceAmount) || 0;
    acc.gst += parseFloat(row.gst) || 0;
    acc.totalWithGST += parseFloat(row.totalWithGST) || 0;
    acc.retention += parseFloat(row.retention) || 0;
    acc.tds += parseFloat(row.tds) || 0;
    acc.netReceivable += parseFloat(row.netReceivable) || 0;
    acc.paymentReceived += parseFloat(row.paymentReceived) || 0;
    acc.balance += parseFloat(row.balance) || 0;
    return acc;
  }, { workDone: 0, invoiceAmount: 0, gst: 0, totalWithGST: 0, retention: 0, tds: 0, netReceivable: 0, paymentReceived: 0, balance: 0 });

  const thStyle = { padding: "8px 6px", background: "#1a365d", color: "#fff", fontSize: 9, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: "1px solid #2d4a7a", whiteSpace: "nowrap" };
  const tdStyle = { padding: "7px 6px", fontSize: 10, border: "1px solid #e2e8f0", textAlign: "right" };

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000a", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
      <div style={{ background: "#fff", borderRadius: 16, width: "100%", maxWidth: 1400, maxHeight: "95vh", display: "flex", flexDirection: "column" }}>

        {/* Action Bar - hidden on print */}
        <div className="no-print" style={{ padding: "12px 20px", borderBottom: "1px solid #e2e8f0", display: "flex", justifyContent: "space-between", alignItems: "center", background: "#f8fafc", borderRadius: "16px 16px 0 0" }}>
          <button onClick={onClose} style={{ background: "none", border: "1px solid #cbd5e0", borderRadius: 8, padding: "6px 16px", cursor: "pointer", fontSize: 13 }}>✕ Close</button>
          <div style={{ display: "flex", gap: 10 }}>
            {onEdit && <button onClick={onEdit} style={{ background: "#3B82F6", color: "#fff", border: "none", borderRadius: 8, padding: "6px 16px", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>✏️ Edit</button>}
            <button onClick={() => window.print()} style={{ background: "#1a365d", color: "#fff", border: "none", borderRadius: 8, padding: "6px 16px", cursor: "pointer", fontSize: 13, fontWeight: 700 }}>🖨 Print</button>
          </div>
        </div>

        {/* Printable Content */}
        <div id="ledger-print" style={{ overflowY: "auto", flex: 1, padding: 24, background: "#fff" }}>
          {/* Company Header */}
          <div style={{ textAlign: "center", marginBottom: 16, borderBottom: "2px solid #1a365d", paddingBottom: 12 }}>
            <div style={{ fontSize: 20, fontWeight: 900, color: "#1a365d", letterSpacing: 1 }}>PERMATECH CONSTRUCTION SERVICES</div>
            <div style={{ fontSize: 10, color: "#4a5568", marginTop: 3 }}>Waterproofing & Civil Contractors | GST: 27XXXXX | Mumbai</div>
          </div>

          {/* Ledger Title */}
          <div style={{ textAlign: "center", marginBottom: 12 }}>
            <div style={{ fontSize: 14, fontWeight: 800, color: "#1a365d", textTransform: "uppercase", letterSpacing: 1 }}>
              {ledger.billTo} — Project Ledger
            </div>
            <div style={{ fontSize: 11, color: "#718096", marginTop: 2 }}>Generated: {new Date().toLocaleDateString("en-IN")}</div>
          </div>

          {/* Table */}
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1400 }}>
              <thead>
                <tr>
                  {["SR NO.", "BILL TO", "SITE NAME", "RA NO.", "INVOICE DATE", "INVOICE NO.", "TOTAL WORK DONE", "INVOICE AMOUNT", "GST AMOUNT", "TOTAL AMT INCL. GST", "RETENTION 5%", "TDS 2%", "NET RECEIVABLE", "PAYMENT RECEIVED", "BALANCE PAYMENT", "REMARKS"].map(h => (
                    <th key={h} style={thStyle}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {ledger.rows.map((row, i) => (
                  <tr key={row.id} style={{ background: i % 2 === 0 ? "#f8fafc" : "#fff" }}>
                    <td style={{ ...tdStyle, textAlign: "center", fontWeight: 700, color: "#1a365d" }}>{row.srNo}</td>
                    <td style={{ ...tdStyle, textAlign: "left", fontWeight: 600 }}>{row.billTo || ledger.billTo || "—"}</td>
                    <td style={{ ...tdStyle, textAlign: "left" }}>{row.siteName || "—"}</td>
                    <td style={{ ...tdStyle, textAlign: "center", color: "#3B82F6", fontWeight: 700 }}>{row.raNo || "—"}</td>
                    <td style={{ ...tdStyle, textAlign: "center" }}>{row.invoiceDate || "—"}</td>
                    <td style={{ ...tdStyle, textAlign: "center" }}>{row.invoiceNo || "—"}</td>
                    <td style={{ ...tdStyle, color: "#3B82F6" }}>{row.workDone ? `₹${parseFloat(row.workDone).toLocaleString("en-IN")}` : "—"}</td>
                    <td style={tdStyle}>{row.invoiceAmount ? `₹${parseFloat(row.invoiceAmount).toLocaleString("en-IN")}` : "—"}</td>
                    <td style={{ ...tdStyle, color: "#7C3AED" }}>{row.gst ? `₹${parseFloat(row.gst).toLocaleString("en-IN")}` : "—"}</td>
                    <td style={{ ...tdStyle, color: "#3B82F6", fontWeight: 700 }}>{row.totalWithGST ? `₹${parseFloat(row.totalWithGST).toLocaleString("en-IN")}` : "—"}</td>
                    <td style={{ ...tdStyle, color: "#D97706" }}>{row.retention ? `(₹${parseFloat(row.retention).toLocaleString("en-IN")})` : "—"}</td>
                    <td style={{ ...tdStyle, color: "#DC2626" }}>{row.tds ? `(₹${parseFloat(row.tds).toLocaleString("en-IN")})` : "—"}</td>
                    <td style={{ ...tdStyle, color: "#059669", fontWeight: 700 }}>{row.netReceivable ? `₹${parseFloat(row.netReceivable).toLocaleString("en-IN")}` : "—"}</td>
                    <td style={{ ...tdStyle, color: "#059669" }}>{row.paymentReceived ? `₹${parseFloat(row.paymentReceived).toLocaleString("en-IN")}` : "—"}</td>
                    <td style={{ ...tdStyle, color: parseFloat(row.balance) > 0 ? "#DC2626" : "#059669", fontWeight: 700 }}>{row.balance !== "" && row.balance !== undefined ? `₹${parseFloat(row.balance).toLocaleString("en-IN")}` : "—"}</td>
                    <td style={{ ...tdStyle, textAlign: "left" }}>{row.remarks || "—"}</td>
                  </tr>
                ))}

                {/* TOTAL ROW */}
                <tr style={{ background: "#1a365d", fontWeight: 800 }}>
                  <td colSpan={6} style={{ ...tdStyle, background: "#1a365d", color: "#fff", textAlign: "right", fontWeight: 800, border: "1px solid #2d4a7a" }}>TOTAL</td>
                  <td style={{ ...tdStyle, background: "#1a365d", color: "#93C5FD", fontWeight: 800, border: "1px solid #2d4a7a" }}>₹{totals.workDone.toLocaleString("en-IN")}</td>
                  <td style={{ ...tdStyle, background: "#1a365d", color: "#fff", fontWeight: 800, border: "1px solid #2d4a7a" }}>₹{totals.invoiceAmount.toLocaleString("en-IN")}</td>
                  <td style={{ ...tdStyle, background: "#1a365d", color: "#C4B5FD", fontWeight: 800, border: "1px solid #2d4a7a" }}>₹{totals.gst.toLocaleString("en-IN")}</td>
                  <td style={{ ...tdStyle, background: "#1a365d", color: "#93C5FD", fontWeight: 800, border: "1px solid #2d4a7a" }}>₹{totals.totalWithGST.toLocaleString("en-IN")}</td>
                  <td style={{ ...tdStyle, background: "#1a365d", color: "#FCD34D", fontWeight: 800, border: "1px solid #2d4a7a" }}>₹{totals.retention.toLocaleString("en-IN")}</td>
                  <td style={{ ...tdStyle, background: "#1a365d", color: "#FCA5A5", fontWeight: 800, border: "1px solid #2d4a7a" }}>₹{totals.tds.toLocaleString("en-IN")}</td>
                  <td style={{ ...tdStyle, background: "#1a365d", color: "#6EE7B7", fontWeight: 800, border: "1px solid #2d4a7a" }}>₹{totals.netReceivable.toLocaleString("en-IN")}</td>
                  <td style={{ ...tdStyle, background: "#1a365d", color: "#6EE7B7", fontWeight: 800, border: "1px solid #2d4a7a" }}>₹{totals.paymentReceived.toLocaleString("en-IN")}</td>
                  <td style={{ ...tdStyle, background: "#1a365d", color: totals.balance > 0 ? "#FCA5A5" : "#6EE7B7", fontWeight: 800, border: "1px solid #2d4a7a" }}>₹{totals.balance.toLocaleString("en-IN")}</td>
                  <td style={{ ...tdStyle, background: "#1a365d", border: "1px solid #2d4a7a" }}></td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Signature Section */}
          <div style={{ display: "flex", justifyContent: "space-between", marginTop: 40, paddingTop: 20 }}>
            <div style={{ textAlign: "center" }}>
              <div style={{ borderTop: "1px solid #1a365d", paddingTop: 8, width: 160, fontSize: 11, color: "#4a5568" }}>Client Signature</div>
              <div style={{ fontSize: 10, color: "#718096", marginTop: 2 }}>{ledger.billTo}</div>
            </div>
            <div style={{ textAlign: "center" }}>
              <div style={{ borderTop: "1px solid #1a365d", paddingTop: 8, width: 160, fontSize: 11, color: "#4a5568" }}>Authorized Signatory</div>
              <div style={{ fontSize: 10, color: "#718096", marginTop: 2 }}>Permatech Construction Services</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function FollowUpCalendar({ quotationEntries }) {
  const today = new Date();
  const [currentMonth, setCurrentMonth] = useState(today.getMonth());
  const [currentYear, setCurrentYear] = useState(today.getFullYear());
  const [tasks, setTasks] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [viewTask, setViewTask] = useState(null);

  const emptyForm = {
    companyName: "", contactPerson: "", contactNumber: "", email: "",
    project: "", notes: "", startDate: today.toISOString().slice(0, 10),
    frequency: "weekly", customDays: 7,
  };
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    getDocs(collection(db, "followup_tasks")).then(snap => {
      const data = snap.docs.map(d => d.data());
      if (data.length > 0) setTasks(data);
      else {
        const ls = localStorage.getItem("followupTasks");
        if (ls) setTasks(JSON.parse(ls));
      }
    }).catch(() => {
      const ls = localStorage.getItem("followupTasks");
      if (ls) setTasks(JSON.parse(ls));
    });
  }, []);

  const saveTask = async (task) => {
    const updated = [...tasks, task];
    setTasks(updated);
    localStorage.setItem("followupTasks", JSON.stringify(updated));
    try { await setDoc(fsDoc(db, "followup_tasks", String(task.id)), task); }
    catch (e) { console.error(e); }
  };

  const deleteTask = async (id) => {
    if (!window.confirm("Delete this follow-up?")) return;
    const updated = tasks.filter(t => t.id !== id);
    setTasks(updated);
    localStorage.setItem("followupTasks", JSON.stringify(updated));
    try { await deleteDoc(fsDoc(db, "followup_tasks", String(id))); }
    catch (e) { console.error(e); }
  };

  const getIntervalDays = (task) => {
    if (task.frequency === "weekly") return 7;
    if (task.frequency === "biweekly") return 14;
    if (task.frequency === "monthly") return 30;
    return Number(task.customDays) || 7;
  };

  // Generate all reminder dates for a task within current month view
  const getTaskDatesInMonth = (task, year, month) => {
    const dates = [];
    const start = new Date(task.startDate);
    const interval = getIntervalDays(task);
    const monthStart = new Date(year, month, 1);
    const monthEnd = new Date(year, month + 1, 0);

    let current = new Date(start);
    // Fast forward to near current month
    while (current < monthStart) {
      current = new Date(current.getTime() + interval * 86400000);
    }
    while (current <= monthEnd) {
      if (current >= monthStart) {
        dates.push(current.toISOString().slice(0, 10));
      }
      current = new Date(current.getTime() + interval * 86400000);
    }
    return dates;
  };

  // Get all tasks for a specific date
  const getTasksForDate = (dateStr) => {
    return tasks.filter(task => {
      const dates = getTaskDatesInMonth(task, currentYear, currentMonth);
      return dates.includes(dateStr);
    });
  };

  // Get upcoming reminders (next 7 days)
  const getUpcomingReminders = () => {
    const upcoming = [];
    const todayStr = today.toISOString().slice(0, 10);
    const next7 = new Date(today.getTime() + 7 * 86400000).toISOString().slice(0, 10);
    tasks.forEach(task => {
      for (let m = currentMonth - 1; m <= currentMonth + 1; m++) {
        const yr = m < 0 ? currentYear - 1 : m > 11 ? currentYear + 1 : currentYear;
        const mo = ((m % 12) + 12) % 12;
        getTaskDatesInMonth(task, yr, mo).forEach(date => {
          if (date >= todayStr && date <= next7) {
            upcoming.push({ ...task, reminderDate: date });
          }
        });
      }
    });
    return upcoming.sort((a, b) => a.reminderDate.localeCompare(b.reminderDate));
  };

  const handleSave = () => {
    if (!form.companyName.trim()) { alert("Please select or enter a company."); return; }
    if (!form.startDate) { alert("Please select a start date."); return; }
    const task = { ...form, id: Date.now(), customDays: Number(form.customDays) || 7 };
    saveTask(task);
    setShowForm(false);
    setForm(emptyForm);
    setSelectedDate(null);
  };

  // Calendar grid
  const firstDay = new Date(currentYear, currentMonth, 1).getDay();
  const daysInMonth = new Date(currentYear, currentMonth + 1, 0).getDate();
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

  const todayStr = today.toISOString().slice(0, 10);
  const upcomingReminders = getUpcomingReminders();

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 };

  const FREQ_COLORS = { weekly: theme.green, biweekly: theme.blue, monthly: theme.purple, custom: theme.orange };
  const FREQ_LABELS = { weekly: "Weekly", biweekly: "Bi-Weekly", monthly: "Monthly", custom: "Custom" };

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <h3 style={{ color: theme.text, fontSize: 20, fontWeight: 800, margin: 0 }}>📅 Follow-up Calendar</h3>
          <div style={{ color: theme.muted, fontSize: 12, marginTop: 3 }}>{tasks.length} follow-ups scheduled</div>
        </div>
        <Btn onClick={() => { setShowForm(true); setForm({ ...emptyForm, startDate: selectedDate || todayStr }); }}>+ Schedule Follow-up</Btn>
      </div>

      {/* Upcoming Reminders Banner */}
      {upcomingReminders.length > 0 && (
        <div style={{ background: theme.orange + "11", border: `1px solid ${theme.orange}44`, borderRadius: 12, padding: "12px 16px", marginBottom: 20 }}>
          <div style={{ color: theme.orange, fontWeight: 700, fontSize: 12, marginBottom: 8 }}>🔔 Upcoming Reminders (Next 7 Days)</div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {upcomingReminders.map((r, i) => (
              <div key={i} style={{ background: theme.card, border: `1px solid ${FREQ_COLORS[r.frequency]}44`, borderRadius: 8, padding: "8px 12px", cursor: "pointer" }} onClick={() => setViewTask(r)}>
                <div style={{ color: theme.text, fontWeight: 700, fontSize: 12 }}>{r.companyName}</div>
                <div style={{ color: theme.muted, fontSize: 11 }}>{r.reminderDate}</div>
                <span style={{ background: FREQ_COLORS[r.frequency] + "22", color: FREQ_COLORS[r.frequency], borderRadius: 4, padding: "1px 6px", fontSize: 10, fontWeight: 700 }}>{FREQ_LABELS[r.frequency]}</span>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Add Form */}
      {showForm && (
        <div style={{ background: theme.card, border: `1px solid ${theme.accent}44`, borderRadius: 12, padding: 20, marginBottom: 20 }}>
          <div style={{ color: theme.accent, fontSize: 12, fontWeight: 700, textTransform: "uppercase", marginBottom: 16 }}>➕ Schedule Follow-up</div>

          {/* Auto-fill from Quotation Register */}
          <div style={{ marginBottom: 12 }}>
            <label style={lbl}>Auto-fill from Quotation Register</label>
            <select onChange={e => {
              const entry = quotationEntries.find(q => String(q.id) === e.target.value);
              if (entry) setForm(f => ({ ...f, companyName: entry.companyName || "", project: entry.project || "", notes: entry.natureOfJob || "" }));
            }} style={{ ...inp, color: theme.accent }}>
              <option value="">— Select company from register —</option>
              {quotationEntries.map(q => (
                <option key={q.id} value={q.id}>{q.companyName} {q.project ? `— ${q.project}` : ""}</option>
              ))}
            </select>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 10 }}>
            <div><label style={lbl}>Company Name <span style={{ color: theme.red }}>*</span></label><input value={form.companyName} onChange={e => setForm(f => ({ ...f, companyName: e.target.value }))} style={inp} placeholder="Company..." /></div>
            <div><label style={lbl}>Contact Person</label><input value={form.contactPerson} onChange={e => setForm(f => ({ ...f, contactPerson: e.target.value }))} style={inp} placeholder="Name..." /></div>
            <div><label style={lbl}>Contact Number</label><input value={form.contactNumber} onChange={e => setForm(f => ({ ...f, contactNumber: e.target.value }))} style={inp} placeholder="Phone..." /></div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, marginBottom: 10 }}>
            <div><label style={lbl}>Project</label><input value={form.project} onChange={e => setForm(f => ({ ...f, project: e.target.value }))} style={inp} placeholder="Project..." /></div>
            <div><label style={lbl}>Notes</label><input value={form.notes} onChange={e => setForm(f => ({ ...f, notes: e.target.value }))} style={inp} placeholder="Reminder notes..." /></div>
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 }}>
            <div>
              <label style={lbl}>Start Date <span style={{ color: theme.red }}>*</span></label>
              <input type="date" value={form.startDate} onChange={e => setForm(f => ({ ...f, startDate: e.target.value }))} style={inp} />
            </div>
            <div>
              <label style={lbl}>Follow-up Frequency</label>
              <select value={form.frequency} onChange={e => setForm(f => ({ ...f, frequency: e.target.value }))} style={{ ...inp, color: FREQ_COLORS[form.frequency] }}>
                <option value="weekly">Weekly (Every 7 days)</option>
                <option value="biweekly">Bi-Weekly (Every 14 days)</option>
                <option value="monthly">Monthly (Every 30 days)</option>
                <option value="custom">Custom</option>
              </select>
            </div>
            {form.frequency === "custom" && (
              <div>
                <label style={lbl}>Every how many days?</label>
                <input type="number" value={form.customDays} onChange={e => setForm(f => ({ ...f, customDays: e.target.value }))} style={{ ...inp, color: theme.orange }} min="1" placeholder="e.g. 10" />
              </div>
            )}
          </div>

          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Btn variant="ghost" onClick={() => { setShowForm(false); setForm(emptyForm); }}>Cancel</Btn>
            <Btn onClick={handleSave}>💾 Save Follow-up</Btn>
          </div>
        </div>
      )}

      {/* Calendar Grid */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden", marginBottom: 20 }}>
        {/* Month Navigation */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 20px", borderBottom: `1px solid ${theme.border}`, background: theme.accent + "11" }}>
          <button onClick={() => {
            if (currentMonth === 0) { setCurrentMonth(11); setCurrentYear(y => y - 1); }
            else setCurrentMonth(m => m - 1);
          }} style={{ background: theme.accent + "22", border: `1px solid ${theme.accent}44`, color: theme.accent, borderRadius: 7, padding: "6px 14px", cursor: "pointer", fontWeight: 700 }}>← Prev</button>
          <div style={{ color: theme.text, fontWeight: 800, fontSize: 16 }}>{monthNames[currentMonth]} {currentYear}</div>
          <button onClick={() => {
            if (currentMonth === 11) { setCurrentMonth(0); setCurrentYear(y => y + 1); }
            else setCurrentMonth(m => m + 1);
          }} style={{ background: theme.accent + "22", border: `1px solid ${theme.accent}44`, color: theme.accent, borderRadius: 7, padding: "6px 14px", cursor: "pointer", fontWeight: 700 }}>Next →</button>
        </div>

        {/* Day Headers */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", background: theme.bg }}>
          {dayNames.map(d => (
            <div key={d} style={{ padding: "10px 0", textAlign: "center", color: theme.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase", borderBottom: `1px solid ${theme.border}` }}>{d}</div>
          ))}
        </div>

        {/* Calendar Days */}
        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)" }}>
          {/* Empty cells before first day */}
          {Array.from({ length: firstDay }).map((_, i) => (
            <div key={`empty-${i}`} style={{ minHeight: 90, borderRight: `1px solid ${theme.border}`, borderBottom: `1px solid ${theme.border}`, background: theme.bg + "88" }} />
          ))}

          {/* Day cells */}
          {Array.from({ length: daysInMonth }).map((_, i) => {
            const day = i + 1;
            const dateStr = `${currentYear}-${String(currentMonth + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;
            const dayTasks = getTasksForDate(dateStr);
            const isToday = dateStr === todayStr;
            const isPast = dateStr < todayStr;

            return (
              <div key={day} onClick={() => { setSelectedDate(dateStr); setShowForm(true); setForm({ ...emptyForm, startDate: dateStr }); }}
                style={{ minHeight: 90, borderRight: `1px solid ${theme.border}`, borderBottom: `1px solid ${theme.border}`, padding: "6px 8px", cursor: "pointer", background: isToday ? theme.accent + "11" : "transparent", transition: "background 0.15s" }}
                onMouseEnter={e => e.currentTarget.style.background = theme.accent + "08"}
                onMouseLeave={e => e.currentTarget.style.background = isToday ? theme.accent + "11" : "transparent"}>
                <div style={{ fontWeight: isToday ? 800 : 500, fontSize: 13, color: isToday ? theme.accent : isPast ? theme.faint : theme.text, background: isToday ? theme.accent : "transparent", borderRadius: isToday ? "50%" : 0, width: isToday ? 26 : "auto", height: isToday ? 26 : "auto", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: 4 }}>{day}</div>
                {dayTasks.slice(0, 2).map((task, ti) => (
                  <div key={ti} onClick={e => { e.stopPropagation(); setViewTask({ ...task, reminderDate: dateStr }); }}
                    style={{ background: FREQ_COLORS[task.frequency] + "22", border: `1px solid ${FREQ_COLORS[task.frequency]}44`, color: FREQ_COLORS[task.frequency], borderRadius: 4, padding: "2px 5px", fontSize: 10, fontWeight: 700, marginBottom: 2, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap", cursor: "pointer" }}>
                    🔔 {task.companyName}
                  </div>
                ))}
                {dayTasks.length > 2 && (
                  <div style={{ color: theme.muted, fontSize: 10 }}>+{dayTasks.length - 2} more</div>
                )}
              </div>
            );
          })}
        </div>
      </div>

      {/* All Follow-ups List */}
      {tasks.length > 0 && (
        <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16 }}>
          <div style={{ color: theme.text, fontWeight: 700, fontSize: 14, marginBottom: 14 }}>📋 All Scheduled Follow-ups</div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            {tasks.map(task => (
              <div key={task.id} style={{ display: "flex", justifyContent: "space-between", alignItems: "center", background: theme.bg, borderRadius: 8, padding: "10px 14px", border: `1px solid ${theme.border}` }}>
                <div>
                  <div style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>{task.companyName}</div>
                  <div style={{ color: theme.muted, fontSize: 11, marginTop: 2 }}>{task.project || ""} {task.notes ? `· ${task.notes}` : ""}</div>
                  <div style={{ color: theme.muted, fontSize: 11 }}>Starting: {task.startDate}</div>
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                  <span style={{ background: FREQ_COLORS[task.frequency] + "22", color: FREQ_COLORS[task.frequency], borderRadius: 5, padding: "3px 10px", fontSize: 11, fontWeight: 700 }}>
                    {FREQ_LABELS[task.frequency]}{task.frequency === "custom" ? ` (${task.customDays}d)` : ""}
                  </span>
                  <Btn small variant="danger" onClick={() => deleteTask(task.id)}>🗑</Btn>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* View Task Modal */}
      {viewTask && (
        <div style={{ position: "fixed", inset: 0, background: "#000a", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 16, width: "100%", maxWidth: 480 }}>
            <div style={{ padding: "18px 24px", borderBottom: `1px solid ${theme.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Follow-up Reminder</div>
                <h3 style={{ color: theme.text, margin: "4px 0 0", fontSize: 18, fontWeight: 800 }}>{viewTask.companyName}</h3>
              </div>
              <Btn small variant="ghost" onClick={() => setViewTask(null)}>✕ Close</Btn>
            </div>
            <div style={{ padding: 24 }}>
              {[
                ["Reminder Date", viewTask.reminderDate],
                ["Company", viewTask.companyName],
                ["Project", viewTask.project || "—"],
                ["Contact Person", viewTask.contactPerson || "—"],
                ["Contact Number", viewTask.contactNumber || "—"],
                ["Frequency", `${FREQ_LABELS[viewTask.frequency]}${viewTask.frequency === "custom" ? ` (every ${viewTask.customDays} days)` : ""}`],
                ["Started From", viewTask.startDate],
                ["Notes", viewTask.notes || "—"],
              ].map(([k, v]) => (
                <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: `1px solid ${theme.border}` }}>
                  <span style={{ color: theme.muted, fontSize: 12, fontWeight: 600 }}>{k}</span>
                  <span style={{ color: theme.text, fontSize: 12, fontWeight: 700 }}>{v}</span>
                </div>
              ))}
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
                <Btn variant="danger" onClick={() => { deleteTask(viewTask.id); setViewTask(null); }}>🗑 Delete</Btn>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function EnquiryLogbook() {
  const [entries, setEntries] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editEntry, setEditEntry] = useState(null);
  const [viewEntry, setViewEntry] = useState(null);

  const emptyRow = {
    engRefNo: "", date: new Date().toISOString().slice(0, 10),
    companyName: "", projectName: "", natureOfWork: "", jobStatus: "",
    dateOfSubmission: "", actualDateOfSubmission: "", qtReference: "",
    amount: "", contactPerson: "", contactNumber: "", email: "",
    status: "", remarks: ""
  };
  const [form, setForm] = useState(emptyRow);

  useEffect(() => {
    getDocs(collection(db, "enquiry_logbook")).then(snap => {
      const data = snap.docs.map(d => d.data());
      if (data.length > 0) setEntries(data);
      else {
        const ls = localStorage.getItem("enquiryLogbook");
        if (ls) setEntries(JSON.parse(ls));
      }
    }).catch(() => {
      const ls = localStorage.getItem("enquiryLogbook");
      if (ls) setEntries(JSON.parse(ls));
    });
  }, []);

  const saveEntry = async (entry) => {
    const isEdit = entries.find(e => e.id === entry.id);
    const updated = isEdit ? entries.map(e => e.id === entry.id ? entry : e) : [entry, ...entries];
    setEntries(updated);
    localStorage.setItem("enquiryLogbook", JSON.stringify(updated));
    try { await setDoc(fsDoc(db, "enquiry_logbook", String(entry.id)), entry); }
    catch (e) { console.error(e); }
  };

  const deleteEntry = async (id) => {
    if (!window.confirm("Delete this entry?")) return;
    const updated = entries.filter(e => e.id !== id);
    setEntries(updated);
    localStorage.setItem("enquiryLogbook", JSON.stringify(updated));
    try { await deleteDoc(fsDoc(db, "enquiry_logbook", String(id))); }
    catch (e) { console.error(e); }
  };

  const handleSave = () => {
    if (!form.companyName.trim()) { alert("Please enter Company Name."); return; }
    if (!form.date) { alert("Please enter Date."); return; }
    const entry = { ...form, id: editEntry?.id || Date.now() };
    saveEntry(entry);
    setShowForm(false);
    setEditEntry(null);
    setForm(emptyRow);
  };

  const handleEdit = (entry) => {
    setEditEntry(entry);
    setForm(entry);
    setShowForm(true);
    setViewEntry(null);
  };

  const exportToExcel = async () => {
    if (entries.length === 0) { alert("No entries to export."); return; }
    
    const headers = ["Eng. Ref. No.", "Date", "Company Name", "Project Name", "Nature of Work", "Job Status", "Date of Submission", "Actual Date of Submission", "Qt. Reference", "Amount", "Contact Person / Designation", "Contact Number", "Email", "Status", "Remarks"];
    const rows = entries.map(e => [e.engRefNo||"", e.date||"", e.companyName||"", e.projectName||"", e.natureOfWork||"", e.jobStatus||"", e.dateOfSubmission||"", e.actualDateOfSubmission||"", e.qtReference||"", e.amount||"", e.contactPerson||"", e.contactNumber||"", e.email||"", e.status||"", e.remarks||""]);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    ws["!cols"] = [{ wch: 14 }, { wch: 13 }, { wch: 26 }, { wch: 24 }, { wch: 22 }, { wch: 16 }, { wch: 18 }, { wch: 22 }, { wch: 18 }, { wch: 14 }, { wch: 28 }, { wch: 16 }, { wch: 26 }, { wch: 14 }, { wch: 24 }];
    headers.forEach((_, colIdx) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIdx });
      if (!ws[cellRef]) return;
      ws[cellRef].s = { fill: { fgColor: { rgb: "C6EFCE" } }, font: { bold: true, sz: 13, color: { rgb: "1A6632" } }, alignment: { horizontal: "center", vertical: "center", wrapText: true }, border: { top: { style: "thin", color: { rgb: "1A6632" } }, bottom: { style: "thin", color: { rgb: "1A6632" } }, left: { style: "thin", color: { rgb: "1A6632" } }, right: { style: "thin", color: { rgb: "1A6632" } } } };
    });
    rows.forEach((_, rowIdx) => {
      headers.forEach((__, colIdx) => {
        const cellRef = XLSX.utils.encode_cell({ r: rowIdx + 1, c: colIdx });
        if (!ws[cellRef]) return;
        ws[cellRef].s = { alignment: { horizontal: "left", vertical: "center", wrapText: true }, border: { top: { style: "thin", color: { rgb: "CCCCCC" } }, bottom: { style: "thin", color: { rgb: "CCCCCC" } }, left: { style: "thin", color: { rgb: "CCCCCC" } }, right: { style: "thin", color: { rgb: "CCCCCC" } } }, fill: { fgColor: { rgb: rowIdx % 2 === 0 ? "F0FFF4" : "FFFFFF" } } };
      });
    });
    ws["!rows"] = [{ hpt: 28 }];
    XLSX.utils.book_append_sheet(wb, ws, "Enquiry Logbook");
    XLSX.writeFile(wb, `Enquiry_Logbook_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 };
  const thStyle = { padding: "12px 14px", background: theme.accent + "22", color: theme.accent, fontSize: 12, fontWeight: 800, textTransform: "uppercase", textAlign: "left", borderBottom: `2px solid ${theme.accent}`, whiteSpace: "nowrap" };
  const tdStyle = { padding: "11px 14px", borderBottom: `1px solid ${theme.border}`, fontSize: 14, color: theme.text, verticalAlign: "middle" };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <h3 style={{ color: theme.text, fontSize: 20, fontWeight: 800, margin: 0 }}>📒 Abstract Enquiry Logbook</h3>
          <div style={{ color: theme.muted, fontSize: 12, marginTop: 3 }}>{entries.length} entries</div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn variant="ghost" onClick={exportToExcel}>📥 Export Excel</Btn>
          <Btn onClick={() => { setShowForm(true); setEditEntry(null); setForm(emptyRow); }}>+ Add Entry</Btn>
        </div>
      </div>

      <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
        <StatCard label="Total Enquiries" value={entries.length} color={theme.blue} icon="📒" />
        <StatCard label="This Month" value={entries.filter(e => e.date?.startsWith(new Date().toISOString().slice(0, 7))).length} color={theme.accent} icon="📅" />
        <StatCard label="Companies" value={new Set(entries.map(e => e.companyName)).size} color={theme.purple} icon="🏢" />
        <StatCard label="Total Amount" value={`₹${entries.reduce((s, e) => s + (isNaN(Number(e.amount)) ? 0 : Number(e.amount) || 0), 0).toLocaleString("en-IN")}`} color={theme.green} icon="💰" />
      </div>

      {showForm && (
        <div style={{ background: theme.card, border: `1px solid ${theme.accent}44`, borderRadius: 12, padding: 20, marginBottom: 20 }}>
          <div style={{ color: theme.accent, fontSize: 12, fontWeight: 700, textTransform: "uppercase", marginBottom: 16 }}>
            {editEntry ? "✏️ Edit Entry" : "➕ New Enquiry Entry"}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 10, marginBottom: 10 }}>
            <div><label style={lbl}>Eng. Ref. No.</label><input value={form.engRefNo} onChange={e => setForm(f => ({ ...f, engRefNo: e.target.value }))} style={inp} placeholder="Ref no..." /></div>
            <div><label style={lbl}>Date <span style={{ color: theme.red }}>*</span></label><input type="date" value={form.date} onChange={e => setForm(f => ({ ...f, date: e.target.value }))} style={inp} /></div>
            <div><label style={lbl}>Company Name <span style={{ color: theme.red }}>*</span></label><input value={form.companyName} onChange={e => setForm(f => ({ ...f, companyName: e.target.value }))} style={inp} placeholder="Company..." /></div>
            <div><label style={lbl}>Project Name</label><input value={form.projectName} onChange={e => setForm(f => ({ ...f, projectName: e.target.value }))} style={inp} placeholder="Project..." /></div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 10, marginBottom: 10 }}>
            <div><label style={lbl}>Nature of Work</label><input value={form.natureOfWork} onChange={e => setForm(f => ({ ...f, natureOfWork: e.target.value }))} style={inp} placeholder="e.g. Waterproofing..." /></div>
            <div><label style={lbl}>Job Status</label><input value={form.jobStatus} onChange={e => setForm(f => ({ ...f, jobStatus: e.target.value }))} style={inp} placeholder="Status..." /></div>
            <div><label style={lbl}>Date of Submission</label><input type="date" value={form.dateOfSubmission} onChange={e => setForm(f => ({ ...f, dateOfSubmission: e.target.value }))} style={inp} /></div>
            <div><label style={lbl}>Actual Date of Submission</label><input type="date" value={form.actualDateOfSubmission} onChange={e => setForm(f => ({ ...f, actualDateOfSubmission: e.target.value }))} style={inp} /></div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 10, marginBottom: 10 }}>
            <div><label style={lbl}>Qt. Reference</label><input value={form.qtReference} onChange={e => setForm(f => ({ ...f, qtReference: e.target.value }))} style={inp} placeholder="Qt ref..." /></div>
            <div><label style={lbl}>Amount</label><input value={form.amount} onChange={e => setForm(f => ({ ...f, amount: e.target.value }))} style={{ ...inp, color: theme.green, fontWeight: 700 }} placeholder="e.g. 50000" /></div>
            <div><label style={lbl}>Contact Person / Designation</label><input value={form.contactPerson} onChange={e => setForm(f => ({ ...f, contactPerson: e.target.value }))} style={inp} placeholder="Name / Designation..." /></div>
            <div><label style={lbl}>Contact Number</label><input value={form.contactNumber} onChange={e => setForm(f => ({ ...f, contactNumber: e.target.value }))} style={inp} placeholder="Phone..." /></div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 10, marginBottom: 16 }}>
            <div><label style={lbl}>Email</label><input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} style={inp} placeholder="email@..." /></div>
            <div><label style={lbl}>Status</label><input value={form.status} onChange={e => setForm(f => ({ ...f, status: e.target.value }))} style={inp} placeholder="Status..." /></div>
            <div><label style={lbl}>Remarks</label><input value={form.remarks} onChange={e => setForm(f => ({ ...f, remarks: e.target.value }))} style={inp} placeholder="Remarks..." /></div>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Btn variant="ghost" onClick={() => { setShowForm(false); setEditEntry(null); setForm(emptyRow); }}>Cancel</Btn>
            <Btn onClick={handleSave}>💾 {editEntry ? "Save Changes" : "Add Entry"}</Btn>
          </div>
        </div>
      )}

      {entries.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>📒</div>
          <div style={{ color: theme.muted, fontSize: 14 }}>No entries yet. Click "+ Add Entry" to start.</div>
        </div>
      ) : (
        <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1600 }}>
            <thead>
              <tr>
                {["Eng. Ref.", "Date", "Company", "Project", "Nature of Work", "Job Status", "Date of Sub.", "Actual Sub.", "Qt. Ref.", "Amount", "Contact", "Phone", "Email", "Status", "Remarks", "Actions"].map(h => (
                  <th key={h} style={thStyle}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {entries.map((entry, i) => (
                <tr key={entry.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                  <td style={{ ...tdStyle, color: theme.accent, fontWeight: 700 }}>{entry.engRefNo || "—"}</td>
                  <td style={{ ...tdStyle, whiteSpace: "nowrap" }}>{entry.date}</td>
                  <td style={{ ...tdStyle, fontWeight: 700 }}>{entry.companyName}</td>
                  <td style={{ ...tdStyle, color: theme.muted }}>{entry.projectName || "—"}</td>
                  <td style={{ ...tdStyle, color: theme.muted }}>{entry.natureOfWork || "—"}</td>
                  <td style={tdStyle}>{entry.jobStatus ? <span style={{ background: theme.blue + "22", color: theme.blue, borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>{entry.jobStatus}</span> : "—"}</td>
                  <td style={{ ...tdStyle, whiteSpace: "nowrap", color: theme.muted }}>{entry.dateOfSubmission || "—"}</td>
                  <td style={{ ...tdStyle, whiteSpace: "nowrap", color: theme.muted }}>{entry.actualDateOfSubmission || "—"}</td>
                  <td style={tdStyle}>{entry.qtReference || "—"}</td>
                  <td style={{ ...tdStyle, color: theme.green, fontWeight: 700 }}>{entry.amount ? (isNaN(Number(entry.amount)) ? entry.amount : `₹${Number(entry.amount).toLocaleString("en-IN")}`) : "—"}</td>
                  <td style={tdStyle}>{entry.contactPerson || "—"}</td>
                  <td style={tdStyle}>{entry.contactNumber || "—"}</td>
                  <td style={{ ...tdStyle, color: theme.blue }}>{entry.email || "—"}</td>
                  <td style={tdStyle}>{entry.status ? <span style={{ background: theme.purple + "22", color: theme.purple, borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>{entry.status}</span> : "—"}</td>
                  <td style={{ ...tdStyle, color: theme.muted }}>{entry.remarks || "—"}</td>
                  <td style={tdStyle}>
                    <div style={{ display: "flex", gap: 6 }}>
                      <Btn small variant="ghost" onClick={() => setViewEntry(entry)}>👁</Btn>
                      <Btn small variant="ghost" onClick={() => handleEdit(entry)}>✏️</Btn>
                      <Btn small variant="danger" onClick={() => deleteEntry(entry.id)}>🗑</Btn>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {viewEntry && (
        <div style={{ position: "fixed", inset: 0, background: "#000a", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
          <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 16, width: "100%", maxWidth: 650, maxHeight: "90vh", overflowY: "auto" }}>
            <div style={{ padding: "18px 24px", borderBottom: `1px solid ${theme.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Enquiry Logbook</div>
                <h3 style={{ color: theme.text, margin: "4px 0 0", fontSize: 18, fontWeight: 800 }}>{viewEntry.companyName}</h3>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <Btn small onClick={() => window.print()} variant="blue">🖨 Print</Btn>
                <Btn small variant="ghost" onClick={() => setViewEntry(null)}>✕ Close</Btn>
              </div>
            </div>
            <div style={{ padding: 24 }}>
              {[
                ["Eng. Ref. No.", viewEntry.engRefNo],
                ["Date", viewEntry.date],
                ["Company Name", viewEntry.companyName],
                ["Project Name", viewEntry.projectName],
                ["Nature of Work", viewEntry.natureOfWork],
                ["Job Status", viewEntry.jobStatus],
                ["Date of Submission", viewEntry.dateOfSubmission],
                ["Actual Date of Submission", viewEntry.actualDateOfSubmission],
                ["Qt. Reference", viewEntry.qtReference],
                ["Amount", viewEntry.amount ? (isNaN(Number(viewEntry.amount)) ? viewEntry.amount : `₹${Number(viewEntry.amount).toLocaleString("en-IN")}`) : "—"],
                ["Contact Person / Designation", viewEntry.contactPerson],
                ["Contact Number", viewEntry.contactNumber],
                ["Email", viewEntry.email],
                ["Status", viewEntry.status],
                ["Remarks", viewEntry.remarks],
              ].map(([k, v]) => (
                <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: `1px solid ${theme.border}` }}>
                  <span style={{ color: theme.muted, fontSize: 12, fontWeight: 600 }}>{k}</span>
                  <span style={{ color: theme.text, fontSize: 12, fontWeight: 700, textAlign: "right", maxWidth: "60%" }}>{v || "—"}</span>
                </div>
              ))}
              <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 16 }}>
                <Btn variant="ghost" onClick={() => handleEdit(viewEntry)}>✏️ Edit</Btn>
                <Btn variant="danger" onClick={() => { deleteEntry(viewEntry.id); setViewEntry(null); }}>🗑 Delete</Btn>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

function QuotationModule() {
  const [quotations, setQuotations] = useState([]);
  const [mode, setMode] = useState("list");
  const [activeQuotation, setActiveQuotation] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDocs(collection(db, "quotations_template")).then(snap => {
      const data = snap.docs.map(d => d.data());
      if (data.length > 0) setQuotations(data);
      else {
        const ls = localStorage.getItem("quotationsTemplate");
        if (ls) setQuotations(JSON.parse(ls));
      }
    }).catch(() => {
      const ls = localStorage.getItem("quotationsTemplate");
      if (ls) setQuotations(JSON.parse(ls));
    }).finally(() => setLoading(false));
  }, []);

  const saveQuotation = async (q) => {
    const isEdit = quotations.find(x => x.id === q.id);
    const updated = isEdit ? quotations.map(x => x.id === q.id ? q : x) : [q, ...quotations];
    setQuotations(updated);
    localStorage.setItem("quotationsTemplate", JSON.stringify(updated));
    try { await setDoc(fsDoc(db, "quotations_template", String(q.id)), q); }
    catch (e) { console.error(e); }
  };

  const deleteQuotation = async (id) => {
    if (!window.confirm("Delete this quotation?")) return;
    const updated = quotations.filter(q => q.id !== id);
    setQuotations(updated);
    localStorage.setItem("quotationsTemplate", JSON.stringify(updated));
    try { await deleteDoc(fsDoc(db, "quotations_template", String(id))); }
    catch (e) { console.error(e); }
  };

  if (loading) return <div style={{ color: theme.muted, padding: 20 }}>Loading...</div>;

  if (mode === "create" || mode === "edit") {
    return <QuotationForm
      existing={activeQuotation}
      onSave={q => { saveQuotation(q); setMode("list"); setActiveQuotation(null); }}
      onBack={() => { setMode("list"); setActiveQuotation(null); }}
    />;
  }

  if (mode === "view" && activeQuotation) {
    return <QuotationPreview
      quotation={activeQuotation}
      onClose={() => { setMode("list"); setActiveQuotation(null); }}
      onEdit={() => setMode("edit")}
    />;
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <h3 style={{ color: theme.text, fontSize: 20, fontWeight: 800, margin: 0 }}>📄 Quotations</h3>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{quotations.length} quotations</div>
        </div>
        <Btn onClick={() => { setActiveQuotation(null); setMode("create"); }}>+ New Quotation</Btn>
      </div>

      <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
        <StatCard label="Total Quotations" value={quotations.length} color={theme.blue} icon="📄" />
        <StatCard label="This Month" value={quotations.filter(q => q.date?.startsWith(new Date().toISOString().slice(0, 7))).length} color={theme.accent} icon="📅" />
        <StatCard label="Total Value" value={`₹${quotations.reduce((s, q) => s + (Number(q.grandTotal) || 0), 0).toLocaleString("en-IN")}`} color={theme.green} icon="💰" />
      </div>

      {quotations.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>📄</div>
          <div style={{ color: theme.muted }}>No quotations yet. Click "+ New Quotation" to start.</div>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {quotations.map((q, i) => (
            <div key={q.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
              <div>
                <div style={{ color: theme.text, fontWeight: 800, fontSize: 15 }}>📄 {q.quotationNo || `Quotation ${i + 1}`}</div>
                <div style={{ color: theme.muted, fontSize: 12, marginTop: 3 }}>
                  {q.clientName || "—"} · {q.date || "—"} ·
                  <span style={{ color: theme.accent, fontWeight: 700 }}> ₹{(q.grandTotal || 0).toLocaleString("en-IN")}</span>
                </div>
                {q.subject && <div style={{ color: theme.faint, fontSize: 11, marginTop: 2 }}>{q.subject}</div>}
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                {q.approvalStatus && (
  <span style={{
    background: q.approvalStatus === "Approved" ? theme.green + "22" : theme.red + "22",
    color: q.approvalStatus === "Approved" ? theme.green : theme.red,
    border: `1px solid ${q.approvalStatus === "Approved" ? theme.green : theme.red}44`,
    borderRadius: 5, padding: "2px 10px", fontSize: 11, fontWeight: 700
  }}>
    {q.approvalStatus === "Approved" ? "✅ Approved" : "❌ Not Approved"}
  </span>
)}
                <Btn small variant="ghost" onClick={() => { setActiveQuotation(q); setMode("view"); }}>👁 View</Btn>
<Btn small variant="ghost" onClick={() => { setActiveQuotation(q); setMode("edit"); }}>✏️ Edit</Btn>
<button onClick={() => saveQuotation({ ...q, approvalStatus: q.approvalStatus === "Approved" ? "Not Approved" : "Approved" })}
  style={{ background: q.approvalStatus === "Approved" ? theme.green + "22" : q.approvalStatus === "Not Approved" ? theme.red + "22" : theme.card, border: `1px solid ${q.approvalStatus === "Approved" ? theme.green : q.approvalStatus === "Not Approved" ? theme.red : theme.border}44`, color: q.approvalStatus === "Approved" ? theme.green : q.approvalStatus === "Not Approved" ? theme.red : theme.muted, borderRadius: 7, padding: "4px 10px", fontSize: 11, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}>
  {q.approvalStatus === "Approved" ? "✅ Approved" : q.approvalStatus === "Not Approved" ? "❌ Not Approved" : "⬜ Set Status"}
</button>
<Btn small variant="danger" onClick={() => deleteQuotation(q.id)}>🗑</Btn>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


function QuotationForm({ existing, onSave, onBack }) {
  const today = new Date().toISOString().slice(0, 10);
  const [quotationNo, setQuotationNo] = useState(existing?.quotationNo || "");
  const [date, setDate] = useState(existing?.date || today);
  const [clientName, setClientName] = useState(existing?.clientName || "");
  const [clientAddress, setClientAddress] = useState(existing?.clientAddress || "");
  const [subject, setSubject] = useState(existing?.subject || "");
  const [gstPct, setGstPct] = useState(existing?.gstPct || 18);
  const [notes, setNotes] = useState(existing?.notes || "If quantities increase due to revised drawings or additional site requirements, the rates will be revised proportionately.\nAny extra work beyond the original scope will be treated as a variation and charged accordingly.");
  const [paymentTerms, setPaymentTerms] = useState(existing?.paymentTerms || "10% Advance payable along with issue of work order.\n60% Advance Against the Material Supply on submission of Proforma invoice.\n30% against RA Bill within 30 days.");
  const [sections, setSections] = useState(existing?.sections || [{
    id: Date.now(), label: "A", title: "REPAIRING OF PARAPET WALL",
    items: [
      { id: Date.now() + 1, description: "Surface Preparation", unit: "", qty: "", rate: "", type: "main" },
      { id: Date.now() + 2, description: "", unit: "", qty: "", rate: "", type: "sub" },
    ]
  }]);

  const addSection = () => {
    const labels = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    setSections(s => [...s, {
      id: Date.now(), label: labels[s.length] || String(s.length + 1),
      title: `SECTION ${labels[s.length] || s.length + 1}`,
      items: [
        { id: Date.now() + 1, description: "", unit: "", qty: "", rate: "", type: "main" },
        { id: Date.now() + 2, description: "", unit: "", qty: "", rate: "", type: "sub" },
      ]
    }]);
  };

  const deleteSection = (sid) => setSections(s => s.filter(x => x.id !== sid));
  const updateSection = (sid, key, val) => setSections(s => s.map(x => x.id === sid ? { ...x, [key]: val } : x));
  const addMainItem = (sid) => setSections(s => s.map(x => x.id === sid ? { ...x, items: [...x.items, { id: Date.now(), description: "", unit: "", qty: "", rate: "", type: "main" }] } : x));
  const addSubItem = (sid) => setSections(s => s.map(x => x.id === sid ? { ...x, items: [...x.items, { id: Date.now(), description: "", unit: "", qty: "", rate: "", type: "sub" }] } : x));
  const updateItem = (sid, iid, key, val) => setSections(s => s.map(x => x.id === sid ? { ...x, items: x.items.map(it => it.id === iid ? { ...it, [key]: val } : it) } : x));
  const deleteItem = (sid, iid) => setSections(s => s.map(x => x.id === sid ? { ...x, items: x.items.filter(it => it.id !== iid) } : x));

  const subtotal = sections.reduce((s, sec) => s + sec.items.reduce((ss, it) => {
    const type = it.type || (it.isHeader ? "main" : "sub");
    return ss + (type === "sub" ? (Number(it.qty) || 0) * (Number(it.rate) || 0) : 0);
  }, 0), 0);
  const gstAmount = Math.round(subtotal * (Number(gstPct) || 0) / 100 * 100) / 100;
  const grandTotal = Math.round((subtotal + gstAmount) * 100) / 100;

  const handleSave = () => {
    if (!clientName.trim()) { alert("Please enter client name."); return; }
    onSave({ id: existing?.id || Date.now(), quotationNo, date, clientName, clientAddress, subject, gstPct, notes, paymentTerms, sections, subtotal, gstAmount, grandTotal, createdAt: existing?.createdAt || new Date().toISOString(), updatedAt: new Date().toISOString() });
  };

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "8px 10px", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <button onClick={onBack} style={{ background: "none", border: "none", color: theme.muted, cursor: "pointer", fontSize: 13, marginBottom: 8, padding: 0 }}>← Back</button>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📄 {existing ? "Edit Quotation" : "New Quotation"}</h2>
        </div>
        <Btn onClick={handleSave}>💾 Save Quotation</Btn>
      </div>

      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 16, textAlign: "center" }}>
        <div style={{ color: theme.accent, fontWeight: 900, fontSize: 16, textTransform: "uppercase", letterSpacing: 1 }}>PERMATECH CONCRETE SOLUTIONS</div>
        <div style={{ color: theme.muted, fontSize: 11, marginTop: 4 }}>18, Divya Darshan, Mount Mary Steps, Bandra (W), Mumbai - 400 050.</div>
        <div style={{ color: theme.muted, fontSize: 11 }}>Tel: +022 3564 3532 · Mobile: 7738131631 · Email: info@permatech.in</div>
        <div style={{ color: theme.faint, fontSize: 10, marginTop: 3 }}>SPECIALIZED IN CRYSTALLINE WATERPROOFING | PU INJECTION GROUTING SYSTEM | POLYUREA WATERPROOFING</div>
      </div>

      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 16 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
          <div><label style={lbl}>Quotation No.</label><input value={quotationNo} onChange={e => setQuotationNo(e.target.value)} style={inp} placeholder="e.g. PCS/AV/Q-124/2025-26" /></div>
          <div><label style={lbl}>Date</label><input type="date" value={date} onChange={e => setDate(e.target.value)} style={inp} /></div>
          <div><label style={lbl}>GST %</label><input type="number" value={gstPct} onChange={e => setGstPct(e.target.value)} style={{ ...inp, color: theme.accent }} /></div>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 12 }}>
          <div><label style={lbl}>Client Name</label><input value={clientName} onChange={e => setClientName(e.target.value)} style={inp} placeholder="Client name..." /></div>
          <div><label style={lbl}>Client Address</label><input value={clientAddress} onChange={e => setClientAddress(e.target.value)} style={inp} placeholder="Client address..." /></div>
        </div>
        <div><label style={lbl}>Subject</label><input value={subject} onChange={e => setSubject(e.target.value)} style={inp} placeholder="e.g. Quotation for Cold Polyurea Coating Terrace Waterproofing" /></div>
      </div>

      {sections.map((sec, si) => (
        <div key={sec.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden", marginBottom: 14 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 16px", background: theme.accent + "11", borderBottom: `1px solid ${theme.border}` }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <input value={sec.label} onChange={e => updateSection(sec.id, "label", e.target.value)}
                style={{ ...inp, width: 50, textAlign: "center", fontWeight: 800, color: theme.accent, background: "transparent", border: `1px solid ${theme.accent}44` }} />
              <input value={sec.title} onChange={e => updateSection(sec.id, "title", e.target.value)}
                style={{ ...inp, width: 260, fontWeight: 700, color: theme.text, background: "transparent", border: `1px solid ${theme.border}` }} placeholder="Section title e.g. REPAIRING OF PARAPET WALL..." />
            </div>
            <div style={{ display: "flex", gap: 6 }}>
              <Btn small variant="ghost" onClick={() => addMainItem(sec.id)}>+ Main Item</Btn>
              <Btn small variant="ghost" onClick={() => addSubItem(sec.id)}>+ Sub Item</Btn>
              {sections.length > 1 && <Btn small variant="danger" onClick={() => deleteSection(sec.id)}>🗑</Btn>}
            </div>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 700 }}>
              <thead>
                <tr>
                  {["SR", "Item Description", "Unit", "Quantity", "Rate (₹)", "Amount (₹)", ""].map(h => (
                    <th key={h} style={{ padding: "8px 10px", background: theme.bg, color: theme.muted, fontSize: 10, fontWeight: 700, textTransform: "uppercase", textAlign: h === "Item Description" ? "left" : "center", borderBottom: `2px solid ${theme.border}` }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {(() => {
                  let mainCount = 0;
                  let subCount = 0;
                  return sec.items.map((item) => {
                    const type = item.type || (item.isHeader ? "main" : "sub");
                    let srLabel = "";
                    if (type === "main") { mainCount++; subCount = 0; srLabel = String(mainCount); }
                    else { subCount++; srLabel = `${mainCount}.${subCount}`; }
                    const amount = type === "sub" ? Math.round((Number(item.qty) || 0) * (Number(item.rate) || 0) * 100) / 100 : 0;
                    return (
                      <tr key={item.id} style={{ background: type === "main" ? theme.accent + "08" : "transparent" }}>
                        <td style={{ padding: "8px 10px", borderBottom: `1px solid ${theme.border}`, textAlign: "center", color: type === "main" ? theme.accent : theme.faint, fontWeight: type === "main" ? 700 : 400, fontSize: 12, width: 60 }}>{srLabel}</td>
                        <td style={{ padding: "7px 8px", borderBottom: `1px solid ${theme.border}`, minWidth: 250 }}>
                          <input value={item.description} onChange={e => updateItem(sec.id, item.id, "description", e.target.value)}
                            style={{ ...inp, background: "transparent", border: "none", borderBottom: `1px solid ${theme.border}`, borderRadius: 0, fontWeight: type === "main" ? 700 : 400, color: type === "main" ? theme.accent : theme.text, paddingLeft: type === "sub" ? 20 : 0 }}
                            placeholder={type === "main" ? "Main item name e.g. Surface Preparation..." : "Sub item description e.g. Carefully remove existing plaster..."} />
                        </td>
                        <td style={{ padding: "7px 8px", borderBottom: `1px solid ${theme.border}`, width: 90 }}>
                          {type === "sub" && <input value={item.unit} onChange={e => updateItem(sec.id, item.id, "unit", e.target.value)} style={{ ...inp, background: "transparent", border: "none", borderBottom: `1px solid ${theme.border}`, borderRadius: 0, textAlign: "center" }} placeholder="Sq.Ft" />}
                        </td>
                        <td style={{ padding: "7px 8px", borderBottom: `1px solid ${theme.border}`, width: 120 }}>
                          {type === "sub" && <input value={item.qty} onChange={e => updateItem(sec.id, item.id, "qty", e.target.value)} style={{ ...inp, background: "transparent", border: "none", borderBottom: `1px solid ${theme.border}`, borderRadius: 0, textAlign: "center", color: theme.blue }} placeholder="0 or As per actual" />}
                        </td>
                        <td style={{ padding: "7px 8px", borderBottom: `1px solid ${theme.border}`, width: 100 }}>
                          {type === "sub" && <input type="number" value={item.rate} onChange={e => updateItem(sec.id, item.id, "rate", e.target.value)} style={{ ...inp, background: "transparent", border: "none", borderBottom: `1px solid ${theme.border}`, borderRadius: 0, textAlign: "center", color: theme.accent }} placeholder="0" />}
                        </td>
                        <td style={{ padding: "7px 10px", borderBottom: `1px solid ${theme.border}`, textAlign: "center", color: theme.green, fontWeight: 700, width: 100 }}>
                          {type === "sub" ? (amount > 0 ? `₹${amount.toLocaleString("en-IN")}` : "—") : ""}
                        </td>
                        <td style={{ padding: "7px 8px", borderBottom: `1px solid ${theme.border}`, width: 30 }}>
                          <button onClick={() => deleteItem(sec.id, item.id)} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 22, height: 22, fontSize: 12, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                        </td>
                      </tr>
                    );
                  });
                })()}
              </tbody>
            </table>
          </div>
        </div>
      ))}

      <Btn variant="ghost" onClick={addSection}>+ Add Section</Btn>

      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginTop: 14, marginBottom: 14 }}>
        {[["Subtotal", subtotal, theme.text], [`GST @ ${gstPct}%`, gstAmount, theme.muted], ["Grand Total", grandTotal, theme.green]].map(([label, val, color]) => (
          <div key={label} style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: label !== "Grand Total" ? `1px solid ${theme.border}` : "none" }}>
            <span style={{ color: theme.muted, fontSize: 13, fontWeight: label === "Grand Total" ? 700 : 400 }}>{label}</span>
            <span style={{ color, fontWeight: label === "Grand Total" ? 900 : 600, fontSize: label === "Grand Total" ? 18 : 14 }}>₹{Number(val).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</span>
          </div>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 14, marginBottom: 14 }}>
        <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 14 }}>
          <label style={lbl}>Notes</label>
          <textarea value={notes} onChange={e => setNotes(e.target.value)} rows={4} style={{ ...inp, resize: "vertical", lineHeight: 1.6 }} placeholder="Notes..." />
        </div>
        <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 14 }}>
          <label style={lbl}>Payment Terms</label>
          <textarea value={paymentTerms} onChange={e => setPaymentTerms(e.target.value)} rows={4} style={{ ...inp, resize: "vertical", lineHeight: 1.6 }} placeholder="Payment terms..." />
        </div>
      </div>
    </div>
  );
}

function QuotationPreview({ quotation, onClose, onEdit }) {
  const thP = { padding: "8px 10px", background: "#162040", color: "#93c5fd", fontSize: 11, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: "1px solid rgba(99,179,237,0.2)" };
  const tdP = { padding: "8px 10px", border: "1px solid #e2e8f0", fontSize: 12, verticalAlign: "top" };

  return (
    <div>
      <style>{`@media print { body * { visibility: hidden !important; } #quot-print, #quot-print * { visibility: visible !important; } #quot-print { position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; background: white !important; padding: 20px !important; } .no-print { display: none !important; } }`}</style>

      <div className="no-print" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <button onClick={onClose} style={{ background: "none", border: "none", color: theme.muted, cursor: "pointer", fontSize: 13, padding: 0 }}>← Back</button>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn variant="ghost" onClick={onEdit}>✏️ Edit</Btn>
          <Btn variant="blue" onClick={() => window.print()}>🖨 Print / PDF</Btn>
        </div>
      </div>

      <div id="quot-print" style={{ background: "#fff", color: "#000", borderRadius: 12, border: `1px solid ${theme.border}`, padding: 28 }}>
        <div style={{ textAlign: "center", borderBottom: "2px solid #162040", paddingBottom: 14, marginBottom: 16 }}>
          <div style={{ fontSize: 18, fontWeight: 900, color: "#162040", textTransform: "uppercase", letterSpacing: 1 }}>Permatech Concrete Solutions</div>
          <div style={{ fontSize: 11, color: "#64748b", marginTop: 4 }}>18, Divya Darshan, Mount Mary Steps, Bandra (W), Mumbai - 400050,</div>
          <div style={{ fontSize: 11, color: "#64748b" }}>Tel No. +022 3564 3532, Mobile No. 7738131631, Email: info@permatech.in</div>
          <div style={{ fontSize: 10, color: "#94a3b8", marginTop: 4, fontStyle: "italic" }}>SPECIALIZED IN CRYSTALLINE WATERPROOFING | PU INJECTION GROUTING SYSTEM | POLYUREA WATERPROOFING</div>
          <div style={{ fontSize: 15, fontWeight: 800, color: "#162040", marginTop: 10, letterSpacing: 1 }}>QUOTATION</div>
        </div>

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16, fontSize: 12 }}>
          <div>
            <div style={{ color: "#64748b", marginBottom: 4 }}>To,</div>
            <div style={{ fontWeight: 700, color: "#0f1f3d", fontSize: 14 }}>{quotation.clientName}</div>
            {quotation.clientAddress && <div style={{ color: "#374151", marginTop: 3, whiteSpace: "pre-line" }}>{quotation.clientAddress}</div>}
          </div>
          <div>
            {[["Quotation No.", quotation.quotationNo || "—"], ["Date", quotation.date ? new Date(quotation.date).toLocaleDateString("en-IN") : "—"]].map(([k, v]) => (
              <div key={k} style={{ display: "flex", gap: 8, marginBottom: 6 }}>
                <span style={{ color: "#64748b", fontWeight: 600, minWidth: 120 }}>{k}:</span>
                <span style={{ color: "#0f1f3d", fontWeight: 700 }}>{v}</span>
              </div>
            ))}
            {quotation.subject && <div style={{ marginTop: 8, background: "#f0f4ff", borderRadius: 6, padding: "6px 10px", color: "#162040", fontWeight: 600, fontSize: 12 }}>Sub: {quotation.subject}</div>}
          </div>
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 16 }}>
          <thead>
            <tr>
              <th style={{ ...thP, width: 60 }}>SR NO</th>
              <th style={{ ...thP, textAlign: "left", minWidth: 300 }}>ITEM DESCRIPTION</th>
              <th style={{ ...thP, width: 80 }}>UNIT</th>
              <th style={{ ...thP, width: 120 }}>QUANTITY</th>
              <th style={{ ...thP, width: 100 }}>RATE</th>
              <th style={{ ...thP, width: 120 }}>AMOUNT</th>
            </tr>
          </thead>
          <tbody>
            {(quotation.sections || []).map((sec) => {
              let mainCount = 0;
              let subCount = 0;
              return (
                <>
                  <tr key={`sec-${sec.id}`} style={{ background: "#eff6ff" }}>
                    <td style={{ ...tdP, textAlign: "center", fontWeight: 800, color: "#162040" }}>{sec.label}</td>
                    <td colSpan={5} style={{ ...tdP, fontWeight: 800, color: "#162040", textTransform: "uppercase", fontSize: 13 }}>{sec.title}</td>
                  </tr>
                  {sec.items.map((item) => {
                    const type = item.type || (item.isHeader ? "main" : "sub");
                    let srLabel = "";
                    if (type === "main") { mainCount++; subCount = 0; srLabel = String(mainCount); }
                    else { subCount++; srLabel = `${mainCount}.${subCount}`; }
                    const amount = type === "sub" ? Math.round((Number(item.qty) || 0) * (Number(item.rate) || 0) * 100) / 100 : 0;
                    return (
                      <tr key={item.id} style={{ background: type === "main" ? "#f0f4ff" : "#fff" }}>
                        <td style={{ ...tdP, textAlign: "center", color: type === "main" ? "#162040" : "#94a3b8", fontWeight: type === "main" ? 800 : 400 }}>{srLabel}</td>
                        <td style={{ ...tdP, fontWeight: type === "main" ? 700 : 400, color: type === "main" ? "#162040" : "#374151", paddingLeft: type === "sub" ? 28 : 10, fontSize: type === "main" ? 13 : 12, lineHeight: 1.6 }}>{item.description}</td>
                        <td style={{ ...tdP, textAlign: "center", color: "#64748b" }}>{type === "sub" ? (item.unit || "—") : ""}</td>
                        <td style={{ ...tdP, textAlign: "center", color: "#2563eb", fontWeight: 600 }}>{type === "sub" ? (item.qty || "—") : ""}</td>
                        <td style={{ ...tdP, textAlign: "center", color: "#374151" }}>{type === "sub" && item.rate ? `₹${Number(item.rate).toLocaleString("en-IN")}` : (type === "sub" ? "—" : "")}</td>
                        <td style={{ ...tdP, textAlign: "center", color: "#059669", fontWeight: amount > 0 ? 700 : 400 }}>{type === "sub" ? (amount > 0 ? `₹${amount.toLocaleString("en-IN")}` : "_") : ""}</td>
                      </tr>
                    );
                  })}
                </>
              );
            })}
            <tr style={{ background: "#f8fafc", borderTop: "1px solid #e2e8f0" }}>
              <td colSpan={5} style={{ ...tdP, textAlign: "right", fontWeight: 700, color: "#374151" }}>Subtotal</td>
              <td style={{ ...tdP, textAlign: "center", color: "#0f172a", fontWeight: 700 }}>₹{(quotation.subtotal || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
            <tr style={{ background: "#f8fafc" }}>
              <td colSpan={4} style={{ ...tdP, textAlign: "right", color: "#64748b" }}>Add: GST @{quotation.gstPct}%</td>
              <td style={{ ...tdP, textAlign: "center", color: "#64748b" }}>(+)</td>
              <td style={{ ...tdP, textAlign: "center", color: "#64748b" }}>₹{(quotation.gstAmount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
            <tr style={{ background: "#162040" }}>
              <td colSpan={5} style={{ ...tdP, textAlign: "right", fontWeight: 800, color: "#93c5fd", background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 13 }}>GRAND TOTAL</td>
              <td style={{ ...tdP, textAlign: "center", fontWeight: 900, color: "#fcd34d", background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 15 }}>₹{(quotation.grandTotal || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
          </tbody>
        </table>

        {quotation.notes && (
          <div style={{ marginBottom: 14, background: "#f8fafc", borderRadius: 8, padding: 14, border: "1px solid #e2e8f0" }}>
            <div style={{ fontWeight: 700, color: "#162040", fontSize: 12, marginBottom: 6 }}>Notes:</div>
            <div style={{ color: "#374151", fontSize: 12, whiteSpace: "pre-line", lineHeight: 1.7 }}>{quotation.notes}</div>
          </div>
        )}

        {quotation.paymentTerms && (
          <div style={{ marginBottom: 16, background: "#f0f4ff", borderRadius: 8, padding: 14, border: "1px solid #c7d7f0" }}>
            <div style={{ fontWeight: 700, color: "#162040", fontSize: 12, marginBottom: 6 }}>Payment Terms:</div>
            <div style={{ color: "#374151", fontSize: 12, whiteSpace: "pre-line", lineHeight: 1.7 }}>{quotation.paymentTerms}</div>
          </div>
        )}

        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 40, marginTop: 30, paddingTop: 20, borderTop: "1px solid #e2e8f0" }}>
          <div style={{ textAlign: "center" }}>
            <div style={{ borderTop: "1px solid #000", paddingTop: 8, color: "#374151", fontSize: 12 }}>FOR CLIENT</div>
            <div style={{ color: "#64748b", fontSize: 11, marginTop: 4 }}>Receiver's Signature With Seal</div>
            <div style={{ color: "#64748b", fontSize: 11, marginTop: 4 }}>Date: ___________</div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ borderTop: "1px solid #000", paddingTop: 8, color: "#374151", fontSize: 12 }}>FOR PERMATECH CONCRETE SOLUTIONS</div>
            <div style={{ color: "#64748b", fontSize: 11, marginTop: 4 }}>Authorised Signatory</div>
            <div style={{ color: "#64748b", fontSize: 11, marginTop: 4 }}>Date: {quotation.date ? new Date(quotation.date).toLocaleDateString("en-IN") : "___________"}</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function LeadListModule() {
  const [sections, setSections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [showAddSection, setShowAddSection] = useState(false);
  const [newSectionName, setNewSectionName] = useState("");

  useEffect(() => {
    getDocs(collection(db, "lead_lists")).then(snap => {
      const data = snap.docs.map(d => d.data());
      const globalList = data.find(d => d.id === "global");
      if (globalList?.sections) setSections(globalList.sections);
      else {
        const ls = localStorage.getItem("lead_list_global");
        if (ls) setSections(JSON.parse(ls));
        else setSections([{ id: Date.now(), name: "Section 1", rows: [] }]);
      }
    }).catch(() => {
      const ls = localStorage.getItem("lead_list_global");
      if (ls) setSections(JSON.parse(ls));
      else setSections([{ id: Date.now(), name: "Section 1", rows: [] }]);
    }).finally(() => setLoading(false));
  }, []);

  const saveSections = async (updated) => {
    setSections(updated);
    setHasChanges(true);
    localStorage.setItem("lead_list_global", JSON.stringify(updated));
    try {
      await setDoc(fsDoc(db, "lead_lists", "global"), { id: "global", sections: updated, updatedAt: new Date().toISOString() });
      setHasChanges(false);
    } catch (e) { console.error(e); }
  };

  const handleSave = async () => {
    setSaving(true);
    await saveSections(sections);
    setSaving(false);
  };

  let globalSr = 0;

  const emptyRow = () => ({
    id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
    name: "", designation: "", company: "", address: "",
    mobile: "", tel: "", email: "", meetingDate: "",
    meetingNotes: "", status: "Open"
  });

  const updateRow = (secId, rowId, key, val) => {
    setSections(s => s.map(sec => sec.id === secId ? {
      ...sec, rows: sec.rows.map(r => r.id === rowId ? { ...r, [key]: val } : r)
    } : sec));
    setHasChanges(true);
    localStorage.setItem("lead_list_global", JSON.stringify(
      sections.map(sec => sec.id === secId ? { ...sec, rows: sec.rows.map(r => r.id === rowId ? { ...r, [key]: val } : r) } : sec)
    ));
  };

  const addRow = (secId) => {
    const updated = sections.map(sec => sec.id === secId ? { ...sec, rows: [...sec.rows, emptyRow()] } : sec);
    setSections(updated);
    setHasChanges(true);
    localStorage.setItem("lead_list_global", JSON.stringify(updated));
  };

  const deleteRow = (secId, rowId) => {
    if (!window.confirm("Delete this lead?")) return;
    const updated = sections.map(sec => sec.id === secId ? { ...sec, rows: sec.rows.filter(r => r.id !== rowId) } : sec);
    setSections(updated);
    setHasChanges(true);
    localStorage.setItem("lead_list_global", JSON.stringify(updated));
  };

  const addSection = () => {
    if (!newSectionName.trim()) { alert("Please enter section name."); return; }
    const updated = [...sections, { id: Date.now(), name: newSectionName, rows: [emptyRow()] }];
    setSections(updated);
    setNewSectionName("");
    setShowAddSection(false);
    setHasChanges(true);
    localStorage.setItem("lead_list_global", JSON.stringify(updated));
  };

  const updateSectionName = (secId, val) => {
    const updated = sections.map(sec => sec.id === secId ? { ...sec, name: val } : sec);
    setSections(updated);
    setHasChanges(true);
  };

  const deleteSection = (secId) => {
    if (!window.confirm("Delete this section and all its leads?")) return;
    const updated = sections.filter(sec => sec.id !== secId);
    setSections(updated);
    setHasChanges(true);
    localStorage.setItem("lead_list_global", JSON.stringify(updated));
  };

  const totalLeads = sections.reduce((s, sec) => s + (sec.rows?.length || 0), 0);

  const inp = (color = theme.text) => ({
    background: "transparent", border: "none", borderBottom: `1px solid ${theme.border}`,
    color, padding: "5px 6px", fontSize: 12, outline: "none", width: "100%",
    boxSizing: "border-box", fontFamily: "inherit"
  });
  const th = { padding: "9px 10px", background: "#162040", color: "#93c5fd", fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "left", border: `1px solid rgba(99,179,237,0.2)`, whiteSpace: "nowrap" };
  const td = { padding: "7px 8px", border: `1px solid ${theme.border}`, fontSize: 12, verticalAlign: "middle" };

  if (loading) return <div style={{ color: theme.muted, padding: 20 }}>Loading...</div>;

  return (
    <div>
      <style>{`@media print { body * { visibility: hidden !important; } #lead-print, #lead-print * { visibility: visible !important; } #lead-print { position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; background: white !important; padding: 20px !important; } .no-print { display: none !important; } }`}</style>

      {/* Header */}
      <div className="no-print" style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>CRM & Sales</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📋 Lead List</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{totalLeads} leads · {sections.length} section{sections.length !== 1 ? "s" : ""}</div>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          {hasChanges && <span style={{ color: theme.orange, fontSize: 12, fontWeight: 600 }}>● Unsaved changes</span>}
          <Btn variant="ghost" onClick={() => downloadTemplate(["Name","Designation","Company","Address","Mobile","Tel","Email","Meeting Date","Meeting Notes","Status"], "Lead_List_Template.xlsx")}>📥 Template</Btn>
<label style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 9, padding: "8px 16px", fontSize: 13, fontWeight: 600, color: theme.text, cursor: "pointer" }}>
  📤 Import Excel
  <input type="file" accept=".xlsx,.xls,.csv" style={{ display: "none" }} onChange={e => {
    if (!e.target.files[0]) return;
    importExcelFile(e.target.files[0], (data) => {
      if (!data.length) { alert("No data found in file."); return; }
      const sectionName = `Imported ${new Date().toLocaleDateString("en-IN")}`;
      const newRows = data.map(row => ({
        id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
        name: row["Name"] || row["name"] || "",
        designation: row["Designation"] || row["designation"] || "",
        company: row["Company"] || row["Company Name"] || "",
        address: row["Address"] || row["address"] || "",
        mobile: String(row["Mobile"] || row["Mobile No."] || row["mobile"] || ""),
        tel: String(row["Tel"] || row["Tel No."] || row["tel"] || ""),
        email: row["Email"] || row["Email ID"] || row["email"] || "",
        meetingDate: row["Meeting Date"] || row["meeting date"] || "",
        meetingNotes: row["Meeting Notes"] || row["notes"] || "",
        status: row["Status"] || row["status"] || "Open"
      }));
      const newSection = { id: Date.now(), name: sectionName, rows: newRows };
      const updated = [...sections, newSection];
      setSections(updated);
      setHasChanges(true);
      localStorage.setItem("lead_list_global", JSON.stringify(updated));
      alert(`✅ Imported ${newRows.length} leads into new section "${sectionName}"`);
    });
    e.target.value = "";
  }} />
</label>
<Btn variant="ghost" onClick={() => window.print()}>🖨 Print</Btn>
<Btn onClick={handleSave} disabled={saving}>{saving ? "⏳ Saving..." : "💾 Save"}</Btn>
        </div>
      </div>

      {/* Stats */}
      <div className="no-print" style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
        <StatCard label="Total Leads" value={totalLeads} color={theme.blue} icon="📋" />
        <StatCard label="Open" value={sections.reduce((s, sec) => s + (sec.rows?.filter(r => r.status === "Open").length || 0), 0)} color={theme.green} icon="🟢" />
        <StatCard label="Closed" value={sections.reduce((s, sec) => s + (sec.rows?.filter(r => r.status === "Closed").length || 0), 0)} color={theme.red} icon="🔴" />
        <StatCard label="Meetings" value={sections.reduce((s, sec) => s + (sec.rows?.filter(r => r.meetingDate).length || 0), 0)} color={theme.purple} icon="📅" />
      </div>

      <div id="lead-print">
        {/* Sections */}
        {sections.map((sec) => (
          <div key={sec.id} style={{ marginBottom: 24 }}>
            {/* Section Header */}
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 0, background: "#162040", padding: "10px 16px", borderRadius: "10px 10px 0 0" }}>
              <input value={sec.name} onChange={e => updateSectionName(sec.id, e.target.value)}
                style={{ background: "transparent", border: "none", borderBottom: "1px solid rgba(147,197,253,0.4)", color: "#93c5fd", fontWeight: 800, fontSize: 14, outline: "none", flex: 1 }} />
              <button onClick={() => addRow(sec.id)} className="no-print"
                style={{ background: "rgba(255,255,255,0.1)", border: "1px solid rgba(147,197,253,0.3)", color: "#93c5fd", borderRadius: 7, padding: "5px 12px", fontSize: 11, cursor: "pointer", fontWeight: 600 }}>
                + Add Lead
              </button>
              {sections.length > 1 && (
                <button onClick={() => deleteSection(sec.id)} className="no-print"
                  style={{ background: "rgba(239,68,68,0.2)", border: "1px solid rgba(239,68,68,0.4)", color: "#fca5a5", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>
                  🗑
                </button>
              )}
            </div>

            {/* Table */}
            <div style={{ overflowX: "auto", border: `1px solid ${theme.border}`, borderTop: "none", borderRadius: "0 0 10px 10px", background: theme.card }}>
              <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1100 }}>
                <thead>
                  <tr>
                    {["SR", "Name", "Designation", "Company", "Address", "Mobile", "Tel", "Email", "Meeting Date", "Meeting Notes", "Status", ""].map((h, i) => (
                      <th key={i} style={{ ...th, textAlign: i === 0 ? "center" : "left" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {(sec.rows || []).map((row) => {
                    globalSr++;
                    const sr = globalSr;
                    return (
                      <tr key={row.id} style={{ background: sr % 2 === 0 ? theme.bg : theme.card }}>
                        <td style={{ ...td, textAlign: "center", color: theme.accent, fontWeight: 700, width: 45 }}>{sr}</td>
                        <td style={{ ...td, minWidth: 130 }}><input value={row.name} onChange={e => updateRow(sec.id, row.id, "name", e.target.value)} style={inp(theme.text)} placeholder="Name..." /></td>
                        <td style={{ ...td, minWidth: 120 }}><input value={row.designation} onChange={e => updateRow(sec.id, row.id, "designation", e.target.value)} style={inp(theme.muted)} placeholder="Designation..." /></td>
                        <td style={{ ...td, minWidth: 130 }}><input value={row.company} onChange={e => updateRow(sec.id, row.id, "company", e.target.value)} style={inp(theme.text)} placeholder="Company..." /></td>
                        <td style={{ ...td, minWidth: 130 }}><input value={row.address} onChange={e => updateRow(sec.id, row.id, "address", e.target.value)} style={inp(theme.muted)} placeholder="Address..." /></td>
                        <td style={{ ...td, minWidth: 110 }}><input value={row.mobile} onChange={e => updateRow(sec.id, row.id, "mobile", e.target.value)} style={inp(theme.blue)} placeholder="Mobile..." /></td>
                        <td style={{ ...td, minWidth: 100 }}><input value={row.tel} onChange={e => updateRow(sec.id, row.id, "tel", e.target.value)} style={inp(theme.muted)} placeholder="Tel..." /></td>
                        <td style={{ ...td, minWidth: 150 }}><input value={row.email} onChange={e => updateRow(sec.id, row.id, "email", e.target.value)} style={inp(theme.accent)} placeholder="Email..." /></td>
                        <td style={{ ...td, minWidth: 120 }}><input type="date" value={row.meetingDate} onChange={e => updateRow(sec.id, row.id, "meetingDate", e.target.value)} style={{ ...inp(theme.purple), fontSize: 11 }} /></td>
                        <td style={{ ...td, minWidth: 160 }}><input value={row.meetingNotes} onChange={e => updateRow(sec.id, row.id, "meetingNotes", e.target.value)} style={inp(theme.muted)} placeholder="Notes..." /></td>
                        <td style={{ ...td, width: 90 }}>
                          <select value={row.status} onChange={e => updateRow(sec.id, row.id, "status", e.target.value)}
                            style={{ ...inp(row.status === "Open" ? theme.green : theme.red), border: "none", cursor: "pointer", fontWeight: 700, fontSize: 11 }}>
                            <option value="Open">🟢 Open</option>
                            <option value="Closed">🔴 Closed</option>
                          </select>
                        </td>
                        <td style={{ ...td, width: 36 }} className="no-print">
                          <button onClick={() => deleteRow(sec.id, row.id)}
                            style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 24, height: 24, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
          </div>
        ))}

        {/* Add Section */}
        {showAddSection ? (
          <div className="no-print" style={{ background: theme.card, border: `1px solid ${theme.accent}44`, borderRadius: 10, padding: 14, marginBottom: 16, display: "flex", gap: 10, alignItems: "center" }}>
            <input value={newSectionName} onChange={e => setNewSectionName(e.target.value)}
              placeholder="Enter section name e.g. Mumbai Leads..."
              style={{ flex: 1, background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 13, outline: "none" }}
              onKeyDown={e => e.key === "Enter" && addSection()} autoFocus />
            <Btn onClick={addSection}>+ Add</Btn>
            <Btn variant="ghost" onClick={() => { setShowAddSection(false); setNewSectionName(""); }}>Cancel</Btn>
          </div>
        ) : (
          <button className="no-print" onClick={() => setShowAddSection(true)}
            style={{ background: theme.card, border: `2px dashed ${theme.border}`, borderRadius: 10, padding: "12px 20px", color: theme.muted, cursor: "pointer", fontSize: 13, fontWeight: 600, width: "100%", textAlign: "center", marginTop: 8 }}>
            + Add New Section
          </button>
        )}
      </div>
    </div>
  );
}

function CRMModule({projects = []}) {
  const [crmTab, setCrmTab] = useState("register");
  const [entries, setEntries] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editEntry, setEditEntry] = useState(null);
  const [viewEntry, setViewEntry] = useState(null);

  const emptyRow = { slNo: "", date: new Date().toISOString().slice(0, 10), companyName: "", project: "", natureOfJob: "", quotationRef: "", quotationValue: "", remarks: "", fileLocation: "" };
  const [form, setForm] = useState(emptyRow);

  useEffect(() => {
    getDocs(collection(db, "quotation_register")).then(snap => {
      const data = snap.docs.map(d => d.data()).sort((a, b) => a.slNo - b.slNo);
      if (data.length > 0) setEntries(data);
      else {
        const ls = localStorage.getItem("quotationRegister");
        if (ls) setEntries(JSON.parse(ls));
      }
    }).catch(() => {
      const ls = localStorage.getItem("quotationRegister");
      if (ls) setEntries(JSON.parse(ls));
    });
  }, []);

  const saveEntry = async (entry) => {
    const isEdit = entries.find(e => e.id === entry.id);
    const updated = isEdit
      ? entries.map(e => e.id === entry.id ? entry : e)
      : [...entries, entry].sort((a, b) => a.slNo - b.slNo);
    setEntries(updated);
    localStorage.setItem("quotationRegister", JSON.stringify(updated));
    try { await setDoc(fsDoc(db, "quotation_register", String(entry.id)), entry); }
    catch (e) { console.error(e); }
  };

  const deleteEntry = async (id) => {
    if (!window.confirm("Delete this entry?")) return;
    const updated = entries.filter(e => e.id !== id);
    setEntries(updated);
    localStorage.setItem("quotationRegister", JSON.stringify(updated));
    try { await deleteDoc(fsDoc(db, "quotation_register", String(id))); }
    catch (e) { console.error(e); }
  };

  const handleSave = () => {
    if (!form.companyName.trim()) { alert("Please enter Company Name."); return; }
    if (!form.date) { alert("Please enter Date."); return; }
    const entry = { ...form, id: editEntry?.id || Date.now(), slNo: form.slNo || entries.length + 1 };
    saveEntry(entry);
    setShowForm(false);
    setEditEntry(null);
    setForm(emptyRow);
  };

  const handleEdit = (entry) => {
    setEditEntry(entry);
    setForm(entry);
    setShowForm(true);
    setViewEntry(null);
  };

  const exportToExcel = async () => {
    if (entries.length === 0) { alert("No entries to export."); return; }
    
   const headers = ["Sl. No.", "Date", "Company Name", "Project", "Nature of Job", "Quotation Reference", "Quotation Value", "Approval Status", "File Location"];
   const rows = entries.map(e => [e.slNo||"", e.date||"", e.companyName||"", e.project||"", e.natureOfJob||"", e.quotationRef||"", e.quotationValue||"", e.approvalStatus||"Pending", e.fileLocation||""]);
    const wb = XLSX.utils.book_new();
    const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
    ws["!cols"] = [{ wch: 8 }, { wch: 14 }, { wch: 28 }, { wch: 24 }, { wch: 24 }, { wch: 22 }, { wch: 18 }, { wch: 24 }, { wch: 24 }];
    headers.forEach((_, colIdx) => {
      const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIdx });
      if (!ws[cellRef]) return;
      ws[cellRef].s = { fill: { fgColor: { rgb: "C6EFCE" } }, font: { bold: true, sz: 13, color: { rgb: "1A6632" } }, alignment: { horizontal: "center", vertical: "center", wrapText: true }, border: { top: { style: "thin", color: { rgb: "1A6632" } }, bottom: { style: "thin", color: { rgb: "1A6632" } }, left: { style: "thin", color: { rgb: "1A6632" } }, right: { style: "thin", color: { rgb: "1A6632" } } } };
    });
    rows.forEach((_, rowIdx) => {
      headers.forEach((__, colIdx) => {
        const cellRef = XLSX.utils.encode_cell({ r: rowIdx + 1, c: colIdx });
        if (!ws[cellRef]) return;
        ws[cellRef].s = { alignment: { horizontal: "left", vertical: "center", wrapText: true }, border: { top: { style: "thin", color: { rgb: "CCCCCC" } }, bottom: { style: "thin", color: { rgb: "CCCCCC" } }, left: { style: "thin", color: { rgb: "CCCCCC" } }, right: { style: "thin", color: { rgb: "CCCCCC" } } }, fill: { fgColor: { rgb: rowIdx % 2 === 0 ? "F0FFF4" : "FFFFFF" } } };
      });
    });
    ws["!rows"] = [{ hpt: 28 }];
    XLSX.utils.book_append_sheet(wb, ws, "Quotation Register");
    XLSX.writeFile(wb, `Quotation_Register_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 };
  const thStyle = { padding: "12px 14px", background: theme.accent + "22", color: theme.accent, fontSize: 12, fontWeight: 800, textTransform: "uppercase", textAlign: "left", borderBottom: `2px solid ${theme.accent}`, whiteSpace: "nowrap" };
  const tdStyle = { padding: "11px 14px", borderBottom: `1px solid ${theme.border}`, fontSize: 14, color: theme.text, verticalAlign: "middle" };

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>CRM & Sales</div>
          <h2 style={{ color: theme.text, fontSize: 26, fontWeight: 800, margin: 0 }}>CRM & Sales</h2>
          <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>{entries.length} entries</div>
        </div>
        {crmTab === "register" && (
          <div style={{ display: "flex", gap: 10 }}>
            <Btn variant="ghost" onClick={exportToExcel}>📥 Export Excel</Btn>
            <Btn variant="ghost" onClick={() => downloadTemplate(["SL No","Quotation No","Client Name","Site Name","Date","Subject","Amount","Status","Remarks"], "Quotation_Register_Template.xlsx")}>📥 Template</Btn>
<label style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 9, padding: "8px 16px", fontSize: 13, fontWeight: 600, color: theme.text, cursor: "pointer" }}>
  📤 Import Excel
  <input type="file" accept=".xlsx,.xls,.csv" style={{ display: "none" }} onChange={e => {
    if (!e.target.files[0]) return;
    importExcelFile(e.target.files[0], (data) => {
      if (!data.length) { alert("No data found."); return; }
      const newEntries = data.map((row, i) => ({
        id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
        slNo: entries.length + i + 1,
        quotationNo: row["Quotation No"] || row["quotation no"] || "",
        clientName: row["Client Name"] || row["client name"] || "",
        siteName: row["Site Name"] || row["site name"] || "",
        date: row["Date"] || row["date"] || "",
        subject: row["Subject"] || row["subject"] || "",
        amount: String(row["Amount"] || row["amount"] || ""),
        status: row["Status"] || row["status"] || "Pending",
        remarks: row["Remarks"] || row["remarks"] || ""
      }));
      const updated = [...entries, ...newEntries];
      setEntries(updated);
      localStorage.setItem("quotationEntries", JSON.stringify(updated));
      alert(`✅ Imported ${newEntries.length} quotation entries!`);
    });
    e.target.value = "";
  }} />
</label>
<Btn onClick={() => { setShowForm(true); setEditEntry(null); setForm({ ...emptyRow, slNo: entries.length + 1 }); }}>+ Add Entry</Btn>
          </div>
        )}
      </div>

      {/* Tabs */}
      <Tabs active={crmTab} onChange={t => { setCrmTab(t); setShowForm(false); setEditEntry(null); setViewEntry(null); }} tabs={[
         { id: "enquiry", label: `📒 Enquiry Logbook` },
        { id: "register", label: `📋 Quotation Register (${entries.length})` },
       
        { id: "calendar", label: `📅 Follow-up Calendar` },
        { id: "quotation", label: `📄 Quotation` },
        { id: "suppliers", label: `📋 Supplier List` },
        { id: "po", label: `📦 Purchase Orders` },
        { id: "leads", label: `📋 Lead List` },
        
      ]} />

      {/* Quotation Register */}
      {crmTab === "register" && <>
        {/* Stats */}
        <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
          <StatCard label="Total Entries" value={entries.length} color={theme.blue} icon="📋" />
          <StatCard label="Total Value" value={`₹${entries.reduce((s, e) => s + (isNaN(Number(e.quotationValue)) ? 0 : Number(e.quotationValue) || 0), 0).toLocaleString("en-IN")}`} color={theme.green} icon="💰" />
          <StatCard label="This Month" value={entries.filter(e => e.date?.startsWith(new Date().toISOString().slice(0, 7))).length} color={theme.accent} icon="📅" />
          <StatCard label="Companies" value={new Set(entries.map(e => e.companyName)).size} color={theme.purple} icon="🏢" />
        </div>

        {/* Add/Edit Form */}
        {showForm && (
          <div style={{ background: theme.card, border: `1px solid ${theme.accent}44`, borderRadius: 12, padding: 20, marginBottom: 20 }}>
            <div style={{ color: theme.accent, fontSize: 12, fontWeight: 700, textTransform: "uppercase", marginBottom: 16 }}>
              {editEntry ? "✏️ Edit Entry" : "➕ New Entry"}
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "80px 140px 1fr 1fr", gap: 10, marginBottom: 10 }}>
              <div><label style={lbl}>Sl. No.</label><input type="number" value={form.slNo} onChange={e => setForm(f => ({ ...f, slNo: e.target.value }))} style={inp} placeholder="1" /></div>
              <div><label style={lbl}>Date</label><input type="date" value={form.date} onChange={e => setForm(f => ({ ...f, date: e.target.value }))} style={inp} /></div>
              <div><label style={lbl}>Company Name <span style={{ color: theme.red }}>*</span></label><input value={form.companyName} onChange={e => setForm(f => ({ ...f, companyName: e.target.value }))} style={inp} placeholder="Company name..." /></div>
              <div><label style={lbl}>Project</label><input value={form.project} onChange={e => setForm(f => ({ ...f, project: e.target.value }))} style={inp} placeholder="Project name..." /></div>
            </div>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 120px 1fr 1fr", gap: 10, marginBottom: 16 }}>
              <div><label style={lbl}>Nature of Job</label><input value={form.natureOfJob} onChange={e => setForm(f => ({ ...f, natureOfJob: e.target.value }))} style={inp} placeholder="e.g. Waterproofing..." /></div>
              <div><label style={lbl}>Quotation Reference</label><input value={form.quotationRef} onChange={e => setForm(f => ({ ...f, quotationRef: e.target.value }))} style={inp} placeholder="Ref no..." /></div>
              <div><label style={lbl}>Quotation Value ₹</label><input value={form.quotationValue} onChange={e => setForm(f => ({ ...f, quotationValue: e.target.value }))} style={{ ...inp, color: theme.green, fontWeight: 700 }} placeholder="e.g. 50000 or Confidential" /></div>
              <div>
  <label style={lbl}>Approval Status</label>
  <select value={form.approvalStatus || ""} onChange={e => setForm(f => ({ ...f, approvalStatus: e.target.value }))}
    style={{ ...inp, color: form.approvalStatus === "Approved" ? theme.green : form.approvalStatus === "Not Approved" ? theme.red : theme.text, fontWeight: 700, cursor: "pointer" }}>
    <option value="">— Select —</option>
    <option value="Approved">✅ Approved</option>
    <option value="Not Approved">❌ Not Approved</option>
  </select>
</div>
              <div><label style={lbl}>File Location</label><input value={form.fileLocation} onChange={e => setForm(f => ({ ...f, fileLocation: e.target.value }))} style={inp} placeholder="e.g. Drive/Folder..." /></div>
            </div>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
              <Btn variant="ghost" onClick={() => { setShowForm(false); setEditEntry(null); setForm(emptyRow); }}>Cancel</Btn>
              <Btn onClick={handleSave}>💾 {editEntry ? "Save Changes" : "Add Entry"}</Btn>
            </div>
          </div>
        )}

        {/* Table */}
        {entries.length === 0 ? (
          <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
            <div style={{ fontSize: 36, marginBottom: 10 }}>📋</div>
            <div style={{ color: theme.muted, fontSize: 14 }}>No entries yet. Click "+ Add Entry" to start.</div>
          </div>
        ) : (
          <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1000 }}>
              <thead>
                <tr>
                  {["Sl. No.", "Date", "Company Name", "Project", "Nature of Job", "Quotation Ref", "Value ₹", "Approval Status", "File Location", "Actions"].map(h => (
                    <th key={h} style={thStyle}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {entries.map((entry, i) => (
                  <tr key={entry.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                    <td style={{ ...tdStyle, textAlign: "center", color: theme.muted, fontWeight: 700 }}>{entry.slNo}</td>
                    <td style={{ ...tdStyle, color: theme.accent, whiteSpace: "nowrap" }}>{entry.date}</td>
                    <td style={{ ...tdStyle, fontWeight: 700 }}>{entry.companyName}</td>
                    <td style={{ ...tdStyle, color: theme.muted }}>{entry.project || "—"}</td>
                    <td style={{ ...tdStyle, color: theme.muted }}>{entry.natureOfJob || "—"}</td>
                    <td style={tdStyle}>{entry.quotationRef ? <span style={{ background: theme.blue + "22", color: theme.blue, borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>{entry.quotationRef}</span> : "—"}</td>
                    <td style={{ ...tdStyle, color: theme.green, fontWeight: 700, textAlign: "right" }}>{entry.quotationValue ? (isNaN(Number(entry.quotationValue)) ? entry.quotationValue : `₹${Number(entry.quotationValue).toLocaleString("en-IN")}`) : "—"}</td>
                    <td style={{ ...tdStyle, textAlign: "center" }}>
  {entry.approvalStatus ? (
    <span style={{
      background: entry.approvalStatus === "Approved" ? theme.green + "22" : theme.red + "22",
      color: entry.approvalStatus === "Approved" ? theme.green : theme.red,
      border: `1px solid ${entry.approvalStatus === "Approved" ? theme.green : theme.red}44`,
      borderRadius: 6, padding: "3px 12px", fontSize: 12, fontWeight: 700
    }}>
      {entry.approvalStatus === "Approved" ? "✅ Approved" : "❌ Not Approved"}
    </span>
  ) : (
    <span style={{ color: theme.muted, fontSize: 12 }}>— Pending —</span>
  )}
</td>
                    <td style={{ ...tdStyle, color: theme.muted, fontSize: 11 }}>{entry.fileLocation || "—"}</td>
                    <td style={tdStyle}>
                      <div style={{ display: "flex", gap: 6 }}>
                        <Btn small variant="ghost" onClick={() => setViewEntry(entry)}>👁 View</Btn>
<Btn small variant="ghost" onClick={() => handleEdit(entry)}>✏️ Edit</Btn>
<button onClick={() => saveEntry({ ...entry, approvalStatus: entry.approvalStatus === "Approved" ? "Not Approved" : "Approved" })}
  style={{ background: entry.approvalStatus === "Approved" ? theme.green + "22" : theme.red + "22", border: `1px solid ${entry.approvalStatus === "Approved" ? theme.green : theme.red}44`, color: entry.approvalStatus === "Approved" ? theme.green : theme.red, borderRadius: 7, padding: "4px 10px", fontSize: 11, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}>
  {entry.approvalStatus === "Approved" ? "✅" : "❌"} {entry.approvalStatus || "Set Status"}
</button>
                        <Btn small variant="danger" onClick={() => deleteEntry(entry.id)}>🗑</Btn>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}

        {/* View Modal */}
        {viewEntry && (
          <div style={{ position: "fixed", inset: 0, background: "#000a", zIndex: 200, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}>
            <div style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 16, width: "100%", maxWidth: 600 }}>
              <div style={{ padding: "18px 24px", borderBottom: `1px solid ${theme.border}`, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div>
                  <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Quotation Register</div>
                  <h3 style={{ color: theme.text, margin: "4px 0 0", fontSize: 18, fontWeight: 800 }}>{viewEntry.companyName}</h3>
                </div>
                <div style={{ display: "flex", gap: 8 }}>
                  <Btn small onClick={() => window.print()} variant="blue">🖨 Print</Btn>
                  <Btn small variant="ghost" onClick={() => setViewEntry(null)}>✕ Close</Btn>
                </div>
              </div>
              <div style={{ padding: 24 }}>
                {[
                  ["Sl. No.", viewEntry.slNo],
                  ["Date", viewEntry.date],
                  ["Company Name", viewEntry.companyName],
                  ["Project", viewEntry.project],
                  ["Nature of Job", viewEntry.natureOfJob],
                  ["Quotation Reference", viewEntry.quotationRef],
                  ["Quotation Value", viewEntry.quotationValue ? (isNaN(Number(viewEntry.quotationValue)) ? viewEntry.quotationValue : `₹${Number(viewEntry.quotationValue).toLocaleString("en-IN")}`) : "—"],
                  ["Approval Status", viewEntry.approvalStatus || "Pending"],
                  ["File Location", viewEntry.fileLocation],
                ].map(([k, v]) => (
                  <div key={k} style={{ display: "flex", justifyContent: "space-between", padding: "10px 0", borderBottom: `1px solid ${theme.border}` }}>
                    <span style={{ color: theme.muted, fontSize: 12, fontWeight: 600 }}>{k}</span>
                    <span style={{ color: theme.text, fontSize: 12, fontWeight: 700, textAlign: "right", maxWidth: "60%" }}>{v || "—"}</span>
                  </div>
                ))}
                <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 16 }}>
                  <Btn variant="ghost" onClick={() => handleEdit(viewEntry)}>✏️ Edit</Btn>
                  <Btn variant="danger" onClick={() => { deleteEntry(viewEntry.id); setViewEntry(null); }}>🗑 Delete</Btn>
                </div>
              </div>
            </div>
          </div>
        )}
      </>}

      {/* Enquiry Logbook */}
      {crmTab === "enquiry" && <EnquiryLogbook />}
      {crmTab === "calendar" && <FollowUpCalendar quotationEntries={entries} />}
      {crmTab === "quotation" && <QuotationModule />}
      {crmTab === "suppliers" && <SupplierListTab />}
      {crmTab === "po" && <PurchaseOrderModule />}
      {crmTab === "leads" && <LeadListModule  />}
    </div>
  );
}

const INITIAL_SUPPLIERS = [
  "Alco Co. Pvt Ltd", "Ambuja Cement", "Amchem Products-Drythane", "BASF",
  "BEC Fertilisers 2", "Chembond Chemicals Ltd", "Chemtreat",
  "Composite Hoses and Hydraulics Pvt. Ltd", "Conrepiare",
  "Costumer Service and Logistic Department",
  "Counto Microfine Products Private Limited", "credence chemie enterprises",
  "DAEHWA PRECISION CO.LTD 27.08.2021", "Desoi Tradeways", "Dharti Enterprise",
  "Don Construction Chemicals India Ltd", "Eco Materials",
  "Entre Monde Polycoaters Ltd", "Federal Sales Corporation",
  "FLEXVERSE POLYMERS PVT LTD", "Grouting pumps", "Headway Chemicals",
  "HILTI", "Hilti India Pvt. Ltd", "Hitech rubber industries", "HUNTSMAN",
  "IMCD India", "Indo guld", "JAYCO", "Jassons Industries Limited",
  "Lympro chemical", "Mars Petrochem Pvt. Ltd", "Maruti Techno Rubber Pvt Ltd",
  "Maxons Waterproofing Solutions", "MC-bauchemie", "MCON", "MYK Schomberg",
  "Natural cemco", "Navyug chemical Pvt.Ltd. khar", "Noble",
  "Noble Building Needs LLP", "NPM MARKETING", "Nuha Construction Solutions",
  "Om shanti Enterprises", "Padmavati Enterprises", "PARAMOUNT",
  "Parexgroup Construction Products Pvt Ltd", "Pranav Trading_OldBrickSupplier",
  "Precise Chemicals (MAH)", "PRICE LIST", "Purchase Order -2025-2026",
  "Purchase order all parties", "purchase order april 2010-2011",
  "Purchase Order April 2013 - March 2014", "Purchase order April 2014-March 2015",
  "PURE LEATHER", "R.K. Industries", "Refkar", "Riddhi Enterprise",
  "Ramesh & Co", "SCHORNBURG", "SWIFT TECHNOPLAST PRIVATE LIMITED",
  "SynkoFlex", "Tech-Dry India Pvt Ltd", "Technocrat Polycoats", "Technofill",
  "Temco CPG (I) Pvt. Ltd", "Tikidan", "Unique Scale", "UTKARSH BRUSH WORKS",
  "vardhkamal industries", "Variety", "VCM Polyth", "Vedant Marketing",
  "Vinpol Coatings Pvt Ltd", "Vipul Waterproofers", "Vision enterprises",
  "Wacker", "Xchem", "YASHAM - Santosh kavishwar", "YESHA ENTERPRISES",
  "Arihant (Barrier Kote)2", "Jayco safety products",
  "Kelvin Energy Solutions - sales quote", "Kelvin Energy - sales quote",
  "New Microsoft Excel Worksheet (2)", "New Microsoft Excel Worksheet",
  "P.O. 54 - 25.07.2013", "Purchase order Montex Glass Fibre",
  "Purchase Order YESHA ENTERPRISES 18", "Purchase order",
  "Silco Aquachem (I) Pvt Ltd",
].map((name, i) => ({
  id: `supplier_${i + 1}`,
  srNo: i + 1,
  folderName: name,
  contactPerson: "",
  mobile: "",
  email: "",
  remarks: "",
}));

function SupplierListTab() {
  const [suppliers, setSuppliers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [editingId, setEditingId] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [newSupplier, setNewSupplier] = useState({ folderName: "", contactPerson: "", mobile: "", email: "", remarks: "" });

  useEffect(() => {
    getDocs(collection(db, "supplier_list")).then(snap => {
      if (snap.docs.length > 0) {
        setSuppliers(snap.docs.map(d => d.data()).sort((a, b) => a.srNo - b.srNo));
      } else {
        const ls = localStorage.getItem("supplier_list");
        if (ls) setSuppliers(JSON.parse(ls));
        else {
          setSuppliers(INITIAL_SUPPLIERS);
          saveAll(INITIAL_SUPPLIERS);
        }
      }
    }).catch(() => {
      const ls = localStorage.getItem("supplier_list");
      if (ls) setSuppliers(JSON.parse(ls));
      else setSuppliers(INITIAL_SUPPLIERS);
    }).finally(() => setLoading(false));
  }, []);

  const saveAll = async (updated) => {
    setSaving(true);
    setSuppliers(updated);
    localStorage.setItem("supplier_list", JSON.stringify(updated));
    try {
      for (const s of updated) {
        await setDoc(fsDoc(db, "supplier_list", String(s.id)), s);
      }
    } catch (e) { console.error(e); }
    finally { setSaving(false); }
  };

  const handleAdd = () => {
    if (!newSupplier.folderName.trim()) return alert("Please enter Supplier / Folder Name.");
    const entry = {
      id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
      srNo: suppliers.length + 1,
      ...newSupplier,
    };
    saveAll([...suppliers, entry]);
    setNewSupplier({ folderName: "", contactPerson: "", mobile: "", email: "", remarks: "" });
    setShowAdd(false);
  };

  const handleUpdate = (id, field, value) => {
    const updated = suppliers.map(s => s.id === id ? { ...s, [field]: value } : s);
    setSuppliers(updated);
    localStorage.setItem("supplier_list", JSON.stringify(updated));
    // Debounced save to Firestore
    clearTimeout(window._supplierSaveTimer);
    window._supplierSaveTimer = setTimeout(async () => {
      setSaving(true);
      try {
        const s = updated.find(x => x.id === id);
        if (s) await setDoc(fsDoc(db, "supplier_list", String(s.id)), s);
      } catch (e) { console.error(e); }
      finally { setSaving(false); }
    }, 800);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this supplier?")) return;
    const updated = suppliers.filter(s => s.id !== id).map((s, i) => ({ ...s, srNo: i + 1 }));
    saveAll(updated);
  };

  const exportExcel = async () => {
    
    const wb = XLSX.utils.book_new();
    const header = [["PERMATECH CONCRETE SOLUTIONS"], ["Supplier List"], [`Generated: ${new Date().toLocaleDateString("en-IN")}`], []];
    const cols = ["Sr. No.", "Supplier / Folder Name", "Contact Person", "Mobile Number", "Email", "Remarks"];
    const rows = suppliers.map(s => [s.srNo, s.folderName, s.contactPerson || "", s.mobile || "", s.email || "", s.remarks || ""]);
    const ws = XLSX.utils.aoa_to_sheet([...header, cols, ...rows]);
    ws["!cols"] = [{ wch: 8 }, { wch: 40 }, { wch: 22 }, { wch: 16 }, { wch: 28 }, { wch: 30 }];
    XLSX.utils.book_append_sheet(wb, ws, "Supplier List");
    XLSX.writeFile(wb, `Supplier_List_${new Date().toISOString().slice(0, 10)}.xlsx`);
  };

  const filtered = suppliers.filter(s =>
    s.folderName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    s.contactPerson?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    s.mobile?.includes(searchQuery) ||
    s.email?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, color: theme.text, padding: "6px 8px", fontSize: 12, outline: "none", width: "100%", boxSizing: "border-box" };
  const th = { padding: "10px 12px", background: "#162040", color: "#93c5fd", fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "left", border: "1px solid rgba(99,179,237,0.2)", whiteSpace: "nowrap" };
  const td = { padding: "8px 10px", border: `1px solid ${theme.border}`, fontSize: 12, verticalAlign: "middle" };

  if (loading) return <div style={{ color: theme.muted, padding: 20 }}>Loading supplier list...</div>;

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>CRM & Sales</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📋 Supplier List</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{suppliers.length} suppliers</div>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          {saving && <span style={{ color: theme.orange, fontSize: 12, fontWeight: 600 }}>⏳ Saving...</span>}
          <Btn variant="ghost" onClick={exportExcel}>📥 Export Excel</Btn>
          <Btn onClick={() => setShowAdd(true)}>+ Add Supplier</Btn>
        </div>
      </div>

      {/* Add Form */}
      {showAdd && (
        <div style={{ background: theme.card, border: `1px solid ${theme.accent}44`, borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <div style={{ color: theme.accent, fontWeight: 700, fontSize: 13, marginBottom: 12 }}>➕ Add New Supplier</div>
          <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 1fr 1fr 2fr", gap: 10, marginBottom: 12 }}>
            <div>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Supplier / Folder Name *</div>
              <input value={newSupplier.folderName} onChange={e => setNewSupplier(s => ({ ...s, folderName: e.target.value }))} style={inp} placeholder="Supplier name..." autoFocus />
            </div>
            <div>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Contact Person</div>
              <input value={newSupplier.contactPerson} onChange={e => setNewSupplier(s => ({ ...s, contactPerson: e.target.value }))} style={inp} placeholder="Name..." />
            </div>
            <div>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Mobile Number</div>
              <input value={newSupplier.mobile} onChange={e => setNewSupplier(s => ({ ...s, mobile: e.target.value }))} style={inp} placeholder="+91..." />
            </div>
            <div>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Email</div>
              <input value={newSupplier.email} onChange={e => setNewSupplier(s => ({ ...s, email: e.target.value }))} style={inp} placeholder="email@..." />
            </div>
            <div>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Remarks</div>
              <input value={newSupplier.remarks} onChange={e => setNewSupplier(s => ({ ...s, remarks: e.target.value }))} style={inp} placeholder="Any notes..." />
            </div>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Btn variant="ghost" onClick={() => { setShowAdd(false); setNewSupplier({ folderName: "", contactPerson: "", mobile: "", email: "", remarks: "" }); }}>Cancel</Btn>
            <Btn onClick={handleAdd}>✅ Add</Btn>
          </div>
        </div>
      )}

      {/* Search */}
      <div style={{ marginBottom: 14 }}>
        <input value={searchQuery} onChange={e => setSearchQuery(e.target.value)}
          style={{ ...inp, maxWidth: 350, padding: "8px 12px", fontSize: 13 }}
          placeholder="🔍 Search by name, contact, mobile or email..." />
      </div>

      {/* Table */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
        <div style={{ padding: "12px 16px", background: "#162040", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>📋 Supplier / Folder List — {filtered.length} entries</div>
          <div style={{ color: "#5a7aa8", fontSize: 11 }}>Click any cell to edit inline</div>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 900 }}>
            <thead>
              <tr>
                {["Sr. No.", "Supplier / Folder Name", "Contact Person", "Mobile Number", "Email", "Remarks", "Actions"].map(h => (
                  <th key={h} style={{ ...th, textAlign: h === "Sr. No." ? "center" : "left" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 && (
                <tr><td colSpan={7} style={{ padding: 30, textAlign: "center", color: theme.muted }}>
                  {searchQuery ? "No suppliers found." : "No suppliers yet."}
                </td></tr>
              )}
              {filtered.map((s, i) => (
                <tr key={s.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                  <td style={{ ...td, textAlign: "center", color: theme.muted, width: 60, fontWeight: 700 }}>{s.srNo}</td>
                  <td style={{ ...td, minWidth: 220, fontWeight: 700, color: theme.text }}>
                    {editingId === s.id ? (
                      <input value={s.folderName} onChange={e => handleUpdate(s.id, "folderName", e.target.value)} style={inp} />
                    ) : (
                      <span onClick={() => setEditingId(s.id)} style={{ cursor: "text" }}>{s.folderName}</span>
                    )}
                  </td>
                  <td style={{ ...td, minWidth: 140 }}>
                    <input value={s.contactPerson || ""} onChange={e => handleUpdate(s.id, "contactPerson", e.target.value)}
                      style={{ ...inp, color: theme.text }} placeholder="—" />
                  </td>
                  <td style={{ ...td, minWidth: 130 }}>
                    <input value={s.mobile || ""} onChange={e => handleUpdate(s.id, "mobile", e.target.value)}
                      style={{ ...inp, color: theme.blue }} placeholder="—" />
                  </td>
                  <td style={{ ...td, minWidth: 200 }}>
                    <input value={s.email || ""} onChange={e => handleUpdate(s.id, "email", e.target.value)}
                      style={{ ...inp, color: theme.accent }} placeholder="—" />
                  </td>
                  <td style={{ ...td, minWidth: 180 }}>
                    <input value={s.remarks || ""} onChange={e => handleUpdate(s.id, "remarks", e.target.value)}
                      style={{ ...inp, color: theme.muted }} placeholder="—" />
                  </td>
                  <td style={{ ...td, width: 60, textAlign: "center" }}>
                    <button onClick={() => handleDelete(s.id)}
                      style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 6, padding: "4px 8px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>🗑</button>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                <td colSpan={7} style={{ padding: "10px 16px", color: "#5a7aa8", fontSize: 11, border: "1px solid rgba(99,179,237,0.2)" }}>
                  Total: <span style={{ color: "#93c5fd", fontWeight: 800 }}>{suppliers.length}</span> suppliers &nbsp;·&nbsp;
                  Filled contacts: <span style={{ color: "#6EE7B7", fontWeight: 700 }}>{suppliers.filter(s => s.contactPerson || s.mobile || s.email).length}</span>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
}


function PurchaseOrderModule() {
  const [pos, setPOs] = useState([]);
  const [mode, setMode] = useState("list"); // list | create | edit | view
  const [activePO, setActivePO] = useState(null);

  useEffect(() => {
    getDocs(collection(db, "purchase_orders")).then(snap => {
      if (snap.docs.length > 0) setPOs(snap.docs.map(d => d.data()));
      else { const ls = localStorage.getItem("purchase_orders"); if (ls) setPOs(JSON.parse(ls)); }
    }).catch(() => {
      const ls = localStorage.getItem("purchase_orders");
      if (ls) setPOs(JSON.parse(ls));
    });
  }, []);

  const savePO = async (po) => {
    const isEdit = pos.find(p => p.id === po.id);
    const updated = isEdit ? pos.map(p => p.id === po.id ? po : p) : [po, ...pos];
    setPOs(updated);
    localStorage.setItem("purchase_orders", JSON.stringify(updated));
    try { await setDoc(fsDoc(db, "purchase_orders", String(po.id)), po); }
    catch (e) { console.error(e); }
  };

  const deletePO = async (id) => {
    if (!window.confirm("Delete this Purchase Order?")) return;
    const updated = pos.filter(p => p.id !== id);
    setPOs(updated);
    localStorage.setItem("purchase_orders", JSON.stringify(updated));
    try { await deleteDoc(fsDoc(db, "purchase_orders", String(id))); }
    catch (e) { console.error(e); }
  };

  const getNextPONo = () => {
    const next = pos.length + 35;
    return `${next}/25-26`;
  };

  if (mode === "create" || mode === "edit") {
    return <POForm existing={activePO} onBack={() => { setMode("list"); setActivePO(null); }} onSave={po => { savePO(po); setMode("view"); setActivePO(po); }} getNextPONo={getNextPONo} />;
  }

  if (mode === "view" && activePO) {
    return <POPreview po={activePO} onBack={() => { setMode("list"); setActivePO(null); }} onEdit={() => setMode("edit")} />;
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>CRM & Sales</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📦 Purchase Orders</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{pos.length} purchase orders</div>
        </div>
        <Btn onClick={() => { setActivePO(null); setMode("create"); }}>+ New PO</Btn>
      </div>

      {pos.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 60, textAlign: "center" }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📦</div>
          <div style={{ color: theme.text, fontWeight: 800, fontSize: 18, marginBottom: 8 }}>No Purchase Orders Yet</div>
          <div style={{ color: theme.muted, fontSize: 13, marginBottom: 16 }}>Create your first purchase order</div>
          <Btn onClick={() => setMode("create")}>+ Create PO</Btn>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {pos.map((po, i) => {
            const grandTotal = po.grandTotal || 0;
            return (
              <div key={po.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
                <div>
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
                    <span style={{ color: theme.accent, fontWeight: 800, fontSize: 15 }}>PO #{po.poNo}</span>
                    <span style={{ background: theme.blue + "22", color: theme.blue, borderRadius: 5, padding: "1px 8px", fontSize: 10, fontWeight: 700 }}>PURCHASE ORDER</span>
                  </div>
                  <div style={{ color: theme.muted, fontSize: 12 }}>📅 {po.date} · 🏢 {po.supplierName}</div>
                  <div style={{ color: theme.faint, fontSize: 11, marginTop: 2 }}>
                    {po.items?.length || 0} items ·
                    <span style={{ color: theme.green, fontWeight: 700 }}> ₹{grandTotal.toLocaleString("en-IN")}</span>
                  </div>
                </div>
                <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                  <Btn small variant="ghost" onClick={() => { setActivePO(po); setMode("view"); }}>👁 View</Btn>
                  <Btn small variant="ghost" onClick={() => { setActivePO(po); setMode("edit"); }}>✏️ Edit</Btn>
                  <Btn small variant="blue" onClick={() => { setActivePO(po); setMode("view"); setTimeout(() => window.print(), 300); }}>🖨 Print</Btn>
                  <Btn small variant="danger" onClick={() => deletePO(po.id)}>🗑</Btn>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

// ============================================================
// PO FORM
// ============================================================

function POForm({ existing, onBack, onSave, getNextPONo }) {
  const [poNo, setPONo] = useState(existing?.poNo || getNextPONo());
  const [date, setDate] = useState(existing?.date || new Date().toISOString().slice(0, 10));
  const [refNo, setRefNo] = useState(existing?.refNo || "Email");
  const [refDate, setRefDate] = useState(existing?.refDate || new Date().toISOString().slice(0, 10));
  const [kindAttn, setKindAttn] = useState(existing?.kindAttn || "");
  const [supplierName, setSupplierName] = useState(existing?.supplierName || "");
  const [supplierAddress, setSupplierAddress] = useState(existing?.supplierAddress || "");
  const [contactPerson, setContactPerson] = useState(existing?.contactPerson || "");
  const [contactMobile, setContactMobile] = useState(existing?.contactMobile || "7738131631");
  const [deliveryName, setDeliveryName] = useState(existing?.deliveryName || "Permatech Concrete Solution");
  const [deliveryAddress, setDeliveryAddress] = useState(existing?.deliveryAddress || "18, Divya Darshan, Mount Mary Steps, Bandra (W), Mumbai - 400050.");
  const [deliveryContact, setDeliveryContact] = useState(existing?.deliveryContact || "Shubham");
  const [deliveryMobile, setDeliveryMobile] = useState(existing?.deliveryMobile || "+91 7738131631");
  const [gst, setGst] = useState(existing?.gst || 18);
  const [items, setItems] = useState(existing?.items || [{ id: Date.now(), description: "", unit: "", packing: "", qty: "", rate: "" }]);

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "8px 10px", fontSize: 12, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 11, fontWeight: 600, display: "block", marginBottom: 4 };
  const th = { padding: "10px 10px", background: "#162040", color: "#93c5fd", fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: "1px solid rgba(99,179,237,0.2)", whiteSpace: "nowrap" };
  const td = { padding: "8px 8px", border: `1px solid ${theme.border}`, fontSize: 12, textAlign: "center", verticalAlign: "middle" };

  // Calculations
  const subTotal = items.reduce((s, i) => s + ((Number(i.qty) || 0) * (Number(i.rate) || 0)), 0);
  const gstAmount = Math.round(subTotal * (Number(gst) || 0) / 100 * 100) / 100;
  const grandTotal = Math.round((subTotal + gstAmount) * 100) / 100;

  const numberToWords = (num) => {
    const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    if (num === 0) return "Zero";
    const convert = (n) => {
      if (n < 20) return ones[n];
      if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
      if (n < 1000) return ones[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " " + convert(n % 100) : "");
      if (n < 100000) return convert(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + convert(n % 1000) : "");
      if (n < 10000000) return convert(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + convert(n % 100000) : "");
      return convert(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + convert(n % 10000000) : "");
    };
    return convert(Math.round(num)) + " Only";
  };

  const handleSave = () => {
    if (!supplierName.trim()) return alert("Please enter Supplier Name.");
    if (items.filter(i => i.description.trim()).length === 0) return alert("Please add at least one item.");
    const po = {
      id: existing?.id || Date.now(),
      poNo, date, refNo, refDate, kindAttn,
      supplierName, supplierAddress, contactPerson, contactMobile,
      deliveryName, deliveryAddress, deliveryContact, deliveryMobile,
      gst, items: items.filter(i => i.description.trim()),
      subTotal, gstAmount, grandTotal,
      amountInWords: numberToWords(grandTotal),
      createdAt: existing?.createdAt || new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    };
    onSave(po);
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div>
          <button onClick={onBack} style={{ background: "none", border: "none", color: theme.muted, cursor: "pointer", fontSize: 13, marginBottom: 8, padding: 0 }}>← Back to Purchase Orders</button>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📦 {existing ? "Edit Purchase Order" : "New Purchase Order"}</h2>
        </div>
        <Btn onClick={handleSave}>💾 Save PO</Btn>
      </div>

      {/* PO Header */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ color: theme.accent, fontWeight: 800, fontSize: 14, marginBottom: 14 }}>📋 PO Details</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 12 }}>
          <div>
            <label style={lbl}>PO Number (Editable)</label>
            <input value={poNo} onChange={e => setPONo(e.target.value)} style={inp} />
          </div>
          <div>
            <label style={lbl}>PO Date</label>
            <input type="date" value={date} onChange={e => setDate(e.target.value)} style={inp} />
          </div>
          <div>
            <label style={lbl}>Reference</label>
            <input value={refNo} onChange={e => setRefNo(e.target.value)} style={inp} placeholder="e.g. Email" />
          </div>
          <div>
            <label style={lbl}>Reference Date</label>
            <input type="date" value={refDate} onChange={e => setRefDate(e.target.value)} style={inp} />
          </div>
        </div>
      </div>

      {/* Supplier Details */}
      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16, marginBottom: 16 }}>
        <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 20 }}>
          <div style={{ color: theme.accent, fontWeight: 800, fontSize: 14, marginBottom: 14 }}>🏢 Supplier Details</div>
          <div style={{ marginBottom: 10 }}>
            <label style={lbl}>Kind Attn</label>
            <input value={kindAttn} onChange={e => setKindAttn(e.target.value)} style={inp} placeholder="Contact person at supplier..." />
          </div>
          <div style={{ marginBottom: 10 }}>
            <label style={lbl}>Supplier Name</label>
            <input value={supplierName} onChange={e => setSupplierName(e.target.value)} style={inp} placeholder="Company name..." />
          </div>
          <div style={{ marginBottom: 10 }}>
            <label style={lbl}>Supplier Address</label>
            <textarea value={supplierAddress} onChange={e => setSupplierAddress(e.target.value)} style={{ ...inp, height: 70, resize: "vertical" }} placeholder="Full address..." />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div>
              <label style={lbl}>Contact Person</label>
              <input value={contactPerson} onChange={e => setContactPerson(e.target.value)} style={inp} placeholder="Name..." />
            </div>
            <div>
              <label style={lbl}>Mobile No.</label>
              <input value={contactMobile} onChange={e => setContactMobile(e.target.value)} style={inp} placeholder="+91..." />
            </div>
          </div>
        </div>

        <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 20 }}>
          <div style={{ color: theme.accent, fontWeight: 800, fontSize: 14, marginBottom: 14 }}>🚚 Delivery Address</div>
          <div style={{ marginBottom: 10 }}>
            <label style={lbl}>Delivery To</label>
            <input value={deliveryName} onChange={e => setDeliveryName(e.target.value)} style={inp} />
          </div>
          <div style={{ marginBottom: 10 }}>
            <label style={lbl}>Delivery Address</label>
            <textarea value={deliveryAddress} onChange={e => setDeliveryAddress(e.target.value)} style={{ ...inp, height: 70, resize: "vertical" }} />
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
            <div>
              <label style={lbl}>Contact Person</label>
              <input value={deliveryContact} onChange={e => setDeliveryContact(e.target.value)} style={inp} />
            </div>
            <div>
              <label style={lbl}>Mobile No.</label>
              <input value={deliveryMobile} onChange={e => setDeliveryMobile(e.target.value)} style={inp} />
            </div>
          </div>
        </div>
      </div>

      {/* Items Table */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden", marginBottom: 16 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "14px 18px", background: "#162040" }}>
          <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>📦 Item Details</div>
          <button onClick={() => setItems(is => [...is, { id: Date.now(), description: "", unit: "", packing: "", qty: "", rate: "" }])}
            style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 7, padding: "5px 14px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>+ Add Item</button>
        </div>
        <div style={{ overflowX: "auto" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 800 }}>
            <thead>
              <tr>{["Sr.", "Description", "Unit", "Packing", "Qty", "Rate ₹", "Amount ₹", ""].map(h => <th key={h} style={th}>{h}</th>)}</tr>
            </thead>
            <tbody>
              {items.map((item, i) => {
                const amount = Math.round((Number(item.qty) || 0) * (Number(item.rate) || 0) * 100) / 100;
                return (
                  <tr key={item.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                    <td style={{ ...td, color: theme.muted, width: 40 }}>{i + 1}</td>
                    <td style={{ ...td, minWidth: 200 }}>
                      <input value={item.description} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, description: e.target.value } : x))}
                        style={inp} placeholder="Item description..." />
                    </td>
                    <td style={{ ...td, width: 80 }}>
                      <input value={item.unit} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, unit: e.target.value } : x))}
                        style={inp} placeholder="Bags" />
                    </td>
                    <td style={{ ...td, width: 160 }}>
                      <input value={item.packing} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, packing: e.target.value } : x))}
                        style={inp} placeholder="25 kg X 50 Bag" />
                    </td>
                    <td style={{ ...td, width: 80 }}>
                      <input type="number" value={item.qty} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, qty: e.target.value } : x))}
                        style={{ ...inp, color: theme.blue, fontWeight: 700 }} placeholder="0" />
                    </td>
                    <td style={{ ...td, width: 100 }}>
                      <input type="number" value={item.rate} onChange={e => setItems(is => is.map((x, j) => j === i ? { ...x, rate: e.target.value } : x))}
                        style={{ ...inp, color: theme.accent, fontWeight: 700 }} placeholder="0" />
                    </td>
                    <td style={{ ...td, color: theme.green, fontWeight: 700, width: 120 }}>₹{amount.toLocaleString("en-IN")}</td>
                    <td style={{ ...td, width: 40 }}>
                      <button onClick={() => setItems(is => is.filter((_, j) => j !== i))}
                        style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 28, height: 28, fontSize: 14, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* GST & Totals */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 20, marginBottom: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", flexWrap: "wrap", gap: 16 }}>
          <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
            <label style={{ ...lbl, marginBottom: 0 }}>GST %</label>
            <input type="number" value={gst} onChange={e => setGst(e.target.value)}
              style={{ ...inp, width: 80, color: theme.accent, fontWeight: 700, textAlign: "center" }} />
          </div>
          <div style={{ textAlign: "right" }}>
            {[["Sub Total", subTotal, theme.text], [`GST @ ${gst}%`, gstAmount, theme.purple], ["Grand Total", grandTotal, theme.green]].map(([label, val, color]) => (
              <div key={label} style={{ display: "flex", justifyContent: "space-between", gap: 40, marginBottom: 6 }}>
                <span style={{ color: theme.muted, fontSize: 13 }}>{label}</span>
                <span style={{ color, fontWeight: label === "Grand Total" ? 900 : 600, fontSize: label === "Grand Total" ? 18 : 13 }}>
                  ₹{val.toLocaleString("en-IN")}
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
        <Btn variant="ghost" onClick={onBack}>Cancel</Btn>
        <Btn onClick={handleSave}>💾 Save Purchase Order</Btn>
      </div>
    </div>
  );
}

// ============================================================
// PO PREVIEW (Print-ready)
// ============================================================

function POPreview({ po, onBack, onEdit }) {
  return (
    <div>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          #po-print, #po-print * { visibility: visible !important; }
          #po-print { position: absolute !important; top: 0 !important; left: 0 !important; width: 100% !important; padding: 16px 20px !important; }
          .no-print { display: none !important; }
          @page { margin: 0; size: A4; }
        }
      `}</style>

      {/* Action Bar */}
      <div className="no-print" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <button onClick={onBack} style={{ background: "none", border: "none", color: theme.muted, cursor: "pointer", fontSize: 13, padding: 0 }}>← Back to Purchase Orders</button>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn variant="ghost" onClick={onEdit}>✏️ Edit</Btn>
          <Btn variant="blue" onClick={() => window.print()}>🖨 Print / PDF</Btn>
        </div>
      </div>

      {/* Printable Area */}
      <div id="po-print" style={{ background: "#fff", color: "#000", padding: 24, borderRadius: 12, border: `1px solid ${theme.border}`, fontFamily: "Arial, sans-serif", fontSize: 11 }}>

        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", borderBottom: "2px solid #1a365d", paddingBottom: 12, marginBottom: 12 }}>
          <div>
            <div style={{ fontWeight: 900, fontSize: 16, color: "#1a365d", letterSpacing: 1 }}>PERMATECH CONCRETE SOLUTIONS</div>
            <div style={{ fontSize: 10, color: "#555", marginTop: 3 }}>18, Divya Darshan, Mount Mary Steps, Bandra West Mumbai - 400050.</div>
            <div style={{ fontSize: 10, color: "#555" }}>Tel: 7738131631 &nbsp;|&nbsp; Email: info@permatech.in</div>
          </div>
          <div style={{ textAlign: "center" }}>
            <div style={{ fontWeight: 900, fontSize: 18, letterSpacing: 3, border: "2px solid #1a365d", color: "#1a365d", padding: "6px 20px" }}>PURCHASE ORDER</div>
          </div>
        </div>

        {/* PO Info Grid */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", border: "1px solid #000", marginBottom: 12 }}>
          {/* Left — Supplier */}
          <div style={{ borderRight: "1px solid #000", padding: "10px 12px" }}>
            {po.kindAttn && <div style={{ fontSize: 10, marginBottom: 4 }}>Kind Attn: <strong>{po.kindAttn}</strong></div>}
            <div style={{ fontSize: 10, color: "#666", marginBottom: 2 }}>To,</div>
            <div style={{ fontWeight: 800, fontSize: 13 }}>{po.supplierName}</div>
            <div style={{ fontSize: 10, color: "#444", marginTop: 4, lineHeight: 1.5 }}>{po.supplierAddress}</div>
          </div>
          {/* Right — PO Details */}
          <div style={{ padding: 0 }}>
            {[
              ["Purchase Order No:", po.poNo, `Dated: ${po.date}`],
              ["Reference:", po.refNo, `Dated: ${po.refDate}`],
              ["Contact Person:", po.contactPerson || "—", ""],
              ["Mobile No.", po.contactMobile || "—", ""],
            ].map(([label, val, extra]) => (
              <div key={label} style={{ display: "grid", gridTemplateColumns: "130px 1fr auto", borderBottom: "1px solid #ddd", padding: "5px 8px", gap: 4 }}>
                <span style={{ fontWeight: 600, color: "#333", fontSize: 10 }}>{label}</span>
                <span style={{ fontSize: 10 }}>{val}</span>
                <span style={{ color: "#555", fontSize: 10 }}>{extra}</span>
              </div>
            ))}
            <div style={{ padding: "5px 8px", fontSize: 10, color: "#555" }}>
              18, Divya Darshan, Mount Mary Steps, Bandra (W), Mumbai - 400050.
            </div>
          </div>
        </div>

        {/* Items Table */}
        <div style={{ fontSize: 10, fontWeight: 700, marginBottom: 6, color: "#1a365d" }}>¦ Item Details</div>
        <table style={{ width: "100%", borderCollapse: "collapse", marginBottom: 12 }}>
          <thead>
            <tr style={{ background: "#1a365d" }}>
              {["Sr.no", "Description", "Unit", "Packing", "Qty", "Rate", "Amount"].map(h => (
                <th key={h} style={{ border: "1px solid #2d4a7a", padding: "7px 8px", color: "#fff", fontSize: 10, fontWeight: 800, textAlign: h === "Description" ? "left" : "center" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {po.items?.map((item, i) => {
              const amount = Math.round((Number(item.qty) || 0) * (Number(item.rate) || 0) * 100) / 100;
              return (
                <tr key={i} style={{ background: i % 2 === 0 ? "#fff" : "#f8fafc" }}>
                  <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center", fontSize: 10 }}>{i + 1}</td>
                  <td style={{ border: "1px solid #ccc", padding: "8px", fontSize: 10, fontWeight: 600 }}>{item.description}</td>
                  <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center", fontSize: 10 }}>{item.unit}</td>
                  <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center", fontSize: 10 }}>{item.packing}</td>
                  <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center", fontSize: 10, fontWeight: 700 }}>{item.qty}</td>
                  <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "right", fontSize: 10 }}>{Number(item.rate).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
                  <td style={{ border: "1px solid #ccc", padding: "8px", textAlign: "right", fontSize: 10, fontWeight: 700 }}>{amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
                </tr>
              );
            })}
            {/* Empty rows */}
            {Array.from({ length: Math.max(0, 3 - (po.items?.length || 0)) }).map((_, i) => (
              <tr key={`e${i}`}>
                {[...Array(7)].map((_, j) => <td key={j} style={{ border: "1px solid #ccc", padding: "8px" }}>&nbsp;</td>)}
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr style={{ background: "#f8fafc" }}>
              <td colSpan={5} style={{ border: "1px solid #ccc", padding: "6px 8px", textAlign: "right", fontWeight: 700, fontSize: 10 }}>Sub Total</td>
              <td colSpan={2} style={{ border: "1px solid #ccc", padding: "6px 8px", textAlign: "right", fontWeight: 700, fontSize: 10 }}>{(po.subTotal || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
            <tr style={{ background: "#f8fafc" }}>
              <td colSpan={5} style={{ border: "1px solid #ccc", padding: "6px 8px", textAlign: "right", fontWeight: 700, fontSize: 10 }}>Add : GST {po.gst}%</td>
              <td colSpan={2} style={{ border: "1px solid #ccc", padding: "6px 8px", textAlign: "right", fontWeight: 700, fontSize: 10, color: "#7c3aed" }}>{(po.gstAmount || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
            <tr style={{ background: "#1a365d" }}>
              <td colSpan={5} style={{ border: "1px solid #2d4a7a", padding: "8px", textAlign: "right", fontWeight: 900, fontSize: 11, color: "#fff" }}>Grand Total:-</td>
              <td colSpan={2} style={{ border: "1px solid #2d4a7a", padding: "8px", textAlign: "right", fontWeight: 900, fontSize: 13, color: "#6EE7B7" }}>{(po.grandTotal || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
          </tfoot>
        </table>

        {/* Amount in words */}
        <div style={{ background: "#f0f4f8", border: "1px solid #ccc", borderRadius: 5, padding: "6px 12px", marginBottom: 12, fontSize: 10, fontWeight: 600 }}>
          RUPEES : {po.amountInWords}
        </div>

        {/* GST No */}
        <div style={{ fontSize: 10, color: "#555", marginBottom: 12 }}>
          GST NO 27AAJFP3195N1ZJ
        </div>

        {/* Footer — Delivery + Signature */}
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginTop: 10 }}>
          <div style={{ border: "1px solid #ccc", borderRadius: 5, padding: "10px 14px" }}>
            <div style={{ fontWeight: 800, fontSize: 11, color: "#1a365d", marginBottom: 8, borderBottom: "1px solid #ccc", paddingBottom: 4 }}>DELIVERY ADDRESS</div>
            <div style={{ fontSize: 10, lineHeight: 1.8 }}>
              <div style={{ fontWeight: 700 }}>{po.deliveryName}</div>
              <div style={{ color: "#444" }}>{po.deliveryAddress}</div>
              <div>Contact Person : {po.deliveryContact}</div>
              <div>Contact No:- {po.deliveryMobile}</div>
            </div>
          </div>
          <div style={{ textAlign: "right", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            <div style={{ fontWeight: 700, fontSize: 12, color: "#1a365d" }}>For Permatech Concrete Solutions</div>
            <div style={{ borderTop: "1px solid #000", paddingTop: 5, fontSize: 11, display: "inline-block", minWidth: 180, marginTop: 60 }}>Authorised Signatory</div>
          </div>
        </div>
      </div>
    </div>
  );
}

function UserManagement() {
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", password: "", role: "office" });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const ROLES = {
    admin: { label: "Admin", color: "#EF4444", access: "Full Access" },
    office: { label: "Office Staff", color: "#3B82F6", access: "Projects, Inventory, HRMS" },
    engineer: { label: "Site Engineer / Supervisor", color: "#10B981", access: "Project Management" },
    labour: { label: "Labour", color: "#F97316", access: "HRMS" },
  };

  useEffect(() => {
    getDocs(collection(db, "users")).then(snap => {
      setUsers(snap.docs.map(d => ({ uid: d.id, ...d.data() })));
    });
  }, []);

  const handleCreate = async () => {
    if (!form.name.trim() || !form.email.trim() || !form.password.trim()) { setError("Please fill all fields."); return; }
    if (form.password.length < 6) { setError("Password must be at least 6 characters."); return; }
    setLoading(true);
    setError("");
    try {
      const cred = await createUserWithEmailAndPassword(auth, form.email.trim(), form.password);
      const userData = { name: form.name, email: form.email.trim(), role: form.role, createdAt: new Date().toISOString() };
      await setDoc(fsDoc(db, "users", cred.user.uid), userData);
      setUsers(u => [...u, { uid: cred.user.uid, ...userData }]);
      setSuccess(`Account created for ${form.name}!`);
      setForm({ name: "", email: "", password: "", role: "office" });
      setShowForm(false);
      setTimeout(() => setSuccess(""), 3000);
    } catch (e) {
      if (e.code === "auth/email-already-in-use") setError("This email is already registered.");
      else setError("Failed to create account. Try again.");
    }
    setLoading(false);
  };

  const handleDelete = async (uid, name) => {
    if (!window.confirm(`Delete account for ${name}? This cannot be undone.`)) return;
    await deleteDoc(fsDoc(db, "users", uid));
    setUsers(u => u.filter(x => x.uid !== uid));
  };

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "8px 10px", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Administration</div>
          <h2 style={{ color: theme.text, fontSize: 26, fontWeight: 800, margin: 0 }}>👥 User Management</h2>
          <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>{users.length} total accounts</div>
        </div>
        <Btn onClick={() => { setShowForm(true); setError(""); }}>+ Create Account</Btn>
      </div>

      {/* Role Summary Cards */}
      <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
        {Object.entries(ROLES).map(([key, r]) => (
          <div key={key} style={{ background: theme.card, border: `1px solid ${r.color}33`, borderRadius: 12, padding: "14px 18px", flex: 1, minWidth: 160 }}>
            <div style={{ color: r.color, fontWeight: 800, fontSize: 20 }}>{users.filter(u => u.role === key).length}</div>
            <div style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>{r.label}</div>
            <div style={{ color: theme.muted, fontSize: 11, marginTop: 2 }}>{r.access}</div>
          </div>
        ))}
      </div>

      {success && (
        <div style={{ background: theme.green + "11", border: `1px solid ${theme.green}33`, borderRadius: 8, padding: "10px 14px", color: theme.green, fontSize: 13, fontWeight: 600, marginBottom: 16 }}>
          ✓ {success}
        </div>
      )}

      {/* Create Form */}
      {showForm && (
        <div style={{ background: theme.card, border: `1px solid ${theme.accent}44`, borderRadius: 12, padding: 20, marginBottom: 20 }}>
          <div style={{ color: theme.accent, fontSize: 12, fontWeight: 700, textTransform: "uppercase", marginBottom: 16 }}>➕ Create New Account</div>
          {error && <div style={{ background: theme.red + "11", border: `1px solid ${theme.red}33`, borderRadius: 7, padding: "8px 12px", color: theme.red, fontSize: 12, marginBottom: 12 }}>⚠️ {error}</div>}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr 1fr", gap: 10, marginBottom: 16 }}>
            <div><label style={lbl}>Full Name</label><input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={inp} placeholder="e.g. Rahul Sharma" /></div>
            <div><label style={lbl}>Email Address</label><input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} style={inp} placeholder="email@company.com" /></div>
            <div><label style={lbl}>Password</label><input type="password" value={form.password} onChange={e => setForm(f => ({ ...f, password: e.target.value }))} style={inp} placeholder="Min 6 characters" /></div>
            <div>
              <label style={lbl}>Role</label>
              <select value={form.role} onChange={e => setForm(f => ({ ...f, role: e.target.value }))} style={{ ...inp, color: ROLES[form.role].color }}>
                {Object.entries(ROLES).map(([key, r]) => (
                  <option key={key} value={key}>{r.label}</option>
                ))}
              </select>
            </div>
          </div>
          <div style={{ background: theme.bg, borderRadius: 8, padding: "10px 14px", marginBottom: 16 }}>
            <div style={{ color: theme.muted, fontSize: 12 }}>
              <span style={{ fontWeight: 700, color: ROLES[form.role].color }}>{ROLES[form.role].label}</span> will have access to: <span style={{ color: theme.text }}>{ROLES[form.role].access}</span>
            </div>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Btn variant="ghost" onClick={() => { setShowForm(false); setError(""); }}>Cancel</Btn>
            <Btn onClick={handleCreate} disabled={loading}>{loading ? "Creating..." : "✓ Create Account"}</Btn>
          </div>
        </div>
      )}

      {/* Users Table */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {["Name", "Email", "Role", "Access", "Created", "Action"].map(h => (
                <th key={h} style={{ padding: "12px 16px", background: theme.accent + "22", color: theme.accent, fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "left", borderBottom: `2px solid ${theme.accent}` }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {users.map((user, i) => (
              <tr key={user.uid} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                <td style={{ padding: "12px 16px", color: theme.text, fontWeight: 700, fontSize: 13 }}>{user.name}</td>
                <td style={{ padding: "12px 16px", color: theme.muted, fontSize: 13 }}>{user.email}</td>
                <td style={{ padding: "12px 16px" }}>
                  <span style={{ background: (ROLES[user.role]?.color || theme.muted) + "22", color: ROLES[user.role]?.color || theme.muted, borderRadius: 5, padding: "3px 10px", fontSize: 11, fontWeight: 700 }}>
                    {ROLES[user.role]?.label || user.role}
                  </span>
                </td>
                <td style={{ padding: "12px 16px", color: theme.muted, fontSize: 12 }}>{ROLES[user.role]?.access || "—"}</td>
                <td style={{ padding: "12px 16px", color: theme.muted, fontSize: 12 }}>{user.createdAt ? user.createdAt.slice(0, 10) : "—"}</td>
                <td style={{ padding: "12px 16px" }}>
                  {user.role !== "admin" && (
                    <Btn small variant="danger" onClick={() => handleDelete(user.uid, user.name)}>🗑 Delete</Btn>
                  )}
                  {user.role === "admin" && <span style={{ color: theme.faint, fontSize: 11 }}>Protected</span>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        {users.length === 0 && (
          <div style={{ padding: 40, textAlign: "center", color: theme.muted }}>No users yet. Create the first account.</div>
        )}
      </div>
    </div>
  );
}

function LoginScreen({ onLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleLogin = async () => {
    if (!email.trim() || !password.trim()) { setError("Please enter email and password."); return; }
    setLoading(true);
    setError("");
    try {
      const cred = await signInWithEmailAndPassword(auth, email.trim(), password);
      const snap = await getDoc(fsDoc(db, "users", cred.user.uid));
      if (!snap.exists()) { setError("User profile not found. Contact admin."); setLoading(false); return; }
      onLogin({ uid: cred.user.uid, ...snap.data() });
    } catch (e) {
      setError("Invalid email or password. Please try again.");
    }
    setLoading(false);
  };

  const inp = { width: "100%", background: "#1A2235", border: "1px solid #2D3748", borderRadius: 8, color: "#E2E8F0", padding: "12px 14px", fontSize: 14, outline: "none", boxSizing: "border-box", marginBottom: 12 };

  return (
    <div style={{ minHeight: "100vh", background: "#0A0F1A", display: "flex", alignItems: "center", justifyContent: "center" }}>
      <div style={{ background: "#111827", border: "1px solid #2D3748", borderRadius: 16, padding: 40, width: "100%", maxWidth: 420 }}>
        <div style={{ textAlign: "center", marginBottom: 32 }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>🏗️</div>
          <h2 style={{ color: "#E2E8F0", fontSize: 24, fontWeight: 800, margin: 0 }}>Permatech ERP</h2>
          <div style={{ color: "#64748B", fontSize: 13, marginTop: 6 }}>Sign in to your account</div>
        </div>

        {error && (
          <div style={{ background: "#EF444411", border: "1px solid #EF444444", borderRadius: 8, padding: "10px 14px", color: "#EF4444", fontSize: 13, marginBottom: 16 }}>
            ⚠️ {error}
          </div>
        )}

        <div>
          <label style={{ color: "#94A3B8", fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 4 }}>Email Address</label>
          <input type="email" value={email} onChange={e => setEmail(e.target.value)} style={inp} placeholder="your@email.com"
            onKeyDown={e => e.key === "Enter" && handleLogin()} />
        </div>

        <div>
          <label style={{ color: "#94A3B8", fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.7, display: "block", marginBottom: 4 }}>Password</label>
          <input type="password" value={password} onChange={e => setPassword(e.target.value)} style={inp} placeholder="••••••••"
            onKeyDown={e => e.key === "Enter" && handleLogin()} />
        </div>

        <button onClick={handleLogin} disabled={loading}
          style={{ width: "100%", background: loading ? "#2D3748" : "#3B82F6", border: "none", borderRadius: 8, color: "#fff", padding: "13px 0", fontSize: 15, fontWeight: 700, cursor: loading ? "not-allowed" : "pointer", marginTop: 8 }}>
          {loading ? "Signing in..." : "Sign In"}
        </button>

        <div style={{ color: "#4A5568", fontSize: 12, textAlign: "center", marginTop: 20 }}>
          Contact your administrator to get access.
        </div>
      </div>
    </div>
  );
}
function CandidateScreening() {
  const [candidates, setCandidates] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [editId, setEditId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [viewResume, setViewResume] = useState(null);
  const emptyForm = { name: "", email: "", phone: "", linkedin: "", interviewDate: "", selection: "Pending", resumeData: null, resumeName: "", resumeType: "", resumeSize: 0 };
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    // Load from localStorage first
    try {
      const ls = localStorage.getItem("candidate_screening");
      if (ls) setCandidates(JSON.parse(ls));
    } catch (e) { console.error(e); }
    // Load metadata from Firestore
    getDocs(collection(db, "candidate_screening")).then(snap => {
      if (snap.docs.length > 0) {
        const firestoreDocs = snap.docs.map(d => d.data());
        // Merge with localStorage (localStorage has resume base64)
        try {
          const ls = localStorage.getItem("candidate_screening");
          const localDocs = ls ? JSON.parse(ls) : [];
          const merged = firestoreDocs.map(fd => {
            const local = localDocs.find(ld => String(ld.id) === String(fd.id));
            return local ? { ...fd, ...local } : fd;
          });
          setCandidates(merged);
        } catch { setCandidates(firestoreDocs); }
      }
    }).catch(e => console.error(e));
  }, []);

  const saveCandidates = async (updated) => {
    setCandidates(updated);
    // Save full data (with base64) to localStorage
    try { localStorage.setItem("candidate_screening", JSON.stringify(updated)); }
    catch (e) { console.warn("localStorage full:", e); }
    // Save metadata only to Firestore
    for (const c of updated) {
      try {
        const { resumeData, ...safe } = c;
        await setDoc(fsDoc(db, "candidate_screening", String(c.id)), {
          ...safe, id: String(c.id), savedAt: new Date().toISOString()
        });
      } catch (e) { console.error("Firestore save failed:", e); }
    }
  };

  const handleResumeUpload = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = e => resolve({ resumeData: e.target.result, resumeName: file.name, resumeType: file.type, resumeSize: file.size });
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  const handleSave = async () => {
    if (!form.name.trim()) { alert("Please enter candidate name."); return; }
    setSaving(true);
    try {
      const id = editId || Date.now();
      const candidate = { ...form, id };
      const updated = editId
        ? candidates.map(c => c.id === editId ? candidate : c)
        : [...candidates, candidate];
      await saveCandidates(updated);
      setForm(emptyForm);
      setShowForm(false);
      setEditId(null);
    } catch (e) { console.error(e); alert("Save failed: " + e.message); }
    finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this candidate?")) return;
    const updated = candidates.filter(c => c.id !== id);
    await saveCandidates(updated);
    try { await deleteDoc(fsDoc(db, "candidate_screening", String(id))); } catch (e) { console.error(e); }
  };

  const handleEdit = (c) => { setForm(c); setEditId(c.id); setShowForm(true); };

  const formatSize = (b) => {
    if (!b) return "—";
    if (b < 1024) return b + " B";
    if (b < 1024 * 1024) return (b / 1024).toFixed(1) + " KB";
    return (b / (1024 * 1024)).toFixed(1) + " MB";
  };

  const selectionColor = (s) => s === "Selected" ? theme.green : s === "Rejected" ? theme.red : s === "On Hold" ? theme.orange : theme.muted;

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "9px 12px", fontSize: 14, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 11, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 };
  const thStyle = { padding: "10px 12px", background: theme.accent + "22", color: theme.accent, fontSize: 11, fontWeight: 800, textTransform: "uppercase", textAlign: "left", borderBottom: `2px solid ${theme.accent}`, whiteSpace: "nowrap" };
  const tdStyle = { padding: "11px 14px", borderBottom: `1px solid ${theme.border}`, fontSize: 13, color: theme.text, verticalAlign: "middle" };

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>HRMS</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>👤 Candidate Screening</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{candidates.length} candidate{candidates.length !== 1 ? "s" : ""} registered</div>
        </div>
        <Btn onClick={() => { setForm(emptyForm); setEditId(null); setShowForm(true); }}>+ Add Candidate</Btn>
      </div>

      {/* Stats */}
      <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
        <StatCard label="Total Candidates" value={candidates.length} color={theme.blue} icon="👤" />
        <StatCard label="Selected" value={candidates.filter(c => c.selection === "Selected").length} color={theme.green} icon="✅" />
        <StatCard label="Rejected" value={candidates.filter(c => c.selection === "Rejected").length} color={theme.red} icon="❌" />
        <StatCard label="Pending" value={candidates.filter(c => c.selection === "Pending").length} color={theme.orange} icon="⏳" />
      </div>

      {/* Form */}
      {showForm && (
        <div style={{ background: theme.card, border: `1px solid ${theme.accent}44`, borderRadius: 12, padding: 20, marginBottom: 20 }}>
          <div style={{ color: theme.accent, fontSize: 13, fontWeight: 700, marginBottom: 16 }}>
            {editId ? "✏️ Edit Candidate" : "➕ New Candidate"}
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
            <div>
              <label style={lbl}>Name <span style={{ color: theme.red }}>*</span></label>
              <input value={form.name} onChange={e => setForm(f => ({ ...f, name: e.target.value }))} style={inp} placeholder="Full name..." />
            </div>
            <div>
              <label style={lbl}>Email</label>
              <input type="email" value={form.email} onChange={e => setForm(f => ({ ...f, email: e.target.value }))} style={inp} placeholder="email@example.com" />
            </div>
            <div>
              <label style={lbl}>Phone</label>
              <input value={form.phone} onChange={e => setForm(f => ({ ...f, phone: e.target.value }))} style={inp} placeholder="+91 98765 43210" />
            </div>
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
            <div>
              <label style={lbl}>LinkedIn URL</label>
              <input value={form.linkedin} onChange={e => setForm(f => ({ ...f, linkedin: e.target.value }))} style={inp} placeholder="https://linkedin.com/in/..." />
            </div>
            <div>
              <label style={lbl}>Interview Date</label>
              <input type="date" value={form.interviewDate} onChange={e => setForm(f => ({ ...f, interviewDate: e.target.value }))} style={inp} />
            </div>
            <div>
              <label style={lbl}>Selection Status</label>
              <select value={form.selection} onChange={e => setForm(f => ({ ...f, selection: e.target.value }))}
                style={{ ...inp, color: selectionColor(form.selection), fontWeight: 700, cursor: "pointer" }}>
                <option value="Pending">⏳ Pending</option>
                <option value="Selected">✅ Selected</option>
                <option value="Rejected">❌ Rejected</option>
                <option value="On Hold">⏸️ On Hold</option>
              </select>
            </div>
          </div>
          {/* Resume Upload */}
          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>Upload Resume</label>
            <label style={{ display: "flex", alignItems: "center", gap: 12, background: theme.bg, border: `1px dashed ${form.resumeData ? theme.green : theme.border}`, borderRadius: 8, padding: "12px 16px", cursor: "pointer" }}>
              <span style={{ fontSize: 22 }}>{form.resumeData ? "📄" : "📂"}</span>
              <div style={{ flex: 1 }}>
                {form.resumeData ? (
                  <div>
                    <div style={{ color: theme.green, fontWeight: 700, fontSize: 13 }}>✓ {form.resumeName}</div>
                    <div style={{ color: theme.muted, fontSize: 11 }}>{formatSize(form.resumeSize)} · Click to replace</div>
                  </div>
                ) : (
                  <div style={{ color: theme.muted, fontSize: 13 }}>Click to upload resume (PDF, DOC, DOCX)</div>
                )}
              </div>
              <input type="file" accept=".pdf,.doc,.docx" style={{ display: "none" }}
                onChange={async e => {
                  if (e.target.files[0]) {
                    const result = await handleResumeUpload(e.target.files[0]);
                    setForm(f => ({ ...f, ...result }));
                  }
                }} />
            </label>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Btn variant="ghost" onClick={() => { setShowForm(false); setForm(emptyForm); setEditId(null); }}>Cancel</Btn>
            <Btn onClick={handleSave} disabled={saving}>{saving ? "⏳ Saving..." : "💾 Save Candidate"}</Btn>
          </div>
        </div>
      )}

      {/* Table */}
      {candidates.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
          <div style={{ fontSize: 40, marginBottom: 10 }}>👤</div>
          <div style={{ color: theme.muted }}>No candidates yet. Click "+ Add Candidate" to start.</div>
        </div>
      ) : (
        <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 900 }}>
            <thead>
              <tr>
                {["SR", "Name", "Email", "Phone", "LinkedIn", "Resume", "Interview Date", "Status", "Actions"].map(h => (
                  <th key={h} style={thStyle}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {candidates.map((c, i) => (
                <tr key={c.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                  <td style={{ ...tdStyle, color: theme.muted, width: 40, textAlign: "center" }}>{i + 1}</td>
                  <td style={{ ...tdStyle, fontWeight: 700, minWidth: 140 }}>{c.name}</td>
                  <td style={{ ...tdStyle, minWidth: 160 }}>
                    {c.email ? <a href={`mailto:${c.email}`} style={{ color: theme.accent, textDecoration: "none" }}>{c.email}</a> : "—"}
                  </td>
                  <td style={{ ...tdStyle, minWidth: 120 }}>
                    {c.phone ? <a href={`tel:${c.phone}`} style={{ color: theme.text, textDecoration: "none" }}>{c.phone}</a> : "—"}
                  </td>
                  <td style={{ ...tdStyle, minWidth: 100 }}>
                    {c.linkedin ? (
                      <a href={c.linkedin} target="_blank" rel="noreferrer"
                        style={{ background: theme.blue + "22", color: theme.blue, border: `1px solid ${theme.blue}44`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700, textDecoration: "none" }}>
                        🔗 LinkedIn
                      </a>
                    ) : "—"}
                  </td>
                  <td style={{ ...tdStyle, minWidth: 100 }}>
                    {c.resumeData ? (
                      <div style={{ display: "flex", gap: 6 }}>
                        <button onClick={() => setViewResume(c)}
                          style={{ background: theme.accent + "22", color: theme.accent, border: `1px solid ${theme.accent}44`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                          👁 View
                        </button>
                        <a href={c.resumeData} download={c.resumeName}
                          style={{ background: theme.green + "22", color: theme.green, border: `1px solid ${theme.green}44`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700, textDecoration: "none" }}>
                          ⬇️
                        </a>
                      </div>
                    ) : <span style={{ color: theme.faint, fontSize: 11 }}>No resume</span>}
                  </td>
                  <td style={{ ...tdStyle, minWidth: 120, color: theme.muted }}>
                    {c.interviewDate ? new Date(c.interviewDate).toLocaleDateString("en-IN") : "—"}
                  </td>
                  <td style={{ ...tdStyle, minWidth: 110 }}>
                    <span style={{ background: selectionColor(c.selection) + "22", color: selectionColor(c.selection), border: `1px solid ${selectionColor(c.selection)}44`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700 }}>
                      {c.selection === "Selected" ? "✅" : c.selection === "Rejected" ? "❌" : c.selection === "On Hold" ? "⏸️" : "⏳"} {c.selection}
                    </span>
                  </td>
                  <td style={{ ...tdStyle, minWidth: 100 }}>
                    <div style={{ display: "flex", gap: 6 }}>
                      <Btn small variant="ghost" onClick={() => handleEdit(c)}>✏️</Btn>
                      <Btn small variant="danger" onClick={() => handleDelete(c.id)}>🗑</Btn>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Resume Preview Modal */}
      {viewResume && (
        <div style={{ position: "fixed", inset: 0, background: "#000000dd", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
          onClick={() => setViewResume(null)}>
          <div style={{ background: theme.card, borderRadius: 12, width: "100%", maxWidth: 900, maxHeight: "92vh", overflow: "auto" }}
            onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "12px 18px", borderBottom: `1px solid ${theme.border}` }}>
              <div>
                <span style={{ color: theme.text, fontWeight: 700 }}>📄 {viewResume.resumeName}</span>
                <div style={{ color: theme.muted, fontSize: 11, marginTop: 2 }}>{viewResume.name} · {formatSize(viewResume.resumeSize)}</div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <a href={viewResume.resumeData} download={viewResume.resumeName}
                  style={{ background: theme.accent + "22", color: theme.accent, border: `1px solid ${theme.accent}44`, borderRadius: 7, padding: "6px 14px", fontSize: 12, fontWeight: 700, textDecoration: "none" }}>
                  ⬇️ Download
                </a>
                <Btn small variant="ghost" onClick={() => setViewResume(null)}>✕ Close</Btn>
              </div>
            </div>
            <div style={{ padding: 20, textAlign: "center" }}>
              {viewResume.resumeType === "application/pdf" ? (
                <embed src={viewResume.resumeData} type="application/pdf" width="100%" height="600px" style={{ borderRadius: 8 }} />
              ) : (
                <div style={{ padding: 40 }}>
                  <div style={{ fontSize: 48, marginBottom: 12 }}>📝</div>
                  <div style={{ color: theme.text, fontWeight: 700 }}>{viewResume.resumeName}</div>
                  <div style={{ color: theme.muted, fontSize: 12, marginTop: 4 }}>Word documents cannot be previewed directly.</div>
                  <a href={viewResume.resumeData} download={viewResume.resumeName}
                    style={{ display: "inline-block", marginTop: 14, background: theme.accent, color: "#fff", borderRadius: 8, padding: "8px 20px", fontSize: 13, fontWeight: 700, textDecoration: "none" }}>
                    ⬇️ Download to View
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}



function SiteMaster({ projects = [] }) {
  const [siteData, setSiteData] = useState({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");

  const STATUS = {
    APPROVED: "Approved",
    EXECUTION: "Execution",
    COMPLETED: "Completed",
    ON_HOLD: "On Hold",
  };

  const STATUS_COLORS = {
    "Approved": { color: "#3B82F6", bg: "#3B82F622", border: "#3B82F644", icon: "✅" },
    "Execution": { color: "#F59E0B", bg: "#F59E0B22", border: "#F59E0B44", icon: "🔧" },
    "Completed": { color: "#10B981", bg: "#10B98122", border: "#10B98144", icon: "🏁" },
    "On Hold": { color: "#EF4444", bg: "#EF444422", border: "#EF444444", icon: "⏸️" },
  };

  useEffect(() => {
    getDocs(collection(db, "site_master")).then(snap => {
      const data = {};
      snap.docs.forEach(d => { data[d.id] = d.data(); });
      setSiteData(data);
    }).catch(() => {
      const ls = localStorage.getItem("site_master");
      if (ls) setSiteData(JSON.parse(ls));
    }).finally(() => setLoading(false));
  }, []);

  const updateSiteStatus = async (projectId, status) => {
    setSaving(true);
    const updated = {
      ...siteData,
      [projectId]: {
        ...(siteData[projectId] || {}),
        status,
        updatedAt: new Date().toISOString(),
      }
    };
    setSiteData(updated);
    localStorage.setItem("site_master", JSON.stringify(updated));
    try {
      await setDoc(fsDoc(db, "site_master", String(projectId)), {
        projectId,
        status,
        updatedAt: new Date().toISOString(),
      });
    } catch (e) { console.error(e); }
    finally { setSaving(false); }
  };

  // Summary counts
  const counts = projects.reduce((acc, p) => {
    const status = siteData[p.id]?.status || "Approved";
    acc[status] = (acc[status] || 0) + 1;
    acc.total++;
    return acc;
  }, { "Approved": 0, "Execution": 0, "Completed": 0, "On Hold": 0, total: 0 });

  // Filtered projects
  const filtered = projects.filter(p => {
    const status = siteData[p.id]?.status || "Approved";
    const matchSearch = !searchQuery ||
      p.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.clientName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      p.siteAddress?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      status.toLowerCase().includes(searchQuery.toLowerCase());
    const matchFilter = filterStatus === "All" || status === filterStatus;
    return matchSearch && matchFilter;
  });

  const th = { padding: "10px 12px", background: "#162040", color: "#93c5fd", fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "left", border: "1px solid rgba(99,179,237,0.2)", whiteSpace: "nowrap" };
  const td = { padding: "10px 12px", border: `1px solid ${theme.border}`, fontSize: 12, verticalAlign: "middle" };

  if (loading) return <div style={{ color: theme.muted, padding: 20 }}>Loading site master...</div>;

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Project Management</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>🏗️ Site Master</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{projects.length} total sites registered</div>
        </div>
        {saving && <span style={{ color: theme.orange, fontSize: 12, fontWeight: 600 }}>⏳ Saving...</span>}
      </div>

      {/* Summary Cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(5, 1fr)", gap: 12, marginBottom: 24 }}>
        {[
          { label: "Total Sites", count: counts.total, color: theme.blue, icon: "🏗️" },
          { label: "Approved", count: counts["Approved"] || 0, color: "#3B82F6", icon: "✅" },
          { label: "In Execution", count: counts["Execution"] || 0, color: "#F59E0B", icon: "🔧" },
          { label: "Completed", count: counts["Completed"] || 0, color: "#10B981", icon: "🏁" },
          { label: "On Hold", count: counts["On Hold"] || 0, color: "#EF4444", icon: "⏸️" },
        ].map(({ label, count, color, icon }) => (
          <div key={label} onClick={() => setFilterStatus(label === "Total Sites" ? "All" : label === "In Execution" ? "Execution" : label)}
            style={{ background: theme.card, border: `2px solid ${filterStatus === (label === "Total Sites" ? "All" : label === "In Execution" ? "Execution" : label) ? color : color + "33"}`, borderRadius: 14, padding: "16px 14px", cursor: "pointer", position: "relative", overflow: "hidden", transition: "all 0.2s" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 4, background: color }} />
            <div style={{ fontSize: 22, marginBottom: 6 }}>{icon}</div>
            <div style={{ color, fontWeight: 900, fontSize: 28 }}>{count}</div>
            <div style={{ color: theme.text, fontWeight: 700, fontSize: 11, marginTop: 4 }}>{label}</div>
          </div>
        ))}
      </div>

      {/* Search + Filter */}
      <div style={{ display: "flex", gap: 12, marginBottom: 16, flexWrap: "wrap" }}>
        <input value={searchQuery} onChange={e => setSearchQuery(e.target.value)}
          placeholder="🔍 Search by site name, client or status..."
          style={{ flex: 1, background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 8, color: theme.text, padding: "9px 14px", fontSize: 13, outline: "none", minWidth: 200 }} />
        <div style={{ display: "flex", gap: 8 }}>
          {["All", "Approved", "Execution", "Completed", "On Hold"].map(s => (
            <button key={s} onClick={() => setFilterStatus(s)}
              style={{ background: filterStatus === s ? (STATUS_COLORS[s]?.color || theme.accent) + "22" : theme.card, border: `1px solid ${filterStatus === s ? (STATUS_COLORS[s]?.color || theme.accent) : theme.border}`, color: filterStatus === s ? (STATUS_COLORS[s]?.color || theme.accent) : theme.muted, borderRadius: 7, padding: "7px 14px", fontSize: 12, fontWeight: filterStatus === s ? 800 : 500, cursor: "pointer", whiteSpace: "nowrap" }}>
              {s === "All" ? "All Sites" : `${STATUS_COLORS[s]?.icon} ${s}`}
            </button>
          ))}
        </div>
      </div>

      {/* Site Table */}
      {filtered.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 40, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>🏗️</div>
          <div style={{ color: theme.muted }}>No sites found matching your search.</div>
        </div>
      ) : (
        <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
          <div style={{ padding: "12px 16px", background: "#162040", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>🏗️ Site List — {filtered.length} sites</div>
            <div style={{ color: "#5a7aa8", fontSize: 11 }}>Click a status button to update</div>
          </div>
          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 900 }}>
              <thead>
                <tr>
                  {["SR", "Site Name", "Client Name", "Project Code", "Current Status", "Change Status", "Last Updated"].map(h => (
                    <th key={h} style={th}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filtered.map((p, i) => {
                  const status = siteData[p.id]?.status || "Approved";
                  const updatedAt = siteData[p.id]?.updatedAt;
                  const sc = STATUS_COLORS[status] || STATUS_COLORS["Approved"];
                  return (
                    <tr key={p.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                      <td style={{ ...td, color: theme.muted, width: 50, textAlign: "center" }}>{i + 1}</td>
                      <td style={{ ...td, fontWeight: 700, minWidth: 180 }}>{p.name || "—"}</td>
                      <td style={{ ...td, color: theme.muted, minWidth: 150 }}>{p.clientName || "—"}</td>
                      <td style={{ ...td, minWidth: 100 }}>
                        {p.projectCode ? (
                          <span style={{ background: theme.accent + "22", color: theme.accent, borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>{p.projectCode}</span>
                        ) : "—"}
                      </td>
                      {/* Current Status Badge */}
                      <td style={{ ...td, minWidth: 120 }}>
                        <span style={{ background: sc.bg, color: sc.color, border: `1px solid ${sc.border}`, borderRadius: 7, padding: "4px 12px", fontSize: 12, fontWeight: 800 }}>
                          {sc.icon} {status}
                        </span>
                      </td>
                      {/* Status Action Buttons */}
                      <td style={{ ...td, minWidth: 340 }}>
                        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
                          {Object.values(STATUS).map(s => {
                            const c = STATUS_COLORS[s];
                            const isActive = status === s;
                            return (
                              <button key={s} onClick={() => !isActive && updateSiteStatus(p.id, s)}
                                disabled={isActive}
                                style={{ background: isActive ? c.color : c.bg, border: `1px solid ${c.border}`, color: isActive ? "#fff" : c.color, borderRadius: 6, padding: "4px 10px", fontSize: 11, fontWeight: 700, cursor: isActive ? "default" : "pointer", opacity: isActive ? 1 : 0.8, transition: "all 0.2s" }}>
                                {c.icon} {s}
                              </button>
                            );
                          })}
                        </div>
                      </td>
                      {/* Last Updated */}
                      <td style={{ ...td, color: theme.muted, fontSize: 11, minWidth: 120 }}>
                        {updatedAt ? new Date(updatedAt).toLocaleDateString("en-IN") : "—"}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              <tfoot>
                <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                  <td colSpan={4} style={{ ...td, color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 12 }}>
                    SUMMARY — {filtered.length} sites shown
                  </td>
                  {["Approved", "Execution", "Completed", "On Hold"].map(s => {
                    const c = STATUS_COLORS[s];
                    const cnt = filtered.filter(p => (siteData[p.id]?.status || "Approved") === s).length;
                    return (
                      <td key={s} style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", textAlign: "center" }}>
                        <span style={{ color: c.color, fontWeight: 800 }}>{c.icon} {cnt}</span>
                      </td>
                    );
                  })}
                  <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

function LabourDocModal({ labour, onClose, onSave }) {
  const [docs, setDocs] = useState(labour.documents || {});
  const DOC_TYPES = [
    { key: "aadhar", label: "Aadhar Card", icon: "🪪" },
    { key: "pan", label: "PAN Card", icon: "💳" },
    { key: "bank", label: "Bank Details", icon: "🏦" },
  ];

  const uploadDoc = (key, file) => {
    const reader = new FileReader();
    reader.onload = ev => {
      const updated = {
        ...docs,
        [key]: { name: file.name, data: ev.target.result, type: file.type, uploadedAt: new Date().toISOString() }
      };
      setDocs(updated);
      onSave(updated);
    };
    reader.readAsDataURL(file);
  };

  const deleteDoc = (key) => {
    if (!window.confirm(`Delete ${DOC_TYPES.find(d => d.key === key)?.label}?`)) return;
    const updated = { ...docs };
    delete updated[key];
    setDocs(updated);
    onSave(updated);
  };

  const viewDoc = (doc) => {
    const win = window.open();
    if (doc.type?.startsWith("image/")) {
      win.document.write(`<img src="${doc.data}" style="max-width:100%" />`);
    } else {
      win.document.write(`<iframe src="${doc.data}" style="width:100%;height:100vh;border:none"></iframe>`);
    }
  };

  const downloadDoc = (doc) => {
    const a = document.createElement("a");
    a.href = doc.data;
    a.download = doc.name;
    a.click();
  };

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000c", zIndex: 400, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: theme.card, borderRadius: 16, width: "100%", maxWidth: 520, boxShadow: "0 20px 60px rgba(0,0,0,0.4)" }}>
        <div style={{ padding: "16px 20px", background: "#162040", borderRadius: "16px 16px 0 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div>
            <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 15 }}>📁 Documents — {labour.name}</div>
            <div style={{ color: "#5a7aa8", fontSize: 11, marginTop: 2 }}>Labour ID: {labour.labourId}</div>
          </div>
          <button onClick={onClose} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", borderRadius: 8, width: 32, height: 32, cursor: "pointer", fontSize: 16 }}>×</button>
        </div>
        <div style={{ padding: 20 }}>
          {DOC_TYPES.map(dt => {
            const doc = docs[dt.key];
            return (
              <div key={dt.key} style={{ background: doc ? theme.green + "08" : theme.red + "08", border: `1px solid ${doc ? theme.green : theme.red}33`, borderRadius: 10, padding: "12px 16px", marginBottom: 12, display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ fontSize: 24, flexShrink: 0 }}>{doc ? "✅" : "❌"}</div>
                <div style={{ flex: 1 }}>
                  <div style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>{dt.icon} {dt.label}</div>
                  {doc ? (
                    <div style={{ color: theme.green, fontSize: 11, marginTop: 2 }}>{doc.name} · {doc.uploadedAt?.slice(0, 10)}</div>
                  ) : (
                    <div style={{ color: theme.red, fontSize: 11, marginTop: 2, fontWeight: 600 }}>Not uploaded</div>
                  )}
                </div>
                <div style={{ display: "flex", gap: 6, flexShrink: 0 }}>
                  {doc && (
                    <>
                      <button onClick={() => viewDoc(doc)} style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>👁 View</button>
                      <button onClick={() => downloadDoc(doc)} style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>📥</button>
                      <button onClick={() => deleteDoc(dt.key)} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 6, padding: "4px 8px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>🗑</button>
                    </>
                  )}
                  <label style={{ background: doc ? theme.orange + "22" : theme.accent + "22", border: `1px solid ${doc ? theme.orange : theme.accent}44`, color: doc ? theme.orange : theme.accent, borderRadius: 6, padding: "4px 10px", fontSize: 11, fontWeight: 700, cursor: "pointer" }}>
                    {doc ? "🔄 Replace" : "📤 Upload"}
                    <input type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display: "none" }}
                      onChange={e => { if (e.target.files[0]) uploadDoc(dt.key, e.target.files[0]); e.target.value = ""; }} />
                  </label>
                </div>
              </div>
            );
          })}
          <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 8 }}>
            <Btn variant="ghost" onClick={onClose}>Close</Btn>
          </div>
        </div>
      </div>
    </div>
  );
}



let SUPERVISOR_LIST = [
  { id: "sup_1", name: "Taukir Shaikh", typeOfJob: "Supervisor", basic: 32000 },
  { id: "sup_2", name: "Chandan Khedekar", typeOfJob: "Supervisor", basic: 26000 },
  { id: "sup_3", name: "Jamaul Islam", typeOfJob: "Supervisor", basic: 35000 },
  { id: "sup_4", name: "MD. Rashid Hus", typeOfJob: "Supervisor", basic: 32500 },
  { id: "sup_5", name: "RAFFIQUE NISA", typeOfJob: "Supervisor", basic: 20000 },
  { id: "sup_6", name: "HITESH", typeOfJob: "Supervisor", basic: 18000 },
];

function SupervisorDetailsTab({projects=[]}) {
  const [supervisors, setSupervisors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [newName, setNewName] = useState("");
  const [newTypeOfJob, setNewTypeOfJob] = useState("Supervisor");
  const [newBasic, setNewBasic] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [supTab, setSupTab] = useState("list");
  
  const [docModal, setDocModal] = useState(null);

  useEffect(() => {
    getDocs(collection(db, "supervisor_list")).then(snap => {
      if (snap.docs.length > 0) {
        const data = snap.docs.map(d => d.data());
        setSupervisors(data);
        SUPERVISOR_LIST = data;
      } else {
        const ls = localStorage.getItem("supervisor_list");
        if (ls) {
          const parsed = JSON.parse(ls);
          setSupervisors(parsed);
          SUPERVISOR_LIST = parsed;
        } else {
          setSupervisors(SUPERVISOR_LIST);
          saveSupervisors(SUPERVISOR_LIST);
        }
      }
    }).catch(() => {
      const ls = localStorage.getItem("supervisor_list");
      if (ls) {
        const parsed = JSON.parse(ls);
        setSupervisors(parsed);
        SUPERVISOR_LIST = parsed;
      } else {
        setSupervisors(SUPERVISOR_LIST);
      }
    }).finally(() => setLoading(false));
  }, []);

  const saveSupervisors = async (updated) => {
    setSaving(true);
    setSupervisors(updated);
    SUPERVISOR_LIST = updated;
    localStorage.setItem("supervisor_list", JSON.stringify(updated));
    try {
      for (const s of updated) {
        await setDoc(fsDoc(db, "supervisor_list", String(s.id)), s);
      }
    } catch (e) { console.error(e); }
    finally { setSaving(false); }
  };

  const handleAdd = () => {
    if (!newName.trim()) return alert("Please enter supervisor name.");
    if (!newBasic || isNaN(Number(newBasic))) return alert("Please enter a valid basic pay.");
    if (supervisors.find(s => s.name.toLowerCase() === newName.trim().toLowerCase())) {
      return alert("Supervisor with this name already exists.");
    }
    const newSup = {
      id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
      name: newName.trim(),
      typeOfJob: newTypeOfJob,
      basic: Number(newBasic),
      documents: {},
    };
    saveSupervisors([...supervisors, newSup]);
    setNewName(""); setNewTypeOfJob("Supervisor"); setNewBasic("");
    setShowAdd(false);
  };

  const handleEdit = (id, name, typeOfJob, basic) => {
    if (!name.trim()) return alert("Name cannot be empty.");
    if (!basic || isNaN(Number(basic))) return alert("Please enter a valid basic pay.");
    const updated = supervisors.map(s => s.id === id ? { ...s, name: name.trim(), typeOfJob, basic: Number(basic) } : s);
    saveSupervisors(updated);
    setEditingId(null);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this supervisor? They will be removed from the dropdown.")) return;
    const updated = supervisors.filter(s => s.id !== id);
    saveSupervisors(updated);
    deleteDoc(fsDoc(db, "supervisor_list", String(id))).catch(console.error);
  };

  const filtered = supervisors.filter(s =>
    s.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 13, outline: "none", boxSizing: "border-box" };
  const th = { padding: "10px 14px", background: "#162040", color: "#93c5fd", fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "left", border: "1px solid rgba(99,179,237,0.2)", whiteSpace: "nowrap" };
  const td = { padding: "10px 14px", borderBottom: `1px solid ${theme.border}`, fontSize: 13, color: theme.text, verticalAlign: "middle" };

  if (loading) return <div style={{ color: theme.muted, padding: 20 }}>Loading supervisor list...</div>;

 return (
  <div>
    <Tabs active={supTab} onChange={setSupTab} tabs={[
      { id: "list", label: "👔 Supervisor List" },
      { id: "payroll", label: "💰 Supervisor Payroll" },
    ]} />

    {supTab === "payroll" && <SupervisorPayrollTab projects={projects} />}

    {supTab === "list" && <>
    {docModal && (
  <LabourDocModal
    labour={docModal}
    onClose={() => setDocModal(null)}
    onSave={(documents) => {
      const updated = supervisors.map(s => s.id === docModal.id ? { ...s, documents } : s);
      saveSupervisors(updated);
    }}
  />
)}
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>HRMS</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>👔 Supervisor Details</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{supervisors.length} supervisors · auto-synced with Daily Progress Report</div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          {saving && <span style={{ color: theme.orange, fontSize: 12, fontWeight: 600, alignSelf: "center" }}>⏳ Saving...</span>}
          <Btn onClick={() => setShowAdd(true)}>+ Add Supervisor</Btn>
        </div>
      </div>

      {/* Info Banner */}
      <div style={{ background: theme.blue + "11", border: `1px solid ${theme.blue}33`, borderRadius: 10, padding: "10px 16px", marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 18 }}>💡</span>
        <span style={{ color: theme.blue, fontSize: 12, fontWeight: 600 }}>Any changes here will automatically reflect in the Supervisor dropdown in Daily Progress Report</span>
      </div>

      {/* Add Form */}
      {showAdd && (
        <div style={{ background: theme.card, border: `1px solid ${theme.accent}44`, borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <div style={{ color: theme.accent, fontWeight: 700, fontSize: 13, marginBottom: 12 }}>➕ Add New Supervisor</div>
          <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap" }}>
            <div style={{ flex: 2 }}>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Supervisor Name</div>
              <input value={newName} onChange={e => setNewName(e.target.value)} style={{ ...inp, width: "100%" }} placeholder="Enter full name..." autoFocus />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Type of Job</div>
              <input value={newTypeOfJob} onChange={e => setNewTypeOfJob(e.target.value)} style={{ ...inp, width: "100%" }} placeholder="e.g. Supervisor" />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Basic Pay (₹/month)</div>
              <input type="number" value={newBasic} onChange={e => setNewBasic(e.target.value)} style={{ ...inp, width: "100%", color: theme.accent, fontWeight: 700 }} placeholder="e.g. 32000" />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Per Day (₹)</div>
              <div style={{ background: theme.green + "11", border: `1px solid ${theme.green}33`, borderRadius: 7, padding: "8px 10px", color: theme.green, fontWeight: 800, fontSize: 14 }}>
                ₹{newBasic ? Math.round(Number(newBasic) / 30) : 0}
              </div>
            </div>
            <Btn onClick={handleAdd}>✅ Add</Btn>
            <Btn variant="ghost" onClick={() => { setShowAdd(false); setNewName(""); setNewBasic(""); }}>Cancel</Btn>
          </div>
        </div>
      )}

      {/* Search */}
      <div style={{ marginBottom: 14 }}>
        <input value={searchQuery} onChange={e => setSearchQuery(e.target.value)}
          style={{ ...inp, width: "100%", maxWidth: 300 }}
          placeholder="🔍 Search supervisor by name..." />
      </div>

      {/* Table */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
        <div style={{ padding: "12px 16px", background: "#162040", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>👔 Supervisor List — {filtered.length} entries</div>
          <div style={{ color: "#5a7aa8", fontSize: 11 }}>Per Day = Basic ÷ 30</div>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {["SR", "Name", "Type of Job", "Basic Pay (₹/month)", "Per Day (₹)", "Actions"].map(h => (
                <th key={h} style={{ ...th, textAlign: h === "Basic Pay (₹/month)" || h === "Per Day (₹)" ? "center" : "left" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 30, textAlign: "center", color: theme.muted, fontSize: 13 }}>
                {searchQuery ? "No supervisor found matching your search." : "No supervisor added yet."}
              </td></tr>
            )}
            {filtered.map((s, i) => {
              const isEditing = editingId === s.id;
              const perDay = Math.round(s.basic / 30);
              return isEditing
                ? <EditableSupervisorRow key={s.id} s={s} i={i} onSave={(name, typeOfJob, basic) => handleEdit(s.id, name, typeOfJob, basic)} onCancel={() => setEditingId(null)} inp={inp} td={td} />
                : (
                  <tr key={s.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                    <td style={{ ...td, color: theme.muted, width: 50, textAlign: "center" }}>{i + 1}</td>
                    <td style={{ ...td, fontWeight: 700 }}>{s.name}</td>
                    <td style={{ ...td, color: theme.muted }}>
                      <span style={{ background: theme.blue + "22", color: theme.blue, borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>{s.typeOfJob || "Supervisor"}</span>
                    </td>
                    <td style={{ ...td, textAlign: "center", color: theme.accent, fontWeight: 700 }}>₹{s.basic?.toLocaleString("en-IN")}</td>
                    <td style={{ ...td, textAlign: "center" }}>
                      <span style={{ background: theme.green + "22", color: theme.green, border: `1px solid ${theme.green}33`, borderRadius: 6, padding: "3px 10px", fontWeight: 800, fontSize: 13 }}>₹{perDay}</span>
                    </td>
                    <td style={td}>
                      <div style={{ display: "flex", gap: 8 }}>
                        <button onClick={() => setDocModal(s)}
  style={{ background: theme.purple + "22", border: `1px solid ${theme.purple}44`, color: theme.purple, borderRadius: 7, padding: "5px 10px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
  📁 Docs {Object.keys(s.documents || {}).length > 0 ? `(${Object.keys(s.documents || {}).length})` : ""}
</button>
<button onClick={() => setEditingId(s.id)} style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 7, padding: "5px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>✏️ Edit</button>
<button onClick={() => handleDelete(s.id)} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 7, padding: "5px 10px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>🗑</button>
                        
                      </div>
                    </td>
                  </tr>
                );
            })}
          </tbody>
          <tfoot>
            <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
              <td colSpan={3} style={{ padding: "10px 14px", color: "#93c5fd", fontWeight: 800, fontSize: 12, border: "1px solid rgba(99,179,237,0.2)" }}>AVERAGE</td>
              <td style={{ padding: "10px 14px", color: "#60a5fa", fontWeight: 900, textAlign: "center", border: "1px solid rgba(99,179,237,0.2)" }}>
                ₹{supervisors.length > 0 ? Math.round(supervisors.reduce((s, x) => s + x.basic, 0) / supervisors.length).toLocaleString("en-IN") : 0}
              </td>
              <td style={{ padding: "10px 14px", color: "#60a5fa", fontWeight: 900, textAlign: "center", border: "1px solid rgba(99,179,237,0.2)" }}>
                ₹{supervisors.length > 0 ? Math.round(supervisors.reduce((s, x) => s + Math.round(x.basic / 30), 0) / supervisors.length) : 0}
              </td>
              <td style={{ border: "1px solid rgba(99,179,237,0.2)" }} />
            </tr>
          </tfoot>
        </table>
      </div>
     
    </>}
  </div>
  
  );
}

function EditableSupervisorRow({ s, i, onSave, onCancel, inp, td }) {
  const [name, setName] = useState(s.name);
  const [typeOfJob, setTypeOfJob] = useState(s.typeOfJob || "Supervisor");
  const [basic, setBasic] = useState(s.basic);
  const perDay = basic ? Math.round(Number(basic) / 30) : 0;

  return (
    <tr style={{ background: theme.accent + "08", border: `1px solid ${theme.accent}33` }}>
      <td style={{ ...td, color: theme.muted, textAlign: "center" }}>{i + 1}</td>
      <td style={td}><input value={name} onChange={e => setName(e.target.value)} style={{ ...inp, width: "100%" }} /></td>
      <td style={td}><input value={typeOfJob} onChange={e => setTypeOfJob(e.target.value)} style={{ ...inp, width: "100%" }} /></td>
      <td style={td}><input type="number" value={basic} onChange={e => setBasic(e.target.value)} style={{ ...inp, color: theme.accent, fontWeight: 700, textAlign: "center" }} /></td>
      <td style={{ ...td, textAlign: "center" }}>
        <span style={{ background: theme.green + "22", color: theme.green, borderRadius: 6, padding: "3px 10px", fontWeight: 800 }}>₹{perDay}</span>
      </td>
      <td style={td}>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => onSave(name, typeOfJob, basic)} style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 7, padding: "5px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>💾 Save</button>
          <button onClick={onCancel} style={{ background: theme.muted + "22", border: `1px solid ${theme.border}`, color: theme.muted, borderRadius: 7, padding: "5px 10px", fontSize: 12, cursor: "pointer" }}>Cancel</button>
        </div>
      </td>
    </tr>
  );
}

let OFFICE_STAFF_LIST = [
  { id: "staff_1", name: "Shubham Sawa", typeOfJob: "Accountant", basic: 21000, documents: {} },
  { id: "staff_2", name: "Vinod", typeOfJob: "Office Boy", basic: 15000, documents: {} },
  { id: "staff_3", name: "Changa Singh", typeOfJob: "Driver", basic: 20000, documents: {} },
  { id: "staff_4", name: "Mrunal Nitin Am", typeOfJob: "Mechanical Technician", basic: 30000, documents: {} },
  { id: "staff_5", name: "Deven Bhansali", typeOfJob: "Office Mgr", basic: 25000, documents: {} },
];

function OfficeStaffDetailsTab() {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [newName, setNewName] = useState("");
  const [newTypeOfJob, setNewTypeOfJob] = useState("");
  const [newBasic, setNewBasic] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [staffTab, setStaffTab] = useState("list");
  const [docModal, setDocModal] = useState(null);

  useEffect(() => {
    getDocs(collection(db, "office_staff_list")).then(snap => {
      if (snap.docs.length > 0) {
        const data = snap.docs.map(d => d.data());
        setStaff(data);
        OFFICE_STAFF_LIST = data;
      } else {
        const ls = localStorage.getItem("office_staff_list");
        if (ls) {
          const parsed = JSON.parse(ls).map(s => ({ ...s, documents: s.documents || {} }));
          setStaff(parsed);
          OFFICE_STAFF_LIST = parsed;
        } else {
          setStaff(OFFICE_STAFF_LIST);
          saveStaff(OFFICE_STAFF_LIST);
        }
      }
    }).catch(() => {
      const ls = localStorage.getItem("office_staff_list");
      if (ls) {
        const parsed = JSON.parse(ls).map(s => ({ ...s, documents: s.documents || {} }));
        setStaff(parsed);
        OFFICE_STAFF_LIST = parsed;
      } else {
        setStaff(OFFICE_STAFF_LIST);
      }
    }).finally(() => setLoading(false));
  }, []);

  const saveStaff = async (updated) => {
    setSaving(true);
    setStaff(updated);
    OFFICE_STAFF_LIST = updated;
    localStorage.setItem("office_staff_list", JSON.stringify(updated));
    try {
      for (const s of updated) {
        await setDoc(fsDoc(db, "office_staff_list", String(s.id)), s);
      }
    } catch (e) { console.error(e); }
    finally { setSaving(false); }
  };

  const handleAdd = () => {
    if (!newName.trim()) return alert("Please enter staff name.");
    if (!newBasic || isNaN(Number(newBasic))) return alert("Please enter a valid basic pay.");
    if (staff.find(s => s.name.toLowerCase() === newName.trim().toLowerCase())) {
      return alert("Staff with this name already exists.");
    }
    const newStaff = {
      id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
      name: newName.trim(),
      typeOfJob: newTypeOfJob.trim(),
      basic: Number(newBasic),
      documents: {},
    };
    saveStaff([...staff, newStaff]);
    setNewName(""); setNewTypeOfJob(""); setNewBasic("");
    setShowAdd(false);
  };

  const handleEdit = (id, name, typeOfJob, basic) => {
    if (!name.trim()) return alert("Name cannot be empty.");
    if (!basic || isNaN(Number(basic))) return alert("Please enter a valid basic pay.");
    const updated = staff.map(s => s.id === id ? { ...s, name: name.trim(), typeOfJob, basic: Number(basic) } : s);
    saveStaff(updated);
    setEditingId(null);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this staff member?")) return;
    const updated = staff.filter(s => s.id !== id);
    saveStaff(updated);
    deleteDoc(fsDoc(db, "office_staff_list", String(id))).catch(console.error);
  };

  const filtered = staff.filter(s =>
    s.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    s.typeOfJob?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 13, outline: "none", boxSizing: "border-box" };
  const th = { padding: "10px 14px", background: "#162040", color: "#93c5fd", fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "left", border: "1px solid rgba(99,179,237,0.2)", whiteSpace: "nowrap" };
  const td = { padding: "10px 14px", borderBottom: `1px solid ${theme.border}`, fontSize: 13, color: theme.text, verticalAlign: "middle" };

  if (loading) return <div style={{ color: theme.muted, padding: 20 }}>Loading office staff list...</div>;

return (
    <div>
      <Tabs active={staffTab} onChange={setStaffTab} tabs={[
        { id: "list", label: "🏢 Staff List" },
        { id: "payroll", label: "💰 Office Payroll" },
      ]} />

      {staffTab === "payroll" && <OfficePayrollTab />}

      {staffTab === "list" && <>
      {docModal && (
        <LabourDocModal
          labour={docModal}
          onClose={() => setDocModal(null)}
          onSave={(documents) => {
            const updated = staff.map(s => s.id === docModal.id ? { ...s, documents } : s);
            saveStaff(updated);
          }}
        />
      )}

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>HRMS</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>🏢 Office Staff Details</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{staff.length} staff members</div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          {saving && <span style={{ color: theme.orange, fontSize: 12, fontWeight: 600, alignSelf: "center" }}>⏳ Saving...</span>}
          <Btn onClick={() => setShowAdd(true)}>+ Add Staff</Btn>
        </div>
      </div>

      {/* Add Form */}
      {showAdd && (
        <div style={{ background: theme.card, border: `1px solid ${theme.accent}44`, borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <div style={{ color: theme.accent, fontWeight: 700, fontSize: 13, marginBottom: 12 }}>➕ Add New Staff Member</div>
          <div style={{ display: "flex", gap: 10, alignItems: "flex-end", flexWrap: "wrap" }}>
            <div style={{ flex: 2 }}>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Full Name</div>
              <input value={newName} onChange={e => setNewName(e.target.value)} style={{ ...inp, width: "100%" }} placeholder="Enter full name..." autoFocus />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Type of Job</div>
              <input value={newTypeOfJob} onChange={e => setNewTypeOfJob(e.target.value)} style={{ ...inp, width: "100%" }} placeholder="e.g. Accountant" />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Basic Pay (₹/month)</div>
              <input type="number" value={newBasic} onChange={e => setNewBasic(e.target.value)} style={{ ...inp, width: "100%", color: theme.accent, fontWeight: 700 }} placeholder="e.g. 25000" />
            </div>
            <div style={{ flex: 1 }}>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Per Day (₹)</div>
              <div style={{ background: theme.green + "11", border: `1px solid ${theme.green}33`, borderRadius: 7, padding: "8px 10px", color: theme.green, fontWeight: 800, fontSize: 14 }}>
                ₹{newBasic ? Math.round(Number(newBasic) / 30) : 0}
              </div>
            </div>
            <Btn onClick={handleAdd}>✅ Add</Btn>
            <Btn variant="ghost" onClick={() => { setShowAdd(false); setNewName(""); setNewTypeOfJob(""); setNewBasic(""); }}>Cancel</Btn>
          </div>
        </div>
      )}

      {/* Search */}
      <div style={{ marginBottom: 14 }}>
        <input value={searchQuery} onChange={e => setSearchQuery(e.target.value)}
          style={{ ...inp, width: "100%", maxWidth: 320 }}
          placeholder="🔍 Search by name or job type..." />
      </div>

      {/* Table */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
        <div style={{ padding: "12px 16px", background: "#162040", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>🏢 Office Staff List — {filtered.length} entries</div>
          <div style={{ color: "#5a7aa8", fontSize: 11 }}>Per Day = Basic ÷ 30</div>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {["SR", "Name", "Type of Job", "Basic Pay (₹/month)", "Per Day (₹)", "Actions"].map(h => (
                <th key={h} style={{ ...th, textAlign: h === "Basic Pay (₹/month)" || h === "Per Day (₹)" ? "center" : "left" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={6} style={{ padding: 30, textAlign: "center", color: theme.muted, fontSize: 13 }}>
                {searchQuery ? "No staff found matching your search." : "No staff added yet."}
              </td></tr>
            )}
            {filtered.map((s, i) => {
              const isEditing = editingId === s.id;
              const perDay = Math.round(s.basic / 30);
              return isEditing
                ? <EditableStaffRow key={s.id} s={s} i={i} onSave={(name, typeOfJob, basic) => handleEdit(s.id, name, typeOfJob, basic)} onCancel={() => setEditingId(null)} inp={inp} td={td} />
                : (
                  <tr key={s.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                    <td style={{ ...td, color: theme.muted, width: 50, textAlign: "center" }}>{i + 1}</td>
                    <td style={{ ...td, fontWeight: 700 }}>{s.name}</td>
                    <td style={td}>
                      <span style={{ background: theme.blue + "22", color: theme.blue, borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>{s.typeOfJob || "—"}</span>
                    </td>
                    <td style={{ ...td, textAlign: "center", color: theme.accent, fontWeight: 700 }}>₹{s.basic?.toLocaleString("en-IN")}</td>
                    <td style={{ ...td, textAlign: "center" }}>
                      <span style={{ background: theme.green + "22", color: theme.green, border: `1px solid ${theme.green}33`, borderRadius: 6, padding: "3px 10px", fontWeight: 800, fontSize: 13 }}>₹{perDay}</span>
                    </td>
                    <td style={td}>
                      <div style={{ display: "flex", gap: 6 }}>
                        <button onClick={() => setDocModal(s)}
                          style={{ background: theme.purple + "22", border: `1px solid ${theme.purple}44`, color: theme.purple, borderRadius: 7, padding: "5px 10px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
                          📁 Docs {Object.keys(s.documents || {}).length > 0 ? `(${Object.keys(s.documents || {}).length})` : ""}
                        </button>
                        <button onClick={() => setEditingId(s.id)}
                          style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 7, padding: "5px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>✏️ Edit</button>
                        <button onClick={() => handleDelete(s.id)}
                          style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 7, padding: "5px 10px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>🗑</button>
                      </div>
                    </td>
                  </tr>
                );
            })}
          </tbody>
          <tfoot>
            <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
              <td colSpan={3} style={{ padding: "10px 14px", color: "#93c5fd", fontWeight: 800, fontSize: 12, border: "1px solid rgba(99,179,237,0.2)" }}>AVERAGE</td>
              <td style={{ padding: "10px 14px", color: "#60a5fa", fontWeight: 900, textAlign: "center", border: "1px solid rgba(99,179,237,0.2)" }}>
                ₹{staff.length > 0 ? Math.round(staff.reduce((s, x) => s + x.basic, 0) / staff.length).toLocaleString("en-IN") : 0}
              </td>
              <td style={{ padding: "10px 14px", color: "#60a5fa", fontWeight: 900, textAlign: "center", border: "1px solid rgba(99,179,237,0.2)" }}>
                ₹{staff.length > 0 ? Math.round(staff.reduce((s, x) => s + Math.round(x.basic / 30), 0) / staff.length) : 0}
              </td>
              <td style={{ border: "1px solid rgba(99,179,237,0.2)" }} />
            </tr>
          </tfoot>
        </table>
      </div>
   
    </>}
  </div>
  );
}

function EditableStaffRow({ s, i, onSave, onCancel, inp, td }) {
  const [name, setName] = useState(s.name);
  const [typeOfJob, setTypeOfJob] = useState(s.typeOfJob || "");
  const [basic, setBasic] = useState(s.basic);
  const perDay = basic ? Math.round(Number(basic) / 30) : 0;

  return (
    <tr style={{ background: theme.accent + "08", border: `1px solid ${theme.accent}33` }}>
      <td style={{ ...td, color: theme.muted, textAlign: "center" }}>{i + 1}</td>
      <td style={td}><input value={name} onChange={e => setName(e.target.value)} style={{ ...inp, width: "100%" }} /></td>
      <td style={td}><input value={typeOfJob} onChange={e => setTypeOfJob(e.target.value)} style={{ ...inp, width: "100%" }} /></td>
      <td style={td}><input type="number" value={basic} onChange={e => setBasic(e.target.value)} style={{ ...inp, color: theme.accent, fontWeight: 700, textAlign: "center" }} /></td>
      <td style={{ ...td, textAlign: "center" }}>
        <span style={{ background: theme.green + "22", color: theme.green, borderRadius: 6, padding: "3px 10px", fontWeight: 800 }}>₹{perDay}</span>
      </td>
      <td style={td}>
        <div style={{ display: "flex", gap: 8 }}>
          <button onClick={() => onSave(name, typeOfJob, basic)} style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 7, padding: "5px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>💾 Save</button>
          <button onClick={onCancel} style={{ background: theme.muted + "22", border: `1px solid ${theme.border}`, color: theme.muted, borderRadius: 7, padding: "5px 10px", fontSize: 12, cursor: "pointer" }}>Cancel</button>
        </div>
      </td>
    </tr>
  );
}


function LabourDetailsTab({projects = []}) {
  const [labours, setLabours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [showAdd, setShowAdd] = useState(false);
  const [newName, setNewName] = useState("");
  const [newRate, setNewRate] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [docModal, setDocModal] = useState(null); // { labourId, labourName }
  const [labourTab, setLabourTab]  = useState("list");

  useEffect(() => {
    getDocs(collection(db, "labour_list")).then(snap => {
      if (snap.docs.length > 0) {
        const data = snap.docs.map(d => d.data());
        setLabours(data);
        LABOUR_LIST = data;
      } else {
        const ls = localStorage.getItem("labour_list");
        if (ls) {
        const parsed = JSON.parse(ls).map((l, i) => ({
  ...l,
  labourId: l.labourId || `LBR${String(i + 1).padStart(3, "0")}`,
  documents: l.documents || {},
}));
setLabours(parsed);
LABOUR_LIST = parsed;
        } else {
          setLabours(LABOUR_LIST.map((l, i) => ({ ...l, id: `labour_${i}` })));
        }
      }
    }).catch(() => {
      const ls = localStorage.getItem("labour_list");
      if (ls) {
       const parsed = JSON.parse(ls).map((l, i) => ({
  ...l,
  labourId: l.labourId || `LBR${String(i + 1).padStart(3, "0")}`,
  documents: l.documents || {},
}));
setLabours(parsed);
LABOUR_LIST = parsed;
      } else {
        setLabours(LABOUR_LIST.map((l, i) => ({ ...l, id: `labour_${i}`, labourId: `LBR${String(i + 1).padStart(3, "0")}`, documents: {} })));
      }
    }).finally(() => setLoading(false));
  }, []);

  const saveLabours = async (updated) => {
    setSaving(true);
    setLabours(updated);
    LABOUR_LIST = updated;
    localStorage.setItem("labour_list", JSON.stringify(updated));
    try {
      for (const l of updated) {
        await setDoc(fsDoc(db, "labour_list", String(l.id)), l);
      }
    } catch (e) { console.error(e); }
    finally { setSaving(false); }
  };

  const handleAdd = () => {
    if (!newName.trim()) return alert("Please enter labour name.");
    if (!newRate || isNaN(Number(newRate))) return alert("Please enter a valid rate.");
    if (labours.find(l => l.name.toLowerCase() === newName.trim().toLowerCase())) {
      return alert("Labour with this name already exists.");
    }
    const newLabour = {
  id: `${Date.now()}_${Math.random().toString(36).slice(2)}`,
  labourId: `LBR${String(labours.length + 1).padStart(3, "0")}`,
  name: newName.trim(),
  rate: Number(newRate),
  documents: {},
};
    saveLabours([...labours, newLabour]);
    setNewName("");
    setNewRate("");
    setShowAdd(false);
  };

  const handleEdit = (id, name, rate) => {
    if (!name.trim()) return alert("Name cannot be empty.");
    if (!rate || isNaN(Number(rate))) return alert("Please enter a valid rate.");
    const updated = labours.map(l => l.id === id ? { ...l, name: name.trim(), rate: Number(rate) } : l);
    saveLabours(updated);
    setEditingId(null);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Delete this labour? They will be removed from the dropdown.")) return;
    const updated = labours.filter(l => l.id !== id);
    saveLabours(updated);
    deleteDoc(fsDoc(db, "labour_list", String(id))).catch(console.error);
  };

  const filtered = labours.filter(l =>
    l.name?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 13, outline: "none", boxSizing: "border-box" };

  if (loading) return <div style={{ color: theme.muted, padding: 20 }}>Loading labour list...</div>;

 return (
  <div>
    <Tabs active={labourTab} onChange={setLabourTab} tabs={[
      { id: "list", label: "👷 Labour List" },
      { id: "payroll", label: "💰 Labour Payroll" },
    ]} />

    {labourTab === "payroll" && <LabourPayrollTab projects={projects} />}

    {labourTab === "list" && <>
    {docModal && (
  <LabourDocModal
    labour={docModal}
    onClose={() => setDocModal(null)}
    onSave={(documents) => {
      const updated = labours.map(l => l.id === docModal.id ? { ...l, documents } : l);
      saveLabours(updated);
    }}
  />
)}
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>HRMS</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>👷 Labour Details</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{labours.length} labours · auto-synced with Daily Progress Report</div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          {saving && <span style={{ color: theme.orange, fontSize: 12, fontWeight: 600, alignSelf: "center" }}>⏳ Saving...</span>}
          <Btn onClick={() => setShowAdd(true)}>+ Add Labour</Btn>
        </div>
      </div>

      {/* Info Banner */}
      <div style={{ background: theme.blue + "11", border: `1px solid ${theme.blue}33`, borderRadius: 10, padding: "10px 16px", marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
        <span style={{ fontSize: 18 }}>💡</span>
        <span style={{ color: theme.blue, fontSize: 12, fontWeight: 600 }}>Any changes here will automatically reflect in the Labour dropdown in Daily Progress Report</span>
      </div>

      {/* Add Labour Form */}
      {showAdd && (
        <div style={{ background: theme.card, border: `1px solid ${theme.accent}44`, borderRadius: 12, padding: 16, marginBottom: 16 }}>
          <div style={{ color: theme.accent, fontWeight: 700, fontSize: 13, marginBottom: 12 }}>➕ Add New Labour</div>
          <div style={{ display: "flex", gap: 10, alignItems: "flex-end" }}>
            <div style={{ flex: 2 }}>
              <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Labour Name</div>
              <input value={newName} onChange={e => setNewName(e.target.value)}
                style={{ ...inp, width: "100%" }} placeholder="Enter full name..."
                onKeyDown={e => e.key === "Enter" && handleAdd()} autoFocus />
            </div>
            <div style={{ flex: 1 }}>
  <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Daily Rate (₹)</div>
  <input type="number" value={newRate} onChange={e => setNewRate(e.target.value)}
    style={{ ...inp, width: "100%", color: theme.accent, fontWeight: 700 }}
    placeholder="e.g. 650"
    onKeyDown={e => e.key === "Enter" && handleAdd()} />
</div>
<div style={{ flex: 1 }}>
  <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>Basic Pay (₹)</div>
  <div style={{ background: theme.accent + "11", border: `1px solid ${theme.accent}33`, borderRadius: 7, padding: "8px 10px", color: theme.accent, fontWeight: 800, fontSize: 14 }}>
    ₹{newRate ? Math.round(Number(newRate) * 30).toLocaleString("en-IN") : 0}
  </div>
</div>
<Btn onClick={handleAdd}>✅ Add</Btn>
            <Btn variant="ghost" onClick={() => { setShowAdd(false); setNewName(""); setNewRate(""); }}>Cancel</Btn>
          </div>
        </div>
      )}

      {/* Search */}
      <div style={{ marginBottom: 14 }}>
        <input value={searchQuery} onChange={e => setSearchQuery(e.target.value)}
          style={{ ...inp, width: "100%", maxWidth: 300 }}
          placeholder="🔍 Search labour by name..." />
      </div>

      {/* Labour Table */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
        <div style={{ padding: "12px 16px", background: "#162040", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>👷 Labour List — {filtered.length} entries</div>
          <div style={{ color: "#5a7aa8", fontSize: 11 }}>Per Hour = Daily Rate ÷ 8</div>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr>
              {["SR", "Labour ID", "Labour Name", "Daily Rate (₹)", "Basic Pay (₹)", "Per Hour (₹)", "Actions"].map(h => (
                <th key={h} style={{ padding: "10px 14px", background: "#162040", color: "#93c5fd", fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: h === "Daily Rate (₹)" || h === "Per Hour (₹)" ? "center" : "left", border: "1px solid rgba(99,179,237,0.2)", whiteSpace: "nowrap" }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filtered.length === 0 && (
              <tr><td colSpan={7} style={{ padding: 30, textAlign: "center", color: theme.muted, fontSize: 13 }}>
                {searchQuery ? "No labour found matching your search." : "No labour added yet."}
              </td></tr>
            )}
            {filtered.map((l, i) => {
              const isEditing = editingId === l.id;
             
              const perHour = Math.round((l.rate / 8) * 100) / 100;
              return (
                <EditableRow
      key={l.id}
       l={l} i={i} isEditing={isEditing}
      perHour={perHour}
      onEdit={() => setEditingId(l.id)}
      onSave={(name, rate) => handleEdit(l.id, name, rate)}
       onCancel={() => setEditingId(null)}
       onDelete={() => handleDelete(l.id)}
       onDocs={() => setDocModal(l)}
     inp={inp}
     theme={theme}
/>
              );
            })}
          </tbody>
          <tfoot>
            <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
              <td colSpan={3} style={{ padding: "10px 14px", color: "#93c5fd", fontWeight: 800, fontSize: 12, border: "1px solid rgba(99,179,237,0.2)" }}>AVERAGE RATE</td>
<td style={{ padding: "10px 14px", color: "#60a5fa", fontWeight: 900, textAlign: "center", border: "1px solid rgba(99,179,237,0.2)" }}>
  ₹{labours.length > 0 ? Math.round(labours.reduce((s, l) => s + l.rate, 0) / labours.length) : 0}
</td>
<td style={{ padding: "10px 14px", color: "#60a5fa", fontWeight: 900, textAlign: "center", border: "1px solid rgba(99,179,237,0.2)" }}>
  ₹{labours.length > 0 ? Math.round(labours.reduce((s, l) => s + l.rate * 30, 0) / labours.length).toLocaleString("en-IN") : 0}
</td>
<td style={{ padding: "10px 14px", color: "#60a5fa", fontWeight: 900, textAlign: "center", border: "1px solid rgba(99,179,237,0.2)" }}>
  ₹{labours.length > 0 ? Math.round((labours.reduce((s, l) => s + l.rate, 0) / labours.length) / 8 * 100) / 100 : 0}
</td>
<td style={{ border: "1px solid rgba(99,179,237,0.2)" }} />
            </tr>
          </tfoot>
        </table>
      </div>
   
    </>}
  </div>
  );
}


function PayrollSummaryTab() {
  const today = new Date();
  const defaultMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;
  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);
  const [labourPayroll, setLabourPayroll] = useState({});
  const [supPayroll, setSupPayroll] = useState({});
  const [officePayroll, setOfficePayroll] = useState({});
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    const fetchAll = async () => {
      const lsL = localStorage.getItem(`payroll_labour_${selectedMonth}`);
      if (lsL) setLabourPayroll(JSON.parse(lsL)); else setLabourPayroll({});
      const lsS = localStorage.getItem(`payroll_supervisor_${selectedMonth}`);
      if (lsS) setSupPayroll(JSON.parse(lsS)); else setSupPayroll({});
      const lsO = localStorage.getItem(`payroll_office_${selectedMonth}`);
      if (lsO) setOfficePayroll(JSON.parse(lsO)); else setOfficePayroll({});
      try {
        const [lDoc, sDoc, oDoc] = await Promise.all([
          getDocs(collection(db, "labour_payroll")),
          getDocs(collection(db, "supervisor_payroll")),
          getDocs(collection(db, "office_payroll")),
        ]);
        const lData = lDoc.docs.find(d => d.id === selectedMonth);
        const sData = sDoc.docs.find(d => d.id === selectedMonth);
        const oData = oDoc.docs.find(d => d.id === selectedMonth);
        if (lData) setLabourPayroll(lData.data().manualData || {});
        if (sData) setSupPayroll(sData.data().manualData || {});
        if (oData) setOfficePayroll(oData.data().manualData || {});
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    };
    fetchAll();
  }, [selectedMonth]);

  const n = v => Number(v) || 0;
  const fmt = v => n(v).toLocaleString("en-IN");
  const monthLabel = new Date(selectedMonth + "-01").toLocaleString("en-IN", { month: "long", year: "numeric" });

  const labourRows = LABOUR_LIST.map(l => {
    const m = labourPayroll[l.id] || {};
    const perDay = n(l.rate);
    const perHour = Math.round((perDay / 8) * 100) / 100;
    const wages = n(m.daysPayable) * perDay;
    const otPayable = Math.round(n(m.otHrs) * perHour * 100) / 100;
    const upto12amWages = n(m.upto12amDays) * perDay;
    const fullNightPayable = n(m.fullNightDays) * 2 * perDay;
    const totalPayable = wages + otPayable + upto12amWages + fullNightPayable;
    const totalWithConvy = totalPayable + n(m.travel) + n(m.food);
    const finalAmount = totalWithConvy - n(m.lessDeduction);
    return { name: l.name, modeOfPayment: m.modeOfPayment || "", paidStatus: m.paidStatus || "", finalAmount };
  });

  const supRows = SUPERVISOR_LIST.map(s => {
    const m = supPayroll[s.id] || {};
    const perDay = Math.round(n(s.basic) / 30);
    const perHour = Math.round((perDay / 8) * 100) / 100;
    const pay = n(m.daysPayable) * perDay;
    const otPayable = Math.round(n(m.otHrs) * perHour * 100) / 100;
    const sundayPayable = n(m.sunday) * perDay;
    const fullNightPayable = n(m.fullNightDays) * 2 * perDay;
    const totalPayable = pay + otPayable + sundayPayable + fullNightPayable + n(m.travel);
    const finalAmount = totalPayable - n(m.trainPass) - n(m.lessDeduction) - n(m.loanRecovery);
    return { name: s.name, modeOfPayment: m.modeOfPayment || "", paidStatus: m.paidStatus || "", finalAmount };
  });

  const officeRows = OFFICE_STAFF_LIST.map(s => {
    const m = officePayroll[s.id] || {};
    const perDay = Math.round(n(s.basic) / 30);
    const perHour = Math.round((perDay / 8) * 100) / 100;
    const pay = n(m.daysPayable) * perDay;
    const otPayable = Math.round(n(m.otHrs) * perHour * 100) / 100;
    const sundayPayable = n(m.sunday) * perDay;
    const fullNightDriver = n(m.nightDays) * perDay;
    const totalPayable = pay + otPayable + sundayPayable + fullNightDriver;
    const total = totalPayable + n(m.conveyance);
    const finalAmount = total - n(m.driverNightExp) - n(m.lessDeduction);
    return { name: s.name, modeOfPayment: m.modeOfPayment || "", paidStatus: m.paidStatus || "", finalAmount };
  });

  const labourTotal = labourRows.reduce((s, r) => s + r.finalAmount, 0);
  const supTotal = supRows.reduce((s, r) => s + r.finalAmount, 0);
  const officeTotal = officeRows.reduce((s, r) => s + r.finalAmount, 0);
  const grandTotal = labourTotal + supTotal + officeTotal;

  const allRows = [
    ...labourRows.map(r => ({ ...r, category: "Labour" })),
    ...supRows.map(r => ({ ...r, category: "Supervisor" })),
    ...officeRows.map(r => ({ ...r, category: "Office Staff" })),
  ];

  const cashRows = allRows.filter(r => r.modeOfPayment === "Cash");
  const bankRows = allRows.filter(r => r.modeOfPayment === "Bank");
  const cashTotal = cashRows.reduce((s, r) => s + r.finalAmount, 0);
  const bankTotal = bankRows.reduce((s, r) => s + r.finalAmount, 0);

  const th = { padding: "10px 12px", background: "#162040", color: "#93c5fd", fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: "1px solid rgba(99,179,237,0.2)", whiteSpace: "nowrap" };
  const td = { padding: "9px 12px", border: `1px solid ${theme.border}`, fontSize: 12, textAlign: "center", verticalAlign: "middle" };

  const exportExcel = async () => {
    
    const wb = XLSX.utils.book_new();
    const header = [["PERMATECH CONCRETE SOLUTIONS"], [`Payroll Summary — ${monthLabel}`], [`Generated: ${new Date().toLocaleDateString("en-IN")}`], []];
    const sumData = [["Category", "No. of Staff", "Final Payable ₹"], ["Labour", labourRows.length, labourTotal], ["Supervisor", supRows.length, supTotal], ["Office Staff", officeRows.length, officeTotal], [], ["GRAND TOTAL", allRows.length, grandTotal]];
    const ws = XLSX.utils.aoa_to_sheet([...header, ...sumData]);
    ws["!cols"] = [{ wch: 20 }, { wch: 15 }, { wch: 18 }];
    XLSX.utils.book_append_sheet(wb, ws, "Summary");
    const cashCols = ["SR", "Name", "Category", "Final Amount ₹", "Status"];
    const cashData = [...cashRows.map((r, i) => [i + 1, r.name, r.category, r.finalAmount, r.paidStatus || "Pending"]), [], ["", "CASH TOTAL", "", cashTotal, ""]];
    const wsCash = XLSX.utils.aoa_to_sheet([...header, cashCols, ...cashData]);
    wsCash["!cols"] = [{ wch: 5 }, { wch: 22 }, { wch: 14 }, { wch: 16 }, { wch: 12 }];
    XLSX.utils.book_append_sheet(wb, wsCash, "Cash Transactions");
    const bankData = [...bankRows.map((r, i) => [i + 1, r.name, r.category, r.finalAmount, r.paidStatus || "Pending"]), [], ["", "BANK TOTAL", "", bankTotal, ""]];
    const wsBank = XLSX.utils.aoa_to_sheet([...header, cashCols, ...bankData]);
    wsBank["!cols"] = [{ wch: 5 }, { wch: 22 }, { wch: 14 }, { wch: 16 }, { wch: 12 }];
    XLSX.utils.book_append_sheet(wb, wsBank, "Bank Transactions");
    XLSX.writeFile(wb, `Payroll_Summary_${selectedMonth}.xlsx`);
  };

  const printSummary = () => {
    const el = document.getElementById("payroll-summary-print");
    if (!el) return;
    const win = window.open("", "_blank");
    win.document.write(`<html><head><style>body{font-family:Arial,sans-serif;padding:20px;font-size:11px}h2{color:#1a365d;font-size:15px;margin-bottom:4px}h3{color:#1a365d;font-size:12px;margin:20px 0 8px;border-bottom:2px solid #1a365d;padding-bottom:4px}table{width:100%;border-collapse:collapse;margin-bottom:20px}th{background:#1a365d;color:#fff;padding:8px;font-size:10px;text-align:center;border:1px solid #2d4a7a}td{padding:7px 8px;border:1px solid #e2e8f0;font-size:11px;text-align:center}tr:nth-child(even){background:#f8fafc}.total-row td{background:#1a365d;color:#fff;font-weight:bold}@media print{@page{margin:10mm}}</style></head><body>${el.innerHTML}</body></html>`);
    win.document.close();
    setTimeout(() => { win.print(); win.close(); }, 500);
  };

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>HRMS</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📊 Payroll Summary</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{monthLabel}</div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn variant="ghost" onClick={printSummary}>🖨 Print PDF</Btn>
          <Btn onClick={exportExcel}>📥 Export Excel</Btn>
        </div>
      </div>

      {/* Month Picker */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 24 }}>
        <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 6 }}>PAYROLL MONTH</div>
        <input type="month" value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)}
          style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.accent, padding: "8px 14px", fontSize: 15, fontWeight: 700, outline: "none" }} />
      </div>

      {loading ? (
        <div style={{ color: theme.muted, padding: 30, textAlign: "center" }}>Loading payroll data...</div>
      ) : (
        <div id="payroll-summary-print">
          <h2 style={{ color: theme.text, margin: "0 0 4px" }}>PERMATECH CONCRETE SOLUTIONS</h2>
          <div style={{ color: theme.muted, fontSize: 12, marginBottom: 20 }}>Payroll Summary — {monthLabel} &nbsp;|&nbsp; Generated: {new Date().toLocaleDateString("en-IN")}</div>

          {/* Category Cards */}
          <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: 14, marginBottom: 24 }}>
            {[
              { label: "👷 Labour Payroll", val: labourTotal, count: labourRows.length, color: theme.blue },
              { label: "👔 Supervisor Payroll", val: supTotal, count: supRows.length, color: theme.accent },
              { label: "🏢 Office Staff Payroll", val: officeTotal, count: officeRows.length, color: theme.purple },
              { label: "💰 Grand Total", val: grandTotal, count: allRows.length, color: theme.green },
            ].map(({ label, val, count, color }) => (
              <div key={label} style={{ background: theme.card, border: `1px solid ${color}44`, borderRadius: 14, padding: "20px 18px", position: "relative", overflow: "hidden" }}>
                <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 4, background: color }} />
                <div style={{ color: theme.muted, fontSize: 12, fontWeight: 600, marginBottom: 8 }}>{label}</div>
                <div style={{ color, fontWeight: 900, fontSize: 24 }}>₹{fmt(val)}</div>
                <div style={{ color: theme.muted, fontSize: 11, marginTop: 6 }}>{count} employees</div>
              </div>
            ))}
          </div>

          {/* Breakdown Table */}
          <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, marginBottom: 28 }}>
            <div style={{ padding: "12px 16px", background: "#162040", borderRadius: "12px 12px 0 0" }}>
              <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>📋 Payroll Breakdown</div>
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>{["Category", "No. of Staff", "Final Payable ₹"].map(h => <th key={h} style={th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {[
                  { label: "👷 Labour", val: labourTotal, count: labourRows.length, color: theme.blue },
                  { label: "👔 Supervisor", val: supTotal, count: supRows.length, color: theme.accent },
                  { label: "🏢 Office Staff", val: officeTotal, count: officeRows.length, color: theme.purple },
                ].map((r, i) => (
                  <tr key={r.label} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                    <td style={{ ...td, textAlign: "left", paddingLeft: 16 }}><span style={{ color: r.color, fontWeight: 800, fontSize: 13 }}>{r.label}</span></td>
                    <td style={{ ...td, color: theme.muted, fontWeight: 600 }}>{r.count}</td>
                    <td style={{ ...td, color: r.color, fontWeight: 900, fontSize: 15 }}>₹{fmt(r.val)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                  <td style={{ ...td, textAlign: "left", paddingLeft: 16, color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 13 }}>GRAND TOTAL</td>
                  <td style={{ ...td, color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>{allRows.length}</td>
                  <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 16 }}>₹{fmt(grandTotal)}</td>
                </tr>
              </tfoot>
            </table>
          </div>

          {/* Cash Transactions */}
          <div style={{ color: theme.orange, fontWeight: 800, fontSize: 15, marginBottom: 10 }}>💵 Cash Transactions</div>
          <div style={{ background: theme.card, border: `1px solid ${theme.orange}44`, borderRadius: 12, overflow: "hidden", marginBottom: 24 }}>
            {cashRows.length === 0 ? (
              <div style={{ padding: 24, textAlign: "center", color: theme.muted }}>No cash transactions this month.</div>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr>{["SR", "Name", "Category", "Final Amount ₹", "Status"].map(h => <th key={h} style={{ ...th, background: "#2d1800" }}>{h}</th>)}</tr></thead>
                <tbody>
                  {cashRows.map((r, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                      <td style={{ ...td, color: theme.muted, width: 40 }}>{i + 1}</td>
                      <td style={{ ...td, fontWeight: 700, textAlign: "left", paddingLeft: 12 }}>{r.name}</td>
                      <td style={td}><span style={{ background: theme.orange + "22", color: theme.orange, borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700 }}>{r.category}</span></td>
                      <td style={{ ...td, color: theme.orange, fontWeight: 900, fontSize: 13 }}>₹{fmt(r.finalAmount)}</td>
                      <td style={td}>{r.paidStatus ? <span style={{ background: r.paidStatus === "Paid" ? theme.green + "22" : theme.red + "22", color: r.paidStatus === "Paid" ? theme.green : theme.red, borderRadius: 5, padding: "2px 10px", fontSize: 11, fontWeight: 700 }}>{r.paidStatus === "Paid" ? "✅ Paid" : "❌ Not Paid"}</span> : <span style={{ color: theme.muted }}>— Pending —</span>}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ background: "#2d1800", borderTop: `2px solid ${theme.orange}` }}>
                    <td colSpan={3} style={{ ...td, textAlign: "right", color: "#FCD34D", fontWeight: 800, background: "#2d1800", border: "1px solid rgba(252,211,77,0.2)" }}>CASH TOTAL</td>
                    <td style={{ ...td, color: "#FCD34D", fontWeight: 900, background: "#2d1800", border: "1px solid rgba(252,211,77,0.2)", fontSize: 15 }}>₹{fmt(cashTotal)}</td>
                    <td style={{ ...td, background: "#2d1800", border: "1px solid rgba(252,211,77,0.2)" }} />
                  </tr>
                </tfoot>
              </table>
            )}
          </div>

          {/* Bank Transactions */}
          <div style={{ color: theme.blue, fontWeight: 800, fontSize: 15, marginBottom: 10 }}>🏦 Bank Transactions</div>
          <div style={{ background: theme.card, border: `1px solid ${theme.blue}44`, borderRadius: 12, overflow: "hidden" }}>
            {bankRows.length === 0 ? (
              <div style={{ padding: 24, textAlign: "center", color: theme.muted }}>No bank transactions this month.</div>
            ) : (
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr>{["SR", "Name", "Category", "Final Amount ₹", "Status"].map(h => <th key={h} style={{ ...th, background: "#0f1f3d" }}>{h}</th>)}</tr></thead>
                <tbody>
                  {bankRows.map((r, i) => (
                    <tr key={i} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                      <td style={{ ...td, color: theme.muted, width: 40 }}>{i + 1}</td>
                      <td style={{ ...td, fontWeight: 700, textAlign: "left", paddingLeft: 12 }}>{r.name}</td>
                      <td style={td}><span style={{ background: theme.blue + "22", color: theme.blue, borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700 }}>{r.category}</span></td>
                      <td style={{ ...td, color: theme.blue, fontWeight: 900, fontSize: 13 }}>₹{fmt(r.finalAmount)}</td>
                      <td style={td}>{r.paidStatus ? <span style={{ background: r.paidStatus === "Paid" ? theme.green + "22" : theme.red + "22", color: r.paidStatus === "Paid" ? theme.green : theme.red, borderRadius: 5, padding: "2px 10px", fontSize: 11, fontWeight: 700 }}>{r.paidStatus === "Paid" ? "✅ Paid" : "❌ Not Paid"}</span> : <span style={{ color: theme.muted }}>— Pending —</span>}</td>
                    </tr>
                  ))}
                </tbody>
                <tfoot>
                  <tr style={{ background: "#0f1f3d", borderTop: `2px solid ${theme.blue}` }}>
                    <td colSpan={3} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#0f1f3d", border: "1px solid rgba(99,179,237,0.2)" }}>BANK TOTAL</td>
                    <td style={{ ...td, color: "#93c5fd", fontWeight: 900, background: "#0f1f3d", border: "1px solid rgba(99,179,237,0.2)", fontSize: 15 }}>₹{fmt(bankTotal)}</td>
                    <td style={{ ...td, background: "#0f1f3d", border: "1px solid rgba(99,179,237,0.2)" }} />
                  </tr>
                </tfoot>
              </table>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

// Separate editable row component to avoid hooks-in-loop issue
function EditableRow({ l, i, isEditing, perHour, onEdit, onSave, onCancel, onDelete, onDocs, inp, theme }){
  const [editName, setEditName] = useState(l.name);
  const [editRate, setEditRate] = useState(String(l.rate));

  useEffect(() => {
    setEditName(l.name);
    setEditRate(String(l.rate));
  }, [l.name, l.rate, isEditing]);

  const td = { padding: "10px 14px", border: `1px solid ${theme.border}`, fontSize: 13, verticalAlign: "middle" };

  return (
    <tr style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
      <td style={{ ...td, color: theme.muted, width: 50, textAlign: "center" }}>{i + 1}</td>
<td style={{ ...td, color: theme.accent, fontWeight: 700, width: 80, textAlign: "center" }}>
  <span style={{ background: theme.accent + "22", border: `1px solid ${theme.accent}44`, borderRadius: 5, padding: "2px 8px", fontSize: 11 }}>
    {l.labourId || "—"}
  </span>
</td>
      <td style={{ ...td, minWidth: 200 }}>
        {isEditing ? (
          <input value={editName} onChange={e => setEditName(e.target.value)}
            style={{ ...inp, width: "100%", fontWeight: 600 }} autoFocus />
        ) : (
          <span style={{ color: theme.text, fontWeight: 600 }}>{l.name}</span>
        )}
      </td>
      <td style={{ ...td, textAlign: "center", minWidth: 130 }}>
        {isEditing ? (
          <input type="number" value={editRate} onChange={e => setEditRate(e.target.value)}
            style={{ ...inp, width: 100, color: theme.accent, fontWeight: 700, textAlign: "center" }} />
        ) : (
          <span style={{ color: theme.accent, fontWeight: 800, fontSize: 15 }}>₹{l.rate}</span>
        )}
      </td>
      <td style={{ ...td, textAlign: "center" }}>
  <span style={{ background: theme.accent + "22", color: theme.accent, borderRadius: 6, padding: "3px 10px", fontWeight: 800, fontSize: 12 }}>
    ₹{isEditing ? Math.round(Number(editRate) * 30).toLocaleString("en-IN") : Math.round(l.rate * 30).toLocaleString("en-IN")}
  </span>
</td>
      <td style={{ ...td, textAlign: "center" }}>
        <span style={{ color: theme.purple, fontWeight: 700 }}>₹{perHour}/hr</span>
      </td>
      <td style={{ ...td, minWidth: 160 }}>
        <div style={{ display: "flex", gap: 6 }}>
          {isEditing ? (
            <>
              <button onClick={() => onSave(editName, editRate)}
                style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 7, padding: "5px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>✅ Save</button>
              <button onClick={onCancel}
                style={{ background: theme.muted + "22", border: `1px solid ${theme.border}`, color: theme.muted, borderRadius: 7, padding: "5px 12px", fontSize: 12, cursor: "pointer" }}>Cancel</button>
            </>
          ) : (
            <>
              <button onClick={onDocs}
    style={{ background: theme.purple + "22", border: `1px solid ${theme.purple}44`, color: theme.purple, borderRadius: 7, padding: "5px 10px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>
    📁 Docs {Object.keys(l.documents || {}).length > 0 ? `(${Object.keys(l.documents || {}).length})` : ""}
  </button>
  <button onClick={onEdit}
    style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 7, padding: "5px 12px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>✏️ Edit</button>
  <button onClick={onDelete}
    style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 7, padding: "5px 10px", fontSize: 12, fontWeight: 700, cursor: "pointer" }}>🗑</button>

            </>
          )}
        </div>
      </td>
    </tr>
  );
}

function HRMSModule({ currentUser, projects = []}) {
  const [hrmsTab, setHrmsTab] = useState("attendance");

  return (
    <div>
      <div style={{ marginBottom: 24 }}>
        <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>HRMS</div>
        <h2 style={{ color: theme.text, fontSize: 26, fontWeight: 800, margin: 0 }}>Human Resource Management</h2>
        <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>Attendance & Recruitment</div>
      </div>

      {currentUser?.role === "labour" ? (
        <AttendanceCapture currentUser={currentUser} />
      ) : (
        <>
          <Tabs active={hrmsTab} onChange={setHrmsTab} tabs={[
  { id: "attendance", label: "📋 Attendance" },
  { id: "screening", label: "👤 Candidate Screening" },
  { id: "labour", label: "👷 Labour Details" },
  { id: "supervisor", label: "👔 Supervisor Details" },
  { id: "officestaff", label: "🏢 Office Staff" },
  { id: "payrollsummary", label: "📊 Payroll Summary" },
]} />

          {hrmsTab === "attendance" && (
            currentUser?.role === "engineer"
              ? <AttendanceDashboard currentUser={currentUser} onlyOwn={true} />
              : <AttendanceDashboard currentUser={currentUser} />
          )}
          {hrmsTab === "screening" && <CandidateScreening />}
          {hrmsTab === "labour" && <LabourDetailsTab projects={projects} />}
          {hrmsTab === "supervisor" && <SupervisorDetailsTab projects={projects} />}
          {hrmsTab === "officestaff" && <OfficeStaffDetailsTab />}
          {hrmsTab === "payrollsummary" && <PayrollSummaryTab />}
        </>
      )}
    </div>
  );
}


function OfficePayrollTab() {
  const today = new Date();
  const defaultMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;
  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);
  const [manualData, setManualData] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const ls = localStorage.getItem(`payroll_office_${selectedMonth}`);
    if (ls) setManualData(JSON.parse(ls));
    else setManualData({});
    getDocs(collection(db, "office_payroll")).then(snap => {
      const doc = snap.docs.find(d => d.id === selectedMonth);
      if (doc) setManualData(doc.data().manualData || {});
    }).catch(() => {});
  }, [selectedMonth]);

  const savePayroll = async (updated) => {
    setSaving(true);
    localStorage.setItem(`payroll_office_${selectedMonth}`, JSON.stringify(updated));
    try {
      await setDoc(fsDoc(db, "office_payroll", selectedMonth), {
        month: selectedMonth, manualData: updated, updatedAt: new Date().toISOString()
      });
    } catch (e) { console.error(e); }
    finally { setSaving(false); }
  };

  const updateManual = (staffId, field, value) => {
    const updated = { ...manualData, [staffId]: { ...(manualData[staffId] || {}), [field]: value } };
    setManualData(updated);
    savePayroll(updated);
  };

  const n = v => Number(v) || 0;
  const fmt = v => n(v).toLocaleString("en-IN");

  // Build payroll rows from OFFICE_STAFF_LIST
  const rows = OFFICE_STAFF_LIST.map(s => {
    const manual = manualData[s.id] || {};
    const basic = n(s.basic);
    const perDay = Math.round(basic / 30);
    const perHour = Math.round((perDay / 8) * 100) / 100;
    const daysPayable = n(manual.daysPayable);
    const pay = daysPayable * perDay;
    const otHrs = n(manual.otHrs);
    const otPayable = Math.round(otHrs * perHour * 100) / 100;
    const sunday = n(manual.sunday);
    const sundayPayable = sunday * perDay;
    const nightDays = n(manual.nightDays);
    const fullNightDriver = nightDays * perDay; // Night × Per Day
    const totalPayable = pay + otPayable + sundayPayable + fullNightDriver;
    const conveyance = n(manual.conveyance);
    const total = totalPayable + conveyance;
    const driverNightExp = n(manual.driverNightExp);
    const lessDeduction = n(manual.lessDeduction);
    const finalAmount = total - driverNightExp - lessDeduction;
    return {
      ...s, basic, perDay, perHour,
      daysPayable, pay, otHrs, otPayable,
      sunday, sundayPayable, nightDays, fullNightDriver,
      totalPayable, conveyance, total,
      driverNightExp, lessDeduction, finalAmount,
      modeOfPayment: manual.modeOfPayment || "",
      paidStatus: manual.paidStatus || "",
    };
  });

  // Grand totals
  const totals = rows.reduce((acc, r) => {
    acc.basic += r.basic;
    acc.daysPayable += r.daysPayable;
    acc.pay += r.pay;
    acc.otPayable += r.otPayable;
    acc.sundayPayable += r.sundayPayable;
    acc.fullNightDriver += r.fullNightDriver;
    acc.totalPayable += r.totalPayable;
    acc.conveyance += r.conveyance;
    acc.total += r.total;
    acc.driverNightExp += r.driverNightExp;
    acc.lessDeduction += r.lessDeduction;
    acc.finalAmount += r.finalAmount;
    return acc;
  }, { basic: 0, daysPayable: 0, pay: 0, otPayable: 0, sundayPayable: 0, fullNightDriver: 0, totalPayable: 0, conveyance: 0, total: 0, driverNightExp: 0, lessDeduction: 0, finalAmount: 0 });

  // Excel Export
  const exportExcel = async () => {
    
    const wb = XLSX.utils.book_new();
    const monthLabel = new Date(selectedMonth + "-01").toLocaleString("en-IN", { month: "long", year: "numeric" });
    const header = [
      ["PERMATECH CONCRETE SOLUTIONS"],
      [`Office Staff Payroll — ${monthLabel}`],
      [`Generated: ${new Date().toLocaleDateString("en-IN")}`],
      [],
    ];
    const cols = ["SR", "Name", "Type of Job", "Mode of Payment", "Basic ₹", "Per Day ₹", "Days Payable", "Pay ₹", "OT Hrs", "OT Payable ₹", "Sunday", "Sunday Payable ₹", "Night (Days)", "Full Night Driver ₹", "Total Payable ₹", "Conveyance ₹", "Total ₹", "Driver Night Exp ₹", "Less Deduction ₹", "Final Amount ₹", "Status"];
    const dataRows = rows.map((r, i) => [
      i + 1, r.name, r.typeOfJob || "—", r.modeOfPayment || "—",
      r.basic, r.perDay, r.daysPayable, r.pay,
      r.otHrs, r.otPayable, r.sunday, r.sundayPayable,
      r.nightDays, r.fullNightDriver, r.totalPayable,
      r.conveyance, r.total, r.driverNightExp, r.lessDeduction,
      r.finalAmount, r.paidStatus || "Pending"
    ]);
    const totalRow = ["", "TOTAL", "", "", totals.basic, "", totals.daysPayable, totals.pay, "", totals.otPayable, "", totals.sundayPayable, "", totals.fullNightDriver, totals.totalPayable, totals.conveyance, totals.total, totals.driverNightExp, totals.lessDeduction, totals.finalAmount, ""];
    const ws = XLSX.utils.aoa_to_sheet([...header, cols, ...dataRows, [], totalRow]);
    ws["!cols"] = [{ wch: 5 }, { wch: 20 }, { wch: 18 }, { wch: 14 }, { wch: 12 }, { wch: 10 }, { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 12 }, { wch: 10 }, { wch: 14 }, { wch: 12 }, { wch: 16 }, { wch: 14 }, { wch: 12 }, { wch: 12 }, { wch: 16 }, { wch: 14 }, { wch: 16 }, { wch: 12 }];
    XLSX.utils.book_append_sheet(wb, ws, "Office Payroll");
    XLSX.writeFile(wb, `Office_Payroll_${selectedMonth}.xlsx`);
  };

  const printPayroll = () => {
    const el = document.getElementById("office-payroll-print");
    if (!el) return;
    const win = window.open("", "_blank");
    win.document.write(`<html><head><style>
      body{font-family:Arial,sans-serif;padding:16px;font-size:9px}
      table{width:100%;border-collapse:collapse}
      th{background:#1a365d;color:#fff;padding:6px 5px;font-size:8px;text-align:center;border:1px solid #2d4a7a;white-space:nowrap}
      td{padding:5px;border:1px solid #e2e8f0;font-size:8px;text-align:center}
      tr:nth-child(even){background:#f8fafc}
      .total-row td{background:#1a365d;color:#fff;font-weight:bold;border-color:#2d4a7a}
      @media print{@page{margin:6mm;size:A3 landscape}}
    </style></head><body>${el.innerHTML}</body></html>`);
    win.document.close();
    setTimeout(() => { win.print(); win.close(); }, 500);
  };

  const th = { padding: "9px 8px", background: "#162040", color: "#93c5fd", fontSize: 9, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: "1px solid rgba(99,179,237,0.2)", whiteSpace: "nowrap" };
  const td = { padding: "7px 6px", border: `1px solid ${theme.border}`, fontSize: 11, textAlign: "center", verticalAlign: "middle" };
  const inp = (color = theme.text) => ({ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 5, color, padding: "4px 6px", fontSize: 11, outline: "none", width: "100%", textAlign: "center", boxSizing: "border-box" });
  const autoCell = (val, color) => (
    <td style={{ ...td, color, fontWeight: 700, background: color + "08" }}>₹{fmt(val)}</td>
  );

  const monthLabel = new Date(selectedMonth + "-01").toLocaleString("en-IN", { month: "long", year: "numeric" });

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>HRMS</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>💰 Office Staff Payroll</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{monthLabel} · {rows.length} staff</div>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          {saving && <span style={{ color: theme.orange, fontSize: 12, fontWeight: 600 }}>⏳ Saving...</span>}
          <Btn variant="ghost" onClick={printPayroll}>🖨 Print PDF</Btn>
          <Btn onClick={exportExcel}>📥 Export Excel</Btn>
        </div>
      </div>

      {/* Month Picker + Summary */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 16, display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
        <div>
          <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>PAYROLL MONTH</div>
          <input type="month" value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)}
            style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.accent, padding: "8px 12px", fontSize: 14, fontWeight: 700, outline: "none" }} />
        </div>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          {[
            { label: "Total Pay", val: totals.pay, color: theme.blue },
            { label: "Total Payable", val: totals.totalPayable, color: theme.accent },
            { label: "Final Payable", val: totals.finalAmount, color: theme.green },
          ].map(({ label, val, color }) => (
            <div key={label} style={{ background: color + "11", border: `1px solid ${color}33`, borderRadius: 8, padding: "8px 14px" }}>
              <div style={{ color: theme.muted, fontSize: 10, fontWeight: 600 }}>{label}</div>
              <div style={{ color, fontWeight: 900, fontSize: 16 }}>₹{fmt(val)}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Table */}
      <div id="office-payroll-print">
        <div style={{ color: theme.muted, fontSize: 12, marginBottom: 12 }}>
          Office Staff Payroll — {monthLabel} &nbsp;|&nbsp; {rows.length} staff &nbsp;|&nbsp; Generated: {new Date().toLocaleDateString("en-IN")}
        </div>
        <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 2200 }}>
            <thead>
              <tr>
                <th style={th}>SR</th>
                <th style={th}>Name</th>
                <th style={th}>Type of Job</th>
                <th style={th}>Mode of Payment</th>
                <th style={th}>Basic ₹</th>
                <th style={th}>Per Day ₹</th>
                <th style={{ ...th, background: "#1e3a5f" }}>Days Payable</th>
                <th style={{ ...th, background: "#1e3a5f" }}>Pay ₹</th>
                <th style={{ ...th, background: "#1a2f5a" }}>OT Hrs</th>
                <th style={{ ...th, background: "#1a2f5a" }}>OT Payable ₹</th>
                <th style={{ ...th, background: "#162a50" }}>Sunday</th>
                <th style={{ ...th, background: "#162a50" }}>Sunday Payable ₹</th>
                <th style={{ ...th, background: "#12224a" }}>Night (Days)</th>
                <th style={{ ...th, background: "#12224a" }}>Full Night Driver ₹</th>
                <th style={{ ...th, background: "#0f1c40" }}>Total Payable ₹</th>
                <th style={{ ...th, background: "#1e3a5f" }}>Conveyance ₹</th>
                <th style={{ ...th, background: "#0f1c40" }}>Total ₹</th>
                <th style={{ ...th, background: "#2d1a1a" }}>Driver Night Exp ₹</th>
                <th style={{ ...th, background: "#2d1a1a" }}>Less Deduction ₹</th>
                <th style={{ ...th, background: "#1a2f1a" }}>Final Amount ₹</th>
                <th style={{ ...th, background: "#1a3520" }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                  <td style={{ ...td, color: theme.muted }}>{i + 1}</td>
                  <td style={{ ...td, fontWeight: 700, textAlign: "left", paddingLeft: 10, minWidth: 150 }}>{r.name}</td>
                  <td style={{ ...td }}>
                    <span style={{ background: theme.blue + "22", color: theme.blue, borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700 }}>{r.typeOfJob || "—"}</span>
                  </td>
                  {/* Mode of Payment */}
                  <td style={{ ...td, minWidth: 110 }}>
                    <select value={r.modeOfPayment} onChange={e => updateManual(r.id, "modeOfPayment", e.target.value)}
                      style={{ ...inp(r.modeOfPayment === "Bank" ? theme.blue : r.modeOfPayment === "Cash" ? theme.green : theme.muted), cursor: "pointer" }}>
                      <option value="">— Select —</option>
                      <option value="Bank">🏦 Bank</option>
                      <option value="Cash">💵 Cash</option>
                    </select>
                  </td>
                  {/* Basic & Per Day — AUTO */}
                  <td style={{ ...td, color: theme.accent, fontWeight: 700 }}>₹{fmt(r.basic)}</td>
                  <td style={{ ...td, color: theme.blue, fontWeight: 700 }}>₹{fmt(r.perDay)}</td>
                  {/* Days Payable — MANUAL */}
                  <td style={{ ...td, minWidth: 80 }}>
                    <input type="number" value={manualData[r.id]?.daysPayable || ""} onChange={e => updateManual(r.id, "daysPayable", e.target.value)} style={inp(theme.green)} placeholder="0" />
                  </td>
                  {/* Pay — AUTO */}
                  {autoCell(r.pay, theme.green)}
                  {/* OT Hrs — MANUAL */}
                  <td style={{ ...td, minWidth: 70 }}>
                    <input type="number" value={manualData[r.id]?.otHrs || ""} onChange={e => updateManual(r.id, "otHrs", e.target.value)} style={inp(theme.orange)} placeholder="0" />
                  </td>
                  {/* OT Payable — AUTO */}
                  {autoCell(r.otPayable, theme.orange)}
                  {/* Sunday — MANUAL */}
                  <td style={{ ...td, minWidth: 70 }}>
                    <input type="number" value={manualData[r.id]?.sunday || ""} onChange={e => updateManual(r.id, "sunday", e.target.value)} style={inp(theme.purple)} placeholder="0" />
                  </td>
                  {/* Sunday Payable — AUTO */}
                  {autoCell(r.sundayPayable, theme.purple)}
                  {/* Night Days — MANUAL */}
                  <td style={{ ...td, minWidth: 70 }}>
                    <input type="number" value={manualData[r.id]?.nightDays || ""} onChange={e => updateManual(r.id, "nightDays", e.target.value)} style={inp(theme.blue)} placeholder="0" />
                  </td>
                  {/* Full Night Driver — AUTO (Night × Per Day) */}
                  {autoCell(r.fullNightDriver, theme.blue)}
                  {/* Total Payable — AUTO */}
                  <td style={{ ...td, color: theme.accent, fontWeight: 900, background: theme.accent + "11", fontSize: 13 }}>₹{fmt(r.totalPayable)}</td>
                  {/* Conveyance — MANUAL */}
                  <td style={{ ...td, minWidth: 80 }}>
                    <input type="number" value={manualData[r.id]?.conveyance || ""} onChange={e => updateManual(r.id, "conveyance", e.target.value)} style={inp(theme.orange)} placeholder="0" />
                  </td>
                  {/* Total — AUTO */}
                  <td style={{ ...td, color: theme.blue, fontWeight: 900, background: theme.blue + "11", fontSize: 13 }}>₹{fmt(r.total)}</td>
                  {/* Driver Night Exp — MANUAL */}
                  <td style={{ ...td, minWidth: 80 }}>
                    <input type="number" value={manualData[r.id]?.driverNightExp || ""} onChange={e => updateManual(r.id, "driverNightExp", e.target.value)} style={inp(theme.red)} placeholder="0" />
                  </td>
                  {/* Less Deduction — MANUAL */}
                  <td style={{ ...td, minWidth: 80 }}>
                    <input type="number" value={manualData[r.id]?.lessDeduction || ""} onChange={e => updateManual(r.id, "lessDeduction", e.target.value)} style={inp(theme.red)} placeholder="0" />
                  </td>
                  {/* Final Amount — AUTO */}
                  <td style={{ ...td, color: r.finalAmount >= 0 ? theme.green : theme.red, fontWeight: 900, background: theme.green + "08", fontSize: 13 }}>₹{fmt(r.finalAmount)}</td>
                  {/* Paid Status */}
                  <td style={{ ...td, minWidth: 110 }}>
                    <select value={r.paidStatus} onChange={e => updateManual(r.id, "paidStatus", e.target.value)}
                      style={{ background: r.paidStatus === "Paid" ? theme.green + "22" : r.paidStatus === "Not Paid" ? theme.red + "22" : theme.bg, border: `1px solid ${r.paidStatus === "Paid" ? theme.green : r.paidStatus === "Not Paid" ? theme.red : theme.border}44`, color: r.paidStatus === "Paid" ? theme.green : r.paidStatus === "Not Paid" ? theme.red : theme.muted, borderRadius: 6, padding: "4px 6px", fontSize: 11, fontWeight: 700, cursor: "pointer", width: "100%", outline: "none" }}>
                      <option value="">— Status —</option>
                      <option value="Paid">✅ Paid</option>
                      <option value="Not Paid">❌ Not Paid</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                <td colSpan={4} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 12 }}>GRAND TOTAL</td>
                <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.basic)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>{totals.daysPayable}</td>
                <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.pay)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                <td style={{ ...td, color: "#FCD34D", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.otPayable)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                <td style={{ ...td, color: "#C4B5FD", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.sundayPayable)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                <td style={{ ...td, color: "#93C5FD", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.fullNightDriver)}</td>
                <td style={{ ...td, color: "#fff", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 13 }}>₹{fmt(totals.totalPayable)}</td>
                <td style={{ ...td, color: "#FCD34D", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.conveyance)}</td>
                <td style={{ ...td, color: "#93C5FD", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 13 }}>₹{fmt(totals.total)}</td>
                <td style={{ ...td, color: "#FCA5A5", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.driverNightExp)}</td>
                <td style={{ ...td, color: "#FCA5A5", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.lessDeduction)}</td>
                <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 14 }}>₹{fmt(totals.finalAmount)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
}

function SupervisorPayrollTab({projects=[]}) {
  const today = new Date();
  const defaultMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;
  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);
  const [manualData, setManualData] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    const ls = localStorage.getItem(`payroll_supervisor_${selectedMonth}`);
    if (ls) setManualData(JSON.parse(ls));
    else setManualData({});
    getDocs(collection(db, "supervisor_payroll")).then(snap => {
      const doc = snap.docs.find(d => d.id === selectedMonth);
      if (doc) setManualData(doc.data().manualData || {});
    }).catch(() => {});
  }, [selectedMonth]);

  const savePayroll = async (updated) => {
    setSaving(true);
    localStorage.setItem(`payroll_supervisor_${selectedMonth}`, JSON.stringify(updated));
    try {
      await setDoc(fsDoc(db, "supervisor_payroll", selectedMonth), {
        month: selectedMonth, manualData: updated, updatedAt: new Date().toISOString()
      });
    } catch (e) { console.error(e); }
    finally { setSaving(false); }
  };

  const updateManual = (supId, field, value) => {
    const updated = { ...manualData, [supId]: { ...(manualData[supId] || {}), [field]: value } };
    setManualData(updated);
    savePayroll(updated);
  };

  const n = v => Number(v) || 0;
  const fmt = v => n(v).toLocaleString("en-IN");

  // Build payroll rows from SUPERVISOR_LIST
  const rows = SUPERVISOR_LIST.map(s => {
    const manual = manualData[s.id] || {};
    const basic = n(s.basic);
    const perDay = Math.round(basic / 30);
    const perHour = Math.round((perDay / 8) * 100) / 100;
    const daysPayable = n(manual.daysPayable);
    const pay = daysPayable * perDay;
    const otHrs = n(manual.otHrs);
    const otPayable = Math.round(otHrs * perHour * 100) / 100;
    const sunday = n(manual.sunday);
    const sundayPayable = sunday * perDay;
    const fullNightDays = n(manual.fullNightDays);
    const fullNightPayable = fullNightDays * 2 * perDay;
    // Auto-fetch travel from all projects logs for this month
const supTravel = projects ? projects.flatMap(p => (p.logs || []).filter(log => log.date?.startsWith(selectedMonth)))
  .filter(log => log.supervisor?.name?.trim().toLowerCase() === s.name?.trim().toLowerCase())
  .reduce((sum, log) => sum + (Number(log.supervisor?.travel) || 0), 0) : 0;
const travel = n(manual.travel) || supTravel;
const totalPayable = pay + otPayable + sundayPayable + fullNightPayable + travel;
    const trainPass = n(manual.trainPass);
    const lessDeduction = n(manual.lessDeduction);
    const loanRecovery = n(manual.loanRecovery);
    const finalAmount = totalPayable - trainPass - lessDeduction - loanRecovery;
    return {
      ...s, basic, perDay, perHour,
      daysPayable, pay, otHrs, otPayable,
      sunday, sundayPayable, fullNightDays, fullNightPayable,
      travel, totalPayable, trainPass, lessDeduction, loanRecovery, finalAmount,
      paidStatus: manual.paidStatus || "",
    };
  });

  // Totals
  const totals = rows.reduce((acc, r) => {
    acc.basic += r.basic;
    acc.daysPayable += r.daysPayable;
    acc.pay += r.pay;
    acc.otPayable += r.otPayable;
    acc.sundayPayable += r.sundayPayable;
    acc.fullNightPayable += r.fullNightPayable;
    acc.travel += r.travel;
    acc.totalPayable += r.totalPayable;
    acc.trainPass += r.trainPass;
    acc.lessDeduction += r.lessDeduction;
    acc.loanRecovery += r.loanRecovery;
    acc.finalAmount += r.finalAmount;
    return acc;
  }, { basic: 0, daysPayable: 0, pay: 0, otPayable: 0, sundayPayable: 0, fullNightPayable: 0, travel: 0, totalPayable: 0, trainPass: 0, lessDeduction: 0, loanRecovery: 0, finalAmount: 0 });

  // Excel Export
  const exportExcel = async () => {
    
    const wb = XLSX.utils.book_new();
    const monthLabel = new Date(selectedMonth + "-01").toLocaleString("en-IN", { month: "long", year: "numeric" });
    const header = [
      ["PERMATECH CONCRETE SOLUTIONS"],
      [`Supervisor Payroll — ${monthLabel}`],
      [`Generated: ${new Date().toLocaleDateString("en-IN")}`],
      [],
    ];
    const cols = ["SR", "Name", "Type of Job", "Basic ₹", "Per Day ₹", "Days Payable", "Pay ₹", "OT Hrs", "OT Payable ₹", "Sunday", "Sunday Payable ₹", "Full Night (Days)", "Full Night Payable ₹", "Travel ₹", "Total Payable ₹", "Train Pass ₹", "Less Deduction ₹", "Loan Recovery ₹", "Final Amount ₹", "Status"];
    const dataRows = rows.map((r, i) => [
      i + 1, r.name, r.typeOfJob || "Supervisor", r.basic, r.perDay,
      r.daysPayable, r.pay, r.otHrs, r.otPayable,
      r.sunday, r.sundayPayable, r.fullNightDays, r.fullNightPayable,
      r.travel, r.totalPayable, r.trainPass, r.lessDeduction, r.loanRecovery,
      r.finalAmount, r.paidStatus || "Pending"
    ]);
    const totalRow = ["", "TOTAL", "", totals.basic, "", totals.daysPayable, totals.pay, "", totals.otPayable, "", totals.sundayPayable, "", totals.fullNightPayable, totals.travel, totals.totalPayable, totals.trainPass, totals.lessDeduction, totals.loanRecovery, totals.finalAmount, ""];
    const ws = XLSX.utils.aoa_to_sheet([...header, cols, ...dataRows, [], totalRow]);
    ws["!cols"] = [{ wch: 5 }, { wch: 20 }, { wch: 16 }, { wch: 12 }, { wch: 10 }, { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 12 }, { wch: 10 }, { wch: 14 }, { wch: 14 }, { wch: 16 }, { wch: 10 }, { wch: 14 }, { wch: 12 }, { wch: 14 }, { wch: 14 }, { wch: 16 }, { wch: 12 }];
    XLSX.utils.book_append_sheet(wb, ws, "Supervisor Payroll");
    XLSX.writeFile(wb, `Supervisor_Payroll_${selectedMonth}.xlsx`);
  };

  const printPayroll = () => {
    const el = document.getElementById("supervisor-payroll-print");
    if (!el) return;
    const win = window.open("", "_blank");
    win.document.write(`<html><head><style>
      body{font-family:Arial,sans-serif;padding:16px;font-size:9px}
      h2{color:#1a365d;font-size:14px;margin-bottom:2px}
      table{width:100%;border-collapse:collapse}
      th{background:#1a365d;color:#fff;padding:6px 5px;font-size:8px;text-align:center;border:1px solid #2d4a7a;white-space:nowrap}
      td{padding:5px;border:1px solid #e2e8f0;font-size:8px;text-align:center}
      tr:nth-child(even){background:#f8fafc}
      .total-row td{background:#1a365d;color:#fff;font-weight:bold;border-color:#2d4a7a}
      @media print{@page{margin:6mm;size:A3 landscape}}
    </style></head><body>${el.innerHTML}</body></html>`);
    win.document.close();
    setTimeout(() => { win.print(); win.close(); }, 500);
  };

  const th = { padding: "9px 8px", background: "#162040", color: "#93c5fd", fontSize: 9, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: "1px solid rgba(99,179,237,0.2)", whiteSpace: "nowrap" };
  const td = { padding: "7px 6px", border: `1px solid ${theme.border}`, fontSize: 11, textAlign: "center", verticalAlign: "middle" };
  const inp = (color = theme.text) => ({ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 5, color, padding: "4px 6px", fontSize: 11, outline: "none", width: "100%", textAlign: "center", boxSizing: "border-box" });

  const monthLabel = new Date(selectedMonth + "-01").toLocaleString("en-IN", { month: "long", year: "numeric" });

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>HRMS</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>💰 Supervisor Payroll</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{monthLabel} · {rows.length} supervisors</div>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          {saving && <span style={{ color: theme.orange, fontSize: 12, fontWeight: 600 }}>⏳ Saving...</span>}
          <Btn variant="ghost" onClick={printPayroll}>🖨 Print PDF</Btn>
          <Btn onClick={exportExcel}>📥 Export Excel</Btn>
        </div>
      </div>

      {/* Month Picker + Summary */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 16, display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
        <div>
          <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>PAYROLL MONTH</div>
          <input type="month" value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)}
            style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.accent, padding: "8px 12px", fontSize: 14, fontWeight: 700, outline: "none" }} />
        </div>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          {[
            { label: "Total Pay", val: totals.pay, color: theme.blue },
            { label: "Total Payable", val: totals.totalPayable, color: theme.accent },
            { label: "Final Payable", val: totals.finalAmount, color: theme.green },
          ].map(({ label, val, color }) => (
            <div key={label} style={{ background: color + "11", border: `1px solid ${color}33`, borderRadius: 8, padding: "8px 14px" }}>
              <div style={{ color: theme.muted, fontSize: 10, fontWeight: 600 }}>{label}</div>
              <div style={{ color, fontWeight: 900, fontSize: 16 }}>₹{fmt(val)}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Table */}
      <div id="supervisor-payroll-print">
        <div style={{ color: theme.muted, fontSize: 12, marginBottom: 12 }}>
          Supervisor Payroll — {monthLabel} &nbsp;|&nbsp; {rows.length} supervisors &nbsp;|&nbsp; Generated: {new Date().toLocaleDateString("en-IN")}
        </div>
        <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 2000 }}>
            <thead>
              <tr>
                <th style={th}>SR</th>
                <th style={th}>Name</th>
                <th style={th}>Type of Job</th>
                <th style={th}>Basic ₹</th>
                <th style={th}>Per Day ₹</th>
                <th style={{ ...th, background: "#1e3a5f" }}>Days Payable</th>
                <th style={{ ...th, background: "#1e3a5f" }}>Pay ₹</th>
                <th style={{ ...th, background: "#1a2f5a" }}>OT Hrs</th>
                <th style={{ ...th, background: "#1a2f5a" }}>OT Payable ₹</th>
                <th style={{ ...th, background: "#162a50" }}>Sunday</th>
                <th style={{ ...th, background: "#162a50" }}>Sunday Payable ₹</th>
                <th style={{ ...th, background: "#12224a" }}>Full Night (Days)</th>
                <th style={{ ...th, background: "#12224a" }}>Full Night Payable ₹</th>
                <th style={{ ...th, background: "#1e3a5f" }}>Travel ₹</th>
                <th style={{ ...th, background: "#0f1c40" }}>Total Payable ₹</th>
                <th style={{ ...th, background: "#2d1a1a" }}>Train Pass ₹</th>
                <th style={{ ...th, background: "#2d1a1a" }}>Less Deduction ₹</th>
                <th style={{ ...th, background: "#2d1a1a" }}>Loan Recovery ₹</th>
                <th style={{ ...th, background: "#1a2f1a" }}>Final Amount ₹</th>
                <th style={{ ...th, background: "#1a3520" }}>Status</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                  <td style={{ ...td, color: theme.muted }}>{i + 1}</td>
                  <td style={{ ...td, fontWeight: 700, textAlign: "left", paddingLeft: 10, minWidth: 150 }}>{r.name}</td>
                  <td style={{ ...td }}>
                    <span style={{ background: theme.blue + "22", color: theme.blue, borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700 }}>{r.typeOfJob || "Supervisor"}</span>
                  </td>
                  <td style={{ ...td, color: theme.accent, fontWeight: 700 }}>₹{fmt(r.basic)}</td>
                  <td style={{ ...td, color: theme.blue, fontWeight: 700 }}>₹{fmt(r.perDay)}</td>
                  {/* Days Payable — MANUAL */}
                  <td style={{ ...td, minWidth: 80 }}>
                    <input type="number" value={manualData[r.id]?.daysPayable || ""} onChange={e => updateManual(r.id, "daysPayable", e.target.value)} style={inp(theme.green)} placeholder="0" />
                  </td>
                  {/* Pay — AUTO */}
                  <td style={{ ...td, color: theme.green, fontWeight: 700, background: theme.green + "08" }}>₹{fmt(r.pay)}</td>
                  {/* OT Hrs — MANUAL */}
                  <td style={{ ...td, minWidth: 70 }}>
                    <input type="number" value={manualData[r.id]?.otHrs || ""} onChange={e => updateManual(r.id, "otHrs", e.target.value)} style={inp(theme.orange)} placeholder="0" />
                  </td>
                  {/* OT Payable — AUTO */}
                  <td style={{ ...td, color: theme.orange, fontWeight: 700, background: theme.orange + "08" }}>₹{fmt(r.otPayable)}</td>
                  {/* Sunday — MANUAL */}
                  <td style={{ ...td, minWidth: 70 }}>
                    <input type="number" value={manualData[r.id]?.sunday || ""} onChange={e => updateManual(r.id, "sunday", e.target.value)} style={inp(theme.purple)} placeholder="0" />
                  </td>
                  {/* Sunday Payable — AUTO */}
                  <td style={{ ...td, color: theme.purple, fontWeight: 700, background: theme.purple + "08" }}>₹{fmt(r.sundayPayable)}</td>
                  {/* Full Night Days — MANUAL */}
                  <td style={{ ...td, minWidth: 70 }}>
                    <input type="number" value={manualData[r.id]?.fullNightDays || ""} onChange={e => updateManual(r.id, "fullNightDays", e.target.value)} style={inp(theme.blue)} placeholder="0" />
                  </td>
                  {/* Full Night Payable — AUTO */}
                  <td style={{ ...td, color: theme.blue, fontWeight: 700, background: theme.blue + "08" }}>₹{fmt(r.fullNightPayable)}</td>
                  {/* Travel — MANUAL */}
                  <td style={{ ...td, minWidth: 80 }}>
                    <input type="number" value={manualData[r.id]?.travel || ""} onChange={e => updateManual(r.id, "travel", e.target.value)} style={inp(theme.orange)} placeholder="0" />
                  </td>
                  {/* Total Payable — AUTO */}
                  <td style={{ ...td, color: theme.accent, fontWeight: 900, background: theme.accent + "11", fontSize: 13 }}>₹{fmt(r.totalPayable)}</td>
                  {/* Train Pass — MANUAL */}
                  <td style={{ ...td, minWidth: 80 }}>
                    <input type="number" value={manualData[r.id]?.trainPass || ""} onChange={e => updateManual(r.id, "trainPass", e.target.value)} style={inp(theme.red)} placeholder="0" />
                  </td>
                  {/* Less Deduction — MANUAL */}
                  <td style={{ ...td, minWidth: 80 }}>
                    <input type="number" value={manualData[r.id]?.lessDeduction || ""} onChange={e => updateManual(r.id, "lessDeduction", e.target.value)} style={inp(theme.red)} placeholder="0" />
                  </td>
                  {/* Loan Recovery — MANUAL */}
                  <td style={{ ...td, minWidth: 80 }}>
                    <input type="number" value={manualData[r.id]?.loanRecovery || ""} onChange={e => updateManual(r.id, "loanRecovery", e.target.value)} style={inp(theme.red)} placeholder="0" />
                  </td>
                  {/* Final Amount — AUTO */}
                  <td style={{ ...td, color: r.finalAmount >= 0 ? theme.green : theme.red, fontWeight: 900, background: theme.green + "08", fontSize: 13 }}>₹{fmt(r.finalAmount)}</td>
                  {/* Paid Status */}
                  <td style={{ ...td, minWidth: 110 }}>
                    <select value={r.paidStatus} onChange={e => updateManual(r.id, "paidStatus", e.target.value)}
                      style={{ background: r.paidStatus === "Paid" ? theme.green + "22" : r.paidStatus === "Not Paid" ? theme.red + "22" : theme.bg, border: `1px solid ${r.paidStatus === "Paid" ? theme.green : r.paidStatus === "Not Paid" ? theme.red : theme.border}44`, color: r.paidStatus === "Paid" ? theme.green : r.paidStatus === "Not Paid" ? theme.red : theme.muted, borderRadius: 6, padding: "4px 6px", fontSize: 11, fontWeight: 700, cursor: "pointer", width: "100%", outline: "none" }}>
                      <option value="">— Status —</option>
                      <option value="Paid">✅ Paid</option>
                      <option value="Not Paid">❌ Not Paid</option>
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                <td colSpan={3} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 12 }}>GRAND TOTAL</td>
                <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.basic)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>{totals.daysPayable}</td>
                <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.pay)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                <td style={{ ...td, color: "#FCD34D", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.otPayable)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                <td style={{ ...td, color: "#C4B5FD", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.sundayPayable)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                <td style={{ ...td, color: "#93C5FD", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.fullNightPayable)}</td>
                <td style={{ ...td, color: "#FCD34D", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.travel)}</td>
                <td style={{ ...td, color: "#fff", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 13 }}>₹{fmt(totals.totalPayable)}</td>
                <td style={{ ...td, color: "#FCA5A5", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.trainPass)}</td>
                <td style={{ ...td, color: "#FCA5A5", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.lessDeduction)}</td>
                <td style={{ ...td, color: "#FCA5A5", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.loanRecovery)}</td>
                <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 14 }}>₹{fmt(totals.finalAmount)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
}


function LabourPayrollTab({ projects = [] }) {
  const today = new Date();
  const defaultMonth = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}`;
  const [selectedMonth, setSelectedMonth] = useState(defaultMonth);
  const [manualData, setManualData] = useState({}); // { labourId: { modeOfPayment, otHrs, upto12amDays, fullNightDays, lessDeduction } }
  const [saving, setSaving] = useState(false);

  // Load saved payroll data for this month
  useEffect(() => {
    const ls = localStorage.getItem(`payroll_labour_${selectedMonth}`);
    if (ls) setManualData(JSON.parse(ls));
    else setManualData({});
    getDocs(collection(db, "labour_payroll")).then(snap => {
      const doc = snap.docs.find(d => d.id === selectedMonth);
      if (doc) setManualData(doc.data().manualData || {});
    }).catch(() => {});
  }, [selectedMonth]);

  const savePayroll = async (updated) => {
    setSaving(true);
    localStorage.setItem(`payroll_labour_${selectedMonth}`, JSON.stringify(updated));
    try {
      await setDoc(fsDoc(db, "labour_payroll", selectedMonth), { month: selectedMonth, manualData: updated, updatedAt: new Date().toISOString() });
    } catch (e) { console.error(e); }
    finally { setSaving(false); }
  };

  const updateManual = (labourId, field, value) => {
    const updated = { ...manualData, [labourId]: { ...(manualData[labourId] || {}), [field]: value } };
    setManualData(updated);
    savePayroll(updated);
  };

  // Get all logs for selected month across all projects
  const monthLogs = projects.flatMap(p => (p.logs || []).filter(log => log.date?.startsWith(selectedMonth)));

  // Get days worked, travel, food for a labour name from logs
  const getLabourStats = (name) => {
    const normalize = s => s?.trim().toLowerCase();
    const labourLogs = monthLogs.filter(log =>
      (log.labours || []).some(l => normalize(l.name) === normalize(name))
    );
    const uniqueDates = [...new Set(labourLogs.map(l => l.date))];
    const daysPayable = uniqueDates.length;
    let travel = 0, food = 0;
    labourLogs.forEach(log => {
      (log.labours || []).filter(l => normalize(l.name) === normalize(name)).forEach(l => {
        travel += Number(l.travellingCost) || 0;
        food += Number(l.foodCost) || 0;
      });
    });
    return { daysPayable, travel, food };
  };

  const n = v => Number(v) || 0;
  const fmt = v => n(v).toLocaleString("en-IN");

  // Build payroll rows
  const rows = LABOUR_LIST.map(l => {
    const manual = manualData[l.id] || {};
    const perDay = n(l.rate);
    const perHour = Math.round((perDay / 8) * 100) / 100;
    const basicSalary = perDay * 30;
    const { daysPayable: autoDays, travel, food } = getLabourStats(l.name);
const daysPayable = manual.daysPayable !== undefined && manual.daysPayable !== ""
  ? n(manual.daysPayable)
  : autoDays;
const wages = daysPayable * perDay;
    const otHrs = n(manual.otHrs);
    const otPayable = Math.round(otHrs * perHour * 100) / 100;
    const upto12amDays = n(manual.upto12amDays);
    const upto12amWages = upto12amDays * perDay;
    const fullNightDays = n(manual.fullNightDays);
    const fullNightPayable = fullNightDays * 2 * perDay;
    const totalPayable = wages + otPayable + upto12amWages + fullNightPayable;
    const totalWithConvy = totalPayable + travel + food;
    const lessDeduction = n(manual.lessDeduction);
    const finalAmount = totalWithConvy - lessDeduction;
    return {
      ...l, perDay, perHour, basicSalary, daysPayable, wages,
      otHrs, otPayable, upto12amDays, upto12amWages,
      fullNightDays, fullNightPayable, totalPayable,
      travel, food, totalWithConvy, lessDeduction, finalAmount,
      modeOfPayment: manual.modeOfPayment || "",
      paidStatus: manual.paidStatus || "",
    };
  });

  // Grand totals
  const totals = rows.reduce((acc, r) => {
    acc.basicSalary += r.basicSalary;
    acc.daysPayable += r.daysPayable;
    acc.wages += r.wages;
    acc.otPayable += r.otPayable;
    acc.upto12amWages += r.upto12amWages;
    acc.fullNightPayable += r.fullNightPayable;
    acc.totalPayable += r.totalPayable;
    acc.travel += r.travel;
    acc.food += r.food;
    acc.totalWithConvy += r.totalWithConvy;
    acc.lessDeduction += r.lessDeduction;
    acc.finalAmount += r.finalAmount;
    return acc;
  }, { basicSalary: 0, daysPayable: 0, wages: 0, otPayable: 0, upto12amWages: 0, fullNightPayable: 0, totalPayable: 0, travel: 0, food: 0, totalWithConvy: 0, lessDeduction: 0, finalAmount: 0 });

  // Excel Export
  const exportExcel = async () => {
    
    const wb = XLSX.utils.book_new();
    const monthLabel = new Date(selectedMonth + "-01").toLocaleString("en-IN", { month: "long", year: "numeric" });
    const header = [
      ["PERMATECH CONCRETE SOLUTIONS"],
      [`Labour Payroll — ${monthLabel}`],
      [`Generated: ${new Date().toLocaleDateString("en-IN")}`],
      [],
    ];
    const cols = ["Name", "Work Status", "Mode of Payment", "Per Day ₹", "Basic Salary ₹", "Days Payable", "Wages ₹", "OT Hrs", "OT Payable ₹", "Upto 12am (Days)", "Wages ₹", "Full Night (Days)", "Full Night Payable ₹", "Total Payable ₹", "Travel ₹", "Breakfast & Dinner ₹", "Total + Conveyance ₹", "Less Deduction ₹", "Final Amount ₹"];
    const dataRows = rows.map(r => [
      r.name, "Labour", r.modeOfPayment || "—", r.perDay, r.basicSalary,
      r.daysPayable, r.wages, r.otHrs, r.otPayable,
      r.upto12amDays, r.upto12amWages, r.fullNightDays, r.fullNightPayable,
      r.totalPayable, r.travel, r.food, r.totalWithConvy, r.lessDeduction, r.finalAmount
    ]);
    const totalRow = ["TOTAL", "", "", "", totals.basicSalary, totals.daysPayable, totals.wages, "", totals.otPayable, "", totals.upto12amWages, "", totals.fullNightPayable, totals.totalPayable, totals.travel, totals.food, totals.totalWithConvy, totals.lessDeduction, totals.finalAmount];
    const ws = XLSX.utils.aoa_to_sheet([...header, cols, ...dataRows, [], totalRow]);
    ws["!cols"] = [{ wch: 20 }, { wch: 12 }, { wch: 14 }, { wch: 10 }, { wch: 14 }, { wch: 12 }, { wch: 12 }, { wch: 10 }, { wch: 12 }, { wch: 14 }, { wch: 10 }, { wch: 14 }, { wch: 16 }, { wch: 14 }, { wch: 10 }, { wch: 18 }, { wch: 18 }, { wch: 16 }, { wch: 16 }];
    XLSX.utils.book_append_sheet(wb, ws, "Labour Payroll");
    XLSX.writeFile(wb, `Labour_Payroll_${selectedMonth}.xlsx`);
  };

  const printPayroll = () => {
    const el = document.getElementById("labour-payroll-print");
    if (!el) return;
    const win = window.open("", "_blank");
    win.document.write(`<html><head><style>
      body{font-family:Arial,sans-serif;padding:16px;font-size:9px}
      h2{color:#1a365d;font-size:14px;margin-bottom:2px}
      .meta{color:#666;font-size:10px;margin-bottom:12px}
      table{width:100%;border-collapse:collapse}
      th{background:#1a365d;color:#fff;padding:6px 5px;font-size:8px;text-align:center;border:1px solid #2d4a7a;white-space:nowrap}
      td{padding:5px;border:1px solid #e2e8f0;font-size:8px;text-align:center}
      tr:nth-child(even){background:#f8fafc}
      .total-row td{background:#1a365d;color:#fff;font-weight:bold;border-color:#2d4a7a}
      @media print{@page{margin:6mm;size:A3 landscape}}
    </style></head><body>${el.innerHTML}</body></html>`);
    win.document.close();
    setTimeout(() => { win.print(); win.close(); }, 500);
  };

  const th = { padding: "9px 8px", background: "#162040", color: "#93c5fd", fontSize: 9, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: "1px solid rgba(99,179,237,0.2)", whiteSpace: "nowrap" };
  const td = { padding: "7px 6px", border: `1px solid ${theme.border}`, fontSize: 11, textAlign: "center", verticalAlign: "middle" };
  const inp = (color = theme.text) => ({ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 5, color, padding: "4px 6px", fontSize: 11, outline: "none", width: "100%", textAlign: "center", boxSizing: "border-box" });
  const autoCell = (val, color = theme.text) => (
    <td style={{ ...td, color, fontWeight: 700, background: color + "08" }}>₹{fmt(val)}</td>
  );

  const monthLabel = new Date(selectedMonth + "-01").toLocaleString("en-IN", { month: "long", year: "numeric" });

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>HRMS</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>💰 Labour Payroll</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{monthLabel} · {rows.length} labours</div>
        </div>
        <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
          {saving && <span style={{ color: theme.orange, fontSize: 12, fontWeight: 600 }}>⏳ Saving...</span>}
          <Btn variant="ghost" onClick={printPayroll}>🖨 Print PDF</Btn>
          <Btn onClick={exportExcel}>📥 Export Excel</Btn>
        </div>
      </div>

      {/* Month Picker */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 16, display: "flex", alignItems: "center", gap: 16, flexWrap: "wrap" }}>
        <div>
          <div style={{ color: theme.muted, fontSize: 11, fontWeight: 600, marginBottom: 4 }}>PAYROLL MONTH</div>
          <input type="month" value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)}
            style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.accent, padding: "8px 12px", fontSize: 14, fontWeight: 700, outline: "none" }} />
        </div>
        <div style={{ display: "flex", gap: 12, flexWrap: "wrap" }}>
          {[
            { label: "Total Wages", val: totals.wages, color: theme.blue },
            { label: "Total Payable", val: totals.totalPayable, color: theme.accent },
            { label: "Final Payable", val: totals.finalAmount, color: theme.green },
          ].map(({ label, val, color }) => (
            <div key={label} style={{ background: color + "11", border: `1px solid ${color}33`, borderRadius: 8, padding: "8px 14px" }}>
              <div style={{ color: theme.muted, fontSize: 10, fontWeight: 600 }}>{label}</div>
              <div style={{ color, fontWeight: 900, fontSize: 16 }}>₹{fmt(val)}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Info Banner */}
      <div style={{ background: theme.blue + "11", border: `1px solid ${theme.blue}33`, borderRadius: 10, padding: "10px 16px", marginBottom: 16, display: "flex", alignItems: "center", gap: 10 }}>
        <span>💡</span>
        <span style={{ color: theme.blue, fontSize: 12, fontWeight: 600 }}>Days Payable, Travel & Food auto-fetched from Daily Progress Reports. OT Hrs, Upto 12am, Full Night & Deduction are entered manually.</span>
      </div>

      {/* Payroll Table */}
      <div id="labour-payroll-print">
        <h2 style={{ color: theme.text, margin: "0 0 4px", display: "none" }} className="print-show">PERMATECH CONCRETE SOLUTIONS</h2>
        <div style={{ color: theme.muted, fontSize: 12, marginBottom: 16 }}>
          Labour Payroll — {monthLabel} &nbsp;|&nbsp; {rows.length} labours &nbsp;|&nbsp; Generated: {new Date().toLocaleDateString("en-IN")}
        </div>
        <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 2000 }}>
            <thead>
              <tr>
                <th style={th} rowSpan={2}>SR</th>
                <th style={th} rowSpan={2}>Name</th>
                <th style={th} rowSpan={2}>Work Status</th>
                <th style={th} rowSpan={2}>Mode of Payment</th>
                <th style={th} rowSpan={2}>Per Day ₹</th>
                <th style={th} rowSpan={2}>Basic Salary ₹</th>
                <th style={{ ...th, background: "#1e3a5f" }} colSpan={2}>Regular</th>
                <th style={{ ...th, background: "#1a2f5a" }} colSpan={2}>Overtime</th>
                <th style={{ ...th, background: "#162a50" }} colSpan={2}>Upto 12am</th>
                <th style={{ ...th, background: "#12224a" }} colSpan={2}>Full Night</th>
                <th style={{ ...th, background: "#0f1c40" }} rowSpan={2}>Total Payable ₹</th>
                <th style={{ ...th, background: "#1e3a5f" }} rowSpan={2}>Travel ₹</th>
                <th style={{ ...th, background: "#1e3a5f" }} rowSpan={2}>Breakfast & Dinner ₹</th>
                <th style={{ ...th, background: "#0f1c40" }} rowSpan={2}>Total + Convy ₹</th>
                <th style={{ ...th, background: "#2d1a1a" }} rowSpan={2}>Less Deduction ₹</th>
                <th style={{ ...th, background: "#1a2f1a" }} rowSpan={2}>Final Amount ₹</th>
                <th style={{ ...th, background: "#1a3520" }} rowSpan={2}>Status</th>
              </tr>
              <tr>
                <th style={{ ...th, background: "#1e3a5f", fontSize: 9 }}>Days</th>
                <th style={{ ...th, background: "#1e3a5f", fontSize: 9 }}>Wages ₹</th>
                <th style={{ ...th, background: "#1a2f5a", fontSize: 9 }}>OT Hrs</th>
                <th style={{ ...th, background: "#1a2f5a", fontSize: 9 }}>OT Pay ₹</th>
                <th style={{ ...th, background: "#162a50", fontSize: 9 }}>Days</th>
                <th style={{ ...th, background: "#162a50", fontSize: 9 }}>Wages ₹</th>
                <th style={{ ...th, background: "#12224a", fontSize: 9 }}>Days</th>
                <th style={{ ...th, background: "#12224a", fontSize: 9 }}>Payable ₹</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                  <td style={{ ...td, color: theme.muted, width: 40 }}>{i + 1}</td>
                  <td style={{ ...td, fontWeight: 700, textAlign: "left", paddingLeft: 10, minWidth: 150, color: theme.text }}>{r.name}</td>
                  <td style={{ ...td }}>
                    <span style={{ background: theme.blue + "22", color: theme.blue, borderRadius: 5, padding: "2px 8px", fontSize: 10, fontWeight: 700 }}>Labour</span>
                  </td>
                  {/* Mode of Payment */}
                  <td style={{ ...td, minWidth: 100 }}>
                    <select value={r.modeOfPayment} onChange={e => updateManual(r.id, "modeOfPayment", e.target.value)}
                      style={{ ...inp(r.modeOfPayment === "Bank" ? theme.blue : r.modeOfPayment === "Cash" ? theme.green : theme.muted), cursor: "pointer" }}>
                      <option value="">— Select —</option>
                      <option value="Bank">🏦 Bank</option>
                      <option value="Cash">💵 Cash</option>
                    </select>
                  </td>
                  {/* Per Day */}
                  <td style={{ ...td, color: theme.accent, fontWeight: 700 }}>₹{fmt(r.perDay)}</td>
                  {/* Basic Salary */}
                  <td style={{ ...td, color: theme.blue, fontWeight: 700 }}>₹{fmt(r.basicSalary)}</td>
                  {/* Days Payable — AUTO with manual override */}
<td style={{ ...td, minWidth: 80 }}>
  <input type="number"
    value={manualData[r.id]?.daysPayable !== undefined ? manualData[r.id]?.daysPayable : r.daysPayable}
    onChange={e => updateManual(r.id, "daysPayable", e.target.value)}
    style={{ ...inp(theme.green), fontWeight: 800 }}
    placeholder={String(r.daysPayable)}
  />
  {manualData[r.id]?.daysPayable !== undefined && manualData[r.id]?.daysPayable !== "" && (
    <div style={{ color: theme.muted, fontSize: 9, marginTop: 2 }}>
      auto: {(() => { const { daysPayable: a } = getLabourStats(r.name); return a; })()}
    </div>
  )}
</td>
                  {/* Wages — AUTO */}
                  {autoCell(r.wages, theme.green)}
                  {/* OT Hrs — MANUAL */}
                  <td style={{ ...td, minWidth: 70 }}>
                    <input type="number" value={manualData[r.id]?.otHrs || ""} onChange={e => updateManual(r.id, "otHrs", e.target.value)}
                      style={inp(theme.orange)} placeholder="0" />
                  </td>
                  {/* OT Payable — AUTO */}
                  {autoCell(r.otPayable, theme.orange)}
                  {/* Upto 12am Days — MANUAL */}
                  <td style={{ ...td, minWidth: 70 }}>
                    <input type="number" value={manualData[r.id]?.upto12amDays || ""} onChange={e => updateManual(r.id, "upto12amDays", e.target.value)}
                      style={inp(theme.purple)} placeholder="0" />
                  </td>
                  {/* Upto 12am Wages — AUTO */}
                  {autoCell(r.upto12amWages, theme.purple)}
                  {/* Full Night Days — MANUAL */}
                  <td style={{ ...td, minWidth: 70 }}>
                    <input type="number" value={manualData[r.id]?.fullNightDays || ""} onChange={e => updateManual(r.id, "fullNightDays", e.target.value)}
                      style={inp(theme.blue)} placeholder="0" />
                  </td>
                  {/* Full Night Payable — AUTO */}
                  {autoCell(r.fullNightPayable, theme.blue)}
                  {/* Total Payable — AUTO */}
                  <td style={{ ...td, color: theme.accent, fontWeight: 900, background: theme.accent + "11", fontSize: 13 }}>₹{fmt(r.totalPayable)}</td>
                  {/* Travel — AUTO */}
                  {autoCell(r.travel, theme.orange)}
                  {/* Food — AUTO */}
                  {autoCell(r.food, theme.green)}
                  {/* Total + Convy — AUTO */}
                  <td style={{ ...td, color: theme.blue, fontWeight: 900, background: theme.blue + "11", fontSize: 13 }}>₹{fmt(r.totalWithConvy)}</td>
                  {/* Less Deduction — MANUAL */}
                  <td style={{ ...td, minWidth: 90 }}>
                    <input type="number" value={manualData[r.id]?.lessDeduction || ""} onChange={e => updateManual(r.id, "lessDeduction", e.target.value)}
                      style={inp(theme.red)} placeholder="0" />
                  </td>
                  {/* Final Amount — AUTO */}
                  <td style={{ ...td, color: r.finalAmount >= 0 ? theme.green : theme.red, fontWeight: 900, background: theme.green + "11", fontSize: 13 }}>₹{fmt(r.finalAmount)}</td>
                  <td style={{ ...td, minWidth: 110 }}>
  <select value={r.paidStatus} onChange={e => updateManual(r.id, "paidStatus", e.target.value)}
    style={{ background: r.paidStatus === "Paid" ? theme.green + "22" : r.paidStatus === "Not Paid" ? theme.red + "22" : theme.bg, border: `1px solid ${r.paidStatus === "Paid" ? theme.green : r.paidStatus === "Not Paid" ? theme.red : theme.border}44`, color: r.paidStatus === "Paid" ? theme.green : r.paidStatus === "Not Paid" ? theme.red : theme.muted, borderRadius: 6, padding: "4px 6px", fontSize: 11, fontWeight: 700, cursor: "pointer", width: "100%", outline: "none" }}>
    <option value="">— Status —</option>
    <option value="Paid">✅ Paid</option>
    <option value="Not Paid">❌ Not Paid</option>
  </select>
</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                <td colSpan={5} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 12 }}>GRAND TOTAL</td>
                <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.basicSalary)}</td>
                <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>{totals.daysPayable}</td>
                <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.wages)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                <td style={{ ...td, color: "#FCD34D", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.otPayable)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                <td style={{ ...td, color: "#C4B5FD", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.upto12amWages)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                <td style={{ ...td, color: "#93C5FD", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.fullNightPayable)}</td>
                <td style={{ ...td, color: "#fff", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 13 }}>₹{fmt(totals.totalPayable)}</td>
                <td style={{ ...td, color: "#FCD34D", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.travel)}</td>
                <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.food)}</td>
                <td style={{ ...td, color: "#93C5FD", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 13 }}>₹{fmt(totals.totalWithConvy)}</td>
                <td style={{ ...td, color: "#FCA5A5", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(totals.lessDeduction)}</td>
                <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)", fontSize: 14 }}>₹{fmt(totals.finalAmount)}</td>
                <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}/>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
}

function AttendanceCapture({ currentUser }) {
  const [step, setStep] = useState("idle"); // idle | camera | preview | uploading | done
  const [type, setType] = useState(null); // "entry" | "exit"
  const [stream, setStream] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [error, setError] = useState("");
  const [todayRecord, setTodayRecord] = useState(null);
  const [loading, setLoading] = useState(true);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const today = new Date().toISOString().slice(0, 10);

 useEffect(() => {
  const todayStr = new Date().toISOString().slice(0, 10);
  getDocs(collection(db, "attendance")).then(snap => {
    const records = snap.docs.map(d => d.data());
    const rec = records.find(r => r.userId === currentUser.uid && r.date === todayStr);
    if (rec) setTodayRecord(rec);
  }).finally(() => setLoading(false));
}, [currentUser.uid]);

  const getLocation = () => new Promise((resolve, reject) => {
    if (!navigator.geolocation) { reject("Geolocation not supported"); return; }
    navigator.geolocation.getCurrentPosition(async pos => {
      const { latitude, longitude } = pos.coords;
     
      try {
        const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`);
        const data = await res.json();
        const addr = data.display_name || `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`;
      
        resolve({ latitude, longitude, address: addr });
      } catch {
        const addr = `${latitude.toFixed(4)}, ${longitude.toFixed(4)}`;
        
        resolve({ latitude, longitude, address: addr });
      }
    }, err => reject(err.message), { enableHighAccuracy: true });
  });

  const startCamera = async (attendanceType) => {
    setError("");
    setType(attendanceType);
    try {
      const mediaStream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: "user" }, audio: false });
      setStream(mediaStream);
      setStep("camera");
      setTimeout(() => { if (videoRef.current) videoRef.current.srcObject = mediaStream; }, 100);
    } catch (e) {
      setError("Camera access denied. Please allow camera permission and try again.");
    }
  };

  const stopCamera = () => {
    if (stream) stream.getTracks().forEach(t => t.stop());
    setStream(null);
    setStep("idle");
    setPhoto(null);
  };

  const takeSelfie = () => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    if (!video || !canvas) return;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext("2d").drawImage(video, 0, 0);
    const dataUrl = canvas.toDataURL("image/jpeg", 0.8);
    setPhoto(dataUrl);
    if (stream) stream.getTracks().forEach(t => t.stop());
    setStream(null);
    setStep("preview");
  };

  const retake = () => {
    setPhoto(null);
    startCamera(type);
  };

  const uploadAttendance = async () => {
    setStep("uploading");
    setError("");
    try {
      const loc = await getLocation();
      const now = new Date();
      const timeStr = now.toLocaleTimeString("en-IN", { hour: "2-digit", minute: "2-digit", hour12: true });

      // Upload photo to Firebase Storage
     const photoURL = photo;

      const existingSnap = await getDocs(collection(db, "attendance"));
      const existing = existingSnap.docs.find(d => d.data().userId === currentUser.uid && d.data().date === today);

      const attendanceData = existing ? {
        ...existing.data(),
        [type]: { time: timeStr, photoURL, location: loc },
        updatedAt: now.toISOString(),
      } : {
        id: `${currentUser.uid}_${today}`,
        userId: currentUser.uid,
        userName: currentUser.name,
        userEmail: currentUser.email,
        date: today,
        [type]: { time: timeStr, photoURL, location: loc },
        createdAt: now.toISOString(),
      };

      await setDoc(fsDoc(db, "attendance", `${currentUser.uid}_${today}`), attendanceData);
      setTodayRecord(attendanceData);
      setStep("done");
      setTimeout(() => setStep("idle"), 2000);
    } catch (e) {
      setError("Failed to upload: " + e);
      setStep("preview");
    }
  };

  const cardStyle = { background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 16, padding: 24, marginBottom: 16 };

  if (loading) return <div style={{ color: theme.muted, textAlign: "center", padding: 40 }}>Loading attendance...</div>;

  return (
    <div style={{ maxWidth: 500, margin: "0 auto" }}>
      {/* Today's Status Card */}
      <div style={cardStyle}>
        <div style={{ color: theme.text, fontWeight: 700, fontSize: 16, marginBottom: 16 }}>📅 Today's Attendance — {today}</div>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
          {/* Entry */}
          <div style={{ background: todayRecord?.entry ? theme.green + "11" : theme.bg, border: `1px solid ${todayRecord?.entry ? theme.green + "44" : theme.border}`, borderRadius: 12, padding: 16, textAlign: "center" }}>
            <div style={{ fontSize: 28, marginBottom: 8 }}>🟢</div>
            <div style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>Entry</div>
            {todayRecord?.entry ? (
              <>
                <div style={{ color: theme.green, fontWeight: 800, fontSize: 15, marginTop: 4 }}>{todayRecord.entry.time}</div>
                {todayRecord.entry.photoURL && (
                  <img src={todayRecord.entry.photoURL} alt="entry" style={{ width: 60, height: 60, borderRadius: 30, objectFit: "cover", marginTop: 8, border: `2px solid ${theme.green}` }} />
                )}
                <div style={{ color: theme.green, fontSize: 10, marginTop: 4, fontWeight: 600 }}>✓ Marked</div>
              </>
            ) : (
              <div style={{ color: theme.muted, fontSize: 12, marginTop: 4 }}>Not marked yet</div>
            )}
          </div>

          {/* Exit */}
          <div style={{ background: todayRecord?.exit ? theme.red + "11" : theme.bg, border: `1px solid ${todayRecord?.exit ? theme.red + "44" : theme.border}`, borderRadius: 12, padding: 16, textAlign: "center" }}>
            <div style={{ fontSize: 28, marginBottom: 8 }}>🔴</div>
            <div style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>Exit</div>
            {todayRecord?.exit ? (
              <>
                <div style={{ color: theme.red, fontWeight: 800, fontSize: 15, marginTop: 4 }}>{todayRecord.exit.time}</div>
                {todayRecord.exit.photoURL && (
                  <img src={todayRecord.exit.photoURL} alt="exit" style={{ width: 60, height: 60, borderRadius: 30, objectFit: "cover", marginTop: 8, border: `2px solid ${theme.red}` }} />
                )}
                <div style={{ color: theme.red, fontSize: 10, marginTop: 4, fontWeight: 600 }}>✓ Marked</div>
              </>
            ) : (
              <div style={{ color: theme.muted, fontSize: 12, marginTop: 4 }}>Not marked yet</div>
            )}
          </div>
        </div>
      </div>

      {/* Action Buttons */}
      {step === "idle" && (
        <div style={cardStyle}>
          <div style={{ color: theme.text, fontWeight: 700, fontSize: 14, marginBottom: 16 }}>📸 Mark Attendance</div>
          <div style={{ display: "flex", gap: 12 }}>
            <button onClick={() => startCamera("entry")} disabled={!!todayRecord?.entry}
              style={{ flex: 1, background: todayRecord?.entry ? theme.border : theme.green + "22", border: `1px solid ${todayRecord?.entry ? theme.border : theme.green + "44"}`, color: todayRecord?.entry ? theme.faint : theme.green, borderRadius: 12, padding: "16px 0", fontSize: 14, fontWeight: 700, cursor: todayRecord?.entry ? "not-allowed" : "pointer" }}>
              🟢 Mark Entry
            </button>
            <button onClick={() => startCamera("exit")} disabled={!!todayRecord?.exit || !todayRecord?.entry}
              style={{ flex: 1, background: (todayRecord?.exit || !todayRecord?.entry) ? theme.border : theme.red + "22", border: `1px solid ${(todayRecord?.exit || !todayRecord?.entry) ? theme.border : theme.red + "44"}`, color: (todayRecord?.exit || !todayRecord?.entry) ? theme.faint : theme.red, borderRadius: 12, padding: "16px 0", fontSize: 14, fontWeight: 700, cursor: (todayRecord?.exit || !todayRecord?.entry) ? "not-allowed" : "pointer" }}>
              🔴 Mark Exit
            </button>
          </div>
          {!todayRecord?.entry && <div style={{ color: theme.muted, fontSize: 11, textAlign: "center", marginTop: 8 }}>Mark entry first before marking exit</div>}
        </div>
      )}

      {/* Camera View */}
      {step === "camera" && (
        <div style={cardStyle}>
          <div style={{ color: theme.text, fontWeight: 700, fontSize: 14, marginBottom: 16 }}>
            📷 Take {type === "entry" ? "Entry" : "Exit"} Selfie
          </div>
          <div style={{ position: "relative", borderRadius: 12, overflow: "hidden", background: "#000", marginBottom: 16 }}>
            <video ref={videoRef} autoPlay playsInline muted style={{ width: "100%", display: "block", maxHeight: 360, objectFit: "cover" }} />
            <div style={{ position: "absolute", top: 12, left: 12, background: type === "entry" ? theme.green + "cc" : theme.red + "cc", color: "#fff", borderRadius: 6, padding: "4px 10px", fontSize: 12, fontWeight: 700 }}>
              {type === "entry" ? "🟢 ENTRY" : "🔴 EXIT"}
            </div>
          </div>
          <canvas ref={canvasRef} style={{ display: "none" }} />
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={stopCamera} style={{ flex: 1, background: theme.border, border: "none", borderRadius: 10, padding: "12px 0", color: theme.muted, fontSize: 14, fontWeight: 700, cursor: "pointer" }}>Cancel</button>
            <button onClick={takeSelfie} style={{ flex: 2, background: type === "entry" ? theme.green : theme.red, border: "none", borderRadius: 10, padding: "12px 0", color: "#fff", fontSize: 15, fontWeight: 800, cursor: "pointer" }}>📸 Take Selfie</button>
          </div>
        </div>
      )}

      {/* Preview */}
      {step === "preview" && photo && (
        <div style={cardStyle}>
          <div style={{ color: theme.text, fontWeight: 700, fontSize: 14, marginBottom: 16 }}>✅ Preview Selfie</div>
          <img src={photo} alt="selfie preview" style={{ width: "100%", borderRadius: 12, marginBottom: 16, objectFit: "cover", maxHeight: 360 }} />
          {error && <div style={{ background: theme.red + "11", border: `1px solid ${theme.red}33`, borderRadius: 8, padding: "8px 12px", color: theme.red, fontSize: 12, marginBottom: 12 }}>⚠️ {error}</div>}
          <div style={{ display: "flex", gap: 10 }}>
            <button onClick={retake} style={{ flex: 1, background: theme.border, border: "none", borderRadius: 10, padding: "12px 0", color: theme.text, fontSize: 14, fontWeight: 700, cursor: "pointer" }}>🔄 Retake</button>
            <button onClick={uploadAttendance} style={{ flex: 2, background: type === "entry" ? theme.green : theme.red, border: "none", borderRadius: 10, padding: "12px 0", color: "#fff", fontSize: 14, fontWeight: 800, cursor: "pointer" }}>
              📍 Submit with Location
            </button>
          </div>
        </div>
      )}

      {/* Uploading */}
      {step === "uploading" && (
        <div style={{ ...cardStyle, textAlign: "center", padding: 40 }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>⏳</div>
          <div style={{ color: theme.text, fontWeight: 700, fontSize: 16 }}>Uploading attendance...</div>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 6 }}>Getting your location and saving photo</div>
        </div>
      )}

      {/* Done */}
      {step === "done" && (
        <div style={{ ...cardStyle, textAlign: "center", padding: 40, border: `1px solid ${theme.green}44` }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>✅</div>
          <div style={{ color: theme.green, fontWeight: 800, fontSize: 18 }}>Attendance Marked!</div>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 6 }}>{type === "entry" ? "Entry" : "Exit"} recorded successfully</div>
        </div>
      )}
    </div>
  );
}

function AttendanceDashboard({ currentUser, onlyOwn = false }) {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedMonth, setSelectedMonth] = useState(new Date().toISOString().slice(0, 7));
  const [selectedUser, setSelectedUser] = useState("all");
  const [viewPhoto, setViewPhoto] = useState(null);
  const [users, setUsers] = useState([]);

  useEffect(() => {
  Promise.all([
    getDocs(collection(db, "attendance")),
    getDocs(collection(db, "users")),
  ]).then(([attSnap, userSnap]) => {
    let recs = attSnap.docs.map(d => d.data());
    if (onlyOwn) recs = recs.filter(r => r.userId === currentUser.uid);
    setRecords(recs);
    setUsers(userSnap.docs.map(d => ({ uid: d.id, ...d.data() })).filter(u => u.role === "labour" || u.role === "engineer"));
  }).finally(() => setLoading(false));
}, [currentUser.uid, onlyOwn]);

  const filteredRecords = records
    .filter(r => r.date?.startsWith(selectedMonth))
    .filter(r => selectedUser === "all" || r.userId === selectedUser)
    .sort((a, b) => b.date.localeCompare(a.date));

  const thStyle = { padding: "10px 14px", background: theme.accent + "22", color: theme.accent, fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "left", borderBottom: `2px solid ${theme.accent}`, whiteSpace: "nowrap" };
  const tdStyle = { padding: "10px 14px", borderBottom: `1px solid ${theme.border}`, fontSize: 12, color: theme.text, verticalAlign: "middle" };
  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "7px 10px", fontSize: 12, outline: "none" };

  if (loading) return <div style={{ color: theme.muted, textAlign: "center", padding: 40 }}>Loading attendance records...</div>;

  return (
    <div>
      {/* Stats */}
      <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
        <StatCard label="Total Records" value={filteredRecords.length} color={theme.blue} icon="📋" />
        <StatCard label="Present Today" value={records.filter(r => r.date === new Date().toISOString().slice(0, 10)).length} color={theme.green} icon="✅" />
        <StatCard label="This Month" value={records.filter(r => r.date?.startsWith(selectedMonth)).length} color={theme.accent} icon="📅" />
        <StatCard label="Total Staff" value={users.length} color={theme.purple} icon="👥" />
      </div>

      {/* Filters */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 16, marginBottom: 20, display: "flex", gap: 16, alignItems: "flex-end", flexWrap: "wrap" }}>
        <div>
          <div style={{ color: theme.muted, fontSize: 10, fontWeight: 600, textTransform: "uppercase", marginBottom: 3 }}>Month</div>
          <input type="month" value={selectedMonth} onChange={e => setSelectedMonth(e.target.value)} style={inp} />
        </div>
        {!onlyOwn && (
          <div>
            <div style={{ color: theme.muted, fontSize: 10, fontWeight: 600, textTransform: "uppercase", marginBottom: 3 }}>Staff Member</div>
            <select value={selectedUser} onChange={e => setSelectedUser(e.target.value)} style={{ ...inp, minWidth: 180 }}>
              <option value="all">All Staff</option>
              {users.map(u => <option key={u.uid} value={u.uid}>{u.name}</option>)}
            </select>
          </div>
        )}
      </div>

      {/* Table */}
      {filteredRecords.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 50, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>📭</div>
          <div style={{ color: theme.muted }}>No attendance records found for selected period.</div>
        </div>
      ) : (
        <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1080 }}>
            <thead>
              <tr>
               {["Date", "Name", "Entry Time", "Entry Selfie", "Entry Location", "Exit Time", "Exit Selfie", "Exit Location", "Status", "Action"].map(h => (
  <th key={h} style={thStyle}>{h}</th>
))}
              </tr>
            </thead>
            <tbody>
              {filteredRecords.map((rec, i) => (
                <tr key={rec.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                  <td style={{ ...tdStyle, color: theme.accent, fontWeight: 700, whiteSpace: "nowrap" }}>{rec.date}</td>
                  <td style={{ ...tdStyle, fontWeight: 700 }}>{rec.userName}</td>

                  {/* Entry Time */}
                  <td style={{ ...tdStyle, color: theme.green, fontWeight: 700 }}>{rec.entry?.time || "—"}</td>

                  {/* Entry Selfie */}
                  <td style={tdStyle}>
                    {rec.entry?.photoURL ? (
                      <img src={rec.entry.photoURL} alt="entry" onClick={() => setViewPhoto({ url: rec.entry.photoURL, label: `${rec.userName} — Entry ${rec.date}` })}
                        style={{ width: 40, height: 40, borderRadius: 20, objectFit: "cover", cursor: "pointer", border: `2px solid ${theme.green}` }} />
                    ) : "—"}
                  </td>

                  {/* Entry Location */}
                  <td style={{ ...tdStyle, color: theme.muted, fontSize: 11, maxWidth: 200 }}>
                    {rec.entry?.location?.address ? (
                      <span title={rec.entry.location.address}>{rec.entry.location.address.slice(0, 40)}...</span>
                    ) : "—"}
                  </td>

                  {/* Exit Time */}
                  <td style={{ ...tdStyle, color: theme.red, fontWeight: 700 }}>{rec.exit?.time || "—"}</td>

                  {/* Exit Selfie */}
                  <td style={tdStyle}>
                    {rec.exit?.photoURL ? (
                      <img src={rec.exit.photoURL} alt="exit" onClick={() => setViewPhoto({ url: rec.exit.photoURL, label: `${rec.userName} — Exit ${rec.date}` })}
                        style={{ width: 40, height: 40, borderRadius: 20, objectFit: "cover", cursor: "pointer", border: `2px solid ${theme.red}` }} />
                    ) : "—"}
                  </td>

                  {/* Exit Location */}
                  <td style={{ ...tdStyle, color: theme.muted, fontSize: 11, maxWidth: 200 }}>
                    {rec.exit?.location?.address ? (
                      <span title={rec.exit.location.address}>{rec.exit.location.address.slice(0, 40)}...</span>
                    ) : "—"}
                  </td>

                  {/* Status */}
                  <td style={tdStyle}>
                    {rec.entry && rec.exit ? (
                      <span style={{ background: theme.green + "22", color: theme.green, borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>Full Day</span>
                    ) : rec.entry ? (
                      <span style={{ background: theme.orange + "22", color: theme.orange, borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>Entry Only</span>
                    ) : (
                      <span style={{ background: theme.red + "22", color: theme.red, borderRadius: 5, padding: "2px 8px", fontSize: 11, fontWeight: 700 }}>Absent</span>
                    )}
                  </td>
                  <td style={tdStyle}>
                    <Btn small variant="danger" onClick={async () => {
                      if (!window.confirm(`Delete attendance for ${rec.userName} on ${rec.date}?`)) return;
                      const updated = records.filter(r => r.id !== rec.id);
                      setRecords(updated);
                      try { await deleteDoc(fsDoc(db, "attendance", `${rec.userId}_${rec.date}`)); }
                      catch (e) { console.error(e); }
                    }}>🗑</Btn>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Photo Viewer Modal */}
      {viewPhoto && (
        <div style={{ position: "fixed", inset: 0, background: "#000d", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
          onClick={() => setViewPhoto(null)}>
          <div style={{ background: theme.bg, borderRadius: 16, padding: 20, maxWidth: 500, width: "100%" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 12 }}>
              <div style={{ color: theme.text, fontWeight: 700, fontSize: 14 }}>{viewPhoto.label}</div>
              <Btn small variant="ghost" onClick={() => setViewPhoto(null)}>✕ Close</Btn>
            </div>
            <img src={viewPhoto.url} alt="selfie" style={{ width: "100%", borderRadius: 12, objectFit: "cover" }} />
          </div>
        </div>
      )}
    </div>
  );
}

function DirectImportModule() {
  const [sheets, setSheets] = useState([]);
  const [mode, setMode] = useState("list");
  const [activeSheet, setActiveSheet] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDocs(collection(db, "import_sheets")).then(snap => {
      const data = snap.docs.map((d, i) => ({
  ...d.data(),
  labourId: d.data().labourId || `LBR${String(i + 1).padStart(3, "0")}`,
  documents: d.data().documents || {},
}));
      if (data.length > 0) setSheets(data);
      else {
        const ls = localStorage.getItem("importSheets");
        if (ls) setSheets(JSON.parse(ls));
      }
    }).catch(() => {
      const ls = localStorage.getItem("importSheets");
      if (ls) setSheets(JSON.parse(ls));
    }).finally(() => setLoading(false));
  }, []);

  const saveSheet = async (sheet) => {
    const isEdit = sheets.find(s => s.id === sheet.id);
    const updated = isEdit ? sheets.map(s => s.id === sheet.id ? sheet : s) : [sheet, ...sheets];
    setSheets(updated);
    localStorage.setItem("importSheets", JSON.stringify(updated));
    try { await setDoc(fsDoc(db, "import_sheets", String(sheet.id)), sheet); }
    catch (e) { console.error(e); }
  };

  const deleteSheet = async (id) => {
    if (!window.confirm("Delete this import sheet? This cannot be undone.")) return;
    const updated = sheets.filter(s => s.id !== id);
    setSheets(updated);
    localStorage.setItem("importSheets", JSON.stringify(updated));
    try { await deleteDoc(fsDoc(db, "import_sheets", String(id))); }
    catch (e) { console.error(e); }
  };

  if (loading) return <div style={{ color: theme.muted, textAlign: "center", padding: 40 }}>Loading...</div>;

  if (mode === "create" || mode === "edit") {
    return <ImportSheetForm
      existing={activeSheet}
      onSave={sheet => { saveSheet(sheet); setMode("list"); setActiveSheet(null); }}
      onBack={() => { setMode("list"); setActiveSheet(null); }}
    />;
  }

  if (mode === "view" && activeSheet) {
    return <ImportSheetPreview
      sheet={activeSheet}
      onClose={() => { setMode("list"); setActiveSheet(null); }}
      onEdit={() => setMode("edit")}
    />;
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Stock Inventory</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📋 Product Costing Sheet</h2>
          <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>{sheets.length} sheet{sheets.length !== 1 ? "s" : ""} saved</div>
        </div>
        <Btn onClick={() => { setActiveSheet(null); setMode("create"); }}>+ New Import Sheet</Btn>
      </div>

      {sheets.length === 0 ? (
        <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 60, textAlign: "center" }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>📋</div>
          <div style={{ color: theme.text, fontWeight: 800, fontSize: 18, marginBottom: 8 }}>No Import Sheets Yet</div>
          <div style={{ color: theme.muted, fontSize: 13, marginBottom: 16 }}>Create your first direct import costing sheet</div>
          <Btn onClick={() => setMode("create")}>+ Create Sheet</Btn>
        </div>
      ) : (
        <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
          {sheets.map((s, i) => (
            <div key={s.id} style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: "16px 20px", display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 10 }}>
              <div>
                <div style={{ color: theme.text, fontWeight: 800, fontSize: 15 }}>📋 {s.refNo || `Sheet ${i + 1}`} — {s.itemName || "—"}</div>
                <div style={{ color: theme.muted, fontSize: 12, marginTop: 3 }}>
                  Date: {s.date || "—"} ·
                  Landed Cost/Unit: <span style={{ color: theme.accent, fontWeight: 700 }}>₹{(s.landedCostPerUnit || 0).toLocaleString("en-IN")}</span>
                </div>
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <Btn small variant="ghost" onClick={() => { setActiveSheet(s); setMode("view"); }}>👁 View</Btn>
                <Btn small variant="ghost" onClick={() => { setActiveSheet(s); setMode("edit"); }}>✏️ Edit</Btn>
                <Btn small variant="danger" onClick={() => deleteSheet(s.id)}>🗑</Btn>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

function ImportSheetForm({ existing, onSave, onBack }) {
  const [refNo, setRefNo] = useState(existing?.refNo || "");
  const [date, setDate] = useState(existing?.date || new Date().toISOString().slice(0, 10));
  const [itemName, setItemName] = useState(existing?.itemName || "");
  const [qty, setQty] = useState(existing?.qty || "");
  const [packing, setPacking] = useState(existing?.packing || "");
  const [unit, setUnit] = useState(existing?.unit || "Ltr");
  const [unitRate, setUnitRate] = useState(existing?.unitRate || "");
  const [currency, setCurrency] = useState(existing?.currency || "Euro");
  const [deliveryCost, setDeliveryCost] = useState(existing?.deliveryCost || "");
  const [conversionDate, setConversionDate] = useState(existing?.conversionDate || "");
  const [conversionRate, setConversionRate] = useState(existing?.conversionRate || "");
  const [bcdPct, setBcdPct] = useState(existing?.bcdPct || 7.5);
  const [swsPct, setSwsPct] = useState(existing?.swsPct || 10);
  const [igstPct, setIgstPct] = useState(existing?.igstPct || 18);
  const [mscCharges, setMscCharges] = useState(existing?.mscCharges || "");
  const [officeExp, setOfficeExp] = useState(existing?.officeExp || "");
  const [clearingForwarding, setClearingForwarding] = useState(existing?.clearingForwarding || "");

  // Auto calculations
  const amount = Math.round((Number(qty) || 0) * (Number(unitRate) || 0) * 100) / 100;
  const totalForeign = Math.round((amount + (Number(deliveryCost) || 0)) * 100) / 100;
  const inrValue = Math.round(totalForeign * (Number(conversionRate) || 0) * 100) / 100;
  const bcdAmount = Math.round(inrValue * (Number(bcdPct) || 0) / 100 * 100) / 100;
  const swsAmount = Math.round(bcdAmount * (Number(swsPct) || 0) / 100 * 100) / 100;
  const igstBase = Math.round((inrValue + bcdAmount + swsAmount) * 100) / 100;
  const igstAmount = Math.round(igstBase * (Number(igstPct) || 0) / 100 * 100) / 100;
  const customDutyTotal = Math.round((bcdAmount + swsAmount + igstAmount) * 100) / 100;
  const landedCostPort = Math.round((inrValue + customDutyTotal) * 100) / 100;
  const totalCost = Math.round((landedCostPort + (Number(mscCharges) || 0) + (Number(officeExp) || 0) + (Number(clearingForwarding) || 0)) * 100) / 100;
  const landedCostPerUnit = (Number(qty) || 0) > 0 ? Math.round(totalCost / (Number(qty) || 1) * 100) / 100 : 0;

  const handleSave = () => {
    if (!refNo.trim() || !itemName.trim()) { alert("Please enter Reference No and Item Name."); return; }
    onSave({
      id: existing?.id || Date.now(),
      refNo, date, itemName, qty, packing, unit, unitRate, currency,
      deliveryCost, conversionDate, conversionRate,
      bcdPct, swsPct, igstPct,
      mscCharges, officeExp, clearingForwarding,
      amount, totalForeign, inrValue, bcdAmount, swsAmount, igstAmount,
      customDutyTotal, landedCostPort, totalCost, landedCostPerUnit,
      createdAt: existing?.createdAt || new Date().toISOString(),
      updatedAt: new Date().toISOString(),
    });
  };

  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 6, color: theme.text, padding: "6px 8px", fontSize: 12, outline: "none", boxSizing: "border-box" };
  const inpFull = { ...inp, width: "100%" };
  const lbl = { color: theme.muted, fontSize: 12, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.5, display: "block", marginBottom: 4 };

  const ROW = (label, unit2, value, isInput = false, inputVal, onChangeFn, inputColor = theme.accent, type = "number") => (
    <tr style={{ borderBottom: `1px solid ${theme.border}` }}>
      <td style={{ padding: "10px 14px", color: theme.text, fontWeight: 600, fontSize: 13 }}>{label}</td>
      <td style={{ padding: "10px 14px", color: theme.muted, fontSize: 12, width: 100 }}>{unit2}</td>
      <td style={{ padding: "10px 14px", textAlign: "right", fontWeight: 700 }}>
        {isInput ? (
          <input type={type} value={inputVal} onChange={e => onChangeFn(e.target.value)}
            style={{ ...inp, width: 160, textAlign: "right", color: inputColor }} placeholder="0" />
        ) : (
          <span style={{ color: inputColor, fontWeight: 700 }}>{value}</span>
        )}
      </td>
    </tr>
  );

  const DIVIDER = (label, color = theme.accent) => (
    <tr>
      <td colSpan={3} style={{ padding: "6px 14px", background: color + "22", color, fontWeight: 800, fontSize: 11, textTransform: "uppercase", letterSpacing: 1 }}>{label}</td>
    </tr>
  );

  const PCT_ROW = (label, pctVal, setPctFn, amount2, color) => (
    <tr style={{ borderBottom: `1px solid ${theme.border}` }}>
      <td style={{ padding: "10px 14px", color: theme.text, fontWeight: 600, fontSize: 13 }}>{label}</td>
      <td style={{ padding: "10px 14px" }}>
        <input type="number" value={pctVal} onChange={e => setPctFn(e.target.value)}
          style={{ ...inp, width: 70, color, textAlign: "center" }} />
        <span style={{ color: theme.muted, fontSize: 11, marginLeft: 4 }}>%</span>
      </td>
      <td style={{ padding: "10px 14px", textAlign: "right", color, fontWeight: 700 }}>
        {amount2.toLocaleString("en-IN", { minimumFractionDigits: 2 })}
      </td>
    </tr>
  );

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <button onClick={onBack} style={{ background: "none", border: "none", color: theme.muted, cursor: "pointer", fontSize: 13, marginBottom: 8, padding: 0 }}>← Back to Sheets</button>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📋 {existing ? "Edit Product Costing Sheet" : "New Product Costing Sheet"}</h2>
        </div>
        <Btn onClick={handleSave}>💾 Save Sheet</Btn>
      </div>

      {/* Header */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 20, marginBottom: 16 }}>
        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr 1fr", gap: 12, marginBottom: 12 }}>
          <div><label style={lbl}>Reference No</label><input value={refNo} onChange={e => setRefNo(e.target.value)} style={inpFull} placeholder="e.g. RE193899" /></div>
          <div><label style={lbl}>Date</label><input type="date" value={date} onChange={e => setDate(e.target.value)} style={inpFull} /></div>
          <div><label style={lbl}>Currency</label><input value={currency} onChange={e => setCurrency(e.target.value)} style={inpFull} placeholder="e.g. Euro" /></div>
        </div>
        <div><label style={lbl}>Item Name</label><input value={itemName} onChange={e => setItemName(e.target.value)} style={inpFull} placeholder="e.g. IPANEX Waterproofing liquid admix" /></div>
      </div>

      {/* Main Table */}
      <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: theme.accent + "22", borderBottom: `2px solid ${theme.accent}` }}>
              <th style={{ padding: "10px 14px", color: theme.accent, fontSize: 11, fontWeight: 800, textTransform: "uppercase", textAlign: "left" }}>Particulars</th>
              <th style={{ padding: "10px 14px", color: theme.accent, fontSize: 11, fontWeight: 800, textTransform: "uppercase", textAlign: "left" }}>Unit</th>
              <th style={{ padding: "10px 14px", color: theme.accent, fontSize: 11, fontWeight: 800, textTransform: "uppercase", textAlign: "right" }}>Value</th>
            </tr>
          </thead>
          <tbody>
            {DIVIDER("Basic Details", theme.blue)}
            <tr style={{ borderBottom: `1px solid ${theme.border}` }}>
              <td style={{ padding: "10px 14px", color: theme.text, fontWeight: 600, fontSize: 13 }}>Qty</td>
              <td style={{ padding: "10px 14px" }}>
                <input value={unit} onChange={e => setUnit(e.target.value)} style={{ ...inp, width: 70, color: theme.muted }} placeholder="Ltr" />
              </td>
              <td style={{ padding: "10px 14px", textAlign: "right" }}>
                <input type="number" value={qty} onChange={e => setQty(e.target.value)} style={{ ...inp, width: 160, textAlign: "right", color: theme.blue }} placeholder="0" />
              </td>
            </tr>
            {ROW("Packing", unit, packing, true, packing, setPacking, theme.muted, "text")}
            {ROW("Unit Rate", unit, unitRate, true, unitRate, setUnitRate, theme.accent)}
            {DIVIDER("Amount & Delivery", theme.green)}
            <tr style={{ borderBottom: `1px solid ${theme.border}`, background: theme.green + "08" }}>
              <td style={{ padding: "10px 14px", color: theme.green, fontWeight: 700, fontSize: 13 }}>Amount</td>
              <td style={{ padding: "10px 14px", color: theme.muted, fontSize: 12 }}>{currency}</td>
              <td style={{ padding: "10px 14px", textAlign: "right", color: theme.green, fontWeight: 800 }}>{amount.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
            {ROW("Cost of Delivery", currency, deliveryCost, true, deliveryCost, setDeliveryCost, theme.orange)}
            <tr style={{ borderBottom: `1px solid ${theme.border}`, background: theme.accent + "08" }}>
              <td style={{ padding: "10px 14px", color: theme.accent, fontWeight: 800, fontSize: 13 }}>Total</td>
              <td style={{ padding: "10px 14px", color: theme.muted, fontSize: 12 }}>{currency}</td>
              <td style={{ padding: "10px 14px", textAlign: "right", color: theme.accent, fontWeight: 900, fontSize: 15 }}>{totalForeign.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>

            {DIVIDER("Currency Conversion", theme.purple)}
            <tr style={{ borderBottom: `1px solid ${theme.border}` }}>
              <td style={{ padding: "10px 14px", color: theme.text, fontWeight: 600, fontSize: 13 }}>Conversion Date</td>
              <td style={{ padding: "10px 14px" }} />
              <td style={{ padding: "10px 14px", textAlign: "right" }}>
                <input type="date" value={conversionDate} onChange={e => setConversionDate(e.target.value)} style={{ ...inp, width: 160 }} />
              </td>
            </tr>
            <tr style={{ borderBottom: `1px solid ${theme.border}` }}>
              <td style={{ padding: "10px 14px", color: theme.text, fontWeight: 600, fontSize: 13 }}>{currency} 1 = INR</td>
              <td style={{ padding: "10px 14px", color: theme.muted, fontSize: 12 }}>INR</td>
              <td style={{ padding: "10px 14px", textAlign: "right" }}>
                <input type="number" value={conversionRate} onChange={e => setConversionRate(e.target.value)} style={{ ...inp, width: 160, textAlign: "right", color: theme.purple }} placeholder="0.00" />
              </td>
            </tr>
            <tr style={{ borderBottom: `1px solid ${theme.border}`, background: theme.purple + "08" }}>
              <td style={{ padding: "10px 14px", color: theme.purple, fontWeight: 800 }}>INR Value</td>
              <td style={{ padding: "10px 14px", color: theme.muted, fontSize: 12 }}>INR</td>
              <td style={{ padding: "10px 14px", textAlign: "right", color: theme.purple, fontWeight: 900, fontSize: 15 }}>{inrValue.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>

            {DIVIDER("Customs Duty", theme.red)}
            {PCT_ROW("(i) Basic Customs Duty (BCD)", bcdPct, setBcdPct, bcdAmount, theme.red)}
            {PCT_ROW("(ii) Social Welfare Surcharge (SWS)", swsPct, setSwsPct, swsAmount, theme.orange)}
            <tr style={{ borderBottom: `1px solid ${theme.border}`, background: theme.accent + "08" }}>
  <td colSpan={2} style={{ padding: "10px 14px", color: theme.accent, fontWeight: 800, fontSize: 13 }}>Total (INR Value + BCD + SWS)</td>
  <td style={{ padding: "10px 14px", textAlign: "right", color: theme.accent, fontWeight: 900, fontSize: 15 }}>{igstBase.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
</tr>
{PCT_ROW("IGST", igstPct, setIgstPct, igstAmount, theme.blue)}
            <tr style={{ borderBottom: `1px solid ${theme.border}`, background: theme.red + "08" }}>
              <td colSpan={2} style={{ padding: "10px 14px", color: theme.red, fontWeight: 800, fontSize: 13 }}>Custom Duty Charges</td>
              <td style={{ padding: "10px 14px", textAlign: "right", color: theme.red, fontWeight: 900, fontSize: 15 }}>{customDutyTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>

            {DIVIDER("Landing & Additional Charges", theme.green)}
            <tr style={{ borderBottom: `1px solid ${theme.border}`, background: theme.green + "08" }}>
              <td style={{ padding: "10px 14px", color: theme.green, fontWeight: 800 }}>Landed Cost at Port</td>
              <td style={{ padding: "10px 14px", color: theme.muted, fontSize: 12 }}>INR</td>
              <td style={{ padding: "10px 14px", textAlign: "right", color: theme.green, fontWeight: 900, fontSize: 15 }}>{landedCostPort.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
            {ROW("MSC Agency Charges (DO)", "INR", mscCharges, true, mscCharges, setMscCharges, theme.muted)}
            {ROW("Office Exp / Labour & Transport", "INR", officeExp, true, officeExp, setOfficeExp, theme.muted)}
            {ROW("Clearing, Forwarding & Misc", "INR", clearingForwarding, true, clearingForwarding, setClearingForwarding, theme.muted)}

            {DIVIDER("Final Cost Summary", theme.accent)}
            <tr style={{ background: theme.accent + "11", borderBottom: `2px solid ${theme.accent}` }}>
              <td colSpan={2} style={{ padding: "12px 14px", color: theme.accent, fontWeight: 900, fontSize: 14 }}>Total Cost</td>
              <td style={{ padding: "12px 14px", textAlign: "right", color: theme.accent, fontWeight: 900, fontSize: 18 }}>₹{totalCost.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
            <tr style={{ background: theme.blue + "11" }}>
              <td colSpan={2} style={{ padding: "12px 14px", color: theme.blue, fontWeight: 900, fontSize: 14 }}>Landed Cost of Material at Godown (per {unit})</td>
              <td style={{ padding: "12px 14px", textAlign: "right", color: theme.blue, fontWeight: 900, fontSize: 18 }}>₹{landedCostPerUnit.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

function ImportSheetPreview({ sheet, onClose, onEdit }) {
  const amount = Math.round((Number(sheet.qty) || 0) * (Number(sheet.unitRate) || 0) * 100) / 100;
  const totalForeign = Math.round((amount + (Number(sheet.deliveryCost) || 0)) * 100) / 100;
  const inrValue = Math.round(totalForeign * (Number(sheet.conversionRate) || 0) * 100) / 100;
  const bcdAmount = Math.round(inrValue * (Number(sheet.bcdPct) || 0) / 100 * 100) / 100;
  const swsAmount = Math.round(bcdAmount * (Number(sheet.swsPct) || 0) / 100 * 100) / 100;
  const igstBase = Math.round((inrValue + bcdAmount + swsAmount) * 100) / 100;
  const igstAmount = Math.round(igstBase * (Number(sheet.igstPct) || 0) / 100 * 100) / 100;
  const customDutyTotal = Math.round((bcdAmount + swsAmount + igstAmount) * 100) / 100;
  const landedCostPort = Math.round((inrValue + customDutyTotal) * 100) / 100;
  const totalCost = Math.round((landedCostPort + (Number(sheet.mscCharges) || 0) + (Number(sheet.officeExp) || 0) + (Number(sheet.clearingForwarding) || 0)) * 100) / 100;
  const landedCostPerUnit = (Number(sheet.qty) || 0) > 0 ? Math.round(totalCost / (Number(sheet.qty) || 1) * 100) / 100 : 0;

  const ROW = (label, unit, value, color = "#374151", bold = false) => (
    <tr style={{ borderBottom: "1px solid #e5e7eb" }}>
      <td style={{ padding: "8px 14px", color: "#374151", fontWeight: bold ? 700 : 500, fontSize: 13 }}>{label}</td>
      <td style={{ padding: "8px 14px", color: "#9ca3af", fontSize: 12 }}>{unit}</td>
      <td style={{ padding: "8px 14px", textAlign: "right", color, fontWeight: bold ? 800 : 600, fontSize: bold ? 14 : 13 }}>{value}</td>
    </tr>
  );

  const DIVIDER = (label, bg, color) => (
    <tr>
      <td colSpan={3} style={{ padding: "6px 14px", background: bg, color, fontWeight: 800, fontSize: 11, textTransform: "uppercase", letterSpacing: 1 }}>{label}</td>
    </tr>
  );

  return (
    <div>
      <style>{`
        @media print {
          body * { visibility: hidden !important; }
          #import-print-area, #import-print-area * { visibility: visible !important; }
          #import-print-area { position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; background: white !important; padding: 20px !important; }
          .no-print { display: none !important; }
        }
      `}</style>

      <div className="no-print" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 20 }}>
        <button onClick={onClose} style={{ background: "none", border: "none", color: theme.muted, cursor: "pointer", fontSize: 13, padding: 0 }}>← Back to Sheets</button>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn variant="ghost" onClick={onEdit}>✏️ Edit</Btn>
          <Btn variant="blue" onClick={() => window.print()}>🖨 Print / PDF</Btn>
        </div>
      </div>

      <div id="import-print-area" style={{ background: "#fff", color: "#000", padding: 24, borderRadius: 12, border: `1px solid ${theme.border}` }}>
        {/* Header */}
        <div style={{ borderBottom: "2px solid #1a365d", paddingBottom: 12, marginBottom: 16 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ fontSize: 16, fontWeight: 900, color: "#1a365d" }}>Direct Import Costing Sheet</div>
            <div style={{ fontSize: 13, color: "#6b7280" }}>{sheet.date}</div>
          </div>
          <div style={{ display: "flex", gap: 20, marginTop: 8 }}>
            <div><span style={{ color: "#6b7280", fontSize: 12 }}>Ref: </span><span style={{ color: "#1a365d", fontWeight: 700, fontSize: 13 }}>{sheet.refNo}</span></div>
            <div><span style={{ color: "#6b7280", fontSize: 12 }}>Item: </span><span style={{ color: "#1a365d", fontWeight: 700, fontSize: 13 }}>{sheet.itemName}</span></div>
          </div>
        </div>

        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#dbeafe", borderBottom: "2px solid #1d4ed8" }}>
              <th style={{ padding: "8px 14px", color: "#1d4ed8", fontSize: 11, fontWeight: 800, textAlign: "left", textTransform: "uppercase" }}>Particulars</th>
              <th style={{ padding: "8px 14px", color: "#1d4ed8", fontSize: 11, fontWeight: 800, textAlign: "left", textTransform: "uppercase" }}>Unit</th>
              <th style={{ padding: "8px 14px", color: "#1d4ed8", fontSize: 11, fontWeight: 800, textAlign: "right", textTransform: "uppercase" }}>Value</th>
            </tr>
          </thead>
          <tbody>
            {DIVIDER("Basic Details", "#eff6ff", "#1d4ed8")}
            {ROW("Qty", sheet.unit, Number(sheet.qty).toLocaleString("en-IN"))}
            {ROW("Packing", sheet.unit, sheet.packing)}
            {ROW("Unit Rate", sheet.unit, Number(sheet.unitRate).toLocaleString("en-IN", { minimumFractionDigits: 2 }))}
            {DIVIDER("Amount & Delivery", "#f0fdf4", "#059669")}
            {ROW("Amount", sheet.currency, amount.toLocaleString("en-IN", { minimumFractionDigits: 2 }), "#059669", true)}
            {ROW("Cost of Delivery", sheet.currency, Number(sheet.deliveryCost).toLocaleString("en-IN", { minimumFractionDigits: 2 }), "#ea580c")}
            {ROW("Total", sheet.currency, totalForeign.toLocaleString("en-IN", { minimumFractionDigits: 2 }), "#1d4ed8", true)}
            {DIVIDER("Currency Conversion", "#faf5ff", "#7c3aed")}
            {ROW("Conversion Date", "", sheet.conversionDate)}
            {ROW(`${sheet.currency} 1 = INR`, "INR", Number(sheet.conversionRate).toLocaleString("en-IN", { minimumFractionDigits: 2 }), "#7c3aed")}
            {ROW("INR Value", "INR", inrValue.toLocaleString("en-IN", { minimumFractionDigits: 2 }), "#7c3aed", true)}
            {DIVIDER("Customs Duty", "#fef2f2", "#dc2626")}
            {ROW(`(i) Basic Customs Duty (BCD) ${sheet.bcdPct}%`, "INR", bcdAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 }), "#dc2626")}
            {ROW(`(ii) Social Welfare Surcharge ${sheet.swsPct}%`, "INR", swsAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 }), "#ea580c")}
            {ROW("Total (INR Value + BCD + SWS)", "INR", igstBase.toLocaleString("en-IN", { minimumFractionDigits: 2 }), "#1d4ed8", true)}
{ROW(`IGST ${sheet.igstPct}%`, "INR", igstAmount.toLocaleString("en-IN", { minimumFractionDigits: 2 }), "#2563eb")}
            {ROW("Custom Duty Charges", "INR", customDutyTotal.toLocaleString("en-IN", { minimumFractionDigits: 2 }), "#dc2626", true)}
            {DIVIDER("Landing & Additional Charges", "#f0fdf4", "#059669")}
            {ROW("Landed Cost at Port", "INR", landedCostPort.toLocaleString("en-IN", { minimumFractionDigits: 2 }), "#059669", true)}
            {ROW("MSC Agency Charges (DO)", "INR", Number(sheet.mscCharges || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 }))}
            {ROW("Office Exp / Labour & Transport", "INR", Number(sheet.officeExp || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 }))}
            {ROW("Clearing, Forwarding & Misc", "INR", Number(sheet.clearingForwarding || 0).toLocaleString("en-IN", { minimumFractionDigits: 2 }))}
            {DIVIDER("Final Cost Summary", "#eff6ff", "#1d4ed8")}
            <tr style={{ background: "#dbeafe", borderBottom: "2px solid #1d4ed8" }}>
              <td colSpan={2} style={{ padding: "10px 14px", color: "#1d4ed8", fontWeight: 900, fontSize: 14 }}>Total Cost</td>
              <td style={{ padding: "10px 14px", textAlign: "right", color: "#1d4ed8", fontWeight: 900, fontSize: 18 }}>₹{totalCost.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
            <tr style={{ background: "#eff6ff" }}>
              <td colSpan={2} style={{ padding: "10px 14px", color: "#1a365d", fontWeight: 900, fontSize: 14 }}>Landed Cost of Material at Godown (per {sheet.unit})</td>
              <td style={{ padding: "10px 14px", textAlign: "right", color: "#1a365d", fontWeight: 900, fontSize: 18 }}>₹{landedCostPerUnit.toLocaleString("en-IN", { minimumFractionDigits: 2 })}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

const REQUIRED_DOCS = [
  { key: "billOfLading", label: "Container → Bill of Lading" },
  { key: "packingList", label: "Packing List (with pallet nos)" },
  { key: "mtc", label: "MTC" },
  { key: "batchCertificate", label: "Batch Certificate" },
  { key: "other", label: "Other" },
  { key: "invoiceMaterial", label: "Invoice of Material" },
];

function ShipmentDocuments() {
  const [shipments, setShipments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeShipment, setActiveShipment] = useState(null);
  const [viewDoc, setViewDoc] = useState(null);

  useEffect(() => {
  getDocs(collection(db, "shipment_documents")).then(snap => {
    const data = snap.docs.map(d => d.data());
    if (data.length > 0) {
      // Merge localStorage doc data back into shipments
      const merged = data.map(s => {
        const lsKey = `shipment_docs_${s.id}`;
        const lsDocs = JSON.parse(localStorage.getItem(lsKey) || "{}");
        const mergedDocs = {};
        Object.keys({ ...s.docs, ...lsDocs }).forEach(k => {
          mergedDocs[k] = lsDocs[k] || s.docs?.[k] || null;
        });
        return { ...s, docs: mergedDocs };
      });
      setShipments(merged);
      setActiveShipment(merged[0].id);
    } else {
      const ls = localStorage.getItem("shipment_documents");
      if (ls) {
        const parsed = JSON.parse(ls);
        setShipments(parsed);
        if (parsed.length > 0) setActiveShipment(parsed[0].id);
      }
    }
  }).catch(() => {
    const ls = localStorage.getItem("shipment_documents");
    if (ls) {
      const parsed = JSON.parse(ls);
      setShipments(parsed);
      if (parsed.length > 0) setActiveShipment(parsed[0].id);
    }
  }).finally(() => setLoading(false));
}, []);

  const saveShipments = async (updated) => {
    setShipments(updated);
    for (const s of updated) {
      try { await setDoc(fsDoc(db, "shipment_documents", String(s.id)), s); }
      catch (e) { console.error(e); }
    }
  };

  const addShipment = () => {
    const newId = Date.now();
    const newShipment = {
      id: newId,
      name: `Shipment ${shipments.length + 1}`,
      createdAt: new Date().toISOString(),
      docs: {}
    };
    const updated = [...shipments, newShipment];
    saveShipments(updated);
    setActiveShipment(newId);
  };

  const deleteShipment = async (id) => {
    if (!window.confirm("Delete this shipment and all its documents?")) return;
    const updated = shipments.filter(s => s.id !== id);
    setShipments(updated);
    if (activeShipment === id) setActiveShipment(updated[0]?.id || null);
    try { await deleteDoc(fsDoc(db, "shipment_documents", String(id))); }
    catch (e) { console.error(e); }
  };

 const uploadDoc = (shipmentId, docKey, file) => {
  if (!file) return;
  const reader = new FileReader();
  reader.onload = (ev) => {
    const docData = {
      data: ev.target.result,
      name: file.name,
      type: file.type,
      uploadedAt: new Date().toISOString()
    };
    // Use functional setState to avoid stale closure
    setShipments(prev => {
      const updated = prev.map(s => s.id === shipmentId ? {
        ...s,
        docs: { ...s.docs, [docKey]: docData }
      } : s);
      // Save metadata only to Firestore (no base64 — too large)
      // Save full data to localStorage
      const lsKey = `shipment_docs_${shipmentId}`;
      const existing = JSON.parse(localStorage.getItem(lsKey) || "{}");
      existing[docKey] = docData;
      localStorage.setItem(lsKey, JSON.stringify(existing));
      // Save only metadata (no base64) to Firestore
      const metaOnly = updated.map(s => ({
        ...s,
        docs: Object.fromEntries(
          Object.entries(s.docs || {}).map(([k, v]) => [
            k, v ? { name: v.name, type: v.type, uploadedAt: v.uploadedAt, hasData: true } : null
          ])
        )
      }));
      metaOnly.forEach(s => {
        setDoc(fsDoc(db, "shipment_documents", String(s.id)), s).catch(console.error);
      });
      return updated;
    });
  };
  reader.onerror = () => alert("Failed to read file. Please try again.");
  reader.readAsDataURL(file);
};
  const removeDoc = async (shipmentId, docKey) => {
  if (!window.confirm("Remove this document?")) return;
  const lsKey = `shipment_docs_${shipmentId}`;
  const lsDocs = JSON.parse(localStorage.getItem(lsKey) || "{}");
  delete lsDocs[docKey];
  localStorage.setItem(lsKey, JSON.stringify(lsDocs));
  const updated = shipments.map(s => s.id === shipmentId ? {
    ...s, docs: { ...s.docs, [docKey]: null }
  } : s);
  await saveShipments(updated);
};

  const renameShipment = (id, name) => {
    const updated = shipments.map(s => s.id === id ? { ...s, name } : s);
    saveShipments(updated);
  };

  if (loading) return <div style={{ color: theme.muted, padding: 20 }}>Loading shipment documents...</div>;

  const currentShipment = shipments.find(s => s.id === activeShipment);
  const getDocStatus = (shipment) => {
    const uploaded = REQUIRED_DOCS.filter(d => shipment.docs?.[d.key]).length;
    return { uploaded, total: REQUIRED_DOCS.length, complete: uploaded === REQUIRED_DOCS.length };
  };

  return (
    <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, padding: 20, marginBottom: 20 }}>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
        <div>
          <div style={{ color: theme.accent, fontWeight: 800, fontSize: 15 }}>📁 Shipment Documents</div>
          <div style={{ color: theme.muted, fontSize: 12, marginTop: 2 }}>{shipments.length} shipment{shipments.length !== 1 ? "s" : ""}</div>
        </div>
        <Btn small onClick={addShipment}>+ Add Shipment</Btn>
      </div>

      {shipments.length === 0 ? (
        <div style={{ background: theme.bg, border: `1px dashed ${theme.border}`, borderRadius: 10, padding: 40, textAlign: "center" }}>
          <div style={{ fontSize: 36, marginBottom: 10 }}>📦</div>
          <div style={{ color: theme.muted, fontSize: 13 }}>No shipments yet. Click "+ Add Shipment" to start.</div>
        </div>
      ) : (
        <div style={{ display: "flex", gap: 16 }}>
          {/* Shipment List */}
          <div style={{ width: 200, flexShrink: 0 }}>
            {shipments.map(s => {
              const status = getDocStatus(s);
              const isActive = activeShipment === s.id;
              return (
                <div key={s.id} onClick={() => setActiveShipment(s.id)}
                  style={{ background: isActive ? theme.accent + "22" : theme.bg, border: `1px solid ${isActive ? theme.accent : theme.border}`, borderRadius: 8, padding: "10px 12px", marginBottom: 8, cursor: "pointer", position: "relative" }}>
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start" }}>
                    <div style={{ color: isActive ? theme.accent : theme.text, fontWeight: 700, fontSize: 13, flex: 1, marginRight: 4 }}>{s.name}</div>
                    <button onClick={e => { e.stopPropagation(); deleteShipment(s.id); }}
                      style={{ background: theme.red + "22", border: "none", color: theme.red, borderRadius: 4, width: 20, height: 20, fontSize: 11, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>×</button>
                  </div>
                  <div style={{ display: "flex", alignItems: "center", gap: 6, marginTop: 4 }}>
                    <div style={{ flex: 1, height: 4, borderRadius: 2, background: theme.border, overflow: "hidden" }}>
                      <div style={{ height: "100%", width: `${(status.uploaded / status.total) * 100}%`, background: status.complete ? theme.green : theme.orange, borderRadius: 2 }} />
                    </div>
                    <span style={{ color: status.complete ? theme.green : theme.orange, fontSize: 10, fontWeight: 700 }}>{status.uploaded}/{status.total}</span>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Document List */}
          {currentShipment && (
            <div style={{ flex: 1 }}>
              {/* Shipment Name Edit */}
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 14 }}>
                <input value={currentShipment.name}
                  onChange={e => renameShipment(currentShipment.id, e.target.value)}
                  style={{ background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "6px 10px", fontSize: 14, fontWeight: 700, outline: "none", flex: 1 }} />
                {(() => {
                  const status = getDocStatus(currentShipment);
                  return (
                    <span style={{ background: status.complete ? theme.green + "22" : theme.orange + "22", color: status.complete ? theme.green : theme.orange, borderRadius: 6, padding: "4px 10px", fontSize: 11, fontWeight: 700 }}>
                      {status.complete ? "✅ All Uploaded" : `⚠️ ${status.total - status.uploaded} Missing`}
                    </span>
                  );
                })()}
              </div>

              {/* Document Rows */}
              <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                {REQUIRED_DOCS.map(docDef => {
                  const doc = currentShipment.docs?.[docDef.key];
                  const isUploaded = !!doc;
                  return (
                    <div key={docDef.key} style={{ display: "flex", alignItems: "center", gap: 12, background: isUploaded ? theme.green + "08" : theme.red + "08", border: `1px solid ${isUploaded ? theme.green + "33" : theme.red + "33"}`, borderRadius: 10, padding: "10px 14px" }}>
                      {/* Status Icon */}
                      <div style={{ fontSize: 18, flexShrink: 0 }}>{isUploaded ? "✅" : "❌"}</div>

                      {/* Label */}
                      <div style={{ flex: 1 }}>
                        <div style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>{docDef.label}</div>
                        {isUploaded ? (
                          <div style={{ color: theme.green, fontSize: 11, marginTop: 2 }}>
                            {doc.name} · {doc.uploadedAt?.slice(0, 10)}
                          </div>
                        ) : (
                          <div style={{ color: theme.red, fontSize: 11, marginTop: 2, fontWeight: 600 }}>
                            ⚠️ Document not uploaded
                          </div>
                        )}
                      </div>

                      {/* Actions */}
                      <div style={{ display: "flex", gap: 8, alignItems: "center", flexShrink: 0 }}>
                        {isUploaded && (
                          <Btn small variant="ghost" onClick={() => setViewDoc({ ...doc, label: docDef.label })}>👁 View</Btn>
                        )}
                        <label style={{ background: isUploaded ? theme.accent + "22" : theme.red + "22", border: `1px solid ${isUploaded ? theme.accent + "44" : theme.red + "44"}`, color: isUploaded ? theme.accent : theme.red, borderRadius: 7, padding: "5px 12px", fontSize: 11, fontWeight: 700, cursor: "pointer", whiteSpace: "nowrap" }}>
                          {isUploaded ? "🔄 Replace" : "📤 Upload"}
                          <input type="file" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx" style={{ display: "none" }}
                            onChange={e => { if (e.target.files[0]) uploadDoc(currentShipment.id, docDef.key, e.target.files[0]); }} />
                        </label>
                        {isUploaded && (
                          <button onClick={() => removeDoc(currentShipment.id, docDef.key)}
                            style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 6, padding: "5px 10px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>🗑</button>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>
      )}

      {/* View Doc Modal */}
      {viewDoc && (
        <div style={{ position: "fixed", inset: 0, background: "#000d", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 }}
          onClick={() => setViewDoc(null)}>
          <div style={{ background: theme.bg, borderRadius: 16, padding: 20, maxWidth: 700, width: "100%", maxHeight: "90vh", overflow: "auto" }} onClick={e => e.stopPropagation()}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
              <div style={{ color: theme.text, fontWeight: 700, fontSize: 15 }}>📄 {viewDoc.label}</div>
              <div style={{ display: "flex", gap: 8 }}>
                <a href={viewDoc.url || viewDoc.data} target="_blank" rel="noreferrer"
                  style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 7, padding: "5px 12px", fontSize: 12, fontWeight: 700, textDecoration: "none" }}>
                  🔗 Open
                </a>
                <Btn small variant="ghost" onClick={() => setViewDoc(null)}>✕ Close</Btn>
              </div>
            </div>
            {viewDoc.type?.startsWith("image/") ? (
              <img src={viewDoc.url || viewDoc.data} alt={viewDoc.label} style={{ width: "100%", borderRadius: 10 }} />
            ) : viewDoc.type === "application/pdf" ? (
              <iframe src={viewDoc.url || viewDoc.data} style={{ width: "100%", height: 500, borderRadius: 10, border: "none" }} title={viewDoc.label} />
            ) : (
              <div style={{ textAlign: "center", padding: 40 }}>
                <div style={{ fontSize: 48, marginBottom: 12 }}>📄</div>
                <div style={{ color: theme.text, fontWeight: 700 }}>{viewDoc.name}</div>
                <div style={{ color: theme.muted, fontSize: 12, marginTop: 4 }}>Click "Open" to view this file</div>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function MaterialSiteTracking() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaved] = useState(false);
  const [saved, setSaving] = useState(false);
  const [suppliedDate1, setSuppliedDate1] = useState("");
  const [suppliedDate2, setSuppliedDate2] = useState("");
  const [supplyModal, setSupplyModal] = useState(null); // { rowId }

  useEffect(() => {
    const defaultRow = {
      id: Date.now(),
      project: "", place: "", startDate: "", confirmOrder: "YES",
      raft: "", retainingWall: "",
      supplies: [],
      
    };
    getDocs(collection(db, "material_site_tracking")).then(snap => {
      const data = snap.docs.map(d => d.data());
      if (data.length > 0) {
        setRows(data);
        if (data[0]?.suppliedDate1Global) setSuppliedDate1(data[0].suppliedDate1Global);
        if (data[0]?.suppliedDate2Global) setSuppliedDate2(data[0].suppliedDate2Global);
      } else {
        const ls = localStorage.getItem("materialSiteTracking");
        if (ls) {
          const parsed = JSON.parse(ls);
          if (parsed.rows) {
            setRows(parsed.rows);
            setSuppliedDate1(parsed.suppliedDate1 || "");
            setSuppliedDate2(parsed.suppliedDate2 || "");
          } else setRows(parsed);
        } else setRows([defaultRow]);
      }
    }).catch(() => {
      const ls = localStorage.getItem("materialSiteTracking");
      if (ls) {
        const parsed = JSON.parse(ls);
        if (parsed.rows) {
          setRows(parsed.rows);
          setSuppliedDate1(parsed.suppliedDate1 || "");
          setSuppliedDate2(parsed.suppliedDate2 || "");
        } else setRows(parsed);
      }
    }).finally(() => setLoading(false));
  }, []);

  const updateRow = (id, key, val) => {
    setSaving(false);
    setRows(rs => rs.map(r => r.id === id ? { ...r, [key]: val } : r));
  };

  const addRow = () => {
    setRows(rs => [...rs, {
      id: Date.now(),
      project: "", place: "", startDate: "", confirmOrder: "YES",
      raft: "", retainingWall: "",
      supplies: [],
      usedAtSite: "", availableOnSite: "",
    }]);
    setSaving(false);
  };

  const deleteRow = (id) => {
    if (!window.confirm("Delete this row?")) return;
    setRows(rs => rs.filter(r => r.id !== id));
    setSaving(false);
  };

  const handleSave = async () => {
    setSaved(true);
    const dataToSave = { rows, suppliedDate1, suppliedDate2 };
    localStorage.setItem("materialSiteTracking", JSON.stringify(dataToSave));
    try {
      for (const row of rows) {
        await setDoc(fsDoc(db, "material_site_tracking", String(row.id)), {
          ...row, suppliedDate1Global: suppliedDate1, suppliedDate2Global: suppliedDate2
        });
      }
      setSaving(true);
      setTimeout(() => setSaving(false), 3000);
    } catch (e) { console.error(e); }
    finally { setSaved(false); }
  };

  // Calculations
  const getTotal = (r) => Math.round(((Number(r.raft) || 0) + (Number(r.retainingWall) || 0)) * 100) / 100;
  const getTotalSupplied = (r) => Math.round((r.supplies || []).reduce((s, x) => s + (Number(x.amount) || 0), 0) * 100) / 100;
  const getBalance = (r) => Math.round((getTotal(r) - getTotalSupplied(r)) * 100) / 100;
  const grandTotal = rows.reduce((s, r) => s + getTotal(r), 0);

  // Supply modal row
  const supplyRow = supplyModal ? rows.find(r => r.id === supplyModal) : null;

  if (loading) return <div style={{ color: theme.muted, padding: 20 }}>Loading...</div>;

  const inp = (color = theme.text) => ({
    background: "transparent", border: "none", borderBottom: `1px solid ${theme.border}`,
    color, padding: "4px 6px", fontSize: 13, outline: "none", width: "100%",
    boxSizing: "border-box", textAlign: "center", fontFamily: "inherit"
  });
  const th = { padding: "10px 8px", background: "#162040", color: "#93c5fd", fontSize: 11, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: `1px solid rgba(99,179,237,0.2)`, whiteSpace: "nowrap" };
  const td = { padding: "8px 6px", border: `1px solid ${theme.border}`, fontSize: 13, textAlign: "center", verticalAlign: "middle" };
  const inpM = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "8px 10px", fontSize: 13, outline: "none", width: "100%", boxSizing: "border-box" };

  return (
    <div>
      <style>{`@media print { body * { visibility: hidden !important; } #mst-print, #mst-print * { visibility: visible !important; } #mst-print { position: fixed !important; top: 0 !important; left: 0 !important; width: 100% !important; background: white !important; padding: 20px !important; } .no-print { display: none !important; } }`}</style>

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Stock Inventory</div>
          <h2 style={{ color: theme.text, fontSize: 22, fontWeight: 800, margin: 0 }}>📊 New Project Supply</h2>
          <div style={{ color: theme.muted, fontSize: 13, marginTop: 3 }}>{rows.length} projects tracked</div>
        </div>
        <div style={{ display: "flex", gap: 10 }}>
          <Btn variant="ghost" onClick={() => window.print()}>🖨 Print</Btn>
          <Btn variant="ghost" onClick={addRow}>+ Add Row</Btn>
          <Btn onClick={handleSave} disabled={saved}>{saved ? "⏳ Saving..." : saving ? "✓ Saved!" : "💾 Save"}</Btn>
        </div>
      </div>

      {/* Stats */}
      <div style={{ display: "flex", gap: 12, marginBottom: 20, flexWrap: "wrap" }}>
        <StatCard label="Total Projects" value={rows.length} color={theme.blue} icon="🏗️" />
        <StatCard label="Total Quantity" value={`${Math.round(grandTotal).toLocaleString("en-IN")} Ltr`} color={theme.accent} icon="📦" />
        <StatCard label="Confirmed Orders" value={rows.filter(r => r.confirmOrder === "YES").length} color={theme.green} icon="✅" />
        <StatCard label="Pending Supply" value={rows.filter(r => getBalance(r) > 0).length} color={theme.orange} icon="⏳" />
      </div>

      {/* Table */}
      <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }}>
        <div id="mst-print">
          <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1100 }}>
            <thead>
              <tr>
                <th style={{ ...th }} colSpan={4}>Project Info</th>
                <th style={{ ...th, background: "#1e3a5f" }} colSpan={3}>Quantity Required (Ltr)</th>
                <th style={{ ...th, background: "#1a3356" }}>Supply Details</th>
                <th style={{ ...th, background: "#162040" }} colSpan={1}>Material Tracking</th>
                <th style={{ ...th, background: "#0f1f3d" }} />
              </tr>
              <tr>
                {["Project", "Place", "Start Date", "Confirm Order",
                  "Raft", "Retaining Wall", "Total",
                  "Supplies (Click to manage)",
                   "Balance Required",
                  ""].map((h, i) => (
                  <th key={i} style={{ ...th, fontSize: 10, background: i < 4 ? "#162040" : i < 7 ? "#1e3a5f" : i === 7 ? "#1a3356" : "#162040" }}>{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {rows.map((r, idx) => {
                const total = getTotal(r);
                const totalSupplied = getTotalSupplied(r);
                const balance = getBalance(r);
                const supplyCount = (r.supplies || []).length;
                return (
                  <tr key={r.id} style={{ background: idx % 2 === 0 ? theme.card : theme.bg }}>
                    <td style={{ ...td, minWidth: 160, fontWeight: 600 }}>
                      <input value={r.project} onChange={e => updateRow(r.id, "project", e.target.value)} style={inp(theme.text)} placeholder="Project name..." />
                    </td>
                    <td style={{ ...td, minWidth: 120 }}>
                      <input value={r.place} onChange={e => updateRow(r.id, "place", e.target.value)} style={inp(theme.muted)} placeholder="Location..." />
                    </td>
                    <td style={{ ...td, minWidth: 130 }}>
                      <input value={r.startDate} onChange={e => updateRow(r.id, "startDate", e.target.value)} style={inp(theme.muted)} placeholder="e.g. 04.03.2026" />
                    </td>
                    <td style={{ ...td, minWidth: 110 }}>
                      <select value={r.confirmOrder} onChange={e => updateRow(r.id, "confirmOrder", e.target.value)}
                        style={{ ...inp(r.confirmOrder === "YES" ? theme.green : r.confirmOrder === "NO" ? theme.red : theme.orange), border: "none", cursor: "pointer" }}>
                        <option value="YES">YES</option>
                        <option value="NO">NO</option>
                        <option value="PENDING">PENDING</option>
                      </select>
                    </td>
                    <td style={{ ...td, minWidth: 90 }}>
                      <input type="number" value={r.raft} onChange={e => updateRow(r.id, "raft", e.target.value)} style={inp(theme.blue)} placeholder="0" />
                    </td>
                    <td style={{ ...td, minWidth: 100 }}>
                      <input type="number" value={r.retainingWall} onChange={e => updateRow(r.id, "retainingWall", e.target.value)} style={inp(theme.blue)} placeholder="0" />
                    </td>
                    {/* Total Auto */}
                    <td style={{ ...td, background: theme.blue + "11" }}>
                      <span style={{ color: theme.blue, fontWeight: 800, fontSize: 14 }}>{total > 0 ? total.toLocaleString("en-IN") : "—"}</span>
                    </td>

                    {/* Supply Details — Click to open modal */}
                    <td style={{ ...td, minWidth: 150 }}>
                      <button onClick={() => setSupplyModal(r.id)}
                        style={{ background: supplyCount > 0 ? theme.purple + "22" : theme.muted + "11", border: `1px solid ${supplyCount > 0 ? theme.purple + "44" : theme.border}`, borderRadius: 8, padding: "6px 12px", cursor: "pointer", width: "100%", textAlign: "center" }}>
                        <div style={{ color: supplyCount > 0 ? theme.purple : theme.muted, fontWeight: 800, fontSize: 14 }}>
                          {totalSupplied > 0 ? totalSupplied.toLocaleString("en-IN") : "—"}
                        </div>
                        <div style={{ color: theme.muted, fontSize: 10, marginTop: 2 }}>
                          {supplyCount > 0 ? `${supplyCount} supply${supplyCount !== 1 ? "ies" : ""} · click to edit` : "Click to add supplies"}
                        </div>
                      </button>
                    </td>

                    
                    {/* Balance Required Auto */}
                    <td style={{ ...td, background: balance > 0 ? theme.red + "11" : theme.green + "08", minWidth: 120 }}>
                      <span style={{ color: balance > 0 ? theme.red : theme.green, fontWeight: 800, fontSize: 14 }}>
                        {total > 0 ? balance.toLocaleString("en-IN") : "—"}
                      </span>
                    </td>
                    {/* Delete */}
                    <td style={{ ...td, width: 40 }} className="no-print">
                      <button onClick={() => deleteRow(r.id)}
                        style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, width: 26, height: 26, fontSize: 13, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
            <tfoot>
  <tr style={{ background: "#162040", borderTop: `2px solid ${theme.accent}` }}>
    <td colSpan={6} style={{ ...td, textAlign: "right", fontWeight: 800, fontSize: 14, color: "#93c5fd", background: "#162040", border: `1px solid rgba(99,179,237,0.2)` }}>GRAND TOTAL</td>
    <td style={{ ...td, background: "#1e3a5f", border: `1px solid rgba(99,179,237,0.2)` }}>
      <span style={{ color: "#60a5fa", fontWeight: 900, fontSize: 16 }}>{Math.round(grandTotal).toLocaleString("en-IN")}</span>
    </td>
    <td style={{ ...td, background: "#1a3356", border: `1px solid rgba(99,179,237,0.2)` }}>
      <span style={{ color: "#a78bfa", fontWeight: 800 }}>{rows.reduce((s, r) => s + getTotalSupplied(r), 0).toLocaleString("en-IN")}</span>
    </td>
    <td style={{ ...td, background: "#162040", border: `1px solid rgba(99,179,237,0.2)` }}>
      <span style={{ color: theme.red, fontWeight: 800 }}>{rows.reduce((s, r) => s + getBalance(r), 0).toLocaleString("en-IN")}</span>
    </td>
    <td style={{ ...td, background: "#162040", border: `1px solid rgba(99,179,237,0.2)` }} className="no-print" />
  </tr>
</tfoot>
          </table>
        </div>
      </div>

      {/* Supply Details Modal */}
      {supplyModal && supplyRow && (
        <div style={{ position: "fixed", inset: 0, background: "#000000cc", zIndex: 300, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}
          onClick={() => setSupplyModal(null)}>
          <div style={{ background: theme.card, borderRadius: 16, width: "100%", maxWidth: 600, maxHeight: "80vh", overflow: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.4)" }}
            onClick={e => e.stopPropagation()}>

            {/* Modal Header */}
            <div style={{ padding: "16px 20px", borderBottom: `1px solid ${theme.border}`, display: "flex", justifyContent: "space-between", alignItems: "center", background: "#162040", borderRadius: "16px 16px 0 0" }}>
              <div>
                <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 15 }}>📦 Supply Details</div>
                <div style={{ color: "#5a7aa8", fontSize: 12, marginTop: 2 }}>{supplyRow.project || "Project"}</div>
              </div>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{ color: "#93c5fd", fontSize: 13, fontWeight: 700 }}>
                  Total: <span style={{ color: "#60a5fa", fontSize: 16 }}>{getTotalSupplied(supplyRow).toLocaleString("en-IN")} Ltr</span>
                </div>
                <button onClick={() => setSupplyModal(null)}
                  style={{ background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.2)", color: "#fff", borderRadius: 8, width: 32, height: 32, fontSize: 16, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
              </div>
            </div>

            {/* Supply List */}
            <div style={{ padding: 20 }}>
              {/* Column Headers */}
              <div style={{ display: "grid", gridTemplateColumns: "40px 1fr 1fr 36px", gap: 10, marginBottom: 10 }}>
                <div style={{ color: theme.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Sr.</div>
                <div style={{ color: theme.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Supply Date</div>
                <div style={{ color: theme.muted, fontSize: 11, fontWeight: 700, textTransform: "uppercase" }}>Amount (Ltr)</div>
                <div />
              </div>

              {/* Supply Rows */}
              {(supplyRow.supplies || []).map((supply, si) => (
                <div key={supply.id || si} style={{ display: "grid", gridTemplateColumns: "40px 1fr 1fr 36px", gap: 10, marginBottom: 10, alignItems: "center" }}>
                  <div style={{ color: theme.accent, fontWeight: 700, textAlign: "center", fontSize: 13 }}>{si + 1}</div>
                  <input type="date" value={supply.date || ""}
                    onChange={e => {
                      const updated = (supplyRow.supplies || []).map((s, j) => j === si ? { ...s, date: e.target.value } : s);
                      updateRow(supplyRow.id, "supplies", updated);
                    }}
                    style={inpM} />
                  <input type="number" value={supply.amount || ""}
                    placeholder="Amount in Ltr..."
                    onChange={e => {
                      const updated = (supplyRow.supplies || []).map((s, j) => j === si ? { ...s, amount: e.target.value } : s);
                      updateRow(supplyRow.id, "supplies", updated);
                    }}
                    style={{ ...inpM, color: theme.purple, fontWeight: 700 }} />
                  <button onClick={() => {
                    const updated = (supplyRow.supplies || []).filter((_, j) => j !== si);
                    updateRow(supplyRow.id, "supplies", updated);
                  }} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 6, width: 36, height: 36, fontSize: 16, cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center" }}>×</button>
                </div>
              ))}

              {/* Add Supply Button */}
              <button onClick={() => {
                const newSupply = { id: Date.now(), date: new Date().toISOString().slice(0, 10), amount: "" };
                const updated = [...(supplyRow.supplies || []), newSupply];
                updateRow(supplyRow.id, "supplies", updated);
              }} style={{ width: "100%", background: theme.purple + "11", border: `2px dashed ${theme.purple}44`, borderRadius: 10, padding: "12px 16px", color: theme.purple, cursor: "pointer", fontSize: 13, fontWeight: 600, marginTop: 6 }}>
                + Add Supply Entry
              </button>

              {/* Summary */}
              {(supplyRow.supplies || []).length > 0 && (
                <div style={{ marginTop: 16, background: theme.purple + "11", border: `1px solid ${theme.purple}33`, borderRadius: 10, padding: "12px 16px" }}>
                  <div style={{ color: theme.muted, fontSize: 12, marginBottom: 6, fontWeight: 600 }}>Supply Summary</div>
                  {(supplyRow.supplies || []).map((s, i) => (
                    <div key={i} style={{ display: "flex", justifyContent: "space-between", marginBottom: 4 }}>
                      <span style={{ color: theme.muted, fontSize: 12 }}>Supply {i + 1} {s.date ? `· ${new Date(s.date).toLocaleDateString("en-IN")}` : ""}</span>
                      <span style={{ color: theme.purple, fontWeight: 700, fontSize: 12 }}>{Number(s.amount) > 0 ? `${Number(s.amount).toLocaleString("en-IN")} Ltr` : "—"}</span>
                    </div>
                  ))}
                  <div style={{ borderTop: `1px solid ${theme.purple}33`, paddingTop: 8, marginTop: 6, display: "flex", justifyContent: "space-between" }}>
                    <span style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>Total Supplied</span>
                    <span style={{ color: theme.purple, fontWeight: 900, fontSize: 16 }}>{getTotalSupplied(supplyRow).toLocaleString("en-IN")} Ltr</span>
                  </div>
                </div>
              )}

              {/* Done Button */}
              <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16, gap: 10 }}>
                <Btn variant="ghost" onClick={() => setSupplyModal(null)}>Close</Btn>
                <Btn onClick={() => { handleSave(); setSupplyModal(null); }}>💾 Save & Close</Btn>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}



// ============================================================
// FINANCE DASHBOARD — Add this full component to App.js
// ============================================================
 function SuppModal({ row, type, onClose, onSave }) {
  const [advance, setAdvance] = useState(row.advanceReceived || "");
  const n = v => Number(v) || 0;
  const fmt = v => n(v).toLocaleString("en-IN");
  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "8px 10px", fontSize: 12, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 11, fontWeight: 600, display: "block", marginBottom: 4 };

  return (
    <div style={{ position: "fixed", inset: 0, background: "#000c", zIndex: 400, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
      <div style={{ background: theme.card, borderRadius: 16, width: "100%", maxWidth: 420, boxShadow: "0 20px 60px rgba(0,0,0,0.4)" }}>
        <div style={{ padding: "16px 20px", background: "#162040", borderRadius: "16px 16px 0 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 15 }}>✏️ Update Payment Info</div>
          <button onClick={onClose} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", borderRadius: 8, width: 32, height: 32, cursor: "pointer", fontSize: 16 }}>×</button>
        </div>
        <div style={{ padding: 20 }}>
          <div style={{ background: theme.bg, borderRadius: 10, padding: "10px 14px", marginBottom: 16 }}>
            <div style={{ color: theme.accent, fontWeight: 700, fontSize: 13 }}>{row.piNo}</div>
            <div style={{ color: theme.muted, fontSize: 12, marginTop: 2 }}>{row.clientName} · ₹{fmt(row.amount)}</div>
          </div>
          <div style={{ marginBottom: 14 }}>
            <label style={lbl}>Advance Received ₹</label>
            <input type="number" value={advance} onChange={e => setAdvance(e.target.value)}
              style={{ ...inp, color: theme.green, fontWeight: 700 }} placeholder="0" />
          </div>
         
          <div style={{ background: theme.accent + "11", border: `1px solid ${theme.accent}33`, borderRadius: 8, padding: "10px 14px", marginBottom: 16 }}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <span style={{ color: theme.muted, fontSize: 12 }}>Invoice Amount</span>
              <span style={{ color: theme.text, fontWeight: 600 }}>₹{fmt(row.amount)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 4 }}>
              <span style={{ color: theme.muted, fontSize: 12 }}>Advance Received</span>
              <span style={{ color: theme.blue, fontWeight: 600 }}>₹{fmt(advance)}</span>
            </div>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 6, borderTop: `1px solid ${theme.border}`, paddingTop: 6 }}>
              <span style={{ color: theme.text, fontWeight: 700, fontSize: 13 }}>Balance</span>
              <span style={{ color: n(row.amount) - n(advance) > 0 ? theme.red : theme.green, fontWeight: 800, fontSize: 14 }}>
                ₹{fmt(n(row.amount) - n(advance))}
              </span>
            </div>
          </div>
          <div style={{ display: "flex", gap: 10, justifyContent: "flex-end" }}>
            <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
            <Btn onClick={() => onSave({ advanceReceived: advance })}>💾 Save</Btn>
          </div>
        </div>
      </div>
    </div>
  );
}

    function FinanceEditModal({ type, row, onClose, onSave }) {
  const [form, setForm] = useState({ ...row });
  const inp = { background: theme.bg, border: `1px solid ${theme.border}`, borderRadius: 7, color: theme.text, padding: "8px 10px", fontSize: 12, outline: "none", width: "100%", boxSizing: "border-box" };
  const lbl = { color: theme.muted, fontSize: 11, fontWeight: 600, display: "block", marginBottom: 4 };
  const s = k => e => setForm(f => ({ ...f, [k]: e.target.value }));
    const fields = {
      payment: [
        { key: "clientName", label: "Client Name" },
        { key: "siteName", label: "Site Name" },
        { key: "invoiceNo", label: "Invoice No" },
        { key: "totalAmount", label: "Total Amount ₹", type: "number" },
        { key: "paidAmount", label: "Paid Amount ₹", type: "number" },
        { key: "date", label: "Invoice Date", type: "date" },
        { key: "status", label: "Status", options: ["Paid", "Partial", "Pending", "Overdue"] },
      ],
      pending: [
        { key: "invoiceNo", label: "Invoice No" },
        { key: "billTo", label: "Bill To" },
        { key: "siteName", label: "Site Name" },
        { key: "date", label: "Date", type: "date" },
        { key: "netReceivable", label: "Net Receivable ₹", type: "number" },
        { key: "paid", label: "Paid ₹", type: "number" },
      ],
    };
    const fs = fields[type] || [];
    return (
      <div style={{ position: "fixed", inset: 0, background: "#000c", zIndex: 400, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 }}>
        <div style={{ background: theme.card, borderRadius: 16, width: "100%", maxWidth: 560, maxHeight: "90vh", overflow: "auto", boxShadow: "0 20px 60px rgba(0,0,0,0.4)" }}>
          <div style={{ padding: "16px 20px", background: "#162040", borderRadius: "16px 16px 0 0", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 15 }}>{row._isNew ? "➕ New Entry" : "✏️ Edit Entry"}</div>
            <button onClick={onClose} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#fff", borderRadius: 8, width: 32, height: 32, cursor: "pointer", fontSize: 16 }}>×</button>
          </div>
          <div style={{ padding: 20 }}>
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12 }}>
              {fs.map(f => (
                <div key={f.key} style={{ gridColumn: f.key === "siteName" || f.key === "billTo" ? "1 / -1" : "auto" }}>
                  <label style={lbl}>{f.label}</label>
                  {f.options ? (
                    <select value={form[f.key] || ""} onChange={s(f.key)} style={{ ...inp, cursor: "pointer" }}>
                      <option value="">— Select —</option>
                      {f.options.map(o => <option key={o} value={o}>{o}</option>)}
                    </select>
                  ) : (
                    <input type={f.type || "text"} value={form[f.key] || ""} onChange={s(f.key)} style={inp} placeholder={f.label} />
                  )}
                </div>
              ))}
            </div>
            <div style={{ display: "flex", gap: 10, justifyContent: "flex-end", marginTop: 20 }}>
              <Btn variant="ghost" onClick={onClose}>Cancel</Btn>
              <Btn onClick={() => onSave(form)}>💾 Save</Btn>
            </div>
          </div>
        </div>
      </div>
    );
  }


function FinanceDashboard({ invoices = [], allTaxInvoices = [] }) {
  const [activeTab, setActiveTab] = useState("overview");
  const [loading, setLoading] = useState(true);

  // ---- Manual tracker state ----
  const [ledgers, setLedgers] = useState([]);
const [pendingRows, setPendingRows] = useState([]);

  // ---- Supplement data (user-entered advance/status for auto-fetched invoices) ----
  const [proformaSupp, setProformaSupp] = useState({}); // { invoiceId: { advanceReceived, status } }
  const [taxSupp, setTaxSupp] = useState({});

  // ---- Tax invoices from Firestore ----
 const taxInvoices = allTaxInvoices;

  // ---- Edit modals ----
  const [editModal, setEditModal] = useState(null);
  const [viewInvoice, setViewInvoice] = useState(null);
  const [suppModal, setSuppModal] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const [ledgerSnap, penSnap, proSuppSnap, taxSuppSnap] = await Promise.all([
  getDocs(collection(db, "ledgers")),
  getDocs(collection(db, "fd_pending")),
  getDocs(collection(db, "fd_proforma_supp")),
  getDocs(collection(db, "fd_tax_supp")),
]);

        if (ledgerSnap.docs.length > 0) setLedgers(ledgerSnap.docs.map(d => d.data()));
else { const ls = localStorage.getItem("ledgers"); if (ls) setLedgers(JSON.parse(ls)); }

        // Pending payments
        if (penSnap.docs.length > 0) setPendingRows(penSnap.docs.map(d => d.data()));
        else { const ls = localStorage.getItem("fd_pending"); if (ls) setPendingRows(JSON.parse(ls)); }

        // Proforma supplement data
        const pSupp = {};
        proSuppSnap.docs.forEach(d => { pSupp[d.id] = d.data(); });
        const lsPS = localStorage.getItem("fd_proforma_supp");
        if (lsPS) Object.assign(pSupp, JSON.parse(lsPS));
        setProformaSupp(pSupp);

        // Tax supplement data
        const tSupp = {};
        taxSuppSnap.docs.forEach(d => { tSupp[d.id] = d.data(); });
        const lsTS = localStorage.getItem("fd_tax_supp");
        if (lsTS) Object.assign(tSupp, JSON.parse(lsTS));
        setTaxSupp(tSupp);

      

      } catch (e) {
        console.error(e);
        const ls1 = localStorage.getItem("ledgers");
        const ls2 = localStorage.getItem("fd_pending");
           if (ls1) setLedgers(JSON.parse(ls1));
           if (ls2) setPendingRows(JSON.parse(ls2));
      } finally { setLoading(false); }
    };
    load();
  }, []);

  // ---- Save supplement ----
  const saveProformaSupp = async (invId, data) => {
    const updated = { ...proformaSupp, [invId]: data };
    setProformaSupp(updated);
    localStorage.setItem("fd_proforma_supp", JSON.stringify(updated));
    try { await setDoc(fsDoc(db, "fd_proforma_supp", String(invId)), data); }
    catch (e) { console.error(e); }
  };

  const saveTaxSupp = async (invId, data) => {
    const updated = { ...taxSupp, [invId]: data };
    setTaxSupp(updated);
    localStorage.setItem("fd_tax_supp", JSON.stringify(updated));
    try { await setDoc(fsDoc(db, "fd_tax_supp", String(invId)), data); }
    catch (e) { console.error(e); }
  };

  // ---- Save manual trackers ----
  const save = async (collName, lsKey, rows, setter) => {
    setter(rows);
    localStorage.setItem(lsKey, JSON.stringify(rows));
    try { for (const r of rows) await setDoc(fsDoc(db, collName, String(r.id)), r); }
    catch (e) { console.error(e); }
  };

  
  const savePending = (rows) => save("fd_pending", "fd_pending", rows, setPendingRows);

  const delRow = async (collName, lsKey, rows, setter, id) => {
    if (!window.confirm("Delete this row?")) return;
    const updated = rows.filter(r => r.id !== id);
    setter(updated);
    localStorage.setItem(lsKey, JSON.stringify(updated));
    try { await deleteDoc(fsDoc(db, collName, String(id))); } catch (e) { console.error(e); }
  };

  const newId = () => `${Date.now()}_${Math.random().toString(36).slice(2)}`;
  const n = v => Number(v) || 0;
  const fmt = v => n(v).toLocaleString("en-IN", { minimumFractionDigits: 0 });
  const today = new Date();
 

  // ---- Derived proforma rows from actual invoices ----
 const proformaRows = invoices.map(inv => {
  const supp = proformaSupp[inv.id] || {};
  const amount = n(inv.totalAmount);
  const advance = n(supp.advanceReceived);
  const days = inv.invoiceDate
    ? Math.floor((new Date() - new Date(inv.invoiceDate)) / (1000 * 60 * 60 * 24))
    : 0;
  return {
    id: inv.id,
    piNo: inv.invoiceNo,
    date: inv.invoiceDate,
    clientName: inv.clientName,
    siteName: inv.siteAddress || inv.subName || "",
    amount,
    advanceReceived: supp.advanceReceived || "",
    balance: amount - advance,
    daysOutstanding: days,
    _inv: inv,
  };
});
// Auto-pending: proforma invoices > 30 days
const autoPendingFromProforma = proformaRows.filter(r => r.daysOutstanding > 30).map(r => ({
  id: `auto_${r.id}`,
  invoiceNo: r.piNo,
  billTo: r.clientName,
  siteName: r.siteName,
  date: r.date,
  netReceivable: r.amount,
  paid: n(r.advanceReceived),
  _isAuto: true,
}));

const allPendingRows = [
  ...pendingRows,
  ...autoPendingFromProforma.filter(ap => !pendingRows.find(pr => pr.invoiceNo === ap.invoiceNo)),
];
  // ---- Derived tax rows from actual tax invoices ----
  const taxRows = taxInvoices.map(inv => {
    const supp = taxSupp[inv.id] || {};
    const amount = n(inv.totalAmount);
    const advance = n(supp.advanceReceived);
    return {
      id: inv.id,
      piNo: inv.invoiceNo,
      date: inv.invoiceDate,
      clientName: inv.clientName,
      siteName: inv.siteAddress || inv.subName || "",
      amount,
      advanceReceived: supp.advanceReceived || "",
      balance: amount - advance,
      status: supp.status || "Pending",
      proformaRef: inv.proformaRef,
      _inv: inv,
    };
  });

  // ---- Monthly Report ----
  const monthlyData = (() => {
    const map = {};
    [...proformaRows].forEach(r => {
      const month = r.date?.slice(0, 7) || "Unknown";
      if (!map[month]) map[month] = { month, invoiceCount: 0, totalInvoiced: 0, totalReceived: 0 };
      map[month].invoiceCount++;
      map[month].totalInvoiced += r.amount;
      map[month].totalReceived += n(r.advanceReceived);
    });
    return Object.values(map).sort((a, b) => b.month.localeCompare(a.month));
  })();

  // ---- Client Wise Report ----
  const clientData = (() => {
    const map = {};
    [...proformaRows].forEach(r => {
      const site = r.siteName || r.clientName || "Unknown";
      if (!map[site]) map[site] = { siteName: site, invoiceCount: 0, totalInvoiced: 0, totalReceived: 0 };
      map[site].invoiceCount++;
      map[site].totalInvoiced += r.amount;
      map[site].totalReceived += n(r.advanceReceived);
    });
    return Object.values(map).sort((a, b) => b.totalInvoiced - a.totalInvoiced);
  })();

  if (loading) return <div style={{ color: theme.muted, padding: 30 }}>Loading Finance Dashboard...</div>;

  // ---- Styles ----
  const th = { padding: "10px 10px", background: "#162040", color: "#93c5fd", fontSize: 10, fontWeight: 800, textTransform: "uppercase", textAlign: "center", border: `1px solid rgba(99,179,237,0.2)`, whiteSpace: "nowrap" };
  const td = { padding: "9px 10px", border: `1px solid ${theme.border}`, fontSize: 12, textAlign: "center", verticalAlign: "middle" };
  

  // ---- Overview Stats ----
const totalProformaAmt = proformaRows.reduce((s, r) => s + r.amount, 0);
const totalTaxAmt = taxRows.reduce((s, r) => s + r.amount, 0);
const totalReceived = proformaRows.reduce((s, r) => s + n(r.advanceReceived), 0);
const totalOutstanding = totalProformaAmt - totalReceived;

  // ---- Edit Modal for manual trackers ----
 
  // ---- Supplement Edit Modal (for proforma/tax advance + status) ----
 
 

  const handleSaveEdit = (type, form) => {
    const isNew = form._isNew;
    const row = { ...form, id: form.id || newId() };
    delete row._isNew;
    
    if (type === "pending") savePending(isNew ? [row, ...pendingRows] : pendingRows.map(r => r.id === row.id ? row : r));
    setEditModal(null);
  };

  const exportInvoiceToExcel = async (inv) => {
    
    const wb = XLSX.utils.book_new();
    const headerData = [
      ["PERMATECH CONCRETE SOLUTIONS"],
      ["18, Divya Darshan, Mount Mary Steps, Bandra (W), Mumbai - 400 050."],
      [""],
      ["Invoice No.", inv.invoiceNo, "Invoice Date", inv.invoiceDate],
      ["Client Name", inv.clientName, "Running Bill No.", inv.runningBillNo || ""],
      ["Client Address", inv.clientAddress || ""],
      ["Site Address", inv.siteAddress || ""],
      [""],
      ["SR.", "Particulars", "Unit", "Qty", "Rate (₹)", "Amount (₹)"],
      ...(inv.items || []).map((item, i) => [i + 1, item.particulars || "", item.unit || "", Number(item.qty) || 0, Number(item.rate) || 0, Math.round((Number(item.qty) || 0) * (Number(item.rate) || 0) * 100) / 100]),
      [""],
      ["", "", "", "", "Invoice Amount", inv.invoiceAmount || 0],
      ["", "", "", "", `CGST @ ${inv.cgst}%`, inv.cgstAmount || 0],
      ["", "", "", "", `SGST @ ${inv.sgst}%`, inv.sgstAmount || 0],
      ["", "", "", "", "Round Off", inv.roundOff || 0],
      ["", "", "", "", "TOTAL AMOUNT", inv.totalAmount || 0],
    ];
    const ws = XLSX.utils.aoa_to_sheet(headerData);
    ws["!cols"] = [{ wch: 6 }, { wch: 30 }, { wch: 10 }, { wch: 10 }, { wch: 15 }, { wch: 15 }];
    XLSX.utils.book_append_sheet(wb, ws, "Invoice");
    XLSX.writeFile(wb, `Invoice_${inv.invoiceNo?.replace(/\//g, "_") || "export"}.xlsx`);
  };

  const printSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    const win = window.open("", "_blank");
    win.document.write(`<html><head><style>body{font-family:Arial,sans-serif;padding:20px}table{width:100%;border-collapse:collapse}th,td{border:1px solid #ccc;padding:8px;font-size:12px}th{background:#162040;color:#93c5fd}</style></head><body>${el.innerHTML}</body></html>`);
    win.document.close();
    setTimeout(() => { win.print(); win.close(); }, 500);
  };

  return (
    <div>
     {editModal && (
  <FinanceEditModal type={editModal.type} row={editModal.row} onClose={() => setEditModal(null)}
    onSave={(form) => handleSaveEdit(editModal.type, form)} />
)}

     {suppModal && (
  <SuppModal
    row={suppModal.row}
    type={suppModal.type}
    onClose={() => setSuppModal(null)}
    onSave={async (data) => {
      if (suppModal.type === "proforma") await saveProformaSupp(suppModal.row.id, data);
      else await saveTaxSupp(suppModal.row.id, data);
      setSuppModal(null);
    }}
  />
)}
      {viewInvoice && (
        <InvoicePreviewModal invoice={viewInvoice} onClose={() => setViewInvoice(null)} />
      )}

      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 24 }}>
        <div>
          <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Finance</div>
          <h2 style={{ color: theme.text, fontSize: 26, fontWeight: 800, margin: 0 }}>💹 Finance Dashboard</h2>
          <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>Complete financial overview — Permatech Concrete Solutions</div>
        </div>
      </div>

      <Tabs active={activeTab} onChange={setActiveTab} tabs={[
        { id: "overview", label: "📊 Overview" },
        { id: "proforma", label: `🧾 Proforma Tracker (${proformaRows.length})` },
        { id: "tax", label: `🧾 Tax Invoice Tracker (${taxRows.length})` },
        { id: "ledger", label: `📒 Project Ledger Tracker` },
        { id: "monthly", label: "📅 Monthly Report" },
        { id: "clientwise", label: "🏢 Client Wise Report" },
        { id: "pending", label: `⏳ Pending Payments (${allPendingRows.length})` },
      ]} />

      {/* ---- OVERVIEW ---- */}
      {activeTab === "overview" && (
        <div>
          <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(180px, 1fr))", gap: 14, marginBottom: 24 }}>
            {[
              { label: "Proforma Invoices", value: proformaRows.length, amount: `₹${fmt(totalProformaAmt)}`, color: theme.blue, icon: "🧾" },
              { label: "Tax Invoices", value: taxRows.length, amount: `₹${fmt(totalTaxAmt)}`, color: theme.purple, icon: "📋" },
              { label: "Total Billed", value: proformaRows.length, amount: `₹${fmt(totalProformaAmt)}`, color: theme.accent, icon: "💰" },
              { label: "Total Received", value: "—", amount: `₹${fmt(totalReceived)}`, color: theme.green, icon: "✅" },
              { label: "Total Outstanding", value: "—", amount: `₹${fmt(totalOutstanding)}`, color: totalOutstanding > 0 ? theme.red : theme.green, icon: "⏳" },
              { label: "Pending Payments", value: allPendingRows.length, amount: `₹${fmt(allPendingRows.reduce((s, r) => s + (n(r.netReceivable) - n(r.paid)), 0))}`, color: theme.orange, icon: "🔔" },
            ].map((s, i) => (
              <div key={i} style={{ background: theme.card, border: `1px solid ${s.color}33`, borderRadius: 14, padding: "18px 16px", position: "relative", overflow: "hidden" }}>
                <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 3, background: s.color }} />
                <div style={{ fontSize: 28, marginBottom: 8 }}>{s.icon}</div>
                <div style={{ color: s.color, fontWeight: 900, fontSize: 20 }}>{s.amount}</div>
                <div style={{ color: theme.text, fontWeight: 700, fontSize: 12, marginTop: 4 }}>{s.label}</div>
                {s.value !== "—" && <div style={{ color: theme.muted, fontSize: 11, marginTop: 2 }}>{s.value} entries</div>}
              </div>
            ))}
          </div>

          {/* Quick Summary */}
          <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
            <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
              <div style={{ padding: "12px 16px", background: "#162040", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 13 }}>🧾 Recent Proforma Invoices</div>
                <button onClick={() => setActiveTab("proforma")} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#93c5fd", borderRadius: 6, padding: "3px 10px", fontSize: 11, cursor: "pointer" }}>View All →</button>
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr>{["PI No", "Client", "Amount", "Status"].map(h => <th key={h} style={{ ...th, fontSize: 9 }}>{h}</th>)}</tr></thead>
                <tbody>
                  {proformaRows.slice(0, 5).map((r, i) => (
                    <tr key={r.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                      <td style={{ ...td, color: theme.accent, fontWeight: 700, fontSize: 11 }}>{r.piNo || "—"}</td>
                      <td style={{ ...td, fontSize: 11 }}>{r.clientName || "—"}</td>
                      <td style={{ ...td, color: theme.green, fontWeight: 600, fontSize: 11 }}>₹{fmt(r.amount)}</td>
                      <td style={{ ...td, textAlign: "center" }}>
  {(() => {
    const days = r.daysOutstanding || 0;
    const color = days <= 30 ? theme.green : days <= 60 ? theme.orange : theme.red;
    const bg = days <= 30 ? theme.green + "22" : days <= 60 ? theme.orange + "22" : theme.red + "22";
    return (
      <span style={{ background: bg, color, border: `1px solid ${color}44`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 800 }}>
        {days} days
      </span>
    );
  })()}
</td>
                    </tr>
                  ))}
                  {proformaRows.length === 0 && <tr><td colSpan={4} style={{ ...td, color: theme.muted, padding: 20 }}>No invoices yet</td></tr>}
                </tbody>
              </table>
            </div>

            <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }}>
              <div style={{ padding: "12px 16px", background: "#162040", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 13 }}>⏳ Pending Payments</div>
                <button onClick={() => setActiveTab("pending")} style={{ background: "rgba(255,255,255,0.1)", border: "none", color: "#93c5fd", borderRadius: 6, padding: "3px 10px", fontSize: 11, cursor: "pointer" }}>View All →</button>
              </div>
              <table style={{ width: "100%", borderCollapse: "collapse" }}>
                <thead><tr>{["Invoice No", "Bill To", "Balance Due"].map(h => <th key={h} style={{ ...th, fontSize: 9 }}>{h}</th>)}</tr></thead>
                <tbody>
                  {allPendingRows.slice(0, 5).map((r, i) => {
                    const bal = n(r.netReceivable) - n(r.paid);
                    return (
                      <tr key={r.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                        <td style={{ ...td, color: theme.accent, fontWeight: 700, fontSize: 11 }}>{r.invoiceNo || "—"}</td>
                        <td style={{ ...td, fontSize: 11 }}>{r.billTo || "—"}</td>
                        <td style={{ ...td, color: bal > 0 ? theme.red : theme.green, fontWeight: 700, fontSize: 11 }}>₹{fmt(bal)}</td>
                      </tr>
                    );
                  })}
                  {allPendingRows.length === 0 && <tr><td colSpan={3} style={{ ...td, color: theme.muted, padding: 20 }}>No pending payments</td></tr>}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}

      {/* ---- PROFORMA TRACKER ---- */}
      {activeTab === "proforma" && (
        <div>
          <div style={{ background: theme.blue + "11", border: `1px solid ${theme.blue}33`, borderRadius: 10, padding: "10px 16px", marginBottom: 14, display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 16 }}>💡</span>
            <span style={{ color: theme.blue, fontSize: 12, fontWeight: 600 }}>Auto-fetched from all project Proforma Invoices. Click ✏️ to update Advance Received & Status.</span>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 14 }}>
            <Btn variant="ghost" onClick={() => printSection("proforma-table")}>🖨 Print</Btn>
          </div>
          <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }} id="proforma-table">
            <div style={{ padding: "12px 16px", background: "#162040", borderRadius: "12px 12px 0 0" }}>
              <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>🧾 Proforma Invoice Tracker — Permatech Concrete Solutions</div>
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1000 }}>
              <thead>
                <tr>{["SR", "PI No", "Date", "Client Name", "Site Name", "Amount ₹", "Advance Received ₹", "Balance ₹", "Days Outstanding", "Actions"].map(h => <th key={h} style={th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {proformaRows.length === 0 && <tr><td colSpan={10} style={{ ...td, padding: 30, color: theme.muted }}>No proforma invoices found. Create invoices in Project Management → Billing.</td></tr>}
                {proformaRows.map((r, i) => (
                  <tr key={r.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                    <td style={{ ...td, color: theme.muted, width: 40 }}>{i + 1}</td>
                    <td style={{ ...td, color: theme.accent, fontWeight: 700, minWidth: 160 }}>{r.piNo || "—"}</td>
                    <td style={{ ...td, minWidth: 100 }}>{r.date || "—"}</td>
                    <td style={{ ...td, minWidth: 160, textAlign: "left", paddingLeft: 12, fontWeight: 600 }}>{r.clientName || "—"}</td>
                    <td style={{ ...td, minWidth: 160, textAlign: "left", paddingLeft: 12 }}>{r.siteName || "—"}</td>
                    <td style={{ ...td, color: theme.green, fontWeight: 700 }}>₹{fmt(r.amount)}</td>
                    <td style={{ ...td, color: theme.blue, fontWeight: 600 }}>₹{fmt(r.advanceReceived)}</td>
                    <td style={{ ...td, color: r.balance > 0 ? theme.red : theme.green, fontWeight: 800 }}>₹{fmt(r.balance)}</td>
                   <td style={{ ...td, textAlign: "center" }}>
                {(() => {
            const days = r.daysOutstanding || 0;
    const color = days <= 30 ? theme.green : days <= 60 ? theme.orange : theme.red;
    const bg = days <= 30 ? theme.green + "22" : days <= 60 ? theme.orange + "22" : theme.red + "22";
    return (
      <span style={{ background: bg, color, border: `1px solid ${color}44`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 800 }}>
        {days} days
      </span>
    );
  })()}
</td>
<td style={{ ...td, minWidth: 120 }}>
  <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
    <button onClick={() => setViewInvoice(r._inv)}
                          style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>👁 View</button>
                        <button onClick={() => exportInvoiceToExcel(r._inv)}
                          style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>📥</button>
                        <button onClick={() => setSuppModal({ row: r, type: "proforma" })}
                          style={{ background: theme.orange + "22", border: `1px solid ${theme.orange}44`, color: theme.orange, borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>✏️</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              {proformaRows.length > 0 && (
                <tfoot>
                  <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                    <td colSpan={5} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>TOTAL</td>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(proformaRows.reduce((s, r) => s + r.amount, 0))}</td>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(proformaRows.reduce((s, r) => s + n(r.advanceReceived), 0))}</td>
                    <td style={{ ...td, color: theme.red, fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(proformaRows.reduce((s, r) => s + r.balance, 0))}</td>
                    <td colSpan={2} style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      )}

      {/* ---- TAX INVOICE TRACKER ---- */}
      {activeTab === "tax" && (
        <div>
          <div style={{ background: theme.purple + "11", border: `1px solid ${theme.purple}33`, borderRadius: 10, padding: "10px 16px", marginBottom: 14, display: "flex", alignItems: "center", gap: 10 }}>
            <span style={{ fontSize: 16 }}>💡</span>
            <span style={{ color: theme.purple, fontSize: 12, fontWeight: 600 }}>Auto-fetched from all project Tax Invoices. Click ✏️ to update Advance Received & Status.</span>
          </div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 14 }}>
            <Btn variant="ghost" onClick={() => printSection("tax-table")}>🖨 Print</Btn>
          </div>
          <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }} id="tax-table">
            <div style={{ padding: "12px 16px", background: "#162040", borderRadius: "12px 12px 0 0" }}>
              <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>🧾 Tax Invoice Tracker — Permatech Concrete Solutions</div>
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1000 }}>
              <thead>
                <tr>{["SR", "Tax Invoice No", "Date", "Client Name", "Site Name", "Amount ₹", "Received ₹", "Balance ₹", "Status", "Actions"].map(h => <th key={h} style={th}>{h}</th>)}</tr>
              </thead>
              <tbody>
                {taxRows.length === 0 && <tr><td colSpan={10} style={{ ...td, padding: 30, color: theme.muted }}>No tax invoices found. Create tax invoices in Project Management → Billing.</td></tr>}
                {taxRows.map((r, i) => (
                  <tr key={r.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                    <td style={{ ...td, color: theme.muted, width: 40 }}>{i + 1}</td>
                    <td style={{ ...td, color: theme.accent, fontWeight: 700, minWidth: 180 }}>{r.piNo || "—"}</td>
                    <td style={{ ...td, minWidth: 100 }}>{r.date || "—"}</td>
                    <td style={{ ...td, minWidth: 160, textAlign: "left", paddingLeft: 12, fontWeight: 600 }}>{r.clientName || "—"}</td>
                    <td style={{ ...td, minWidth: 160, textAlign: "left", paddingLeft: 12 }}>{r.siteName || "—"}</td>
                    <td style={{ ...td, color: theme.green, fontWeight: 700 }}>₹{fmt(r.amount)}</td>
                    <td style={{ ...td, color: theme.blue, fontWeight: 600 }}>₹{fmt(r.advanceReceived)}</td>
                    <td style={{ ...td, color: r.balance > 0 ? theme.red : theme.green, fontWeight: 800 }}>₹{fmt(r.balance)}</td>
                    <td style={{ ...td, textAlign: "center" }}>
  {(() => {
    if (!r.date) return <span style={{ color: theme.muted }}>—</span>;
    const days = Math.floor((new Date() - new Date(r.date)) / (1000 * 60 * 60 * 24));
    const color = days <= 30 ? theme.green : days <= 60 ? theme.orange : theme.red;
    const bg = days <= 30 ? theme.green + "22" : days <= 60 ? theme.orange + "22" : theme.red + "22";
    return (
      <span style={{ background: bg, color, border: `1px solid ${color}44`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 800 }}>
        {days} days
      </span>
    );
  })()}
</td>
                    <td style={{ ...td, minWidth: 120 }}>
                      <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
                        <button onClick={() => setViewInvoice(r._inv)}
                          style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>👁 View</button>
                        <button onClick={() => exportInvoiceToExcel(r._inv)}
                          style={{ background: theme.green + "22", border: `1px solid ${theme.green}44`, color: theme.green, borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>📥</button>
                        <button onClick={() => setSuppModal({ row: r, type: "tax" })}
                          style={{ background: theme.orange + "22", border: `1px solid ${theme.orange}44`, color: theme.orange, borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>✏️</button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              {taxRows.length > 0 && (
                <tfoot>
                  <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                    <td colSpan={5} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>TOTAL</td>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(taxRows.reduce((s, r) => s + r.amount, 0))}</td>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(taxRows.reduce((s, r) => s + n(r.advanceReceived), 0))}</td>
                    <td style={{ ...td, color: theme.red, fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(taxRows.reduce((s, r) => s + r.balance, 0))}</td>
                    <td colSpan={2} style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      )}

      {/* ---- PROJECT LEDGER TRACKER ---- */}
{activeTab === "ledger" && (
  <div>
    <div style={{ background: theme.blue + "11", border: `1px solid ${theme.blue}33`, borderRadius: 10, padding: "10px 16px", marginBottom: 14, display: "flex", alignItems: "center", gap: 10 }}>
      <span>💡</span>
      <span style={{ color: theme.blue, fontSize: 12, fontWeight: 600 }}>Auto-fetched from all project ledgers in Billing & Invoicing. Create ledgers in Project Management → Billing → Project Ledger.</span>
    </div>
    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 14 }}>
      <Btn variant="ghost" onClick={() => printSection("ledger-tracker-table")}>🖨 Print</Btn>
    </div>
    {ledgers.length === 0 ? (
      <div style={{ background: theme.card, border: `1px dashed ${theme.border}`, borderRadius: 12, padding: 40, textAlign: "center" }}>
        <div style={{ fontSize: 40, marginBottom: 10 }}>📒</div>
        <div style={{ color: theme.muted }}>No ledger entries yet. Create ledgers in Project Management → Billing → Project Ledger tab.</div>
      </div>
    ) : (
      <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }} id="ledger-tracker-table">
        <div style={{ padding: "12px 16px", background: "#162040", borderRadius: "12px 12px 0 0" }}>
          <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>📒 Project Ledger Tracker — Permatech Concrete Solutions</div>
          <div style={{ color: "#5a7aa8", fontSize: 11, marginTop: 2 }}>{ledgers.reduce((s, l) => s + (l.rows?.length || 0), 0)} total entries across {ledgers.length} ledgers</div>
        </div>
        <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 1600 }}>
          <thead>
            <tr>
              {["SR No.", "Bill To", "Site Name", "RA No.", "Invoice Date", "Invoice No.", "Total Work Done ₹", "Invoice Amount ₹", "GST Amount ₹", "Total Incl. GST ₹", "Retention 5% ₹", "TDS 2% ₹", "Net Receivable ₹", "Payment Received ₹", "Balance Payment ₹", "Remarks"].map(h => (
                <th key={h} style={th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ledgers.flatMap(ledger =>
              (ledger.rows || []).map((row, i) => (
                <tr key={`${ledger.id}_${row.id}`} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                  <td style={{ ...td, color: theme.accent, fontWeight: 700, width: 50 }}>{row.srNo || i + 1}</td>
                  <td style={{ ...td, textAlign: "left", paddingLeft: 10, fontWeight: 600, minWidth: 120 }}>{row.billTo || ledger.billTo || "—"}</td>
                  <td style={{ ...td, textAlign: "left", paddingLeft: 10, minWidth: 120 }}>{row.siteName || "—"}</td>
                  <td style={{ ...td, color: theme.blue, fontWeight: 700 }}>{row.raNo || "—"}</td>
                  <td style={{ ...td, minWidth: 100 }}>{row.invoiceDate || "—"}</td>
                  <td style={{ ...td, minWidth: 100 }}>{row.invoiceNo || "—"}</td>
                  <td style={{ ...td, color: theme.blue, fontWeight: 600 }}>₹{(parseFloat(row.workDone) || 0).toLocaleString("en-IN")}</td>
                  <td style={{ ...td, fontWeight: 600 }}>₹{(parseFloat(row.invoiceAmount) || 0).toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: theme.purple }}>₹{(parseFloat(row.gst) || 0).toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: theme.blue, fontWeight: 700 }}>₹{(parseFloat(row.totalWithGST) || 0).toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: theme.orange }}>₹{(parseFloat(row.retention) || 0).toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: theme.red }}>₹{(parseFloat(row.tds) || 0).toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: theme.green, fontWeight: 700 }}>₹{(parseFloat(row.netReceivable) || 0).toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: theme.green }}>₹{(parseFloat(row.paymentReceived) || 0).toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: parseFloat(row.balance) > 0 ? theme.red : theme.green, fontWeight: 800 }}>₹{(parseFloat(row.balance) || 0).toLocaleString("en-IN")}</td>
                  <td style={{ ...td, textAlign: "left", paddingLeft: 10, minWidth: 120 }}>{row.remarks || "—"}</td>
                </tr>
              ))
            )}
          </tbody>
          {/* Grand Total Row */}
          {(() => {
            const allRows = ledgers.flatMap(l => l.rows || []);
            const gt = allRows.reduce((acc, row) => {
              acc.workDone += parseFloat(row.workDone) || 0;
              acc.invoiceAmount += parseFloat(row.invoiceAmount) || 0;
              acc.gst += parseFloat(row.gst) || 0;
              acc.totalWithGST += parseFloat(row.totalWithGST) || 0;
              acc.retention += parseFloat(row.retention) || 0;
              acc.tds += parseFloat(row.tds) || 0;
              acc.netReceivable += parseFloat(row.netReceivable) || 0;
              acc.paymentReceived += parseFloat(row.paymentReceived) || 0;
              acc.balance += parseFloat(row.balance) || 0;
              return acc;
            }, { workDone: 0, invoiceAmount: 0, gst: 0, totalWithGST: 0, retention: 0, tds: 0, netReceivable: 0, paymentReceived: 0, balance: 0 });
            return (
              <tfoot>
                <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                  <td colSpan={6} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>GRAND TOTAL</td>
                  <td style={{ ...td, color: "#93c5fd", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{gt.workDone.toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: "#fff", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{gt.invoiceAmount.toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: "#C4B5FD", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{gt.gst.toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: "#93c5fd", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{gt.totalWithGST.toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: "#FCD34D", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{gt.retention.toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: "#FCA5A5", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{gt.tds.toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{gt.netReceivable.toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{gt.paymentReceived.toLocaleString("en-IN")}</td>
                  <td style={{ ...td, color: gt.balance > 0 ? "#FCA5A5" : "#6EE7B7", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{gt.balance.toLocaleString("en-IN")}</td>
                  <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                </tr>
              </tfoot>
            );
          })()}
        </table>
      </div>
    )}
  </div>
      )}

      {/* ---- MONTHLY REPORT ---- */}
      {activeTab === "monthly" && (
        <div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 14 }}>
            <Btn variant="ghost" onClick={() => printSection("monthly-table")}>🖨 Print</Btn>
          </div>
          <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }} id="monthly-table">
            <div style={{ padding: "12px 16px", background: "#162040", borderRadius: "12px 12px 0 0" }}>
              <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>📅 Monthly Report — Permatech Concrete Solutions</div>
              
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr>{["Month", "Invoice Count", "Total Invoiced ₹", "Total Received ₹", "Outstanding ₹"].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
              <tbody>
                {monthlyData.length === 0 && <tr><td colSpan={5} style={{ ...td, padding: 30, color: theme.muted }}>No data yet.</td></tr>}
                {monthlyData.map((m, i) => {
                  const outstanding = m.totalInvoiced - m.totalReceived;
                  return (
                    <tr key={m.month} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                      <td style={{ ...td, fontWeight: 700, color: theme.accent }}>{m.month}</td>
                      <td style={{ ...td, color: theme.blue, fontWeight: 600 }}>{m.invoiceCount}</td>
                      <td style={{ ...td, color: theme.green, fontWeight: 700 }}>₹{fmt(m.totalInvoiced)}</td>
                      <td style={{ ...td, color: theme.blue, fontWeight: 700 }}>₹{fmt(m.totalReceived)}</td>
                      <td style={{ ...td, color: outstanding > 0 ? theme.red : theme.green, fontWeight: 800 }}>₹{fmt(outstanding)}</td>
                    </tr>
                  );
                })}
              </tbody>
              {monthlyData.length > 0 && (
                <tfoot>
                  <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                    <td style={{ ...td, color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>TOTAL</td>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>{monthlyData.reduce((s, m) => s + m.invoiceCount, 0)}</td>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(monthlyData.reduce((s, m) => s + m.totalInvoiced, 0))}</td>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(monthlyData.reduce((s, m) => s + m.totalReceived, 0))}</td>
                    <td style={{ ...td, color: theme.red, fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(monthlyData.reduce((s, m) => s + (m.totalInvoiced - m.totalReceived), 0))}</td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      )}

      {/* ---- CLIENT WISE REPORT ---- */}
      {activeTab === "clientwise" && (
        <div>
          <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: 14 }}>
            <Btn variant="ghost" onClick={() => printSection("client-table")}>🖨 Print</Btn>
          </div>
          <div style={{ background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12, overflow: "hidden" }} id="client-table">
            <div style={{ padding: "12px 16px", background: "#162040", borderRadius: "12px 12px 0 0" }}>
              <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>🏢 Client Wise Report — Permatech Concrete Solutions</div>
              
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead><tr>{["SR", "Site Name", "Invoice Count", "Total Invoiced ₹", "Total Received ₹", "Outstanding ₹"].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
              <tbody>
                {clientData.length === 0 && <tr><td colSpan={6} style={{ ...td, padding: 30, color: theme.muted }}>No data yet.</td></tr>}
                {clientData.map((c, i) => {
                  const outstanding = c.totalInvoiced - c.totalReceived;
                  return (
                    <tr key={c.siteName} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                      <td style={{ ...td, color: theme.muted, width: 40 }}>{i + 1}</td>
                      <td style={{ ...td, fontWeight: 700, color: theme.text, textAlign: "left", paddingLeft: 12 }}>{c.siteName}</td>
                      <td style={{ ...td, color: theme.blue, fontWeight: 600 }}>{c.invoiceCount}</td>
                      <td style={{ ...td, color: theme.green, fontWeight: 700 }}>₹{fmt(c.totalInvoiced)}</td>
                      <td style={{ ...td, color: theme.blue, fontWeight: 700 }}>₹{fmt(c.totalReceived)}</td>
                      <td style={{ ...td, color: outstanding > 0 ? theme.red : theme.green, fontWeight: 800 }}>₹{fmt(outstanding)}</td>
                    </tr>
                  );
                })}
              </tbody>
              {clientData.length > 0 && (
                <tfoot>
                  <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                    <td colSpan={2} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>TOTAL</td>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>{clientData.reduce((s, c) => s + c.invoiceCount, 0)}</td>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(clientData.reduce((s, c) => s + c.totalInvoiced, 0))}</td>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(clientData.reduce((s, c) => s + c.totalReceived, 0))}</td>
                    <td style={{ ...td, color: theme.red, fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(clientData.reduce((s, c) => s + (c.totalInvoiced - c.totalReceived), 0))}</td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      )}

      {/* ---- PENDING PAYMENTS ---- */}
      {activeTab === "pending" && (
        <div>
          <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginBottom: 14 }}>
            <Btn variant="ghost" onClick={() => printSection("pending-table")}>🖨 Print</Btn>
            <Btn onClick={() => setEditModal({ type: "pending", row: { invoiceNo: "", billTo: "", siteName: "", date: today.toISOString().slice(0, 10), netReceivable: "", paid: "", _isNew: true } })}>+ Add Entry</Btn>
          </div>
          <div style={{ overflowX: "auto", background: theme.card, border: `1px solid ${theme.border}`, borderRadius: 12 }} id="pending-table">
            <div style={{ padding: "12px 16px", background: "#162040", borderRadius: "12px 12px 0 0" }}>
              <div style={{ color: "#93c5fd", fontWeight: 800, fontSize: 14 }}>⏳ Pending Payments — Permatech Concrete Solutions</div>
            </div>
            <table style={{ width: "100%", borderCollapse: "collapse", minWidth: 900 }}>
              <thead><tr>{["SR No", "Invoice No", "Bill To", "Site Name", "Date", "Net Receivable ₹", "Paid ₹", "Balance Due ₹", "Actions"].map(h => <th key={h} style={th}>{h}</th>)}</tr></thead>
              <tbody>
                {allPendingRows.length === 0 && <tr><td colSpan={9} style={{ ...td, padding: 30, color: theme.muted }}>No pending payments.</td></tr>}
                {allPendingRows.map((r, i) => {
                  const bal = n(r.netReceivable) - n(r.paid);
                  return (
                    <tr key={r.id} style={{ background: i % 2 === 0 ? theme.card : theme.bg }}>
                      <td style={{ ...td, color: theme.muted, width: 50, textAlign: "center" }}>
  {i + 1}
  {r._isAuto && <div style={{ color: theme.orange, fontSize: 9, fontWeight: 700 }}>AUTO</div>}
</td>
                      <td style={{ ...td, color: theme.accent, fontWeight: 700, minWidth: 140 }}>{r.invoiceNo || "—"}</td>
                      <td style={{ ...td, minWidth: 140, textAlign: "left", paddingLeft: 12, fontWeight: 600 }}>{r.billTo || "—"}</td>
                      <td style={{ ...td, minWidth: 140, textAlign: "left", paddingLeft: 12 }}>{r.siteName || "—"}</td>
                      <td style={{ ...td, minWidth: 100 }}>{r.date || "—"}</td>
                      <td style={{ ...td, color: theme.green, fontWeight: 700 }}>₹{fmt(r.netReceivable)}</td>
                      <td style={{ ...td, color: theme.blue, fontWeight: 600 }}>₹{fmt(r.paid)}</td>
                      <td style={{ ...td, color: bal > 0 ? theme.red : theme.green, fontWeight: 900, fontSize: 13 }}>₹{fmt(bal)}</td>
                     <td style={{ ...td, minWidth: 90 }}>
  {r._isAuto ? (
    <span style={{ color: theme.orange, fontSize: 10, fontWeight: 600 }}>Auto</span>
  ) : (
    <div style={{ display: "flex", gap: 4, justifyContent: "center" }}>
      <button onClick={() => setEditModal({ type: "pending", row: r })} style={{ background: theme.blue + "22", border: `1px solid ${theme.blue}44`, color: theme.blue, borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>✏️</button>
      <button onClick={() => delRow("fd_pending", "fd_pending", pendingRows, setPendingRows, r.id)} style={{ background: theme.red + "22", border: `1px solid ${theme.red}44`, color: theme.red, borderRadius: 5, padding: "3px 8px", fontSize: 11, cursor: "pointer", fontWeight: 700 }}>🗑</button>
    </div>
  )}
</td>
                    </tr>
                  );
                })}
              </tbody>
              {allPendingRows.length > 0 && (
                <tfoot>
                  <tr style={{ background: "#162040", borderTop: "2px solid #93c5fd" }}>
                    <td colSpan={5} style={{ ...td, textAlign: "right", color: "#93c5fd", fontWeight: 800, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>TOTAL</td>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(allPendingRows.reduce((s, r) => s + n(r.netReceivable), 0))}</td>
                    <td style={{ ...td, color: "#60a5fa", fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(allPendingRows.reduce((s, r) => s + n(r.paid), 0))}</td>
                    <td style={{ ...td, color: theme.red, fontWeight: 900, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }}>₹{fmt(allPendingRows.reduce((s, r) => s + (n(r.netReceivable) - n(r.paid)), 0))}</td>
                    <td style={{ ...td, background: "#162040", border: "1px solid rgba(99,179,237,0.2)" }} />
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </div>
      )}
    </div>
  );
}


function StockInventoryModule({ products, setProducts, movements, setMovements, pendingRequests, setPendingRequests, godownProducts, setGodownProducts, godownMovements, setGodownMovements, projects = [] }) {
  const [inventorySubTab, setInventorySubTab] = useState("warehouse");
  const [showDocuments, setShowDocuments] = useState(false);

  return (
    <div>
      {/* Header */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 20 }}>
  <div>
    <div style={{ color: theme.accent, fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: "uppercase", marginBottom: 4 }}>Inventory</div>
    <h2 style={{ color: theme.text, fontSize: 26, fontWeight: 800, margin: 0 }}>Stock Inventory</h2>
    <div style={{ color: theme.muted, fontSize: 14, marginTop: 3 }}>Warehouse & Godown Management</div>
  </div>
  <Btn variant={showDocuments ? "blue" : "ghost"} onClick={() => setShowDocuments(d => !d)}>
    📁 {showDocuments ? "Hide Documents" : "Documents"}
  </Btn>
</div>

      {/* Dropdown selector */}
      <div style={{ display: "flex", alignItems: "center", gap: 12, marginBottom: 20 }}>
        <div style={{ position: "relative" }}>
         <Tabs active={inventorySubTab} onChange={setInventorySubTab} tabs={[
  { id: "warehouse", label: "📦 Warehouse" },
  { id: "godown", label: "🏭 Godown" },
 { id: "import", label: "📋 Product Costing Sheet" },
{ id: "sitetracking", label: "📊 New Project Supply" },
 
]} />
          <span style={{ position: "absolute", right: 12, top: "50%", transform: "translateY(-50%)", pointerEvents: "none", color: theme.muted, fontSize: 12 }}>▾</span>
        </div>
        {inventorySubTab === "warehouse" && pendingRequests.length > 0 && (
          <span style={{ background: theme.orange + "22", color: theme.orange, border: `1px solid ${theme.orange}44`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700 }}>
            📋 {pendingRequests.length} pending
          </span>
        )}
        {inventorySubTab === "warehouse" && products.filter(p => p.currentStock <= p.reorderLevel).length > 0 && (
          <span style={{ background: theme.red + "22", color: theme.red, border: `1px solid ${theme.red}44`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700 }}>
            ⚠️ {products.filter(p => p.currentStock <= p.reorderLevel).length} low stock
          </span>
        )}
        {inventorySubTab === "godown" && godownProducts.filter(p => p.currentStock <= p.reorderLevel).length > 0 && (
          <span style={{ background: theme.red + "22", color: theme.red, border: `1px solid ${theme.red}44`, borderRadius: 6, padding: "3px 10px", fontSize: 11, fontWeight: 700 }}>
            ⚠️ {godownProducts.filter(p => p.currentStock <= p.reorderLevel).length} low stock
          </span>
        )}
      </div>

    {showDocuments && <ShipmentDocuments />}

      {!showDocuments && <>
        {inventorySubTab === "warehouse" && (
          <InventoryModule
  products={products}
  setProducts={setProducts}
  movements={movements}
  setMovements={setMovements}
  pendingRequests={pendingRequests}
  setPendingRequests={setPendingRequests}
  projects={projects}
/>
        )}
        {inventorySubTab === "godown" && (
          <GodownModule
            products={godownProducts}
            setProducts={setGodownProducts}
            movements={godownMovements}
            setMovements={setGodownMovements}
          />
        )}
        {inventorySubTab === "import" && <DirectImportModule />}
{inventorySubTab === "sitetracking" && <MaterialSiteTracking />}

      </>}
    </div>
  );
}

export default function App() {
  const [activeModule, setActiveModule] = useState("projects");
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // Auth state
  const [currentUser, setCurrentUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  // Theme
  const [isDark, setIsDark] = useState(() => localStorage.getItem("theme") === "dark");
  theme = isDark ? darkTheme : lightTheme;

  // Shared state
  const [projects, setProjects] = useState([]);
  const [products, setProducts] = useState(() => {
    const saved = localStorage.getItem("products");
    return saved ? JSON.parse(saved) : initialProducts;
  });
  const [movements, setMovements] = useState(() => {
    const saved = localStorage.getItem("movements");
    return saved ? JSON.parse(saved) : initialMovements;
  });
  const [godownProducts, setGodownProducts] = useState(() => {
    const saved = localStorage.getItem("godownProducts");
    return saved ? JSON.parse(saved) : initialGodownProducts;
  });
  const [godownMovements, setGodownMovements] = useState(() => {
    const saved = localStorage.getItem("godownMovements");
    return saved ? JSON.parse(saved) : initialGodownMovements;
  });
  const [masterBOQ, setMasterBOQ] = useState(initialMasterBOQ);
  const [pendingRequests, setPendingRequests] = useState(initialPendingRequests);
  const [materialRequests, setMaterialRequests] = useState([]);
  const [invoices, setInvoices] = useState([]);
  const [challans, setChallans] = useState([]);
  

  // Auth listener
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
      if (firebaseUser) {
        try {
          const snap = await getDoc(fsDoc(db, "users", firebaseUser.uid));
          if (snap.exists()) setCurrentUser({ uid: firebaseUser.uid, ...snap.data() });
          else setCurrentUser(null);
        } catch {
          setCurrentUser(null);
        }
      } else {
        setCurrentUser(null);
      }
      setAuthLoading(false);
    });
    return () => unsub();
  }, []);

  // Load Firebase data
  useEffect(() => {
    const loadData = async () => {
      
    
      try {
        const [projSnap, chalSnap, reqSnap, invSnap, boqSnap] = await Promise.all([
          getDocs(collection(db, 'projects')),
          getDocs(collection(db, 'challans')),
          getDocs(collection(db, 'material_requests')),
          getDocs(collection(db, 'invoices')),
          getDocs(collection(db, 'master_boq')),
        ]);

        const parse = (docs) => docs.map(d => {
          const raw = d.data();
          if (typeof raw.data === 'string') return JSON.parse(raw.data);
          return raw.data || raw;
        });

        const proj = parse(projSnap.docs);
        const chal = parse(chalSnap.docs);
        const reqs = parse(reqSnap.docs);
        const inv  = parse(invSnap.docs);
        const boq  = parse(boqSnap.docs);

        if (proj.length > 0) setProjects(proj);
        else { const ls = localStorage.getItem("projects"); if (ls) setProjects(JSON.parse(ls)); }

        if (chal.length > 0) setChallans(chal);
        else { const ls = localStorage.getItem("challans"); if (ls) setChallans(JSON.parse(ls)); }

        if (reqs.length > 0) setMaterialRequests(reqs);
        else { const ls = localStorage.getItem("materialRequests"); if (ls) setMaterialRequests(JSON.parse(ls)); }

        if (inv.length > 0) setInvoices(inv.map(i => i.data || i));
        else { const ls = localStorage.getItem("invoices"); if (ls) setInvoices(JSON.parse(ls)); }

        if (boq.length > 0) setMasterBOQ(boq);
        else { const ls = localStorage.getItem("masterBOQ"); if (ls) setMasterBOQ(JSON.parse(ls)); }

      } catch (err) {
        console.error("Firebase error, loading from localStorage:", err);
        const lsProjects = localStorage.getItem("projects");
        const lsChallans = localStorage.getItem("challans");
        const lsRequests = localStorage.getItem("materialRequests");
        const lsInvoices = localStorage.getItem("invoices");
        const lsMasterBOQ = localStorage.getItem("masterBOQ");
        if (lsProjects) setProjects(JSON.parse(lsProjects));
        if (lsChallans) setChallans(JSON.parse(lsChallans));
        if (lsRequests) setMaterialRequests(JSON.parse(lsRequests));
        if (lsInvoices) setInvoices(JSON.parse(lsInvoices));
        if (lsMasterBOQ) setMasterBOQ(JSON.parse(lsMasterBOQ));
      } 
    };
    loadData();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    setCurrentUser(null);
  };

  // Role-based access
 const ROLE_ACCESS = {
  admin: ["projects", "inventory", "challan", "billing", "rateanalysis", "crm", "hrms", "users", "finance"],
  office:   ["projects", "inventory", "hrms", "finance"],
  engineer: ["projects"],
  labour:   ["hrms"],
};

  const allowedModules = ROLE_ACCESS[currentUser?.role] || [];

  const activeNav = NAV.find(n => n.id === activeModule);

  // Loading screen
  if (authLoading) return (
    <div style={{ background: theme.bg, minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 16 }}>
      <div style={{ fontSize: 48, marginBottom: 8 }}>⚙️</div>
      <div style={{ color: theme.text, fontSize: 20, fontWeight: 800 }}>Loading Permatech ERP...</div>
      <div style={{ color: theme.muted, fontSize: 13 }}>Connecting to database</div>
    </div>
  );

  // Login screen
  if (!currentUser) return <LoginScreen onLogin={setCurrentUser} />;

  return (
    <div style={{ display: "flex", minHeight: "100vh", background: theme.bg, color: theme.text, fontFamily: "'Sora', 'Segoe UI', sans-serif", fontSize: 15 }}>

      {/* Sidebar */}
<div style={{ width: sidebarOpen ? 230 : 64, background: isDark ? "#0f1f3d" : "#162040", flexShrink: 0, transition: "width 0.25s ease", display: "flex", flexDirection: "column", position: "sticky", top: 0, height: "100vh", overflow: "hidden" }}>
  {/* Logo */}
 <div style={{ padding: sidebarOpen ? "16px 18px" : "12px 10px", display: "flex", alignItems: "center", justifyContent: "center", borderBottom: "1px solid rgba(255,255,255,0.06)" }}>
  <img src={COMPANY_LOGO} alt="Permatech"
    style={{ height: sidebarOpen ? 64 : 40, width: sidebarOpen ? "100%" : 44, objectFit: "contain", objectPosition: "center", transition: "all 0.25s ease" }} />
</div>

 <nav style={{ flex: 1, padding: "14px 10px", overflowY: "auto" }}>

  {sidebarOpen && <div style={{ color: "rgba(255,255,255,0.4)", fontSize: 9, fontWeight: 700, letterSpacing: "2px", textTransform: "uppercase", padding: "0 8px", marginBottom: 8, fontFamily: "'Sora', sans-serif" }}>Main</div>}

  {NAV.filter(item => allowedModules.includes(item.id) && ["projects","inventory","billing","finance"].includes(item.id)).map(item => {
    const isActive = activeModule === item.id;
    return (
      <button key={item.id} onClick={() => !item.disabled && setActiveModule(item.id)}
        style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, padding: sidebarOpen ? "10px 12px" : "10px", borderRadius: 10, marginBottom: 3, background: isActive ? "rgba(37,99,235,0.15)" : "transparent", border: isActive ? "1px solid rgba(37,99,235,0.3)" : "1px solid transparent", cursor: item.disabled ? "not-allowed" : "pointer", opacity: item.disabled ? 0.4 : 1, textAlign: "left", transition: "all 0.15s" }}>
        <span style={{ fontSize: 14, flexShrink: 0, width: 18, textAlign: "center" }}>{item.icon}</span>
        {sidebarOpen && <div style={{ color: isActive ? "#ffffff" : "rgba(255,255,255,0.75)", fontWeight: isActive ? 700 : 500, fontSize: 13, fontFamily: "'Sora', sans-serif", letterSpacing: "0.3px" }}>{item.label}</div>}
      </button>
    );
  })}

  {sidebarOpen && <div style={{ color: "#3a5a80", fontSize: 9, fontWeight: 700, letterSpacing: "1.5px", textTransform: "uppercase", padding: "0 8px", margin: "12px 0 8px" }}>Operations</div>}

  {NAV.filter(item => allowedModules.includes(item.id) && ["crm","hrms","rateanalysis"].includes(item.id)).map(item => {
    const isActive = activeModule === item.id;
    return (
      <button key={item.id} onClick={() => !item.disabled && setActiveModule(item.id)}
        style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, padding: sidebarOpen ? "10px 12px" : "10px", borderRadius: 10, marginBottom: 3, background: isActive ? "rgba(37,99,235,0.15)" : "transparent", border: isActive ? "1px solid rgba(37,99,235,0.3)" : "1px solid transparent", cursor: item.disabled ? "not-allowed" : "pointer", opacity: item.disabled ? 0.4 : 1, textAlign: "left", transition: "all 0.15s" }}>
        <span style={{ fontSize: 14, flexShrink: 0, width: 18, textAlign: "center" }}>{item.icon}</span>
       {sidebarOpen && <div style={{ color: isActive ? "#ffffff" : "rgba(255,255,255,0.75)", fontWeight: isActive ? 700 : 500, fontSize: 13, fontFamily: "'Sora', sans-serif", letterSpacing: "0.3px" }}>{item.label}</div>}
      </button>
    );
  })}

  {currentUser?.role === "admin" && <>
    {sidebarOpen && <div style={{ color: "#3a5a80", fontSize: 9, fontWeight: 700, letterSpacing: "1.5px", textTransform: "uppercase", padding: "0 8px", margin: "12px 0 8px" }}>Admin</div>}
    <button onClick={() => setActiveModule("users")}
      style={{ width: "100%", display: "flex", alignItems: "center", gap: 10, padding: sidebarOpen ? "10px 12px" : "10px", borderRadius: 10, marginBottom: 3, background: activeModule === "users" ? "rgba(37,99,235,0.15)" : "transparent", border: activeModule === "users" ? "1px solid rgba(37,99,235,0.3)" : "1px solid transparent", cursor: "pointer", textAlign: "left", transition: "all 0.15s" }}>
      <span style={{ fontSize: 14, flexShrink: 0, width: 18, textAlign: "center" }}>👥</span>
      {sidebarOpen && <div style={{ color: activeModule === "users" ? "#ffffff" : "rgba(255,255,255,0.75)", fontWeight: activeModule === "users" ? 700 : 500, fontSize: 13, fontFamily: "'Sora', sans-serif", letterSpacing: "0.3px" }}>User Management</div>}
    </button>
  </>}

</nav>

  {/* Collapse */}
  <button onClick={() => setSidebarOpen(o => !o)}
    style={{ margin: 10, padding: 10, background: "rgba(255,255,255,0.05)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 9, color: "#5a7aa8", cursor: "pointer", fontSize: 13, display: "flex", alignItems: "center", justifyContent: "center" }}>
    {sidebarOpen ? "◀" : "▶"}
  </button>
</div>
      {/* Main Content */}
      <div style={{ flex: 1, overflow: "auto", background: isDark ? "#060b14" : "#f8faff" }}>


        {/* Top Bar */}
<div style={{ background: isDark ? "#0f1f3d" : "#162040", borderBottom: "1px solid rgba(255,255,255,0.06)", padding: "0 24px", position: "sticky", top: 0, zIndex: 50, boxShadow: "0 2px 8px rgba(0,0,0,0.15)" }}>
  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", height: 56 }}>
    <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
      <span style={{ fontSize: 16 }}>{activeNav?.icon}</span>
      <span style={{ color: "#fff", fontWeight: 700, fontSize: 18 }}>{activeNav?.label}</span>
      <span style={{ background: "rgba(37,99,235,0.3)", border: "1px solid rgba(37,99,235,0.5)", color: "#93c5fd", fontSize: 9, fontWeight: 700, padding: "3px 8px", borderRadius: 5, letterSpacing: "1px", textTransform: "uppercase" }}>Dashboard</span>
    </div>
    <div style={{ display: "flex", gap: 10, alignItems: "center" }}>
      {activeModule === "inventory" && products.filter(p => p.currentStock <= p.reorderLevel).length > 0 && (
        <button onClick={() => setActiveModule("inventory")}
          style={{ background: "rgba(239,68,68,0.15)", border: "1px solid rgba(239,68,68,0.3)", color: "#fca5a5", borderRadius: 20, padding: "4px 12px", fontSize: 10, fontWeight: 600, cursor: "pointer" }}>
          ⚠️ {products.filter(p => p.currentStock <= p.reorderLevel).length} low stock
        </button>
      )}
      {activeModule === "inventory" && pendingRequests.length > 0 && (
        <button onClick={() => setActiveModule("inventory")}
          style={{ background: "rgba(245,158,11,0.15)", border: "1px solid rgba(245,158,11,0.3)", color: "#fcd34d", borderRadius: 20, padding: "4px 12px", fontSize: 10, fontWeight: 600, cursor: "pointer" }}>
          📋 {pendingRequests.length} pending
        </button>
      )}
      <button onClick={() => { const next = !isDark; setIsDark(next); localStorage.setItem("theme", next ? "dark" : "light"); }}
        style={{ background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 9, width: 36, height: 36, display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", fontSize: 16 }}>
        {isDark ? "☀️" : "🌙"}
      </button>
      <div style={{ display: "flex", alignItems: "center", gap: 8, background: "rgba(255,255,255,0.08)", border: "1px solid rgba(255,255,255,0.12)", borderRadius: 22, padding: "5px 13px 5px 5px" }}>
        <div style={{ width: 28, height: 28, background: "linear-gradient(135deg,#2563eb,#0891b2)", borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center", fontSize: 10, fontWeight: 700, color: "#fff" }}>
          {currentUser?.name?.charAt(0)?.toUpperCase() || "A"}
        </div>
        <div>
          <div style={{ color: "#e2efff", fontSize: 11, fontWeight: 600 }}>{currentUser?.name}</div>
          <div style={{ color: "#5a7aa8", fontSize: 9, textTransform: "capitalize" }}>{currentUser?.role}</div>
        </div>
      </div>
      <button onClick={handleLogout}
        style={{ background: "rgba(239,68,68,0.12)", border: "1px solid rgba(239,68,68,0.25)", color: "#fca5a5", borderRadius: 8, padding: "6px 12px", fontSize: 10, fontWeight: 600, cursor: "pointer" }}>
        🚪 Logout
      </button>
    </div>
  </div>
</div>

        {/* Module Content */}
        <div style={{ padding: "28px 24px", minHeight: "100%", background: isDark ? "#060b14" : "#f8faff" }}>
          {activeModule === "projects" && <ProjectsModule projects={projects} setProjects={setProjects} challans={challans} setChallans={setChallans} materialRequests={materialRequests} setMaterialRequests={setMaterialRequests} invoices={invoices} setInvoices={setInvoices} masterBOQ={masterBOQ} setMasterBOQ={setMasterBOQ} />}
          {activeModule === "inventory" && <StockInventoryModule products={products} setProducts={setProducts} movements={movements} setMovements={setMovements} pendingRequests={pendingRequests} setPendingRequests={setPendingRequests} godownProducts={godownProducts} setGodownProducts={setGodownProducts} godownMovements={godownMovements} setGodownMovements={setGodownMovements} projects={projects} />}
          {activeModule === "challan" && <ChallanModule challans={challans} setChallans={setChallans} projects={projects} materialRequests={materialRequests} setMaterialRequests={setMaterialRequests} />}
          {activeModule === "billing" && <BillingModule invoices={invoices} setInvoices={setInvoices} projects={projects} />}
          {activeModule === "finance" && <FinanceDashboard
           invoices={projects.flatMap(p => p.invoices || [])}
           allTaxInvoices={projects.flatMap(p => p.taxInvoices || [])}
            />}  
          {activeModule === "rateanalysis" && <RateAnalysisModule />}
          {activeModule === "crm" && <CRMModule projects = {projects} />}
          {activeModule === "hrms" && <HRMSModule currentUser={currentUser} projects={projects} />}
          {activeModule === "users" && currentUser?.role === "admin" && <UserManagement />}
        </div>
      </div>
    </div>
  );
}
